import React, { useState, useEffect, useLayoutEffect, useRef, useMemo, useCallback, forwardRef, useImperativeHandle } from 'react';
import { createPortal } from 'react-dom';   // Workspace v4: tab + alat kanan dipindah ke kepala halaman (App.jsx)
import { db, auth, storage } from '../firebase';
import { doc, setDoc, onSnapshot, updateDoc, serverTimestamp, collection, addDoc, getDocs, deleteDoc, query, where, getDoc, writeBatch, increment } from 'firebase/firestore';
import { ref as fbRef, uploadBytes, getDownloadURL, deleteObject, getMetadata } from 'firebase/storage';
/* ★ Gambar daripada jawapan agent (2026-09-11) — satu takrifan dikongsi dengan
   PRO Studio: pusingan mana yang gambarnya disimpan + muat naik ke kad. */
import { MAKS_GAMBAR_TAMBAHAN, imageTurnsDaripadaAgent, simpanGambarAgentKeKad, ringkasGambarProduk, kadTiadaRuangGambar, hadMasaPusinganGambar, ringkasCubaSemulaGambar } from '../utils/agentGambar';
import { adalahRalatSambungan } from '../utils/ralatExtension';
import { semakTahapGemini, ayatLogTahapGemini } from '../utils/geminiPemilih';   // ★ tahap Thinking Gemini (2026-10-11)
import { isR2Enabled, isR2Url, uploadVideoToR2, deleteR2Video, subscribeR2Config } from '../services/r2VideoService';
import { getEmptyPromptCollection, createNewProduct } from '../types/product';
import { aiService } from '../services/aiService';
import { enqueueFlowJob, bukaBatchHostedBeta, sealBatchHostedBeta } from '../services/centralWorkerService'; // ★ Hosted Flow Beta — enqueue + manifest batch (notifikasi)
import { hantarHostedBeta, sebabOffline } from '../services/hostedRun'; // ★ Hosted Flow Beta — enjin Submit
import { subscribeToProducts, saveProducts, saveProduct, removeProduct, removeProducts, syncStatusFromUserDoc, recoverProductMetadata, retryProductPipeline, loadProductDetail, mergeDetailIntoProduct, isSplitEnabled } from '../services/productService';
import { listTemplates } from '../services/templateService';
import { SYSTEM_DEFAULT_COMBINED_INSTRUCTION } from './AIInstructionsView';
import { determineMode } from '../utils/promptResolver';
import { susunHasilGenerate, logikDariModule } from '../utils/susunHasilGenerate';
import { useHasilGenerateTertinggal, padamDocProgress, buangDocLainUntukKad } from '../hooks/useHasilGenerateTertinggal';
import { getUserRole, ROLES } from '../utils/roles';
import { productDisplayNo } from '../utils/productDisplayId';
import CompleteProductDataModal from './CompleteProductDataModal';
import ProductLibraryModal from './ProductLibraryModal';
import { salinProdukKeKad } from '../utils/salinProdukKeKad';
import PopupRuangGambarAgent from './PopupRuangGambarAgent';
import PopupPromptKosongFlow from './PopupPromptKosongFlow';
import PopupModelFlowTiada from './PopupModelFlowTiada';
import usePantauModelFlow from '../hooks/usePantauModelFlow';
import { masalahPromptKad, ringkasMasalahPrompt } from '../utils/semakPromptFlow';
/* ★ Paparan gambar besar (2026-09-13) — jalur gambar kad v3.9: tekan gambar, keluar saiz besar. */
import PratontonGambar from './PratontonGambar';
/* ★ Link dalam popup Pengumuman Workspace boleh ditekan (2026-09-22) — penukar pautan
   yang SAMA dengan Tutorial Artikel; import, jangan salin. */
import { pautkanTeks } from './artikelKongsi';
import { sediakanEditDataKad, simpanDariKad, FOLDER_MY_PRODUCTS, bacaDataKadSahaja, tulisDataKadSalinan } from '../utils/editDataProduk';
import { buangStatusLarian, failDirujukKadKekal, tapisFailMasihDipakai } from '../utils/kadSalinan';
import { semakGateBegKuning, pilihanGateLangkau, pilihanGateTanpaBeg, bacaPilihanGate } from '../utils/gateBegKuning';
import PopupGateBegKuning from './PopupGateBegKuning';
/* ★ Kosongkan Prompt (bar pukal, 2026-09-13) — pelan + penulisan duduk dalam fail sendiri. */
import { SET_KAD, pelanKad, setAdaTeks, setTanpaTeks, kosongkanPromptKad } from '../utils/kosongkanPrompt';
/* `PanelRightOpen` — butang "Show Control Panel" dalam jalur tab (muncul hanya
   semasa panel tersorok). Pasangan yang SAMA dengan butang kuncup rel menu
   StudioShell (PanelLeftClose/Open), cuma menghadap ke kanan, supaya dua
   kawalan ruang skrin itu kelihatan sekeluarga. Pasangan menyoroknya
   (`PanelRightClose`) hidup pada kepala panel dalam App.jsx. */
import { ArrowUpDown, ArrowUp, ArrowDown, Check, ChevronsUpDown, ChevronsDownUp, X, Copy, GripVertical, PanelRightOpen, PanelRightClose, PanelLeftOpen, PanelLeftClose } from 'lucide-react';
// Phone automation (v4) — enjin bulk RUN terus dari card ditick (WebUSB/ADB,
// dalam webapp; bukan extension). ya-webadb berat dimuat lazy dalam loadLibs,
// jadi import kelas ini ringan. phoneApp = daftar app dikongsi.
import { AndroidController, phoneVideoDest } from '../utils/androidAdb';
import { phoneApp as cariPhoneApp } from '../utils/phoneApps';
import { runRecipe } from '../utils/androidRunner';
import { recipeFor } from '../utils/androidRecipe';
import { masalahIsiPost, captionUntukPhone, sudahMasukShopee } from '../utils/androidPostCheck';
import { petaMulaLarian, naikTarafRekodKad } from '../utils/rekodLarianKad';
import { isReady as phoneReady } from '../utils/androidCalibration';
import { loadAdminDefault } from '../utils/androidDefault';
import { jalanPhoneDump } from '../utils/phoneRunDump';
/* Komponen reka bentuk v3.9 — dipakai oleh dialog yang sudah ditukar ke
   rupa baharu. Ia terikat pada `.s-root`, yang dipasang pada bekas app
   apabila suis v3.9 hidup, jadi ia selamat diimport di sini: tanpa suis,
   tiada satu pun daripadanya dirender. */
import { Btn, Segmented, Badge } from '../design/ui';
/* Enjin bahasa. ⚠️ Fail ini melayan DUA rupa (lama + v3.9), jadi `useT()`
   TIDAK dipanggil terus untuk ayat yang dikongsi — lihat pembalut `T()`
   dalam WorkspaceView: bila suis v3.9 mati, ia memulangkan ayat Melayu
   asal supaya pelanggan pada rupa lama tidak tiba-tiba nampak English.
   Komponen anak (VideoThumbPreview) menerima `t` sebagai prop PILIHAN
   atas sebab yang sama; SortMenuV39 pula v3.9 sahaja, jadi ia bebas
   memanggil useT() terus. */
import { useT } from '../i18n';
import ShortcutSlashPembantu from './ShortcutSlashPembantu';
/* Susunan agent pilihan pelanggan — pemilih ini mesti menyusun dengan
   peraturan yang SAMA seperti senarai dalam PRO Studio. Kalau tidak, agent
   yang pelanggan letak di atas muncul di tengah-tengah di sini. */
import { agentDiWorkspace, bandingAgent } from '../utils/susunAgent';
import { getEffectiveScriptKey, getDisplayLabelForProduct, getMarketingName, isUploadBlockedForModule, getSceneCount, getModule } from '../config/modules';
import { jenisKadWorkflow, ringkasKadDitanda } from '../utils/workflowRobot';

import PilihV39 from './PilihV39';
import RightSidebar from './RightSidebar';
import QuickNotesPanel from './QuickNotesPanel';
import ConfirmDialog from './ConfirmDialog';
import ToastContainer from './Toast';
import { toast } from './toastBus';
import { kiraHasilAgent, terapHasilAgent } from '../utils/hasilAgentKad';
import { simpanHasilAgent } from '../utils/simpanHasilAgent';
import { bolehCubaSemulaAgent, JEDA_CUBA_SEMULA_MS } from '../utils/cubaSemulaAgent';
import ChatGPTTabView from './ChatGPTTabView';
/* Tab Schedule (v3.9). Komponen yang SAMA dengan prototaip
   /workspace-v3.9, bukan salinan — corak sama seperti GroupSwitcherV39.
   Satu kalendar sahaja bermakna pembetulan rupa hanya perlu dibuat
   sekali, dan prototaip kekal menjadi rujukan yang benar. */
import JadualTiktokV39 from './JadualTiktokV39';
import ScheduleTemplateModalV39 from './ScheduleTemplateModalV39';
import GateExtensionV39 from './GateExtensionV39';
import { akaunBaharu, setDipegangAkaunLain, tarikhLabelHari, bezaHariIni, adalahTarikh, tarikhKeDate, naikTarafSemuaSusunan, naikTarafSenarai, HAD_HARI_TIKTOK, LANGKAH_MINIT } from './scheduleV39';
import { muatDariServer, migrasiKeServer, simpanShared, simpanSusunanAkaun, flushSimpanan, padamAkaun, akaunKeTarikh, muatSusunanAkaun } from '../services/jadualService';
import { binaRancanganFb, binaPayloadFb, captionUntukFb, namaFailReelFb, kunciStatusSlot, HAD_HARI_FB } from '../utils/rancanganKalendar';
/* ★ [2026-09-27] Suis caption TikTok/FB pada SETIAP kotak caption kad (pilihan A) — paparan sahaja. */
import SuisCaptionKad from './SuisCaptionKad';
/* ★ Enjin Flow RESIPI (17 Okt — PLAN_FLOW_RESIPI.md): prompt card 3–5 scene "satu gambar untuk semua scene". */
import { KadResipiPrompt, ModalResipiPrompt, KotakGambarBabak } from './PromptResipiScene';
/* ★ Card DUA scene (Image Prompt · Video Prompt Scene 1 · Video Script + Video Prompt Scene 2) — dahulu khas
   robot AI16SAAT (`=== 'ai16saat'`, 4 tempat). Kini juga module enjin RESIPI 2 scene (17 Okt): bentuk medan
   sama (promptImage · promptVideo/promptVideo1 · promptVideo2), robot resipi membacanya serupa. */
const kadDuaBabak = (product) => {
    const k = getEffectiveScriptKey(product);
    return k === 'ai16saat' || (k === 'resipi' && getSceneCount(product) === 2 && getModule(product?.moduleId)?.resipi?.gambar !== 'sahaja');
};
/* ★ RESIPI "gambar berlainan setiap scene" (31 Okt): medan promptImage{n} — card 2 scene dapat kotak tambahan, 3–5 scene satu kotak setiap scene. */
const resipiBerlainan = (product) => getEffectiveScriptKey(product) === 'resipi' && ['berlainan', 'sahaja'].includes(getModule(product?.moduleId)?.resipi?.gambar);
/* ★ RESIPI Before and after (1 Nov): medan promptImage (mula) + promptImage2 (akhir) + promptVideo; card 1 scene dapat kotak gambar akhir. */
const resipiFrame = (product) => getEffectiveScriptKey(product) === 'resipi' && getModule(product?.moduleId)?.resipi?.gambar === 'frame';
/* ★ RESIPI Images only (1 Nov): 1–4 gambar, satu set, tiada video — card sentiasa guna susun atur satu-set (Image Prompt setiap gambar). */
const resipiGambarSahaja = (product) => getEffectiveScriptKey(product) === 'resipi' && getModule(product?.moduleId)?.resipi?.gambar === 'sahaja';
/* ★ RESIPI text to video (1 Nov): tiada Image Prompt — robot tidak membacanya, jadi kotak itu disorok. */
const resipiTanpaGambar = (product) => getEffectiveScriptKey(product) === 'resipi' && getModule(product?.moduleId)?.resipi?.gambar === 'tiada';
import { captionKad, labelCaptionKad, teksKotakFb, fbKosongSengaja, setDenganKotakFb } from '../utils/captionKad';
/* ★ Status per akaun pada kad + butang Status pada bar pukal (2026-09-18) —
   pil ikut akaun yang dibuka di kalendar; logik tulen dalam fail sendiri. */
import { SET_KAD_STATUS, kunciAkaun, gabungStatusAkaun, statusAkaunDibuka, kiraStatusAkaun, pelanStatusPukal, pelanStatusPasangan, ID_POSTED, pecahPilihanStatus, idPilihanStatus } from '../utils/statusAkaunKad';
import MenuStatusPukal from './MenuStatusPukal';
import { modTiktokBerkesan, linkTiktokUntukRobot } from '../utils/pautanProduk';
import { tetapanSemakanTiktok } from '../utils/semakanTiktok';
import { bacaJenisPostTiktok, gambarKad, setLarianTiktok } from '../utils/jenisPostTiktok';   // ★ 2026-11-04 Photo post TikTok
/* Blok DATA PRODUK untuk agent pelanggan — takrifan SAMA yang dipakai oleh
   larian Configure di PRO Studio. Jangan buat salinan kedua di sini. */
import { gabungArahanAgent } from '../services/productReadyService';

// Amaran "lebih daripada satu extension SESAAT terpasang" — dipapar sekali per sesi
// browser supaya pelanggan tidak dihujani modal setiap kali tukar page.
const DUP_EXT_WARNED_KEY = 'sesaat_dup_ext_warned';

// ★ HighlightTextarea — textarea biasa + backdrop berwarna di belakang untuk SOROT bahagian
//   tertentu (hook = amber, script = emerald/teal). Visual sahaja — tak ubah nilai/onChange.
//   Backdrop & textarea kongsi padding/font/leading supaya warna align tepat dengan teks.
//   boxClassName: bg + border + rounded (pada wrapper). textClassName: padding + font + leading
//   (dikongsi). highlights: [{ text, color }] — color = kelas bg Tailwind.
const HL_ESCAPE = (s) => String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
const HighlightTextarea = ({ value, onChange, highlights = [], boxClassName = '', textClassName = '', heightClassName = '', textColorClassName = 'text-slate-700 dark:text-slate-200', placeholder, readOnly = false, onClick }) => {
    const taRef = useRef(null);
    const bdRef = useRef(null);
    const v = value || '';
    // Kumpul julat highlight (semua occurrence setiap text), buang yang bertindih (ambil yang awal).
    const ranges = [];
    for (const h of (highlights || [])) {
        const t = (h && h.text) ? String(h.text) : '';
        if (!t) continue;
        let from = 0;
        while (true) {
            const i = v.indexOf(t, from);
            if (i === -1) break;
            ranges.push({ start: i, end: i + t.length, color: h.color });
            from = i + t.length;
        }
    }
    ranges.sort((a, b) => a.start - b.start);
    let html = '';
    let cursor = 0;
    for (const r of ranges) {
        if (r.start < cursor) continue; // bertindih — skip
        html += HL_ESCAPE(v.slice(cursor, r.start));
        html += `<mark class="${r.color} rounded-[2px] text-transparent">${HL_ESCAPE(v.slice(r.start, r.end))}</mark>`;
        cursor = r.end;
    }
    html += HL_ESCAPE(v.slice(cursor)) + '\n'; // trailing newline ikut tinggi textarea
    const syncScroll = () => {
        if (bdRef.current && taRef.current) {
            bdRef.current.scrollTop = taRef.current.scrollTop;
            bdRef.current.scrollLeft = taRef.current.scrollLeft;
        }
    };
    return (
        /* `sesaat-hlbox` = cangkuk tunggal untuk kotak medan ini. Warna pastel
           (amber hook, emerald script…) datang daripada `boxClassName` yang
           berbeza pada setiap pemanggil; satu cangkuk di sini membolehkan v3.9
           menggelapkan kesemuanya tanpa menyentuh belasan tempat panggilan. */
        <div className={`sesaat-hlbox relative ${heightClassName} ${boxClassName} focus-within:ring-2 focus-within:ring-primary`}>
            <div
                ref={bdRef}
                aria-hidden="true"
                className={`absolute inset-0 overflow-hidden whitespace-pre-wrap break-words pointer-events-none text-transparent ${textClassName}`}
                dangerouslySetInnerHTML={{ __html: html }}
            />
            <textarea
                ref={taRef}
                value={v}
                onChange={onChange}
                onScroll={syncScroll}
                readOnly={readOnly}
                onClick={onClick}
                placeholder={placeholder}
                className={`absolute inset-0 w-full h-full bg-transparent border-0 resize-none focus:outline-none focus:ring-0 ${textClassName} ${textColorClassName}`}
            />
        </div>
    );
};

// Helpers to convert JSON to Plain Text Prompts and vice-versa
// Tukar JSON mentah → teks Plain yang kemas. GENERIC: papar SEMUA field yang wujud
// (bukan senarai tetap), supaya apa-apa format keluar penuh — 3-set lama, FLOWNITY N-babak, dll.
// ★ COST-FIX (satu pusat): susun paparan "Full Prompt" TERUS dari `prompts` —
// generic untuk SEMUA module (standard 3-set, FLOWNITY N-babak, Smart Custom).
// Ambil semua medan teks dalam setiap set; langkau medan media & dalaman.
// Ini ganti keperluan simpan salinan `rawOutput` (~11KB/doc) dalam Firestore.
// ★ WAJIB ADA DATA (2026-07-28) — Stage 1 (analisa gambar) + Stage 2 (carian web) dah OFF
//   KEKAL untuk semua module, jadi generation bergantung 100% pada data produk yang di-scrape
//   masa Import di Extension SESAAT. Helper ni dipakai untuk TAPIS auto-generate masa produk
//   baru ditambah — produk tanpa data langsung tak dihantar ke server (elak hasil sampah &
//   kuota terbakar). Sekatan sebenar duduk dalam generateForProduct (pintu tunggal semua
//   Generate/Retry/Regenerate) — yang tu ambil kira juga flag module skipStages12.
//   Nota: tapisan auto-gen ni SENGAJA tak semak skipStages12 (setakat ni FLOWNITY sahaja,
//   dan ia memang dikecualikan lebih awal). Kalau module skipStages12 baru muncul, kesan
//   paling teruk = auto-gen dilangkau + user tekan Generate sendiri (tetap menjadi).
const hasGenerationData = (p) => !!(p?.intelligenceData && (p.intelligenceData.imageAnalysis || p.intelligenceData.webResearch));

/* ⚠️ KEMBAR: DUP_MEDIA_FIELDS (bawah) + MEDIA_SET dalam utils/kosongkanPrompt.js
   + MEDAN_MEDIA_SET dalam utils/kadSalinan.js (pagar padam fail dikongsi, 2026-10-06).
   Medan media baharu → tambah di KEEMPAT-EMPAT tempat, kalau tidak butang
   Kosongkan Prompt akan memadamnya sebagai teks. */
const PROMPT_VIEW_SKIP = new Set(['uploadedVideo', 'uploadedVideoThumb', 'uploadedImage']);

/* ⭐ GANTI, BUKAN TAMPAL — satu peraturan untuk SEMUA laluan yang menulis
   hasil ChatGPT/Gemini ke dalam kad (Agent Saya + Smart Custom/FLOWNITY lama).

   Aduan user 2026-08-19, dengan bukti skrin: satu kad dijalankan dengan agent
   Gemini 5 medan, kemudian dengan agent ChatGPT 3 medan. Dahulu blok gabungan
   melebur hasil baharu ke ATAS teks sedia ada, jadi Hook Text dan Video Script
   kekal milik larian Gemini sedangkan tiga medan lain sudah bertukar. Kad
   menjadi campuran dua larian, dan pelanggan membacanya sebagai larian yang
   tersekat separuh jalan.

   Peraturannya kini: larian TERKINI menentukan seluruh teks kad. SEMUA set
   dibina semula — bukan hanya set yang diisi larian ini — supaya lebihan set
   dan babak daripada larian yang lebih panjang turut dikosongkan.

   ⚠️⚠️ DIKOSONGKAN, BUKAN DIBUANG daripada objek — ini keperluan Firestore,
      bukan gaya. Teks kad tinggal dalam subdoc `detail/text` (Split V2) yang
      ditulis dengan `merge: true`; Firestore menggabungkan peta secara DALAM,
      jadi kunci yang hilang daripada objek tempatan TIDAK terpadam di pangkalan
      data dan medan lama hidup semula pada muat berikutnya — pepijat yang
      nampak "kembali dengan sendiri". Menulis nilai kosong ke atasnya yang
      benar-benar melenyapkannya. ⛔ Jangan "kemaskan" dengan membuang kunci,
      dan jangan tukar subdoc itu kepada tulisan tanpa merge (laluan lain
      menulis sebahagian sahaja, cth intelligenceData — ia akan terpadam).

   ⛔ `*Template` ditulis null, BUKAN string kosong. Kod suntingan menyemak
      `!= null` (recomputeSetPrompts), jadi template kosong masih dikira wujud:
      suntingan Hook yang PERTAMA selepas itu akan membina semula Image/Video
      Prompt daripada template kosong dan memadam teks baharu secara senyap.

   Yang SENGAJA dikekalkan (keputusan user): video, poster dan gambar dalam
   PROMPT_VIEW_SKIP, serta kunci dalaman `_`. Fail itu hasil kerja sebenar yang
   memakan kuota dan masa, dan memadamnya tidak boleh dibatalkan; pelanggan
   tetap boleh memadamnya sendiri. */
const gantiPromptsDenganHasil = (promptsLama, mapped) => {
    const lama = promptsLama || {};
    const kekal = (k) => PROMPT_VIEW_SKIP.has(k) || k.startsWith('_');
    const out = {};
    for (const setKey of new Set([...Object.keys(lama), ...Object.keys(mapped || {})])) {
        const setLama = lama[setKey];
        const asas = {};
        if (setLama && typeof setLama === 'object') {
            for (const k of Object.keys(setLama)) {
                asas[k] = kekal(k) ? setLama[k] : (k.endsWith('Template') ? null : '');
            }
        }
        out[setKey] = { ...asas, ...((mapped || {})[setKey] || {}) };
    }
    return out;
};
const promptsToJson = (prompts) => {
    if (!prompts || typeof prompts !== 'object') return '{}';
    try {
        const obj = {};
        for (const [setKey, setVal] of Object.entries(prompts)) {
            if (!setVal || typeof setVal !== 'object') continue;
            const out = {};
            for (const [k, v] of Object.entries(setVal)) {
                if (PROMPT_VIEW_SKIP.has(k) || k.startsWith('_')) continue;
                if (v == null || v === '') continue;
                if (typeof v === 'string' && v.startsWith('data:')) continue; // jangan bawa base64
                if (typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean') out[k] = v;
            }
            if (Object.keys(out).length > 0) obj[setKey] = out;
        }
        return JSON.stringify(obj, null, 2);
    } catch { return '{}'; }
};

// ═══════════════════════════════════════════════════════════
// ★ DUPLICATE KAD (2026-08-03) — salin kad pipeline yang dah menjadi jadi stok baharu.
// Kes sebenar pelanggan: satu kad "winning", dan untuk dapat video kedua dia terpaksa
// tunggu video siap → upload TikTok → padam video → Run Flow semula, satu-satu. Salinan
// = kad baharu dengan prompt yang SAMA, boleh di-Run serentak. Tiada panggilan AI →
// kuota generation TIDAK berkurang.
//
// Media (video, thumbnail, gambar hasil Flow) SENGAJA tidak disalin: dua kad tidak boleh
// berkongsi fail Storage yang sama — laluan padam produk kutip URL video/thumb terus dari
// `prompts` (collectProductStorageUrls), jadi padam satu kad akan memusnahkan fail milik
// kad satu lagi. Kad salinan bermula bersih dan menjana videonya sendiri.
const DUP_MEDIA_FIELDS = new Set(['uploadedVideo', 'uploadedVideoThumb', 'uploadedImage']);

/* Keadaan tertutup popup Kosongkan Prompt. ⚠️ KEMBAR medan media: MEDIA_SET dalam
   utils/kosongkanPrompt.js mesti sama dengan PROMPT_VIEW_SKIP + DUP_MEDIA_FIELDS. */
const KOSONG_PROMPT_TUTUP = { open: false, setKey: null, fasa: 'semak', pelan: [], langkau: 0, kosong: 0 };

/** Salin `prompts` — teks sahaja, buang medan media. */
const clonePromptsTextOnly = (prompts) => {
    const out = {};
    if (!prompts || typeof prompts !== 'object') return out;
    for (const [setKey, setVal] of Object.entries(prompts)) {
        if (!setVal || typeof setVal !== 'object' || Array.isArray(setVal)) {
            if (setVal != null) out[setKey] = setVal; // kunci bukan-set (cth _templateTrace)
            continue;
        }
        const s = {};
        for (const [k, v] of Object.entries(setVal)) {
            if (DUP_MEDIA_FIELDS.has(k)) continue;
            s[k] = v;
        }
        out[setKey] = s;
    }
    return out;
};

/** "Baju Kurung (3)" → "Baju Kurung" */
const dupBaseName = (name) => String(name || 'Produk').replace(/\s*\(\d+\)\s*$/, '').trim() || 'Produk';

/**
 * Nombor salinan seterusnya bagi sesuatu nama asas. Kad asal dikira #1, jadi salin
 * berulang (atau salin daripada kad yang sendirinya salinan) tidak menghasilkan dua "(2)".
 */
const nextDupIndex = (base, existingNames) => {
    let max = 0;
    for (const raw of existingNames) {
        const s = String(raw || '').trim();
        if (s === base) { max = Math.max(max, 1); continue; }
        const m = s.match(/^(.*?)\s*\((\d+)\)$/);
        if (m && m[1].trim() === base) max = Math.max(max, parseInt(m[2], 10) || 0);
    }
    return max + 1;
};

// ★ COST-FIX (kaunter storage, 2026-07): tambah kaunter `storageUsedBytes` pada user doc —
// ganti scan listAll+getMetadata setiap fail (126M ops/bln = RM849). Bar & had 2GB baca
// kaunter ni. Nota: PADAM fail sengaja TIDAK tolak kaunter (drift ke arah selamat);
// butang Optimize (App.jsx) recount penuh + tulis semula nilai tepat = self-heal.
const bumpStorageCounter = (db, uid, deltaBytes) => {
    if (!uid || !deltaBytes) return;
    setDoc(doc(db, 'users', uid), { storageUsedBytes: increment(deltaBytes) }, { merge: true })
        .catch(() => { /* bukan kritikal — Optimize recount akan betulkan */ });
};

const jsonToPlain = (jsonStr) => {
    try {
        const parsed = JSON.parse(jsonStr);
        if (!parsed || typeof parsed !== 'object') return '';
        const fmtVal = (v) => (v && typeof v === 'object') ? JSON.stringify(v) : String(v);
        const renderObj = (obj) => Object.keys(obj)
            .filter(f => obj[f] !== undefined && obj[f] !== null && obj[f] !== '')
            .map(f => `${f}: ${fmtVal(obj[f])}`)
            .join('\n\n');
        const setKeys = Object.keys(parsed).filter(k => k.startsWith('set'));
        let plain = '';
        if (setKeys.length) {
            setKeys.forEach((key, index) => {
                if (index > 0) plain += '\n\n';
                plain += `[SET ${key.replace('set', '')}]\n`;
                const v = parsed[key];
                const body = (v && typeof v === 'object') ? renderObj(v) : fmtVal(v);
                if (body) plain += body + '\n';
            });
        } else {
            plain = renderObj(parsed); // tiada struktur "set" — papar flat
        }
        return plain.trim();
    } catch (e) {
        return '';
    }
};

// Tukar teks Plain → JSON. GENERIC: guna nama field dari JSON ASAL sebagai anchor untuk
// pisah value (selamat walau value mengandungi ':'). Tak lagi terhad pada 3 field tetap.
const plainToJson = (plainStr, originalJsonStr) => {
    let parsed = {};
    try { parsed = JSON.parse(originalJsonStr); } catch (e) { }

    const setKeys = Object.keys(parsed).filter(k => k.startsWith('set'));
    // Kumpul semua nama field merentas semua set; anchor paling panjang dulu (elak 'sceneN' silap padan 'sceneNN').
    const fieldSet = new Set();
    setKeys.forEach(sk => Object.keys(parsed[sk] || {}).forEach(f => fieldSet.add(f)));
    const fieldList = Array.from(fieldSet).sort((a, b) => b.length - a.length);
    if (!fieldList.length) return originalJsonStr; // tiada field dikenali — jangan rosakkan

    const esc = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const extractField = (str, fieldName) => {
        const others = fieldList.filter(f => f !== fieldName).map(esc);
        const next = others.length ? others.join('|') : '(?!)'; // '(?!)' = pattern yang takkan padan
        const regex = new RegExp(`(?:^|\\n)${esc(fieldName)}\\s*[:\\-]\\s*([\\s\\S]*?)(?=(?:\\n(?:${next})\\s*[:\\-])|$)`, 'i');
        const m = str.match(regex);
        return m ? m[1].trim() : null;
    };
    const applyToSet = (setName, content) => {
        if (!parsed[setName]) parsed[setName] = {};
        fieldList.forEach(f => {
            const val = extractField(content, f);
            if (val !== null) parsed[setName][f] = val;
        });
    };

    // Pisah ikut header [SET N]
    const setRegex = /(?:^|\n)\[?SET[ \-_]*(\d+)\]?(?=\s|\n|$)/gi;
    const parts = plainStr.split(setRegex);
    if (parts.length === 1) {
        if (parts[0].trim()) applyToSet(setKeys[0] || 'set1', parts[0]);
    } else {
        let i = 1;
        while (i < parts.length) {
            applyToSet('set' + parts[i], parts[i + 1] || '');
            i += 2;
        }
    }

    return JSON.stringify(parsed, null, 2);
};

/* ★ v3.0.0: Helper to request local video from extension via bridge.
   ⚠️ `t` PILIHAN — dua daripada tiga pemanggil langsung tidak memapar mesej
   ralat ini (mereka hanya membaca berjaya/gagal), jadi hanya laluan modal
   pemain video yang menghantarnya. Tanpa `t`, ayat asal dikekalkan.
   ⛔ 'SESAAT_GET_LOCAL_VIDEO' / 'SESAAT_LOCAL_VIDEO_RESPONSE' = jenis mesej
      bridge kepada extension — JANGAN sentuh. */
const requestLocalVideo = (productId, setKey, t = null) => {
    const T = (kunci, lalai) => (t ? t(kunci) : lalai);
    return new Promise((resolve, reject) => {
        const requestId = `${productId}_${setKey}_${Date.now()}`;
        const timeout = setTimeout(() => {
            window.removeEventListener('message', handler);
            reject(new Error(T('ws.video.extNotResponding', 'Extension not responding. Pastikan Extension SESAAT aktif.')));
        }, 5000);
        const handler = (event) => {
            if (event.data?.type === 'SESAAT_LOCAL_VIDEO_RESPONSE' && event.data.requestId === requestId) {
                clearTimeout(timeout);
                window.removeEventListener('message', handler);
                if (event.data.success) {
                    resolve(event.data.base64);
                } else {
                    reject(new Error(event.data.error || T('ws.video.notInLocalCache', 'Video not found in local cache')));
                }
            }
        };
        window.addEventListener('message', handler);
        window.postMessage({ type: 'SESAAT_GET_LOCAL_VIDEO', productId, setKey, requestId }, '*');
    });
};

// ★ Reusable Video Thumbnail Preview — shows thumbnail with play overlay, falls back to video poster or icon placeholder
/* ---------- Menu susunan (rupa v3.9) ---------------------------------
   Bentuk SAMA dengan prototaip /workspace-v3.9: TIGA jenis, arah ditukar
   dengan menekan jenis yang sama sekali lagi. Menu lama menyenaraikan ENAM
   baris berasingan (naik & turun bagi setiap jenis) — dua kali panjang
   untuk bilangan pilihan sebenar yang sama.

   ⛔ Ia memakai `flowSortType`/`flowSortDirection` yang SEDIA ADA. Tiada
      state baharu dan logik susunan langsung tidak disentuh — yang bertukar
      hanyalah rupa menu. Sebab itu id di bawah kekal 'index'/'time'/'module'
      seperti kod lama, bukan nama BM seperti dalam prototaip.

   ⛔ Menu lama dibuka dengan `group-hover`. Itu TIDAK boleh dibuka langsung
      pada telefon dan tablet — tiada tetikus untuk melalui atasnya, jadi
      pilihan susunan memang mustahil dicapai di sana. Yang ini dibuka
      dengan tekan. */
/* Tinggi jalur alat v3.9 — nilai PERMULAAN sahaja. Tinggi sebenar diukur
   daripada elemen itu sendiri semasa jalan (lihat `jalurTinggi` di dalam
   komponen); nombor ini hanya dipakai pada render pertama sebelum ukuran
   sampai, dan sebagai sandaran kalau ResizeObserver tiada.

     22  padding atas jalur tab
   + 36  tinggi jalur tab (`.sesaat-ws-pills`: butang 30px + padding 3+3)
   + 16  padding bawah jalur tab

   ⛔ SEJARAH — sebab ia tidak lagi dikira dengan tangan: nilai ini dahulu
      78+36+16 = 130, kerana jalur alat menyimpan ruang untuk kepala
      halaman yang MELAYANG di atasnya. Pada 2026-08-12 kepala itu ditukar
      menjadi kepala halaman biasa dan padding jalur dikecilkan kepada
      22px — tetapi pemalar ini tertinggal pada 130. Akibatnya bar pukal
      parkir 56px terlalu rendah: satu jurang kosong menganga di bawah
      tab, dan bar itu menutup bahagian atas kad pertama (diukur hidup
      2026-08-13: jalur 74px, bar parkir pada 197px sedangkan jalur tamat
      pada 141px).

      Amaran lama di sini berbunyi "kalau nilai di atas diubah, ubah di
      sini juga". Amaran itu tidak dipatuhi, dan memang begitulah nasib
      amaran begini. Sebab itu ia kini DIUKUR, bukan dikira. */
const V39_TOOLBAR_H_ASAS = 22 + 36 + 16;

/* Ruang KOSONG di atas sesuatu butang dalam bar pukal — diukur dari BAWAH
   jalur alat, bukan dari atas skrin.

   ⛔ JANGAN pulangkan ia kepada `rect.top`. Jalur alat melekat di kepala
      senarai dengan latar PEJAL dan zIndex 20, manakala bar pukal zIndex 15.
      Menu yang dibuka ke ATAS dan masuk ke kawasan jalur itu dicat DI
      BELAKANGnya dan lenyap terus daripada skrin — ia tetap terbuka, tetapi
      pengguna tidak nampak apa-apa dan membacanya sebagai butang rosak.

   Aduan sebenar (pelanggan, 2026-08-23): akaun dengan DUA group sahaja
   langsung tidak nampak senarai Move Group. Puncanya bukan bilangan group
   itu sendiri — ia anggaran tinggi menu: senarai pendek dianggap "muat di
   atas", jadi ia sentiasa dibuka ke atas terus ke dalam jalur. Akaun yang
   banyak group tidak pernah kena kerana anggaran mereka besar dan menu itu
   membalik ke bawah dengan sendirinya. Jadi ia gagal tepat pada pengguna
   yang paling sedikit datanya, dan lulus pada akaun kita sendiri.

   Rupa lama tidak terjejas: di sana bar pukal duduk di atas kad DIPILIH yang
   pertama (boleh jauh ke bawah senarai), jadi jarak dari jalur memang besar
   dan menu kekal membuka ke atas seperti sebelum ini. */
/* ---------- Status TikTok per AKAUN, disimpan pada KAD -------------------
   Dipindah ke utils/statusAkaunKad.js (2026-09-18) bersama nota penuhnya:
   `kunciAkaun`, `gabungStatusAkaun`, dan fungsi baharu `statusAkaunDibuka`
   (pil hanya ikut akaun yang dibuka di kalendar — arahan user 2026-09-18). */

function ruangAtasJalur(rect, jalurEl) {
    const hadAtas = jalurEl ? jalurEl.getBoundingClientRect().bottom : 0;
    return rect.top - Math.max(hadAtas, 0);
}

/* ---------- Tab Schedule (v3.9) — simpanan draf ----------------------
   Susunan kalendar, senarai template dan label akaun disimpan dalam
   SIMPANAN BROWSER buat masa ini, bukan Firestore.

   Sebab ia belum naik ke server: susunan ini belum lagi menjadi jadual
   yang benar-benar dihantar ke TikTok. Laluan sebenar memerlukan
   release extension baharu (pengiraan masa setiap video berlaku di
   dalam background.ts, fail yang hanya sampai kepada pelanggan melalui
   pasang semula). Menyimpannya ke Firestore hari ini bermakna mencipta
   bentuk data yang akan ditulis semula sebaik laluan sebenar dibina.

   ⚠️ Kesan yang mesti diketahui: susunan ini TIDAK merentas browser.
      Pengguna yang menyusun di browser A tidak akan melihatnya di
      browser B. Ini diterima buat sementara kerana ia draf perancangan;
      ia BUKAN kelakuan akhir yang dikehendaki.

   Corak simpanan-browser ini sama seperti `flowSortType` dan
   `activeTab` di atas — tetapan yang memang milik satu browser. */
const SCHED_KEY_V39 = 'sesaat_sched_v39';

/* ---------- ★ v3.9.2 — TETAPAN LARIAN JADI MILIK SETIAP BROWSER --------------
   Punca aduan multi-browser 2026-08-25: pilihan set (Flow + TikTok), mod
   Showcase/Post Only dan tetapan larian lain disimpan sebagai SATU rekod
   `extensionSettings` di Firestore untuk SATU akaun — dan listener di bawah
   menolaknya masuk ke SEMUA browser. Pelanggan tukar set di browser 2 →
   browser 1 dan 3 bertukar sendiri, lalu Run di browser 1 menjalankan pilihan
   browser 2.

   Kini: pilihan larian browser INI disimpan dalam localStorage (kunci di
   bawah). Firestore hanya menjadi BENIH kali pertama (browser yang belum ada
   rekod sendiri); selepas itu, perubahan dari browser lain TIDAK lagi diterima
   masuk. ⚠️ Penulisan KE Firestore SENGAJA dikekalkan — panel extension +
   extension versi lama masih membacanya dari situ; menghentikannya akan
   mematikan paparan tetapan di panel. Nilai Firestore = "browser terakhir yang
   menulis", dan itu memadai untuk pembaca tersebut.

   `isMultipleBrowserMode` + `postTiktokAfterFlow` SENGAJA kekal dikongsi ikut
   cloud — kedua-duanya tetapan akaun, bukan pilihan larian per-browser. */
const RUN_CONFIG_KEY = 'sesaat_run_config_v1';

const bacaRunConfigLokal = () => {
    try {
        const mentah = localStorage.getItem(RUN_CONFIG_KEY);
        if (!mentah) return null;
        const d = JSON.parse(mentah);
        return (d && typeof d === 'object') ? d : null;
    } catch { return null; }
};

const tulisRunConfigLokal = (cfg) => {
    try { localStorage.setItem(RUN_CONFIG_KEY, JSON.stringify(cfg)); } catch { /* storan penuh/ditutup — abai */ }
};

/* ⭐ 2026-09-03 — MIGRASI model video LAMA → model + tempoh + ingredients berasingan.
   Nilai tersimpan lama `flowUltraMode` mengunci ketiga-tiga: 'omni_flash_8s' dsb. Skrip Flow
   kini remote (kemas kini serta-merta) tetapi tetapan tersimpan hidup lama, jadi kita LERAIKAN
   masa dibaca supaya pengguna sedia ada dapat kelakuan SAMA PERSIS:
     omni_flash_Ns → model 'omni_flash', tempoh 'Ns', ingredients ON  (Omni memang guna Ingredients)
     lite/fast/lower_priority → model kekal, tempoh '8s' (default lama), ingredients OFF
   `dur`/`ing` tersimpan (kalau ada) menang atas terbitan — supaya pilihan pengguna kekal. */
// ⭐ 2026-09-13 — resolusi video Omni. Nilai tersimpan rosak/tiada → '720p' (lalai lama Flow).
const normResolusiVideo = (r) => (r === '360p' || r === '720p') ? r : '720p';
/* ⭐ 2026-09-16 — SAIZ FAIL VIDEO (menu Download dlm Flow).
   'asal' = "Original size" (kelakuan SEBELUM ini, lalai) · 'naik' = "Upscaled".
   Nilai disimpan sebagai perkataan, BUKAN nombor: menu Flow memaparkan nombor yang
   BERBEZA ikut cara video dijana (diukur hidup 2026-09-16 — Omni 360p bagi
   "360p Original size"+"720p Upscaled"; Omni 720p dan Veo Lite bagi "720p Original
   size"+"1080p Upscaled"+4K). Menyimpan nombor akan gagal SENYAP pada video yang
   menunya tiada nombor itu. ⛔ 4K (50 kredit/video) sengaja TIADA pilihan. */
const normSaizVideo = (v) => (v === 'naik' ? 'naik' : 'asal');
// ⭐ 2026-09-15 — Workflow Control Panel. Nilai rosak/tiada → 'generate' (kelakuan lama).
const normWorkflow = (w) => (w === 'kad' ? 'kad' : 'generate');

const leraiModVideoLama = (mode, dur, ing) => {
    let model = (typeof mode === 'string' && mode) ? mode : 'lower_priority';
    let duration = (typeof dur === 'string') ? dur : null;
    let ingredients = (typeof ing === 'boolean') ? ing : null;
    const m = /^omni_flash_(\d+)s$/.exec(model);
    if (m) {
        model = 'omni_flash';
        if (duration == null) duration = m[1] + 's';
        if (ingredients == null) ingredients = true;
    }
    if (duration == null) duration = '8s';                       // default lama semua mode
    if (ingredients == null) ingredients = (model === 'omni_flash'); // kelakuan lama
    return { model, duration, ingredients };
};

const schedBaca = () => {
    try {
        const mentah = localStorage.getItem(SCHED_KEY_V39);
        if (!mentah) return {};
        const d = JSON.parse(mentah);
        return (d && typeof d === 'object') ? d : {};
    } catch { return {}; }
};

/* Satu akaun lalai supaya kalendar boleh terus digunakan. Tanpa ia,
   pengguna berdepan dengan pemilih akaun kosong sebelum sempat
   memahami apa itu "akaun" di skrin ini. */
const SCHED_AKAUN_LALAI = [{ id: 'akaun1', nama: 'Akaun 1' }];

/* Pembanding susunan produk. DIKONGSI oleh senarai kad biasa dan senarai
   produk pada tab Schedule — dua salinan bermakna satu daripadanya akan
   ketinggalan senyap bila peraturan susunan berubah. */
/* ★ SUSUNAN MANUAL KAD (drag, 2026-09-05) — medan `manualOrder` pada doc produk, DIKONGSI
   webapp ↔ extension melalui Firestore. Kad TANPA nombor (baru masuk) duduk di ATAS, terbaru
   dahulu antara sesama mereka; kad bernombor ikut menaik. Arah asc/desc TIDAK terpakai.
   ⚠️ Salinan kembar dalam extension: `bandingSusunanManual` + `kiraSusunanSeret` (App.tsx).
   Dua codebase tidak kongsi kod — ubah satu, ubah dua-dua. */
const _masaProduk = (p) => (p?.movedAt || parseInt(String(p?.id || '').split('_')[1] || '0', 10) || 0);
function bandingSusunanManual(a, b) {
    const ma = typeof a?.manualOrder === 'number' ? a.manualOrder : null;
    const mb = typeof b?.manualOrder === 'number' ? b.manualOrder : null;
    if (ma === null && mb === null) return _masaProduk(b) - _masaProduk(a);
    if (ma === null) return -1;
    if (mb === null) return 1;
    return ma - mb;
}
/* Kira nombor baharu selepas seretan. `senarai` = kad dalam turutan PAPARAN semasa. Kad diseret
   (berbilang bila kad bertanda) masuk SEBELUM target bila diseret ke atas, SELEPAS target bila ke
   bawah. Semua kad dalam senarai dinomborkan semula (langkah 1000); hanya yang BERUBAH dipulangkan. */
function kiraSusunanSeret(senarai, idsSeret, targetId) {
    const set = new Set(idsSeret);
    const kekal = senarai.filter(p => !set.has(p.id));
    const diseret = senarai.filter(p => set.has(p.id));
    let idx = kekal.findIndex(p => p.id === targetId);
    if (idx < 0) idx = kekal.length;
    const asal = senarai.findIndex(p => set.has(p.id));
    const targetAsal = senarai.findIndex(p => p.id === targetId);
    if (asal >= 0 && targetAsal > asal) idx += 1;
    const baru = [...kekal.slice(0, idx), ...diseret, ...kekal.slice(idx)];
    const hasil = new Map();
    baru.forEach((p, i) => {
        const n = (i + 1) * 1000;
        if (p.manualOrder !== n) hasil.set(p.id, n);
    });
    return hasil;
}

/* ★ GAMBAR PRODUK TAMBAHAN (2026-09-05) — `extraImageUrls` pada kad (aras ATAS, bukan dalam
   `prompts.setN`: Split V2 akan hantar medan dalam set ke subdoc teks berat). Gambar UTAMA kekal
   `imageBase64`/`imageUrl`. Had 5 termasuk utama = 4 tambahan. Kembar dalam extension:
   `extraImgs`/`multiImg` (ProductCard.tsx). */
const GBR_MAKS_TAMBAHAN = MAKS_GAMBAR_TAMBAHAN;   // satu sumber: utils/agentGambar.js
function gambarTambahan(p) {
    return Array.isArray(p?.extraImageUrls)
        ? p.extraImageUrls.filter(u => typeof u === 'string' && u).slice(0, GBR_MAKS_TAMBAHAN)
        : [];
}

function bandingProduk(st, sd) {
    return (a, b) => {
        if (st === 'manual') return bandingSusunanManual(a, b);
        if (st === 'index') {
            const indexA = a.originalIndex || 0;
            const indexB = b.originalIndex || 0;
            return sd === 'asc' ? indexA - indexB : indexB - indexA;
        } else if (st === 'module') {
            const modA = (a.moduleId || '').toLowerCase();
            const modB = (b.moduleId || '').toLowerCase();
            if (!modA && !modB) return 0;
            if (!modA) return 1;
            if (!modB) return -1;
            return sd === 'asc' ? modA.localeCompare(modB) : modB.localeCompare(modA);
        }
        // ★ Use movedAt (if present) so moved products appear as newest
        const timeA = a.movedAt || parseInt(a.id.split('_')[1] || 0);
        const timeB = b.movedAt || parseInt(b.id.split('_')[1] || 0);
        return sd === 'asc' ? timeA - timeB : timeB - timeA;
    };
}

/* ⛔ `id` = nilai yang disimpan dan dibanding (localStorage + logik susun).
   JANGAN sentuh. Hanya `kunci`/`tip` diterjemah; tip yang berbentuk simbol
   (1 → 10, A → Z) memang sama dalam kedua-dua bahasa, jadi ia kekal literal. */
const SUSUN_V39 = [
    { id: 'index', kunci: 'ws.sort.number', lalai: 'asc', tip: { asc: '1 → 10', desc: '10 → 1' } },
    { id: 'time', kunci: 'ws.sort.time', lalai: 'desc', tipKunci: { asc: 'ws.sort.tip.oldest', desc: 'ws.sort.tip.newest' } },
    { id: 'module', kunci: 'ws.sort.module', lalai: 'asc', tip: { asc: 'A → Z', desc: 'Z → A' } },
    { id: 'manual', kunci: 'ws.sort.manual', lalai: 'asc', tipKunci: { asc: 'ws.sort.tip.manual', desc: 'ws.sort.tip.manual' } },
];

const SortMenuV39 = ({ jenis, arah, onTukar }) => {
    /* Komponen ini dirender HANYA di bawah suis v3.9 (dua titik panggilan
       dipagar `uiV39`), jadi ia selamat memanggil useT() tanpa syarat. */
    const t = useT();
    const teksTip = (s, a) => (s.tipKunci ? t(s.tipKunci[a]) : s.tip[a]);
    const [buka, setBuka] = useState(false);
    const rujuk = useRef(null);

    useEffect(() => {
        if (!buka) return undefined;
        const luar = (e) => { if (rujuk.current && !rujuk.current.contains(e.target)) setBuka(false); };
        const esc = (e) => { if (e.key === 'Escape') setBuka(false); };
        document.addEventListener('mousedown', luar);
        document.addEventListener('keydown', esc);
        return () => {
            document.removeEventListener('mousedown', luar);
            document.removeEventListener('keydown', esc);
        };
    }, [buka]);

    const kini = SUSUN_V39.find((s) => s.id === jenis) || SUSUN_V39[1];
    const IkonArah = arah === 'asc' ? ArrowUp : ArrowDown;

    return (
        <div ref={rujuk} style={{ position: 'relative' }}>
            <button
                type="button"
                onClick={() => setBuka((v) => !v)}
                aria-haspopup="menu"
                aria-expanded={buka}
                /* Chip bergaris, nilai diukur daripada butang susun prototaip:
                   garis --s-line-strong, bucu 8px, tinggi 32px, padding 0 11px.
                   Tanpa garis ini ia teks bogel di tepi kanan toolbar dan
                   langsung tidak kelihatan seperti benda yang boleh ditekan. */
                style={{
                    display: 'flex', alignItems: 'center', gap: 6,
                    height: 32, padding: '0 11px', borderRadius: 8, cursor: 'pointer',
                    border: '1px solid var(--s-line-strong)', fontFamily: 'inherit', fontSize: 13, fontWeight: 500,
                    background: buka ? 'var(--s-fill)' : 'transparent', color: 'var(--s-ink)',
                }}
            >
                <ArrowUpDown size={14} strokeWidth={2} style={{ color: 'var(--s-ink-3)' }} />
                {t(kini.kunci)}
                <IkonArah size={12} strokeWidth={2.4} style={{ color: 'var(--s-ink-3)' }} />
            </button>

            {/* Dijajar ke KANAN: butang ini duduk di hujung kanan toolbar, jadi
                menu yang bermula dari tepi kirinya melimpah keluar skrin. */}
            {buka && (
                <div className="s-pop" role="menu" style={{ minWidth: 210, left: 'auto', right: 0 }}>
                    {SUSUN_V39.map((s) => {
                        const aktif = s.id === jenis;
                        return (
                            <button
                                key={s.id}
                                type="button"
                                role="menuitem"
                                className="s-pop__row"
                                onClick={() => onTukar(s.id, aktif ? (arah === 'asc' ? 'desc' : 'asc') : s.lalai)}
                            >
                                <span style={{ flex: 1, fontSize: 13, color: aktif ? 'var(--s-ink)' : 'var(--s-ink-2)' }}>
                                    {t(s.kunci)}
                                </span>
                                <span className="s-dim" style={{ fontSize: 11.5 }}>{teksTip(s, aktif ? arah : s.lalai)}</span>
                                {aktif && <Check size={13} strokeWidth={2.2} style={{ color: 'var(--s-ink)', flex: 'none' }} />}
                            </button>
                        );
                    })}
                    <span className="s-pop__sep" />
                    <p style={{ margin: 0, padding: '2px 9px 5px', fontSize: 11.5, lineHeight: 1.45, color: 'var(--s-ink-3)' }}>
                        {t('ws.sort.hint')}
                    </p>
                </div>
            )}
        </div>
    );
};

/* ---------- Susun atur tab Schedule (v3.9) ---------------------------------
   Dua lajur: senarai kad di kiri, kalendar di kanan. Kedua-duanya kelihatan
   serentak kerana kerja di skrin itu ialah MENYERET kad ke slot waktu —
   senarai di belakang suis menjadikannya mustahil.

   ⚠️ Bila `aktif` palsu ia memulangkan anaknya BULAT-BULAT, tanpa bekas
      tambahan. Ini bukan kemalasan: senarai kad rupa lama bergantung pada
      `space-y-*` daripada bekas di atasnya, dan bekas tambahan di tengah
      akan memutuskan jarak antara kad pada SEMUA tab lain.

   ⛔ Senarai kad tidak dihantar masuk sebagai prop dan tidak disalin ke
      dalam komponen ini — ia kekal di tempat asalnya dalam pokok JSX
      WorkspaceView (satu blok ~2,400 baris yang membawa setiap butang,
      textarea dan modal kad). Membawanya keluar bermakna menyalinnya. */
/* ⭐ DUA lajur, DUA tatal BERASINGAN (arahan user 2026-08-23) - nota penuh
   pada `.s-tikjad__kiri` dalam ui.css. Ringkasnya: tetikus di atas senarai
   menatal senarai sahaja, tetikus di atas kalendar menatal kalendar sahaja.
   Halaman itu sendiri tidak lagi menatal pada tab ini.

   Kepala senarai ("Products N" + susunan) SENGAJA di luar kotak tatal - ia
   membawa kiraan dan pemilih susunan, dan kedua-duanya milik SELURUH senarai,
   bukan milik bahagian yang kebetulan sedang dilihat. */
/* Pil status di bawah satu kotak set — status AKAUN YANG SEDANG DIBUKA di
   kalendar SAHAJA (arahan user 2026-09-18: "pil hanya appear status yg
   related dgn akaun yg di buka di calendar"). Tukar akaun di kalendar = pil
   pada semua kad bertukar ikut akaun itu. Rekod akaun lain KEKAL tersimpan
   pada kad dan muncul semula bila akaun itu dibuka (utils/statusAkaunKad.js).

   ⛔ Dahulu (2026-08-23) satu baris bagi SETIAP akaun, dengan nombor kecil
      kedudukan akaun di kiri. Ditarik balik: pengguna nampak pil "Failed"
      milik akaun lain yang butang pukal tidak boleh sentuh. Jangan pulangkan
      tanpa bertanya. Nama akaun kini dalam tooltip baris.

   ⛔ Pemilih guna PilihV39 kerana komponen itu melukis menunya dalam portal
      ke <body>. Menu biasa akan terpotong: kad ini duduk dalam lajur senarai
      yang ada tatal sendiri (lihat `.s-tikjad__tatal`). */
const StatusSetV39 = ({ rekod, namaAkaun, t, onTukar }) => {
    if (!rekod || !rekod.st) return null;
    const asas = [
        { id: 'complete', label: t('workspace.tiktok.cal.stDone') },
        /* ★ [2026-09-29] Posted = complete + md 'now' (utils/statusAkaunKad.js). */
        { id: ID_POSTED, label: t('workspace.tiktok.cal.stPosted') },
        { id: 'draft', label: t('workspace.tiktok.cal.stDraft') },
        { id: 'failed', label: t('workspace.tiktok.cal.stFail') },
        { id: '', label: t('workspace.tiktok.cal.stNone') },
    ];
    /* `running`/`uncertain` tiada dalam senarai boleh-pilih (sama seperti
       menu kalendar - pengguna tidak sepatutnya menetapkan "sedang jalan"
       dengan tangan). Tetapi tanpa entri padanan, pemilih akan memapar
       "Pilih" dan status sebenar hilang dari skrin - jadi ia disisip sebagai
       entri paparan bila perlu. */
    const pilihan = (rekod.st === 'running' || rekod.st === 'uncertain')
        ? [{ id: rekod.st, label: rekod.st === 'running' ? t('workspace.tiktok.cal.stRunning') : t('workspace.tiktok.cal.stUncertain') }, ...asas]
        : asas;
    return (
        <div className="s-setstat">
            <div className={'s-setstat__baris s-setstat__baris--' + rekod.st} title={namaAkaun || undefined}>
                <PilihV39
                    ariaLabel={t('workspace.tiktok.cal.editStatus')}
                    nilai={idPilihanStatus(rekod.st, rekod.md)}
                    onPilih={(v) => onTukar(v)}
                    pilihan={pilihan}
                    tinggi={20}
                    saizTeks={10.5}
                    lebar="auto"
                    lebarMenu={160}
                />
            </div>
        </div>
    );
};

/* `slotKepala` (Workspace v4, 26 Okt — aduan user: "tab schedule ni, ada ruang
   kosong kat list card"): dalam v4 jalur tab dipindah ke kepala halaman, jadi
   sel KIRI grid jalur alat tinggal kosong dan jalur itu kelihatan sebagai jurang
   menganga di atas senarai. Kepala "Products N · Sort" dihantar ke sel itu, jadi
   ia berbaris dengan bar tarikh kalendar dan senarai bermula terus di bawahnya.
   Slot tiada (Classic) → kepala kekal di tempat asalnya. */
const SchedGrid = ({ aktif, kiriSorok = false, onTogol, kepala, kalendar, gayaGrid, slotKepala = null, children }) => {
    if (!aktif) return children;
    /* Hide/show senarai = MANUAL (user 27 Okt). Butang HIDE kini PILL dalam
       kepala senarai, sebelah kiri "Time" (2026-11-01).

       Arah SHOW berbeza ikut rupa (arahan user 2026-11-01):
       · v4 (`slotKepala` wujud = kepala diportal ke kepala halaman): bila
         senarai tersorok, kepala tidak dirender, jadi lajur kiri HILANG
         sepenuhnya (`s-tikjad--solo`, satu lajur) dan kalendar jadi penuh.
         Butang "Show list" jadi PILL dalam bar kalendar (JadualTiktokV39),
         sepadan dengan "Show Control Panel".
       · classic (tiada portal kepala): kekal JALUR NIPIS `.s-tikjad__buka`
         di tepi — tidak disentuh. */
    const v4 = !!slotKepala;
    const kelas = 's-tikjad'
        + (kiriSorok && !v4 ? ' s-tikjad--kirisorok' : '')
        + (kiriSorok && v4 ? ' s-tikjad--solo' : '');
    return (
        <div className={kelas} style={gayaGrid}>
            {kiriSorok ? (
                v4 ? null : (
                    <button
                        type="button"
                        className="s-tikjad__buka"
                        onClick={onTogol}
                        title="Show product list"
                        aria-label="Show product list"
                    >
                        <PanelLeftOpen size={16} strokeWidth={2} aria-hidden="true" />
                    </button>
                )
            ) : (
                <div className="s-tikjad__kiri">
                    {slotKepala ? createPortal(kepala, slotKepala) : kepala}
                    <div className="s-tikjad__tatal">{children}</div>
                </div>
            )}
            <div className="s-tikjad__kanan">{kalendar}</div>
        </div>
    );
};

/* ★★ POSTER FRAME VIDEO — SATU takrifan untuk SEMUA laluan (2026-08-23).
   Rutin ini pernah disalin di TIGA tempat (poster video local, upload video
   manual, dan baiki-thumbnail masa preview) dan salinan itu sudah mula
   terpesong antara satu sama lain. Ia digabung di sini.

   Kenapa ia serumit ini: video gabungan Google Flow cerewet untuk di-seek.
   Frame kena BETUL-BETUL di-paint sebelum di-draw, dan beberapa titik masa
   kena dicuba — kalau tidak yang keluar ialah frame HITAM, iaitu thumbnail
   yang nampak rosak walhal videonya elok.

   ⚠️ `src` WAJIB blob: atau data: (sumber kita sendiri). Video yang dimuatkan
      terus dari URL jauh akan "taint" canvas, dan toBlob/toDataURL melempar
      SecurityError. */
const _posterOnceEvt = (target, evt, ms) => new Promise((resolve, reject) => {
    const ok = () => { cl(); resolve(); };
    const er = () => { cl(); reject(new Error(evt + ' error')); };
    const to = setTimeout(() => { cl(); reject(new Error(evt + ' timeout')); }, ms);
    const cl = () => { clearTimeout(to); target.removeEventListener(evt, ok); target.removeEventListener('error', er); };
    target.addEventListener(evt, ok, { once: true });
    target.addEventListener('error', er, { once: true });
});
const _posterPainted = (v) => new Promise((resolve) => {
    if (typeof v.requestVideoFrameCallback === 'function') {
        let done = false;
        try { v.requestVideoFrameCallback(() => { done = true; resolve(); }); } catch (_) { resolve(); return; }
        setTimeout(() => { if (!done) resolve(); }, 400);
    } else { setTimeout(resolve, 200); }
});
/** Tangkap satu bingkai daripada video → <canvas>. Melempar kalau semua titik gagal.
 *  opts: { lebar, tinggi } saiz tetap · { maksLebar } kecilkan ikut nisbah asal. */
async function tangkapPosterVideo(src, { lebar = 0, tinggi = 0, maksLebar = 0 } = {}) {
    const videoEl = document.createElement('video');
    videoEl.muted = true;
    videoEl.preload = 'auto';
    videoEl.playsInline = true;
    videoEl.src = src;
    try {
        await _posterOnceEvt(videoEl, 'loadedmetadata', 10000);
        const dur = isFinite(videoEl.duration) && videoEl.duration > 0 ? videoEl.duration : 0;
        const titik = dur > 0 ? [Math.min(Math.max(dur * 0.2, 0.8), 3), dur * 0.5, dur * 0.75, 0.3] : [0.5];
        let w = lebar || videoEl.videoWidth || 360;
        let h = tinggi || videoEl.videoHeight || 640;
        if (maksLebar && w > maksLebar) { h = Math.max(1, Math.round(h * (maksLebar / w))); w = maksLebar; }
        const c = document.createElement('canvas');
        c.width = w; c.height = h;
        const ctx = c.getContext('2d');
        for (const tt of titik) {
            try {
                const seeked = _posterOnceEvt(videoEl, 'seeked', 6000);
                try { videoEl.currentTime = Math.max(0, tt); } catch (_) { /* cuba titik lain */ }
                await seeked;
                await _posterPainted(videoEl);
                ctx.drawImage(videoEl, 0, 0, w, h);
                return c;
            } catch (_) { /* cuba titik seterusnya */ }
        }
        throw new Error('poster gagal — semua titik masa gagal');
    } finally {
        try { videoEl.removeAttribute('src'); videoEl.load(); } catch (_) { /* abaikan */ }
        videoEl.remove();
    }
}

/* ⚠️ Komponen ini dirender pada KEDUA-DUA rupa. Prop `t` sengaja PILIHAN:
   WorkspaceView menghantarnya hanya bila suis v3.9 hidup, jadi tanpa suis
   ia jatuh ke ayat lalai dan kad pelanggan hari ini kekal seperti asal. */
const VideoThumbPreview = ({ product, setKey, showCloudBadge = true, onPlayLocalVideo, onPlayCloudVideo, t = null, pushingKeys = null }) => {
    const T = (kunci, lalai, vars) => (t ? t(kunci, vars) : lalai);
    const thumbUrl = product.prompts?.[setKey]?.uploadedVideoThumb;
    const videoUrl = product.prompts?.[setKey]?.uploadedVideo;
    const isLocalOnly = !!videoUrl && videoUrl.startsWith('local://');
    const hasVideo = !!videoUrl && (videoUrl.startsWith('https://') || isLocalOnly);
    const isOnCloud = !!videoUrl && (videoUrl.includes('firebasestorage') || isR2Url(videoUrl));

    const handleClick = () => {
        if (isLocalOnly && onPlayLocalVideo) {
            onPlayLocalVideo(product.id, setKey);
        } else if (isOnCloud && onPlayCloudVideo) {
            onPlayCloudVideo(videoUrl, product.id, setKey);
        }
    };

    // ★ Untuk video local://, bytes sebenar wujud HANYA dalam browser yang upload
    // (chrome.storage.local, per-profil — TIDAK sync antara browser). Kita tanya extension
    // via bridge sama ada browser INI betul-betul ada bytes tu:
    //   • present → decode poster frame dari bytes tempatan, papar sebagai thumbnail.
    //   • absent  → papar KOSONG (macam "no video"), supaya browser yang tak ada video
    //               takkan nampak "ready". Kita SENGAJA TIDAK fallback ke thumbnail cloud
    //               untuk video local — fallback tu punca video nampak ready di browser yang
    //               sebenarnya tak boleh post ke TikTok.
    const [localThumbDataUrl, setLocalThumbDataUrl] = useState(null);
    const [localStatus, setLocalStatus] = useState(isLocalOnly ? 'checking' : null); // 'checking' | 'present' | 'absent'
    useEffect(() => {
        if (!isLocalOnly) { setLocalStatus(null); setLocalThumbDataUrl(null); return; }
        let cancelled = false;
        let blobUrl = null;
        const cleanup = () => {
            if (blobUrl) { URL.revokeObjectURL(blobUrl); blobUrl = null; }
        };
        // Decode poster frame dari bytes (best-effort — gagal decode cuma bermakna takda poster).
        const decodeThumb = (base64) => fetch(base64).then((r) => r.blob()).then(async (blob) => {
            if (cancelled) return null;
            blobUrl = URL.createObjectURL(blob);
            const kanvas = await tangkapPosterVideo(blobUrl);
            return kanvas.toDataURL('image/jpeg', 0.7);
        });
        setLocalStatus('checking');
        setLocalThumbDataUrl(null);
        requestLocalVideo(product.id, setKey).then(
            // Bridge RESOLVE → bytes MEMANG ada di browser ni.
            (base64) => {
                if (cancelled) return;
                setLocalStatus('present');
                if (!base64 || typeof base64 !== 'string' || !base64.startsWith('data:')) return;
                return decodeThumb(base64)
                    .then((dataUrl) => { if (!cancelled && dataUrl) setLocalThumbDataUrl(dataUrl); })
                    .catch(() => { /* decode gagal — kekal 'present', cuma takda poster frame */ });
            },
            // Bridge REJECT → cache MISS atau extension tak jawab → TIADA di browser ni.
            () => { if (!cancelled) setLocalStatus('absent'); }
        ).finally(() => cleanup());
        return () => { cancelled = true; cleanup(); };
    }, [isLocalOnly, product.id, setKey]);

    // Video local: poster HANYA dari bytes tempatan yang di-decode (tak pernah guna thumb cloud).
    // Video cloud / bukan-local: kekal guna Firestore thumbUrl macam biasa.
    const effectiveThumbUrl = isLocalOnly ? localThumbDataUrl : thumbUrl;
    const effectiveHasThumb = !!effectiveThumbUrl;
    const canShowVideoFrame = hasVideo && !isLocalOnly;
    // ★ Denyut hijau (arahan user 2026-08-23): slot ini sedang di-push ke cloud (Save Cloud).
    const isPushingToCloud = pushingKeys instanceof Set && pushingKeys.has(`${product.id}::${setKey}`);

    return (
        <div
            onClick={handleClick}
            className="w-full h-full bg-slate-900 flex flex-col items-center justify-center cursor-pointer relative group/play"
        >
            {/* ★ Denyut hijau semasa Save Cloud (arahan user 2026-08-23) — slot ini tengah naik R2. */}
            {isPushingToCloud && (
                <div className="absolute inset-0 z-30 pointer-events-none flex items-center justify-center bg-emerald-500/25 animate-pulse">
                    <span className="material-symbols-outlined text-emerald-100 text-[26px]" style={{ filter: 'drop-shadow(0 1px 2px rgba(0,0,0,0.45))' }}>cloud_upload</span>
                </div>
            )}
            {(effectiveHasThumb || canShowVideoFrame) ? (
                <>
                    {effectiveHasThumb ? (
                        <img src={effectiveThumbUrl} alt={T('ws.card.video.thumbAlt', 'Video thumbnail')} className="w-full h-full object-cover" loading="lazy" draggable={false} />
                    ) : (
                        /* ★ Video cloud TANPA thumbnail: placeholder statik. Dulu <video preload="metadata">
                           + seek 0.5s — seek itu paksa browser tarik DATA video sebenar pada setiap render
                           kad × setiap browser (kos egress). Klik tetap membuka video seperti biasa. */
                        <div className="w-full h-full flex flex-col items-center justify-center">
                            <div className="w-12 h-12 rounded-full bg-emerald-500/20 flex items-center justify-center mb-1">
                                <span className="material-symbols-outlined text-[24px] text-emerald-400">play_circle</span>
                            </div>
                            <span className="text-[9px] font-bold text-emerald-400 text-center px-2 uppercase tracking-wide">{T('ws.card.video.ready', 'Video Ready')}</span>
                        </div>
                    )}
                    <div className="absolute inset-0 bg-black/20 flex items-center justify-center opacity-0 group-hover/play:opacity-100 transition-opacity">
                        <div className="w-10 h-10 rounded-full bg-white/90 flex items-center justify-center shadow-lg">
                            <span className="material-symbols-outlined text-[20px] text-emerald-600 ml-0.5">play_arrow</span>
                        </div>
                    </div>
                    {showCloudBadge && (
                        <div className="absolute bottom-1 right-1 px-1 py-0.5 bg-black/50 rounded flex items-center gap-0.5" title={isOnCloud ? T('ws.card.video.savedCloud', 'Saved to Cloud') : isLocalOnly ? T('ws.card.video.savedLocal', 'Tersimpan di browser ini') : ''}>
                            {isOnCloud && <span className="material-symbols-outlined text-[11px] text-emerald-400">cloud_done</span>}
                            {isLocalOnly && <span className="material-symbols-outlined text-[11px] text-blue-400">computer</span>}
                        </div>
                    )}
                </>
            ) : (isLocalOnly && localStatus === 'checking') ? (
                /* Masih tanya extension sama ada browser INI ada bytes video tu. */
                <>
                    <div className="w-9 h-9 rounded-full border-2 border-slate-600 border-t-slate-300 animate-spin mb-1"></div>
                    <span className="text-[9px] font-bold text-slate-500 text-center px-2 uppercase tracking-wide">{T('ws.card.video.checking', 'Menyemak…')}</span>
                </>
            ) : (isLocalOnly && localStatus === 'present') ? (
                /* Bytes ADA di browser ni, cuma poster gagal decode — tetap video local sah & boleh main. */
                <>
                    <div className="w-12 h-12 rounded-full bg-blue-500/20 flex items-center justify-center mb-1">
                        <span className="material-symbols-outlined text-[24px] text-blue-400">play_circle</span>
                    </div>
                    <span className="text-[9px] font-bold text-blue-400 text-center px-2 uppercase tracking-wide">{T('ws.card.video.local', 'Local Video')}</span>
                </>
            ) : isLocalOnly ? (
                /* localStatus === 'absent' → video TIADA di browser ni. Papar kosong supaya tak nampak "ready". */
                <>
                    <span className="material-symbols-outlined text-[28px] mb-1 text-slate-500">play_arrow</span>
                    <span className="text-[9px] font-bold text-slate-500 dark:text-slate-400 text-center px-2 uppercase tracking-wide">{T('ws.card.video.none', 'No Video')}</span>
                </>
            ) : videoUrl ? (
                <>
                    <div className="w-12 h-12 rounded-full bg-emerald-500/20 flex items-center justify-center mb-1">
                        <span className="material-symbols-outlined text-[24px] text-emerald-400">play_circle</span>
                    </div>
                    <span className="text-[9px] font-bold text-emerald-400 text-center px-2 uppercase tracking-wide">{T('ws.card.video.ready', 'Video Ready')}</span>
                </>
            ) : (
                <>
                    <span className="material-symbols-outlined text-[28px] mb-1 text-slate-500">play_arrow</span>
                    <span className="text-[9px] font-bold text-slate-500 dark:text-slate-400 text-center px-2 uppercase tracking-wide">{T('ws.card.video.none', 'No Video')}</span>
                </>
            )}
        </div>
    );
};

// ★ POPUP HALANGAN UPLOAD (restructure 2026-08-23) — DWIBAHASA + pill tukar bahasa DALAM popup.
//   Sebab (arahan user 2026-08-23): kalau user set English tapi tak faham, popup biasa (alert)
//   tak boleh dibuka semula selepas ditutup untuk tukar bahasa di page — jadi mesej HILANG. Pill
//   di sini biar dia baca terus dalam bahasa yang dia faham. Toggle TEMPATAN (tak sentuh tetapan
//   global) — lalai BM kerana majoriti pengguna + kes yang dilaporkan (BM tersangkut pada set EN).
function UploadBlockPopup({ data, onClose }) {
    const [lang, setLang] = useState('ms');
    if (!data) return null;
    const pill = (on) => ({
        padding: '4px 13px', borderRadius: 999, fontSize: 12, fontWeight: 700,
        cursor: 'pointer', border: 'none',
        background: on ? '#111827' : '#eef2f6', color: on ? '#ffffff' : '#64748b',
    });
    return (
        <div onClick={onClose} style={{
            position: 'fixed', inset: 0, zIndex: 10001, background: 'rgba(0,0,0,0.5)',
            display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16,
        }}>
            <div onClick={(e) => e.stopPropagation()} style={{
                background: '#ffffff', color: '#1f2937', borderRadius: 16, padding: 22,
                maxWidth: 440, width: '100%', boxShadow: '0 24px 64px rgba(0,0,0,0.32)',
            }}>
                <div style={{ display: 'flex', gap: 6, justifyContent: 'flex-end', marginBottom: 14 }}>
                    <button onClick={() => setLang('ms')} style={pill(lang === 'ms')}>BM</button>
                    <button onClick={() => setLang('en')} style={pill(lang === 'en')}>EN</button>
                </div>
                <div style={{ fontSize: 14, lineHeight: 1.65, whiteSpace: 'pre-wrap', marginBottom: 18 }}>
                    {data[lang]}
                </div>
                <button onClick={onClose} style={{
                    width: '100%', padding: 11, borderRadius: 12, background: '#111827',
                    color: '#ffffff', border: 'none', fontWeight: 700, fontSize: 14, cursor: 'pointer',
                }}>OK</button>
            </div>
        </div>
    );
}

const WorkspaceView = forwardRef(({ onNavigate, lockedSet, onSetLockChange, selectedSpaceId: propSelectedSpaceId, onSelectSpace, hideTikTokPanel, hideFlowPanel, pendingDeletesRef, automationTargetSets: propAutomationTargetSets, setAutomationTargetSets: propSetAutomationTargetSets, automationTargetScenes: propAutomationTargetScenes, isMultipleBrowserMode: propIsMultipleBrowserMode, setIsMultipleBrowserMode: propSetIsMultipleBrowserMode, tiktokTargetSets: propTiktokTargetSets, setTiktokTargetSets: propSetTiktokTargetSets, isPostOnly: propIsPostOnly, setIsPostOnly: propSetIsPostOnly, isShowcaseOnly: propIsShowcaseOnly, setIsShowcaseOnly: propSetIsShowcaseOnly, flowProjectUrl: propFlowProjectUrl, setFlowProjectUrl: propSetFlowProjectUrl, continueCollectionMode, flowUltraMode: propFlowUltraMode, setFlowUltraMode: propSetFlowUltraMode, flowVideoDuration: propFlowVideoDuration, setFlowVideoDuration: propSetFlowVideoDuration, flowIngredientsMode: propFlowIngredientsMode, setFlowIngredientsMode: propSetFlowIngredientsMode, flowVideoResolution: propFlowVideoResolution, setFlowVideoResolution: propSetFlowVideoResolution, flowDownloadSize: propFlowDownloadSize, setFlowDownloadSize: propSetFlowDownloadSize, flowWorkflow: propFlowWorkflow, setFlowWorkflow: propSetFlowWorkflow, workflowAktif = false, flowImageModel: propFlowImageModel, setFlowImageModel: propSetFlowImageModel, modules: propModules, activeModuleId: propActiveModuleId, savedAvatars: propSavedAvatars, selectedTemplate: propSelectedTemplate, selectedSubModuleId: propSelectedSubModuleId, flownityVoice: propFlownityVoice, isScheduled, scheduledStartTime, scheduledInterval, directSchedule, caraPost = '', hasilScene = 'gabung', rujukanProduk = 'semua', simpanGambar = 'folder', bilOutput = '1', onGroupsChange, onGroupCountsChange, onSelectedGroupChange, onSelectedCountChange, onSelectedFlownityChange, onSelectedScriptChange, onKadDitandaWfChange, onActiveTabChange, onAgentPanelChange, onSchedRunInfo, panelSorok = false, onTogglePanelSorok = null, kandunganTabGenerate = null, slotTabV4 = null, slotAlatV4 = null, uiV39 = false, ctaTeksLarian = '', proModeAktif = false, aiLabelAktif = true, begKuningAktif = true, fbAddProductAktif = true, fbLaluan = 'contentlibrary', hostedBetaAktif = false }, ref) => {
    /* ---------- Bahasa ------------------------------------------------
       ⭐ PERATURAN YANG PALING MUDAH DILANGGAR DI SINI: halaman ini
       melayan KEDUA-DUA rupa. Bahasa lalai app ialah English, dan
       pelanggan hari ini masih pada rupa LAMA — jadi memanggil `t()`
       tanpa syarat bermakna workspace Melayu mereka bertukar English
       tanpa sesiapa memilihnya.

       Pembalut `T()` di bawah menyelesaikannya: bila suis v3.9 mati ia
       memulangkan ayat lalai (ayat ASAL, disalin tepat), dan hanya bila
       suis hidup barulah ia mencari kamus. Setiap ayat UI dalam fail ini
       WAJIB melalui T(), bukan t(). */
    const t = useT();
    /* useCallback supaya rujukannya stabil — beberapa handler di bawah ialah
       useCallback sendiri, dan T yang lahir semula setiap render akan
       membatalkan memo mereka pada setiap render. */
    const T = useCallback((kunci, lalai, vars) => (uiV39 ? t(kunci, vars) : lalai), [uiV39, t]);
    /* Dihantar kepada komponen anak yang dikongsi dua rupa (VideoThumbPreview).
       Null bila suis mati = anak itu guna ayat lalainya sendiri. */
    const tAnak = uiV39 ? t : null;
    // State
    const [products, setProducts] = useState([]);
    const [selectedProductId, setSelectedProductId] = useState(null);
    const [selectedLogicId, setSelectedLogicId] = useState('');
    const [activeSet, setActiveSet] = useState('set1'); // 'set1' | 'set2' | 'set3'
    /* Senarai Schedule hide/show = MANUAL (user 27 Okt: "biar user sendiri tekan
       untuk hide/show", TIADA auto bila Control Panel buka). State DI SINI (bukan
       SchedGrid) sebab bar tarikh kalendar atas pun kena geser ke kiri sama. */
    const [senaraiSorok, setSenaraiSorok] = useState(false);
    // Phone automation (v4): controller WebUSB dikekalkan antara larian (reconnect
    // senyap guna telefon yang di-grant masa Setup/Test). Lihat handleRunPhone.
    const phoneCtlRef = useRef(null);
    const phoneStopRef = useRef(false);
    const [statusFilter, setStatusFilter] = useState('all'); // 'all', 'pending', 'queued_flow', 'queued_tiktok', 'completed', 'failed'
    // Per-browser isolation: sort prefs + activeTab persist to localStorage,
    // not Firestore — multiple Chrome profiles don't cross-sync UI state.
    /* Kad mana yang timbunan gambarnya dibuka. Per-BROWSER (pelanggan guna 3-5 browser serentak;
       ini pilihan paparan, bukan data produk). ⛔ Ditulis HANYA dalam pengendali klik, tidak pernah
       dari useEffect — effect turut berjalan pada mount dan akan mengunci setiap browser pada nilai
       lalai (perangkap sama `sesaat_products_paparan_v2`). */
    const [gambarBuka, setGambarBuka] = useState(() => {
        try { return new Set(JSON.parse(localStorage.getItem('sesaat_kad_gambar_buka_v1') || '[]')); }
        catch { return new Set(); }
    });
    const togolGambar = useCallback((id) => {
        setGambarBuka((prev) => {
            const next = new Set(prev);
            if (next.has(id)) next.delete(id); else next.add(id);
            try { localStorage.setItem('sesaat_kad_gambar_buka_v1', JSON.stringify([...next])); } catch { /* mod privasi */ }
            return next;
        });
    }, []);

    const [flowSortType, setFlowSortType] = useState(() => localStorage.getItem('flowSortType') || 'time');
    const [flowSortDirection, setFlowSortDirection] = useState(() => localStorage.getItem('flowSortDirection') || 'desc');
    const [tiktokSortType, setTiktokSortType] = useState(() => localStorage.getItem('tiktokSortType') || 'time');
    const [tiktokSortDirection, setTiktokSortDirection] = useState(() => localStorage.getItem('tiktokSortDirection') || 'desc');
    const [activeTab, setActiveTab] = useState(() => {
        const v = localStorage.getItem('activeTab');
        return (v === 'all' || v === 'flow' || v === 'tiktok') ? v : 'all';
    });

    /* ---------- Tab Schedule (v3.9) ----------------------------------
       Semuanya dibaca SEKALI semasa mount daripada simpanan browser
       (lihat SCHED_KEY_V39 di atas untuk sebab ia belum ke Firestore).

       `schedSusunan` berbentuk { [idAkaun]: { hariTemplate, isian } } —
       setiap akaun TikTok memegang susunannya SENDIRI. Menyimpannya
       rata tanpa akaun bermakna pengguna beberapa akaun melihat satu
       kalendar bercampur, dan tiada cara mengetahui video mana milik
       akaun yang mana. */
    const [schedTemplates, setSchedTemplates] = useState(() => {
        const d = schedBaca();
        /* Jadual yang disimpan sebelum 2026-08-14 membawa bentuk lama
           (`corak`/`selang`/`mulaJam`/`hentiJam`). Ia dinaik taraf SEKALI di
           sini — peraturan selang dikembangkan menjadi senarai waktu yang
           setara, jadi jadual pengguna berkelakuan sama seperti sebelumnya.
           Menormalkannya di pintu masuk, bukan dalam setiap pengiraan, supaya
           tiada tempat yang boleh terlepas pandang. */
        return naikTarafSenarai(d.templates);
    });
    const [schedAkaun, setSchedAkaun] = useState(() => {
        const d = schedBaca();
        return (Array.isArray(d.akaun) && d.akaun.length) ? d.akaun : SCHED_AKAUN_LALAI;
    });
    const [schedAkaunAktif, setSchedAkaunAktif] = useState(() => {
        const d = schedBaca();
        const senarai = (Array.isArray(d.akaun) && d.akaun.length) ? d.akaun : SCHED_AKAUN_LALAI;
        /* Akaun tersimpan mungkin sudah dipadam sejak sesi lepas — jatuh
           balik kepada yang pertama supaya kalendar tidak menunjuk kepada
           akaun yang tiada dan kelihatan kosong tanpa sebab. */
        return senarai.some((a) => a.id === d.akaunAktif) ? d.akaunAktif : senarai[0].id;
    });
    const [schedSusunan, setSchedSusunan] = useState(() => {
        const d = schedBaca();
        /* ⭐ Draf yang ditulis SEBELUM 2026-09-16 berkunci offset hari
           (0 = hari ini). Ia dinaik taraf SEKALI di sini kepada tarikh
           sebenar — lihat seksyen TARIKH SEBENAR dalam scheduleV39.js untuk
           sebab kunci offset itu dibuang. Draf baharu sudah berkunci tarikh,
           jadi ia melalui fungsi ini tanpa berubah. */
        return (d.susunan && typeof d.susunan === 'object') ? naikTarafSemuaSusunan(d.susunan) : {};
    });
    const [schedModalBuka, setSchedModalBuka] = useState(false);

    /* ---------- Tinggi jalur alat, DIUKUR ----------------------------
       Bar pukal melekat tepat di bawah jalur alat. Kedua-duanya melekat
       dalam bekas tatal yang SAMA, jadi jarak lekat bar = tinggi jalur.

       Ia diukur dan bukan ditulis sebagai nombor kerana nombor itu sudah
       pernah hanyut sekali (lihat V39_TOOLBAR_H_ASAS di atas), dan kerana
       tinggi sebenarnya memang berbeza-beza: mobile.css memberi jalur ini
       padding yang lain pada telefon, jadi satu nombor tetap mustahil
       betul pada kedua-dua saiz. */
    const jalurRef = useRef(null);
    const [jalurTinggi, setJalurTinggi] = useState(V39_TOOLBAR_H_ASAS);
    /* Sel kiri jalur alat pada tab Schedule v4 — kosong sejak tab berpindah ke
       kepala halaman; kepala senarai diportal ke sini (lihat SchedGrid). */
    const [slotKepalaSched, setSlotKepalaSched] = useState(null);

    useLayoutEffect(() => {
        const el = jalurRef.current;
        if (!el) return undefined;
        const ukur = () => {
            const t = Math.round(el.getBoundingClientRect().height);
            /* 0 bermakna jalur belum dirender (cth tab bertukar) — memakainya
               akan menarik bar pukal naik ke atas tab. Biarkan nilai lama. */
            if (t > 0) setJalurTinggi((lama) => (lama === t ? lama : t));
        };
        ukur();
        if (typeof ResizeObserver === 'undefined') return undefined;
        const ro = new ResizeObserver(ukur);
        ro.observe(el);
        return () => ro.disconnect();
    }, [uiV39]);

    /* Satu tulisan untuk keempat-empat bahagian. Empat effect berasingan
       bermakna empat tulisan setiap kali satu benda berubah, dan yang
       terakhir menang — jadi bahagian yang berubah serentak boleh hilang. */
    useEffect(() => {
        try {
            localStorage.setItem(SCHED_KEY_V39, JSON.stringify({
                templates: schedTemplates,
                akaun: schedAkaun,
                akaunAktif: schedAkaunAktif,
                susunan: schedSusunan,
            }));
        } catch { /* simpanan penuh atau ditutup — draf sahaja, jangan ganggu kerja */ }
    }, [schedTemplates, schedAkaun, schedAkaunAktif, schedSusunan]);

    /* ---------- Langkah 1: susunan jadual ke SERVER (bukan browser) -------
       Reka bentuk: penukaran offset ⇄ tarikh sebenar berlaku SEPENUHNYA
       dalam jadualService — UI di sini kekal bekerja dalam offset. Semua
       operasi server FAIL-SAFE: kalau rules belum di-deploy (sebelum lancar
       v3.9) atau rangkaian putus, ia gagal senyap dan kalendar terus guna
       localStorage seperti hari ini. `schedServerOkRef` hanya jadi true
       selepas muat/migrasi BERJAYA — jadi tulisan server tidak pernah
       dicuba pada persekitaran yang menolaknya. */
    const schedRefDisimpan = useRef({});       // { `${uid}__${akaunId}`: {tarikh: json} }
    const schedServerOkRef = useRef(false);     // server boleh ditulis?
    const schedDimuatRef = useRef(false);       // muat/migrasi sudah dijalankan?

    const seedRefDisimpan = useCallback((uid, susunan) => {
        const peta = {};
        for (const akaunId in (susunan || {})) {
            const perTarikh = akaunKeTarikh(susunan[akaunId] || {});
            const json = {};
            for (const tarikh in perTarikh) json[tarikh] = JSON.stringify(perTarikh[tarikh]);
            peta[`${uid}__${akaunId}`] = json;
        }
        schedRefDisimpan.current = peta;
    }, []);

    useEffect(() => {
        if (!uiV39) return undefined;
        const uid = auth.currentUser?.uid;
        if (!uid || schedDimuatRef.current) return undefined;
        schedDimuatRef.current = true;
        let batal = false;
        let siap = false;

        (async () => {
            try {
                const dataLokal = schedBaca();
                const mentah = (() => { try { return localStorage.getItem(SCHED_KEY_V39); } catch { return null; } })();
                let hasil = await muatDariServer(uid);
                /* ⛔ Jangan MENULIS (migrasi) selepas effect ini dibatalkan —
                   pusingan kedua memuat semula dan menulis sendiri. Tanpa pagar
                   ini, StrictMode boleh menjalankan dua migrasi serentak. */
                if (batal) return;

                if (hasil.ada) {
                    /* Server sudah jadi sumber kebenaran. TETAPI browser ini
                       mungkin pegang akaun yang HANYA wujud di sini — gabung
                       ia naik (union), jangan biar hilang. */
                    const migrated = hasil.migratedAccounts || [];
                    const perluMerge = (dataLokal.akaun || []).some(
                        (a) => a?.id
                            && !(hasil.akaun || []).some((b) => b.id === a.id)
                            && !migrated.includes(a.id),
                    );
                    if (perluMerge) hasil = await migrasiKeServer(uid, dataLokal, mentah);
                } else {
                    /* Belum pernah naik server → migrasi localStorage. */
                    hasil = await migrasiKeServer(uid, dataLokal, mentah);
                }

                if (batal || !hasil?.ada) return;

                /* Server jadi sumber kebenaran — ganti state tempatan. */
                if (Array.isArray(hasil.templates)) setSchedTemplates(naikTarafSenarai(hasil.templates));
                if (Array.isArray(hasil.akaun) && hasil.akaun.length) {
                    setSchedAkaun(hasil.akaun);
                    setSchedAkaunAktif((kini) => (hasil.akaun.some((a) => a.id === kini) ? kini : hasil.akaun[0].id));
                }
                if (hasil.susunan && typeof hasil.susunan === 'object') setSchedSusunan(hasil.susunan);

                seedRefDisimpan(uid, hasil.susunan || {});
                schedServerOkRef.current = true;
            } catch {
                /* Gagal (rules belum deploy / offline) — kekal localStorage,
                   JANGAN hidupkan tulisan server. */
                schedServerOkRef.current = false;
            } finally {
                siap = true;
            }
        })();

        return () => {
            batal = true;
            /* ⭐ [2026-09-20] PEPIJAT LOCALHOST: kalendar tidak pernah baca/tulis
               server dalam mod pembangunan. React StrictMode menjalankan effect
               DUA kali — pusingan 1 menanda `schedDimuatRef` lalu dibatalkan,
               pusingan 2 pulang awal kerana ref itu sudah true. Hasil server
               pusingan 1 dibuang oleh pagar `batal`, jadi `schedServerOkRef`
               kekal false: tiada bacaan server, tiada tulisan server, dan
               kalendar localhost hidup daripada draf browser sahaja (aduan
               2026-09-18: slot Failed di skrin, tiada status di server).
               Melepaskan ref bila muatan BELUM siap membenarkan pusingan kedua
               memuat semula.
               ⛔ Production tidak berubah: di sana cleanup hanya berjalan semasa
                  unmount sebenar, dan komponen yang dipasang semula bermula
                  dengan ref baharu. */
            if (!siap) schedDimuatRef.current = false;
        };
    }, [uiV39, seedRefDisimpan]);

    /* Tulis 'shared' (templates + senarai akaun) — nyahlantun, hanya lepas muat. */
    useEffect(() => {
        if (!schedServerOkRef.current) return;
        const uid = auth.currentUser?.uid;
        if (!uid) return;
        simpanShared(uid, { templates: schedTemplates, akaun: schedAkaun });
    }, [schedTemplates, schedAkaun]);

    /* Tulis susunan akaun AKTIF — nyahlantun + diff per tarikh. Hanya akaun
       aktif yang boleh berubah (semua mutasi lalu schedUbahSusunan). */
    useEffect(() => {
        if (!schedServerOkRef.current) return;
        const uid = auth.currentUser?.uid;
        if (!uid || !schedAkaunAktif) return;
        simpanSusunanAkaun(uid, schedAkaunAktif, schedSusunan[schedAkaunAktif], schedRefDisimpan);
    }, [schedSusunan, schedAkaunAktif]);

    /* Paksa tulis segera bila halaman ditutup — elak seretan terakhir hilang
       kerana nyahlantun 800ms belum sempat menembak. */
    useEffect(() => {
        const flush = () => {
            if (!schedServerOkRef.current) return;
            const uid = auth.currentUser?.uid;
            if (!uid || !schedAkaunAktif) return;
            flushSimpanan(uid, schedAkaunAktif, schedSusunan[schedAkaunAktif], schedRefDisimpan);
        };
        window.addEventListener('beforeunload', flush);
        return () => { window.removeEventListener('beforeunload', flush); flush(); };
    }, [schedSusunan, schedAkaunAktif]);

    /* Cermin susunan dalam ref supaya pembersihan slot boleh membaca nilai
       TERKINI tanpa lalu setState(prev=>…) (elak corak eager-read yang
       memory `project_react_eager_state_read_gotcha` amaran). */
    const schedSusunanRef = useRef(schedSusunan);
    useEffect(() => { schedSusunanRef.current = schedSusunan; }, [schedSusunan]);
    const schedAkaunRef = useRef(schedAkaun);
    useEffect(() => { schedAkaunRef.current = schedAkaun; }, [schedAkaun]);
    /* Nama akaun yang sedang dibuka di kalendar — untuk pil kad (tooltip),
       menu butang Status dan mesej toast (2026-09-18). */
    const namaAkaunDibuka = useMemo(
        () => schedAkaun.find((a) => a.id === schedAkaunAktif)?.nama || '',
        [schedAkaun, schedAkaunAktif],
    );

    /* Pepijat 3: produk dipadam → buang slotnya dari SEMUA akaun kalendar
       (bukan cuma disorok masa melukis). Tulis akaun yang terkesan ke server
       terus — termasuk akaun BUKAN aktif, yang effect tulisan biasa tidak
       sentuh. */
    const prunProdukDariJadual = useCallback((ids) => {
        const idSet = ids instanceof Set ? ids : new Set(ids);
        if (!idSet.size) return;
        const prev = schedSusunanRef.current || {};
        const next = {};
        const terkesan = [];
        for (const akaunId in prev) {
            const akaun = prev[akaunId] || {};
            const isian = akaun.isian || {};
            let ubah = false;
            const isianBaru = {};
            for (const k in isian) {
                const e = isian[k];
                const pid = e?.pid || e?.p?.id;
                if (pid && idSet.has(pid)) { ubah = true; continue; }
                isianBaru[k] = e;
            }
            next[akaunId] = ubah ? { ...akaun, isian: isianBaru } : akaun;
            if (ubah) terkesan.push(akaunId);
        }
        if (!terkesan.length) return;
        setSchedSusunan(next);
        if (schedServerOkRef.current && auth.currentUser?.uid) {
            const uid = auth.currentUser.uid;
            terkesan.forEach((akaunId) => simpanSusunanAkaun(uid, akaunId, next[akaunId], schedRefDisimpan));
        }
    }, []);

    /* ⭐ Template dipadam → KOSONGKAN hari yang memakainya, merentas SEMUA
       akaun kalendar (keputusan user 2026-08-26). Reka bentuk asal modal —
       "waktunya dikekalkan pada hari itu sebagai waktu tersendiri" — DITOLAK
       user sebagai leceh: padam bermaksud padam, pengguna tidak patut
       terpinga-pinga mencari sisa. Penunjuk template hari DIBUANG dan isian
       hari itu DIKOSONGKAN — corak sama seperti menukar template pada satu
       hari (lihat pilihTemplateHari dalam JadualTiktokV39).
       ⚠️ `waktuTambahan` SENGAJA tidak disentuh — ia milik HARI, bukan milik
          template (peraturan sedia ada). Slot berisi pada waktu tambahan
          turut dikosongkan bersama hari itu, sama seperti tukar-template.
       ⚠️ Tulisan server terus ke SETIAP akaun terkesan, termasuk akaun bukan
          aktif — effect tulisan biasa hanya menjaga akaun aktif (corak sama
          prunProdukDariJadual di atas). */
    const padamTemplateDariKalendar = useCallback((idTemplate) => {
        if (!idTemplate) return;
        const prev = schedSusunanRef.current || {};
        const next = {};
        const terkesan = [];
        for (const akaunId in prev) {
            const akaun = prev[akaunId] || {};
            const ht = akaun.hariTemplate || {};
            const hariGuna = Object.keys(ht).filter((h) => ht[h] === idTemplate);
            if (!hariGuna.length) { next[akaunId] = akaun; continue; }
            const htBaru = { ...ht };
            hariGuna.forEach((h) => { delete htBaru[h]; });
            const isianBaru = {};
            for (const k in (akaun.isian || {})) {
                if (!hariGuna.some((h) => String(k).startsWith(`${h}_`))) isianBaru[k] = akaun.isian[k];
            }
            next[akaunId] = { ...akaun, hariTemplate: htBaru, isian: isianBaru };
            terkesan.push(akaunId);
        }
        if (!terkesan.length) return;
        setSchedSusunan(next);
        if (schedServerOkRef.current && auth.currentUser?.uid) {
            const uid = auth.currentUser.uid;
            terkesan.forEach((akaunId) => simpanSusunanAkaun(uid, akaunId, next[akaunId], schedRefDisimpan));
        }
    }, []);

    /* Bilangan HARI yang memakai setiap template, merentas semua akaun —
       disuap ke modal supaya amaran padamnya berkata BENAR. Wayar ini tidak
       pernah dipasang sebelum 2026-08-26: tanpa ia, modal sentiasa memapar
       "tidak digunakan oleh mana-mana hari" walaupun template itu sedang
       dipakai. */
    const gunaTemplate = useMemo(() => {
        const kira = {};
        for (const akaunId in (schedSusunan || {})) {
            const ht = schedSusunan[akaunId]?.hariTemplate || {};
            for (const h in ht) { const id = ht[h]; if (id) kira[id] = (kira[id] || 0) + 1; }
        }
        return kira;
    }, [schedSusunan]);
    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);
    const [saveStatus, setSaveStatus] = useState('idle');
    const [searchQuery, setSearchQuery] = useState('');
    // Pre-flight check sebelum bulk run. Returns true = teruskan, false = batal.
    // Generate button badge update sendiri via App.jsx onSnapshot — tak perlu local quota state.
    const ensureQuotaForBulk = useCallback(async (requestedCount) => {
        const q = await aiService.getMyDailyQuota();
        if (!q || q.unlimited) return true; // admin atau quota fetch fail — allow

        if (q.remaining <= 0) {
            const msg = q.tier === 'trial'
                ? T('ws.quota.trialEmpty', `Coin percubaan anda telah habis (0/${q.cap}). Sila naik taraf ke pelan berbayar untuk teruskan.`, { cap: q.cap })
                : T('ws.quota.dailyEmpty', `Kuota harian anda telah habis (${q.used}/${q.cap}). Kuota akan reset pada 12:00 AM (Malaysia).`, { used: q.used, cap: q.cap });
            alert(msg);
            return false;
        }
        // SEKAT TERUS (bukan "teruskan?") bila pilihan melebihi baki. Dulu ia window.confirm —
        // user tekan OK, batch ditembak serentak, dan lebihan produk gagal satu-satu dgn ralat
        // server. Lebih baik halang di depan supaya user kurangkan pilihan sendiri.
        if (requestedCount > q.remaining) {
            const msg = q.tier === 'trial'
                ? T('ws.quota.trialShort', `Anda memilih ${requestedCount} produk, tetapi baki coin percubaan anda tinggal ${q.remaining}.\n\nSila kurangkan pilihan kepada ${q.remaining} produk atau kurang, kemudian cuba semula.`, { count: requestedCount, remaining: q.remaining })
                : T('ws.quota.dailyShort', `Anda memilih ${requestedCount} produk, tetapi baki kuota hari ini tinggal ${q.remaining} daripada ${q.cap}.\n\nSila kurangkan pilihan kepada ${q.remaining} produk atau kurang. Kuota akan reset pada 12:00 AM (Malaysia).`, { count: requestedCount, remaining: q.remaining, cap: q.cap });
            alert(msg);
            return false;
        }
        return true;
    }, [T]);

    // Automation Settings — Use props from App.jsx when available (left sidebar controls)
    const [isImageOnly, setIsImageOnly] = useState(false);
    const [flowProjectMode, setFlowProjectMode] = useState('same_project'); // 'same_project' or 'new_project'
    const [_localFlowProjectUrl, _localSetFlowProjectUrl] = useState('');
    const flowProjectUrl = propFlowProjectUrl !== undefined ? propFlowProjectUrl : _localFlowProjectUrl;
    const setFlowProjectUrl = propSetFlowProjectUrl || _localSetFlowProjectUrl;
    const [_localFlowUltraMode, _localSetFlowUltraMode] = useState('lower_priority');
    const flowUltraMode = propFlowUltraMode !== undefined ? propFlowUltraMode : _localFlowUltraMode;
    const setFlowUltraMode = propSetFlowUltraMode || _localSetFlowUltraMode;
    const [_localFlowVideoDuration, _localSetFlowVideoDuration] = useState('8s');
    const flowVideoDuration = propFlowVideoDuration !== undefined ? propFlowVideoDuration : _localFlowVideoDuration;
    const setFlowVideoDuration = propSetFlowVideoDuration || _localSetFlowVideoDuration;
    const [_localFlowIngredientsMode, _localSetFlowIngredientsMode] = useState(false);
    const flowIngredientsMode = propFlowIngredientsMode !== undefined ? propFlowIngredientsMode : _localFlowIngredientsMode;
    const setFlowIngredientsMode = propSetFlowIngredientsMode || _localSetFlowIngredientsMode;
    const [_localFlowVideoResolution, _localSetFlowVideoResolution] = useState('720p');
    const flowVideoResolution = propFlowVideoResolution !== undefined ? propFlowVideoResolution : _localFlowVideoResolution;
    const [_localFlowDownloadSize, _localSetFlowDownloadSize] = useState('asal');
    const flowDownloadSize = propFlowDownloadSize !== undefined ? propFlowDownloadSize : _localFlowDownloadSize;
    const setFlowDownloadSize = propSetFlowDownloadSize || _localSetFlowDownloadSize;
    const setFlowVideoResolution = propSetFlowVideoResolution || _localSetFlowVideoResolution;
    /* ⭐ 2026-09-15 — WORKFLOW Control Panel: 'generate' | 'kad'. Disimpan per-browser seperti Resolusi video.
       ⛔ `workflowKad` (nilai yang benar-benar menukar larian) DITAKRIF DI BAWAH, sebelum
          handleRunFlow — ia perlukan senarai kad yang ditanda. Jangan takrif semula di sini. */
    const [_localFlowWorkflow, _localSetFlowWorkflow] = useState('generate');
    const flowWorkflow = propFlowWorkflow !== undefined ? propFlowWorkflow : _localFlowWorkflow;
    const setFlowWorkflow = propSetFlowWorkflow || _localSetFlowWorkflow;
    /* `workflowKad` DIPINDAH ke bawah (sebelum handleRunFlow) 2026-09-16 — ia kini turut
       bergantung pada kad yang DITANDA, dan pengiraan itu perlukan getProductTab. */
    const [_localFlowImageModel, _localSetFlowImageModel] = useState('Nano Banana Pro');
    const flowImageModel = propFlowImageModel !== undefined ? propFlowImageModel : _localFlowImageModel;
    const setFlowImageModel = propSetFlowImageModel || _localSetFlowImageModel;
    const [_localAutomationTargetSets, _localSetAutomationTargetSets] = useState(['set1', 'set2', 'set3']);
    const automationTargetSets = propAutomationTargetSets || _localAutomationTargetSets;
    const setAutomationTargetSets = propSetAutomationTargetSets || _localSetAutomationTargetSets;
    // FLOWNITY: senarai scene terpilih (S1–S5) — read-only, selector di App.jsx sticky footer
    const automationTargetScenes = propAutomationTargetScenes || ['set1', 'set2', 'set3', 'set4', 'set5'];
    const [postTiktokAfterFlow, setPostTiktokAfterFlow] = useState(false);
    // ★ LOCKED ON: Multi Browser Mode paksa true (fallback kalau tiada prop)
    const [_localIsMultipleBrowserMode, _localSetIsMultipleBrowserMode] = useState(true);
    const isMultipleBrowserMode = propIsMultipleBrowserMode !== undefined ? propIsMultipleBrowserMode : _localIsMultipleBrowserMode;
    const setIsMultipleBrowserMode = propSetIsMultipleBrowserMode || _localSetIsMultipleBrowserMode;

    const [_localTiktokTargetSets, _localSetTiktokTargetSets] = useState(['set1']);
    const tiktokTargetSets = propTiktokTargetSets || _localTiktokTargetSets;
    const setTiktokTargetSets = propSetTiktokTargetSets || _localSetTiktokTargetSets;
    const [isShowcaseMode, setIsShowcaseMode] = useState(true);
    const [_localIsPostOnly, _localSetIsPostOnly] = useState(false);
    const isPostOnly = propIsPostOnly !== undefined ? propIsPostOnly : _localIsPostOnly;
    const setIsPostOnly = propSetIsPostOnly || _localSetIsPostOnly;
    const [_localIsShowcaseOnly, _localSetIsShowcaseOnly] = useState(false);
    const isShowcaseOnly = propIsShowcaseOnly !== undefined ? propIsShowcaseOnly : _localIsShowcaseOnly;
    const setIsShowcaseOnly = propSetIsShowcaseOnly || _localSetIsShowcaseOnly;

    // Spaces State (Niches)
    const [spaces, setSpaces] = useState([
        { id: 'default', name: 'AI8SAAT', icon: 'auto_awesome', color: 'indigo', isSystem: true }
    ]);
    // selectedSpaceId is now managed by App.jsx and passed as prop
    const selectedSpaceId = propSelectedSpaceId || 'default';
    const [isAddingSpace, setIsAddingSpace] = useState(false);
    const [newSpaceName, setNewSpaceName] = useState('');
    const [isSettingsOpen, setIsSettingsOpen] = useState(false);
    const [editingSpaceId, setEditingSpaceId] = useState(null);

    // Logic Options State (loaded from Firestore personas)
    const [logicOptions, setLogicOptions] = useState([]);
    const [systemDefaultLogicId, setSystemDefaultLogicId] = useState('default'); // ★ Centralized from system_spaces
    // const [selectedLogicId, setSelectedLogicId] = useState(null); // This was duplicated, removed from here

    // ★ v3.0.0: Video Player Modal State (for playing local + cloud videos in webapp)
    const [videoModal, setVideoModal] = useState({ open: false, blobUrl: null, loading: false, error: null });

    // ★ v3.0.0 Fasa 6: Product Groups
    const [selectedGroupId, setSelectedGroupId] = useState('all'); // 'all' or group name
    const [groups, setGroups] = useState(['Workspace']); // merged groups (derived + custom)
    const [customGroups, setCustomGroups] = useState([]); // user-created groups (persist even if empty)
    const [showGroupDropdown, setShowGroupDropdown] = useState(false); // for floating bar dropdown
    const [showNewGroupInput, setShowNewGroupInput] = useState(false);
    const [newGroupName, setNewGroupName] = useState('');
    const groupDropdownBtnRef = useRef(null);
    const [groupDropdownDirection, setGroupDropdownDirection] = useState('up'); // 'up' = open above button, 'down' = below
    const [showAvatarDropdown, setShowAvatarDropdown] = useState(false); // floating bar: bulk "Tukar Avatar" dropdown
    const avatarDropdownBtnRef = useRef(null);
    const [avatarDropdownDirection, setAvatarDropdownDirection] = useState('up'); // 'up' = open above button, 'down' = below
    const [avatarChangeModal, setAvatarChangeModal] = useState({ open: false, avatar: null, count: 0 }); // confirm modal for bulk avatar change
    // Draft prompt state — keyed by productId, prevents Firestore write on every keystroke
    const [draftPromptMap, setDraftPromptMap] = useState({}); // { [productId]: prompts }
    // ★ B1 fix: Track sync failures (Hook Text edit yang tak boleh auto-sync ke Image Prompt)
    const [hookSyncWarnings, setHookSyncWarnings] = useState({}); // { [productId_setKey]: string }
    const [dirtyProductIds, setDirtyProductIds] = useState(new Set());
    const [savedPromptNotifs, setSavedPromptNotifs] = useState({}); // { [productId]: boolean }

    // Input State (per space)
    const [spaceInputs, setSpaceInputs] = useState({}); // { [spaceId]: '...' }

    // Right Sidebar
    const [isRightSidebarOpen, setIsRightSidebarOpen] = useState(true);

    // Quick Notes panel (right-side slide-in)
    const [isQuickNotesOpen, setIsQuickNotesOpen] = useState(false);

    // Split Panel State
    const [splitPosition, setSplitPosition] = useState(50); // percentage, 50% default
    const splitContainerRef = useRef(null);
    const isResizingRef = useRef(false);
    const [expandedSets, setExpandedSets] = useState({}); // { set1: true, set2: false, ... }
    const [expandedTiktokSets, setExpandedTiktokSets] = useState({}); // { productId_set1: true, ... }
    const [expandedCards, setExpandedCards] = useState({}); // { productId: true = expanded }
    const [activeSceneTab, setActiveSceneTab] = useState({}); // { productId: sceneNum } — N-scene modules (e.g. FLOWNITY)
    const [allFlowExpanded, setAllFlowExpanded] = useState(false); // default: all collapsed
    const [allTiktokCollapsed, setAllTiktokCollapsed] = useState(false);
    const [promptModalProductId, setPromptModalProductId] = useState(null); // fullscreen prompt-edit modal
    const promptModalRef = useRef(null); // ★ bekas untuk pembantu shortcut "/" (ShortcutSlashPembantu)
    /* ★ [2026-09-16] Kad mana sedang memapar caption FACEBOOK (bukan TikTok) —
       paparan sahaja, tidak disimpan.
       ★ [2026-09-27] Butang "FB" Set 1 diganti suis TikTok/FB pada SETIAP kotak
       caption kad; kunci = product.id, jadi tekan pada mana-mana set menukar
       ketiga-tiga set kad itu serentak (SuisCaptionKad.jsx). */
    const [capTabFb, setCapTabFb] = useState(() => new Set());
    const tukarCapKad = useCallback((id, fb) => setCapTabFb(prev => {
        if (prev.has(id) === fb) return prev;
        const n = new Set(prev);
        if (fb) n.add(id); else n.delete(id);
        return n;
    }), []);

    /* ── Tab SET untuk kad TERBUKA pada TELEFON (arahan user 2026-08-23) ──
       Kad terbuka menyusun Set 1/2/3 bersebelahan pada komputer. Pada
       telefon grid itu jatuh jadi satu lajur, jadi ketiga-tiga set
       bertindan: diukur 3,797px = 5.5 skrin telefon untuk SATU kad.

       Peta ini menyimpan set mana yang sedang dilihat, satu nilai bagi
       setiap kad — bukan satu nilai global. Dua kad terbuka serentak
       mesti boleh berada pada set berlainan; nilai global akan menukar
       kedua-duanya sekali gus dan itu terbaca sebagai pepijat.

       ⛔ KOMPUTER TIDAK TERJEJAS: jalur tab ini `md:hidden`, dan
          penyorokan lajur hidup dalam @media telefon (mobile.css seksyen Q).
          Tanpa peraturan itu, atribut `data-set-aktif` tidak buat apa-apa. */
    const [setTabKad, setSetTabKad] = useState({});
    /* ⭐ Elemen DOM dalam jalur tab (Schedule) tempat bar tarikh kalendar
       dipaparkan melalui portal — arahan user 2026-08-21 "sebaris tab".
       `setSchedDateNavSlot` (setter useState) beridentiti stabil, jadi ia
       selamat dipakai terus sebagai callback ref pada slot itu. Bar tarikh
       sebenar tinggal di KalendarMingguV39; ia cuma dirender ke sini. */
    const [schedDateNavSlot, setSchedDateNavSlot] = useState(null);
    /* Slot kedua pada jalur yang SAMA, di hujung kanan — penukar akaun +
       Schedule template (arahan user 26 Okt: "2 button tu bawa ke baris atas
       dan letak ke kanan sekali"). Satu baris penuh di atas grid hari hilang. */
    const [schedAlatSlot, setSchedAlatSlot] = useState(null);

    // ═══════════════════════════════════════════════════════════
    // ★ SPLIT V2: detailCache — teks berat produk split, DIASINGKAN dari state
    // `products` (state kekal ringan → feed re-fire TAK clobber teks, diff
    // auto-save TAK nampak teks). Paparan/Run baca via withDetail().
    // Lihat memory project_product_doc_split.
    // ═══════════════════════════════════════════════════════════
    const detailCacheRef = useRef(new Map());   // productId -> detail dari loadProductDetail (+_fetchedAtMs)
    const detailInflightRef = useRef(new Map()); // productId -> Promise (dedupe getDoc serentak)
    const [, setDetailReadyTick] = useState(0);  // bump → re-render selepas hydrate/prime
    const [detailLoadingIds, setDetailLoadingIds] = useState(() => new Set());
    const [detailErrorIds, setDetailErrorIds] = useState(() => new Set()); // hydrate gagal → UI cuba semula

    const needsDetail = (p) => !!(p && p.splitV === 2 && !detailCacheRef.current.has(p.id));
    const isDetailPending = (p) => needsDetail(p) || (p && detailLoadingIds.has(p.id));

    // Hydrate teks berat utk satu/senarai produk. throwOnError=true utk laluan
    // kritikal (Run Flow / Generate / Archive) — WAJIB abort, jangan teruskan senyap.
    const hydrateDetails = async (list, { throwOnError = false } = {}) => {
        const targets = (Array.isArray(list) ? list : [list]).filter(needsDetail);
        if (targets.length === 0) return true;
        setDetailLoadingIds(prev => { const n = new Set(prev); targets.forEach(p => n.add(p.id)); return n; });
        let ok = true;
        let firstErr = null;
        const failedIds = [];
        const okIds = [];
        await Promise.all(targets.map(async (p) => {
            let job = detailInflightRef.current.get(p.id);
            if (!job) {
                job = loadProductDetail(auth.currentUser.uid, p.id)
                    .then(d => { detailCacheRef.current.set(p.id, { ...d, _fetchedAtMs: Date.now() }); })
                    .finally(() => detailInflightRef.current.delete(p.id));
                detailInflightRef.current.set(p.id, job);
            }
            try { await job; okIds.push(p.id); } catch (e) {
                ok = false;
                failedIds.push(p.id);
                if (!firstErr) firstErr = e;
                console.warn('[SplitV2] hydrate gagal', p.id, e?.message);
            }
        }));
        setDetailErrorIds(prev => {
            const n = new Set(prev);
            okIds.forEach(id => n.delete(id));
            failedIds.forEach(id => n.add(id));
            return n;
        });
        setDetailLoadingIds(prev => { const n = new Set(prev); targets.forEach(p => n.delete(p.id)); return n; });
        setDetailReadyTick(t => t + 1);
        if (!ok && throwOnError) throw (firstErr || new Error(T('ws.detail.loadFailed', 'Gagal memuatkan teks produk')));
        return ok;
    };

    // Baca produk DENGAN teks (lapisan paparan sahaja — state products kekal ringan)
    const withDetail = (p) => {
        if (!p || p.splitV !== 2) return p;
        const d = detailCacheRef.current.get(p.id);
        if (!d) return p;
        return mergeDetailIntoProduct(p, d);
    };

    // Prime cache dgn teks yang baru dihasilkan kod sendiri (generation / scrape /
    // draft commit) supaya paparan kekal ada teks selepas feed gantikan state dgn
    // doc ringan. Buffer +60s elak self-invalidate oleh lastUpdated save sendiri.
    // ⛔ Tanpa `prompts` pada kad yang BELUM ada salinan dalam cache = salinan `prompts: null`
    //    yang dianggap lengkap → hydrate dilangkau → Run Flow hantar kad tanpa prompt (Flow guna
    //    nama produk, senyap). Prime separa hanya bila `detailCacheRef.current.has(id)`.
    const primeDetailCache = (productId, { prompts, intelligenceData, rawOutput } = {}) => {
        const prev = detailCacheRef.current.get(productId);
        detailCacheRef.current.set(productId, {
            exists: true,
            prompts: prompts ?? prev?.prompts ?? null,
            intelligenceData: intelligenceData ?? prev?.intelligenceData ?? null,
            rawOutput: rawOutput ?? prev?.rawOutput ?? null,
            updatedAt: null,
            _fetchedAtMs: Date.now() + 60000,
        });
        setDetailReadyTick(t => t + 1);
    };

    // ★ V3: Bidirectional expand/collapse sync — listen for messages FROM extension
    const productsRef = useRef([]);
    useEffect(() => { productsRef.current = products; }, [products]);

    /* ★ [2026-09-18] Toggle "Pasang beg kuning" (TikTok) + "Add product" (Facebook)
       dibaca melalui REF di dalam pengendali Run. Pengendali itu turut dipanggil
       dari useCallback Retry (schedRetrySemuaGagal / schedRetrySlot) yang deps-nya
       tidak membawa prop ini — tanpa ref, Retry selepas pelanggan menukar toggle
       akan memakai nilai LAMA, senyap (perangkap closure basi, lihat CLAUDE.md
       PRO Mode). Lalai HIDUP; hanya `false` eksplisit yang mematikan. */
    const begKuningRef = useRef(begKuningAktif !== false);
    useEffect(() => { begKuningRef.current = begKuningAktif !== false; }, [begKuningAktif]);
    const fbAddProductRef = useRef(fbAddProductAktif !== false);
    useEffect(() => { fbAddProductRef.current = fbAddProductAktif !== false; }, [fbAddProductAktif]);
    /* ★ [2026-09-26] Laluan post FB (Content Library | Page) — pilihan pelanggan, dihantar
       dalam `tetapan.laluan` pada KEDUA-DUA payload FB (kalendar + tick kad). utils/laluanFb.js */
    const fbLaluanRef = useRef(fbLaluan === 'page' ? 'page' : 'contentlibrary');
    useEffect(() => { fbLaluanRef.current = fbLaluan === 'page' ? 'page' : 'contentlibrary'; }, [fbLaluan]);

    // ★ Auto-open video modal bila webapp dibuka dari extension dengan URL params
    // e.g. /workspace?viewVideo=PRODUCT_ID&set=set1
    const viewVideoHandled = useRef(false);
    useEffect(() => {
        if (viewVideoHandled.current || products.length === 0) return;
        const params = new URLSearchParams(window.location.search);
        const viewVideoId = params.get('viewVideo');
        const setKey = params.get('set');
        if (!viewVideoId || !setKey) return;
        const product = products.find(p => p.id === decodeURIComponent(viewVideoId));
        if (!product) return;
        const videoUrl = product.prompts?.[setKey]?.uploadedVideo;
        if (!videoUrl) return;
        viewVideoHandled.current = true;
        handlePlayCloudVideo(videoUrl, product.id, setKey);
        // Buang params dari URL supaya tak trigger lagi kalau refresh
        const url = new URL(window.location.href);
        url.searchParams.delete('viewVideo');
        url.searchParams.delete('set');
        window.history.replaceState({}, '', url.toString());
    }, [products]);
    useEffect(() => {
        const handler = (event) => {
            if (event.data?.type === 'SESAAT_CARD_EXPAND_FROM_EXT' && event.data.productId) {
                setExpandedCards(prev => ({ ...prev, [event.data.productId]: !!event.data.expanded }));
            }
            if (event.data?.type === 'SESAAT_EXPAND_ALL_FROM_EXT') {
                const newState = !!event.data.expanded;
                setAllFlowExpanded(newState);
                const next = {};
                productsRef.current.forEach(p => { next[p.id] = newState; });
                setExpandedCards(prev => ({ ...prev, ...next }));
            }
        };
        window.addEventListener('message', handler);
        return () => window.removeEventListener('message', handler);
    }, []);

    // ★ SPLIT V2: hydrate teks bila card di-expand — SATU effect cover SEMUA pintu
    // masuk expand (toggle klik, Expand All, 2 mesej dari extension) + modal fullscreen.
    useEffect(() => {
        const wantIds = new Set(Object.keys(expandedCards).filter(id => expandedCards[id]));
        if (promptModalProductId) wantIds.add(promptModalProductId);
        if (wantIds.size === 0) return;
        const targets = products.filter(p => wantIds.has(p.id) && needsDetail(p));
        if (targets.length) hydrateDetails(targets);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [expandedCards, promptModalProductId, products]);

    // ★ Marquee (Drag-to-Select) State
    const [selectionBox, setSelectionBox] = useState(null); // { x1, y1, x2, y2 }
    const [previewSelectedIds, setPreviewSelectedIds] = useState([]);
    const canvasRef = useRef(null);
    const scrollAnimRef = useRef(null); // auto-scroll animation frame

    /* ---------- Tinggi KELIHATAN kawasan tatal, DIUKUR ------------------
       Dipakai oleh tab Schedule: lajur senarai di kiri menatal SENDIRI, jadi
       ia perlu tahu berapa tinggi ruang yang benar-benar kelihatan.
       `clientHeight` kawasan tatal menjawabnya terus.

       ⚠️ Diukur, bukan `100vh`: kawasan ini bermula di bawah kepala halaman,
          dan pada telefon `100vh` mengira bar browser yang tidak benar-benar
          ada. Nombor tetap pula sudah pernah hanyut sekali dalam fail ini -
          lihat nota V39_TOOLBAR_H_ASAS.

       ⛔ Ukuran ini WAJIB dipasang melalui ref panggil-balik, BUKAN useEffect
          yang membaca `canvasRef.current`.

          Sebab: komponen ini memulangkan skrin pemuatan lebih awal
          (`if (isLoading) return <spinner/>`), jadi ketika effect mula-mula
          berjalan kanvas LANGSUNG BELUM WUJUD - `canvasRef.current` null,
          effect keluar, dan dengan senarai kebergantungan `[uiV39]` ia tidak
          pernah berjalan semula selepas pemuatan selesai. Tinggi kekal 0,
          `max-height` tidak pernah ditetapkan, dan senarai kiri langsung tidak
          menatal - itulah tepat kegagalan yang dilaporkan user 2026-08-23.

          Ref panggil-balik tidak boleh gagal begitu: Bereaksi memanggilnya
          SETIAP KALI elemen itu betul-betul dipasang atau ditanggalkan. */
    const [kanvasTinggi, setKanvasTinggi] = useState(0);
    const kanvasRORef = useRef(null);
    const pasangKanvas = useCallback((el) => {
        canvasRef.current = el;
        if (kanvasRORef.current) { kanvasRORef.current.disconnect(); kanvasRORef.current = null; }
        if (!el) return;
        const ukur = () => {
            /* ⚠️ TOLAK padding bawah kawasan tatal. `clientHeight` mengira
                  padding itu sebagai ruang, tetapi `scrollHeight` turut
                  mengiranya sebagai kandungan - jadi memakai clientHeight
                  mentah menjadikan lajur 24px terlalu tinggi dan kawasan tatal
                  luar boleh ditatal sedikit. Hasilnya DUA bar tatal bersebelahan
                  pada tepi kanan, satu daripadanya tidak membawa apa-apa.
                  (Aduan user 2026-08-23: "kenapa ada 2 scroll?") */
            const pb = parseFloat(getComputedStyle(el).paddingBottom) || 0;
            const t = Math.round(el.clientHeight - pb);
            /* 0 bermakna belum dirender - memakainya akan meruntuhkan lajur
               senarai kepada ketinggian sifar. Biarkan nilai lama. */
            if (t > 0) setKanvasTinggi((lama) => (lama === t ? lama : t));
        };
        ukur();
        if (typeof ResizeObserver === 'undefined') return;
        kanvasRORef.current = new ResizeObserver(ukur);
        kanvasRORef.current.observe(el);
    }, []);

    // Undo / Redo system
    const undoStackRef = useRef([]);
    const redoStackRef = useRef([]);
    const [undoCount, setUndoCount] = useState(0); // trigger re-render for button state
    const [redoCount, setRedoCount] = useState(0);
    const MAX_UNDO = 30;

    const pushUndo = useCallback((snapshot) => {
        undoStackRef.current.push(snapshot);
        if (undoStackRef.current.length > MAX_UNDO) undoStackRef.current.shift();
        redoStackRef.current = []; // clear redo on new action
        setUndoCount(undoStackRef.current.length);
        setRedoCount(0);
    }, []);

    const handleUndo = useCallback(() => {
        if (undoStackRef.current.length === 0) return;
        const prev = undoStackRef.current.pop();
        redoStackRef.current.push(products);
        setProducts(prev);
        saveToCloud(prev);
        setUndoCount(undoStackRef.current.length);
        setRedoCount(redoStackRef.current.length);
    }, [products]);

    const handleRedo = useCallback(() => {
        if (redoStackRef.current.length === 0) return;
        const next = redoStackRef.current.pop();
        undoStackRef.current.push(products);
        setProducts(next);
        saveToCloud(next);
        setUndoCount(undoStackRef.current.length);
        setRedoCount(redoStackRef.current.length);
    }, [products]);

    // Keyboard shortcuts: Ctrl+Z / Ctrl+Y
    useEffect(() => {
        const onKeyDown = (e) => {
            if ((e.ctrlKey || e.metaKey) && e.key === 'z' && !e.shiftKey) { e.preventDefault(); handleUndo(); }
            if ((e.ctrlKey || e.metaKey) && (e.key === 'y' || (e.key === 'z' && e.shiftKey))) { e.preventDefault(); handleRedo(); }
        };
        window.addEventListener('keydown', onKeyDown);
        return () => window.removeEventListener('keydown', onKeyDown);
    }, [handleUndo, handleRedo]);

    // Automation Progress Overlay
    const [automationProgress, setAutomationProgress] = useState({
        isActive: false,
        type: '', // 'flow' | 'tiktok'
        steps: [],
        currentStep: 0,
        totalSteps: 0,
        status: 'idle', // 'running' | 'success' | 'error' | 'disconnected'
        message: '',
        details: '',
        extensionStatus: 'unknown' // 'connected' | 'disconnected' — populated by pre-flight ping
    });

    /* ★ v4 — MODAL FB AUTO-TUTUP BILA SIAP. Extension (background) menyiar FB_PROGRESS;
       content.ts memancarkannya ke window webapp. Bila robot SIAP + balik ke tab SESAAT
       (status 'complete'/'error'), modal ditutup — sama seperti Flow/TikTok, tetapi diikat
       pada SIAP SEBENAR (bukan pemasa 5s buta). Status 'running' mengemas kini butiran
       supaya pengguna nampak kemajuan. */
    useEffect(() => {
        const handler = (e) => {
            const d = e.data;
            if (!d || d.type !== 'FB_PROGRESS') return;
            if (d.status === 'complete') {
                const done = d.done || 0, gagal = d.gagal || 0;
                /* ★ v3.9.4 — pecahan ikut hasil SEBENAR (diterbit / dijadual / draf) + nama
                   page aktif. Extension 3.9.3 hanya menghantar done+gagal → ayat lama. */
                const adaPecahan = d.posted != null || d.draf != null || d.dijadual != null;
                let details;
                if (adaPecahan) {
                    const bhg = [];
                    if (d.posted) bhg.push(T('ws.fb.hasilPost', `${d.posted} reel diterbit`, { n: d.posted }));
                    if (d.dijadual) bhg.push(T('ws.fb.hasilJadual', `${d.dijadual} reel dijadualkan`, { n: d.dijadual }));
                    if (d.draf) bhg.push(T('ws.fb.hasilDraf', `${d.draf} draf disimpan`, { n: d.draf }));
                    if (gagal) bhg.push(T('ws.fb.hasilGagal', `${gagal} gagal`, { n: gagal }));
                    details = (bhg.length ? bhg.join(' · ') : T('ws.fb.hasilKosong', 'Tiada reel diproses.'))
                        + (d.pageName ? ` — ${T('ws.fb.hasilPage', `Page: ${d.pageName}`, { nama: d.pageName })}` : '');
                    // Sebab kegagalan dipapar TERUS — pelanggan tidak patut perlu buka console.
                    if (gagal && Array.isArray(d.kegagalan) && d.kegagalan.length) details += '\n' + d.kegagalan.slice(0, 3).join('\n');
                } else {
                    details = gagal
                        ? T('ws.fb.doneSome', `${done} reel diterbit, ${gagal} gagal.`, { n: done, gagal })
                        : T('ws.fb.doneAll', `${done} reel diterbit.`, { n: done });
                }
                const semuaGagal = gagal > 0 && done === 0;
                setAutomationProgress(prev => ({
                    ...prev, isActive: true, type: 'facebook', status: semuaGagal ? 'error' : 'success',
                    message: semuaGagal ? T('ws.fb.failMsg', '❌ Facebook Reels gagal') : T('ws.fb.doneMsg', '✅ Facebook Reels selesai!'),
                    details,
                }));
                setTimeout(() => setAutomationProgress(prev => ({ ...prev, isActive: false })), gagal ? 12000 : 4000);
            } else if (d.status === 'error') {
                setAutomationProgress(prev => ({
                    ...prev, isActive: true, type: 'facebook', status: 'error',
                    message: T('ws.fb.failMsg', '❌ Facebook Reels gagal'),
                    details: String(d.label || '').replace(/^Facebook Reels\n?/, '') || T('ws.fb.failGeneric', 'Sila cuba lagi.'),
                }));
                setTimeout(() => setAutomationProgress(prev => ({ ...prev, isActive: false })), 6000);
            } else if (d.status === 'running' && d.label) {
                setAutomationProgress(prev => (prev.isActive && prev.type === 'facebook'
                    ? { ...prev, details: String(d.label).replace(/^Facebook Reels\n?/, '') }
                    : prev));
            }
        };
        window.addEventListener('message', handler);
        return () => window.removeEventListener('message', handler);
    }, [T]);

    // Bandingkan versi — "v lebih rendah daripada req?".
    // Juga dipakai untuk memilih versi TERTINGGI antara beberapa extension yang menjawab,
    // jadi ia ditakrif SEBELUM pingExtension (yang bergantung padanya).
    const _isVersionBelow = (v, req) => {
        if (!v) return true; // takda versi dalam PONG = extension lama
        const pa = String(v).split('.').map(n => parseInt(n, 10) || 0);
        const pb = String(req).split('.').map(n => parseInt(n, 10) || 0);
        for (let i = 0; i < Math.max(pa.length, pb.length); i++) {
            const a = pa[i] || 0, b = pb[i] || 0;
            if (a < b) return true;
            if (a > b) return false;
        }
        return false; // sama atau lebih baru = OK
    };

    // Pre-flight liveness check — confirms content script AND background service worker
    // are alive before dispatching automation. PING round-trips:
    //   webapp → content script → chrome.runtime → background (EXTENSION_HEARTBEAT) → callback → content script → webapp PONG
    // Any link broken (context invalidated, SW dead, etc.) → no PONG → alive:false.
    // 1500ms timeout accommodates cold service worker wake-up.
    //
    // ★ FIX [2026-08-03] — KUMPUL SEMUA PONG, JANGAN AMBIL YANG PERTAMA SAMPAI.
    //   v3.8.2 memperkenalkan `key` (ID tetap) → ID-nya BERBEZA daripada pemasangan lama,
    //   jadi Chrome memasangnya sebagai extension KEDUA; extension lama TIDAK diganti.
    //   Kedua-dua content script mendengar SESAAT_PING dan kedua-duanya membalas PONG.
    //   Kod lama menerima PONG PERTAMA yang tiba — bila extension lama (service worker
    //   panas) menang perlumbaan, PONG-nya TIADA `version` → gate membaca "lama" → modal
    //   paksa dipapar walaupun v3.8.2 memang terpasang dan berfungsi. Aduan pelanggan
    //   2026-08-03: "sy dah update, tapi masih keluar mcm ni".
    //   Kini: selepas PONG pertama, tunggu tetingkap pengumpulan pendek, kemudian pilih
    //   versi TERTINGGI. `responders`/`versions` dipulangkan supaya pemanggil boleh
    //   memberitahu pelanggan bahawa extension lama masih perlu dibuang.
    const pingExtension = (collectMs = 250) => new Promise((resolve) => {
        let finished = false;
        let hardTimer = null;
        let collectTimer = null;
        const versions = []; // satu entri per extension yang menjawab ('' = extension lama)
        /* ★ v3.9.2 — status suis "Allow user scripts", satu entri per responden.
           Extension pra-3.9.2 tidak menghantar medan ini; ia dibaca sebagai false,
           yang betul (versi itu memang tiada kebenaran userScripts langsung). */
        const suisUS = [];
        /* ★ v3.9.4 — bendera `fbTetapan` setiap responden: extension faham mod
           draf/jadual + AI label untuk Facebook. Tiada = extension lama (ia akan TERUS
           POST walaupun diminta simpan draf). Optimistik seperti suis userScripts. */
        const fbT = [];
        const finish = () => {
            if (finished) return;
            finished = true;
            if (hardTimer) clearTimeout(hardTimer);
            if (collectTimer) clearTimeout(collectTimer);
            window.removeEventListener('message', handler);
            if (!versions.length) { resolve({ alive: false, version: '', versions: [], responders: 0, userScripts: false, fbTetapan: false }); return; }
            let best = versions[0];
            for (const v of versions) if (_isVersionBelow(best, v)) best = v;
            // ★ Kira responden UNIK IKUT VERSI, bukan bilangan mesej.
            //   `window.postMessage` disiarkan kepada semua pendengar pada window yang
            //   sama, dan PONG tidak membawa apa-apa rujukan kepada PING yang mencetusnya
            //   — jadi dua PING yang bertindih menghasilkan dua PONG yang KEDUA-DUANYA
            //   dikutip oleh setiap panggilan pingExtension. Ia berlaku pada React
            //   StrictMode (effect dijalankan 2× dalam dev) dan di production bila
            //   pelanggan menekan Run semasa probe on-mount masih berjalan.
            //   Mengira mesej mentah = tuduhan palsu "2 extension". Extension yang sama
            //   sentiasa melapor versi yang sama, manakala pemasangan lama vs baharu
            //   melapor versi berbeza ('' vs '3.8.x') — jadi versi unik ialah kiraan
            //   yang betul. (Dua extension pada versi SERUPA tidak dikesan; tidak mengapa
            //   — gate versi tetap lulus dengan betul dan tiada amaran palsu dikeluarkan.)
            const uniq = Array.from(new Set(versions));
            /* Kalau MANA-MANA extension yang menjawab melaporkan suis hidup, kita
               anggap hidup. Sengaja optimistik: pelanggan multi-extension tidak
               patut disekat kerana satu pemasangan lama turut menjawab. */
            resolve({ alive: true, version: best, versions: uniq, responders: uniq.length, userScripts: suisUS.some(Boolean), fbTetapan: fbT.some(Boolean) });
        };
        const handler = (event) => {
            if (finished || event.data?.type !== 'SESAAT_PONG') return;
            versions.push((event.data && event.data.version) || '');
            suisUS.push(event.data?.userScripts === true);
            fbT.push(event.data?.fbTetapan === true);
            if (collectTimer) return;                                  // tetingkap sudah bermula
            if (hardTimer) { clearTimeout(hardTimer); hardTimer = null; }
            collectTimer = setTimeout(finish, collectMs);
        };
        window.addEventListener('message', handler);
        try {
            window.postMessage({ type: 'SESAAT_PING' }, '*');
        } catch (e) { /* ignore */ }
        hardTimer = setTimeout(finish, 1500);
    });

    // ★ GATE VERSI EXTENSION (v3.8.2) — paksa user upgrade extension lama sebelum Run.
    //   Suis Firestore config/extension_gate { enabled, requiredVersion }.
    //   FAIL-OPEN: sebarang ralat baca / suis OFF / doc tiada → JANGAN blok (return null).
    // Return { requiredVersion } kalau kena blok, atau null kalau lepas.
    const checkExtensionVersionGate = async (extVersion) => {
        try {
            const snap = await getDoc(doc(db, 'config', 'extension_gate'));
            if (!snap.exists()) return null;               // doc tiada → tak blok
            const cfg = snap.data() || {};
            if (!cfg.enabled) return null;                 // suis OFF → tak blok
            const req = cfg.requiredVersion || '3.8.2';
            if (_isVersionBelow(extVersion, req)) return { requiredVersion: req };
            return null;
        } catch (e) {
            console.warn('[VersionGate] fail-open (config tak dapat dibaca):', e?.message);
            return null;                                   // FAIL-OPEN — jangan sekat user sebab ralat kita
        }
    };

    /* ★ v3.9.2 — GATE SUIS "ALLOW USER SCRIPTS" DICANTUM ke dalam DOC YANG SAMA
       (arahan user 2026-09-03: "cantum jadi satu suis"). `config/extension_gate`
       kini membawa medan `requireUserScripts`. Satu doc kawal kedua-dua:
         { enabled: true, requiredVersion: '3.9.2', requireUserScripts: true }
       → extension lama dipaksa naik taraf DAHULU (gate versi), barulah suis dipaksa.
       Mustahil tersilap sampai pelanggan lama terperangkap — lihat pengaman
       versi≥3.9.2 pada pemanggil. FAIL-OPEN sama: ralat / medan tiada → false. */
    const bacaWajibUserScript = async () => {
        try {
            const snap = await getDoc(doc(db, 'config', 'extension_gate'));
            return snap.exists() && snap.data()?.enabled === true && snap.data()?.requireUserScripts === true;
        } catch { return false; }
    };

    // Mixed-module guard modal — abort Run Flow when selection mixes incompatible modules
    const [mixedModuleModal, setMixedModuleModal] = useState(null);

    /* ★ SEMAKAN RUANG GAMBAR SEBELUM RUN AGENT SAYA (keputusan user 2026-09-13) — tab My Agent SAHAJA.
       `kadTiadaRuang` = kad yang menahan larian terakhir [{ id, nama, ada, perlu }]. Tanda kuning pada
       kad KEKAL selepas popup ditutup; ia hilang sendiri bila kad itu sudah ada ruang (dikira semula
       setiap render daripada `extraImageUrls` semasa), bila tick kad itu dibuang (2026-09-18 — peraturan
       SAMA seperti tanda "tiada prompt" Run Flow, keputusan user), atau bila Run ditekan semula (senarai
       dikosongkan dahulu, kemudian disemak semula). Logik semakan: `kadTiadaRuangGambar`. */
    const [kadTiadaRuang, setKadTiadaRuang] = useState([]);
    const [popupTiadaRuang, setPopupTiadaRuang] = useState(false);
    const ruangGambarById = Object.fromEntries(kadTiadaRuang.map(k => [k.id, k]));
    /* Pratonton DEV sahaja: /workspace?ruangpreview=1 — popup + tanda kuning pada 2 kad (kad bertick
       dahulu, kalau tiada: 2 kad pertama) TANPA menjalankan apa-apa. `pratonton` memaksa tanda walaupun
       kad sebenarnya masih ada ruang. `import.meta.env.DEV` = false dalam build production. */
    const ruangPreviewDibuatRef = useRef(false);
    useEffect(() => {
        if (ruangPreviewDibuatRef.current) return undefined;
        let aktif = false;
        try { aktif = import.meta.env.DEV && new URLSearchParams(location.search).get('ruangpreview') === '1'; } catch { aktif = false; }
        if (!aktif || !Array.isArray(products) || products.length === 0) return undefined;
        const t = setTimeout(() => {
            ruangPreviewDibuatRef.current = true;
            const pilih = products.filter(p => p.selected);
            const sumber = (pilih.length ? pilih : products).slice(0, 2);
            setKadTiadaRuang(sumber.map(p => ({ id: p.id, nama: String(p.name || ''), ada: gambarTambahan(p).length, perlu: 1, pratonton: true })));
            setPopupTiadaRuang(true);
        }, 400);
        return () => clearTimeout(t);
    }, [products]);

    /* ★ SEMAKAN PROMPT SEBELUM RUN FLOW (keputusan user 2026-09-18) — corak SAMA semakan ruang gambar di
       atas: popup + card oren + TIADA automation dijalankan bila satu card bermasalah.
       `kadPromptKosong` = card yang menahan larian terakhir [{ id, nama, masalah }]. Tanda oren pada card
       dikira SEMULA setiap render (`masalahPromptSemasa` dalam senarai card) dan hilang sendiri sebaik card
       itu tidak lagi menahan larian: prompt diisi · tick card dibuang · set dibuang tick di Control Panel ·
       Workflow ditukar · Run ditekan semula (senarai dikosongkan, kemudian disemak semula). Tanda tidak
       disimpan — refresh membuangnya, dan Run seterusnya tetap menyemak semula.
       Logik semakan + ayat: utils/semakPromptFlow.js · popup: PopupPromptKosongFlow. */
    const [kadPromptKosong, setKadPromptKosong] = useState([]);
    const [popupPromptKosong, setPopupPromptKosong] = useState(false);
    /* ★ 2026-09-24 — robot Flow berhenti kerana model Video tiada dalam akaun Flow → popup (hooks/usePantauModelFlow.js). */
    const { popupModelTiada, mulaPantauModel, tutupPopupModel } = usePantauModelFlow(products);
    const promptKosongById = new Map(kadPromptKosong.map(k => [k.id, k]));
    /* Card bertanda yang teksnya sudah keluar dari cache (doc utama berubah — cth Generate dari browser
       lain) dimuat semula, supaya tanda boleh hilang sendiri tanpa pelanggan membuka card itu. */
    useEffect(() => {
        const ids = new Set(kadPromptKosong.filter(k => !k.pratonton).map(k => k.id));
        if (ids.size === 0) return;
        const targets = products.filter(p => ids.has(p.id) && needsDetail(p));
        if (targets.length) hydrateDetails(targets);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [kadPromptKosong, products]);
    /* Pratonton DEV sahaja: /workspace?promptpreview=1 — popup + tanda oren pada 2 card (card bertick
       dahulu, kalau tiada: 2 card pertama) TANPA menjalankan apa-apa. `pratonton` memaksa tanda walaupun
       card sebenarnya lengkap. `import.meta.env.DEV` = false dalam build production. */
    const promptPreviewDibuatRef = useRef(false);
    useEffect(() => {
        if (promptPreviewDibuatRef.current) return undefined;
        let aktif = false;
        try { aktif = import.meta.env.DEV && new URLSearchParams(location.search).get('promptpreview') === '1'; } catch { aktif = false; }
        if (!aktif || !Array.isArray(products) || products.length === 0) return undefined;
        const t = setTimeout(() => {
            promptPreviewDibuatRef.current = true;
            const pilih = products.filter(p => p.selected);
            const sumber = (pilih.length ? pilih : products).slice(0, 2);
            setKadPromptKosong(sumber.map((p, i) => ({
                id: p.id, nama: String(p.name || ''), pratonton: true,
                masalah: i === 0
                    ? [{ set: 'set1', kurang: ['gambar', 'video'] }]
                    : [{ set: 'set2', kurang: ['gambar'] }, { set: 'set3', kurang: ['video'] }],
            })));
            setPopupPromptKosong(true);
        }, 400);
        return () => clearTimeout(t);
    }, [products]);

    // ★ Gate versi extension (v3.8.2) — { requiredVersion } bila user extension lama klik Run
    const [versionGateModal, setVersionGateModal] = useState(null);
    // 'idle' | 'checking' | 'still-old' — untuk butang "Saya Sudah Kemas Kini" dalam modal paksa
    const [versionRecheck, setVersionRecheck] = useState('idle');
    /* ★ 2026-09-27 — "Saya Sudah Kemas Kini" = MUAT SEMULA TAB (aduan user: dah pasang
       versi baharu, popup kekal sehingga refresh sendiri). Punca: Chrome TIDAK menyuntik
       content script extension yang baru dipasang ke tab yang SUDAH terbuka — tab ini
       hanya boleh bercakap dengan extension baharu selepas dimuat semula. Semakan tanpa
       muat semula (cara lama) sentiasa melapor "masih versi lama" palsu.
       Bendera sessionStorage → selepas muat semula, kalau gate versi MASIH berkuat kuasa,
       notis "masih versi lama" dipapar (pelanggan tahu kenapa, bukan popup yang sama senyap). */
    const VERGATE_SEMAK_KEY = 'sesaat_vergate_semak';
    const semakSelepasKemasKini = () => {
        setVersionRecheck('checking');
        try { sessionStorage.setItem(VERGATE_SEMAK_KEY, '1'); } catch { /* mod privasi — muat semula tetap jalan */ }
        window.location.reload();
    };

    // ★ PENGUMUMAN WORKSPACE (config/workspace_announce) — muncul SELEPAS gate v3.9.3
    //   selesai (versionGateModal null). Had 3 kali/hari/browser (arahan user 2026-09-05).
    //   Boleh tutup (X / klik luar / butang Faham). Teks + suis on/off dikawal admin dari
    //   /admin/announce (Firestore) — tukar tanpa deploy. Fail-closed: doc hilang / ralat
    //   baca / suis OFF → tiada modal. Rules WAJIB all-auth-read (config/{docId} lalai
    //   admin-only → tanpa deploy rules, pelanggan tak boleh baca = modal mati).
    const [announceModal, setAnnounceModal] = useState(null);
    const versionGateModalRef = useRef(null);
    useEffect(() => { versionGateModalRef.current = versionGateModal; }, [versionGateModal]);
    useEffect(() => {
        let batal = false;
        const _klDate = () => { try { return new Date().toLocaleDateString('en-CA', { timeZone: 'Asia/Kuala_Lumpur' }); } catch { return new Date().toISOString().slice(0, 10); } };
        const _LS = 'sesaat_ws_announce_v1';
        const bolehPapar = (id) => { try { const r = JSON.parse(localStorage.getItem(_LS) || '{}'); if (r.d === _klDate() && r.id === id) return (r.n || 0) < 3; return true; } catch { return true; } };
        const tambah = (id) => { try { let r = JSON.parse(localStorage.getItem(_LS) || '{}'); if (r.d !== _klDate() || r.id !== id) r = { d: _klDate(), id, n: 0 }; r.n = (r.n || 0) + 1; localStorage.setItem(_LS, JSON.stringify(r)); } catch { /* mod privasi */ } };
        const previewDev = (() => { try { return import.meta.env.DEV && new URLSearchParams(location.search).get('announcepreview') === '1'; } catch { return false; } })();
        const jalan = async () => {
            try {
                const snap = await getDoc(doc(db, 'config', 'workspace_announce'));
                if (batal || !snap.exists()) return;
                const a = snap.data() || {};
                const id = String(a.id || (a.updatedAt && a.updatedAt.seconds) || 'x');
                if (!previewDev) {
                    if (!a.enabled) return;
                    if (!(a.title || a.body)) return;
                    if (!bolehPapar(id)) return;          // dah 3 kali hari ni
                    if (versionGateModalRef.current) return; // gate masih menghalang → jangan tindih
                    tambah(id);
                }
                if (!batal) setAnnounceModal({ title: a.title || '', body: a.body || '' });
            } catch { /* fail-closed */ }
        };
        // Beri gate ~6s settle (ping 800/2500/5000ms) sebelum papar pengumuman.
        const t = setTimeout(jalan, previewDev ? 300 : 6000);
        return () => { batal = true; clearTimeout(t); };
    }, []);

    // ★ AMARAN WAJIB KEMAS KINI (2026-07-29) — semak versi extension sebaik Workspace
    //   DIBUKA, bukan tunggu user tekan Run.
    //   SEBAB: selepas SPLIT V2 (config/product_split) dihidupkan, doc produk bertukar
    //   format. Extension LAMA menulis REPLACE roster penuh tanpa marker splitV →
    //   rules TOLAK → sync/save dia gagal SENYAP. User kena tahu di muka pintu, bukan
    //   selepas kerja dia hilang.
    //   • Extension TIDAK menjawab → JANGAN papar (itu kes belum pasang = onboarding).
    //   • Fail-open sama macam gate Run: suis config/extension_gate OFF atau ralat baca
    //     → checkExtensionVersionGate pulang null → modal tak muncul. Satu suis matikan semua.
    //   Tetingkap pengumpulan lebih panjang di sini (900ms) berbanding laluan Run —
    //   tiada pelanggan tercegat menunggu, jadi utamakan ketepatan.
    const probeExtensionVersion = async () => {
        try {
            const ping = await pingExtension(900);
            if (!ping.alive) return { state: 'absent', ping };
            const gate = await checkExtensionVersionGate(ping.version);
            return gate
                ? { state: 'old', requiredVersion: gate.requiredVersion, ping }
                : { state: 'ok', ping };
        } catch (_) { return { state: 'absent', ping: null }; }
    };

    // ★ Probe BERULANG — verdict "old" hanya muktamad selepas SEMUA percubaan habis.
    //   Service worker extension baharu selalunya sejuk sebaik tab dibuka, jadi percubaan
    //   pertama boleh terlepas PONG-nya sedangkan extension lama (SW panas) menjawab
    //   serta-merta. Sekali "ok" muncul, itu keputusan muktamad — berhenti terus.
    //   `waits` = jeda sebelum setiap percubaan.
    const probeExtensionVersionSettled = async (waits, isCancelled) => {
        let lastOld = null;
        let lastPing = null;
        for (const wait of waits) {
            if (wait) await new Promise(r => setTimeout(r, wait));
            if (isCancelled && isCancelled()) return { state: 'cancelled' };
            const res = await probeExtensionVersion();
            if (isCancelled && isCancelled()) return { state: 'cancelled' };
            if (res.ping) lastPing = res.ping;
            if (res.state === 'ok') return res;
            if (res.state === 'old') lastOld = res;
        }
        return lastOld || { state: 'absent', ping: lastPing };
    };

    /* ★ REKOD VERSI EXTENSION (2026-08-22) — jawapan kepada "siapa belum update?".
       Nombor versi MEMANG sudah sampai ke webapp setiap kali pelanggan membuka
       Workspace (melalui PONG), tetapi selama ini ia hanya dipakai untuk pagar versi
       lalu DIBUANG. Satu-satunya tempat ia pernah tersimpan ialah `error_logs` — dan
       itu hanya ditulis apabila sesuatu ROSAK, jadi ia sampel kemalangan, bukan
       senarai pelanggan (diukur 2026-08-22: 30 hari = 7 pengguna unik sahaja).

       ⛔ Dipanggil SEBELUM cabang 'old' memulangkan — pelanggan yang masih pada versi
          lama justru populasi yang paling perlu direkod.
       ⚠️ Satu tulisan per browser per PERUBAHAN versi sahaja (pagar localStorage), jadi
          kosnya hampir sifar walaupun Workspace dibuka berpuluh kali sehari.
       ⚠️ Titik TIDAK boleh berada dalam kunci peta Firestore ("3.9.0" → "3_9_0") —
          corak sama seperti kunci tarikh dalam `egressTrace`.
       ⚠️ `extVersions` menyimpan SETIAP versi yang pernah dilihat berserta masanya.
          Seorang pelanggan guna 3-5 browser dan sebahagiannya mungkin sudah update
          sementara yang lain belum; satu medan "versi terakhir" sahaja akan berkelip
          antara browser dan MENYEMBUNYIKAN browser yang masih lama.
       ⚠️ Nombor versi TIDAK dapat membezakan dua build yang berkongsi nombor yang sama
          (cth 3.9.0 lama lwn 3.9.0 baharu). Ia menjawab "siapa masih 3.8.x", bukan
          "siapa sudah ada build terkini".
       Medan ini BUKAN dalam protectedUserFields → tiada deploy rules diperlukan. */
    const EXT_VER_KEY = 'sesaat_ext_ver_reported';
    const rekodVersiExtension = async (versi) => {
        const v = String(versi || '').trim();
        if (!v || !auth.currentUser?.uid) return;
        try { if (localStorage.getItem(EXT_VER_KEY) === v) return; } catch { /* mod privasi */ }
        try {
            await setDoc(doc(db, 'users', auth.currentUser.uid), {
                extVersion: v,
                extVersionAt: serverTimestamp(),
                extVersions: { [v.replace(/\./g, '_')]: serverTimestamp() },
            }, { merge: true });
            try { localStorage.setItem(EXT_VER_KEY, v); } catch { /* ignore */ }
        } catch (e) {
            /* Rekod sahaja — kegagalan di sini TIDAK boleh menghalang Workspace. */
            console.warn('[ExtVer] gagal rekod versi extension:', e?.message);
        }
    };

    useEffect(() => {
        let cancelled = false;
        // PREVIEW LOCALHOST SAHAJA: buka /workspace?testgate=1 untuk lihat modal tanpa
        // mengubah config/extension_gate (yang akan menyekat SEMUA pelanggan prod).
        // import.meta.env.DEV = false dalam build production → tak pernah wujud di prod.
        if (import.meta.env.DEV && typeof location !== 'undefined'
            && new URLSearchParams(location.search).has('testgate')) {
            setVersionGateModal({ requiredVersion: '3.8.2', forced: true, duplicate: true });
            return;
        }
        // PREVIEW LOCALHOST: /workspace?testdup=1 → modal amaran "extension berganda".
        if (import.meta.env.DEV && typeof location !== 'undefined'
            && new URLSearchParams(location.search).has('testdup')) {
            setVersionGateModal({ mode: 'duplicate', count: 2 });
            return;
        }
        // PREVIEW LOCALHOST: /workspace?testusgate=1 → modal suis "Allow user scripts".
        //   Dibalut import.meta.env.DEV — tidak wujud dalam build production.
        if (import.meta.env.DEV && typeof location !== 'undefined'
            && new URLSearchParams(location.search).has('testusgate')) {
            setVersionGateModal({ mode: 'userscript', forced: true });
            return;
        }
        (async () => {
            // Service worker extension selalu sejuk masa page baru dibuka — cuba 3×
            // sebelum berputus asa, supaya user v3.8.2 tak kena modal palsu.
            const res = await probeExtensionVersionSettled([800, 2500, 5000], () => cancelled);
            if (cancelled || res.state === 'cancelled') return;
            // Rekod versi dahulu — cabang 'old' memulangkan awal di bawah.
            if (res.ping?.version) rekodVersiExtension(res.ping.version);
            const dup = (res.ping?.responders || 0) > 1;
            // Muat semula dari butang "Saya Sudah Kemas Kini"? (semakSelepasKemasKini)
            let dariSemak = false;
            try { dariSemak = sessionStorage.getItem(VERGATE_SEMAK_KEY) === '1'; sessionStorage.removeItem(VERGATE_SEMAK_KEY); } catch { /* ignore */ }
            if (res.state === 'old') {
                if (dariSemak) setVersionRecheck('still-old');
                setVersionGateModal({ requiredVersion: res.requiredVersion, forced: true, duplicate: dup });
                return;
            }
            // ★ Extension terkini OK — tetapi kalau extension LAMA masih terpasang
            //   serentak, pelanggan tetap perlu tahu: dua content script mendengar
            //   arahan Run yang sama (risiko submit berganda ke Flow), extension lama
            //   masih cuba sync (ditolak rules selepas SPLIT V2 = gagal senyap), dan ia
            //   memakan dua slot browser. Papar sekali per sesi supaya tidak menjengkelkan.
            /* ★ v3.9.2 — GATE SUIS "ALLOW USER SCRIPTS" (dicantum ke extension_gate).
               Diperiksa SELEPAS gate versi. ⛔ PENGAMAN: hanya berkuat kuasa untuk
               extension 3.9.2 ke atas — versi lama tidak boleh melaporkan suis
               (medannya tiada), jadi memaksanya di sini akan memerangkap mereka
               kekal. Versi lama diuruskan oleh gate versi di atas (paksa naik taraf).
               ⚠️ FAIL-OPEN: medan tiada / bacaan gagal → JANGAN sekat. */
            const bolehLaporSuis = res.ping?.version && !_isVersionBelow(res.ping.version, '3.9.2');
            if (res.state === 'ok' && bolehLaporSuis && res.ping?.userScripts !== true) {
                const wajib = await bacaWajibUserScript();
                if (wajib && !cancelled) {
                    setVersionGateModal({ mode: 'userscript', forced: true });
                    return;
                }
            }
            if (res.state === 'ok' && dup) {
                let seen = false;
                try { seen = !!sessionStorage.getItem(DUP_EXT_WARNED_KEY); } catch (_) { /* ignore */ }
                if (!seen) {
                    try { sessionStorage.setItem(DUP_EXT_WARNED_KEY, '1'); } catch (_) { /* ignore */ }
                    setVersionGateModal({ mode: 'duplicate', count: res.ping.responders });
                }
            }
        })();
        return () => { cancelled = true; };
    }, []);

    const selectedProduct = products.find(p => p.id === selectedProductId);

    // Safe URL hostname extractor — prevents crash from invalid URLs
    const safeHostname = (url) => {
        if (!url) return T('ws.card.noLink', 'No link');
        try { return new URL(url).hostname; } catch { return url.length > 40 ? url.substring(0, 40) + '...' : url; }
    };

    const isFromCloudRef = useRef(false);
    const isSettingsFromCloudRef = useRef(false); // Prevent settings write-back loop
    /* ★ v3.9.2: true = browser ini sudah ada rekod tetapan larian SENDIRI
       (localStorage) — medan larian dari Firestore TIDAK lagi diterima masuk.
       false = belum ada rekod → snapshot cloud pertama menjadi benih. */
    const runConfigSediaRef = useRef(false);

    // ★ Save reliability: track last-saved-to-server state so we only write changed docs
    // Map<productId, JSON-string-of-stripped-doc> + lastSavedGroupsJson string.
    // Populated on initial subscribe + after every successful save.
    const lastSavedSnapshotRef = useRef({ products: new Map(), groups: '' });
    // ★ Per-browser checkbox selection restore (refresh-safe).
    // Capture localStorage AT MOUNT before any useEffect runs — otherwise the
    // selectedIdsKey effect (below) fires first with empty products and
    // overwrites LS with [], destroying the prior selection before snapshot
    // arrives. hasReceivedFirstSnapshotRef gates LS writes for the same
    // reason: don't write [] before first snapshot lands.
    const restoredSelectedIdsRef = useRef((() => {
        try {
            const raw = typeof localStorage !== 'undefined' ? localStorage.getItem('workspace_selected_ids') : null;
            if (raw) {
                const parsed = JSON.parse(raw);
                if (Array.isArray(parsed)) return new Set(parsed);
            }
        } catch (_) { /* ignore */ }
        return new Set();
    })());
    const isFirstProductsSnapshotRef = useRef(true);
    const hasReceivedFirstSnapshotRef = useRef(false);
    const [saveError, setSaveError] = useState(null); // { message, attemptedAt } when save fails after retries

    const videoInputRef = useRef(null);
    const [uploadingState, setUploadingState] = useState({ productId: null, setKey: null, isUploading: false });
    // ★ Popup halangan upload (dwibahasa + pill tukar bahasa) — { ms, en } atau null.
    const [uploadBlockPopup, setUploadBlockPopup] = useState(null);
    // ★ Slot video yang SEDANG di-push ke cloud (Save Cloud) — untuk denyut hijau. Set `${pid}::${setKey}`.
    const [cloudPushingKeys, setCloudPushingKeys] = useState(() => new Set());
    const [previewImage, setPreviewImage] = useState(null);
    /* Paparan besar jalur gambar kad v3.9 — { senarai, mula, tajuk }. Berasingan daripada
       `previewImage` (pratonton lama kad bergambar SATU — kod stabil, tidak disentuh). */
    const [pratontonKad, setPratontonKad] = useState(null);
    // Delete-video flow state
    const [deletingState, setDeletingState] = useState({ productId: null, setKey: null, fadingOut: false });
    const [deleteConfirm, setDeleteConfirm] = useState({ open: false, product: null, setKey: null, busy: false });
    // Bulk product-delete confirm (frees cloud storage). estBytes = measured size of files to free.
    const [productDeleteConfirm, setProductDeleteConfirm] = useState({ open: false, ids: [], estBytes: null, busy: false, progress: null });
    const productDeleteEstimateRef = useRef(null);
    // ★ DUPLICATE KAD — modal pilih bilangan salinan (tiada had; lihat handleDuplicateProducts)
    const [duplicateModal, setDuplicateModal] = useState({ open: false, ids: [], copies: 1, busy: false });
    // ★ Bulk video-only delete (per set) — card & prompt kekal, video sahaja dipadam
    const [bulkVideoDeleteConfirm, setBulkVideoDeleteConfirm] = useState({ open: false, setKey: null, items: [], estBytes: null, busy: false, progress: null });
    const bulkVideoEstimateRef = useRef(null);
    const [showDelVideoDropdown, setShowDelVideoDropdown] = useState(false);
    /* ★ Bulk kosongkan STATUS pil TikTok (per set) — rekod `setStatusAkaun`
       sahaja. Video, caption dan slot kalendar TIDAK disentuh. */
    const [showClearStatusDropdown, setShowClearStatusDropdown] = useState(false);
    /* ★ Bulk KOSONGKAN PROMPT (per set) — teks sahaja; video, gambar & data produk
       kekal. fasa: 'semak' (membaca teks segar) → 'sedia' (tunggu pengesahan) → 'tulis'. */
    const [showKosongPromptDropdown, setShowKosongPromptDropdown] = useState(false);
    const [kosongPrompt, setKosongPrompt] = useState(KOSONG_PROMPT_TUTUP);
    const kosongPromptReqRef = useRef(0);

    // Storage Limit — 2GB per user
    const STORAGE_LIMIT_BYTES = 5 * 1024 * 1024 * 1024; // 5GB (naik dari 2GB — Fasa 3 R2)
    const [storageUsed, setStorageUsed] = useState(0); // bytes
    const fileInputRef = useRef(null);
    const [uploadingProductId, setUploadingProductId] = useState(null);
    // ★ [2026-11-04] Blank Card — menu "Add product / Add image" pada petak gambar kosong.
    //   blankMenuFor = id kad yang menunya sedang terbuka; addProductFor = id kad yang
    //   sedang pilih produk dari My Products (modal ProductLibraryModal).
    const [blankMenuFor, setBlankMenuFor] = useState(null);
    const [addProductFor, setAddProductFor] = useState(null);

    // Raw output modal state
    const [rawOutputModal, setRawOutputModal] = useState({ open: false, productId: null, content: '', plainContent: '', viewMode: 'json' });
    /* ★ EDIT DATA dari kad (PLAN_EDIT_DATA_KAD.md, 2026-09-12) — borang Product Data yang SAMA
       seperti My Products, dibuka dari chip kontras pada kad. Logik cari-pasangan + simpan
       hidup dalam utils/editDataProduk.js (fail sendiri — bukan dalam fail gergasi ini). */
    const [editDataKad, setEditDataKad] = useState(null);        // { kad, kes, item, produkBorang, kumpulan, profil, … }
    /* ★ GATE beg kuning sebelum Run TikTok (2026-10-06) — { senarai, bilLain, semuaTiada, langkau(), tanpaBeg() } atau null.
       Peraturan: utils/gateBegKuning.js · rupa: PopupGateBegKuning.jsx. */
    const [gateBeg, setGateBeg] = useState(null);
    const [editDataLoadingId, setEditDataLoadingId] = useState(null);

    // Inline editing for product name/link
    const [editingProductHeader, setEditingProductHeader] = useState({ id: null, field: null }); // { id: productId, field: 'name' | 'link' }
    const [editingValue, setEditingValue] = useState('');
    const [copiedField, setCopiedField] = useState(null); // 'name_productId' or 'link_productId'

    /* ═══ EDIT DATA dari kad — buka / muat naik / padam / simpan ═══ */
    const bukaEditDataKad = async (product) => {
        const uid = auth.currentUser?.uid;
        const email = auth.currentUser?.email;
        if (!uid || !email || !product?.id || editDataLoadingId) return;
        setEditDataLoadingId(product.id);
        try {
            const sedia = await sediakanEditDataKad({ uid, email, kad: product });
            setEditDataKad({ kad: product, ...sedia });
        } catch (e) {
            console.warn('[EditData] gagal sediakan borang:', e?.message);
            alert(T('ws.card.editDataFail', 'Data produk tidak dapat dimuatkan. Cuba sekali lagi.'));
        } finally {
            setEditDataLoadingId(null);
        }
    };
    /* Muat naik gambar dari borang kad → laluan yang SAMA seperti My Products pelanggan
       (users/{uid}/library/product/…) supaya pemadam gambar lama + kaunter 5GB
       memahaminya. Borang sudah memampatkan fail sebelum memanggil ini. */
    const muatNaikGambarKad = async (file) => {
        const uid = auth.currentUser?.uid;
        if (!uid || !file) throw new Error('Missing file');
        const ext = file.name.split('.').pop()?.toLowerCase() || 'jpg';
        const idFail = editDataKad?.item?.id || editDataKad?.kad?.id || 'kad';
        const storagePath = `users/${uid}/library/${FOLDER_MY_PRODUCTS}/${idFail}_${Date.now()}.${ext}`;
        const r = fbRef(storage, storagePath);
        await uploadBytes(r, file, { contentType: file.type || 'image/jpeg', cacheControl: 'public, max-age=31536000, immutable' });
        bumpStorageCounter(db, uid, file.size);   // ★ kaunter storage (simetri: padam menolak semula)
        return await getDownloadURL(r);
    };
    /* ⚠️ KEMBAR dengan LibraryView.padamGambarSimpanan — dua fail tidak berkongsi
       komponen; ubah satu, ubah dua-dua. Hanya fail di bawah users/{uid}/library/
       disentuh (fail System / CDN TikTok dilangkau). */
    const padamGambarKad = async (imageUrl) => {
        try {
            const uid = auth.currentUser?.uid;
            if (!imageUrl || !uid || !String(imageUrl).includes('firebasestorage.googleapis.com')) return;
            const m = new URL(imageUrl).pathname.match(/\/o\/(.+?)(\?|$)/);
            if (!m) return;
            const storagePath = decodeURIComponent(m[1]);
            if (!storagePath.startsWith(`users/${uid}/library/`)) return;
            const r = fbRef(storage, storagePath);
            let sz = 0;
            try { sz = (await getMetadata(r)).size || 0; } catch { /* abaikan */ }
            await deleteObject(r);
            if (sz > 0) bumpStorageCounter(db, uid, -sz);
        } catch (e) { console.warn('[EditData] Gagal padam gambar lama:', e?.message); }
    };
    const simpanEditDataKad = async (borang) => {
        const ctx = editDataKad;
        if (!ctx) return;
        const uid = auth.currentUser?.uid;
        const email = auth.currentUser?.email;
        let hasil;
        try {
            hasil = await simpanDariKad({ uid, email, kad: ctx.kad, pasangan: ctx, produkBorang: ctx.produkBorang, borang, padamGambar: padamGambarKad });
        } catch (e) {
            /* Item sudah tersimpan tetapi kad gagal dikemas kini → beritahu dengan ayat yang
               menyatakan keadaan sebenar (borang kekal terbuka, pelanggan boleh cuba semula). */
            if (e?.itemDisimpan) throw new Error(T('products.complete.kad.gagalKad', 'Disimpan ke My Products, tetapi kad Workspace tidak dapat dikemas kini. Buka Edit data sekali lagi dan tekan Simpan semula.'));
            throw e;
        }
        /* Perenggan data baharu masuk cache teks berat supaya kad memaparkannya
           serta-merta — feed onSnapshot hanya membawa doc ringan.
           ⛔ HANYA kad yang teksnya SUDAH ada dalam cache. primeDetailCache pada kad tanpa
              salinan mencipta salinan `prompts: null` yang dianggap LENGKAP: hydrate dilangkau,
              kad memapar prompt kosong, dan Run Flow menghantar kad TANPA prompt — skrip Flow
              jatuh ke NAMA PRODUK, senyap (kes sebenar 2026-09-13: buang gambar storyboard →
              Simpan → Run Flow). Peraturan user 2026-09-13: buang gambar hanya mengubah gambar;
              prompt terbaru kekal dipapar dan ditampal ke Flow. Kad tanpa salinan membaca subdoc
              sendiri bila dibuka / di-Run — subdoc sudah membawa perenggan baharu (tulisan di
              atas sudah selesai). */
        if (hasil.intelligenceData) {
            for (const id of hasil.kadIds) {
                if (detailCacheRef.current.has(id)) primeDetailCache(id, { intelligenceData: hasil.intelligenceData });
            }
        }
        setEditDataKad(null);
    };

    const startEditingField = (productId, field, currentValue) => {
        setEditingProductHeader({ id: productId, field });
        setEditingValue(currentValue || '');
    };

    const saveEditingField = () => {
        if (!editingProductHeader.id) return;
        const { id, field } = editingProductHeader;
        const updated = products.map(p => {
            if (p.id !== id) return p;
            if (field === 'name') return { ...p, name: editingValue };
            if (field === 'link') return { ...p, link: editingValue };
            if (field === 'shopeeLink') return { ...p, shopeeLink: editingValue };  // ★ v4 FB Reels
            return p;
        });
        setProducts(updated);
        saveToCloud(updated);
        setEditingProductHeader({ id: null, field: null });
        setEditingValue('');
    };

    const cancelEditing = () => {
        setEditingProductHeader({ id: null, field: null });
        setEditingValue('');
    };

    const copyToClipboard = (text, fieldKey) => {
        navigator.clipboard.writeText(text || '');
        setCopiedField(fieldKey);
        setTimeout(() => setCopiedField(null), 1500);
    };

    // ★ Copy prompt + selit tag SESAAT (padan automation): user paste manual ke Flow → media bawa
    //   tag → boleh dikesan/disusun sama macam automation. sceneNum utk FLOWNITY (##IMAGE-SET1-SCENE{n}##)
    //   & video ai16saat 2-scene (##VIDEO-SET{n}-SCENE{m}##); null selain (##IMAGE-SET{n}## / ##VIDEO-SET{n}##).
    const copyWithTag = (kind, setKey, sceneNum, text, fieldKey) => {
        const n = (String(setKey || 'set1').match(/\d+/) || ['1'])[0];
        const tag = (sceneNum != null) ? `##${kind}-SET${n}-SCENE${sceneNum}##` : `##${kind}-SET${n}##`;
        // ★ FIX (review 2026-07-26): buang tag SEDIA ADA dlm teks sebelum cop tag baru —
        //   elak tag bertimbun bila user copy → paste ke kotak lain → copy semula.
        //   (Tag bertimbun = padanan kad automation boleh tersilap set.)
        const clean = String(text || '').replace(/##[a-zA-Z0-9_\-]+##/g, '').trim();
        copyToClipboard(clean ? `${tag} ${clean}` : (text || ''), fieldKey);
    };

    // Block direct webapp upload untuk module yang `uploadVia: 'extension-only'` dalam registry.
    // Cover ai16saat-half, homeniche, smartcustom, flownity, dan future variants — generik via registry.
    // ★ R2 (restructure 2026-08-23): pagar nama-module ini HANYA terpakai bila R2 MATI (dasar
    //   lama sebagai jaring). R2 HIDUP → SEMUA module boleh upload dari webapp — pintu pusat
    //   `uploadVideoToWarehouse` yang jaga had (≤50MB + 300/hari + 5GB, server). Tanpa gate ini,
    //   pelanggan FLOWNITY/SMART nampak popup "mesti guna extension" sedangkan cloud dah terbuka.
    const isUploadBlockedProduct = (product) => {
        if (!product) return false;
        if (isR2Enabled()) return false; // R2 hidup → tiada sekatan ikut nama module
        return isUploadBlockedForModule(product.moduleId);
    };
    // Nama modul diambil dari registry — dulu mesej ini hardcode "AI16SAAT", jadi user
    // Home Niche / SMART / FLOWNITY nampak nama modul yang salah.
    const showUploadBlockedAlert = (product) => {
        const label = product?.moduleId ? getMarketingName(product.moduleId) : T('ws.upload.blockedModuleFallback', 'modul ini');
        alert(T('ws.upload.blockedModule', `📥 Untuk produk ${label}, upload video perlu dilakukan melalui extension SESAAT.\n\nLangkah:\n1. Buka extension SESAAT\n2. Cari product card yang sama\n3. Klik butang "Mass Video"\n4. Pilih video file (set1/set2/set3) daripada folder Downloads\n\nVideo untuk modul ini tidak boleh disimpan ke Cloud kerana saiznya besar — ia hanya tersimpan dalam storage pada browser ini sahaja.`, { label }));
    };

    // ★ PINTU PUSAT GUDANG VIDEO — WEBAPP (restructure 2026-08-23, cermin extension routeVideoToWarehouse).
    //   SATU peraturan untuk SEMUA laluan webapp: video ≤50MB + suis R2 on → R2 (had 300/hari +
    //   5GB dijaga SERVER). Selain itu (>50MB / R2 tertutup) → LEMPAR dengan `videoCode`; pemanggil
    //   putuskan (Save-Cloud → kekal local; upload manual → popup "guna Extension").
    //   ⛔ TIADA tulisan Firebase baru langsung — video baru webapp SEMUA ke R2 (arahan user 2026-08-23).
    const uploadVideoToWarehouse = async (blob, { productId, setKey }) => {
        if (isR2Enabled() && blob.size <= 50 * 1024 * 1024) {
            const { url } = await uploadVideoToR2(blob, { productId, setKey });
            return { url, warehouse: 'r2' };
        }
        const oversize = blob.size > 50 * 1024 * 1024;
        const e = new Error(oversize
            ? `Video ${(blob.size / 1048576).toFixed(1)}MB melebihi had 50MB.`
            : 'R2 tidak tersedia sekarang.');
        e.videoCode = oversize ? 'oversize' : 'r2-off';
        throw e;
    };

    const handleVideoUpload = async (event) => {
        const file = event.target.files?.[0];
        if (!file || !uploadingState.productId || !uploadingState.setKey) return;

        // ★ GUARD module extension-only: must upload via extension, not webapp
        const blockProduct = products.find(p => p.id === uploadingState.productId);
        if (isUploadBlockedProduct(blockProduct)) {
            showUploadBlockedAlert(blockProduct);
            event.target.value = '';
            setUploadingState({ productId: '', setKey: '', isUploading: false });
            return;
        }

        // ★ Manual upload WAJIB ikut peraturan cloud (arahan user 2026-08-23): video >50MB TIDAK
        //   boleh ke cloud dari webapp (webapp tiada storan local). Arahkan ke Extension yang boleh
        //   simpan video besar dalam browser + terus post TikTok. ⛔ TIADA jaring Firebase.
        if (file.size > 50 * 1024 * 1024) {
            const mb = (file.size / 1048576).toFixed(1);
            setUploadBlockPopup({
                ms: `Video ini ${mb}MB — melebihi had 50MB untuk simpanan cloud.\n\nSila muat naik video ini melalui Extension SESAAT: video besar disimpan dalam browser anda dan masih boleh di-post ke TikTok.`,
                en: `This video is ${mb}MB — over the 50MB cloud limit.\n\nPlease upload this video through the SESAAT Extension: large videos are kept in your browser and can still be posted to TikTok.`,
            });
            event.target.value = '';
            setUploadingState({ productId: '', setKey: '', isUploading: false });
            return;
        }

        // Validation: 2GB storage limit per user
        if (storageUsed + file.size > STORAGE_LIMIT_BYTES) {
            const usedMB = (storageUsed / 1024 / 1024).toFixed(1);
            const limitMB = (STORAGE_LIMIT_BYTES / 1024 / 1024).toFixed(0);
            const fileMB = (file.size / 1024 / 1024).toFixed(1);
            /* ⚠️ Ayat lalai SENGAJA mengekalkan aksara rosak yang memang
               ada dalam kod asal — rupa LAMA tidak boleh berubah tanpa
               kebenaran. Versi kamus (v3.9) memakai simbol yang betul. */
            alert(T('ws.upload.storageFull', `âš ï¸ Storage limit reached!\n\nUsed: ${usedMB} MB / ${limitMB} MB\nFile size: ${fileMB} MB\n\nPlease delete some old videos to free up space.`, { used: usedMB, limit: limitMB, file: fileMB }));
            return;
        }

        setUploadingState(prev => ({ ...prev, isUploading: true }));

        try {
            // ★ v3.0.0: Clean up old video before uploading replacement
            const oldProduct = products.find(p => p.id === uploadingState.productId);
            const oldVideoUrl = oldProduct?.prompts?.[uploadingState.setKey]?.uploadedVideo;
            const oldThumbUrl = oldProduct?.prompts?.[uploadingState.setKey]?.uploadedVideoThumb;

            // Delete old video file from Firebase Storage (prevent orphans)
            if (oldVideoUrl) {
                await deleteVideoFromStorage(oldVideoUrl);
            }
            // Delete old thumbnail file from Firebase Storage
            if (oldThumbUrl) {
                await deleteVideoFromStorage(oldThumbUrl);
            }
            // Notify extension to clear old local cache (all 3 tiers)
            window.postMessage({
                type: 'SESAAT_CLEAR_VIDEO_CACHE',
                productId: uploadingState.productId,
                setKey: uploadingState.setKey,
                videoUrl: oldVideoUrl || ''
            }, '*');

            // ★ Debug: Log upload context
            console.log('[VideoUpload] Starting upload:', {
                fileName: file.name,
                fileSize: (file.size / 1024 / 1024).toFixed(2) + ' MB',
                fileType: file.type,
                productId: uploadingState.productId,
                setKey: uploadingState.setKey,
                hasAuth: !!auth.currentUser,
                uid: auth.currentUser?.uid?.substring(0, 8)
            });

            if (!auth.currentUser) {
                throw new Error(T('ws.upload.notAuthenticated', 'User not authenticated. Please log in again.'));
            }

            // ★ PINTU PUSAT (restructure 2026-08-23): R2 SAHAJA — TIADA Firebase (arahan user).
            //   Saiz >50MB sudah ditolak di atas. R2 tertutup/gagal → pintu LEMPAR → outer catch
            //   papar popup "guna Extension" (webapp tiada storan local). Kaunter simpanan = SERVER.
            let downloadURL;
            {
                const { url, warehouse } = await uploadVideoToWarehouse(file, {
                    productId: uploadingState.productId,
                    setKey: uploadingState.setKey,
                });
                downloadURL = url;
                console.log(`[VideoUpload] ✅ ${warehouse} upload:`, downloadURL.substring(0, 60));
            }

            const updatedProducts = products.map(p => {
                if (p.id === uploadingState.productId) {
                    const currentPrompts = p.prompts || getEmptyPromptCollection();
                    return {
                        ...p,
                        prompts: {
                            ...currentPrompts,
                            [uploadingState.setKey]: {
                                ...currentPrompts[uploadingState.setKey] || {},
                                uploadedVideo: downloadURL
                            }
                        }
                    };
                }
                return p;
            });

            setProducts(updatedProducts);
            await saveToCloud(updatedProducts);
            // Refresh storage usage after upload
            window.dispatchEvent(new Event('SESAAT_STORAGE_CHANGED'));

            // ★ THUMBNAIL: Auto-generate poster frame for lightweight preview
            try {
                // ★ Poster diambil daripada FAIL yang baru dipilih (blob tempatan) — 0 muat turun.
                const _posterSrc = URL.createObjectURL(file);
                let thumbBlob;
                try {
                    const _kanvas = await tangkapPosterVideo(_posterSrc, { lebar: 360, tinggi: 640 });
                    thumbBlob = await new Promise(resolve => _kanvas.toBlob(b => resolve(b), 'image/jpeg', 0.7));
                } finally {
                    URL.revokeObjectURL(_posterSrc);
                }
                if (!thumbBlob) throw new Error('toBlob kosong');

                const thumbRef = fbRef(storage, `videos/${auth.currentUser.uid}/${uploadingState.productId}/${uploadingState.setKey}_thumb.jpg`);
                await uploadBytes(thumbRef, thumbBlob, { contentType: 'image/jpeg', cacheControl: 'public, max-age=604800' });
                /* ⛔ POSTER SENGAJA TIDAK DIKIRA DALAM METER SIMPANAN (keputusan user
                   2026-08-26). Path `_thumb.jpg` adalah TETAP — jana semula MENINDIH fail
                   lama, jadi saiz sebenar dalam bucket tidak bertambah. Menaikkan kaunter
                   di sini membuat meter pelanggan menggelembung setiap kali dia mengganti
                   video, sehingga dia tersekat "simpanan penuh" palsu.
                   Peraturan ini kini SERAGAM di tiga tempat: laluan naik (di sini + panel
                   extension), laluan padam (deleteVideoFromStorage), dan kiraan semula
                   Optimize. Menyentuh satu tanpa yang lain = nombor melompat. */
                const thumbURL = await getDownloadURL(thumbRef);

                const withThumb = updatedProducts.map(p => {
                    if (p.id === uploadingState.productId) {
                        return {
                            ...p,
                            prompts: {
                                ...p.prompts,
                                [uploadingState.setKey]: {
                                    ...p.prompts[uploadingState.setKey],
                                    uploadedVideoThumb: thumbURL
                                }
                            }
                        };
                    }
                    return p;
                });
                setProducts(withThumb);
                await saveToCloud(withThumb);
                console.log('Thumbnail generated:', thumbURL.substring(0, 60));
            } catch (thumbErr) {
                console.warn('Thumbnail generation failed (non-critical):', thumbErr);
            }
        } catch (error) {
            console.error('Video Upload Error:', error);
            if (error?.videoCode === 'r2-off' || error?.videoCode === 'oversize') {
                // Cloud tak boleh terima video ini → webapp tiada storan local → guna Extension.
                setUploadBlockPopup({
                    ms: 'Storan cloud tidak tersedia sekarang, atau video melebihi had 50MB.\n\nSila muat naik video ini melalui Extension SESAAT.',
                    en: 'Cloud storage is not available right now, or the video is over 50MB.\n\nPlease upload this video through the SESAAT Extension.',
                });
            } else {
                const errMsg = error?.code ? `[${error.code}] ${error.message}` : error.message;
                alert(T('ws.upload.videoFailed', `Gagal memuat naik video:\n${errMsg}`, { msg: errMsg }));
            }
        } finally {
            setUploadingState({ productId: null, setKey: null, isUploading: false });
            if (videoInputRef.current) videoInputRef.current.value = '';
        }
    };

    const handleImageUpload = async (productId, file) => {
        if (!file) return;
        if (!auth.currentUser) {
            alert(T('ws.image.reloginNeeded', 'Sila log masuk semula untuk ganti gambar.'));
            return;
        }

        // 1) Tunjuk preview base64 dengan serta-merta (transient — akan diganti imageUrl bila upload siap)
        let base64Preview;
        try {
            base64Preview = await new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.onerror = () => reject(reader.error || new Error('FileReader failed'));
                reader.readAsDataURL(file);
            });
        } catch (err) {
            alert(T('ws.image.readFailed', 'Gagal baca fail gambar: ' + err.message, { msg: err.message }));
            return;
        }
        setProducts(prev => prev.map(p => p.id === productId
            ? { ...p, imageBase64: base64Preview, imageUrl: '', localImagePath: null }
            : p
        ));

        // 2) Upload ke Storage supaya imageUrl persists (imageBase64 ada dalam STRIP_FIELDS — tak survive ke Firestore)
        try {
            const ext = (file.name.split('.').pop() || 'jpg').toLowerCase();
            const storagePath = `users/${auth.currentUser.uid}/products/${productId}/${Date.now()}.${ext}`;
            const storageRef = fbRef(storage, storagePath);
            await uploadBytes(storageRef, file, { contentType: file.type || 'image/jpeg', cacheControl: 'public, max-age=31536000, immutable' });
            bumpStorageCounter(db, auth.currentUser.uid, file.size); // ★ kaunter storage
            const imageUrl = await getDownloadURL(storageRef);

            // 3) Ganti preview dgn URL sebenar + save (imageUrl bukan dalam STRIP_FIELDS, jadi persist)
            let snapshot;
            setProducts(prev => {
                snapshot = prev.map(p => p.id === productId
                    ? { ...p, imageBase64: '', imageUrl, localImagePath: null }
                    : p
                );
                return snapshot;
            });
            const result = await saveToCloud(snapshot);
            if (!result?.ok) {
                const sebab = result?.error?.message || T('ws.image.unknownError', 'unknown');
                alert(T('ws.image.metaSaveFailed', 'Gambar dah upload, tapi gagal save metadata: ' + sebab, { msg: sebab }));
            }
        } catch (err) {
            console.error('[ImageUpload] error:', err);
            alert(T('ws.image.uploadFailed', 'Gagal upload gambar: ' + err.message, { msg: err.message }));
            // Revert preview supaya user tahu save gagal
            setProducts(prev => prev.map(p => p.id === productId
                ? { ...p, imageBase64: '' }
                : p
            ));
        }
    };

    // Load products from subcollection + settings from user doc
    useEffect(() => {
        if (!auth.currentUser) return;

        // ★ Products from subcollection
        const unsubProducts = subscribeToProducts(auth.currentUser.uid, (prods) => {
            isFromCloudRef.current = true;
            // ★ Update last-saved snapshot from server. Baseline for diffing in saveToCloud.
            // Server data IS the source of truth for what's saved — local edits diff against this.
            const newSnapshot = new Map();
            for (const fp of prods) {
                if (!fp.id) continue;
                const cleaned = { ...fp };
                for (const f of STRIP_FIELDS) delete cleaned[f];
                stripRawOutputIfPipeline(cleaned);
                newSnapshot.set(fp.id, JSON.stringify(sanitizeForFirestore(cleaned)));
                // ★ SPLIT V2: invalidate cache teks bila doc utama berubah SELEPAS fetch
                //   (edit dari browser lain). Cache di-prime kod sendiri ada buffer +60s.
                const c = detailCacheRef.current.get(fp.id);
                if (c && c._fetchedAtMs && fp.lastUpdated?.toMillis
                    && fp.lastUpdated.toMillis() > c._fetchedAtMs) {
                    detailCacheRef.current.delete(fp.id);
                }
            }
            lastSavedSnapshotRef.current.products = newSnapshot;

            // ★ First snapshot only: restore checkbox selection from the value
            // captured at mount (restoredSelectedIdsRef). After that, preserve
            // from React prev. Mark hasReceivedFirstSnapshot so the persistence
            // useEffect can begin writing to localStorage.
            let restoredSelectedIds = null;
            if (isFirstProductsSnapshotRef.current) {
                isFirstProductsSnapshotRef.current = false;
                restoredSelectedIds = restoredSelectedIdsRef.current;
            }
            hasReceivedFirstSnapshotRef.current = true;

            setProducts(prev => {
                const prevMap = new Map(prev.map(p => [p.id, p]));
                const firestoreIds = new Set(prods.map(p => p.id));

                const merged = prods.map(fp => {
                    const local = prevMap.get(fp.id);
                    const wantSelected = restoredSelectedIds
                        ? restoredSelectedIds.has(fp.id)
                        : (local ? !!local.selected : false);
                    if (local && (local.isGenerating || local.generationFailed)) {
                        return {
                            ...fp,
                            selected: wantSelected,
                            isGenerating: local.isGenerating,
                            generatingStatus: local.generatingStatus,
                            generationFailed: local.generationFailed
                        };
                    }
                    return wantSelected ? { ...fp, selected: true } : fp;
                });

                // ★ Keep locally-added products that haven't synced to Firestore yet
                // (injected by SESAAT_NEW_PRODUCTS event with isGenerating: true)
                const localOnly = prev.filter(p =>
                    !firestoreIds.has(p.id) && (p.isGenerating || p.generationFailed)
                );

                if (localOnly.length > 0) {
                    console.log(`[WorkspaceView] Preserving ${localOnly.length} local-only products during Firestore sync`);
                }

                return [...merged, ...localOnly];
            });
            if (!selectedProductId && prods.length > 0) {
                setSelectedProductId(prods[0].id);
            }
            setIsLoading(false);
        }, (err) => {
            console.error('[WorkspaceView] Products error:', err);
            setIsLoading(false);
        });

        /* ★ v3.9.2 — pulihkan tetapan larian browser INI sebelum listener cloud
           dipasang. Susunan penting: flag `runConfigSediaRef` mesti benar SEBELUM
           snapshot pertama tiba, kalau tidak nilai cloud (pilihan browser lain)
           menimpa pilihan browser ini sekali pada setiap muat halaman. Nilai
           disemak jenis satu-satu — rekod rosak dilangkau medan demi medan, bukan
           dibuang seluruhnya. */
        {
            const lokal = bacaRunConfigLokal();
            if (lokal) {
                if (Array.isArray(lokal.automationTargetSets)) setAutomationTargetSets(lokal.automationTargetSets);
                if (Array.isArray(lokal.tiktokTargetSets)) setTiktokTargetSets(lokal.tiktokTargetSets);
                if (typeof lokal.isPostOnly === 'boolean') setIsPostOnly(lokal.isPostOnly);
                if (typeof lokal.isShowcaseOnly === 'boolean') setIsShowcaseOnly(lokal.isShowcaseOnly);
                if (typeof lokal.isImageOnly === 'boolean') setIsImageOnly(lokal.isImageOnly);
                if (typeof lokal.isShowcaseMode === 'boolean') setIsShowcaseMode(lokal.isShowcaseMode);
                if (typeof lokal.flowProjectMode === 'string') setFlowProjectMode(lokal.flowProjectMode);
                if (typeof lokal.flowProjectUrl === 'string') setFlowProjectUrl(lokal.flowProjectUrl);
                if (typeof lokal.flowUltraMode === 'string') {
                    const _fm = leraiModVideoLama(lokal.flowUltraMode, lokal.flowVideoDuration, lokal.flowIngredientsMode);
                    setFlowUltraMode(_fm.model);
                    setFlowVideoDuration(_fm.duration);
                    setFlowIngredientsMode(_fm.ingredients);
                }
                if (typeof lokal.flowImageModel === 'string') setFlowImageModel(lokal.flowImageModel);
                if (typeof lokal.flowVideoResolution === 'string') setFlowVideoResolution(normResolusiVideo(lokal.flowVideoResolution));
                if (typeof lokal.flowWorkflow === 'string') setFlowWorkflow(normWorkflow(lokal.flowWorkflow));
                if (typeof lokal.flowDownloadSize === 'string') setFlowDownloadSize(normSaizVideo(lokal.flowDownloadSize));
                /* ★ [2026-09-13] 'menunggu', BUKAN true: nilai di atas baru DIJADUALKAN — ia belum masuk state.
                   Effect simpan (di bawah) yang berjalan dalam commit yang SAMA masih membawa nilai LALAI; ia
                   melangkau pusingan itu apabila melihat penanda ini. Penanda ini truthy, jadi pagar benih cloud
                   (`!runConfigSediaRef.current`) kekal menolak benih seperti dahulu. */
                runConfigSediaRef.current = 'menunggu';
                console.log('[WorkspaceView] ★ Tetapan larian browser ini dipulihkan (per-browser)');
            }
        }

        // Settings from user doc (spaces, extensionSettings, sort prefs)
        const docRef = doc(db, 'users', auth.currentUser.uid);
        const unsubSettings = onSnapshot(docRef, (docSnap) => {
            if (docSnap.exists()) {
                const data = docSnap.data();
                // ★ Kaunter storage — bar baca nilai dari user doc (ganti scan listAll)
                setStorageUsed(data.storageUsedBytes || 0);
                const spacesData = data.spaces || data.groups;
                if (spacesData && Array.isArray(spacesData)) {
                    // Strip productCount — computed dynamically, not stored
                    const stripped = spacesData.map(({ productCount, ...rest }) => rest);
                    setSpaces(stripped);
                    // ★ Update saved-snapshot baseline so saveToCloud diffs correctly
                    lastSavedSnapshotRef.current.groups = JSON.stringify(sanitizeForFirestore({ groups: stripped }));
                }
                // Per-browser isolation: activeTab + sort prefs loaded from
                // localStorage — don't restore from Firestore here, otherwise
                // multiple Chrome profiles would cross-sync UI state.
                // ★ v3.0.0 Fasa 6: Restore custom groups
                if (data.customWorkspaceGroups && Array.isArray(data.customWorkspaceGroups)) {
                    setCustomGroups(data.customWorkspaceGroups);
                }
                if (data.extensionSettings) {
                    const s = data.extensionSettings;
                    /* ★ v3.9.2 — medan LARIAN dari cloud hanya diterima sebagai BENIH
                       kali pertama (browser ini belum ada rekod sendiri). Selepas itu
                       ia diabaikan: pilihan set/mod browser lain TIDAK lagi menukar
                       pilihan browser ini secara senyap (punca aduan multi-browser
                       2026-08-25). Benih terus ditulis ke localStorage supaya muat
                       semula berikutnya tidak menerima cloud lagi. */
                    if (!runConfigSediaRef.current) {
                        /* Penanda "datang dari cloud" HANYA semasa benih — dulu ia dipasang
                           pada SETIAP snapshot, dan effect auto-save memakan satu perubahan
                           pengguna setiap kali (skip + reset). Selepas pagar per-browser,
                           snapshot berulang tidak lagi mengubah state larian, jadi penanda
                           yang tertinggal akan menelan klik pengguna yang berikutnya. */
                        isSettingsFromCloudRef.current = true;
                        if (Array.isArray(s.automationTargetSets)) setAutomationTargetSets(s.automationTargetSets);
                        if (Array.isArray(s.tiktokTargetSets)) setTiktokTargetSets(s.tiktokTargetSets);
                        if (s.isPostOnly !== undefined) setIsPostOnly(s.isPostOnly);
                        if (s.isShowcaseOnly !== undefined) setIsShowcaseOnly(s.isShowcaseOnly);
                        if (s.isImageOnly !== undefined) setIsImageOnly(s.isImageOnly);
                        if (s.isShowcaseMode !== undefined) setIsShowcaseMode(s.isShowcaseMode);
                        if (s.flowProjectUrl !== undefined) setFlowProjectUrl(s.flowProjectUrl);
                        // Cloud boleh bawa nilai LAMA (omni_flash_8s) atau baharu — leraikan sekali.
                        const _fmSeed = leraiModVideoLama(s.flowUltraMode, s.flowVideoDuration, s.flowIngredientsMode);
                        if (s.flowUltraMode !== undefined) {
                            setFlowUltraMode(_fmSeed.model);
                            setFlowVideoDuration(_fmSeed.duration);
                            setFlowIngredientsMode(_fmSeed.ingredients);
                        }
                        if (s.flowImageModel !== undefined) setFlowImageModel(s.flowImageModel);
                        if (s.flowVideoResolution !== undefined) setFlowVideoResolution(normResolusiVideo(s.flowVideoResolution));
                        if (s.flowWorkflow !== undefined) setFlowWorkflow(normWorkflow(s.flowWorkflow));
                        if (s.flowDownloadSize !== undefined) setFlowDownloadSize(normSaizVideo(s.flowDownloadSize));
                        runConfigSediaRef.current = true;
                        tulisRunConfigLokal({
                            automationTargetSets: Array.isArray(s.automationTargetSets) ? s.automationTargetSets : ['set1', 'set2', 'set3'],
                            tiktokTargetSets: Array.isArray(s.tiktokTargetSets) ? s.tiktokTargetSets : ['set1'],
                            isPostOnly: s.isPostOnly === true,
                            isShowcaseOnly: s.isShowcaseOnly === true,
                            isImageOnly: s.isImageOnly === true,
                            isShowcaseMode: s.isShowcaseMode !== false,
                            flowProjectMode: 'same_project',
                            flowProjectUrl: typeof s.flowProjectUrl === 'string' ? s.flowProjectUrl : '',
                            flowUltraMode: _fmSeed.model,
                            flowVideoDuration: _fmSeed.duration,
                            flowIngredientsMode: _fmSeed.ingredients,
                            flowVideoResolution: normResolusiVideo(s.flowVideoResolution),
                            flowWorkflow: normWorkflow(s.flowWorkflow),
                            flowDownloadSize: normSaizVideo(s.flowDownloadSize),
                            flowImageModel: typeof s.flowImageModel === 'string' ? s.flowImageModel : 'Nano Banana Pro',
                        });
                        console.log('[WorkspaceView] ★ Benih tetapan larian dari cloud → disimpan per-browser');
                    }
                    // ★ Admin: trust Firestore. Non-admin: paksa true + auto-heal legacy false.
                    //   (SENGAJA di LUAR pagar per-browser — ia tetapan akaun, bukan pilihan larian.)
                    {
                        const _isAdmin = getUserRole(auth.currentUser?.email) === ROLES.ADMIN;
                        if (_isAdmin) {
                            if (s.isMultipleBrowserMode !== undefined) setIsMultipleBrowserMode(s.isMultipleBrowserMode);
                        } else {
                            setIsMultipleBrowserMode(true);
                            if (s.isMultipleBrowserMode === false && auth.currentUser?.uid) {
                                setDoc(doc(db, 'users', auth.currentUser.uid), { extensionSettings: { isMultipleBrowserMode: true } }, { merge: true })
                                    .then(() => console.log('[Workspace] Auto-healed legacy isMultipleBrowserMode=false → true'))
                                    .catch(err => console.warn('[Workspace] Auto-heal failed:', err));
                            }
                        }
                    }
                    if (s.postTiktokAfterFlow !== undefined) setPostTiktokAfterFlow(s.postTiktokAfterFlow);
                }
            }
        }, (error) => {
            console.error('Settings Error:', error);
        });

        // ★ One-time status sync: fix status mismatch from legacy bug
        // (handleRunFlow/handleRunTikTok wrote status to user doc instead of subcollection)
        syncStatusFromUserDoc(auth.currentUser.uid).catch(err => {
            console.warn('[WorkspaceView] Status sync failed (non-critical):', err.message);
        });

        // ★ One-time metadata recovery: match recovered products with productLibrary
        recoverProductMetadata(auth.currentUser.uid).then(result => {
            if (result.recovered > 0) console.log(`[WorkspaceView] ✅ Recovered metadata for ${result.recovered} products`);
            if (result.unmatched > 0) console.warn(`[WorkspaceView] âš ï¸ ${result.unmatched} products could not be matched`);
        }).catch(err => {
            console.warn('[WorkspaceView] Metadata recovery failed (non-critical):', err.message);
        });

        return () => { unsubProducts(); unsubSettings(); };
    }, []);;

    // Sync activeSet with lockedSet prop when it changes
    useEffect(() => {
        setActiveSet(lockedSet);
    }, [lockedSet]);

    // Handle Lock Set Change
    const handleSetLockChange = (newSet) => {
        onSetLockChange(newSet);
    };

    // ? Auto-save sticker bar settings to Firestore (sync with extension)
    useEffect(() => {
        // Skip if this change came from Firestore onSnapshot (prevents write-back loop)
        if (isSettingsFromCloudRef.current) {
            isSettingsFromCloudRef.current = false;
            return;
        }

        /* ★ [2026-09-13] BAIKI "link project + tetapan larian hilang selepas refresh" (aduan user).
           Pusingan ini berjalan dalam commit yang SAMA dengan pemulihan di atas, jadi ia masih membawa
           nilai LALAI render pertama. Dahulu ia terus menulis lalai itu ke simpanan browser. Dalam
           mod pembangunan (localhost) React StrictMode menjalankan langkah pembukaan DUA kali: pemulihan
           kali kedua membaca lalai yang baru ditulis → link project, set, model, resolusi kembali ke asal
           SETIAP kali refresh — dan salinan Firestore turut ditulis lalai. Disahkan dengan ujian React 19
           sebenar pada localhost 2026-09-13 (StrictMode: hilang · tanpa StrictMode: kekal).
           Pembetulan: langkau pusingan basi ini SAHAJA (termasuk tulisan Firestore); render seterusnya
           membawa nilai yang dipulihkan dan menyimpannya seperti biasa. */
        if (runConfigSediaRef.current === 'menunggu') {
            runConfigSediaRef.current = true;
            return;
        }

        if (!auth.currentUser) return;

        /* ★ v3.9.2 — simpan pilihan larian browser INI (per-browser). Hanya selepas
           benih/pemulihan selesai: sebelum itu, effect ini berjalan pada mount dengan
           nilai LALAI, dan menyimpannya akan mengunci browser pada lalai sebelum
           tetapan sebenar pelanggan sempat tiba (perangkap sama seperti
           `sesaat_products_paparan_v2` — lihat CLAUDE.md seksyen 🧾). */
        if (runConfigSediaRef.current) {
            tulisRunConfigLokal({
                automationTargetSets, tiktokTargetSets, isPostOnly, isShowcaseOnly,
                isImageOnly, isShowcaseMode, flowProjectMode,
                flowProjectUrl, flowUltraMode, flowVideoDuration, flowIngredientsMode, flowVideoResolution, flowDownloadSize, flowWorkflow, flowImageModel,
            });
        }

        const timer = setTimeout(async () => {
            try {
                const docRef = doc(db, 'users', auth.currentUser.uid);
                await setDoc(docRef, sanitizeForFirestore({
                    extensionSettings: {

                        automationTargetSets,
                        tiktokTargetSets,
                        isPostOnly,
                        isShowcaseOnly,
                        isImageOnly,
                        isShowcaseMode,
                        postTiktokAfterFlow,
                        isMultipleBrowserMode,
                        // Keep existing extension fields intact
                        flowProjectMode,
                        flowProjectUrl,
                        flowUltraMode,
                        flowVideoDuration,
                        flowIngredientsMode,
                        flowVideoResolution,
                        flowDownloadSize,
                        flowWorkflow,
                        flowImageModel,
                        isAutoSaveCloud: isMultipleBrowserMode,
                        isAutoDownloadLocal: false
                    }
                }), { merge: true });
                console.log('[StickerBar] Settings synced to Firestore');
            } catch (err) {
                console.error('[StickerBar] Failed to sync settings:', err);
            }
        }, 1000); // 1 second debounce

        return () => clearTimeout(timer);
    }, [automationTargetSets, tiktokTargetSets, isPostOnly, isShowcaseOnly, isImageOnly, isShowcaseMode, flowProjectMode, flowProjectUrl, flowUltraMode, flowVideoDuration, flowIngredientsMode, flowVideoResolution, flowDownloadSize, flowWorkflow, flowImageModel, postTiktokAfterFlow, isMultipleBrowserMode]);

    // ★ Subscribe to system_spaces/ai8saat for centralized default logic (real-time)
    useEffect(() => {
        const systemSpaceRef = doc(db, 'system_spaces', 'ai8saat');
        const unsubscribe = onSnapshot(systemSpaceRef, (docSnap) => {
            if (docSnap.exists()) {
                const data = docSnap.data();
                if (data.defaultLogicId) {
                    setSystemDefaultLogicId(data.defaultLogicId);
                }
            }
        });
        return () => unsubscribe();
    }, []);

    // Load Logic Options — from shared system_spaces for system spaces, user's own for custom
    useEffect(() => {
        if (!auth.currentUser) return;

        const currentSpace = spaces.find(s => s.id === selectedSpaceId);
        const isSystemSpace = currentSpace?.isSystem;

        // Determine which Firestore path to read personas from
        const personasPath = isSystemSpace
            ? `system_spaces/${selectedSpaceId === 'default' ? 'ai8saat' : selectedSpaceId}/personas`
            : `users/${auth.currentUser.uid}/personas`;

        console.log('[WorkspaceView] Loading personas from:', personasPath, '(isSystem:', isSystemSpace, ')');

        const personasRef = collection(db, ...personasPath.split('/'));
        const unsubscribe = onSnapshot(personasRef, (snapshot) => {
            const options = snapshot.docs.map(doc => ({
                id: doc.id,
                _isSystem: isSystemSpace || false,
                ...doc.data()
            }));
            setLogicOptions(options);
            if (options.length > 0 && !selectedLogicId) {
                // ★ For system spaces: use centralized defaultLogicId from system_spaces
                const defaultId = isSystemSpace ? systemDefaultLogicId : options[0].id;
                const hasDefault = options.find(o => o.id === defaultId);
                setSelectedLogicId(hasDefault ? defaultId : options[0].id);
            }
            console.log('[WorkspaceView] Loaded', options.length, 'personas:', options.map(o => o.name).join(', '));
        }, (error) => {
            console.error('Logic Options Error:', error);
        });

        return () => unsubscribe();
    }, [selectedSpaceId, spaces, systemDefaultLogicId]);

    // ★ Sanitize data for Firestore — removes undefined values recursively
    // Fields to strip from Firestore saves — these are large AI response dumps
    // that bloat the document size. They're kept in React state for viewing but
    // don't need to be persisted. rawOutput alone can be 10KB+ per product.
    const STRIP_FIELDS = new Set([
        '_webResearch', '_analysis', '_videoPromptFull',
        'isGenerating', 'generatingStatus', 'generationFailed',
        // ★ Per-browser isolation: checkbox selection is UI state — don't sync
        // across Chrome profiles via Firestore. Browser B's selections stay
        // independent of Browser A's.
        'selected',
        // ★ NEVER persist these — they're either UI-only or break Firestore size limits
        'imageBase64',          // inline base64 image — must live in Storage as imageUrl
        'imagePreview',         // UI-only preview field
        '_isOrphanRecovered',   // UI tag added by productService on read
        '_detailLoaded',        // ★ SPLIT V2: flag view-layer dari mergeDetailIntoProduct
    ]);

    // ★ COST-FIX (satu pusat, scoped 2026-07): rawOutput = salinan bertindih teks `prompts`
    //   (~11KB/doc ≈ 30% saiz dokumen) yang di-egress berjuta kali oleh feed listener.
    //   Untuk module PIPELINE, modal Full Prompt susun paparan semula dari `prompts`
    //   (promptsToJson) — salinan tak perlu ke Firestore. FLOWNITY & Smart Custom
    //   DIKECUALIKAN buat masa ini (modal mereka = tempat paste/scrape ChatGPT; tunggu
    //   fungsi susun generic di extension siap dalam release akan datang).
    const RAWOUT_KEEP_MODULES = new Set(['flownity', 'smartcustom']);
    const stripRawOutputIfPipeline = (obj) => {
        if (obj && !RAWOUT_KEEP_MODULES.has(String(obj.moduleId || '').toLowerCase())) delete obj.rawOutput;
    };

    const sanitizeForFirestore = (data) => {
        if (data === undefined) return null;
        if (data === null || typeof data !== 'object') return data;
        if (Array.isArray(data)) return data.map(item => sanitizeForFirestore(item));
        // ★ FIX (SPLIT V2 audit 2026-07): lepaskan objek SDK Firestore as-is
        //   (serverTimestamp/Timestamp/FieldValue) — jangan lebur jadi map sampah.
        if (data.constructor && data.constructor !== Object) return data;
        const cleaned = {};
        for (const [key, value] of Object.entries(data)) {
            if (value !== undefined && !STRIP_FIELDS.has(key)) {
                cleaned[key] = sanitizeForFirestore(value);
            }
        }
        return cleaned;
    };

    // Save products to Firestore — uses subcollection with diff + retry + token refresh
    // ★ Reliability principles (per feedback memory: save WAJIB jadi):
    //   1. Diff against last-saved snapshot — write ONLY changed products (small payload)
    //   2. Retry transient failures up to 3x with backoff + force token refresh
    //   3. Surface error to user if all retries fail (never silent)
    //   4. Update snapshot only AFTER server confirms success
    const SAVE_MAX_ATTEMPTS = 3;
    // Returns { ok: true } on success / no-op, { ok: false, error } on hard failure.
    // Callers that need to react to save failure (e.g. delete-video flow) can await + branch.
    const saveToCloud = async (updatedProducts) => {
        if (!auth.currentUser) return { ok: false, error: new Error('Not authenticated') };

        setIsSaving(true);
        setSaveStatus('saving');
        setSaveError(null);

        // ── Diff: compute which products actually changed vs last saved ──
        const changed = [];
        const cleanedById = new Map(); // for snapshot update post-success
        for (const p of updatedProducts) {
            if (!p || !p.id) continue;
            const cleaned = { ...p };
            for (const f of STRIP_FIELDS) delete cleaned[f];
            stripRawOutputIfPipeline(cleaned);
            const sanitized = sanitizeForFirestore(cleaned);
            const json = JSON.stringify(sanitized);
            if (lastSavedSnapshotRef.current.products.get(p.id) !== json) {
                changed.push(sanitized);
                cleanedById.set(p.id, json);
            }
        }

        // ── Diff: spaces ──
        const spacesPayload = sanitizeForFirestore({ groups: spaces });
        const spacesJson = JSON.stringify(spacesPayload);
        const spacesChanged = lastSavedSnapshotRef.current.groups !== spacesJson;

        // Nothing to save? Bail without API call.
        if (changed.length === 0 && !spacesChanged) {
            setSaveStatus('idle');
            setIsSaving(false);
            return { ok: true, noop: true };
        }

        let lastErr = null;
        for (let attempt = 1; attempt <= SAVE_MAX_ATTEMPTS; attempt++) {
            try {
                // On retry: force refresh auth token (handles ~60min expiry mid-session)
                if (attempt > 1) {
                    setSaveStatus(`retry ${attempt}/${SAVE_MAX_ATTEMPTS}`);
                    try { await auth.currentUser.getIdToken(true); }
                    catch (e) { console.warn('[AutoSave] Token refresh on retry failed:', e.message); }
                }

                if (changed.length > 0) {
                    await saveProducts(auth.currentUser.uid, changed);
                }
                if (spacesChanged) {
                    const docRef = doc(db, 'users', auth.currentUser.uid);
                    await setDoc(docRef, spacesPayload, { merge: true });
                }

                // ── Success: update snapshot so next call diffs correctly ──
                for (const [id, json] of cleanedById) {
                    lastSavedSnapshotRef.current.products.set(id, json);
                }
                if (spacesChanged) {
                    lastSavedSnapshotRef.current.groups = spacesJson;
                }

                setSaveStatus('saved');
                setSaveError(null);
                setTimeout(() => setSaveStatus(prev => prev === 'saved' ? 'idle' : prev), 2000);
                setIsSaving(false);
                if (attempt > 1) console.log(`[AutoSave] ✅ Recovered on attempt ${attempt}`);
                return { ok: true };
            } catch (err) {
                lastErr = err;
                console.warn(`[AutoSave] Attempt ${attempt}/${SAVE_MAX_ATTEMPTS} failed:`, err?.code || '', err?.message || err);
                if (attempt < SAVE_MAX_ATTEMPTS) {
                    await new Promise(r => setTimeout(r, attempt * 1000)); // 1s, 2s
                }
            }
        }

        // ── All retries exhausted: surface error + clipboard safety net ──
        console.error('[AutoSave] ❌ FAILED after all retries:', lastErr);
        setSaveStatus('error');
        setSaveError({
            message: lastErr?.message || 'Unknown error',
            code: lastErr?.code || null,
            attemptedAt: new Date(),
            changedCount: changed.length,
        });
        setIsSaving(false);

        // Best-effort: copy unsaved edits to clipboard so user doesn't lose work on reload
        try {
            const safetyPayload = JSON.stringify({
                _meta: { savedAt: new Date().toISOString(), uid: auth.currentUser?.uid, count: changed.length },
                products: changed,
            }, null, 2);
            await navigator.clipboard.writeText(safetyPayload);
            console.log('[AutoSave] Unsaved edits copied to clipboard as safety backup');
        } catch (e) {
            console.warn('[AutoSave] Could not auto-copy edits to clipboard:', e.message);
        }

        return { ok: false, error: lastErr };
    };

    // Save only selected products to cloud (manual — triggered by user)
    const handleSaveSelectedToCloud = async () => {
        if (!auth.currentUser) return;
        const selected = filteredAndSortedProducts.filter(p => p.selected);
        if (selected.length === 0) return;
        setIsSaving(true);
        setSaveStatus('saving');

        // ★★ DASAR VIDEO CLOUD (restructure 2026-08-23) — SATU peraturan, SEMUA module (cermin
        //    extension routeVideoToWarehouse). R2 HIDUP → semua push ke R2 (≤50MB; had 300/hari +
        //    5GB dijaga SERVER; video yang lebih besar / lepas had kekal dalam browser, masih boleh
        //    di-post). R2 MATI → SEMUA kekal local — webapp TIDAK menulis Firebase baru (gudang
        //    lama read-only). Concept "local-only module" sudah DIBUANG: kekal-local kini semata
        //    bergantung suis R2 (had ≤50MB pindah ke dalam pintu `uploadVideoToWarehouse`).
        const videoStaysLocal = () => !isR2Enabled();

        try {
            // ═══ STEP 0: Push video yg masih local:// → Cloud (on-demand) ═══
            // Bytes duduk dlm extension → minta via bridge requestLocalVideo, upload ke cloud.
            let pushedCount = 0, extMissingCount = 0, localKeptCount = 0, quotaKeptCount = 0;
            const videoUrlUpdates = new Map(); // `${pid}::${setKey}` → cloud URL
            // ★ POSTER (2026-08-26): laluan ini dulu menaikkan video ke cloud TANPA gambar
            //   kad, jadi kad kekal kotak kosong sampai pengguna menekan preview. Bytes
            //   video sudah ada di tangan di sini, jadi posternya percuma.
            const posterUpdates = new Map(); // `${pid}::${setKey}` → URL poster
            for (const p of selected) {
                if (!p.id) continue;
                const prompts = p.prompts || {};
                const stayLocal = videoStaysLocal();
                for (const setKey of Object.keys(prompts)) {
                    const v = prompts[setKey]?.uploadedVideo;
                    if (typeof v !== 'string' || !v.startsWith('local://')) continue;
                    if (stayLocal) { localKeptCount++; continue; } // R2 mati → kekal local (tiada Firebase baru)
                    const _pushKey = `${p.id}::${setKey}`;
                    setCloudPushingKeys(prev => { const n = new Set(prev); n.add(_pushKey); return n; }); // ★ denyut hijau ON
                    try {
                        const dataUrl = await requestLocalVideo(p.id, setKey); // base64 data URL
                        const blob = await (await fetch(dataUrl)).blob();
                        // ★ PINTU PUSAT: R2 sahaja (≤50MB; kaunter simpanan diurus SERVER masa keluar
                        //   pas). Video >50MB / lepas had 300 / simpanan penuh → pintu LEMPAR → kekal local.
                        const { url } = await uploadVideoToWarehouse(blob, { productId: p.id, setKey });
                        videoUrlUpdates.set(`${p.id}::${setKey}`, url);
                        pushedCount++;
                        /* ★ Gambar kad — diambil daripada blob yang SAMA (0 muat turun).
                           Path `_thumb.jpg` TETAP, jadi ia menindih fail lama dan tidak
                           menambah simpanan; ia juga tidak melalui pintu pas video, jadi
                           ia tidak memakan had 300 video/hari. Gagal = kekal tiada gambar,
                           JANGAN gagalkan simpanan video kerananya. */
                        try {
                            const _posterSrc = URL.createObjectURL(blob);
                            let _posterBlob;
                            try {
                                const _kanvas = await tangkapPosterVideo(_posterSrc, { maksLebar: 360 });
                                _posterBlob = await new Promise(r => _kanvas.toBlob(b => r(b), 'image/jpeg', 0.7));
                            } finally { URL.revokeObjectURL(_posterSrc); }
                            if (_posterBlob && auth.currentUser) {
                                const _posterRef = fbRef(storage, `videos/${auth.currentUser.uid}/${p.id}/${setKey}_thumb.jpg`);
                                await uploadBytes(_posterRef, _posterBlob, { contentType: 'image/jpeg', cacheControl: 'public, max-age=604800' });
                                posterUpdates.set(`${p.id}::${setKey}`, await getDownloadURL(_posterRef));
                            }
                        } catch (_pe) {
                            console.warn(`[SaveSelected] Poster gagal ${p.id}/${setKey} (tidak kritikal):`, _pe?.message || _pe);
                        }
                    } catch (e) {
                        // Bezakan DUA kegagalan yang maksudnya bertentangan:
                        //  · cloud tolak / video >50MB / lepas had = keadaan biasa, video kekal
                        //    dalam browser dan masih boleh di-post;
                        //  · extension tiada / bytes tak dijumpai = pengguna kena buka browser
                        //    yang betul. Menyatukan dua-duanya menyuruh pengguna membaiki benda salah.
                        const kod = e?.videoCode || String(e?.code || '');
                        if (kod === 'oversize' || kod === 'r2-off' || kod.includes('resource-exhausted')) {
                            quotaKeptCount++;
                            console.warn(`[SaveSelected] Video kekal local (${kod}) ${p.id}/${setKey}:`, e?.message || e);
                        } else {
                            extMissingCount++;
                            console.warn(`[SaveSelected] Push video local→cloud gagal ${p.id}/${setKey}:`, e?.message || e);
                        }
                    } finally {
                        setCloudPushingKeys(prev => { const n = new Set(prev); n.delete(_pushKey); return n; }); // ★ denyut hijau OFF
                    }
                }
            }

            // Terapkan URL cloud baru ke salinan produk (belum setProducts — elak race auto-save)
            let workingProducts = products;
            if (videoUrlUpdates.size > 0 || posterUpdates.size > 0) {
                workingProducts = products.map(p => {
                    let changedP = false;
                    const nextPrompts = { ...(p.prompts || {}) };
                    for (const setKey of Object.keys(nextPrompts)) {
                        const key = `${p.id}::${setKey}`;
                        if (videoUrlUpdates.has(key)) {
                            nextPrompts[setKey] = { ...nextPrompts[setKey], uploadedVideo: videoUrlUpdates.get(key) };
                            changedP = true;
                        }
                        if (posterUpdates.has(key)) {
                            nextPrompts[setKey] = { ...nextPrompts[setKey], uploadedVideoThumb: posterUpdates.get(key) };
                            changedP = true;
                        }
                    }
                    return changedP ? { ...p, prompts: nextPrompts } : p;
                });
            }

            // ═══ STEP 1: Diff vs snapshot + simpan (guna workingProducts supaya URL cloud baru ikut) ═══
            const selectedIds = new Set(selected.map(p => p.id));
            const changed = [];
            const cleanedById = new Map();
            for (const p of workingProducts) {
                if (!p.id || !selectedIds.has(p.id)) continue;
                const cleaned = { ...p };
                for (const f of STRIP_FIELDS) delete cleaned[f];
                stripRawOutputIfPipeline(cleaned);
                const sanitized = sanitizeForFirestore(cleaned);
                const json = JSON.stringify(sanitized);
                if (lastSavedSnapshotRef.current.products.get(p.id) !== json) {
                    changed.push(sanitized);
                    cleanedById.set(p.id, json);
                }
            }
            if (changed.length > 0) {
                await saveProducts(auth.currentUser.uid, changed);
                for (const [id, json] of cleanedById) {
                    lastSavedSnapshotRef.current.products.set(id, json);
                }
            }
            // setProducts SELEPAS save + snapshot dikemas kini → auto-save nampak no-change (no double write)
            if (videoUrlUpdates.size > 0) setProducts(workingProducts);

            setSaveStatus('saved');
            setTimeout(() => setSaveStatus('idle'), 2000);

            // ★ Notif jelas
            if (pushedCount > 0) toast.success(T('ws.toast.videoPushed', `${pushedCount} video dimuat naik ke Cloud`, { n: pushedCount }));
            if (localKeptCount > 0) toast.info(T('ws.toast.videoKeptLocal', `💾 ${localKeptCount} video kekal dalam browser ini — simpanan video Cloud tidak tersedia buat masa ini. Video tidak hilang: ia masih boleh di-post ke TikTok dari browser ini.`, { n: localKeptCount }));
            if (quotaKeptCount > 0) toast.info(T('ws.toast.videoQuotaKept', `💾 ${quotaKeptCount} video kekal dalam browser ini — had cloud harian sudah cukup, simpanan penuh, atau video melebihi 50MB. Ia masih boleh di-post ke TikTok dari browser ini.`, { n: quotaKeptCount }));
            if (extMissingCount > 0) toast.warning(T('ws.toast.videoPushFailed', `${extMissingCount} video tak dapat dimuat naik — buka di browser yang ada Extension SESAAT aktif.`, { n: extMissingCount }));
        } catch (err) {
            console.warn('[SaveSelected] Failed:', err.message);
            setSaveStatus('idle');
        } finally {
            setIsSaving(false);
        }
    };

    // ★ R2 suis (Fasa 2) — subscribe sekali (fail-closed → OFF kalau rules tolak baca).
    useEffect(() => { subscribeR2Config(); }, []);

    // Auto-save products to Cloud
    // Skip if the update came from onSnapshot (prevents Firestore write-back loop)
    useEffect(() => {
        if (isFromCloudRef.current) {
            isFromCloudRef.current = false; // Reset for next change
            return;
        }

        const timer = setTimeout(() => {
            if (products.length > 0) {
                saveToCloud(products);
            }
        }, 2000); // 2 second debounce

        return () => clearTimeout(timer);
    }, [products]);

    const saveSpacesToCloud = async (updatedSpaces) => {
        if (!auth.currentUser) return;
        setIsSaving(true);
        try {
            // Strip productCount (computed display-only) before saving to Firestore
            const cleanSpaces = updatedSpaces.map(({ productCount, ...rest }) => rest);
            const docRef = doc(db, 'users', auth.currentUser.uid);
            await setDoc(docRef, sanitizeForFirestore({ groups: cleanSpaces }), { merge: true });
        } catch (err) {
            console.error('Save Spaces Error:', err);
        } finally {
            setIsSaving(false);
        }
    };

    // Parse input text
    const handleParseInput = async () => {
        const inputText = spaceInputs[selectedSpaceId] || '';
        if (!inputText.trim()) {
            alert(T('ws.input.empty', 'Sila masukkan data produk.'));
            return;
        }

        const lines = inputText.trim().split('\n').filter(line => line.trim());
        const newProducts = [];

        lines.forEach((line, index) => {
            const parts = line.split('*|*').map(s => s.trim().replace(/^['"]+|['"]+$/g, ''));

            let name = parts[0];
            let link = '';
            let imageSrc = '';
            let parsedIndex;

            if (!/^\d+$/.test(parts[0])) {
                const match = parts[0].match(/^(\d+)[.)]\s+(.*)/);
                if (match) {
                    parsedIndex = parseInt(match[1]);
                    name = match[2];
                }
            }

            const isIndexFirst = /^\d+$/.test(parts[0]);

            if (isIndexFirst && parts.length >= 2) {
                parsedIndex = parseInt(parts[0]);
                name = parts[1];
                imageSrc = parts[2] || '';
                link = parts[3] || '';
            } else if (!isIndexFirst && !parsedIndex) {
                link = parts[1] || '';
                imageSrc = parts[2] || '';
            } else if (parsedIndex && !isIndexFirst) {
                link = parts[1] || '';
                imageSrc = parts[2] || '';
            }

            if (parsedIndex === undefined) {
                const idMatch = name.match(/(\d+)/);
                if (idMatch) {
                    parsedIndex = parseInt(idMatch[1], 10);
                }
            }

            if (!imageSrc && link) {
                const lowerLink = link.toLowerCase();
                const isPathLike = lowerLink.match(/^[a-z]:\\/i) || lowerLink.startsWith('/') || lowerLink.match(/\.(png|jpg|jpeg|webp|gif|bmp)$/i);
                const isUrl = lowerLink.startsWith('http://') || lowerLink.startsWith('https://');

                if (isPathLike && !isUrl) {
                    imageSrc = link;
                    link = '';
                }
            }

            let imageBase64 = null;
            let imageUrl = null;

            if (imageSrc && imageSrc.startsWith('http')) {
                imageUrl = imageSrc;
            } else if (imageSrc && imageSrc.startsWith('data:')) {
                imageBase64 = imageSrc;
            }

            newProducts.push({
                id: `prod_${Date.now()}_${index}_${Math.random().toString(36).substring(2, 9)}`,
                originalIndex: parsedIndex || products.length + index + 1,
                name,
                link,
                imageBase64,
                imageUrl,
                localImagePath: imageSrc || null,
                prompts: getEmptyPromptCollection(),
                selectedSets: ['set1', 'set2', 'set3'],
                logs: [],
                selected: true,
                // P6.3 — Smart Custom manual add tiada prompts → start dari 'chatgpt' tab
                tab: (propActiveModuleId === 'smartcustom' || propActiveModuleId === 'flownity') ? 'chatgpt' : 'flow',
                spaceId: selectedSpaceId === 'default' ? null : selectedSpaceId,
                logicId: selectedLogicId || (logicOptions.length > 0 ? logicOptions[0].id : null) || spaces.find(s => s.id === selectedSpaceId)?.settings?.defaultLogicId || null
            });
        });

        // Set loading overlay on products that will be auto-generated
        // ★ FLOWNITY: pipeline OFF — produk ditambah sebagai card KOSONG, TIADA auto-generate/loading
        // (module guna scrape JSON dari Gem/ChatGPT). Skip isGenerating + auto-gen sepenuhnya.
        // ★ WAJIB ADA DATA (2026-07-28): produk tanpa data scrape TIDAK dijana (lihat
        //   hasGenerationData) — kad ditambah kosong, user boleh import semula guna Extension.
        const productsToGenerate = (propActiveModuleId === 'flownity' || propActiveModuleId === 'smartcustom')
            ? []
            : newProducts.filter(p => p.logicId && hasGenerationData(p));
        const skippedNoData = (propActiveModuleId === 'flownity' || propActiveModuleId === 'smartcustom')
            ? 0
            : newProducts.filter(p => p.logicId && !hasGenerationData(p)).length;
        productsToGenerate.forEach(p => {
            p.isGenerating = true;
            p.generatingStatus = {
                /* ⛔ `phase` = nilai yang dibanding oleh kod paparan — JANGAN terjemah.
                   Hanya `detail` ialah ayat yang dibaca pelanggan. */
                phase: 'starting',
                detail: T('ws.gen.initializing', 'Initializing...'),
                stepIndex: 0,
                totalSteps: 3,
                hasImage: !!(p.imageBase64 || p.imageUrl),
                steps: []
            };
        });

        const updated = [...products, ...newProducts];
        setProducts(updated);
        // Clear input for THIS space only
        setSpaceInputs(prev => ({ ...prev, [selectedSpaceId]: '' }));
        saveToCloud(updated);

        // ⛔ [2026-08-26] Tulisan `users.productLibrary` DIBUANG (fungsi ini pun tiada pemanggil).
        // ★ Beritahu user produk mana yang tak dijana sebab tiada data (elak "kenapa diam je?")
        if (skippedNoData > 0) {
            alert(T('ws.input.skippedNoData', `${skippedNoData} produk ditambah tetapi TIDAK dijana kerana tiada data produk.\n\nSila import produk menggunakan butang Import di dalam Extension SESAAT, kemudian tarik masuk semula ke Workspace.`, { n: skippedNoData }));
        }

        // STAGGERED CONCURRENT: Fire each API call with 2s delay between starts
        // All run in parallel after their stagger delay — no waiting for completion
        if (productsToGenerate.length > 0) {
            // Pre-flight quota check — warn user if request exceeds remaining cap
            const proceed = await ensureQuotaForBulk(productsToGenerate.length);
            if (!proceed) return;

            const generatePromises = productsToGenerate.map((newProduct, i) =>
                new Promise(resolve => setTimeout(resolve, i * 2000))
                    .then(() => generateForProduct(newProduct.id, newProduct.logicId, newProduct))
                    .catch(err => console.error(`[AutoGen] Failed for "${newProduct.name}":`, err))
            );
            Promise.allSettled(generatePromises);
        }

        if (newProducts.length > 0) {
            setSelectedProductId(newProducts[0].id);
        }
    };



    // ★ COST-FIX (kaunter storage, 2026-07): fungsi scan `calculateStorageUsed`
    //   (listAll + getMetadata SETIAP fail, jalan on-mount) DIBUANG dari sini —
    //   ia antara punca 126 JUTA Storage ops/bln (RM849). Bar kini baca
    //   `storageUsedBytes` terus dari user doc (listener settings di atas);
    //   upload → bumpStorageCounter(); butang Optimize (App.jsx) recount + tulis semula.

    // ============================================
    // ★ v3.0.0: Play local video via extension bridge
    // ============================================
    const handlePlayLocalVideo = async (productId, setKey) => {
        setVideoModal({ open: true, blobUrl: null, loading: true, error: null });
        try {
            const base64 = await requestLocalVideo(productId, setKey, tAnak);
            const resp = await fetch(base64);
            const blob = await resp.blob();
            const blobUrl = URL.createObjectURL(blob);
            setVideoModal({ open: true, blobUrl, loading: false, error: null });
        } catch (err) {
            setVideoModal({ open: true, blobUrl: null, loading: false, error: err.message });
        }
    };

    // ★ Cache blob modal video (sesi ini sahaja): tonton ulang video sama = 0 muat turun
    //   (dulu <video src=URL> stream terus — setiap tontonan = tarik penuh dari Storage).
    //   Had 12 entri (~40MB); entri tersingkir di-revoke supaya memori tak bocor.
    const cloudVideoCacheRef = useRef(new Map()); // url -> objectURL
    const videoModalReqRef = useRef(0); // pagar race: modal ditutup semasa fetch masih berjalan
    const handlePlayCloudVideo = async (videoUrl, productId = '', setKey = '') => {
        const cache = cloudVideoCacheRef.current;
        if (cache.has(videoUrl)) {
            const objUrl = cache.get(videoUrl);
            setVideoModal({ open: true, blobUrl: objUrl, loading: false, error: null });
            baikiThumbPreview(objUrl, productId, setKey, videoUrl);
            return;
        }
        const req = ++videoModalReqRef.current;
        setVideoModal({ open: true, blobUrl: null, loading: true, error: null });
        try {
            const resp = await fetch(videoUrl);
            if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
            const blob = await resp.blob();
            if (videoModalReqRef.current !== req) return; // modal dah ditutup — jangan buka semula
            const objUrl = URL.createObjectURL(blob);
            if (cache.size >= 12) {
                const oldestKey = cache.keys().next().value;
                URL.revokeObjectURL(cache.get(oldestKey));
                cache.delete(oldestKey);
            }
            cache.set(videoUrl, objUrl);
            setVideoModal({ open: true, blobUrl: objUrl, loading: false, error: null });
            baikiThumbPreview(objUrl, productId, setKey, videoUrl);
        } catch (e) {
            if (videoModalReqRef.current !== req) return;
            // Gagal fetch (offline/CORS) → fallback stream terus dari URL macam perangai lama.
            setVideoModal({ open: true, blobUrl: videoUrl, loading: false, error: null });
        }
    };

    /* ★★ BAIKI THUMBNAIL MASA PREVIEW (2026-08-23) — jawapan kepada kad video
       cloud yang kekal papar placeholder "VIDEO READY" tanpa gambar.

       Poster video dijana SEKALI sahaja, iaitu masa video baru siap. Kalau ia
       gagal ketika itu (video belum habis naik / had percubaan poster tercapai),
       TIADA apa yang pernah cuba lagi — kad itu kekal kosong selamanya.

       Di sini kita ambil peluang PERCUMA: pelanggan yang menekan play sudah pun
       memuat turun video itu ke dalam browser (modal menyimpannya sebagai blob),
       jadi satu bingkai dicilok daripada blob yang SAMA — 0 bait tambahan,
       0 tindakan pelanggan, dan kad terus berisi gambar.

       ⛔ JANGAN jadikan ia automatik untuk kad yang TIDAK dibuka. Itu bermakna
          memuat turun video semata-mata untuk gambar kecil — iaitu punca bil
          video yang paling mahal (siasatan egress 14-19 Ogos). Pemulihan pukal
          untuk video yang tidak pernah ditonton mesti butang yang pelanggan
          tekan sendiri, bukan kerja latar belakang. */
    const thumbBaikiRef = useRef(new Map()); // `${productId}_${setKey}` → bilangan cubaan sesi ini
    const baikiThumbPreview = async (blobUrl, productId, setKey, videoUrl) => {
        // Fetch gagal → modal jatuh ke stream URL terus → canvas jadi "tainted"
        // dan toBlob melempar. Blob sahaja yang selamat ditangkap.
        if (!blobUrl || !String(blobUrl).startsWith('blob:')) return;
        if (!productId || !setKey || !auth.currentUser) return;
        const kunci = `${productId}_${setKey}`;
        const cubaan = thumbBaikiRef.current.get(kunci) || 0;
        if (cubaan >= 2) return; // had 2 cubaan/sesi — elak gelung pada video yang memang tak boleh di-decode
        const semasa = productsRef.current.find(p => p.id === productId);
        const setSemasa = semasa?.prompts?.[setKey];
        if (!setSemasa || setSemasa.uploadedVideo !== videoUrl) return; // video dah bertukar
        /* ★★ 2026-09-10: dulu baris ini berbunyi `if (setSemasa.uploadedVideoThumb) return;`
           — "sudah ada gambar, tak payah buat apa-apa". Itu MENYEKAT pemulihan bagi kes yang
           paling perlu dipulihkan: poster yang WUJUD tetapi HITAM. Extension menjananya dengan
           cara yang salah sehingga v3.9.4 (lihat CLAUDE.md 2026-09-10), jadi ribuan kad membawa
           petak hitam yang jaring ini enggan ganti kerana ia nampak "sudah ada".
           Sekarang poster sedia ada DISEMAK dahulu: bingkai sebenar 360px ≈ 15-60KB, manakala
           poster rosak ialah kanvas kosong ≈ 2KB (diukur: 2,137 bait, MD5 SAMA merentas tiga
           video berbeza). Di bawah ambang itu = rosak, ganti. Kos semakan ~2KB, boleh diabaikan.
           ⛔ Ambang JANGAN dinaikkan tinggi-tinggi: gambar gelap yang SAH pun boleh kecil, dan
              menggantikan poster yang elok bermakna memuat turun video tanpa sebab (punca bil
              egress paling mahal — siasatan 14-19 Ogos). */
        if (setSemasa.uploadedVideoThumb) {
            const AMBANG_POSTER_ROSAK = 4096;   // bait
            let baitPoster = -1;
            try {
                const r = await fetch(setSemasa.uploadedVideoThumb, { method: 'HEAD' });
                const cl = r.headers.get('content-length');
                if (cl) baitPoster = parseInt(cl, 10);
                if (!(baitPoster >= 0)) {        // sesetengah pelayan tak beri panjang pada HEAD
                    const g = await fetch(setSemasa.uploadedVideoThumb);
                    baitPoster = (await g.blob()).size;
                }
            } catch (_) { return; }              // tak dapat disemak → jangan sentuh yang mungkin elok
            if (!(baitPoster >= 0) || baitPoster >= AMBANG_POSTER_ROSAK) return;   // poster elok
            console.log(`[Thumb] poster sedia ada nampak rosak (${baitPoster} bait) — jana semula: ${kunci}`);
        }
        thumbBaikiRef.current.set(kunci, cubaan + 1);
        try {
            await new Promise(r => setTimeout(r, 500)); // biar modal mula main dulu, elak tersekat
            const kanvas = await tangkapPosterVideo(blobUrl, { maksLebar: 360 });
            const blob = await new Promise(r => kanvas.toBlob(b => r(b), 'image/jpeg', 0.7));
            if (!blob) throw new Error('toBlob kosong');
            // ⚠️ Path thumbnail TETAP (ditimpa setiap kali) — sebab itu kaunter simpanan
            //    sengaja TIDAK dinaikkan di sini; menaikkannya pada path yang ditimpa
            //    membuat kaunter menggelembung dan pelanggan tersekat "storage penuh" palsu.
            const rujukan = fbRef(storage, `videos/${auth.currentUser.uid}/${productId}/${setKey}_thumb.jpg`);
            await uploadBytes(rujukan, blob, { contentType: 'image/jpeg', cacheControl: 'public, max-age=604800' });
            const thumbURL = await getDownloadURL(rujukan);
            // ⚠️ Baca state TERKINI, bukan salinan yang ditangkap sebelum decode —
            //    pelanggan mungkin menyunting kad lain sepanjang video dimainkan.
            const terkini = productsRef.current;
            const sasaran = terkini.find(p => p.id === productId);
            if (!sasaran || sasaran.prompts?.[setKey]?.uploadedVideo !== videoUrl) return;
            const seterusnya = terkini.map(p => (p.id !== productId ? p : {
                ...p,
                prompts: {
                    ...(p.prompts || {}),
                    [setKey]: { ...(p.prompts?.[setKey] || {}), uploadedVideoThumb: thumbURL }
                }
            }));
            setProducts(seterusnya);
            await saveToCloud(seterusnya);
            console.log('[Thumb] ✅ Dibaiki masa preview:', kunci);
        } catch (err) {
            console.warn('[Thumb] Baiki masa preview gagal (tidak kritikal):', err?.message || err);
        }
    };

    const closeVideoModal = () => {
        videoModalReqRef.current++; // batalkan fetch yang masih dalam penerbangan
        // Jangan revoke blob yang duduk dalam cache — ia dikitar semula untuk tontonan seterusnya.
        const cachedUrls = new Set(cloudVideoCacheRef.current.values());
        if (videoModal.blobUrl && videoModal.blobUrl.startsWith('blob:') && !cachedUrls.has(videoModal.blobUrl)) {
            URL.revokeObjectURL(videoModal.blobUrl);
        }
        setVideoModal({ open: false, blobUrl: null, loading: false, error: null });
    };

    // ★ Tekan Esc untuk tutup modal preview video (elak banyak klik mouse)
    useEffect(() => {
        if (!videoModal.open) return;
        const onKeyDown = (e) => { if (e.key === 'Escape') closeVideoModal(); };
        window.addEventListener('keydown', onKeyDown);
        return () => window.removeEventListener('keydown', onKeyDown);
    }, [videoModal.open, videoModal.blobUrl]);

    // ============================================
    // HELPER: Delete video file from Firebase Storage (with 1 retry)
    // ============================================
    const deleteVideoFromStorage = async (videoUrl) => {
        // ★ R2 (Fasa 2): video R2 dipadam via server (kunci padam di server sahaja).
        if (isR2Url(videoUrl)) {
            try { await deleteR2Video(videoUrl); return { ok: true }; }
            catch (e) { console.warn('[R2] padam gagal:', e?.message); return { ok: false, error: e }; }
        }
        if (!videoUrl || !videoUrl.includes('firebasestorage.googleapis.com')) return { ok: true, skipped: true };
        const urlObj = new URL(videoUrl);
        const pathMatch = urlObj.pathname.match(/\/o\/(.+?)(\?|$)/);
        if (!pathMatch) return { ok: true, skipped: true };
        const storagePath = decodeURIComponent(pathMatch[1]);
        const storageRef = fbRef(storage, storagePath);

        const attemptDelete = async () => {
            // ★ v3.8.2 (review 2026-07-26): ambil saiz DULU → tolak kaunter selepas padam.
            //   Kaunter `storageUsedBytes` kini jadi GATE had 2GB (extension baca ia ganti
            //   scan penuh) — kalau ia hanya NAIK, user yang padam video kekal tersekat.
            /* ⛔ Poster (`_thumb.jpg`) TIDAK menyentuh kaunter — ia juga tidak pernah
               menaikkannya (lihat nota laluan muat naik). Menolak sesuatu yang tidak
               pernah ditambah menarik meter ke bawah sehingga boleh jadi NEGATIF. */
            const _adalahPoster = /_thumb.jpg$/i.test(storagePath);
            let _sz = 0;
            if (!_adalahPoster) {
                try { _sz = (await getMetadata(storageRef)).size || 0; } catch { /* abaikan */ }
            }
            await deleteObject(storageRef);
            if (_sz > 0 && auth.currentUser) bumpStorageCounter(db, auth.currentUser.uid, -_sz);
        };

        try {
            await attemptDelete();
            console.log(`[Storage] ✓ File deleted: ${storagePath}`);
            return { ok: true };
        } catch (err) {
            // object-not-found = already gone, treat as success
            if (err?.code === 'storage/object-not-found') {
                console.log(`[Storage] File already gone: ${storagePath}`);
                return { ok: true, alreadyGone: true };
            }
            // Retry once after 1s
            console.warn(`[Storage] Delete failed, retrying in 1s:`, err.message);
            await new Promise(r => setTimeout(r, 1000));
            try {
                await attemptDelete();
                console.log(`[Storage] ✓ File deleted (retry): ${storagePath}`);
                return { ok: true };
            } catch (err2) {
                if (err2?.code === 'storage/object-not-found') return { ok: true, alreadyGone: true };
                console.error(`[Storage] Delete failed after retry:`, err2.message);
                return { ok: false, error: err2 };
            }
        }
    };

    // ============================================
    // HELPER: Delete video from Storage + clear from product
    // Order: Firestore save FIRST (source of truth) → only then delete Storage file.
    // If save fails after retries, UI is rolled back and Storage is untouched, so user can retry safely.
    // Returns: { ok: true } | { ok: true, orphaned: true } | { ok: false, error }
    // ============================================
    const handleDeleteVideo = async (product, setKey) => {
        const videoUrl = product.prompts?.[setKey]?.uploadedVideo;
        const thumbUrl = product.prompts?.[setKey]?.uploadedVideoThumb;

        // Snapshot full products for rollback if save fails
        const originalProducts = products;
        const prevSet = { ...(product.prompts?.[setKey] || {}) };

        // 1. Optimistically update UI state
        const clearedPrompts = {
            ...product.prompts,
            [setKey]: { ...prevSet, uploadedVideo: '', uploadedVideoThumb: '' }
        };
        const updated = products.map(p =>
            p.id === product.id ? { ...p, prompts: clearedPrompts } : p
        );
        setProducts(updated);

        // 2. Await Firestore save (saveToCloud has internal 3x retry + token refresh)
        const saveResult = await saveToCloud(updated);
        if (!saveResult?.ok) {
            // Hard failure → rollback UI; do NOT delete Storage file (still intact for retry)
            setProducts(originalProducts);
            return { ok: false, error: saveResult?.error || new Error('Firestore save failed') };
        }

        // 3. Save confirmed → safe to delete actual files (best-effort; orphans are harmless)
        const videoResult = await deleteVideoFromStorage(videoUrl);
        const thumbResult = thumbUrl ? await deleteVideoFromStorage(thumbUrl) : { ok: true };

        // 4. Notify extension to clear video cache (all 3 tiers)
        window.postMessage({
            type: 'SESAAT_CLEAR_VIDEO_CACHE',
            productId: product.id,
            setKey: setKey,
            videoUrl: videoUrl || ''
        }, '*');

        // 5. Refresh storage usage
        window.dispatchEvent(new Event('SESAAT_STORAGE_CHANGED'));

        if (!videoResult.ok || !thumbResult.ok) {
            return { ok: true, orphaned: true };
        }
        return { ok: true };
    };

    // ============================================
    // Open confirm modal (entry point from delete button)
    // ============================================
    const requestDeleteVideo = (product, setKey) => {
        setDeleteConfirm({ open: true, product, setKey, busy: false });
    };

    // ============================================
    // Run delete after confirm
    // ============================================
    const confirmDeleteVideo = async () => {
        const { product, setKey } = deleteConfirm;
        if (!product || !setKey) return;
        setDeleteConfirm(prev => ({ ...prev, busy: true }));
        // Trigger fade-out on the video container
        setDeletingState({ productId: product.id, setKey, fadingOut: true });
        // Brief fade hint (200ms matches CSS transition) — actual save runs after
        await new Promise(r => setTimeout(r, 200));
        try {
            const result = await handleDeleteVideo(product, setKey);
            if (!result?.ok) {
                // Save failed — handleDeleteVideo already rolled back products state.
                // Storage file untouched (safe to retry). Show error + keep modal open.
                const errMsg = result?.error?.message || T('ws.common.tryAgain', 'Cuba lagi');
                toast.error(T('ws.toast.saveFailedVideoRestored', `Save gagal — video dipulihkan. ${errMsg}`, { msg: errMsg }));
                setDeleteConfirm(prev => ({ ...prev, busy: false }));
            } else if (result.orphaned) {
                toast.info(T('ws.toast.videoDeletedOrphan', 'Video dipadam dari database, tapi fail di Storage tak dapat dialih keluar — akan dibersihkan automatik kemudian'));
                setDeleteConfirm({ open: false, product: null, setKey: null, busy: false });
            } else {
                toast.success(T('ws.toast.videoDeleted', 'Video berjaya dipadam'));
                setDeleteConfirm({ open: false, product: null, setKey: null, busy: false });
            }
        } catch (err) {
            console.error('[Delete Video] Failed:', err);
            const sebabPadam = err.message || T('ws.common.tryAgain', 'Cuba lagi');
            toast.error(T('ws.toast.videoDeleteFailed', `Gagal padam video: ${sebabPadam}`, { msg: sebabPadam }));
            setDeleteConfirm(prev => ({ ...prev, busy: false }));
        } finally {
            // Always clear fade state — if rollback happened, products has the video URL back,
            // so the container re-renders with full opacity once fadingOut flips off.
            setDeletingState({ productId: null, setKey: null, fadingOut: false });
        }
    };

    // ============================================
    // ★ BULK PRODUCT DELETE — actually frees cloud storage
    //   Old bulk "Delete" removed only Firestore docs → video files stayed
    //   orphaned in Storage, so the storage bar never dropped. Now every deleted
    //   product's video + thumbnail files are removed from Storage too, and the
    //   user sees exactly how much space was reclaimed.
    // ============================================
    const fmtStorage = (bytes) => {
        const mb = (bytes || 0) / 1024 / 1024;
        if (mb >= 1024) return `${(mb / 1024).toFixed(2)} GB`;
        return `${mb >= 10 ? Math.round(mb) : mb.toFixed(1)} MB`;
    };

    // All Firebase Storage URLs a product owns (video + thumbnail, every set).
    const collectProductStorageUrls = (product) => {
        const urls = [];
        const pr = product?.prompts || {};
        for (const key of Object.keys(pr)) {
            const s = pr[key] || {};
            if (s.uploadedVideo) urls.push(s.uploadedVideo);
            if (s.uploadedVideoThumb) urls.push(s.uploadedVideoThumb);
        }
        /* ★ Gambar tambahan MILIK KAD INI sahaja (2026-09-11) — gambar yang agent
           hasilkan disimpan di `users/{uid}/products/{productId}/…`. Padam kad =
           fail itu ikut terpadam + kaunter 5GB turun (simetri dengan muat naiknya).
           ⛔ Gambar tambahan di laluan LAIN (cth salinan gambar My Products yang
              dikongsi beberapa kad) SENGAJA dikecualikan — memadamnya mematikan
              gambar pada kad lain. */
        const uid = auth.currentUser?.uid || '';
        const milikKad = uid && product?.id ? `users%2F${uid}%2Fproducts%2F${product.id}%2F` : null;
        if (milikKad && Array.isArray(product?.extraImageUrls)) {
            for (const u of product.extraImageUrls) {
                if (typeof u === 'string' && u.includes('firebasestorage.googleapis.com') && u.includes(milikKad)) urls.push(u);
            }
        }
        // ★ RESIPI Images only: gambar hasil robot (extension gambarHasilKad.ts) milik card ini.
        if (milikKad && product?.gambarHasil && typeof product.gambarHasil === 'object') {
            for (const u of Object.values(product.gambarHasil)) {
                if (typeof u === 'string' && u.includes('firebasestorage.googleapis.com') && u.includes(milikKad)) urls.push(u);
            }
        }
        return urls;
    };

    // Sum the real byte size of the given Storage URLs (missing files count as 0).
    const sumStorageBytes = async (urls) => {
        let total = 0;
        await Promise.all(urls.map(async (u) => {
            try {
                if (!u || !u.includes('firebasestorage.googleapis.com')) return;
                const m = new URL(u).pathname.match(/\/o\/(.+?)(\?|$)/);
                if (!m) return;
                const md = await getMetadata(fbRef(storage, decodeURIComponent(m[1])));
                total += md.size || 0;
            } catch { /* file already gone / unreadable → 0 */ }
        }));
        return total;
    };

    // Entry point from the floating "Delete" button. Opens the confirm modal and
    // measures how much space the delete will free (shown in the modal + toast).
    const requestDeleteProducts = (ids) => {
        if (!ids || ids.length === 0) return;
        const targets = products.filter(p => ids.includes(p.id));
        // ★ 2026-10-06: fail yang kad KEKAL masih rujuk (cth gambar agent yang dikongsi kad salinan)
        //   tidak dipadam, jadi tidak dikira dalam anggaran juga — sama senarai seperti confirmDeleteProducts.
        const failKekal = failDirujukKadKekal(products, new Set(ids));
        const est = sumStorageBytes(tapisFailMasihDipakai(targets.flatMap(collectProductStorageUrls), failKekal));
        productDeleteEstimateRef.current = est;
        setProductDeleteConfirm({ open: true, ids, estBytes: null, busy: false, progress: null });
        est.then((bytes) => {
            setProductDeleteConfirm(prev => (prev.open && prev.ids === ids) ? { ...prev, estBytes: bytes } : prev);
        });
    };

    const confirmDeleteProducts = async () => {
        const ids = productDeleteConfirm.ids;
        if (!ids || ids.length === 0 || !auth.currentUser) return;
        // Freed amount = the size we measured for the estimate (same files we delete).
        const freedBytes = (await productDeleteEstimateRef.current) || 0;

        setProductDeleteConfirm(prev => ({ ...prev, busy: true, progress: { done: 0, total: ids.length } }));

        const idSet = new Set(ids);
        const targets = products.filter(p => idSet.has(p.id));
        // ★ 2026-10-06: fail yang masih dirujuk kad yang KEKAL (dikira SEBELUM state dikosongkan di bawah).
        //   Kad salinan (Duplicate) berkongsi gambar agent kad asalnya — tanpa pagar ini, memadam kad
        //   asal memadam fail itu dan gambar tambahan kad salinan pecah (utils/kadSalinan.js).
        const failKekal = failDirujukKadKekal(products, idSet);
        // Optimistic UI: remove cards immediately (pendingDeletes guards onSnapshot re-inject).
        isFromCloudRef.current = true;
        setProducts(products.filter(p => !idSet.has(p.id)));
        ids.forEach(id => { if (pendingDeletesRef) pendingDeletesRef.current.add(id); });

        // 1. Delete Storage files (video + thumbnail) per product, updating progress.
        let done = 0;
        for (const prod of targets) {
            const urls = tapisFailMasihDipakai(collectProductStorageUrls(prod), failKekal);
            await Promise.all(urls.map(u => deleteVideoFromStorage(u)));
            done += 1;
            setProductDeleteConfirm(prev => ({ ...prev, progress: { done, total: ids.length } }));
        }

        // 2. Delete Firestore docs (single atomic batch → one clean snapshot update).
        try {
            await removeProducts(auth.currentUser.uid, ids);
        } catch (err) {
            console.warn('[BulkDelete] doc delete failed:', err.message);
        }
        // ★ FIX "padam tak melekat" (2026-07-27): extension buang salinan video setiap produk
        //   yang dipadam (bytes + penanda local) — kalau tidak kad extension kekal papar video.
        ids.forEach(id => window.postMessage({ type: 'SESAAT_CLEAR_PRODUCT_CACHE', productId: id }, '*'));
        ids.forEach(id => { if (pendingDeletesRef) pendingDeletesRef.current.delete(id); });

        // ★ Pepijat 3 (Langkah 1): buang slot kalendar produk yang dipadam.
        prunProdukDariJadual(idSet);

        // 3. Refresh storage bar.
        window.dispatchEvent(new Event('SESAAT_STORAGE_CHANGED'));

        setProductDeleteConfirm({ open: false, ids: [], estBytes: null, busy: false, progress: null });
        toast.success(T('ws.toast.productsDeleted', `${ids.length} produk dipadam · ${fmtStorage(freedBytes)} dikosongkan`, { n: ids.length, size: fmtStorage(freedBytes) }));
    };

    // ============================================
    // ★ BULK STATUS — TUKAR atau KOSONGKAN pil status pada kad terpilih, per set.
    //   [2026-09-18] Ganti butang "Kosongkan Status" (arahan user, lakaran
    //   diluluskan): menu kiri = pilih set, menu kanan = status baharu
    //   (Scheduled · Draft · Failed · Not run yet). Rupa dalam MenuStatusPukal.jsx.
    //   Sebelum 2026-08-24 satu-satunya jalan ialah membuka pil pada SETIAP video.
    //
    //   ⭐ SKOP = AKAUN YANG SEDANG DIBUKA di kalendar — dan pil pada kad kini
    //      memapar akaun itu SAHAJA (utils/statusAkaunKad.js), jadi apa yang
    //      pengguna nampak = apa yang butang ini ubah. Aduan 2026-09-18: pil
    //      "Failed" milik akaun lain kelihatan, butang tidak menyentuhnya, dan
    //      butang itu DIAM. Kini setiap tekan menghasilkan mesej.
    //
    //   Slot kalendar akaun itu ikut sama (arahan user 2026-09-16 + 2026-09-18):
    //     • kosongkan → `kosongkanSlotKadAktif` — turut membersihkan slot yang
    //       kadnya tiada rekod (tinggalan zaman sebelum sync)
    //     • tukar     → `cerminStatusKeSlot` — corak sama seperti menukar satu pil
    //   ⭐ [2026-09-20] Status boleh DITANDA sendiri pada kad yang belum ada pil
    //      (arahan user: "kadang user nak juga tanda sendiri status kat multiple
    //      card") — tetapi hanya untuk set yang ADA VIDEO; kad lain dilangkau
    //      dan dilapor. Mengosongkan tidak pernah mencipta apa-apa.
    //   ⚠️ 'running' DILANGKAU dengan sengaja, dan DILAPOR. Set yang sedang
    //      dihantar akan menerima keputusannya sebentar lagi, dan effect graduasi
    //      menulis keputusan itu SEMULA ke pil — guna Stop untuk menghentikannya.
    //   Video, caption dan prompt tidak disentuh.
    //
    //   Menulis melalui `tulisStatusAkaunKad` — SATU-SATUNYA penulis rekod ini.
    //   Ia yang menjaga peraturan `st: ''` (bukan buang kunci), mengekalkan
    //   `nama`+`masa` rekod asal, dan menyimpan hanya kad yang betul-betul berubah.
    // ============================================
    const bulkTukarStatus = (setKey, stBaru, labelStatus) => {
        const st = stBaru || '';
        const keys = setKey === 'all' ? SET_KAD_STATUS : [setKey];
        const terpilih = filteredAndSortedProducts.filter(p => p.selected);
        const { tukar, sama, berjalan, tiadaVideo } = pelanStatusPukal(terpilih, keys, schedAkaunAktif, st, namaAkaunDibuka);
        const slotBerubah = st === ''
            ? kosongkanSlotKadAktif(terpilih.flatMap((p) => keys.map((s) => ({ pid: p.id, s }))))
            : [];
        if (tukar.length) {
            tulisStatusAkaunKad(tukar);
            if (st !== '') cerminStatusKeSlot(tukar);
        }
        const jumlah = new Set([...tukar.map((r) => `${r.pid}__${r.s}`), ...slotBerubah]).size;
        /* Nota tambahan pada hujung mesej — setiap kad yang DILANGKAU mesti
           ada sebabnya di skrin, bukan senyap. */
        const nota = [];
        if (berjalan) nota.push(T('ws.toast.statusBerjalan', 'Set yang sedang dihantar tidak diubah — guna Stop untuk menghentikannya.'));
        if (tiadaVideo) nota.push(T('ws.toast.statusTiadaVideo', 'Kad yang tiada video untuk set itu dilangkau — status hanya untuk set yang ada video.'));
        const ekor = nota.length ? ' ' + nota.join(' ') : '';
        if (!jumlah) {
            /* Tiada apa berubah — BERITAHU sebabnya, jangan diam. */
            if (sama) {
                toast.info(T('ws.toast.statusSudah', `Status itu memang sudah ${labelStatus} — tiada apa diubah.`, { status: labelStatus }) + ekor);
            } else if (nota.length) {
                toast.info(nota.join(' '));
            } else {
                toast.info(T('ws.toast.statusTiada', `Tiada status untuk akaun ${namaAkaunDibuka} pada kad yang ditanda.`, { akaun: namaAkaunDibuka }));
            }
            return;
        }
        /* ⚠️ Enjin i18n tiada peraturan jamak, jadi bentuk TUNGGAL ada kuncinya
           sendiri — "1 statuses cleared" dibaca cuai (corak sama seperti
           `ws.jadual.tpl.deleteUsedNoteOne`). Bilangan KAD sengaja tidak
           disebut: ia nombor kedua yang bebas, jadi ia memerlukan empat
           gabungan ayat sedangkan pengguna sendiri yang menanda kad itu. */
        const ayat = st === ''
            ? (jumlah === 1
                ? T('ws.toast.statusDikosongkanSatu', '1 status dikosongkan.')
                : T('ws.toast.statusDikosongkan', `${jumlah} status dikosongkan.`, { n: jumlah }))
            : (jumlah === 1
                ? T('ws.toast.statusDitukarSatu', `1 status ditukar ke ${labelStatus}.`, { status: labelStatus })
                : T('ws.toast.statusDitukar', `${jumlah} status ditukar ke ${labelStatus}.`, { n: jumlah, status: labelStatus }));
        toast.success(ayat + ekor);
    };

    // ============================================
    // ★ BULK VIDEO-ONLY DELETE — padam video sahaja utk selected cards, per set.
    //   Card + prompt + caption KEKAL. Order sama dgn handleDeleteVideo:
    //   Firestore save FIRST (source of truth) → baru padam fail Storage.
    //   Save gagal → rollback UI, Storage untouched (selamat retry).
    // ============================================
    const requestBulkDeleteVideos = (setKey) => {
        const keys = setKey === 'all' ? ['set1', 'set2', 'set3'] : [setKey];
        const items = [];
        filteredAndSortedProducts.filter(p => p.selected).forEach(p => {
            keys.forEach(k => {
                const s = p.prompts?.[k];
                if (s?.uploadedVideo) items.push({ productId: p.id, setKey: k, videoUrl: s.uploadedVideo, thumbUrl: s.uploadedVideoThumb || '' });
            });
        });
        if (items.length === 0) return;
        const est = sumStorageBytes(items.flatMap(it => [it.videoUrl, it.thumbUrl].filter(Boolean)));
        bulkVideoEstimateRef.current = est;
        setBulkVideoDeleteConfirm({ open: true, setKey, items, estBytes: null, busy: false, progress: null });
        est.then((bytes) => {
            setBulkVideoDeleteConfirm(prev => (prev.open && prev.items === items) ? { ...prev, estBytes: bytes } : prev);
        });
    };

    const confirmBulkDeleteVideos = async () => {
        const { items } = bulkVideoDeleteConfirm;
        if (!items || items.length === 0) return;
        const freedBytes = (await bulkVideoEstimateRef.current) || 0;
        setBulkVideoDeleteConfirm(prev => ({ ...prev, busy: true, progress: { done: 0, total: items.length } }));

        const originalProducts = products;

        // 1. Optimistic UI: kosongkan field video utk semua set terpilih dalam satu pass
        const byProduct = new Map();
        items.forEach(it => {
            if (!byProduct.has(it.productId)) byProduct.set(it.productId, []);
            byProduct.get(it.productId).push(it.setKey);
        });
        const updated = products.map(p => {
            const keys = byProduct.get(p.id);
            if (!keys) return p;
            const prompts = { ...p.prompts };
            keys.forEach(k => { prompts[k] = { ...(prompts[k] || {}), uploadedVideo: '', uploadedVideoThumb: '' }; });
            return { ...p, prompts };
        });
        setProducts(updated);

        // 2. Firestore save FIRST — gagal = rollback, fail Storage kekal (boleh retry)
        const saveResult = await saveToCloud(updated);
        if (!saveResult?.ok) {
            setProducts(originalProducts);
            setBulkVideoDeleteConfirm(prev => ({ ...prev, busy: false, progress: null }));
            const sebabSave = saveResult?.error?.message || T('ws.common.tryAgain', 'Cuba lagi');
            toast.error(T('ws.toast.saveFailedVideoRestored', `Save gagal — video dipulihkan. ${sebabSave}`, { msg: sebabSave }));
            return;
        }

        // 3. Save confirmed → padam fail sebenar (best-effort; orphan tak bahaya)
        let done = 0;
        let orphaned = false;
        for (const it of items) {
            const videoResult = await deleteVideoFromStorage(it.videoUrl);
            const thumbResult = it.thumbUrl ? await deleteVideoFromStorage(it.thumbUrl) : { ok: true };
            if (!videoResult.ok || !thumbResult.ok) orphaned = true;
            // Notify extension supaya clear video cache (semua tier, termasuk local://)
            window.postMessage({
                type: 'SESAAT_CLEAR_VIDEO_CACHE',
                productId: it.productId,
                setKey: it.setKey,
                videoUrl: it.videoUrl || ''
            }, '*');
            done += 1;
            setBulkVideoDeleteConfirm(prev => ({ ...prev, progress: { done, total: items.length } }));
        }

        // 4. Refresh storage bar
        window.dispatchEvent(new Event('SESAAT_STORAGE_CHANGED'));

        setBulkVideoDeleteConfirm({ open: false, setKey: null, items: [], estBytes: null, busy: false, progress: null });
        if (orphaned) {
            toast.info(T('ws.toast.videosDeletedOrphan', `${items.length} video dipadam · sebahagian fail Storage tak dapat dialih keluar — akan dibersihkan automatik kemudian`, { n: items.length }));
        } else {
            toast.success(T('ws.toast.videosDeleted', `${items.length} video dipadam · ${fmtStorage(freedBytes)} dikosongkan`, { n: items.length, size: fmtStorage(freedBytes) }));
        }
    };

    // ============================================
    // ★ BULK KOSONGKAN PROMPT — padam teks prompt kad terpilih, per set (2026-09-13).
    //   Keputusan user + sebab ia TIDAK melalui saveToCloud: utils/kosongkanPrompt.js.
    //   Turutan: baca teks SEGAR → kira kad yang betul-betul ada teks → popup →
    //   tulis TERUS ke Firestore → barulah paparan dikemas kini. Gagal tulis =
    //   paparan tidak berubah + ralat dilapor (tiada kad "nampak kosong" yang
    //   sebenarnya masih berisi di pangkalan data).
    // ============================================
    const labelSetKad = (k) => (k === 'all'
        ? T('ws.pukal.semuaSet', 'Semua Set')
        : ((spaces.find(s => s.id === selectedSpaceId)?.settings?.labels?.[k]) || k.replace('set', 'Set ')));

    const requestKosongkanPrompt = async (setKey) => {
        if (!auth.currentUser) return;
        const dipilih = filteredAndSortedProducts.filter(p => p.selected);
        if (dipilih.length === 0) return;
        /* Kad yang sedang dijana DILANGKAU: generation menulis teks sebaik siap,
           jadi mengosongkannya sekarang hanya menghasilkan kad yang kosong sekejap
           lalu penuh semula — dibaca sebagai butang yang tidak menjadi. */
        const sasaran = dipilih.filter(p => !p.isGenerating);
        const langkau = dipilih.length - sasaran.length;
        if (sasaran.length === 0) {
            toast.info(T('ws.toast.kosongPromptSemuaJana', 'Semua kad yang ditanda sedang dijana — tunggu siap dahulu.'));
            return;
        }
        const req = ++kosongPromptReqRef.current;
        setKosongPrompt({ ...KOSONG_PROMPT_TUTUP, open: true, setKey, fasa: 'semak', langkau });
        let bacaan;
        try {
            /* ⛔ Baca SEGAR, bukan cache — pelan padam dibina daripada kunci yang
               wujud di pangkalan data SEKARANG (lihat nota pelanKad).
               Had masa 20s: popup terkunci semasa menyemak, jadi sambungan yang
               tersangkut tidak boleh memerangkap pelanggan di situ. */
            const semua = Promise.all(sasaran.map(async (produk) => ({
                produk,
                detail: produk.splitV === 2 ? await loadProductDetail(auth.currentUser.uid, produk.id) : null,
            })));
            let pemasa;
            const hadMasa = new Promise((_, tolak) => {
                pemasa = setTimeout(() => tolak(new Error(T('ws.confirm.kosongPromptHadMasa', 'sambungan terlalu lambat'))), 20000);
            });
            try { bacaan = await Promise.race([semua, hadMasa]); }
            finally { clearTimeout(pemasa); }
        } catch (err) {
            if (kosongPromptReqRef.current !== req) return;
            setKosongPrompt(KOSONG_PROMPT_TUTUP);
            const sebab = err?.message || T('ws.common.tryAgain', 'Cuba lagi');
            toast.error(T('ws.toast.kosongPromptSemakGagal', `Gagal menyemak kad: ${sebab}. Tiada apa-apa dikosongkan.`, { msg: sebab }));
            return;
        }
        if (kosongPromptReqRef.current !== req) return;
        const pelan = bacaan
            .map(({ produk, detail }) => pelanKad({ produk, detail, draf: draftPromptMap[produk.id], setKey }))
            .filter(pl => pl.adaTeks);
        if (pelan.length === 0) {
            setKosongPrompt(KOSONG_PROMPT_TUTUP);
            const set = labelSetKad(setKey);
            toast.info(T('ws.toast.kosongPromptTiada', `Tiada prompt untuk dikosongkan dalam ${set}.`, { set }));
            return;
        }
        setKosongPrompt(prev => ({ ...prev, fasa: 'sedia', pelan, kosong: sasaran.length - pelan.length }));
    };

    const confirmKosongkanPrompt = async () => {
        const { pelan, fasa } = kosongPrompt;
        if (fasa !== 'sedia' || pelan.length === 0 || !auth.currentUser) return;
        setKosongPrompt(prev => ({ ...prev, fasa: 'tulis' }));

        const { berjaya, ralat } = await kosongkanPromptKad(auth.currentUser.uid, pelan);

        /* Paparan dikemas kini HANYA untuk kad yang sudah disahkan server. */
        if (berjaya.length > 0) {
            const okIds = new Set(berjaya);
            const pelanById = new Map(pelan.filter(pl => okIds.has(pl.id)).map(pl => [pl.id, pl]));
            const tanpaTeks = (prompts, sets) => {
                if (!prompts || typeof prompts !== 'object') return prompts;
                const out = { ...prompts };
                sets.forEach(s => { if (out[s]) out[s] = setTanpaTeks(out[s]); });
                return out;
            };
            setProducts(prev => prev.map(p => {
                const pl = pelanById.get(p.id);
                if (!pl) return p;
                const out = { ...p, prompts: tanpaTeks(p.prompts, pl.sets) };
                delete out.rawOutput;
                return out;
            }));
            /* ★ SPLIT V2: cache teks diisi dengan bacaan segar TANPA teks yang dipadam.
               Buffer +60s (corak primeDetailCache) supaya `lastUpdated` tulisan sendiri
               tidak membatalkannya. ⚠️ primeDetailCache TIDAK dipakai: ia memakai `??`,
               jadi rawOutput null jatuh semula kepada Full Prompt yang lama. */
            pelanById.forEach((pl, id) => {
                if (!pl.detail) return;
                detailCacheRef.current.set(id, {
                    ...pl.detail,
                    prompts: tanpaTeks(pl.detail.prompts, pl.sets) ?? null,
                    rawOutput: null,
                    updatedAt: null,
                    _fetchedAtMs: Date.now() + 60000,
                });
            });
            setDetailReadyTick(t => t + 1);
            /* Draf belum disimpan membawa teks lama — kalau dibiarkan, menekan Simpan
               pada kad itu kemudian menulis semula teks yang baru dikosongkan. */
            const drafBaharu = { ...draftPromptMap };
            const drafDibuang = [];
            let drafUbah = false;
            pelanById.forEach((pl, id) => {
                if (!drafBaharu[id]) return;
                drafUbah = true;
                const baki = tanpaTeks(drafBaharu[id], pl.sets);
                if (Object.values(baki).some(setAdaTeks)) drafBaharu[id] = baki;
                else { delete drafBaharu[id]; drafDibuang.push(id); }
            });
            if (drafUbah) setDraftPromptMap(drafBaharu);
            if (drafDibuang.length) {
                setDirtyProductIds(prev => { const s = new Set(prev); drafDibuang.forEach(id => s.delete(id)); return s; });
            }
            setHookSyncWarnings(prev => {
                const next = { ...prev };
                pelanById.forEach((pl, id) => pl.sets.forEach(s => { delete next[`${id}_${s}`]; }));
                return next;
            });
        }

        setKosongPrompt(KOSONG_PROMPT_TUTUP);
        if (ralat) {
            const sebab = ralat?.message || T('ws.common.tryAgain', 'Cuba lagi');
            toast.error(berjaya.length > 0
                ? T('ws.toast.kosongPromptSeparuh', `${berjaya.length} daripada ${pelan.length} kad dikosongkan — selebihnya gagal: ${sebab}`, { ok: berjaya.length, n: pelan.length, msg: sebab })
                : T('ws.toast.kosongPromptGagal', `Gagal mengosongkan prompt: ${sebab}. Tiada apa-apa berubah.`, { msg: sebab }));
            return;
        }
        toast.success(berjaya.length === 1
            ? T('ws.toast.kosongPromptSiapSatu', 'Prompt dikosongkan pada 1 kad.')
            : T('ws.toast.kosongPromptSiap', `Prompt dikosongkan pada ${berjaya.length} kad.`, { n: berjaya.length }));
    };

    // Update product
    const updateProduct = (productId, updates) => {
        const updated = products.map(p =>
            p.id === productId ? { ...p, ...updates } : p
        );
        setProducts(updated);
        saveToCloud(updated);
    };

    // ============================================
    // DRAFT PROMPT HELPERS — local edit without Firestore write
    // ============================================

    // ★ GOYANG hookText ↔ promptImage SYNC HELPERS
    // Extract hook ayat dari promptImage (e.g. `text overlay "Hari ni je"` → "Hari ni je")
    // Skip kalau dia placeholder [HOOK] (bermakna AI ikut new-style output, hookText stored separately).
    const extractHookFromPromptImage = (promptImage) => {
        if (!promptImage) return '';
        const patterns = [
            /text overlay\s*["'“”]([^"'“”]+?)["'“”]/i,
            /overlay\s*["'“”]([^"'“”]+?)["'“”]\s+(?:in|positioned|at)/i,
        ];
        for (const re of patterns) {
            const m = promptImage.match(re);
            if (m && m[1] && m[1].trim() !== '[HOOK]') return m[1].trim();
        }
        return '';
    };
    // Replace hook dalam promptImage. Handle 3 modes:
    //   1) [HOOK] placeholder (new-style AI) → direct replace
    //   2) Old hook string match exact → split-join replace
    //   3) Regex fallback — replace quoted text selepas "text overlay"
    const replaceHookInPromptImage = (promptImage, oldHook, newHook) => {
        if (!promptImage) return promptImage;
        if (promptImage.includes('[HOOK]')) return promptImage.replace(/\[HOOK\]/g, newHook);
        if (oldHook && promptImage.includes(oldHook)) return promptImage.split(oldHook).join(newHook);
        return promptImage.replace(
            /((?:text\s+overlay|overlay)\s*["'“”])([^"'“”]+?)(["'“”])/i,
            (_match, p1, _p2, p3) => `${p1}${newHook}${p3}`
        );
    };
    // Computed display value — kalau hookText stored kosong, fallback extract dari promptImage.
    // Senario typical: produk legacy yang AI generate dengan hook inline (no [HOOK] placeholder).
    const getEffectiveHookText = (productId, fallbackPrompts, setKey) => {
        const eff = draftPromptMap[productId] ?? fallbackPrompts;
        const stored = eff?.[setKey]?.hookText;
        if (stored) return stored;
        return extractHookFromPromptImage(eff?.[setKey]?.promptImage) || '';
    };

    // ★ videoScript ↔ promptVideo SYNC HELPERS — support 3 patterns:
    //   1) [SCRIPT]/[SCRIPT1]/[SCRIPT2] placeholder (pre-substitute; videoScript stored separately)
    //   2) "Spoken dialog (exact script):\n<block>" — new unified pattern (Home Niche, AI16SAAT, AI8SAAT)
    //   3) "0–8s: <text>" — legacy GOYANG pattern (backward compat)
    // sceneSuffix: '' (single-scene), '1' (Scene 1), '2' (Scene 2)
    const scriptToken = (sceneSuffix) => `[SCRIPT${sceneSuffix}]`;
    const SPOKEN_BLOCK_RE = /Spoken dialog \(exact script\):\s*\n([\s\S]+?)(?=\n\s*\n|\nThe model|\nThe text|\nNO\s|$)/i;
    const SPOKEN_BLOCK_REPLACE_RE = /(Spoken dialog \(exact script\):\s*\n)([\s\S]+?)(?=\n\s*\n|\nThe model|\nThe text|\nNO\s|$)/i;

    const extractScriptFromPromptVideo = (promptVideo, sceneSuffix = '') => {
        if (!promptVideo) return '';
        // Placeholder still literal → no actual script yet
        if (promptVideo.includes(scriptToken(sceneSuffix))) return '';
        // Pattern 2: "Spoken dialog (exact script):" block
        const blockM = promptVideo.match(SPOKEN_BLOCK_RE);
        if (blockM && blockM[1]) {
            const content = blockM[1].trim();
            if (content && content !== '[SCRIPT]' && content !== '[SCRIPT1]' && content !== '[SCRIPT2]') {
                return content;
            }
        }
        // Pattern 3: legacy GOYANG "0–8s: <text>"
        const oldM = promptVideo.match(/0\s*[–-]\s*8s:\s*(.+?)(?:\n|$)/i);
        if (oldM && oldM[1] && oldM[1].trim() !== '[SCRIPT]') return oldM[1].trim();
        return '';
    };

    const replaceScriptInPromptVideo = (promptVideo, oldScript, newScript, sceneSuffix = '') => {
        if (!promptVideo) return promptVideo;
        const token = scriptToken(sceneSuffix);
        // Pattern 1: placeholder substitution
        if (promptVideo.includes(token)) return promptVideo.split(token).join(newScript);
        // Pattern 2: replace "Spoken dialog (exact script):\n<block>"
        if (SPOKEN_BLOCK_REPLACE_RE.test(promptVideo)) {
            return promptVideo.replace(SPOKEN_BLOCK_REPLACE_RE, (_m, p1) => `${p1}${newScript}`);
        }
        // Pattern 3: exact-string match
        if (oldScript && promptVideo.includes(oldScript)) return promptVideo.split(oldScript).join(newScript);
        // Pattern 4: legacy GOYANG single-line replace
        return promptVideo.replace(
            /(0\s*[–-]\s*8s:\s*)(.+?)(\n|$)/i,
            (_match, p1, _p2, p3) => `${p1}${newScript}${p3}`
        );
    };

    const getEffectiveVideoScript = (productId, fallbackPrompts, setKey, sceneSuffix = '') => {
        const eff = draftPromptMap[productId] ?? fallbackPrompts;
        const storedField = sceneSuffix ? `videoScript${sceneSuffix}` : 'videoScript';
        const videoField = sceneSuffix ? `promptVideo${sceneSuffix}` : 'promptVideo';
        const stored = eff?.[setKey]?.[storedField];
        if (stored) return stored;
        return extractScriptFromPromptVideo(eff?.[setKey]?.[videoField], sceneSuffix) || '';
    };

    // ★ FLOWNITY (N-scene) — "Video Prompt (penuh)" bukan field tersimpan; ia DERIVED dari
    //   Image Prompt (visual = promptVideo{n}) + Video Dialog (videoScript{n}). Susunan MESTI
    //   sama tepat dengan yang extension bina masa paste ke Flow (flow-automation-flownity.js
    //   _buildScenePrompts) supaya copy manual = 100% sama dengan automation.
    const buildNSceneFullVideo = (visualRaw, dialog) => {
        let visual = String(visualRaw || '');
        const idx = visual.search(/\n*\s*Spoken dialog \(exact script\):/i);
        if (idx !== -1) visual = visual.slice(0, idx);        // buang blok dialog kalau ada (elak dua kali)
        visual = visual.replace(/\[SCRIPT\d*\]/g, '').trimEnd();
        const scr = String(dialog || '').trim();
        return scr ? `${visual}\n\nSpoken dialog (exact script):\n${scr}` : visual.trim();
    };
    // Video Prompt penuh untuk scene n, ambil kira draft edit semasa (Image Prompt + Video Dialog).
    const getEffectiveNSceneFull = (productId, fallbackPrompts, n) => {
        const eff = draftPromptMap[productId] ?? fallbackPrompts;
        const visual = eff?.set1?.[`promptVideo${n}`] || '';
        const dialog = getEffectiveVideoScript(productId, fallbackPrompts, 'set1', String(n));
        return buildNSceneFullVideo(visual, dialog);
    };

    // ============================================
    // ★ TEMPLATE SYNC (FIX bug edit hook/script) — produk baru simpan *Template dgn placeholder.
    //   Sync DETERMINISTIK (bukan regex teka): edit Hook Text / Video Script → substitute ke prompt;
    //   edit prompt terus → reverse balik jadi template. Produk lama (takda *Template) guna laluan
    //   regex legacy di bawah supaya tak rosak.
    // ============================================
    // Produk pakai sistem template baru kalau ada mana-mana *Template field.
    const setUsesTemplate = (set) => !!(set && (
        set.promptImageTemplate != null || set.promptVideoTemplate != null ||
        set.promptVideo1Template != null || set.promptVideo2Template != null
    ));
    // Substitute token → nilai dalam template.
    const applyTokens = (template, tokens) => {
        if (template == null) return template;
        let out = template;
        for (const [tok, val] of Object.entries(tokens)) {
            if (val) out = out.split(tok).join(val);
        }
        return out;
    };
    // Recompute SEMUA prompt display dari template + nilai hook/script semasa.
    const recomputeSetPrompts = (set) => {
        const hook = set.hookText || '';
        const out = { ...set };
        if (set.promptImageTemplate != null) out.promptImage = applyTokens(set.promptImageTemplate, { '[HOOK]': hook });
        if (set.promptVideoTemplate != null) out.promptVideo = applyTokens(set.promptVideoTemplate, { '[SCRIPT]': set.videoScript || '', '[HOOK]': hook });
        if (set.promptVideo1Template != null) out.promptVideo1 = applyTokens(set.promptVideo1Template, { '[SCRIPT1]': set.videoScript1 || '', '[HOOK]': hook });
        if (set.promptVideo2Template != null) out.promptVideo2 = applyTokens(set.promptVideo2Template, { '[SCRIPT2]': set.videoScript2 || '', '[HOOK]': hook });
        return out;
    };
    // Reverse prompt edit — user edit prompt display (Image/Video Prompt) terus. DETERMINISTIK,
    //   handle multi-token (video ada script + hook). Guna PREFIX/SUFFIX pada OLD DISPLAY sekeliling
    //   nilai utama (hook/script). Pulangkan { value, template, extracted }:
    //    - extracted=true : kawasan nilai diedit → value baru di-extract, template KEKAL.
    //    - extracted=false: sekeliling diedit → value KEKAL, template di-rebuild (swap value→token).
    //   secondaryPairs: nilai lain yg di-swap balik jadi token masa rebuild template (cth hook dlm video).
    const reversePromptEdit = (oldDisplay, oldValue, token, oldTemplate, newDisplay, secondaryPairs = []) => {
        if (oldValue) {
            const idx = oldDisplay.indexOf(oldValue);
            if (idx !== -1) {
                const prefix = oldDisplay.slice(0, idx);
                const suffix = oldDisplay.slice(idx + oldValue.length);
                if (newDisplay.startsWith(prefix) && newDisplay.endsWith(suffix) && newDisplay.length >= prefix.length + suffix.length) {
                    // Kawasan nilai diedit (sekeliling kekal) → extract nilai baru, template kekal.
                    return { value: newDisplay.slice(prefix.length, newDisplay.length - suffix.length), template: oldTemplate, extracted: true };
                }
            }
        }
        // Sekeliling diedit → rebuild template dari newDisplay (swap nilai semasa + secondary → token).
        let tpl = newDisplay;
        if (oldValue && tpl.includes(oldValue)) tpl = tpl.split(oldValue).join(token);
        for (const sp of secondaryPairs) {
            if (sp.value && tpl.includes(sp.value)) tpl = tpl.split(sp.value).join(sp.token);
        }
        return { value: oldValue, template: tpl, extracted: false };
    };
    // Apply edit ke set yang guna template — deterministik, dua-hala penuh. Pulangkan set baru.
    const applyTemplateEdit = (oldSet, field, value) => {
        if (field === 'hookText') {
            return recomputeSetPrompts({ ...oldSet, hookText: value });
        }
        if (field === 'videoScript' || field === 'videoScript1' || field === 'videoScript2') {
            return recomputeSetPrompts({ ...oldSet, [field]: value });
        }
        if (field === 'promptImage') {
            // Dua-hala: edit kawasan hook → update Hook Text field; edit sekeliling → template rebuild.
            const r = reversePromptEdit(oldSet.promptImage || '', oldSet.hookText || '', '[HOOK]', oldSet.promptImageTemplate ?? null, value);
            return recomputeSetPrompts(r.extracted
                ? { ...oldSet, hookText: r.value }
                : { ...oldSet, promptImageTemplate: r.template });
        }
        if (field === 'promptVideo' || field === 'promptVideo1' || field === 'promptVideo2') {
            const sfx = field === 'promptVideo1' ? '1' : field === 'promptVideo2' ? '2' : '';
            const tplField = `promptVideo${sfx}Template`;
            const scriptTok = sfx ? `[SCRIPT${sfx}]` : '[SCRIPT]';
            const scriptField = sfx ? `videoScript${sfx}` : 'videoScript';
            // Dua-hala: edit kawasan script → update Video Script field; edit sekeliling → template rebuild.
            // Hook (shared) di-swap balik jadi [HOOK] sebagai secondary masa rebuild template.
            const r = reversePromptEdit(oldSet[field] || '', oldSet[scriptField] || '', scriptTok, oldSet[tplField] ?? null, value, [{ value: oldSet.hookText || '', token: '[HOOK]' }]);
            return recomputeSetPrompts(r.extracted
                ? { ...oldSet, [scriptField]: r.value }
                : { ...oldSet, [tplField]: r.template });
        }
        // Field lain (cth captionTiktok, uploadedImage) — set terus.
        return { ...oldSet, [field]: value };
    };

    // ★ Template badge — tunjuk hook/bg style dari template SNAPSHOT (yang dipakai masa generate).
    // BUKAN dari active template di leftpanel — supaya badge tak auto-tukar bila user pilih template baru.
    // Fallback: kalau snapshot tak ada (legacy product / belum generate), tunjuk active template.
    const getTemplateBadgeLabel = (product, setKey, type) => {
        if (product?.moduleId !== 'goyang') return null;
        const tmpl = product?.templateSnapshot || propSelectedTemplate;
        if (!tmpl) return null;
        const s = tmpl[setKey];
        if (!s) return null;
        if (type === 'hook') {
            if (!s.hook || s.hook === 'Auto (AI decide)') return null;
            return s.hook === 'Custom' ? (s.hookCustom || 'Custom') : s.hook;
        }
        if (type === 'bg') {
            if (!s.bg || s.bg === 'Auto (AI decide)') return null;
            return s.bg === 'Custom' ? (s.bgCustom || 'Custom') : s.bg;
        }
        return null;
    };
    // Inline badge component — minimalist, absolute positioned bucu kanan bawah dalam textarea wrapper.
    const TemplateBadge = ({ label, color }) => {
        if (!label) return null;
        const palette = color === 'blue'
            ? 'border-blue-200 text-blue-700 dark:border-blue-800/40 dark:text-blue-400'
            : 'border-amber-200 text-amber-700 dark:border-amber-800/40 dark:text-amber-400';
        return (
            <div className={`absolute bottom-1.5 right-1.5 px-1.5 py-0.5 bg-white/85 dark:bg-slate-900/85 backdrop-blur-sm border ${palette} text-[8px] font-bold uppercase tracking-wider rounded pointer-events-none shadow-sm`}>
                {label}
            </div>
        );
    };

    const updateDraftPrompt = (productId, currentPrompts, setKey, field, value) => {
        // ★ [2026-09-27] Kotak "Facebook Caption" (modal) — medan maya `captionFbKotak`: menulis
        //   captionFb + captionFbKosong SERENTAK ikut peraturan user (setDenganKotakFb, utils/captionKad.js):
        //   sama dengan caption TikTok = ikut TikTok · kosong = FB tanpa caption · lain = caption FB sendiri.
        if (field === 'captionFbKotak') {
            setDraftPromptMap(prev => {
                const base = prev[productId] ?? currentPrompts;
                return { ...prev, [productId]: { ...base, [setKey]: setDenganKotakFb(base?.[setKey], value) } };
            });
            setDirtyProductIds(prev => new Set([...prev, productId]));
            return;
        }
        // ★ FLOWNITY (N-scene) — user edit "Video Prompt (penuh)" terus. Field maya `fullVideo{n}`:
        //   pecah balik pada penanda "Spoken dialog (exact script):" → sebelum = visual (promptVideo{n}),
        //   selepas = dialog (videoScript{n}). Tiada penanda → semua jadi visual, dialog kekal (elak hilang data).
        const _fullM = field.match(/^fullVideo(\d+)$/);
        if (_fullM) {
            const n = _fullM[1];
            const s = String(value || '');
            const m = s.match(/^([\s\S]*?)\n*\s*Spoken dialog \(exact script\):\s*\n?([\s\S]*)$/i);
            const visual = m ? m[1].trimEnd() : s.trimEnd();
            const dialog = m ? m[2].trim() : null;
            setDraftPromptMap(prev => {
                const base = prev[productId] ?? currentPrompts;
                const oldSet = base?.[setKey] || {};
                const nextSet = { ...oldSet, [`promptVideo${n}`]: visual, ...(dialog !== null ? { [`videoScript${n}`]: dialog } : {}) };
                return { ...prev, [productId]: { ...base, [setKey]: nextSet } };
            });
            setDirtyProductIds(prev => new Set([...prev, productId]));
            return;
        }

        // ★ TEMPLATE PATH (produk baru ada *Template) — sync deterministik dua-hala, tiada regex teka.
        const probeSet = (draftPromptMap[productId] ?? currentPrompts)?.[setKey] || {};
        if (setUsesTemplate(probeSet)) {
            setDraftPromptMap(prev => {
                const base = prev[productId] ?? currentPrompts;
                const oldSet = base?.[setKey] || {};
                const nextSet = applyTemplateEdit(oldSet, field, value);
                return { ...prev, [productId]: { ...base, [setKey]: nextSet } };
            });
            // Sync deterministik — clear sebarang warning sync lama.
            const warnKey = `${productId}_${setKey}`;
            setHookSyncWarnings(prev => { if (!prev[warnKey]) return prev; const next = { ...prev }; delete next[warnKey]; return next; });
            setDirtyProductIds(prev => new Set([...prev, productId]));
            return;
        }

        // ★ LEGACY PATH (produk lama tanpa template) — sync regex sedia ada. Behavior lama dikekalkan.
        // ★ GOYANG SYNC — bila edit hookText, auto-update promptImage. Bila edit promptImage, auto-extract hookText.
        if (field === 'hookText' || field === 'promptImage') {
            const warnKey = `${productId}_${setKey}`;
            setDraftPromptMap(prev => {
                const base = prev[productId] ?? currentPrompts;
                const oldSet = base?.[setKey] || {};
                const oldHookText = oldSet.hookText || extractHookFromPromptImage(oldSet.promptImage) || '';
                let nextSet;
                if (field === 'hookText') {
                    const oldPromptImage = oldSet.promptImage || '';
                    const newPromptImage = replaceHookInPromptImage(oldPromptImage, oldHookText, value);
                    nextSet = { ...oldSet, hookText: value, promptImage: newPromptImage };
                    // ★ B1 fix: Detect sync fail — kalau promptImage tak berubah BUT hookText changed = pattern tak detect
                    const syncFailed = oldPromptImage && oldPromptImage === newPromptImage && value !== oldHookText && value.trim() !== '';
                    if (syncFailed) {
                        console.warn(`[HookSync] Hook Text edit didn't auto-update Image Prompt for ${warnKey}. Pattern not detected in promptImage. User must edit Image Prompt manually.`);
                        setHookSyncWarnings(prev => ({ ...prev, [warnKey]: T('ws.card.hookSyncWarn', '⚠ Image Prompt tak auto-update — pattern hook tak detect. Edit Image Prompt manually.') }));
                    } else {
                        // Sync succeeded — clear any previous warning
                        setHookSyncWarnings(prev => { const next = { ...prev }; delete next[warnKey]; return next; });
                    }
                } else {
                    // field === 'promptImage'
                    const extracted = extractHookFromPromptImage(value);
                    nextSet = { ...oldSet, promptImage: value, ...(extracted ? { hookText: extracted } : {}) };
                    // Clear warning bila user edit Image Prompt directly (resync mungkin jadi)
                    setHookSyncWarnings(prev => { const next = { ...prev }; delete next[warnKey]; return next; });
                }
                return { ...prev, [productId]: { ...base, [setKey]: nextSet } };
            });
            setDirtyProductIds(prev => new Set([...prev, productId]));
            return;
        }

        // ★ videoScript ↔ promptVideo SYNC — bidirectional, supports single-scene + 2-scene.
        //   Pairs: videoScript↔promptVideo, videoScript1↔promptVideo1, videoScript2↔promptVideo2.
        const SCRIPT_FIELDS = ['videoScript', 'videoScript1', 'videoScript2'];
        const PROMPT_FIELDS = ['promptVideo', 'promptVideo1', 'promptVideo2'];
        const isScriptField = SCRIPT_FIELDS.includes(field);
        const isPromptField = PROMPT_FIELDS.includes(field);
        if (isScriptField || isPromptField) {
            const suffix = field.match(/[12]$/)?.[0] || ''; // '', '1', or '2'
            const scriptField = `videoScript${suffix}`;
            const promptField = `promptVideo${suffix}`;
            setDraftPromptMap(prev => {
                const base = prev[productId] ?? currentPrompts;
                const oldSet = base?.[setKey] || {};
                const oldVideoScript = oldSet[scriptField] || extractScriptFromPromptVideo(oldSet[promptField], suffix) || '';
                let nextSet;
                if (isScriptField) {
                    const oldPromptVideo = oldSet[promptField] || '';
                    const newPromptVideo = replaceScriptInPromptVideo(oldPromptVideo, oldVideoScript, value, suffix);
                    nextSet = { ...oldSet, [scriptField]: value, [promptField]: newPromptVideo };
                } else {
                    // isPromptField — extract videoScript dari new promptVideo
                    const extracted = extractScriptFromPromptVideo(value, suffix);
                    nextSet = { ...oldSet, [promptField]: value, ...(extracted ? { [scriptField]: extracted } : {}) };
                }
                return { ...prev, [productId]: { ...base, [setKey]: nextSet } };
            });
            setDirtyProductIds(prev => new Set([...prev, productId]));
            return;
        }

        // Default field update
        setDraftPromptMap(prev => ({
            ...prev,
            [productId]: {
                ...(prev[productId] ?? currentPrompts),
                [setKey]: {
                    ...((prev[productId] ?? currentPrompts)?.[setKey]),
                    [field]: value
                }
            }
        }));
        setDirtyProductIds(prev => new Set([...prev, productId]));
    };

    const saveProductDraftPrompts = (productId) => {
        const draft = draftPromptMap[productId];
        if (!draft) return;
        // ★ SPLIT V2: prime cache dgn draft (paparan kekal selepas feed strip state)
        const _sp = products.find(p => p.id === productId);
        if (_sp && (_sp.splitV === 2 || isSplitEnabled())) {
            primeDetailCache(productId, { prompts: draft });
        }
        updateProduct(productId, { prompts: draft });
        setDirtyProductIds(prev => { const s = new Set(prev); s.delete(productId); return s; });
        setDraftPromptMap(prev => { const m = { ...prev }; delete m[productId]; return m; });
        setSavedPromptNotifs(prev => ({ ...prev, [productId]: true }));
        setTimeout(() => setSavedPromptNotifs(prev => { const m = { ...prev }; delete m[productId]; return m; }), 4000);
    };

    const cancelProductDraftPrompts = (productId) => {
        setDraftPromptMap(prev => { const m = { ...prev }; delete m[productId]; return m; });
        setDirtyProductIds(prev => { const s = new Set(prev); s.delete(productId); return s; });
    };

    // ★ HASIL TERTINGGAL (2026-10-26) — Generate yang dimulakan oleh page INI.
    //   milik = progressId larian page ini (hook tidak menyentuh doc-nya)
    //   aktif = productId -> bilangan larian yang sedang berjalan (hook tidak menulis kad itu)
    //   Lihat hooks/useHasilGenerateTertinggal.js.
    const sesiJanaRef = useRef({ milik: new Set(), aktif: new Map() });
    const tandaJanaAktif = (productId, beza) => {
        const aktif = sesiJanaRef.current.aktif;
        const baki = (aktif.get(productId) || 0) + beza;
        if (baki > 0) aktif.set(productId, baki); else aktif.delete(productId);
    };

    // ============================================
    // SHARED HELPER: Generate AI content for a product
    // Used by: handleParseInput auto-gen, logic selector onChange, regeneration button
    // ============================================
    const generateForProduct = async (productId, logicId, productData = null) => {
        // ★ MODULE MASTER PROMPT: Check if this product has a moduleId with a masterPrompt
        const productRef = productData || products.find(p => p.id === productId);
        const productModuleId = productRef?.moduleId;

        // ★ FLOWNITY: pipeline server OFF — module guna scrape JSON dari Gem/ChatGPT.
        // Return SENYAP di sini (sebelum sebarang status/loading di-set) → product card kekal kosong,
        // takda error "Pipeline Gagal", takda spinner. Buang block ni = ON balik pipeline.
        if (productModuleId === 'flownity' || productModuleId === 'smartcustom') return;

        // ★ GUARD (race first-login): produk ADA moduleId tapi senarai module belum siap
        // dimuat (propModules kosong) → JANGAN generate. Kalau diteruskan, matchedModule=null
        // → generation jatuh ke laluan fallback tanpa master prompt module ("Lain-lain" +
        // hasil bukan gaya module). Pemuat module (App.jsx) auto-pulih dlm 1-2s → cuba semula terus jadi.
        if (productModuleId && (!propModules || propModules.length === 0)) {
            console.warn(`[generateForProduct] Modules belum siap dimuat — abort "${productRef?.name || productId}" (moduleId=${productModuleId})`);
            setProducts(prev => prev.map(p => p.id === productId ? {
                ...p,
                isGenerating: false,
                generationFailed: true,
                generatingStatus: { phase: 'error', detail: T('ws.gen.modulesNotReady', 'Senarai module belum siap dimuat. Tunggu 1-2 saat, kemudian cuba Generate semula.'), stepIndex: 0 },
            } : p));
            return;
        }

        const matchedModule = productModuleId && propModules ? propModules.find(m => m.id === productModuleId) : null;

        let logic;
        let resolvedAvatar = null;
        let useServerMasterPrompt = false;
        if (matchedModule) {
            // ★ SERVER-SIDE MASTER PROMPT RESOLUTION
            // Master prompt stays in Firestore (secret); server reads + resolves it per-call.
            // Non-admin users never receive the prompt text — just pass moduleId.
            resolvedAvatar = propSavedAvatars?.find(a => a.id === productRef?.avatarId) || null;
            const mode = determineMode(productRef, resolvedAvatar);
            console.log('[generateForProduct] ★ Using MODULE (server-resolved) for:', productModuleId, '| mode:', mode, '| avatar:', resolvedAvatar?.id || 'none', '| gender:', productRef?.gender || 'none');
            useServerMasterPrompt = true;
            // Satu salinan dalam utils/susunHasilGenerate.js (dipakai juga oleh laluan hasil tertinggal).
            logic = logikDariModule(matchedModule, productModuleId);
        } else {
            // Fallback: use existing persona/logic system
            logic = logicOptions.find(l => l.id === logicId);
            if (!logic && logicOptions.length > 0) {
                console.warn('[generateForProduct] Logic not found:', logicId, '→ falling back to:', logicOptions[0].id);
                logic = logicOptions[0];
            }
            if (!logic) {
                console.warn('[generateForProduct] No logic options available at all');
                return;
            }
        }

        // Mandatory fields now come directly from shared system_spaces persona
        console.log('[generateForProduct] Mandatory fields:', {
            imageLen: (logic.mandatoryImageAppend || '').length,
            videoLen: (logic.mandatoryVideoAppend || '').length
        });


        let unsubscribeProgress = null;
        // ★ HASIL TERTINGGAL (2026-10-26): progressId larian ini — doc dipadam bila hasil sudah
        //   ditulis ke kad; kalau gagal, doc diserah kepada useHasilGenerateTertinggal.
        let progressIdIni = null;
        tandaJanaAktif(productId, +1);

        try {
            // Use passed productData first (for newly added products), fallback to state
            let product = productData || products.find(p => p.id === productId) || {};

            // ★ SPLIT V2: produk split — muat subdoc (intel + teks) SEBELUM keputusan
            //   routing. Tanpa ini `usingIntelligence` sentiasa false → skip Stage 1+2
            //   mati senyap → kos OpenAI naik. Gagal muat → throw → generationFailed.
            if (needsDetail(product)) {
                await hydrateDetails(product, { throwOnError: true });
            }
            product = withDetail(product);

            // Check intelligence cache before setting initial loading state
            const cachedIntelligence = product.intelligenceData;
            const usingIntelligence = !!(cachedIntelligence && (cachedIntelligence.imageAnalysis || cachedIntelligence.webResearch));

            // ★ WAJIB ADA DATA (2026-07-28) — Stage 1 (analisa gambar) + Stage 2 (carian web)
            //   dah OFF KEKAL untuk semua module. Maknanya generation bergantung 100% pada data
            //   produk yang di-scrape masa Import di Extension SESAAT. Produk tanpa data = AI
            //   cuma ada nama produk → hasil sampah TAPI kuota tetap terbakar.
            //   Sekat SEBELUM loading state & sebelum panggilan server → kuota tak berkurang.
            //   Throw (bukan return) supaya kad papar sebab + butang Retry, bukan diam-diam gagal.
            if (!usingIntelligence && !matchedModule?.skipStages12) {
                throw new Error(T('ws.gen.noData', 'Produk ini tiada data produk. Sila import semula produk ini menggunakan butang Import di dalam Extension SESAAT, kemudian tarik masuk semula ke Workspace.'));
            }

            // Set loading state with initial progress
            // If intelligence cache is used, show all 3 stages with 1+2 pre-marked as done
            setProducts(prev => prev.map(p => p.id === productId ? {
                ...p,
                isGenerating: true,
                generatingStatus: {
                    phase: usingIntelligence ? 'generating' : 'starting',
                    detail: usingIntelligence
                        ? T('ws.gen.status.cached', 'Intelligence cached — skipping analysis...')
                        : T('ws.gen.status.init', 'Initializing...'),
                    stepIndex: usingIntelligence ? 2 : 0,
                    totalSteps: 3,
                    hasImage: usingIntelligence ? true : !!(product.imageBase64 || product.imageUrl),
                    steps: []
                }
            } : p));

            // Progress callback from aiService — sets up Firestore listener for real-time updates
            const onProgress = (currentIndex, totalSets, setLabel, phase, progressId) => {
                if (progressId && auth.currentUser && !progressIdIni) {
                    // Larian ini milik page ini — hook hasil tertinggal tidak menyentuh doc-nya.
                    progressIdIni = progressId;
                    sesiJanaRef.current.milik.add(progressId);
                    // Doc lama kad yang sama (Generate terdahulu yang gagal / tertinggal) sudah basi.
                    buangDocLainUntukKad(auth.currentUser.uid, productId, progressId);
                }
                if (progressId && auth.currentUser) {
                    // Listen to Firestore progress doc for real-time updates from Cloud Function
                    const progressDocRef = doc(db, 'users', auth.currentUser.uid, 'generation_progress', progressId);
                    unsubscribeProgress = onSnapshot(progressDocRef, (snap) => {
                        if (!snap.exists()) return;
                        const data = snap.data();
                        setProducts(prev => prev.map(p => p.id === productId ? {
                            ...p,
                            generatingStatus: {
                                phase: data.phase,
                                detail: data.detail,
                                stepIndex: data.stepIndex || 0,
                                totalSteps: data.totalSteps || 3,
                                // Preserve hasImage:true if set initially (intelligence run shows all 3 stages)
                                hasImage: data.hasImage || p.generatingStatus?.hasImage || false,
                                steps: buildStepList({ ...data, hasImage: data.hasImage || p.generatingStatus?.hasImage || false })
                            }
                        } : p));
                    });
                }
            };

            // If product already has cached intelligence data (stage 1+2), skip straight to stage 3
            let combinedResult;
            // GOYANG template resolution — single-source pattern. Lihat CLAUDE.md "Template Selection
            // Architecture". Sidebar TIADA pengaruh pada produk yang dah stamped — committed decision.
            //
            // Source ikut prioriti:
            //   1. product.templateId — stamped masa Generate kali sebelum ini. Retry / regenerate /
            //      generate-after-fail SEMUA baca dari sini. Sidebar tukar TAK affect.
            //   2. localStorage 'goyang_selectedTemplateId' — first-time Generate je. Live sidebar
            //      selection, race-immune (bukan React state). Stamp ke produk doc lepas resolve.
            //
            // propSelectedTemplate (React state) TIDAK digunakan untuk generate logic — race condition source.
            // Dia kekal untuk legacy badge display + flow input fallback je (produk lama pre-fix).
            let goyangTemplateId = null;
            let goyangTemplate = null;
            let goyangTemplateSource = '';
            if (productModuleId === 'goyang') {
                if (productRef?.templateId) {
                    goyangTemplateId = productRef.templateId;
                    goyangTemplate = productRef.templateSnapshot || null;
                    goyangTemplateSource = 'product.templateId (stamped)';
                } else {
                    // First-time Generate — baca dari localStorage (single source untuk sidebar selection)
                    const localId = (typeof localStorage !== 'undefined' && localStorage.getItem('goyang_selectedTemplateId')) || '';
                    if (localId) {
                        goyangTemplateId = localId;
                        // Resolve snapshot object: prefer propSelectedTemplate kalau ID match (instant),
                        // fallback fetch fresh dari Firestore kalau React state belum sync.
                        if (propSelectedTemplate?.id === localId) {
                            goyangTemplate = propSelectedTemplate;
                        } else {
                            try {
                                const list = await listTemplates('goyang');
                                goyangTemplate = list.find(t => t.id === localId) || null;
                            } catch (err) {
                                console.warn('[generateForProduct] Failed fetch template fresh:', err);
                            }
                        }
                        goyangTemplateSource = 'localStorage';
                    }
                }
                console.log('[generateForProduct] 🔎 GOYANG templateId at generate:', goyangTemplateId
                    ? { id: goyangTemplateId, source: goyangTemplateSource }
                    : '⚠ NULL — no stamp on produk AND no sidebar selection');

                // Guard: GOYANG WAJIB ada template. Tanpa template, master prompt takda hook/bg fragments
                // → output mengarut. Throw explicit error instead of silent fail dengan template kosong.
                if (!goyangTemplateId) {
                    throw new Error(T('ws.gen.goyangNeedTemplate', 'GOYANG memerlukan template. Sila pilih template di sidebar sebelum cuba lagi.'));
                }

                // ★ STAMP templateId ke produk doc — lock-in commitment. Subsequent retry/regenerate
                // baca dari sini (sidebar-immune). Stamp BEFORE server call supaya fail case pun ada
                // templateId untuk retry. Snapshot stamped sama untuk UI badge + flow input cache.
                //
                // Functional setState — jangan clobber isGenerating yang baru di-set di atas.
                // saveProduct (single doc) — non-blocking, elak whole-list rewrite.
                if (productRef?.templateId !== goyangTemplateId
                    || (goyangTemplate && !productRef?.templateSnapshot)) {
                    setProducts(prev => prev.map(p => p.id === productId ? {
                        ...p,
                        templateId: goyangTemplateId,
                        ...(goyangTemplate ? { templateSnapshot: goyangTemplate } : {})
                    } : p));
                    if (auth.currentUser) {
                        saveProduct(auth.currentUser.uid, {
                            ...productRef,
                            templateId: goyangTemplateId,
                            ...(goyangTemplate ? { templateSnapshot: goyangTemplate } : {})
                        }).catch(err => console.warn('[generateForProduct] Template stamp save failed:', err));
                    }
                }
            }

            // ★ PRO MODE (PLAN_PROSTUDIO_BLOCKS.md) — prioriti SAMA seperti template GOYANG:
            //   1. product.proMode (dicop masa Generate sebelum ini) — Retry/regenerate baca dari sini.
            //   2. suis composer (prop proModeAktif) — Generate kali PERTAMA sahaja.
            //   Card = keputusan yang sudah komited; suis bertukar tidak mengubah card lama.
            //   Server hanya menerima TANDA; teks blocks dibaca server sendiri dari akaun.
            const proModeDipakai = productModuleId === 'goyang'
                && (typeof productRef?.proMode === 'boolean' ? productRef.proMode : !!proModeAktif);
            if (proModeDipakai && productRef?.proMode !== true) {
                // Cop SEBELUM panggilan server supaya kes gagal pun ada tanda untuk Retry.
                // Medan template disertakan supaya tulisan ini tidak menggugurkan cop template
                // yang baru sahaja ditulis oleh blok di atas.
                const copPro = {
                    ...(goyangTemplateId ? { templateId: goyangTemplateId } : {}),
                    ...(goyangTemplate ? { templateSnapshot: goyangTemplate } : {}),
                    proMode: true,
                };
                setProducts(prev => prev.map(p => p.id === productId ? { ...p, ...copPro } : p));
                if (auth.currentUser) {
                    saveProduct(auth.currentUser.uid, { ...productRef, ...copPro })
                        .catch(err => console.warn('[generateForProduct] Pro Mode stamp save failed:', err));
                }
            }

            // ★ SUB-MODULE resolution — same pattern as GOYANG template.
            // 1. product.subModuleId (stamped) — retry/regenerate baca dari sini, sidebar-immune.
            // 2. propSelectedSubModuleId (localStorage) — first-time Generate sahaja.
            let _subModuleId = null;
            const activeMod = (propModules || []).find(m => m.id === productModuleId);
            if (activeMod?.hasSubModules) {
                if (productRef?.subModuleId) {
                    _subModuleId = productRef.subModuleId;
                } else {
                    _subModuleId = propSelectedSubModuleId
                        || (typeof localStorage !== 'undefined' && localStorage.getItem(`${productModuleId}_selectedSubModuleId`))
                        || null;
                }
                if (!_subModuleId) {
                    /* `subModuleLabel` datang dari Firestore (teks admin) — ia DATA, bukan ayat UI. */
                    const labelSub = activeMod.subModuleLabel || T('ws.gen.subModuleFallback', 'teknik');
                    throw new Error(T('ws.gen.needSubModule', `Module ini memerlukan pilihan ${labelSub}. Sila pilih di sidebar sebelum Generate.`, { label: labelSub }));
                }
                // Stamp subModuleId ke produk doc
                if (productRef?.subModuleId !== _subModuleId) {
                    setProducts(prev => prev.map(p => p.id === productId ? { ...p, subModuleId: _subModuleId } : p));
                    if (auth.currentUser) {
                        saveProduct(auth.currentUser.uid, { ...productRef, subModuleId: _subModuleId })
                            .catch(err => console.warn('[generateForProduct] SubModule stamp save failed:', err));
                    }
                }
                console.log(`[generateForProduct] ★ Sub-module: "${_subModuleId}" for module ${productModuleId}`);
            }

            const _genSceneCount = getSceneCount({ moduleId: productModuleId, smartcustomSceneCount: product?.smartcustomSceneCount });

            // ★ FLOWNITY: override product gender dengan Suara Watak pilihan user
            const productForGen = (productModuleId === 'flownity' && propFlownityVoice)
                ? { ...product, gender: propFlownityVoice }
                : product;

            const genOptions = useServerMasterPrompt
                ? { avatar: resolvedAvatar, moduleId: productModuleId, templateId: goyangTemplateId, proMode: proModeDipakai, sceneCount: _genSceneCount, subModuleId: _subModuleId }
                : { avatar: resolvedAvatar, sceneCount: _genSceneCount };

            // Routing rules (2026-07-28 — Stage 1+2 OFF KEKAL untuk SEMUA module):
            // - Stage 3 SAHAJA. Data scrape (dari Import di Extension) atau cache intelligence
            //   sedia ada disuap terus ke penjana prompt. Stage 2 (carian web) hilang sepenuhnya
            //   = bahagian paling mahal. Tukar-ganti diterima user: AI tak "tengok" gambar sebenar.
            // - Produk TANPA data dah disekat lebih awal (guard "WAJIB ADA DATA" di atas) → laluan
            //   penuh Stage 1+2+3 tak lagi tercapai untuk module biasa.
            // - Baki laluan generateProductContent = module ber-flag skipStages12 sahaja (server pun
            //   skip Stage 1+2 untuk flag tu) — dikekalkan supaya module macam FLOWNITY tak rosak.
            // Open untuk semua tier; cost-protection via coin (trial) atau daily cap (paid).
            const moduleSkipsStages12 = !!(matchedModule?.skipStages12);
            const canSkipStages = !moduleSkipsStages12 && usingIntelligence;

            if (canSkipStages) {
                console.log(`[generateForProduct] ★ Stage 3 only for "${productForGen.name}" (module: ${productModuleId}, intelligence: ${cachedIntelligence.sourceType || 'cache'})`);
                combinedResult = await aiService.generateFromIntelligence(productForGen, cachedIntelligence, logic, onProgress, genOptions);
            } else {
                console.log(`[generateForProduct] ★ Module ${productModuleId} ber-flag skipStages12 — Stage 1+2 di-skip di server`);
                combinedResult = await aiService.generateProductContent(productForGen, logic, onProgress, genOptions);
            }

            // Cleanup listener
            if (unsubscribeProgress) unsubscribeProgress();

            // Map combined result to product prompts + store raw output
            // Use a captured variable so we can save to cloud AFTER state update
            let finalProducts = null;
            setProducts(prev => {
                const current = prev.find(p => p.id === productId);
                if (!current) return prev;

                // ⚠️ Susunan prompt kad = SATU salinan dalam utils/susunHasilGenerate.js — dipakai juga
                //    oleh laluan "hasil tertinggal" (page kembali selepas ditutup semasa Generate).
                const { newPrompts, rawOutput, intelligenceToSave } = susunHasilGenerate({
                    current, combinedResult, logic,
                    appendProduct: productData || current,
                    appendAvatar: propSavedAvatars?.find(a => a.id === (productData || current)?.avatarId) || null,
                    intelSimpanan: detailCacheRef.current.get(productId)?.intelligenceData || null,
                });

                finalProducts = prev.map(p => p.id === productId ? {
                    ...p,
                    prompts: newPrompts,
                    rawOutput,
                    intelligenceData: intelligenceToSave,
                    // ★ Template lock-in pada produk doc — lihat CLAUDE.md "Template Selection Architecture".
                    //   `templateId` = source of truth (server fetch fresh menggunakan ID ni).
                    //   `templateSnapshot` = denormalized cache untuk UI badge + flow input je.
                    ...(goyangTemplateId ? { templateId: goyangTemplateId } : {}),
                    ...(goyangTemplate ? { templateSnapshot: goyangTemplate } : {}),
                    // ★ Pro Mode lock-in (PLAN_PROSTUDIO_BLOCKS.md) — Retry/regenerate baca dari sini.
                    ...(proModeDipakai ? { proMode: true } : {}),
                    // ★ Template trace — Cloud Function logged per-set fragments USED vs MISSING.
                    //   Untuk debug: confirm AI dapat fragment description yang betul.
                    ...(combinedResult?._templateTrace ? { templateTrace: combinedResult._templateTrace } : {}),
                    // (debug log dah dipindah ke luar setProducts updater — jangan log dalam updater function)
                    isGenerating: false,
                    generationFailed: null,
                    generatingStatus: null
                } : p);
                return finalProducts;
            });
            // ★ SPLIT V2: prime cache teks hasil generation — selepas feed gantikan
            //   state dgn doc ringan, paparan (expand/Run) kekal ada teks tanpa getDoc.
            if (finalProducts) {
                const fpNew = finalProducts.find(p => p.id === productId);
                if (fpNew && (fpNew.splitV === 2 || isSplitEnabled())) {
                    primeDetailCache(productId, {
                        prompts: fpNew.prompts,
                        intelligenceData: fpNew.intelligenceData,
                        rawOutput: fpNew.rawOutput,
                    });
                }
            }
            // Save to Firestore AFTER state update (not inside the updater)
            // Small delay to let React batch with other concurrent updates
            await new Promise(r => setTimeout(r, 100));
            if (finalProducts) saveToCloud(finalProducts);
            // Hasil sudah dalam kad → salinan dalam peti progress tidak diperlukan lagi.
            // ⛔ finalProducts null = page ini sudah ditutup (setState tidak berjalan) → JANGAN
            //    padam; Workspace yang dibuka semula mengambil hasil dari doc itu.
            if (finalProducts && progressIdIni && auth.currentUser) padamDocProgress(auth.currentUser.uid, progressIdIni);
        } catch (error) {
            console.error('[generateForProduct] Failed for', productId, error);
            if (unsubscribeProgress) unsubscribeProgress();
            // Serah doc kepada hook hasil tertinggal: kalau server tetap siap (cth had masa 5 min
            // client tamat dahulu), hasil itu masih masuk kad bila server menulisnya.
            if (progressIdIni) sesiJanaRef.current.milik.delete(progressIdIni);
            // Keep overlay visible with failed state + retry info
            setProducts(prev => prev.map(p => p.id === productId ? {
                ...p,
                isGenerating: false,
                generationFailed: {
                    error: error.message || T('ws.gen.unknownError', 'Ralat tidak diketahui.'),
                    logicId: logicId,
                    failedAt: Date.now(),
                    // 'unavailable' = gangguan di pihak kita (kredit OpenAI habis, OpenAI down).
                    // Kad akan SOROK butang Retry — tekan berulang tak membantu, cuma
                    // membebankan sistem yang memang tengah bermasalah.
                    systemSide: error.code === 'unavailable'
                },
                generatingStatus: null
            } : p));
        } finally {
            tandaJanaAktif(productId, -1);
        }
    };

    // Helper: Build step list for multi-step progress overlay
    const buildStepList = (progressData) => {
        const { phase, hasImage, stepIndex } = progressData;
        const steps = [];
        if (hasImage) {
            /* ⛔ `id` + `icon` bukan ayat UI — `id` dibanding oleh logik status
               langkah, `icon` ialah nama ikon Material. Hanya label/detail
               yang dibaca pelanggan. */
            steps.push({ id: 'vision', icon: 'visibility', label: T('ws.gen.step.vision.label', 'Image Analysis'), detail: T('ws.gen.step.vision.detail', 'Analyzing product image...') });
        }
        steps.push({ id: 'research', icon: 'travel_explore', label: T('ws.gen.step.research.label', 'Web Research'), detail: T('ws.gen.step.research.detail', 'Searching web for product info...') });
        steps.push({ id: 'generate', icon: 'auto_awesome', label: T('ws.gen.step.generate.label', 'Creative Generation'), detail: T('ws.gen.step.generate.detail', 'Generating high-quality content...') });

        // Mark step statuses — pipeline order: vision â†' research â†' generate
        const phaseOrder = hasImage
            ? ['analyzing_image', 'researching', 'generating', 'complete']
            : ['researching', 'generating', 'complete'];
        const currentPhaseIdx = phaseOrder.indexOf(phase);

        return steps.map((step, i) => ({
            ...step,
            status: i < currentPhaseIdx ? 'done' : i === currentPhaseIdx ? 'active' : 'pending'
        }));
    };

    // ★ HASIL TERTINGGAL (2026-10-26) — Generate yang dimulakan sebelum page ini dibuka
    //   (pelanggan ke page lain / refresh semasa Generate). Hook mencari doc progress;
    //   pengendali di bawah menulis kad. Susunan prompt = susunHasilGenerate (salinan sama
    //   dengan generateForProduct). Lihat hooks/useHasilGenerateTertinggal.js.
    useHasilGenerateTertinggal({
        uid: auth.currentUser?.uid || null,
        products,
        sesiIni: sesiJanaRef,
        pengendali: {
            onJalan: (productId, data) => {
                setProducts(prev => prev.map(p => {
                    if (p.id !== productId) return p;
                    // generateFromIntelligence (totalSteps 1) dipapar 3 langkah, 1+2 siap — sama seperti laluan biasa.
                    const hasImage = !!(data.hasImage || p.generatingStatus?.hasImage || data.totalSteps === 1);
                    return {
                        ...p,
                        isGenerating: true,
                        generationFailed: null,
                        generatingStatus: {
                            phase: data.phase,
                            detail: data.detail,
                            stepIndex: data.stepIndex || 0,
                            totalSteps: data.totalSteps || 3,
                            hasImage,
                            steps: buildStepList({ ...data, hasImage })
                        }
                    };
                }));
            },
            // Sebelum doc dituntut: kad split mesti ada intel dalam cache, kalau tidak
            // intelligenceData tersimpan null. Melontar = doc tidak dituntut, cuba lagi kemudian.
            sedia: async (productId) => {
                const kad = productsRef.current.find(p => p.id === productId);
                if (kad && needsDetail(kad)) await hydrateDetails(kad, { throwOnError: true });
            },
            onSiap: async (productId, combinedResult) => {
                const kad = productsRef.current.find(p => p.id === productId);
                if (!kad) return;
                const matchedModule = kad.moduleId && propModules ? propModules.find(m => m.id === kad.moduleId) : null;
                const logic = matchedModule
                    ? logikDariModule(matchedModule, kad.moduleId)
                    : (logicOptions.find(l => l.id === kad.logicId) || logicOptions[0] || null);
                if (!logic) {
                    // Senarai module / logic belum dimuat — gagal JELAS, jangan tulis kad tanpa ayat wajib.
                    setProducts(prev => prev.map(p => p.id === productId ? {
                        ...p, isGenerating: false, generatingStatus: null,
                        generationFailed: { error: T('ws.gen.tertinggal.tiadaLogic', 'Hasil Generate tidak dapat dimasukkan kerana tetapan module belum dimuat. Sila tekan Retry.'), logicId: kad.logicId || null, failedAt: Date.now(), systemSide: false }
                    } : p));
                    return;
                }
                let finalProducts = null;
                setProducts(prev => {
                    const current = prev.find(p => p.id === productId);
                    if (!current) return prev;
                    const { newPrompts, rawOutput, intelligenceToSave } = susunHasilGenerate({
                        current, combinedResult, logic,
                        appendProduct: current,
                        appendAvatar: propSavedAvatars?.find(a => a.id === current.avatarId) || null,
                        intelSimpanan: detailCacheRef.current.get(productId)?.intelligenceData || null,
                    });
                    // Cop template / Pro Mode sudah ditulis ke kad SEBELUM panggilan server — tidak diulang.
                    finalProducts = prev.map(p => p.id === productId ? {
                        ...p,
                        prompts: newPrompts,
                        rawOutput,
                        intelligenceData: intelligenceToSave,
                        ...(combinedResult?._templateTrace ? { templateTrace: combinedResult._templateTrace } : {}),
                        isGenerating: false,
                        generationFailed: null,
                        generatingStatus: null
                    } : p);
                    return finalProducts;
                });
                if (!finalProducts) return;
                const fpNew = finalProducts.find(p => p.id === productId);
                if (fpNew && (fpNew.splitV === 2 || isSplitEnabled())) {
                    primeDetailCache(productId, { prompts: fpNew.prompts, intelligenceData: fpNew.intelligenceData, rawOutput: fpNew.rawOutput });
                }
                await new Promise(r => setTimeout(r, 100));
                saveToCloud(finalProducts);
                console.log(`[HasilTertinggal] ✅ Hasil Generate diambil untuk "${fpNew?.name || productId}" (page ditutup semasa Generate)`);
            },
            onGagal: (productId, { jenis, mesej, kod } = {}) => {
                const ayat = {
                    mati: T('ws.gen.tertinggal.terhenti', 'Generate terhenti sebelum siap. Sila tekan Retry.'),
                    terlaluBesar: T('ws.gen.tertinggal.terlaluBesar', 'Hasil Generate terlalu besar untuk disimpan. Sila tekan Retry.'),
                    kosong: T('ws.gen.tertinggal.kosong', 'Generate tidak memulangkan hasil. Sila tekan Retry.'),
                    rosak: T('ws.gen.tertinggal.kosong', 'Generate tidak memulangkan hasil. Sila tekan Retry.'),
                };
                setProducts(prev => prev.map(p => {
                    // Kad yang sudah bertanda gagal (laluan biasa) — kekalkan mesej asalnya.
                    if (p.id !== productId || p.generationFailed) return p;
                    return {
                        ...p,
                        isGenerating: false,
                        generatingStatus: null,
                        generationFailed: {
                            error: jenis === 'ralat' ? (mesej || T('ws.gen.unknownError', 'Ralat tidak diketahui.')) : (ayat[jenis] || ayat.kosong),
                            logicId: p.logicId || null,
                            failedAt: Date.now(),
                            systemSide: kod === 'unavailable'
                        }
                    };
                }));
            },
            onHilang: (productId) => {
                setProducts(prev => prev.map(p => (p.id === productId && p.isGenerating)
                    ? { ...p, isGenerating: false, generatingStatus: null }
                    : p));
            },
        },
    });

    // Listen for new products added from the header bar (App.jsx)
    // and auto-generate AI content, same as handleParseInput does
    useEffect(() => {
        const handleNewProducts = async (event) => {
            const { newProducts } = event.detail || {};
            if (!newProducts || newProducts.length === 0) return;

            // Select the first new product immediately
            setSelectedProductId(newProducts[0].id);

            // IMPORTANT: Inject new products into local state FIRST with isGenerating: true
            // This fixes the missing loading overlay — without this, the products haven't
            // arrived via Firestore onSnapshot yet, so setProducts(prev.map(...)) in
            // generateForProduct can't find the product to set isGenerating on.
            const productsWithGenerating = newProducts.map(p => {
                // ★ FLOWNITY: pipeline OFF — card KOSONG, takda loading/auto-gen (guna scrape Gem/ChatGPT)
                // ★ WAJIB ADA DATA (2026-07-28): produk tanpa data scrape pun TIADA auto-gen —
                //   kalau tidak, overlay loading berpusing selamanya sebab tiada generate dilancar.
                const pipelineOff = p.moduleId === 'flownity' || p.moduleId === 'smartcustom' || !hasGenerationData(p);
                return {
                    ...p,
                    isGenerating: pipelineOff ? false : !!p.logicId,
                    generatingStatus: (!pipelineOff && p.logicId) ? {
                        phase: 'starting',
                        detail: T('ws.gen.status.init', 'Initializing...'),
                        stepIndex: 0,
                        totalSteps: 3,
                        hasImage: !!(p.imageBase64 || p.imageUrl),
                        steps: []
                    } : null
                };
            });

            setProducts(prev => {
                // Merge: add new products that don't already exist
                const existingIds = new Set(prev.map(p => p.id));
                const toAdd = productsWithGenerating.filter(p => !existingIds.has(p.id));
                return [...prev, ...toAdd];
            });

            /* ---------- Lompat ke tab destinasi (v3.9) --------------------
               Tab Generate v3.9 tidak memaparkan sebarang kad, jadi tanpa
               lompatan ini pengguna menekan Generate dan melihat skrin yang
               langsung tidak berubah — kerja berjalan di belakang tabir tanpa
               satu pun tanda di skrin.

               Destinasi dibaca daripada kad itu sendiri melalui getProductTab,
               BUKAN dengan menulis semula senarai module di sini: FLOWNITY dan
               Smart Custom mendarat di Agent AI, selebihnya di Flow. Satu
               tekanan Generate menjana satu module sahaja (module diambil
               daripada sidebar), jadi kad pertama sudah mewakili kesemuanya.

               Ditetapkan tanpa syarat — React sendiri berhenti apabila nilainya
               sama, dan membandingkan dengan `activeTab` di sini bermakna
               membaca nilai yang sudah basi daripada closure pendengar ini.

               Rupa lama tidak melompat: tab "All" di sana memang sudah
               memaparkan kad baharu itu. */
            if (uiV39 && productsWithGenerating.length > 0) {
                setActiveTab(getProductTab(productsWithGenerating[0]));
            }

            // Staggered concurrent — 2s delay between each API call start
            // ★ WAJIB ADA DATA (2026-07-28): produk tanpa data scrape dilangkau + user diberitahu.
            const _genCandidates = newProducts.filter(p => p.logicId && p.moduleId !== 'flownity' && p.moduleId !== 'smartcustom');
            const productsToGen = _genCandidates.filter(hasGenerationData);
            const _skippedNoData = _genCandidates.length - productsToGen.length;
            if (_skippedNoData > 0) {
                alert(T('ws.alert.skippedNoData', `${_skippedNoData} produk ditarik masuk tetapi TIDAK dijana kerana tiada data produk.\n\nSila import produk tersebut menggunakan butang Import di dalam Extension SESAAT, kemudian tarik masuk semula ke Workspace.`, { n: _skippedNoData }));
            }
            if (productsToGen.length > 0) {
                const proceed = await ensureQuotaForBulk(productsToGen.length);
                if (!proceed) return;
            }
            const generatePromises = productsToGen.map((newProduct, i) =>
                new Promise(resolve => setTimeout(resolve, i * 2000))
                    .then(() => generateForProduct(newProduct.id, newProduct.logicId, newProduct))
                    .catch(err => console.error(`[AutoGen] Failed for "${newProduct.name}":`, err))
            );
            await Promise.allSettled(generatePromises);
        };

        window.addEventListener('SESAAT_NEW_PRODUCTS', handleNewProducts);
        return () => window.removeEventListener('SESAAT_NEW_PRODUCTS', handleNewProducts);
        // Re-attach when logicOptions change so generateForProduct has fresh data.
        // `uiV39` turut disenaraikan: suis itu bermula mati dan hidup kemudian
        // apabila config selesai dibaca, jadi tanpa ia di sini pendengar akan
        // kekal memegang nilai `false` yang sudah basi dan lompatan tab di atas
        // tidak akan berlaku langsung.
        // `proModeAktif` (PLAN_PROSTUDIO_BLOCKS.md) — perangkap yang SAMA: suis Pro Mode
        // menjadi aktif hanya selepas blocks pelanggan selesai dibaca (onSnapshot), jadi
        // pendengar yang dipasang semasa mount memegang `false` yang basi dan SETIAP
        // Generate dari composer jatuh ke enjin default walaupun chip menunjukkan ON.
        // Ditangkap 2026-09-10 pada larian sebenar (log server: MODULE mode, kad tanpa cop).
    }, [logicOptions, uiV39, proModeAktif]);

    // Update prompt for current set
    const handlePromptChange = (field, value) => {
        if (!selectedProduct) return;

        const currentPrompts = selectedProduct.prompts || getEmptyPromptCollection();
        const currentSet = currentPrompts[activeSet] || { promptImage: '', promptVideo: '', captionTiktok: '' };

        const updatedPrompts = {
            ...currentPrompts,
            [activeSet]: {
                ...currentSet,
                [field]: value
            }
        };

        updateProduct(selectedProductId, { prompts: updatedPrompts });
    };

    // Delete product — ★ also cleans up video files from Firebase Storage
    const handleDeleteProduct = (productId) => {
        const productToDelete = products.find(p => p.id === productId);
        const updated = products.filter(p => p.id !== productId);
        isFromCloudRef.current = true;
        setProducts(updated);
        if (selectedProductId === productId) {
            setSelectedProductId(updated[0]?.id || null);
        }
        // ★ CRITICAL: Use pendingDeletesRef to prevent App.jsx onSnapshot from re-injecting
        if (auth.currentUser) {
            if (pendingDeletesRef) pendingDeletesRef.current.add(productId);

            // ★ Delete video files from Firebase Storage FIRST
            const videoDeletePromises = [];
            if (productToDelete?.prompts) {
                for (const setKey of ['set1', 'set2', 'set3']) {
                    const videoUrl = productToDelete.prompts[setKey]?.uploadedVideo;
                    if (videoUrl) {
                        videoDeletePromises.push(deleteVideoFromStorage(videoUrl));
                    }
                }
            }

            // Run video cleanup + Firestore doc delete in parallel
            Promise.allSettled(videoDeletePromises)
                .then(() => removeProduct(auth.currentUser.uid, productId))
                .then(() => {
                    // ★ FIX "padam tak melekat" (2026-07-27): beritahu extension supaya salinan
                    //   video produk ni dlm browser (bytes + penanda local) turut dibuang.
                    //   Dulu padam PRODUK langsung tak hantar apa-apa → salinan duduk kekal.
                    window.postMessage({ type: 'SESAAT_CLEAR_PRODUCT_CACHE', productId }, '*');
                    // Refresh storage bar
                    window.dispatchEvent(new Event('SESAAT_STORAGE_CHANGED'));
                })
                .catch(err => console.warn('[Delete] Delete failed:', err.message))
                .finally(() => { if (pendingDeletesRef) pendingDeletesRef.current.delete(productId); });
            // ★ Pepijat 3 (Langkah 1): buang slot kalendar produk yang dipadam.
            prunProdukDariJadual([productId]);
        }
    };

    // ═══════════════════════════════════════════════════════════
    // ★ DUPLICATE KAD (2026-08-03) — cipta N salinan bagi setiap kad dipilih.
    // Prompt + data produk + template/avatar dibawa; video, thumbnail & status upload
    // TIDAK (lihat DUP_MEDIA_FIELDS di atas fail). Tiada panggilan AI → kuota generation
    // tidak berkurang. Tiada had bilangan salinan (keputusan user 2026-08-03).
    // ═══════════════════════════════════════════════════════════
    const handleDuplicateProducts = async (ids, copies) => {
        if (!auth.currentUser) return;
        const perCard = Math.max(1, Math.floor(Number(copies) || 1));
        const idSet = new Set(ids || []);
        const sources = products.filter(p => idSet.has(p.id));
        if (sources.length === 0) return;

        setIsSaving(true);
        try {
            // ★ SPLIT V2: teks berat duduk dalam subdoc — hydrate DULU. Tanpa ini salinan
            //   lahir kosong tanpa sebarang amaran. Gagal muat = batalkan seluruh operasi
            //   (throwOnError) — lebih baik tiada salinan daripada salinan tanpa prompt.
            await hydrateDetails(sources, { throwOnError: true });
            // ★ 2026-10-06: medan borang "Kad ini sahaja" (`scrapedDataKad`) duduk dalam subdoc tetapi
            //   BUKAN sebahagian laluan simpan biasa — tanpa langkah ini borang Edit data kad salinan
            //   keluar kosong + PENDING. Dibaca di sini, ditulis selepas salinan tersimpan
            //   (utils/editDataProduk.js). Gagal baca = batal, sama peraturan seperti hydrate di atas.
            const uidDup = auth.currentUser.uid;
            const dataKadAsal = await bacaDataKadSahaja({ uid: uidDup, kadIds: sources.map(s => s.id) });

            const usedNames = products.map(p => p.name);
            let maxIndex = products.reduce((m, p) => Math.max(m, p.originalIndex || 0), 0);
            const now = Date.now();
            const created = [];

            sources.forEach((src, si) => {
                const full = withDetail(src);
                const base = dupBaseName(full.name);
                for (let i = 0; i < perCard; i++) {
                    const copyName = `${base} (${nextDupIndex(base, usedNames)})`;
                    usedNames.push(copyName);
                    maxIndex += 1;
                    const clonedPrompts = clonePromptsTextOnly(full.prompts);
                    const hasText = promptsToJson(clonedPrompts) !== '{}';
                    const copy = {
                        // Spread-then-override (corak sama retryProductPipeline): semua medan
                        // identiti — moduleId, logicId, templateSnapshot, avatar, gender,
                        // intelligenceData, scrapedData, spaceId, workspaceGroup — ikut
                        // automatik, termasuk medan baharu yang ditambah kemudian.
                        ...full,
                        id: `prod_${now}_${si}_${i}_${Math.random().toString(36).substring(2, 9)}`,
                        name: copyName,
                        originalIndex: maxIndex,
                        prompts: clonedPrompts,
                        // Kad baharu = belum pernah run: status upload & log bermula kosong.
                        setStatuses: null,
                        logs: [`Salinan daripada "${full.name}" @ ${new Date().toISOString()}`],
                        duplicatedFrom: full.id,
                        // Ada prompt → sedia untuk Run Flow. Tiada prompt (cth kad FLOWNITY
                        // belum scrape) → kekal di tab asalnya supaya tidak "hilang" dari
                        // pandangan user.
                        tab: hasText ? 'flow' : (full.tab || 'flow'),
                        status: hasText ? 'generated' : 'pending',
                        movedAt: now + i,   // sort 'time' desc (default) → salinan muncul di atas
                        selected: false,    // elak salinan ikut terpilih → tekan Duplicate lagi = ganda berganda
                        isGenerating: false,
                        generatingStatus: null,
                        generationFailed: null,
                    };
                    // ★ FASA 2 — buang collection Google Flow milik kad ASAL. Kad salinan
                    //   belum pernah di-Run, jadi ia WAJIB dapat collection sendiri. Kalau
                    //   dibiarkan: (a) kad papar link "Collection Flow" milik orang lain, dan
                    //   (b) Continue Collection akan sambung masuk collection kad asal DAN
                    //   langkau set dalam `deliveredSets` → langsung tiada video baharu.
                    delete copy.collectionUrl;
                    delete copy.deliveredSets;
                    // Biar laluan tulis (_stageProductWrite) yang cop splitV ikut suis semasa.
                    delete copy.splitV;
                    delete copy._detailLoaded;
                    delete copy._isOrphanRecovered;
                    delete copy.lastUpdated;
                    delete copy._pipelineResetAt;
                    // ★ 2026-10-06: pil status per akaun (Posted / Scheduled / Failed) + sebab gagal kad
                    //   ASAL tidak boleh ikut — kad salinan belum ada video dan belum pernah di-post.
                    //   `setStatuses: null` di atas tidak meliputi dua medan ini (utils/kadSalinan.js).
                    buangStatusLarian(copy);
                    created.push(copy);
                }
            });

            const updated = [...products, ...created];
            setProducts(updated);
            // ★ SPLIT V2: prime cache teks salinan — selepas feed gantikan state dengan doc
            //   ringan, kad kekal ada prompt tanpa getDoc tambahan.
            if (isSplitEnabled()) {
                created.forEach(c => primeDetailCache(c.id, {
                    prompts: c.prompts,
                    intelligenceData: c.intelligenceData,
                    rawOutput: c.rawOutput,
                }));
            }
            const res = await saveToCloud(updated);
            if (res && res.ok) {
                // Kad salinan sudah tersimpan → baru tulis medan borang "Kad ini sahaja" kad asalnya.
                // Gagal di sini ≠ gagal Duplicate, tetapi pelanggan WAJIB tahu (borang salinan kosong).
                const perluData = created
                    .filter(c => dataKadAsal.has(c.duplicatedFrom))
                    .map(c => ({ id: c.id, scrapedDataKad: dataKadAsal.get(c.duplicatedFrom) }));
                let dataKadGagal = false;
                try {
                    await tulisDataKadSalinan({ uid: uidDup, senarai: perluData });
                } catch (e) {
                    dataKadGagal = true;
                    console.error('[Duplicate] Medan "Kad ini sahaja" gagal disalin:', e);
                }
                if (dataKadGagal) {
                    toast.error(T('ws.dup.dataKadFailed', `${created.length} salinan dibuat, tetapi data produk yang disunting pada kad asal tidak dapat disalin. Sila padam salinan itu dan Duplicate sekali lagi.`, { n: created.length }));
                } else {
                    toast.success(T('ws.dup.success', `${created.length} salinan dibuat — sedia untuk Run Flow. Kuota generation tidak digunakan.`, { n: created.length }));
                }
            }
            // Simpan gagal → banner ralat saveToCloud (+ salinan clipboard) yang bercakap.
        } catch (err) {
            console.error('[Duplicate] Failed:', err);
            const sebabDup = err.message || T('ws.dup.tryAgain', 'Cuba lagi');
            toast.error(T('ws.dup.failed', `Gagal buat salinan: ${sebabDup}`, { msg: sebabDup }));
        } finally {
            setIsSaving(false);
        }
    };

    // ★ RETRY PIPELINE: Reset product to fresh state, then auto-run AI generation
    // `tanpaSoal` — laluan pukal sudah bertanya SEKALI untuk semua kad; tanpa
    // ini pengguna dihujani satu kotak `confirm` bagi setiap produk dipilih.
    const handleRetryPipeline = async (product, { tanpaSoal = false } = {}) => {
        if (!auth.currentUser) return;
        /* Nama produk = DATA pelanggan; ia dihantar sebagai pemboleh ubah, bukan diterjemah. */
        const namaKad = product.name || product.id;
        if (!tanpaSoal && !confirm(T('ws.retry.confirm', `Reset "${namaKad}" ke fresh pipeline?\n\nIni akan:\n• Clear semua prompts & captions\n• Reset status ke pending\n• Video sedia ada akan disimpan\n• Pipeline AI akan run semula secara automatik`, { name: namaKad }))) return;
        try {
            const resetData = await retryProductPipeline(auth.currentUser.uid, product.id, product);
            // ★ SPLIT V2: buang cache teks — subdoc dah dipadam teksnya; kalau cache
            //   kekal, teks lama resurrect pada paparan/Run bila generation gagal.
            //   Hydrate seterusnya ambil fresh dari cloud (intel masih ada di subdoc).
            detailCacheRef.current.delete(product.id);
            setDetailReadyTick(t => t + 1);
            // ⚠️ Bentuk fungsi (prev => …) WAJIB. Laluan pukal memanggil ini
            //    berkali-kali berturut-turut; membaca `products` daripada closure
            //    bermakna setiap panggilan bermula daripada senarai yang SAMA dan
            //    hanya reset terakhir tinggal pada skrin.
            setProducts(prev => prev.map(p => p.id === product.id ? { ...resetData, id: product.id } : p));

            // Auto-run the AI pipeline with the product's logic or first available
            const logicId = product.logicId || (logicOptions.length > 0 ? logicOptions[0].id : null);
            if (logicId) {
                generateForProduct(product.id, logicId, { ...resetData, id: product.id })
                    .catch(err => console.error(`[RetryPipeline] Generation failed for "${product.name}":`, err));
            }
        } catch (err) {
            console.error('[RetryPipeline] Failed:', err);
            alert(T('ws.retry.failed', `âŒ Gagal reset: ${err.message}`, { msg: err.message }));
        }
    };

    /* ★ RETRY PUKAL (v3.9) — Retry berpindah daripada setiap kad ke bar pukal,
       mengikut prototaip. Sebabnya: memulihkan larian yang gagal jarang
       dilakukan pada satu kad sahaja; selepas satu batch gagal, yang dikehendaki
       ialah mencuba SEMUA sekali gus.

       ⚠️ Setiap produk = 1 kuota generation. Sebab itu ia melalui gate kuota
          yang SAMA seperti laluan bulk generate lain (`ensureQuotaForBulk`),
          dan kotak pengesahan menyebut angka itu terus terang — tanpa ia,
          satu klik boleh menghabiskan kuota harian pelanggan. */
    const handleBulkRetry = async () => {
        if (!auth.currentUser) return;
        const dipilih = filteredAndSortedProducts.filter(p => p.selected);
        if (dipilih.length === 0) return;
        const soalan = T('ws.retry.bulkConfirm',
            `Jalankan semula pipeline untuk ${dipilih.length} produk?\n\n`
            + `• Prompt & caption sedia ada akan dipadam dan dijana semula\n`
            + `• Video sedia ada KEKAL — ia tidak disentuh\n`
            + `• Menggunakan ${dipilih.length} daripada kuota generation harian anda`,
            { n: dipilih.length });
        if (!confirm(soalan)) return;
        const proceed = await ensureQuotaForBulk(dipilih.length);
        if (!proceed) return;
        for (const p of dipilih) {
            // Berturutan, bukan serentak: setiap reset menulis ke Firestore dan
            // generation dilepaskan tanpa ditunggu, jadi ini sudah memberi jarak
            // semula jadi antara panggilan AI.
            await handleRetryPipeline(p, { tanpaSoal: true });
        }
    };

    // Toggle select
    const handleToggleSelect = (productId) => {
        updateProduct(productId, {
            selected: !products.find(p => p.id === productId)?.selected
        });
    };

    // Get current prompts
    const getCurrentPrompts = () => {
        if (!selectedProduct?.prompts?.[activeSet]) {
            return { promptImage: '', promptVideo: '', captionTiktok: '' };
        }
        return selectedProduct.prompts[activeSet];
    };

    const currentPrompts = getCurrentPrompts();

    // Space Management Handlers
    const handleAddSpace = async () => {
        if (!newSpaceName.trim()) return;
        const newSpace = {
            id: `space_${Date.now()}`,
            name: newSpaceName.trim(),
            icon: 'folder',
            color: ['indigo', 'emerald', 'amber', 'rose', 'violet'][spaces.length % 5]
        };
        const updatedSpaces = [...spaces, newSpace];
        setSpaces(updatedSpaces);
        setNewSpaceName('');
        setIsAddingSpace(false);
        handleSelectSpace(newSpace.id);
        saveSpacesToCloud(updatedSpaces);
    };

    const handleDeleteSpace = (spaceId) => {
        const space = spaces.find(s => s.id === spaceId);
        if (space?.isSystem) return; // System spaces cannot be deleted
        const updatedSpaces = spaces.filter(s => s.id !== spaceId);
        setSpaces(updatedSpaces);
        saveSpacesToCloud(updatedSpaces);
        if (selectedSpaceId === spaceId) {
            handleSelectSpace('default');
        }
    };

    // Per-browser isolation: parent App.jsx will persist selectedSpaceId to
    // localStorage. No Firestore write here — keeps each Chrome profile separate.
    const handleSelectSpace = (spaceId) => {
        if (onSelectSpace) onSelectSpace(spaceId);
    };

    // Per-browser isolation: activeTab persisted to localStorage via the
    // useEffect below — no Firestore write here.
    const handleSwitchTab = (tab) => {
        setActiveTab(tab);
    };

    // Persist UI state to localStorage (per-Chrome-profile, not cross-browser)
    useEffect(() => { localStorage.setItem('activeTab', activeTab); }, [activeTab]);
    useEffect(() => { localStorage.setItem('flowSortType', flowSortType); }, [flowSortType]);
    useEffect(() => { localStorage.setItem('flowSortDirection', flowSortDirection); }, [flowSortDirection]);
    useEffect(() => { localStorage.setItem('tiktokSortType', tiktokSortType); }, [tiktokSortType]);
    useEffect(() => { localStorage.setItem('tiktokSortDirection', tiktokSortDirection); }, [tiktokSortDirection]);

    // ════════════════════════════════════════════════════════════════════════
    // SESAAT UI SYNC BRIDGE (v3.4.0) — webapp side
    // Mirrors UI state to/from the extension popup running in the same Chrome
    // profile via window.postMessage relayed by extension content.ts. Different
    // Chrome profile = different content script, so no cross-browser leakage
    // (per-browser isolation kept intact).
    // ════════════════════════════════════════════════════════════════════════
    const SESAAT_UI_SYNC_TAG = '__sesaat_ui_sync__';
    const SESAAT_ORPHAN_TAG = '__sesaat_orphan__';
    const lastAppliedFromExtRef = useRef({}); // { key: lastValueAppliedFromExt }
    const lastEmittedRef = useRef({}); // { key: lastValueEmittedToExt }
    const [extensionOrphan, setExtensionOrphan] = useState(false);

    // Detect orphaned content script — extension reloaded while this tab was
    // open. Bridge can't write to chrome.storage.local anymore so sync silently
    // fails. content.ts posts __sesaat_orphan__ once when this happens; show a
    // banner offering a one-click refresh.
    useEffect(() => {
        const handler = (event) => {
            if (event.source !== window) return;
            if (event.data?.[SESAAT_ORPHAN_TAG] === true) setExtensionOrphan(true);
        };
        window.addEventListener('message', handler);
        return () => window.removeEventListener('message', handler);
    }, []);

    const emitUiSync = (key, value) => {
        try {
            const serialized = JSON.stringify(value);
            // First fire on mount: record initial value without broadcasting,
            // so we don't overwrite extension state before HYDRATE_RESPONSE.
            if (lastEmittedRef.current[key] === undefined) {
                lastEmittedRef.current[key] = serialized;
                return;
            }
            if (lastEmittedRef.current[key] === serialized) return;
            // If this exact value was JUST applied from ext, skip ONE echo —
            // then clear the latch so subsequent legit changes go through.
            if (lastAppliedFromExtRef.current[key] === serialized) {
                delete lastAppliedFromExtRef.current[key];
                lastEmittedRef.current[key] = serialized;
                return;
            }
            lastEmittedRef.current[key] = serialized;
            console.log('[UI-SYNC webapp→ext]', key, value);
            window.postMessage({
                [SESAAT_UI_SYNC_TAG]: true,
                direction: 'webapp_to_ext',
                type: 'SET',
                key,
                value,
            }, '*');
        } catch (_) { /* ignore */ }
    };

    // Emit local state changes to the extension
    useEffect(() => { emitUiSync('activeTab', activeTab); }, [activeTab]);
    useEffect(() => { emitUiSync('flowSortType', flowSortType); }, [flowSortType]);
    useEffect(() => { emitUiSync('flowSortDirection', flowSortDirection); }, [flowSortDirection]);
    useEffect(() => { emitUiSync('tiktokSortType', tiktokSortType); }, [tiktokSortType]);
    useEffect(() => { emitUiSync('tiktokSortDirection', tiktokSortDirection); }, [tiktokSortDirection]);
    useEffect(() => { emitUiSync('selectedGroupId', selectedGroupId); }, [selectedGroupId]);

    // Emit selected product IDs whenever the selection changes
    const selectedIdsKey = useMemo(() => {
        return products.filter(p => p.selected).map(p => p.id).sort().join(',');
    }, [products]);
    useEffect(() => {
        const ids = selectedIdsKey ? selectedIdsKey.split(',') : [];
        emitUiSync('selectedIds', ids);
        // ★ Per-browser persist (survives refresh). Skip until first Firestore
        // snapshot lands — initial render fires this effect with empty
        // products and would clobber the prior selection in localStorage
        // before snapshot has a chance to restore it.
        if (!hasReceivedFirstSnapshotRef.current) return;
        try { localStorage.setItem('workspace_selected_ids', JSON.stringify(ids)); } catch (_) { /* quota / private mode */ }
    }, [selectedIdsKey]);

    // Listen for incoming UI updates from the extension popup
    useEffect(() => {
        const handler = (event) => {
            if (event.source !== window) return;
            const data = event.data;
            if (!data || data[SESAAT_UI_SYNC_TAG] !== true) return;
            if (data.direction !== 'ext_to_webapp') return;

            const apply = (key, value) => {
                console.log('[UI-SYNC webapp←ext]', key, value);
                try { lastAppliedFromExtRef.current[key] = JSON.stringify(value); } catch (_) { }
                if (key === 'activeTab') {
                    if (value === 'all' || value === 'flow' || value === 'tiktok') setActiveTab(value);
                } else if (key === 'flowSortType') {
                    if (value === 'index' || value === 'time' || value === 'module' || value === 'manual') setFlowSortType(value);
                } else if (key === 'flowSortDirection') {
                    if (value === 'asc' || value === 'desc') setFlowSortDirection(value);
                } else if (key === 'tiktokSortType') {
                    if (value === 'index' || value === 'time' || value === 'module' || value === 'manual') setTiktokSortType(value);
                } else if (key === 'tiktokSortDirection') {
                    if (value === 'asc' || value === 'desc') setTiktokSortDirection(value);
                } else if (key === 'selectedGroupId') {
                    if (typeof value === 'string') setSelectedGroupId(value);
                } else if (key === 'selectedIds') {
                    if (Array.isArray(value)) {
                        const idSet = new Set(value);
                        setProducts(prev => prev.map(p => {
                            const want = idSet.has(p.id);
                            return p.selected === want ? p : { ...p, selected: want };
                        }));
                    }
                }
            };

            if (data.type === 'SET' && typeof data.key === 'string') {
                apply(data.key, data.value);
            } else if (data.type === 'HYDRATE_RESPONSE' && data.payload && typeof data.payload === 'object') {
                for (const k in data.payload) apply(k, data.payload[k]);
            }
        };
        window.addEventListener('message', handler);
        // Ask the extension to send its current UI state on mount
        window.postMessage({
            [SESAAT_UI_SYNC_TAG]: true,
            direction: 'webapp_to_ext',
            type: 'HYDRATE_REQUEST',
        }, '*');
        return () => window.removeEventListener('message', handler);
    }, []);

    // ★ v3.0.0 Fasa 6: Derive unique groups from products in current space
    const availableGroups = useMemo(() => {
        const spaceProducts = selectedSpaceId === 'default'
            ? products.filter(p => !(p.spaceId || p.groupId) || p.spaceId === 'default' || p.groupId === 'default')
            : products.filter(p => p.spaceId === selectedSpaceId || p.groupId === selectedSpaceId);
        const groupSet = new Set(spaceProducts.map(p => p.workspaceGroup || 'Workspace'));
        groupSet.add('Workspace'); // always have default
        return Array.from(groupSet).sort((a, b) => a === 'Workspace' ? -1 : b === 'Workspace' ? 1 : a.localeCompare(b));
    }, [products, selectedSpaceId]);

    // Sync groups = merge derived (from products) + custom (user-created, may be empty)
    useEffect(() => {
        const merged = new Set([...availableGroups, ...customGroups]);
        merged.add('Workspace');
        const sorted = Array.from(merged).sort((a, b) => a === 'Workspace' ? -1 : b === 'Workspace' ? 1 : a.localeCompare(b));
        setGroups(sorted);
        if (onGroupsChange) onGroupsChange(sorted);
    }, [availableGroups, customGroups]);

    // Auto-flip "Move Group" dropdown direction based on available space.
    // Ruang di ATAS diukur dari bawah jalur alat — lihat nota `ruangAtasJalur`.
    useLayoutEffect(() => {
        if (!showGroupDropdown || !groupDropdownBtnRef.current) return;
        const rect = groupDropdownBtnRef.current.getBoundingClientRect();
        const spaceAbove = ruangAtasJalur(rect, jalurRef.current);
        const spaceBelow = window.innerHeight - rect.bottom;
        // Estimate: each item ~32px + New Group row ~40px + padding, capped at 60vh
        const estimatedHeight = Math.min((groups.length * 32) + 50, window.innerHeight * 0.6);
        if (spaceAbove < estimatedHeight && spaceBelow > spaceAbove) {
            setGroupDropdownDirection('down');
        } else {
            setGroupDropdownDirection('up');
        }
    }, [showGroupDropdown, groups.length]);

    // Auto-flip "Tukar Avatar" dropdown direction (same rationale as Move Group above —
    // floating bar sits near top of viewport after Select All, upward menu would clip).
    useLayoutEffect(() => {
        if (!showAvatarDropdown || !avatarDropdownBtnRef.current) return;
        const rect = avatarDropdownBtnRef.current.getBoundingClientRect();
        const spaceAbove = ruangAtasJalur(rect, jalurRef.current);
        const spaceBelow = window.innerHeight - rect.bottom;
        // Estimate: 1 header/hint row + N same-gender avatars, ~34px each + padding, capped 60vh
        const itemCount = (propSavedAvatars?.length || 0) + 1;
        const estimatedHeight = Math.min((itemCount * 34) + 60, window.innerHeight * 0.6);
        if (spaceAbove < estimatedHeight && spaceBelow > spaceAbove) {
            setAvatarDropdownDirection('down');
        } else {
            setAvatarDropdownDirection('up');
        }
    }, [showAvatarDropdown, propSavedAvatars?.length]);

    // Sync group counts to App.jsx
    useEffect(() => {
        if (!onGroupCountsChange) return;
        const spaceProducts = selectedSpaceId === 'default'
            ? products.filter(p => !(p.spaceId || p.groupId) || p.spaceId === 'default' || p.groupId === 'default')
            : products.filter(p => p.spaceId === selectedSpaceId || p.groupId === selectedSpaceId);
        const counts = {};
        groups.forEach(g => {
            counts[g] = g === 'Workspace'
                ? spaceProducts.filter(p => !p.workspaceGroup || p.workspaceGroup === 'Workspace').length
                : spaceProducts.filter(p => p.workspaceGroup === g).length;
        });
        onGroupCountsChange(counts);
    }, [products, groups, selectedSpaceId]);

    // Notify App.jsx when selected group changes
    useEffect(() => {
        if (onSelectedGroupChange) onSelectedGroupChange(selectedGroupId);
    }, [selectedGroupId]);

    /* Beritahu App.jsx tab mana sedang dibuka. App yang merender panel
       larian di tepi, dan dalam v3.9 panel itu hanya wujud pada tab Flow
       dan Schedule — jadi App perlu tahu tab semasa. Corak sama seperti
       `onSelectedGroupChange` di atas; jangan baca `activeTab` dari App
       melalui postMessage, ia laluan penyegerakan antara browser dan bukan
       untuk keadaan skrin sendiri. */
    useEffect(() => {
        if (onActiveTabChange) onActiveTabChange(activeTab);
    }, [activeTab]);

    // Notify App.jsx when selected count changes (for footer counter in left sidebar).
    // Why: App.jsx has its own `products` state that doesn't see the per-browser
    // `selected` flag toggled here, so its counter would otherwise stay at 0.
    useEffect(() => {
        if (!onSelectedCountChange) return;
        /* v3.9: kira kad yang KELIHATAN sahaja — tab semasa, group semasa.
           Sebelum ini ia mengira setiap kad bertanda di seluruh workspace,
           jadi menanda 2 kad di tab Schedule membuatkan Control Panel tab
           Flow melaporkan "2 Selected" walaupun tab itu langsung tidak
           memaparkan kad tersebut (dilaporkan user 2026-08-12).

           ⛔ Rupa lama SENGAJA dibiar seperti asal: di sana tab hanyalah
              penapis paparan, dan pelanggan memang biasa menanda kad di tab
              "All" kemudian menekan Run. Menukarnya bermakna mengubah tabiat
              kerja yang sedia berjalan setiap hari. */
        const selected = products.filter(p => {
            if (!p.selected) return false;
            if (!uiV39) return true;
            if (activeTab !== 'all' && getProductTab(p) !== activeTab) return false;
            if (selectedGroupId !== 'all' && (p.workspaceGroup || 'Workspace') !== selectedGroupId) return false;
            return true;
        });
        onSelectedCountChange(selected.length);
        if (onSelectedFlownityChange) {
            onSelectedFlownityChange(selected.length > 0 && selected.every(p => p.moduleId === 'flownity'));
        }
        /* ⛔ `activeTab` dan `selectedGroupId` WAJIB ada di sini. Dahulu
           senarai ini hanya `[products]`, dan itu betul selagi kiraan tidak
           bergantung pada tab. Sebaik ia bergantung, senarai lama menjadi
           pepijat: menukar tab tidak mengubah `products`, jadi kesan ini
           tidak dijalankan semula dan kiraan kekal dengan nilai tab
           SEBELUMNYA — tanda 1 kad di Agent AI, tukar ke Flow, panel masih
           melaporkan "1 Selected" (dilaporkan user 2026-08-12).

           `uiV39` turut disenaraikan: ia menentukan cabang mana yang
           dipakai, jadi menghidupkan suis tanpa mengira semula meninggalkan
           kiraan gaya lama di skrin. */
    }, [products, activeTab, selectedGroupId, uiV39]);


    // ★ v3.0.0 Fasa 6: Move selected products to a group
    const handleMoveToGroup = async (targetGroup) => {
        const selectedProducts = filteredAndSortedProducts.filter(p => p.selected);
        if (selectedProducts.length === 0) return;
        const selectedIds = new Set(selectedProducts.map(p => p.id));
        const updated = products.map(p => {
            if (selectedIds.has(p.id)) {
                return { ...p, workspaceGroup: targetGroup, selected: false };
            }
            return p;
        });
        setProducts(updated);
        setShowGroupDropdown(false);
    };

    // ★ Bulk "Tukar Avatar" — repoint avatar untuk produk dipilih TANPA jana semula pipeline.
    // Avatar cuma input masa Flow run (paste gambar) — TIDAK terlibat dlm prompt/video yang dah dijana.
    // Tukar 3 field je (gender/avatarId/avatarImageUrl); prompt, video & baki data kekal → tiada coin.
    // SYARAT JANTINA SAMA: hanya produk yang gender-nya SAMA dengan avatar baru ditukar — prompt terikat
    //   pada jantina asal (mode3_withAvatar guna gender/umur/hijab), female↔male akan mismatch teruk.
    //   Dropdown dah filter same-gender; guard di sini defensive (double-safety).
    // GOYANG DILANGKAU: guna hand/bg (customBgImageUrl reuse slot avatarImageUrl + gender = hand gender).
    // Dipanggil dari modal pengesahan (bukan terus dari dropdown) supaya user aware impact hijab/umur/gender.
    const applyAvatarChange = async (avatar) => {
        if (!avatar || !avatar.id) return;
        const eligible = filteredAndSortedProducts.filter(p =>
            p.selected && p.moduleId !== 'goyang' && (p.gender || null) === (avatar.gender || null));
        if (eligible.length === 0) return;
        const eligibleIds = new Set(eligible.map(p => p.id));
        const patch = { gender: avatar.gender || null, avatarId: avatar.id, avatarImageUrl: avatar.imageUrl || null };
        setIsSaving(true);
        try {
            const updated = products.map(p => eligibleIds.has(p.id) ? { ...p, ...patch, selected: false } : p);
            setProducts(updated);
            await saveToCloud(updated);
        } catch (err) {
            console.error('[ChangeAvatar] Failed:', err);
        } finally {
            setIsSaving(false);
        }
    };

    // ★ v3.0.0 Fasa 6: Create new group (persists even if empty)
    const handleCreateGroup = async (name, moveProducts = true) => {
        const trimmed = name.trim();
        if (!trimmed || trimmed === 'Workspace') return;
        // Add to custom groups (persist)
        setCustomGroups(prev => {
            const updated = prev.includes(trimmed) ? prev : [...prev, trimmed];
            // Persist to Firestore
            if (auth.currentUser) {
                const docRef = doc(db, 'users', auth.currentUser.uid);
                setDoc(docRef, { customWorkspaceGroups: updated }, { merge: true }).catch(err => console.warn('Save groups error:', err));
            }
            return updated;
        });
        // Move selected products to new group (if requested)
        if (moveProducts) await handleMoveToGroup(trimmed);
        setNewGroupName('');
        setShowNewGroupInput(false);
    };

    // Rename an existing custom group: update customGroups + migrate products' workspaceGroup
    const handleRenameGroup = async (oldName, newName) => {
        const trimmed = (newName || '').trim();
        if (!trimmed || trimmed === oldName) return { ok: false, reason: 'invalid' };
        if (trimmed === 'Workspace' || trimmed === 'all') return { ok: false, reason: 'reserved' };
        if (groups.some(g => g.toLowerCase() === trimmed.toLowerCase() && g !== oldName)) {
            return { ok: false, reason: 'duplicate' };
        }
        // Update customGroups (persist to Firestore)
        setCustomGroups(prev => {
            const updated = prev.map(g => g === oldName ? trimmed : g);
            if (auth.currentUser) {
                const docRef = doc(db, 'users', auth.currentUser.uid);
                setDoc(docRef, { customWorkspaceGroups: updated }, { merge: true }).catch(err => console.warn('Rename group error:', err));
            }
            return updated;
        });
        // Migrate products: workspaceGroup oldName -> trimmed
        setProducts(prev => prev.map(p => p.workspaceGroup === oldName ? { ...p, workspaceGroup: trimmed } : p));
        // If currently selected, follow the rename
        if (selectedGroupId === oldName) setSelectedGroupId(trimmed);
        return { ok: true, newName: trimmed };
    };

    // Delete a custom group: move its products to destination group, then remove entry
    const handleDeleteGroup = async (name, destination = 'Workspace') => {
        if (!name || name === 'Workspace') return { ok: false, reason: 'reserved' };
        const destTarget = destination === 'all' ? 'Workspace' : destination;
        // Migrate products out of deleted group
        setProducts(prev => prev.map(p => p.workspaceGroup === name
            ? { ...p, workspaceGroup: destTarget === 'Workspace' ? undefined : destTarget }
            : p));
        // Remove from customGroups (persist)
        setCustomGroups(prev => {
            const updated = prev.filter(g => g !== name);
            if (auth.currentUser) {
                const docRef = doc(db, 'users', auth.currentUser.uid);
                setDoc(docRef, { customWorkspaceGroups: updated }, { merge: true }).catch(err => console.warn('Delete group error:', err));
            }
            return updated;
        });
        // If active group is the deleted one, switch to destination
        if (selectedGroupId === name) {
            setSelectedGroupId(destTarget === 'Workspace' ? 'all' : destTarget);
        }
        return { ok: true };
    };

    // Base filtered products (by space, group, and search)
    /* Tapisan space + group SAHAJA — carian sengaja belum dikenakan di sini.
       Kalendar tab Schedule membaca senarai ini (lihat `schedKad`): kalau ia
       membaca senarai yang sudah ditapis carian, menaip dalam kotak carian
       akan MENGOSONGKAN slot kalendar yang sudah tersusun — kalendar
       memadankan isinya dengan senarai produk semasa, jadi produk yang
       tersorok akan dikira "sudah tiada". */
    const groupFilteredProducts = useMemo(() => {
        // Filter by space: 'default' shows products with no spaceId/groupId, other spaces show their own
        const spaceFiltered = selectedSpaceId === 'default'
            ? products.filter(p => !(p.spaceId || p.groupId) || p.spaceId === 'default' || p.groupId === 'default')
            : products.filter(p => p.spaceId === selectedSpaceId || p.groupId === selectedSpaceId);

        // Filter by group: 'all' = ungrouped products only (no custom group assigned)
        return selectedGroupId === 'all'
            ? spaceFiltered.filter(p => !p.workspaceGroup || p.workspaceGroup === 'Workspace')
            : spaceFiltered.filter(p => p.workspaceGroup === selectedGroupId);
    }, [products, selectedSpaceId, selectedGroupId]);

    const baseFilteredProducts = useMemo(() => {
        return groupFilteredProducts.filter(p => !searchQuery || p.name.toLowerCase().includes(searchQuery.toLowerCase()));
    }, [groupFilteredProducts, searchQuery]);


    /* ---------- Nama tab marking -------------------------------------
       Reka bentuk v3.9 menamakan semula TIGA tab: "All" → "Generate",
       "Tiktok" → "Schedule", dan "Agent AI" → "My Agent". Susunan
       kekal (Generate · My Agent · Flow · Schedule) — user 2026-08-10.

       ⛔ Yang bertukar hanyalah NAMA PADA SKRIN. Nilai `all`/`chatgpt`/
          `flow`/`tiktok` TIDAK boleh disentuh: ia tertulis dalam medan
          `p.tab` pada puluhan ribu dokumen produk, disimpan dalam
          localStorage (`activeTab`), dihantar antara browser melalui
          emitUiSync, dan dibaca oleh extension yang codebase-nya
          berasingan. Menukar nilai = migrasi data, bukan tukar label.

       ⚠️ Extension ada bar tab yang SAMA (App.tsx) dan ia TIADA suis
          v3.9. Selagi extension belum dikeluarkan semula, panelnya
          masih menulis "All" dan "Tiktok". Itu memang dijangka.

       Suis mati → nama lama, tepat seperti sebelum ini. */
    const TAB_NAMA = uiV39
        ? { all: T('ws.tab.generate', 'Generate'), chatgpt: T('ws.tab.agentAi', 'Agent AI'), flow: T('ws.tab.flow', 'Flow'), tiktok: T('ws.tab.schedule', 'Schedule') }
        /* Cabang rupa LAMA. T() di sini sentiasa memulangkan ayat lalai (cabang
           ini hanya dicapai bila `uiV39` palsu), jadi rupa lama TIDAK berubah —
           kunci disebut semata-mata supaya ia tidak kelihatan yatim dalam kamus. */
        : { all: T('ws.tab.all', 'All'), chatgpt: T('ws.tab.agentAi', 'Agent AI'), flow: T('ws.tab.flow', 'Flow'), tiktok: T('ws.tab.tiktok', 'Tiktok') };

    /* Chip baris kad dalam v3.9 — nilai `.s-rowchip` prototaip disalin ke sini
       kerana kad ini hidup di luar pokok CSS v3.9 (ia halaman lama). Kalau
       `.s-rowchip` dilaraskan kemudian, laraskan yang ini sekali. */
    /* Chip dikecilkan (arahan user 2026-08-21): 12→11px, padding rapat.
       Dipakai semua chip kad v3.9 (link, Full Prompt, module, dsb). */
    const CHIP_V39 = {
        display: 'inline-flex', alignItems: 'center',
        fontSize: 11, fontWeight: 500, lineHeight: 1.4,
        padding: '1px 7px', borderRadius: 5, whiteSpace: 'nowrap',
        border: '1px solid var(--s-line)', background: 'var(--s-fill)',
        color: 'var(--s-ink-2)',
    };

    // Helper: determine which tab a product belongs to (same logic as extension)
    // FLOWNITY/SMART: tab ChatGPT secara DEFAULT + KEKAL selepas scrape (NO auto-move).
    // Pindah HANYA bila user Mark Flow/Tiktok (set p.tab). Mark ChatGPT set p.tab='chatgpt' → balik sini.
    // ⚠️ KEMBAR senarai module dengan `MODUL_TAB_AGENT` (butang Mark Agent AI / handleMarkAs).
    const getProductTab = (p) => {
        if (p.moduleId === 'flownity' || p.moduleId === 'smartcustom') {
            return (p.tab === 'flow' || p.tab === 'tiktok') ? p.tab : 'chatgpt';
        }
        return p.tab || 'flow';
    };

    // Calculate counts for tabs
    const flowCount = useMemo(() => {
        return baseFilteredProducts.filter(p => getProductTab(p) === 'flow').length;
    }, [baseFilteredProducts]);

    const tiktokCount = useMemo(() => {
        return baseFilteredProducts.filter(p => getProductTab(p) === 'tiktok').length;
    }, [baseFilteredProducts]);

    // P6.1 — ChatGPT tab count (Smart Custom only)
    const chatgptCount = useMemo(() => {
        return baseFilteredProducts.filter(p => getProductTab(p) === 'chatgpt').length;
    }, [baseFilteredProducts]);

    /* ---------- Tab Schedule (v3.9) — data untuk kalendar ---------------
       Kalendar tidak menerima produk mentah; ia membaca `videos` sebagai
       tiga penanda ada/tiada. Penyesuai ini hidup di sini dan bukan di
       dalam kalendar supaya kalendar kekal komponen rupa sahaja — dan
       kekal SAMA antara prototaip dan halaman ini.

       ⭐ Sumbernya kad BERTANDA Schedule sahaja (keputusan user 2026-08-13).
          Dahulu ia mengambil seluruh group dan menapis "ada video" — jadi
          menekan Mark Schedule tidak mengubah apa-apa di sini, dan kad yang
          ditanda terus hilang daripada tab Flow tanpa muncul di mana-mana.
          Tanda itulah yang menentukan isi tab ini sekarang; video tidak lagi
          menjadi syarat masuk (slot boleh menunggu videonya — lihat
          KalendarMingguV39).

       ⚠️ `groupFilteredProducts`, BUKAN `baseFilteredProducts`: senarai ini
          turut menjadi rujukan kalendar semasa memadankan slot dengan produk
          terkini. Kalau ia mengikut carian, menaip dalam kotak carian akan
          mengosongkan slot yang sudah tersusun.

       ⚠️ Split V2 tidak menjejaskan apa-apa di sini — `uploadedVideo` dan
          `captionTiktok` memang kekal dalam dokumen utama, jadi tiada
          hydrate diperlukan (lihat nota Split V2 dalam CLAUDE.md). */
    /* Bentuk kalendar bagi SATU produk. Dipakai oleh dua senarai di bawah —
       satu ditapis untuk paparan, satu penuh untuk padanan. */
    const kepadaKadJadual = useCallback((p) => ({
        id: p.id,
        name: p.name,
        gambar: p.imageUrl || p.localImagePath || null,
        /* `local://` dikira ADA video — ia penanda video yang tersimpan
           dalam browser, bukan ketiadaan video. */
        videos: ['set1', 'set2', 'set3'].map((k) => (p.prompts?.[k]?.uploadedVideo ? 1 : 0)),
        prompts: p.prompts,
        /* Langkah 3 (paparan status slot): status post TikTok per set —
           { tiktok_set1: 'complete'|'draft'|'failed'|'uncertain'|'running' }.
           Slot membacanya untuk warna. `setStatusReason` = SEBAB (kenapa gagal
           / draf) supaya slot boleh papar, bukan sekadar "Failed" kosong. */
        setStatuses: p.setStatuses || {},
        setStatusReason: p.setStatusReason || {},
    }), []);

    /* ⛔ Senarai PENUH — tanpa tapisan group, tab atau carian. Ia dipakai
          HANYA untuk memadankan slot kalendar dengan produknya.

          Kalendar milik AKAUN, bukan milik group. Menggunakan senarai
          tertapis untuk padanan bermakna video yang dijadualkan dalam
          Group A "hilang" sebaik pengguna beralih ke Group B — dan slot itu
          kemudian dikira kosong lalu DITIMPA secara kekal oleh seretan
          berikutnya. Itu kehilangan data, bukan masalah paparan. */
    const schedKadSemua = useMemo(
        () => (uiV39 ? products.map(kepadaKadJadual) : []),
        [products, uiV39, kepadaKadJadual],
    );

    const schedKad = useMemo(() => {
        if (!uiV39) return [];
        return groupFilteredProducts
            .filter((p) => getProductTab(p) === 'tiktok')
            /* Susunan datang daripada kawalan yang duduk TEPAT di atas
               senarai ini (bukan lagi di jalur alat) — jadi ia mesti
               benar-benar menyusunnya. Kawalan yang tidak mengubah apa-apa
               ialah kawalan palsu. */
            .sort(bandingProduk(tiktokSortType, tiktokSortDirection))
            .map((p) => ({
                id: p.id,
                name: p.name,
                gambar: p.imageUrl || p.localImagePath || null,
                /* `local://` dikira ADA video — ia penanda video yang
                   tersimpan dalam browser, bukan ketiadaan video. */
                videos: ['set1', 'set2', 'set3'].map((k) => (p.prompts?.[k]?.uploadedVideo ? 1 : 0)),
                prompts: p.prompts,
            }));
        /* ⛔ TIADA lagi tapisan "mesti ada video" di hujung sini. Ia dibuang
              2026-08-13: produk ditanda Schedule sebelum Flow dijalankan,
              jadi menapisnya bermakna kad yang baru ditanda hilang serta-merta
              daripada tab yang sepatutnya menerimanya. */
    }, [groupFilteredProducts, uiV39, tiktokSortType, tiktokSortDirection]);

    /* Susunan MENTAH bagi akaun yang sedang dibuka — dihantar apa adanya.

       ⛔ Dahulu ia dipadankan dan DITAPIS di sini (hanya produk yang lulus
          tapisan group kekal), lalu dihantar ke kalendar sebagai "isian".
          Tetapi setiap tulisan kalendar pergi ke objek MENTAH. Jadi slot
          milik group lain kelihatan kosong dan ditimpa secara kekal, dan
          Undo menulis snapshot tertapis itu semula ke atas data mentah —
          memadam setiap entri yang kebetulan tersembunyi.

          Padanan produk kini berlaku DI DALAM kalendar, untuk paparan
          sahaja, menggunakan `schedKadSemua` yang tidak ditapis. Jangan
          kembalikan penapisan ke sini. */
    const schedSusunanAktif = useMemo(
        () => schedSusunan[schedAkaunAktif] || null,
        [schedSusunan, schedAkaunAktif],
    );

    const schedUbahSusunan = useCallback((fn) => {
        setSchedSusunan((prev) => {
            const kini = prev[schedAkaunAktif] || { hariTemplate: {}, isian: {} };
            return { ...prev, [schedAkaunAktif]: fn(kini) };
        });
    }, [schedAkaunAktif]);

    const schedCiptaAkaun = useCallback((nama) => {
        const baru = akaunBaharu(nama);
        setSchedAkaun((prev) => [...prev, baru]);
        setSchedAkaunAktif(baru.id);
    }, []);

    /* Namakan semula akaun kalendar. Effect tulisan 'shared' menghantar
       senarai akaun terkini ke server sendiri. */
    const schedNamaAkaun = useCallback((id, nama) => {
        const bersih = String(nama || '').trim();
        if (!bersih) return;
        setSchedAkaun((prev) => prev.map((a) => (a.id === id ? { ...a, nama: bersih } : a)));
    }, []);

    /* Padam akaun kalendar + seluruh susunannya. Akaun terakhir tidak boleh
       dipadam (kalendar mesti ada sekurang-kurangnya satu tempat). */
    const schedPadamAkaun = useCallback((id) => {
        const akaunKini = schedAkaunRef.current || [];
        if (akaunKini.length <= 1) {
            toast.warning(T('ws.sched.akaunTerakhir', 'Tidak boleh padam akaun terakhir. Cipta satu lagi dahulu.'));
            return;
        }
        const baki = akaunKini.filter((a) => a.id !== id);
        setSchedAkaun(baki);
        setSchedSusunan((s) => { const n = { ...s }; delete n[id]; return n; });
        setSchedAkaunAktif((aktif) => (aktif === id ? baki[0].id : aktif));
        if (schedServerOkRef.current && auth.currentUser?.uid) {
            padamAkaun(auth.currentUser.uid, id).catch(() => {});
            delete schedRefDisimpan.current[`${auth.currentUser.uid}__${id}`];
        }
        toast.success(T('ws.sched.akaunDipadam', 'Akaun kalendar dipadam.'));
    }, [T]);

    /* Set yang dipegang kalendar akaun LAIN. Ia MENANDAKAN sahaja —
       lihat nota penuh dalam scheduleV39. Kesan yang boleh dilihat:
       beralih ke akaun kedua, set yang sudah ditempah akaun pertama
       bertanda putus-putus, dan seretan terus jatuh pada set yang
       masih bebas. */
    const schedSetLuar = useMemo(
        () => setDipegangAkaunLain(schedSusunan, schedAkaunAktif, schedAkaun),
        [schedSusunan, schedAkaunAktif, schedAkaun],
    );

    /* Tab Schedule v3.9 — satu suis untuk kedua-dua perkara yang berubah di
       sana: susun atur dua lajur, dan jalur pemegang seret pada setiap kad.
       Rupa lama tidak pernah masuk ke sini. */
    const schedMode = uiV39 && activeTab === 'tiktok';
    /* Senarai kecut aktif: tab Schedule + user tekan sorok (manual).
       Dipakai oleh SchedGrid (sorok lajur senarai) DAN bar tarikh atas (geser kiri). */
    const senaraiKecut = schedMode && senaraiSorok;
    /* Tab Flow + My Agent dalam Workspace v4 (26 Okt, arahan user: "buatkan
       scroll tu start daripada listing card… buat la sama follow mcm kat tab
       schedule"). Dalam v4 pil sorting berpindah ke kepala halaman, jadi
       halaman menatal sebagai satu kepingan panjang dan baris kad naik sampai
       terkerat di bawah pil itu. Penyelesaiannya MEKANISME YANG SAMA seperti
       tab Schedule: lajur senarai diberi tinggi yang DIUKUR dan menatal
       sendiri (`.s-senaraiv4` / `.s-senaraiv4__tatal` dalam ui.css), jadi bar
       tatal bermula di listing kad dan merapat pada kad.
       ⛔ Tab Schedule dikecualikan — ia sudah memakai corak ini sendiri
          (`.s-tikjad`), dan tab Generate memakai komposer, bukan senarai. */
    const senaraiV4Tetap = uiV39 && !!slotTabV4 && (activeTab === 'flow' || activeTab === 'chatgpt');

    /* ---------- Pilihan slot (disatukan — arahan user 2026-08-20) ----------
       CERMIN kunci slot yang dipilih dalam kalendar (JadualTiktokV39
       melaporkannya melalui `onPilihBerubah`). Model SAMA seperti pilih kad di
       tab Flow: pengguna pilih slot (tick kepala hari = SEMUA slot hari itu,
       atau seret/klik slot satu-satu), bar pukal muncul untuk Buang/Batal, dan
       butang Run di Control Panel menjalankan slot yang DIPILIH ini — bar pukal
       sendiri TIADA butang Run (sama seperti bar pilih kad tab Flow).
       Reset bila tukar akaun (cermin turut lapor kosong, ini cuma serta-merta). */
    const [schedPilih, setSchedPilih] = useState(() => new Set());
    useEffect(() => { setSchedPilih(new Set()); }, [schedAkaunAktif]);

    /* Ringkasan larian kalendar (untuk bar bawah + pagar Run). Dikira daripada
       slot pada tarikh ditanda sahaja. `bil` = bilangan slot; video hilang /
       waktu terlepas ditapis kemudian semasa Run, jadi ini anggaran PALING
       BANYAK — cukup untuk bar bawah beritahu pengguna apa yang akan jalan. */
    const schedRunInfo = useMemo(() => {
        const isian = schedSusunanAktif?.isian || {};
        let bil = 0;
        const offSet = new Set();
        for (const k of schedPilih) {
            if (!isian[k]) continue;          // kunci basi (slot sudah tiada)
            bil++;
            /* Kunci = `${tarikh}_${minit}`; tarikh tiada garis bawah. */
            offSet.add(String(k).split('_')[0]);
        }
        /* Tarikh 'YYYY-MM-DD' — susunan rentetan = susunan tarikh. */
        const offs = [...offSet].sort();
        return { bil, bilHari: offs.length, offMula: offs[0], offAkhir: offs[offs.length - 1] };
    }, [schedSusunanAktif, schedPilih]);

    /* Lapor ringkasan ke App.jsx (bar bawah Control Panel). null bila BUKAN
       mod Schedule → bar bawah kekal papar kiraan kad bertick seperti biasa. */
    useEffect(() => {
        if (!onSchedRunInfo) return;
        if (!schedMode) { onSchedRunInfo(null); return; }
        const { bil, bilHari, offMula, offAkhir } = schedRunInfo;
        const julat = bilHari === 0 ? ''
            : offMula === offAkhir ? tarikhLabelHari(offMula)
                : `${tarikhLabelHari(offMula)}–${tarikhLabelHari(offAkhir)}`;
        onSchedRunInfo({ bil, bilHari, julat });
    }, [schedMode, schedRunInfo, onSchedRunInfo]);

    /* ★ v3.9.2 — MUAT SEMULA kalendar akaun aktif setiap kali tab Schedule
       dibuka (dan setiap kali akaun aktif bertukar semasa di tab itu).

       Sebabnya: kalendar dimuat SEKALI pada mount, jadi dua browser yang
       membuka kalendar akaun sama tidak pernah nampak perubahan satu sama
       lain sehingga muat semula penuh halaman — seretan browser lain tidak
       kelihatan, dan slot yang sudah dijalankan di sana masih nampak kosong
       di sini (punca aduan multi-browser 2026-08-25).

       Urutan menjadikannya selamat: edit tertunda browser INI di-flush
       DAHULU (debounce 800ms mungkin belum menulis), barulah server dibaca —
       selepas flush, server = kerja kita + perubahan browser lain, jadi
       gantian penuh di bawah tidak membuang apa-apa. `schedRefDisimpan`
       dikemas kini SEBELUM state supaya effect auto-save (yang berjalan
       sebaik state berubah) mendapati tiada beza dan tidak menulis semula.

       ⚠️ Tetingkap kecil yang diterima sedar: seretan yang dibuat DALAM
       beberapa ratus ms antara flush dan bacaan boleh ditimpa — pengguna
       baru sahaja membuka tab itu, jadi kebarangkaliannya hampir sifar. */
    const schedSegarRef = useRef(false);
    useEffect(() => {
        if (!schedMode) return;
        const uid = auth.currentUser?.uid;
        if (!uid || !schedAkaunAktif) return;
        if (!schedServerOkRef.current) return;   // server belum jadi sumber (mount belum siap)
        if (schedSegarRef.current) return;       // satu penyegaran pada satu masa
        schedSegarRef.current = true;
        (async () => {
            try {
                await flushSimpanan(uid, schedAkaunAktif, schedSusunan[schedAkaunAktif], schedRefDisimpan);
                const svr = await muatSusunanAkaun(uid, schedAkaunAktif);
                if (!svr) return; // gagal baca → kekal paparan sedia ada (fail-open)
                const kunci = `${uid}__${schedAkaunAktif}`;
                const perTarikh = akaunKeTarikh(svr);
                const rekod = {};
                for (const tarikh in perTarikh) rekod[tarikh] = JSON.stringify(perTarikh[tarikh]);
                if (schedRefDisimpan.current) schedRefDisimpan.current[kunci] = rekod;
                setSchedSusunan((prev) => ({ ...prev, [schedAkaunAktif]: svr }));
            } catch { /* penyegaran sahaja — jangan ganggu kerja */ }
            finally { schedSegarRef.current = false; }
        })();
        // schedSusunan sengaja BUKAN dependency — effect ini penyegaran sekali
        // setiap kali tab dibuka / akaun bertukar, bukan pengikut setiap edit.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [schedMode, schedAkaunAktif]);

    /* Set yang SUDAH duduk dalam kalendar akaun yang sedang dibuka, dikumpul
       ikut produk: { [idProduk]: ['set1', 'set3'] }.

       Ia dikira di sini kerana jalur pemegang seret pada setiap kad perlu
       menunjukkannya (tanda 1·2·3), dan jalur itu hidup dalam senarai kad —
       bukan di dalam kalendar. Sumbernya `schedSusunanAktif`, iaitu susunan
       yang SUDAH dipadankan semula dengan produk terkini, supaya slot yang
       produknya sudah tiada tidak dikira. */
    const schedSetGuna = useMemo(() => {
        const peta = {};
        const isian = schedSusunanAktif?.isian || {};
        for (const k in isian) {
            const e = isian[k];
            /* `e.p?.id` = sokongan data lama yang menyimpan salinan penuh
               objek produk; bentuk baharu menyimpan `pid` sahaja. */
            const pid = e?.pid || e?.p?.id;
            if (!pid || !e?.s) continue;
            (peta[pid] = peta[pid] || []).push(e.s);
        }
        return peta;
    }, [schedSusunanAktif]);

    /* Laporan selepas seretan PUKAL. Ia perlu kerana seretan pukal boleh
       mengalir ke hari yang TIDAK kelihatan pada tetingkap kalendar
       semasa (tiga hari sahaja dipapar serentak) — tanpa satu ayat, video
       yang mendarat pada hari keempat kelihatan seperti hilang. */
    const schedLapor = useCallback(({ diletak = 0, tinggal = 0, hariAkhir, tiadaTemplate = false }) => {
        /* Pepijat 2: hari tanpa template — mesej khusus, bukan "tiada slot
           kosong" yang mengelirukan (memang tiada slot kerana tiada template). */
        if (tiadaTemplate) {
            toast.warning(T('ws.sched.noTemplate', 'Hari ini belum ada template — pilih template pada kepala hari dahulu, kemudian seret video masuk.'));
            return;
        }
        if (!diletak) {
            toast.warning(T('ws.sched.noSlot', `Tiada slot kosong — ${tinggal} video tidak dapat diletakkan. Pilih template pada tarikh lain, atau kosongkan slot sedia ada.`, { n: tinggal }));
            return;
        }
        /* Tarikh hujung disebut hanya bila ia melepasi hari yang dijatuhkan —
           kalau semuanya mendarat pada hari yang sama, pengguna sudah
           melihatnya sendiri. */
        const hujung = (adalahTarikh(hariAkhir) && bezaHariIni(hariAkhir) > 0)
            ? T('ws.sched.untilSuffix', ` (hingga ${tarikhLabelHari(hariAkhir)})`, { tarikh: tarikhLabelHari(hariAkhir) })
            : '';
        if (tinggal > 0) {
            toast.warning(T('ws.sched.partial', `${diletak} video diletakkan${hujung}. ${tinggal} lagi tidak muat — slot pada hari-hari berikutnya sudah penuh atau belum ada template.`, { diletak, hujung, tinggal }));
        } else {
            toast.success(T('ws.sched.placed', `${diletak} video diletakkan${hujung}.`, { diletak, hujung }));
        }
    }, [T]);

    /* Caption diambil daripada produk yang dihantar oleh kalendar, bukan
       dicari semula ikut nama — dua produk boleh berkongsi nama yang sama
       selepas Duplicate. */
    const schedCapsyen = useCallback((nama, n, produk) => {
        const teks = produk?.prompts?.[`set${n}`]?.captionTiktok;
        return (teks && teks.trim()) ? teks : T('ws.sched.noCaption', 'Tiada caption pada set ini.');
    }, [T]);

    /* ---------- Tab Generate tidak lagi memaparkan produk (v3.9) ----------
       Nilai tab ini kekal `all`, tetapi maksudnya berubah: ia bukan lagi
       penapis "semua produk" — ia tempat kerja MENYEDIAKAN prompt (arahan
       user 2026-08-12, mengikut prototaip /workspace-v3.9). Kad yang sudah
       dijana tinggal di tab tandanya sendiri sahaja: Flow, Agent AI atau
       Schedule.

       Sebelum ini setiap kad muncul DUA kali — sekali di sini dan sekali di
       tab sebenarnya — jadi kiraan tab pertama sentiasa jumlah ketiga-tiga
       tab yang lain. Yang dibuang ialah pertindihan itu, bukan kadnya.

       ⛔ Rupa lama TIDAK disentuh: tanpa suis v3.9, tab "All" kekal memapar
          semua produk tepat seperti sebelum ini. */
    const filteredAndSortedProducts = useMemo(() => {
        if (uiV39 && activeTab === 'all') return [];

        // Filter by active tab using same logic as extension
        let sorted = activeTab === 'all'
            ? [...baseFilteredProducts]
            : baseFilteredProducts.filter(p => getProductTab(p) === activeTab);

        // Sorting Logic — use panel-specific sort for activeTab
        const st = activeTab === 'tiktok' ? tiktokSortType : flowSortType;
        const sd = activeTab === 'tiktok' ? tiktokSortDirection : flowSortDirection;
        sorted.sort(bandingProduk(st, sd));

        return sorted;
    }, [baseFilteredProducts, activeTab, statusFilter, flowSortType, flowSortDirection, tiktokSortType, tiktokSortDirection, uiV39]);

    // Keyboard shortcut: Ctrl+A — select/deselect all visible products
    useEffect(() => {
        const onKeyDown = (e) => {
            if (!(e.ctrlKey || e.metaKey) || e.key !== 'a') return;
            const tag = document.activeElement?.tagName;
            if (tag === 'INPUT' || tag === 'TEXTAREA' || document.activeElement?.isContentEditable) return;
            e.preventDefault();
            const allSelected = filteredAndSortedProducts.length > 0 && filteredAndSortedProducts.every(p => p.selected);
            const ids = new Set(filteredAndSortedProducts.map(p => p.id));
            const updated = products.map(p => ({
                ...p,
                selected: ids.has(p.id) ? !allSelected : p.selected
            }));
            setProducts(updated);
            saveToCloud(updated);
        };
        window.addEventListener('keydown', onKeyDown);
        return () => window.removeEventListener('keydown', onKeyDown);
    }, [filteredAndSortedProducts, products, saveToCloud]);

    // ? Per-panel sort helpers
    const sortFlowProducts = useCallback((arr) => {
        return [...arr].sort((a, b) => {
            if (flowSortType === 'manual') return bandingSusunanManual(a, b);
            if (flowSortType === 'index') {
                return flowSortDirection === 'asc' ? (a.originalIndex || 0) - (b.originalIndex || 0) : (b.originalIndex || 0) - (a.originalIndex || 0);
            } else if (flowSortType === 'module') {
                const mA = (a.moduleId || '').toLowerCase(), mB = (b.moduleId || '').toLowerCase();
                if (!mA && !mB) return 0;
                if (!mA) return 1;
                if (!mB) return -1;
                return flowSortDirection === 'asc' ? mA.localeCompare(mB) : mB.localeCompare(mA);
            } else {
                const tA = a.movedAt || parseInt(a.id.split('_')[1] || 0), tB = b.movedAt || parseInt(b.id.split('_')[1] || 0);
                return flowSortDirection === 'asc' ? tA - tB : tB - tA;
            }
        });
    }, [flowSortType, flowSortDirection]);

    const sortTiktokProducts = useCallback((arr) => {
        return [...arr].sort((a, b) => {
            if (tiktokSortType === 'manual') return bandingSusunanManual(a, b);
            if (tiktokSortType === 'index') {
                return tiktokSortDirection === 'asc' ? (a.originalIndex || 0) - (b.originalIndex || 0) : (b.originalIndex || 0) - (a.originalIndex || 0);
            } else if (tiktokSortType === 'module') {
                const mA = (a.moduleId || '').toLowerCase(), mB = (b.moduleId || '').toLowerCase();
                if (!mA && !mB) return 0;
                if (!mA) return 1;
                if (!mB) return -1;
                return tiktokSortDirection === 'asc' ? mA.localeCompare(mB) : mB.localeCompare(mA);
            } else {
                const tA = a.movedAt || parseInt(a.id.split('_')[1] || 0), tB = b.movedAt || parseInt(b.id.split('_')[1] || 0);
                return tiktokSortDirection === 'asc' ? tA - tB : tB - tA;
            }
        });
    }, [tiktokSortType, tiktokSortDirection]);

    const flowProducts = useMemo(() => {
        return sortFlowProducts(baseFilteredProducts.filter(p => getProductTab(p) === 'flow'));
    }, [baseFilteredProducts, sortFlowProducts]);

    const tiktokProducts = useMemo(() => {
        return sortTiktokProducts(baseFilteredProducts.filter(p => getProductTab(p) === 'tiktok'));
    }, [baseFilteredProducts, sortTiktokProducts]);

    // ? Resizer drag handlers
    const handleResizeStart = useCallback((e) => {
        e.preventDefault();
        isResizingRef.current = true;
        document.body.style.cursor = 'col-resize';
        document.body.style.userSelect = 'none';

        const handleMouseMove = (e) => {
            if (!isResizingRef.current || !splitContainerRef.current) return;
            const containerRect = splitContainerRef.current.getBoundingClientRect();
            const newPosition = ((e.clientX - containerRect.left) / containerRect.width) * 100;
            // Clamp between 20% and 80%
            setSplitPosition(Math.min(80, Math.max(20, newPosition)));
        };

        const handleMouseUp = () => {
            isResizingRef.current = false;
            document.body.style.cursor = '';
            document.body.style.userSelect = '';
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        };

        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
    }, []);

    // ★ Marquee (Drag-to-Select) Handlers
    const handleMarqueeDown = useCallback((e) => {
        // Only left click, and not on interactive elements
        if (e.button !== 0) return;
        const tag = e.target.tagName.toLowerCase();
        if (['input', 'textarea', 'button', 'select', 'a'].includes(tag) || e.target.closest('button') || e.target.closest('input') || e.target.closest('textarea') || e.target.closest('a') || e.target.closest('[role="button"]')) return;
        /* Elemen yang memang dibuat untuk DISERET (pemegang seret kad tab
           Schedule, `.s-jadgrip`) tidak boleh memulakan kotak pilihan —
           dua gerak isyarat akan bermula serentak, dan sebaik seretan HTML5
           bermula, browser BERHENTI menghantar event tetikus: mouseup tidak
           pernah sampai, kotak marquee tersangkut di skrin sehingga
           pengguna klik sekali lagi (aduan user 2026-08-15). */
        if (e.target.closest('[draggable="true"]')) return;

        if (!canvasRef.current) return;
        const rect = canvasRef.current.getBoundingClientRect();
        const x = e.clientX - rect.left + canvasRef.current.scrollLeft;
        const y = e.clientY - rect.top + canvasRef.current.scrollTop;
        setSelectionBox({ x1: x, y1: y, x2: x, y2: y });
    }, []);

    const handleMarqueeMove = useCallback((e) => {
        if (!selectionBox || !canvasRef.current) return;
        const canvas = canvasRef.current;
        const rect = canvas.getBoundingClientRect();
        const x = e.clientX - rect.left + canvas.scrollLeft;
        const y = e.clientY - rect.top + canvas.scrollTop;

        const newBox = { ...selectionBox, x2: x, y2: y };
        setSelectionBox(newBox);

        // ★ Auto-scroll: trigger when near top/bottom edge
        const EDGE_ZONE = 80; // px from edge to start scrolling
        const MAX_SPEED = 18; // max scroll speed px/frame
        const mouseY = e.clientY - rect.top; // position relative to canvas viewport

        let scrollSpeed = 0;
        if (mouseY < EDGE_ZONE) {
            // Near top — scroll up
            scrollSpeed = -Math.round(MAX_SPEED * (1 - mouseY / EDGE_ZONE));
        } else if (mouseY > rect.height - EDGE_ZONE) {
            // Near bottom — scroll down
            scrollSpeed = Math.round(MAX_SPEED * (1 - (rect.height - mouseY) / EDGE_ZONE));
        }

        // Cancel previous frame
        if (scrollAnimRef.current) {
            cancelAnimationFrame(scrollAnimRef.current);
            scrollAnimRef.current = null;
        }

        if (scrollSpeed !== 0) {
            const doScroll = () => {
                if (!canvasRef.current) return;
                canvasRef.current.scrollTop += scrollSpeed;
                scrollAnimRef.current = requestAnimationFrame(doScroll);
            };
            scrollAnimRef.current = requestAnimationFrame(doScroll);
        }

        // Real-time preview: find cards overlapping the selection box
        const xMin = Math.min(newBox.x1, newBox.x2);
        const xMax = Math.max(newBox.x1, newBox.x2);
        const yMin = Math.min(newBox.y1, newBox.y2);
        const yMax = Math.max(newBox.y1, newBox.y2);

        const previews = [];
        const elements = canvas.querySelectorAll('[data-product-id]');
        const canvasRect = canvas.getBoundingClientRect();

        elements.forEach(el => {
            const elRect = el.getBoundingClientRect();
            const elX1 = elRect.left - canvasRect.left + canvas.scrollLeft;
            const elY1 = elRect.top - canvasRect.top + canvas.scrollTop;
            const elX2 = elX1 + elRect.width;
            const elY2 = elY1 + elRect.height;

            if (elX1 < xMax && elX2 > xMin && elY1 < yMax && elY2 > yMin) {
                previews.push(el.getAttribute('data-product-id'));
            }
        });

        setPreviewSelectedIds(previews);
    }, [selectionBox]);

    const handleMarqueeUp = useCallback(() => {
        // ★ Stop auto-scroll
        if (scrollAnimRef.current) {
            cancelAnimationFrame(scrollAnimRef.current);
            scrollAnimRef.current = null;
        }

        if (!selectionBox) return;

        const wasTinyClick = Math.abs(selectionBox.x2 - selectionBox.x1) < 5 && Math.abs(selectionBox.y2 - selectionBox.y1) < 5;

        if (previewSelectedIds.length > 0) {
            // Select the dragged-over products, deselect others
            const selectedSet = new Set(previewSelectedIds);
            const updated = products.map(p => ({ ...p, selected: selectedSet.has(p.id) }));
            setProducts(updated);
            saveToCloud(updated);
        } else if (wasTinyClick) {
            // Click on empty area = clear all selection
            const updated = products.map(p => ({ ...p, selected: false }));
            setProducts(updated);
            saveToCloud(updated);
        }

        setSelectionBox(null);
        setPreviewSelectedIds([]);
    }, [selectionBox, previewSelectedIds, products]);

    /* Jaring keselamatan pelengkap kepada guard `[draggable="true"]` dalam
       handleMarqueeDown: apa-apa seretan HTML5 yang bermula di dalam kanvas
       membatalkan kotak pilihan SERTA-MERTA. Semasa seretan, browser tidak
       lagi menghantar event tetikus — handleMarqueeUp tidak akan dipanggil,
       jadi kotak DAN gelung auto-scroll (yang menjadualkan dirinya sendiri
       melalui requestAnimationFrame) mesti dibersihkan di sini; kalau tidak,
       kedua-duanya tersangkut sehingga klik seterusnya. */
    const handleCanvasDragStart = useCallback(() => {
        if (scrollAnimRef.current) {
            cancelAnimationFrame(scrollAnimRef.current);
            scrollAnimRef.current = null;
        }
        setSelectionBox(null);
        setPreviewSelectedIds([]);
    }, []);


    /* ★ DRAG SUSUN KAD (2026-09-05, v3.9). Jatuhan pada kad lain = susun semula. Nombor ditulis ke
       `manualOrder` melalui saveToCloud (diff-save) → listener extension terima → susunan SAMA di
       kedua-dua tempat. Susunan tab bertukar ke "Susunan saya" supaya hasil seretan kelihatan. */
    const susunKadSeret = (idsSeret, targetId) => {
        if (!idsSeret.length || idsSeret.includes(targetId)) return;
        const perubahan = kiraSusunanSeret(filteredAndSortedProducts, idsSeret, targetId);
        if (perubahan.size === 0) return;
        const updated = products.map(p => perubahan.has(p.id) ? { ...p, manualOrder: perubahan.get(p.id) } : p);
        setProducts(updated);
        saveToCloud(updated);
        if (activeTab === 'tiktok') { setTiktokSortType('manual'); setTiktokSortDirection('asc'); }
        else { setFlowSortType('manual'); setFlowSortDirection('asc'); }
    };

    /* ★ SUSUN GAMBAR PRODUK (2026-09-05). Posisi 1 = gambar UTAMA, jadi menyeret gambar lain ke
       hadapan betul-betul menukar gambar utama kad. Kad menyimpan gambar utama dalam DUA medan lama
       (`imageBase64` dan `imageUrl`) yang dibaca dengan keutamaan berbeza di tempat berbeza — jadi
       kedua-duanya ditulis dengan nilai yang SAMA supaya tiada pembaca terpesong.
       ⚠️ Saiz doc tidak berubah walau gambar base64 berpindah ke dalam senarai: ia memang sudah
       berada dalam doc yang sama. */
    const susunGambarSeret = (productId, dari, ke) => {
        if (dari === ke) return;
        const p = productsRef.current?.find(x => x.id === productId) || products.find(x => x.id === productId);
        if (!p) return;
        const semua = [p.imageBase64 || p.imageUrl, ...gambarTambahan(p)].filter(Boolean);
        if (dari < 0 || ke < 0 || dari >= semua.length || ke >= semua.length) return;
        const baru = [...semua];
        baru.splice(ke, 0, baru.splice(dari, 1)[0]);
        const updated = products.map(x => x.id === productId
            ? { ...x, imageBase64: baru[0], imageUrl: baru[0], extraImageUrls: baru.slice(1) }
            : x);
        setProducts(updated);
        saveToCloud(updated);
    };

    // Run Flow Logic — ★ DUAL-PATH: Direct message + Firestore fallback
    /* ⭐ 2026-09-16 — KUNCI "Guna gambar pada card" bila kad yang DITANDA tidak menyokongnya.
       Peraturan: kalau SATU pun kad yang ditanda bukan skrip ai8saat (AI8SAAT / SMART 1 babak),
       mod card tidak boleh dipakai untuk larian itu — jadi:
         · Control Panel melumpuhkan pilihan itu + menyebut module yang menghalang
         · `workflowKad` di bawah jadi PALSU, jadi larian itu berjalan cara biasa (generate)
       ⭐ Nilai TERSIMPAN pelanggan (`flowWorkflow`) TIDAK disentuh — tanda kad AI8SAAT semula
          dan mod card kembali dengan sendirinya. Itu sebabnya kita kira di sini, bukan
          setFlowWorkflow('generate'): menulis nilai itu akan memadam pilihan pelanggan.

       ⛔ FAIL-OPEN: tiada kad ditanda → null (terbuka). Kalau kita tersilap MENGUNCI, pelanggan
          yang mahu mod card dapat mod generate (bakar kredit gambar). Ia kelihatan — nota amber
          menyebut module dan butang Run kehilangan "· Gambar card" — tetapi tetap jangan
          longgarkan syarat ini tanpa mengukur dahulu.

       ⚠️ KEMBAR: penapis di bawah MESTI sama dengan penapis `productsToRun` dalam handleRunFlow
          (beberapa baris di bawah). Ubah satu, ubah dua-dua — kalau tidak panel mengunci kad yang
          sebenarnya boleh dijalankan, atau membiarkan kad yang tidak boleh. */
    /* ★ [3 Nov] Senarai kad ditanda diasingkan supaya dropdown Workflow v4 (ringkasan Formula di
       bawah) membaca penapis YANG SAMA dengan `kadTakSokong` — satu takrifan, bukan dua. */
    const kadDitandaWf = useMemo(() => {
        if (!workflowAktif) return [];
        const dlmSpace = selectedSpaceId === 'default'
            ? products.filter(p => !(p.spaceId || p.groupId) || p.spaceId === 'default' || p.groupId === 'default')
            : products.filter(p => p.spaceId === selectedSpaceId || p.groupId === selectedSpaceId);
        return dlmSpace.filter(p => {
            if (!p.selected) return false;
            if (uiV39 && activeTab !== 'all' && getProductTab(p) !== activeTab) return false;
            if (selectedGroupId === 'all') return true;
            return (p.workspaceGroup || 'Workspace') === selectedGroupId;
        });
    }, [workflowAktif, products, activeTab, selectedGroupId, uiV39, selectedSpaceId]);

    const kadTakSokong = useMemo(() => {
        if (!kadDitandaWf.length) return null;
        /* SATU kad yang tidak menyokong sudah cukup untuk mengunci — termasuk pilihan
           bercampur module (AI8SAAT + AI16SAAT), yang memang tidak boleh dijalankan. */
        const halang = kadDitandaWf.find(p => getEffectiveScriptKey(p) !== 'ai8saat');
        return halang ? getDisplayLabelForProduct(halang) : null;
    }, [kadDitandaWf]);

    /* Control Panel (App.jsx) tidak nampak kad yang ditanda — WorkspaceView yang melaporkan. */
    useEffect(() => {
        onSelectedScriptChange?.(kadTakSokong);
    }, [kadTakSokong, onSelectedScriptChange]);

    /* ★ [3 Nov] Ringkasan Formula kad ditanda → dropdown Workflow (Workspace v4 mod New). Dilapor
       sebagai teks JSON supaya effect hanya menyala bila ISI berubah (tiada gelung render). */
    const ringkasanWfJson = useMemo(() => JSON.stringify(ringkasKadDitanda(kadDitandaWf, {
        jenisKad: (p) => jenisKadWorkflow(p, { getEffectiveScriptKey, getModule }),
        labelKad: getDisplayLabelForProduct,
    })), [kadDitandaWf]);
    useEffect(() => {
        onKadDitandaWfChange?.(JSON.parse(ringkasanWfJson));
    }, [ringkasanWfJson, onKadDitandaWfChange]);

    /* ⛔ SATU-SATUNYA nilai yang menukar larian. Palsu bila pagar `workflowAktif` mati
       (admin + rupa v3.9, dikira App.jsx) ATAU kad yang ditanda tidak menyokong mod card. */
    const workflowKad = !!workflowAktif && flowWorkflow === 'kad' && !kadTakSokong;

    /* ★ Babak FLOWNITY yang ditanda di Control Panel (S1–S5 → [1..5]). SATU takrifan: payload Run Flow
       (`flownityScenes`) DAN semakan prompt membacanya — dua salinan boleh membuat semakan menanda babak
       yang pelanggan sudah buang tick. */
    const babakFlownityDipilih = () => automationTargetScenes.map(s => parseInt(String(s).replace('set', ''), 10)).filter(n => n > 0).sort((a, b) => a - b);
    /* ★ Opsyen semakan prompt untuk SATU card, ikut tetapan Control Panel SEMASA. Dipakai Run Flow DAN tanda
       oren pada card (dikira setiap render) — satu takrifan supaya tanda hilang tepat bila card tidak lagi
       menahan larian. `setsSiap` = set yang Continue Collection langkau (sudah dihantar). */
    const opsyenSemakPrompt = (p) => {
        const scriptKey = getEffectiveScriptKey(p);
        return {
            scriptKey,
            sets: automationTargetSets,
            workflowKad,
            sceneCount: getSceneCount(p),
            jenisGambar: resipiFrame(p) ? 'frame' : resipiGambarSahaja(p) ? 'sahaja' : (resipiBerlainan(p) ? 'berlainan' : (resipiTanpaGambar(p) ? 'tiada' : 'sama')),
            scenes: scriptKey === 'nscene' ? babakFlownityDipilih() : null,
            setsSiap: (continueCollectionMode && Array.isArray(p?.deliveredSets)) ? p.deliveredSets : [],
        };
    };

    const hostedRunRef = useRef(false); // ★ Hosted Flow Beta — pagar klik berganda (sync, elak duplicate)
    const handleRunFlow = async () => {
        /* Run ditekan semula → tanda "tiada prompt" lama dikosongkan dahulu; semakan prompt di bawah
           menandakan semula card yang MASIH bermasalah (keputusan user 2026-09-18). */
        setKadPromptKosong([]);
        setPopupPromptKosong(false);
        if (!auth.currentUser) {
            alert(T('ws.run.loginFirst', "Sila log masuk terlebih dahulu."));
            return;
        }

        // Only run products from current space AND selected
        const spaceProducts = selectedSpaceId === 'default'
            ? products.filter(p => !(p.spaceId || p.groupId) || p.spaceId === 'default' || p.groupId === 'default')
            : products.filter(p => p.spaceId === selectedSpaceId || p.groupId === selectedSpaceId);
        // ★ v3.0.0: Run any selected product, regardless of tab
        // ★ Fix: Filter by current group — only run products from the group user is viewing
        const productsToRun = spaceProducts.filter(p => {
            if (!p.selected) return false;
            /* v3.9: hanya kad pada TAB SEMASA dijalankan (arahan user
               2026-08-12). Tanpa ini, kad yang ditanda di tab Schedule
               benar-benar masuk queue Flow — bukan sekadar tersalah kira —
               sedangkan pengguna langsung tidak nampak kad itu di skrin
               semasa dia menekan Run.

               ⛔ Rupa lama kekal "run any selected, regardless of tab"
                  seperti sejak v3.0.0. Itu laluan yang pelanggan guna
                  setiap hari; ia hanya bertukar bersama-sama v3.9. */
            if (uiV39 && activeTab !== 'all' && getProductTab(p) !== activeTab) return false;
            if (selectedGroupId === 'all') return true;
            return (p.workspaceGroup || 'Workspace') === selectedGroupId;
        });

        if (productsToRun.length === 0) {
            alert(T('ws.run.selectProduct', "Sila pilih produk untuk dijalankan."));
            return;
        }

        // ★ SPLIT V2: WAJIB hydrate teks produk split SEBELUM apa-apa mutasi/payload —
        //   tanpa ini extension terima prompts KOSONG senyap (Flow jana guna nama produk).
        //   Gagal muat = ABORT run (tiada apa-apa berubah lagi di titik ni).
        try {
            await hydrateDetails(productsToRun, { throwOnError: true });
        } catch (e) {
            alert(T('ws.run.hydrateFailed', "Gagal memuatkan teks prompt dari cloud. Sila semak sambungan internet anda dan cuba semula."));
            return;
        }

        // ★ FASA 2 (Continue Collection): reconcile collection tersimpan pada produk (SATU produk sahaja).
        //   Guna product.collectionUrl (auto-disimpan selepas run biasa) + langkau set yang dah siap.
        let _sambungMode = false, _sambungCollectionUrl = '', _sambungDelivered = [];
        if (continueCollectionMode) {
            if (productsToRun.length !== 1) { alert(T('ws.run.continueOneOnly', "Untuk Continue Collection, pilih SATU produk sahaja.")); return; }
            const _cp = productsToRun[0];
            if (!_cp.collectionUrl) { alert(T('ws.run.noCollection', "Produk ini belum ada collection tersimpan.\nRun Flow biasa sekali dulu — collection akan disimpan automatik, baru boleh Continue.")); return; }
            _sambungMode = true;
            _sambungCollectionUrl = _cp.collectionUrl;
            _sambungDelivered = Array.isArray(_cp.deliveredSets) ? _cp.deliveredSets : [];
            console.log(`[Flow] ★ CONTINUE COLLECTION: ${_cp.name} → ${_sambungCollectionUrl} (siap: ${_sambungDelivered.join(',') || '—'})`);
        }

        // ★ Maintenance lock — enforce pada PRODUK yang dipilih, BUKAN module selector.
        // Sebab: user boleh switch ke AI8SAAT module lalu pilih produk GOYANG → bypass kalau check selector.
        // Fix: semak p.moduleId pada setiap produk yang akan dirun.
        // Admin tetap boleh run semua modul untuk testing.
        // AI8SAAT + GOYANG + AI16SAAT + Home Niche sudah stabil — buka untuk semua user. Smart Custom masih maintenance.
        const _isAdminFlow = getUserRole(auth.currentUser?.email) === ROLES.ADMIN;
        // ✅ SMART DIBUKA 2026-08-17 (arahan user) — senarai ini kini kosong.
        // Ia dibuka SERENTAK dengan MAINTENANCE_LOCKED_MODULES dalam App.jsx;
        // membuka satu sahaja bermakna module boleh dipilih tetapi Run gagal,
        // atau sebaliknya. Nak kunci semula: masukkan id module ke DUA-DUA senarai.
        const FLOW_LOCKED_MODULES = [];
        const hasLockedProduct = productsToRun.some(p => FLOW_LOCKED_MODULES.includes(p.moduleId));
        if (!_isAdminFlow && hasLockedProduct) {
            toast.warning(T('ws.run.moduleMaintenance', 'Modul ini sedang penyelenggaraan — kami sedang adapt extension untuk interface terbaru Google Labs Flow. Nanti kami buka balik sebaik sahaja stabil.'));
            return;
        }

        // ★ Mixed-module guard — group by EFFECTIVE scriptKey, abort if multiple distinct scripts selected
        // Bug context: extension load satu automation script per batch (script-level, bukan task-level).
        // Mixed selection = wrong script jalan untuk produk yang tak match. Halang di webapp side.
        // Note: Smart Custom rute script ikut smartcustomSceneCount (1=ai8saat, 2=ai16saat).
        // Smart Custom 1-scene + ai8saat product = SAME script = boleh run sama-sama.
        // Smart Custom 2-scene + ai16saat-half = SAME script = boleh run sama-sama.
        const productsByScript = new Map();
        for (const p of productsToRun) {
            const scriptKey = getEffectiveScriptKey(p);
            if (!productsByScript.has(scriptKey)) productsByScript.set(scriptKey, []);
            productsByScript.get(scriptKey).push(p);
        }
        if (productsByScript.size > 1) {
            const groups = [];
            for (const [scriptKey, prods] of productsByScript) {
                // Use first product's display label as group label (handles Smart Custom scene suffix)
                groups.push({
                    scriptKey,
                    marketingName: getDisplayLabelForProduct(prods[0]),
                    count: prods.length,
                    productNames: prods.slice(0, 5).map(p => p.name || T('ws.common.noName', '(tanpa nama)')),
                    hasMore: prods.length > 5,
                });
            }
            setMixedModuleModal({ groups });
            return;
        }

        /* ⭐ 2026-09-15 — WORKFLOW "Guna gambar card" (admin sahaja; `workflowKad` palsu bagi yang lain).
           (1) Skrip yang ada laluan card = AI8SAAT sahaja (AI8SAAT + SMART 1 babak). Module lain AKAN jalan cara
               biasa kalau tidak disekat di sini (skrip mereka tidak membaca flowWorkflow) — senyap dan membakar
               kredit untuk generate gambar yang pengguna tidak minta.
           (2) Veo terima 3 gambar sahaja dalam Ingredients (diukur flow.google.com 2026-09-15). Card yang ada lebih
               → pengguna disahkan dahulu, sebab gambar selebihnya (selalunya storyboard yang ditambah di hujung)
               tidak masuk video. Kiraan KEMBAR dengan _kadSenaraiGambar (flow-common.js): gambar utama + avatar
               http + gambar tambahan http/data (maks 4). */
        if (workflowKad) {
            const _skKad = getEffectiveScriptKey(productsToRun[0]);
            if (_skKad !== 'ai8saat') {
                alert(T('ws.run.workflowKadModul', `Workflow "Guna gambar pada card" buat masa ini hanya untuk AI8SAAT dan SMART 1 babak.\n\nCard yang dipilih guna ${getDisplayLabelForProduct(productsToRun[0])}. Tukar Workflow ke "Generate di Flow" untuk run card ini.`, { module: getDisplayLabelForProduct(productsToRun[0]) }));
                return;
            }
            if (flowUltraMode !== 'omni_flash') {
                const _bilGambarKad = (p) => {
                    const utama = (p.imageBase64 || p.imageUrl || p.localImagePath) ? 1 : 0;
                    const avatar = (typeof p.avatarImageUrl === 'string' && p.avatarImageUrl.startsWith('http')) ? 1 : 0;
                    const tambahan = gambarTambahan(p).filter(u => u.startsWith('http') || u.startsWith('data:')).slice(0, 4).length;
                    return utama + avatar + tambahan;
                };
                const _lebih3 = productsToRun.filter(p => _bilGambarKad(p) > 3);
                if (_lebih3.length && !window.confirm(T('ws.run.workflowKadVeo', `Model Veo hanya guna 3 gambar card.\n\n${_lebih3.length} card yang dipilih ada lebih daripada 3 gambar — gambar selebihnya tidak akan masuk video (keutamaan: gambar utama, avatar, kemudian gambar 2, 3…).\n\nPilih Omni Flash untuk guna semua gambar.\n\nTeruskan dengan 3 gambar?`, { n: _lebih3.length }))) {
                    return;
                }
            }
        }

        if (automationTargetSets.length === 0) {
            alert(T('ws.run.selectSet', "Sila pilih sekurang-kurangnya satu Set (S1-S3)."));
            return;
        }

        // ★ FLOWNITY scene subset (Bahagian 1 — plumbing sahaja) — hantar senarai scene terpilih (S1–S5) ke skrip.
        //   INERT buat masa ni: flow-automation-flownity.js belum baca `flownityScenes` (Bahagian 2).
        //   Modul lain → null (skrip abai). Format: nombor scene, cth [4, 5].
        const _isFlownityRun = productsToRun[0] ? getEffectiveScriptKey(productsToRun[0]) === 'nscene' : false;
        const flownityScenes = _isFlownityRun
            ? babakFlownityDipilih()
            : null;

        /* ★ SEMAKAN PROMPT (keputusan user 2026-09-18) — SEBELUM ping extension, sebelum apa-apa tab dibuka.
           Robot Flow menggantikan prompt kosong dengan NAMA PRODUK dan terus menjana (kredit terbakar, hasil
           tidak menjadi, tiada sebab pada card). Satu card bermasalah = SELURUH larian ditahan (sama seperti
           semakan ruang gambar tab My Agent) sehingga pelanggan mengisi prompt, membuang tick card / set, atau
           menukar Workflow. Semakan dibuat atas teks yang SAMA seperti payload (withDetail selepas hydrate).
           ⛔ Card split yang kelihatan kosong DIBACA SEMULA dari server dahulu: salinan dalam ingatan boleh
              basi (pepijat cache 13 Sept menghantar card tanpa prompt walaupun subdoc penuh). Bacaan segar itu
              turut membetulkan cache — payload di bawah terus membawa teks yang betul. */
        const _semakPrompt = () => productsToRun
            .map(p => ({ p, masalah: masalahPromptKad(withDetail(p), opsyenSemakPrompt(p)) }))
            .filter(x => x.masalah.length > 0);
        let _tiadaPrompt = _semakPrompt();
        const _bacaSemula = _tiadaPrompt.filter(x => x.p.splitV === 2);
        if (_bacaSemula.length > 0) {
            try {
                await Promise.all(_bacaSemula.map(async ({ p }) => {
                    const d = await loadProductDetail(auth.currentUser.uid, p.id);
                    detailCacheRef.current.set(p.id, { ...d, _fetchedAtMs: Date.now() });
                }));
            } catch (e) {
                console.warn('[Flow] Semakan prompt: bacaan semula teks gagal', e?.message);
                alert(T('ws.run.hydrateFailed', "Gagal memuatkan teks prompt dari cloud. Sila semak sambungan internet anda dan cuba semula."));
                return;
            }
            setDetailReadyTick(t => t + 1);
            _tiadaPrompt = _semakPrompt();
        }
        if (_tiadaPrompt.length > 0) {
            console.warn(`[Flow] ✗ Run ditahan — ${_tiadaPrompt.length} card tiada prompt:`, _tiadaPrompt.map(x => `${x.p.name} → ${JSON.stringify(x.masalah)}`));
            setKadPromptKosong(_tiadaPrompt.map(({ p, masalah }) => ({ id: p.id, nama: String(p.name || ''), masalah })));
            setPopupPromptKosong(true);
            const _idPertama = _tiadaPrompt[0].p.id;
            setTimeout(() => {
                try {
                    const sel = (typeof CSS !== 'undefined' && CSS.escape) ? CSS.escape(_idPertama) : String(_idPertama).replace(/"/g, '\\"');
                    document.querySelector(`[data-product-id="${sel}"]`)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
                } catch { /* tatal gagal = card masih bertanda; bukan kegagalan larian */ }
            }, 80);
            return;
        }

        /* ⭐ Workflow card: Ingredients SENTIASA hidup (mod Frames hanya terima 2 gambar), dan Veo hanya 8s bila
           ada gambar Ingredients — sepadan dengan paparan berkunci App.jsx (`durasiKunci8`). Nilai tersimpan
           pengguna TIDAK diubah; hanya larian card ini yang membawa nilai paksa. Skrip turut mempertahankannya. */
        const ingredientsLarian = workflowKad ? true : flowIngredientsMode;
        const durasiLarian = (workflowKad && flowUltraMode !== 'omni_flash') ? '8s' : flowVideoDuration;

        // ════════════════════════════════════════════════════════════════════════════
        // ★ HOSTED FLOW BETA (approve owner 2026-10-30) — pelanggan LAYAK pilih mode Hosted →
        //   card+set terpilih masuk QUEUE Central Worker (PC ofis). ⛔ TIADA extension /
        //   SESAAT_DIRECT_FLOW. Hosted OFF / Run Flow Biasa → teruskan laluan legacy di bawah (tak diubah).
        //   Idempotency SERVER (uid_pid_set_tarikh) + pagar ref → double-klik / retry timeout tak duplicate.
        //   Confirmation HANYA selepas backend TERIMA job; backend mati → gagal BISING (bukan pura-pura).
        // ════════════════════════════════════════════════════════════════════════════
        if (hostedBetaAktif) {
            if (hostedRunRef.current) { console.warn('[Hosted] Run sedang berjalan — abai klik berganda'); return; }
            // ★ Hosted Beta = workflow 'Guna gambar card' SAHAJA (Veo LP, 1 scene, tiada jana imej).
            //   workflowKad ON menjamin card AI8SAAT (disemak di atas). OFF → minta tukar dulu.
            if (!workflowKad) { alert(T('hosted.run.kadOnly', "Hosted Flow Beta guna 'Guna gambar card' sahaja. Tukar Workflow ke 'Guna gambar card' di Control Panel dulu, kemudian Submit semula.")); return; }
            const sortedSets = [...automationTargetSets].sort();
            const items = [];
            for (const p of productsToRun) for (const setKey of sortedSets) items.push({ productId: p.id, setKey });
            const workflowHosted = 'kad'; // dipaksa (server juga paksa) — tiada 'generate' untuk Hosted
            const LABEL_RALAT = { QUOTA_EXCEEDED: 'kuota 9 video harian penuh', CARD_LIMIT: 'had 3 card harian penuh', NOT_ELIGIBLE: 'langganan Lite LP tidak aktif', NO_PROMPT: 'prompt video kosong', PAUSED: 'Hosted Beta sedang dijeda admin', NOT_CARD_OWNER: 'card bukan milik anda', MODEL_NOT_ALLOWED: 'model tidak dibenarkan' };
            const namaRalat = (g) => LABEL_RALAT[g.error] || g.error || 'ralat';
            hostedRunRef.current = true;
            setIsSaving(true);
            setAutomationProgress({
                isActive: true, type: 'flow', status: 'running', extensionStatus: 'connected',
                currentStep: 1, totalSteps: 1,
                steps: [{ label: T('hosted.run.sending', 'Menghantar ke PC ofis SESAAT...'), status: 'running' }],
                message: T('hosted.run.title', `Hosted Flow Beta — ${items.length} job`, { n: items.length }),
                details: T('hosted.run.detail', `${productsToRun.length} card × ${sortedSets.length} set → PC ofis. Anda boleh tutup browser; video masuk card bila siap.`, { n: productsToRun.length, sets: sortedSets.length })
            });
            // Satu Submit = satu batchId = satu email ringkasan bila batch selesai (keputusan owner 30 Okt).
            const batchId = (globalThis.crypto && globalThis.crypto.randomUUID) ? globalThis.crypto.randomUUID() : ('b_' + Date.now() + '_' + Math.random().toString(36).slice(2));
            try {
                const hasil = await hantarHostedBeta({
                    enqueue: enqueueFlowJob, items, workflow: workflowHosted, batchId,
                    openBatch: bukaBatchHostedBeta, sealBatch: sealBatchHostedBeta,
                    onProgress: (siap, jumlah) => setAutomationProgress(prev => (prev ? { ...prev, details: T('hosted.run.progress', `${siap}/${jumlah} dihantar...`, { siap, jumlah }) } : prev)),
                });
                const jumlahOk = hasil.dihantar.length + hasil.duplicate.length;
                if (hasil.offline || (jumlahOk === 0 && hasil.gagal.length > 0 && hasil.gagal.every((g) => sebabOffline(g)))) {
                    setAutomationProgress({
                        isActive: true, type: 'flow', status: 'disconnected', extensionStatus: 'disconnected',
                        steps: [], currentStep: 0, totalSteps: 0,
                        message: T('hosted.run.offlineTitle', 'PC ofis SESAAT tidak dapat dihubungi'),
                        details: T('hosted.run.offlineDetail', 'Job TIDAK dihantar. Cuba sebentar lagi atau hubungi admin SESAAT.')
                    });
                } else {
                    const nGagal = hasil.gagal.length;
                    setAutomationProgress({
                        isActive: true, type: 'flow', status: nGagal ? 'error' : 'success',
                        currentStep: 1, totalSteps: 1,
                        steps: [{ label: T('hosted.run.sent', `${jumlahOk} job diterima queue ✓`, { n: jumlahOk }), status: nGagal ? 'error' : 'done' }],
                        message: nGagal ? T('hosted.run.partial', '⚠ Sebahagian job gagal') : T('hosted.run.okTitle', '🚀 Job masuk queue PC ofis!'),
                        details: (hasil.dihantar.length ? T('hosted.run.okDetail', `${hasil.dihantar.length} job baharu dihantar.`, { n: hasil.dihantar.length }) : '')
                            + (hasil.duplicate.length ? T('hosted.run.dupDetail', ` ${hasil.duplicate.length} sudah dalam barisan (tiada duplicate).`, { n: hasil.duplicate.length }) : '')
                            + (nGagal ? T('hosted.run.failDetail', ` ${nGagal} gagal: ${hasil.gagal.map(namaRalat).join(', ')}`, { n: nGagal, sebab: hasil.gagal.map(namaRalat).join(', ') }) : '')
                            + T('hosted.run.seeStatus', ' Lihat status di Control Panel.')
                    });
                }
            } catch (e) {
                setAutomationProgress({
                    isActive: true, type: 'flow', status: 'error', steps: [], currentStep: 0, totalSteps: 0,
                    message: T('hosted.run.failed', '❌ Submit Hosted gagal'),
                    details: (e && e.message) || 'Ralat tidak diketahui.'
                });
            } finally {
                hostedRunRef.current = false;
                setIsSaving(false);
                setTimeout(() => setAutomationProgress((prev) => (prev ? { ...prev, isActive: false } : prev)), 6000);
            }
            return; // ⛔ Hosted selesai di sini — JANGAN jatuh ke laluan extension legacy
        }

        setIsSaving(true);
        console.log("[Flow] ★ Starting Direct Flow Automation...");

        // ★ PRE-FLIGHT CHECK: Confirm content script alive before dispatching.
        // If dead (extension context invalidated etc.), show explicit refresh modal instead of silent fallback.
        const ping = await pingExtension();
        if (!ping.alive) {
            console.warn('[Flow] ✗ Pre-flight ping failed — content script unreachable. Showing refresh modal.');
            setAutomationProgress({
                isActive: true, type: 'flow', steps: [], currentStep: 0, totalSteps: 0,
                status: 'disconnected',
                extensionStatus: 'disconnected',
                message: T('ws.run.extDisconnected', 'Extension Terputus Sambungan'),
                details: T('ws.run.extDisconnectedFlow', 'Tab ini perlu di-refresh dulu sebelum boleh start Flow.')
            });
            setIsSaving(false);
            return;
        }
        // ★ GATE VERSI (v3.8.2): blok extension lama sebelum Run
        const _vGate = await checkExtensionVersionGate(ping.version);
        if (_vGate) { setVersionGateModal(_vGate); setIsSaving(false); return; }

        const totalSteps = 3;
        setAutomationProgress({
            isActive: true, type: 'flow', steps: [
                /* ⛔ `status` = nilai yang dibanding oleh paparan langkah — JANGAN terjemah. */
                { label: T('ws.run.step.prepare', 'Menyediakan produk...'), status: 'pending' },
                { label: T('ws.run.step.send', 'Menghantar arahan ke Extension...'), status: 'pending' },
                { label: T('ws.run.step.done', 'Selesai!'), status: 'pending' }
            ], currentStep: 0, totalSteps, status: 'running',
            extensionStatus: 'connected',
            message: T('ws.run.flowTitle', `Flow Automation — ${productsToRun.length} produk`, { n: productsToRun.length }),
            /* ⛔ `s.replace('set','S')` menukar KUNCI SET jadi label ringkas (set1 → S1).
               Itu bukan terjemahan — jangan sentuh. */
            details: T('ws.run.setsLabel', `Sets: ${automationTargetSets.map(s => s.replace('set', 'S')).join(', ')}`, { sets: automationTargetSets.map(s => s.replace('set', 'S')).join(', ') })
        });

        try {
            let stepIdx = 0;

            // Step 1: Mark items as 'queued_flow' + save to Firestore
            setAutomationProgress(prev => ({ ...prev, currentStep: stepIdx + 1, steps: prev.steps.map((s, i) => i === stepIdx ? { ...s, status: 'running' } : s) }));
            const runIds = new Set(productsToRun.map(tp => tp.id));
            const updatedProducts = products.map(p => {
                if (runIds.has(p.id)) {
                    return {
                        ...p,
                        status: 'queued_flow',
                        extensionSettings: {
                            isImageOnly,
                            flowProjectMode,
                            flowProjectUrl,
                            flowUltraMode,
                            flowVideoDuration: durasiLarian,
                            flowIngredientsMode: ingredientsLarian,
                            flowVideoResolution,
                            flowDownloadSize,
                            flowWorkflow: workflowKad ? 'kad' : 'generate',
                            flowSceneOutput: hasilScene,   // ★ RESIPI: 'gabung' | 'asing' (Control Panel "Scene output") — settings disalin bulat-bulat ke skrip
                    flowRujukanProduk: rujukanProduk,   // ★ RESIPI gambar berlainan: scene mana guna gambar produk (Control Panel "Product photo")
                    flowSimpanGambar: simpanGambar,   // ★ RESIPI Images only: 'folder' | 'kad' (Control Panel "Save images")
                    flowBilOutput: bilOutput,   // ★ RESIPI Images only: '1'..'4' gambar setiap prompt (Control Panel "Images per prompt")
                            flowImageModel,
                            targetSets: automationTargetSets,
                            flownityScenes
                        }
                    };
                }
                return p;
            });
            setProducts(updatedProducts);
            // ★ Save ONLY the products that changed (was: saving all N products = N×listener reads)
            const changedOnly = updatedProducts.filter(p => runIds.has(p.id));
            await saveProducts(auth.currentUser.uid, changedOnly);
            mulaPantauModel(runIds);   // ★ popup bila robot berhenti kerana model Video tiada (2026-09-24)
            setAutomationProgress(prev => ({ ...prev, steps: prev.steps.map((s, i) => i === stepIdx ? { ...s, status: 'done' } : s) }));
            stepIdx++;

            // Step 2: ★ DUAL-PATH — Try Direct message first, fallback to Firestore queue
            setAutomationProgress(prev => ({ ...prev, currentStep: stepIdx + 1, steps: prev.steps.map((s, i) => i === stepIdx ? { ...s, status: 'running' } : s) }));

            // Build sequential tasks list
            const sequentialTasks = [];
            const sortedSets = [...automationTargetSets].sort();
            for (const item of productsToRun) {
                for (const setId of sortedSets) {
                    sequentialTasks.push({
                        productId: item.id,
                        targetSet: setId
                    });
                }
            }

            // ★ NO dynamic substitution at run flow — textarea content IS the source of truth.
            // Apa user nampak dalam textarea = apa extension paste ke Gemini = apa user copy manual.
            // Hook substitution + mandatory append semua dah dilakukan masa generate-time
            // (Cloud Function substitute [HOOK]; mapping di atas append mandatoryImage/Video).
            // Manual copy + auto extension flow consistent — single source of truth.

            // Prepare product data for the extension
            // ★ SPLIT V2: withDetail — teks dari detailCache (dihydrate awal function)
            const productDataForExtension = productsToRun.map(withDetail).map(p => {
                // GOYANG template-level overrides (avatar UI hidden for GOYANG):
                //  - customBgImageUrl → reuses avatarImageUrl slot (no avatar concept in GOYANG)
                //  - handGender ('female'/'male', NOT 'auto') → overrides p.gender
                // Prefer product.templateSnapshot (used at generation time) over current leftpanel
                // selection to keep flow inputs consistent with the baked-in prompt.
                const isGoyang = (p.moduleId || null) === 'goyang';
                const tplForFlow = p.templateSnapshot || propSelectedTemplate;
                const templateBgUrl = (isGoyang && tplForFlow?.customBgImageUrl) || null;
                const tplHandGender = (isGoyang && tplForFlow?.handGender && tplForFlow.handGender !== 'auto') ? tplForFlow.handGender : null;
                return {
                    id: p.id,
                    name: p.name,
                    link: p.link,
                    originalIndex: p.originalIndex || null,
                    imageBase64: p.imageBase64 || null,
                    imageUrl: (p.imageBase64 && typeof p.imageBase64 === 'string' && p.imageBase64.startsWith('http'))
                        ? p.imageBase64
                        : (p.imageUrl || p.localImagePath || null),
                    localImagePath: p.localImagePath || null,
                    prompts: p.prompts,
                    // V3: Avatar & module data for flow-common.js
                    moduleId: p.moduleId || null,
                    sceneCount: getSceneCount(p), // N-scene: berapa babak nak di-extend dalam Flow
                    gender: tplHandGender || p.gender || null,
                    avatarId: p.avatarId || null,
                    /* Avatar 100% ikut pemilih Workspace (No avatar / Male /
                       Female / avatar upload). Agent Saya TIDAK mengawal avatar —
                       "Avatar used on" di sana dikunci "Every scene" (placement),
                       bukan on/off. On/off = kerja Workspace. */
                    avatarImageUrl: templateBgUrl || p.avatarImageUrl || null,
                    /* ★ Gambar produk TAMBAHAN (2026-09-05). Payload ini menyenaraikan medan SATU
                       PERSATU — bukan spread — jadi medan baharu yang tidak disebut di sini TIDAK
                       akan sampai ke skrip Flow, dan kegagalannya SENYAP (video dijana tanpa
                       gambar tambahan, tiada ralat). Jambatan content.ts menyalin `products`
                       bulat-bulat, jadi inilah satu-satunya tempat yang perlu disentuh.
                       ⛔ Skrip Flow BELUM memakainya — ia menunggu kerja skrip remote. */
                    extraImageUrls: gambarTambahan(p),
                    /* ★ Enjin RESIPI (17 Okt): borang tempahan module (cth { gambar: 'sama' }) — robot membacanya sebagai
                       product.resipi (flow-resipi/20-resipi.js). Medan disenarai SATU PERSATU di sini; tertinggal = robot
                       guna lalai senyap. Module lain = null (diabaikan). */
                    resipi: getModule(p.moduleId)?.resipi || null
                };
            });

            // ★ DUAL-PATH DELIVERY: Try direct message first, auto-fallback to Firestore queue
            let deliveredViaDirect = false;
            const ackPromise = new Promise((resolve) => {
                const ackHandler = (event) => {
                    if (event.data?.type === 'SESAAT_DIRECT_FLOW_ACK') {
                        console.log('[Flow] ✅ Extension ACK received — direct path working!');
                        window.removeEventListener('message', ackHandler);
                        resolve(true);
                    }
                };
                window.addEventListener('message', ackHandler);
                // Auto-timeout after 3 seconds
                setTimeout(() => {
                    window.removeEventListener('message', ackHandler);
                    resolve(false);
                }, 3000);
            });

            // ★ MODULE ROUTING: Resolve effective script key (registry-based, handles Smart Custom)
            // - ai16saat-half/full → 'ai16saat' (same script, different masterPrompt)
            // - goyang → 'goyang'
            // - ai8saat → 'ai8saat' (default)
            // - smartcustom + sceneCount=1 → 'ai8saat'
            // - smartcustom + sceneCount=2 → 'ai16saat'
            // Mixed-module guard ensures all products dalam batch share same effective script,
            // so first product's effective key = whole batch's script.
            const derivedSpaceType = getEffectiveScriptKey(productsToRun[0]);
            console.log(`[Flow] ★ Sending DIRECT FLOW message: ${sequentialTasks.length} tasks, spaceType=${derivedSpaceType}, postTiktok=${postTiktokAfterFlow}`);
            window.postMessage({
                type: 'SESAAT_DIRECT_FLOW',
                spaceType: derivedSpaceType,
                tasks: sequentialTasks,
                products: productDataForExtension,
                settings: {
                    isImageOnly,
                    flowProjectMode,
                    flowProjectUrl: _sambungMode ? _sambungCollectionUrl : flowProjectUrl,
                    flowUltraMode,
                    flowVideoDuration: durasiLarian,
                    flowIngredientsMode: ingredientsLarian,
                    flowVideoResolution,
                    /* ⭐ 2026-09-16 — saiz fail video: 'asal' | 'naik'. Jambatan content.ts menyalin
                       `settings` BULAT-BULAT, jadi medan ini sampai ke skrip remote tanpa kerja extension. */
                    flowDownloadSize,
                    /* ⭐ 2026-09-15 — Workflow: 'kad' → skrip AI8SAAT jalan _jalankanWorkflowKad (tiada generate
                       gambar). Jambatan content.ts + background menyalin `settings` BULAT-BULAT (disahkan), jadi
                       medan ini sampai ke skrip remote tanpa kerja extension. */
                    flowWorkflow: workflowKad ? 'kad' : 'generate',
                    flowSceneOutput: hasilScene,   // ★ RESIPI: 'gabung' | 'asing' (Control Panel "Scene output") — settings disalin bulat-bulat ke skrip
                    flowRujukanProduk: rujukanProduk,   // ★ RESIPI gambar berlainan: scene mana guna gambar produk (Control Panel "Product photo")
                    flowSimpanGambar: simpanGambar,   // ★ RESIPI Images only: 'folder' | 'kad' (Control Panel "Save images")
                    flowBilOutput: bilOutput,   // ★ RESIPI Images only: '1'..'4' gambar setiap prompt (Control Panel "Images per prompt")
                    flowImageModel,
                    flownityScenes,
                    sambungMode: _sambungMode,          // ★ FASA 2
                    deliveredSets: _sambungDelivered    // ★ FASA 2
                },
                postTiktokAfterFlow,
                tiktokTargetSets: postTiktokAfterFlow ? [...automationTargetSets].sort() : [],
                uid: auth.currentUser.uid
            }, '*');

            // Wait for ACK from content script
            deliveredViaDirect = await ackPromise;

            if (!deliveredViaDirect) {
                // ★ Pre-flight passed but ACK didn't come — extension died between ping and dispatch.
                // Switch modal to disconnected state instead of silent Firestore fallback.
                console.warn('[Flow] ✗ No ACK after dispatch — content script likely died mid-flight. Showing refresh modal.');
                setAutomationProgress({
                    isActive: true, type: 'flow', steps: [], currentStep: 0, totalSteps: 0,
                    status: 'disconnected',
                    extensionStatus: 'disconnected',
                    message: 'Extension Terputus Sambungan',
                    details: 'Tab ini perlu di-refresh dulu sebelum boleh start Flow.'
                });
                setIsSaving(false);
                return;
            }
            // (Firestore fallback removed — user must refresh tab via modal button when extension dies)
            if (false) {
                try {
                    const queueRef = null;
                    await Promise.resolve();
                    console.log('[Flow] ✅ Firestore queue job written — background listener will pick it up');
                    deliveredViaDirect = true; // Mark as delivered via fallback
                } catch (queueErr) {
                    console.error('[Flow] âŒ Firestore queue fallback also failed:', queueErr);
                    throw new Error('Extension offline dan Firestore queue gagal. Sila refresh halaman dan cuba lagi.');
                }
            }

            setAutomationProgress(prev => ({ ...prev, steps: prev.steps.map((s, i) => i === stepIdx ? { ...s, status: 'done', label: T('ws.run.tasksSent', `${sequentialTasks.length} tugasan dihantar ✓`, { n: sequentialTasks.length }) } : s) }));
            stepIdx++;

            // Step 3: Done
            await new Promise(r => setTimeout(r, 300));
            setAutomationProgress(prev => ({
                ...prev, currentStep: stepIdx + 1, status: 'success',
                steps: prev.steps.map((s, i) => i === stepIdx ? { ...s, status: 'done' } : s),
                message: T('ws.run.started', `🚀 Automasi Bermula!`),
                /* ⚠️ `postTiktokAfterFlow` = laluan DORMAN (tiada UI menghidupkannya).
                   Ayatnya diterjemah semata-mata untuk kesempurnaan. */
                details: T('ws.run.startedDetail', `${productsToRun.length} produk telah dihantar ke Extension. Extension sedang membuka Google Flow...`, { n: productsToRun.length })
                    + (postTiktokAfterFlow ? T('ws.run.tiktokAfterFlow', '\n★ TikTok akan auto-run selepas Flow selesai.') : '')
            }));

            // ★ Auto-close popup after 5 seconds
            setTimeout(() => {
                setAutomationProgress(prev => ({ ...prev, isActive: false }));
            }, 5000);

        } catch (error) {
            console.error("Error starting flow:", error);
            setAutomationProgress(prev => ({
                ...prev, status: 'error',
                message: T('ws.run.failed', '❌ Automasi Gagal!'),
                details: error.message,
                steps: prev.steps.map((s, i) => i === prev.currentStep - 1 ? { ...s, status: 'error' } : s)
            }));

            // ★ Auto-close popup after 5 seconds
            setTimeout(() => {
                setAutomationProgress(prev => ({ ...prev, isActive: false }));
            }, 5000);
        } finally {
            setIsSaving(false);
        }
    };

    /* ============================================================
       ★ LANGKAH 3 — Run TikTok BACA KALENDAR (mod Schedule).
       Berasingan sepenuhnya daripada laluan kad-bertick di bawah supaya
       laluan sedia ada tidak tersentuh langsung. Ia menghantar SENARAI
       WAKTU TEPAT (`slots`) setiap video, bukan "masa mula + selang".
       ============================================================ */
    /* `kunciTerpilih` = Set kunci slot `${off}_${minit}` untuk dijalankan.
       null = jalankan slot yang DIPILIH (`schedPilih`) — laluan Run biasa dari
       butang Run di Control Panel. Diberi Set khusus untuk Retry (satu slot
       gagal / semua gagal). Model sama seperti Flow: pilih dulu, kemudian Run. */
    /* `pilihanGateMasuk` (2026-10-06) = pilihan pelanggan dalam popup gate beg kuning
       (utils/gateBegKuning.js). Hanya objek berpenanda `__gateBeg` dibaca; apa-apa lain = larian biasa. */
    const handleRunTikTokKalendar = async (kunciTerpilih = null, pilihanGateMasuk = null) => {
        const gate = bacaPilihanGate(pilihanGateMasuk);
        const kunciJalan = kunciTerpilih || schedPilih;
        if (!kunciJalan || !kunciJalan.size) {
            alert(T('ws.sched.run.noPilih', 'Sila pilih sekurang-kurangnya satu slot sebelum Run — tick kepala hari untuk pilih semua slot hari itu, atau klik slot satu-satu.'));
            return;
        }
        const isian = schedSusunanAktif?.isian || {};
        const petaProduk = new Map(products.map((p) => [p.id, p]));
        const sekarang = Date.now();
        const pad = (n) => String(n).padStart(2, '0');

        /* ★ v3.9.2 — PAGAR ANTI-DOUBLE-POST MERENTAS BROWSER. Kalendar dimuat
           SEKALI pada mount, jadi browser ini tidak nampak slot yang browser LAIN
           sudah jalankan selepas itu (kalendar akaun sama dibuka di dua browser =
           video sama di-post DUA KALI). Status slot dibaca segar dari server di
           sini; slot yang server tanda sudah berjalan/siap — tetapi paparan
           tempatan belum tahu — dilangkau dan statusnya digabung masuk supaya
           pengguna nampak sebabnya. Gagal baca → fail-open (perangai lama). */
        let isianServer = null;
        try {
            const svr = await muatSusunanAkaun(auth.currentUser?.uid, schedAkaunAktif);
            isianServer = svr?.isian || null;
        } catch { isianServer = null; }

        const rancangan = [];
        const langkauLain = [];
        /* ★ [2026-11-04] Photo post (Control Panel, utils/jenisPostTiktok.js) — dibekukan SEKALI untuk larian ini.
           Syarat slot = card ada gambar (bukan video set). */
        /* ⚠️ Suis hanya wujud dalam v4 mod New (`slotTabV4`) — di luar v4 sentiasa 'video' (KEMBAR pagar App.jsx). */
        const jenisPostLarian = slotTabV4 ? bacaJenisPostTiktok() : 'video';
        let tiadaProduk = 0, tiadaVideo = 0, tiadaGambar = 0, terlepas = 0, lepasHad = 0, salahMinit = 0, luarGroup = 0, jalanLain = 0, kunciRosak = 0;
        for (const k in isian) {
            const e = isian[k];
            if (!e) continue;
            const pisah = String(k).split('_');
            const minit = Number(pisah.pop());
            const off = pisah.join('_');
            /* Jalankan HANYA slot yang dipilih (atau kunci Retry yang diberi). */
            if (!kunciJalan.has(k)) continue;
            /* ⛔ Kunci mesti TARIKH SEBENAR. Slot yang kuncinya tidak difahami
               DILANGKAU dan DILAPOR — menekanya bermakna menghantar video ke
               TikTok pada tarikh yang pelanggan tidak pernah pilih. */
            if (!adalahTarikh(off)) { kunciRosak++; continue; }
            /* Slot ini sudah dijalankan oleh BROWSER LAIN? (Server kata sudah
               berjalan/siap/draf, tempatan tidak — perbezaan itu = maklumat baru
               dari browser lain. Kalau kedua-dua sama, ikut perangai sedia ada.) */
            if (isianServer) {
                const stSv = isianServer[k]?.st;
                if ((stSv === 'running' || stSv === 'complete' || stSv === 'draft') && stSv !== e.st) {
                    jalanLain++;
                    langkauLain.push({ k, st: stSv, sb: isianServer[k]?.sb || '' });
                    continue;
                }
            }
            const pid = e.pid || e.p?.id;
            const s = e.s;
            const prod = petaProduk.get(pid);
            if (!prod) { tiadaProduk++; continue; }
            /* Video wujud untuk set ini? (`local://` dikira ada.) — Photo post: card ada gambar? */
            if (jenisPostLarian === 'gambar') {
                if (!gambarKad(prod).length) { tiadaGambar++; continue; }
            } else if (!prod.prompts?.[s]?.uploadedVideo) { tiadaVideo++; continue; }
            /* Pagar per-slot — semak SETIAP slot, bukan mengagak dari yang pertama. */
            if (minit % LANGKAH_MINIT !== 0) { salahMinit++; continue; }
            /* Waktu hantar dibina daripada TARIKH SLOT itu sendiri, bukan
               "hari ini + offset". Itulah pembetulan teras 2026-09-16: dengan
               offset, halaman yang terbuka melepasi tengah malam menghantar
               setiap video satu hari LEWAT daripada yang pelanggan pilih. */
            const d = tarikhKeDate(off);
            d.setHours(Math.floor(minit / 60), minit % 60, 0, 0);
            const ms = d.getTime();
            /* ★ [2026-09-16] "Post sekarang" mengabaikan waktu slot — pagar masa
               hanya untuk jadual/draf. */
            if (caraPost !== 'now') {
                if (bezaHariIni(off) > HAD_HARI_TIKTOK) { lepasHad++; continue; }
                /* Waktu sudah kurang 15 minit dari SEKARANG → terlepas masa, langkau
                   (jangan biar TikTok yang tolak). */
                if (ms - sekarang < 15 * 60 * 1000) { terlepas++; continue; }
            }
            const grup = prod.workspaceGroup || 'Workspace';
            if (selectedGroupId !== 'all' && grup !== selectedGroupId) luarGroup++; // lapor sahaja — TETAP jalan
            const at = `${off}T${pad(Math.floor(minit / 60))}:${pad(minit % 60)}`;
            const slotId = `${schedAkaunAktif}_${off}_${minit}`;
            rancangan.push({ pid, s, at, slotId, ms, k });
        }
        rancangan.sort((a, b) => a.ms - b.ms); // MENAIK — robot mesti sampai sebelum waktu slot berlalu

        /* ★ v3.9.2 — status server untuk slot yang dilangkau digabung ke paparan,
           supaya slot itu terus menunjukkan "sudah dijalankan" dan bukannya
           kelihatan seperti dilangkau tanpa sebab. */
        if (langkauLain.length) {
            setSchedSusunan((prev) => {
                const su = prev[schedAkaunAktif] || { hariTemplate: {}, isian: {} };
                const isianBaru = { ...(su.isian || {}) };
                langkauLain.forEach(({ k, st, sb }) => {
                    if (isianBaru[k]) isianBaru[k] = { ...isianBaru[k], st, sb };
                });
                return { ...prev, [schedAkaunAktif]: { ...su, isian: isianBaru } };
            });
        }

        if (!rancangan.length) {
            const sebab = [];
            if (jalanLain) sebab.push(T('ws.sched.run.rLain', `${jalanLain} slot dilangkau — sudah dijalankan oleh browser lain`, { n: jalanLain }));
            if (tiadaVideo) sebab.push(T('ws.sched.run.rVideo', `${tiadaVideo} slot belum ada video (jalankan Flow dahulu)`, { n: tiadaVideo }));
            if (tiadaGambar) sebab.push(T('ws.sched.run.rGambar', `${tiadaGambar} slot card-nya tiada gambar (Photo post)`, { n: tiadaGambar }));
            if (terlepas) sebab.push(T('ws.sched.run.rMasa', `${terlepas} slot waktunya sudah terlalu hampir (kurang 15 minit)`, { n: terlepas }));
            if (lepasHad) sebab.push(T('ws.sched.run.rHad', `${lepasHad} slot melepasi had ${HAD_HARI_TIKTOK} hari`, { n: lepasHad, had: HAD_HARI_TIKTOK }));
            if (tiadaProduk) sebab.push(T('ws.sched.run.rProduk', `${tiadaProduk} slot produknya sudah tiada`, { n: tiadaProduk }));
            if (kunciRosak) sebab.push(T('ws.sched.run.rKunci', `${kunciRosak} slot tarikhnya tidak difahami — buka semula tab Schedule, kemudian seret video itu sekali lagi`, { n: kunciRosak }));
            alert(T('ws.sched.run.noRunnable', 'Tiada slot yang boleh dijalankan pada tarikh yang ditick.') + (sebab.length ? '\n\n' + sebab.join('\n') : ''));
            return;
        }
        /* ★ [2026-09-16] Cara post WAJIB dipilih (pemilih Control Panel; Showcase
           Only dikecualikan — tiada video dipost), dan "Post sekarang" = SATU
           video sahaja (keputusan user 12 Sept: lebih selamat buat masa ini). */
        /* ★ [2026-09-18] Beg kuning MATI → video sahaja: link produk tidak dihantar,
           Showcase dilangkau, Showcase Only yang tersorok TIDAK berkesan. Satu
           takrifan dengan laluan tick kad — utils/pautanProduk.js. */
        /* ★ [2026-10-06] `tanpaBeg` = pelanggan memilih "Post tanpa beg kuning" dalam popup gate
           (semua kad larian ini tiada produk TikTok) — untuk larian INI sahaja; toggle tersimpan tidak disentuh. */
        const begKuning = gate?.tanpaBeg ? false : begKuningRef.current;
        const modTt = modTiktokBerkesan({ begKuning, isPostOnly, isShowcaseOnly });
        if (!caraPost && !modTt.isShowcaseOnly) { alert(T('ws.cara.pilihDulu', 'Pilih cara post dahulu (Post sekarang · Jadual · Simpan draf) di Control Panel.')); return; }
        if (caraPost === 'now' && rancangan.length !== 1) {
            alert(T('ws.sched.run.nowSatu', `Post sekarang hanya untuk SATU video. Anda tick ${rancangan.length} slot — kekalkan satu sahaja, atau pilih Jadual / Simpan draf.`, { n: rancangan.length }));
            return;
        }
        /* ★ [2026-10-06] GATE BEG KUNING (keputusan user) — beg kuning HIDUP + ada kad tanpa link produk
           TikTok (cth produk Shopee) → TAHAN larian dan tanya dahulu. Tanpa gate ini robot menyimpan
           SEMUA video kad itu sebagai draf ("kad ini tiada link produk TikTok") dan pelanggan hanya
           tahu selepas larian tamat. Diletak SEBELUM apa-apa dihantar / dicop 'running'.
           Langkau = jalankan semula dengan kunci slot kad lain sahaja; Tanpa beg = larian yang sama,
           beg kuning mati untuk larian ini. Kedua-duanya membawa penanda gate → gate tidak muncul dua kali. */
        if (begKuning && !gate) {
            const semakan = semakGateBegKuning(rancangan.map((r) => petaProduk.get(r.pid)));
            if (semakan.perlu) {
                /* State gate menyimpan DATA sahaja; larian semula dipanggil melalui ref (fungsi TERKINI),
                   bukan closure render ini — elak `products` / kalendar basi bila popup lama terbuka. */
                setGateBeg({
                    laluan: 'kalendar',
                    senarai: semakan.tiada, bilLain: semakan.bilLain, semuaTiada: semakan.semuaTiada,
                    idTiada: [...semakan.idTiada],
                    kunciLain: rancangan.filter((r) => !semakan.idTiada.has(r.pid)).map((r) => r.k),
                    kunciSemua: rancangan.map((r) => r.k),
                });
                return;
            }
        }

        setIsSaving(true);
        const ping = await pingExtension();
        if (!ping.alive) {
            setAutomationProgress({
                isActive: true, type: 'tiktok', steps: [], currentStep: 0, totalSteps: 0,
                status: 'disconnected', extensionStatus: 'disconnected',
                message: T('ws.run.extDisconnected', 'Extension Terputus Sambungan'),
                details: T('ws.run.extDisconnectedTiktok', 'Tab ini perlu di-refresh dulu sebelum boleh start TikTok.'),
            });
            setIsSaving(false);
            return;
        }
        const _vGate = await checkExtensionVersionGate(ping.version);
        if (_vGate) { setVersionGateModal(_vGate); setIsSaving(false); return; }

        const effectiveShowcase = modTt.isShowcaseMode;
        const effectiveShowcaseOnly = modTt.isShowcaseOnly;

        /* Amaran ringkas untuk slot yang dilangkau / slot dari group lain —
           dipapar SELEPAS pengesahan tetapi sebelum robot mula. */
        const dilangkau = tiadaVideo + tiadaGambar + terlepas + lepasHad + tiadaProduk + salahMinit;
        if (dilangkau > 0) toast.warning(T('ws.sched.run.skipped', `${dilangkau} slot dilangkau (video belum siap / waktu terlepas). ${rancangan.length} akan dijalankan.`, { n: dilangkau, jalan: rancangan.length }));
        if (luarGroup > 0) toast.info(T('ws.sched.run.otherGroup', `${luarGroup} daripada slot ini milik produk group lain — ia tetap akan dijalankan.`, { n: luarGroup }));

        setAutomationProgress({
            isActive: true, type: 'tiktok', steps: [
                { label: T('ws.tiktok.step.prepare', 'Menyediakan produk untuk TikTok...'), status: 'pending' },
                { label: T('ws.run.step.send', 'Menghantar arahan ke Extension...'), status: 'pending' },
                { label: T('ws.run.step.done', 'Selesai!'), status: 'pending' },
            ], currentStep: 0, totalSteps: 3, status: 'running', extensionStatus: 'connected',
            message: T('ws.sched.run.title', `Jadual TikTok — ${rancangan.length} video`, { n: rancangan.length }),
            details: T('ws.sched.run.detail', `${rancangan.length} video pada waktu tepat setiap slot.`, { n: rancangan.length }),
        });

        try {
            let stepIdx = 0;
            setAutomationProgress((prev) => ({ ...prev, currentStep: stepIdx + 1, steps: prev.steps.map((s, i) => (i === stepIdx ? { ...s, status: 'running' } : s)) }));

            /* Cop 'running' pada setiap produk×set yang terlibat. */
            const setIkutProduk = {};
            rancangan.forEach((r) => { (setIkutProduk[r.pid] = setIkutProduk[r.pid] || new Set()).add(r.s); });
            const runIds = new Set(Object.keys(setIkutProduk));
            const namaAkaunLarian = (schedAkaun.find((a) => a.id === schedAkaunAktif)?.nama) || '';
            const updatedProducts = products.map((p) => {
                if (!runIds.has(p.id)) return p;
                const newSetStatuses = { ...(p.setStatuses || {}) };
                /* Rekod per-akaun bermula DI SINI, bukan bila robot selesai.
                   Hanya webapp tahu akaun mana slot itu milik; robot langsung
                   tidak menerima maklumat akaun. Kalau ia ditulis hanya pada
                   penghujung, larian yang gagal separuh jalan tidak akan
                   meninggalkan sebarang kesan pada kad. */
                let petaAkaun = p.setStatusAkaun || {};
                setIkutProduk[p.id].forEach((s) => {
                    newSetStatuses[`tiktok_${s}`] = 'running';
                    /* ★ [2026-09-29] `md` dicop pada KAD juga (bukan slot sahaja) —
                       tanpanya pil kad Post now kekal "Scheduled". Graduasi tidak
                       menyentuh `md`, jadi cop ini kekal bila robot selesai. */
                    /* ★ [2026-11-03] pf = platform larian terakhir pada pil (override) —
                       WAJIB dicop, rekodLarianKad.js menerangkan sebabnya. */
                    petaAkaun = gabungStatusAkaun(petaAkaun, s, schedAkaunAktif, {
                        st: 'running', sb: '', md: caraPost === 'now' ? 'now' : '', pf: 'tt', nama: namaAkaunLarian, masa: Date.now(),
                    });
                });
                return {
                    ...p, setStatuses: newSetStatuses, setStatusAkaun: petaAkaun,
                    extensionSettings: { isImageOnly, isShowcaseMode: effectiveShowcase, isPostOnly, isShowcaseOnly: effectiveShowcaseOnly, begKuning },
                };
            });
            setProducts(updatedProducts);
            await saveProducts(auth.currentUser.uid, updatedProducts.filter((p) => runIds.has(p.id)));

            /* ★ LANGKAH 5 — tanda 'running' pada SLOT sendiri (bukan hanya pada
               produk). Inilah yang membuat status kekal per-slot: slot ini akan
               "naik taraf" kepada complete/draft/failed apabila robot selesai
               (lihat effect graduasi), dan slot LAIN yang guna produk sama tidak
               tersentuh. */
            const kunciRun = new Set(rancangan.map((r) => r.k));
            setSchedSusunan((prev) => {
                const su = prev[schedAkaunAktif] || { hariTemplate: {}, isian: {} };
                const isianBaru = { ...(su.isian || {}) };
                /* `pf` = platform larian ini (tt/fb) — dibaca effect graduasi supaya
                   hasil robot yang BETUL yang naik ke slot (kunci kad tiktok_/fb_). */
                /* ★ [2026-09-27] `md` = cara post larian ini ('now' sahaja disimpan). Kad robot hanya
                   tahu "complete" — tanpa md, Post now dilabel "Scheduled" (aduan user). */
                kunciRun.forEach((k) => { if (isianBaru[k]) isianBaru[k] = { ...isianBaru[k], st: 'running', sb: '', pf: 'tt', md: caraPost === 'now' ? 'now' : '' }; });
                return { ...prev, [schedAkaunAktif]: { ...su, isian: isianBaru } };
            });

            /* Pastikan susunan kalendar terkini sudah di server sebelum Run. */
            if (schedServerOkRef.current && auth.currentUser?.uid) {
                flushSimpanan(auth.currentUser.uid, schedAkaunAktif, schedSusunan[schedAkaunAktif], schedRefDisimpan);
            }

            setAutomationProgress((prev) => ({ ...prev, steps: prev.steps.map((s, i) => (i === stepIdx ? { ...s, status: 'done' } : s)) }));
            stepIdx++;
            setAutomationProgress((prev) => ({ ...prev, currentStep: stepIdx + 1, steps: prev.steps.map((s, i) => (i === stepIdx ? { ...s, status: 'running' } : s)) }));

            const productDataForExtension = [...runIds].map((id) => {
                const p = petaProduk.get(id);
                /* ★ [2026-09-18] Link kosong bila beg kuning MATI → robot langkau Showcase + beg. */
                /* ★ [2026-11-04] extraImageUrls = gambar tambahan untuk Photo post. Dahulu hanya gambar utama dihantar
                   dan background bergantung pada bacaan database sendiri — bacaan itu gagal senyap → post 1 gambar
                   (ujian user 4 Nov: card 4 gambar → 1). Medan dalam `products` dihantar bulat-bulat oleh content.ts. */
                return { id: p.id, name: p.name, link: linkTiktokUntukRobot(p, begKuning), prompts: p.prompts, imageBase64: p.imageBase64 || null, imageUrl: p.imageUrl || p.localImagePath || null, extraImageUrls: Array.isArray(p.extraImageUrls) ? p.extraImageUrls : [] };
            });
            const slots = rancangan.map((r) => ({ productId: r.pid, setKey: r.s, at: r.at, slotId: r.slotId }));

            window.postMessage({
                type: 'SESAAT_DIRECT_TIKTOK',
                /* ★ [v3.9.3] KOTAK TERBUKA. Tetapan larian BAHARU masuk DI SINI,
                   bukan sebagai medan baharu di sebelahnya — medan tetap perlu
                   disentuh di 4 tempat + release extension, dan yang tercicir
                   gagal SENYAP. ⛔ WAJIB ada pada KEDUA-DUA laluan Run TikTok
                   (kalendar + lama); terlepas satu = CTA hilang senyap di situ. */
                /* ★ [2026-09-16] `mode` = cara post: 'now' (tekan Post) · 'schedule' ·
                   'draft'. Skrip TikTok (remote) membacanya; extension lama
                   mengabaikannya dan ikut `directSchedule` di bawah seperti biasa. */
                /* ★ [2026-09-18] `begKuning` = niat pelanggan (toggle Control Panel). Robot
                   lama tidak membacanya — link kosong di atas yang melangkau beg. */
                tetapan: { ctaText: ctaTeksLarian || '', aiLabel: aiLabelAktif !== false, mode: caraPost || (directSchedule ? 'schedule' : 'draft'), begKuning, semakMuzik: tetapanSemakanTiktok().semakMuzik, semakKandungan: tetapanSemakanTiktok().semakKandungan, jenisPost: jenisPostLarian },   /* ★ [2026-11-04] jenisPost — utils/jenisPostTiktok.js */   /* ★ [2026-10-13] semakMuzik + semakKandungan (dua medan sahaja — lihat utils/semakanTiktok.js) */   // ★ v3.9.4 — suis AI label Control Panel
                products: productDataForExtension,
                slots,
                /* Sandaran untuk extension LAMA yang belum faham `slots` — masa
                   mula = slot pertama, selang 30 minit. Extension baru abaikan
                   ini dan guna `slots`. Gate versi patut halang extension lama. */
                schedule: { startTime: slots[0].at, interval: 30 },
                uid: auth.currentUser.uid,
                /* ⭐ Direct Schedule = PILIHAN pengguna (arahan user 2026-08-20):
                   HIDUP → robot tekan Schedule (terus terbit ikut waktu slot).
                   MATI → robot simpan sebagai DRAF — pengguna edit dahulu (letak
                   music, dsb) dan terbit sendiri. Kalendar tetap menetapkan
                   WAKTU; Direct Schedule cuma tentukan sama ada robot terus
                   terbit atau berhenti di draf. */
                directSchedule: caraPost ? caraPost === 'schedule' : !!directSchedule,
                /* ★ v3.9.2 — mod larian DIBEKUKAN pada saat Run ditekan di browser INI.
                   Tanpa ini, extension membaca mod dari salinan Firestore yang DIKONGSI
                   semua browser — klik di browser lain boleh menukar kelakuan larian ini.
                   Medan ini mesti turut disalin dalam jambatan content.ts (penapis
                   eksplisit) — lihat peraturan EMPAT tempat dalam CLAUDE.md. */
                modes: { isShowcaseMode: effectiveShowcase, isPostOnly: modTt.isPostOnly, isShowcaseOnly: effectiveShowcaseOnly },
            }, '*');

            await new Promise((r) => setTimeout(r, 1000));
            setAutomationProgress((prev) => ({ ...prev, steps: prev.steps.map((s, i) => (i === stepIdx ? { ...s, status: 'done' } : s)) }));
            stepIdx++;

            await new Promise((r) => setTimeout(r, 300));
            setAutomationProgress((prev) => ({
                ...prev, currentStep: stepIdx + 1, status: 'success',
                steps: prev.steps.map((s, i) => (i === stepIdx ? { ...s, status: 'done' } : s)),
                message: T('ws.tiktok.started', '🎉 TikTok Automation Dimulakan!'),
                details: T('ws.sched.run.startedDetail', `${rancangan.length} video dihantar ke Extension — akan dijadualkan pada waktu tepat setiap slot.`, { n: rancangan.length })
                    /* ★ v3.9.2: beritahu juga bila sebahagian slot dilangkau kerana
                       browser lain sudah menjalankannya — tanpa ini pelanggan hanya
                       nampak kiraan yang "kurang" tanpa sebab. */
                    + (jalanLain ? '\n' + T('ws.sched.run.rLain', `${jalanLain} slot dilangkau — sudah dijalankan oleh browser lain`, { n: jalanLain }) : ''),
            }));
            setTimeout(() => setAutomationProgress((prev) => ({ ...prev, isActive: false })), 5000);
        } catch (error) {
            console.error('Error starting TikTok (kalendar):', error);
            setAutomationProgress((prev) => ({
                ...prev, status: 'error',
                message: T('ws.tiktok.failed', '❌ TikTok Automation Gagal!'),
                details: error.message,
                steps: prev.steps.map((s, i) => (i === prev.currentStep - 1 ? { ...s, status: 'error' } : s)),
            }));
            setTimeout(() => setAutomationProgress((prev) => ({ ...prev, isActive: false })), 5000);
        } finally {
            setIsSaving(false);
        }
    };

    /* ---------- Langkah 4: Retry slot gagal ---------------------------
       Slot GAGAL pada akaun aktif (untuk jalur "N gagal" + Retry all).
       ⛔ 'uncertain' (kuning) TIDAK dikira gagal — ia mungkin sudah tersiar,
          dan retry-nya bermakna draf berganda (tak boleh tarik balik). */
    const schedSlotGagal = useMemo(() => {
        const isian = schedSusunanAktif?.isian || {};
        const keluar = [];
        for (const k in isian) {
            if (isian[k]?.st === 'failed') keluar.push(k);
        }
        return keluar;
    }, [schedSusunanAktif]);

    /* SATU tempat yang menulis rekod status per-akaun pada kad. Tiga pemanggil
       (graduasi robot, tukar status dalam slot kalendar, tukar status pada kad)
       - kalau setiap satu menulis sendiri, ketiga-tiganya pasti terpesong.

       ⚠️ Menulis hanya kad yang BERUBAH, dan hanya bila nilainya betul-betul
          berbeza. Effect graduasi berjalan setiap kali feed produk berdenyut,
          jadi tanpa semakan ini ia akan menulis semula perkara yang sama
          berulang kali dan mencetuskan denyut seterusnya. */
    const tulisStatusAkaunKad = useCallback((senarai) => {
        if (!senarai || !senarai.length || !auth.currentUser) return;
        const ikutProduk = new Map();
        senarai.forEach((r) => {
            const a = ikutProduk.get(r.pid) || [];
            a.push(r);
            ikutProduk.set(r.pid, a);
        });
        const berubah = [];
        const semua = productsRef.current.map((p) => {
            const kerja = ikutProduk.get(p.id);
            if (!kerja) return p;
            let peta = p.setStatusAkaun || {};
            let ss = p.setStatuses || {};
            let ubah = false;
            kerja.forEach((r) => {
                /* ★ [2026-11-03] Catatan tersembunyi Shopee `setStatuses.sp_setN` (pintu elak post
                   berganda — sudahMasukShopee, utils/androidPostCheck.js). Ditulis DI SINI, dalam
                   tulisan card yang sama: dua tulisan berasingan pada card yang sama saling
                   menindih (productsRef hanya dikemas kini selepas render).
                   `r.sp` = nilai daripada robot telefon. Pelanggan KOSONGKAN status (st '') →
                   catatan turut dikosongkan supaya Shopee boleh dijalankan semula; tidak bila
                   ia sedang 'running' (guna Stop). */
                const kSp = `sp_${r.s}`;
                const spBaru = typeof r.sp === 'string' ? r.sp
                    : (r.st === '' && ss[kSp] && ss[kSp] !== 'running') ? '' : undefined;
                if (spBaru !== undefined && (ss[kSp] || '') !== spBaru) {
                    ss = { ...ss, [kSp]: spBaru };
                    ubah = true;
                }
                if (!r.akaunId) return;   // tiada akaun kalendar: catatan Shopee sahaja
                const kA = kunciAkaun(r.akaunId);
                const lama = peta?.[`tiktok_${r.s}`]?.[kA] || null;
                /* ★ [2026-09-29] `md` (Posted) hanya ditulis bila pemanggil
                   menghantarnya (tukar manual). Graduasi robot tidak menghantar
                   `md`, jadi cop Post now semasa Run kekal. ⛔ Jangan letak
                   `md: undefined` — Firestore menolak nilai undefined.
                   ★ [2026-11-03] `pf` (platform larian terakhir) sama — utils/rekodLarianKad.js. */
                const adaMd = typeof r.md === 'string';
                const adaPf = typeof r.pf === 'string';
                if (lama && lama.st === r.st && (lama.sb || '') === (r.sb || '')
                    && (!adaMd || (lama.md || '') === r.md)
                    && (!adaPf || (lama.pf || '') === r.pf)) return;
                const data = {
                    st: r.st, sb: r.sb || '',
                    nama: lama?.nama || r.nama || '',
                    masa: lama?.masa || Date.now(),
                };
                if (adaMd) data.md = r.md;
                if (adaPf) data.pf = r.pf;
                peta = gabungStatusAkaun(peta, r.s, r.akaunId, data);
                ubah = true;
            });
            if (!ubah) return p;
            const baru = { ...p, setStatusAkaun: peta, setStatuses: ss };
            berubah.push(baru);
            return baru;
        });
        if (!berubah.length) return;
        setProducts(semua);
        saveProducts(auth.currentUser.uid, berubah).catch(() => { });
    }, []);

    /* ★ [2026-09-16] SYNC KAD → KALENDAR (arahan user: "pastikan ia sync dengan
       status card di belah kiri juga. begitu juga jika user clear status di bar
       di card kiri, akan sync perubahan juga di status di kalendar").

       Arah SEBALIKNYA (kalendar → kad) memang sudah wujud sejak dahulu:
       `schedSetStatusSlot` + effect graduasi kedua-duanya memanggil
       `tulisStatusAkaunKad`. Yang tiada hanyalah arah ini — sebelum 16 Sept
       ia SENGAJA tidak disentuh (keputusan 24 Ogos, lihat tooltip lama
       "kalendar tidak disentuh"); keputusan itu kini ditarik balik.

       ⭐ Pemetaan tidak ada kekaburan: satu produk+set hanya boleh duduk dalam
          SATU slot bagi setiap akaun kalendar — menyeret set yang sama ke slot
          lain MEMINDAHKANNYA (lihat `letakSet` dalam JadualTiktokV39), bukan
          menyalin. Jadi satu pil status pada kad = satu slot, tepat.

       Akaun BUKAN aktif turut ditulis di sini kerana pil pada kad memang
       memapar satu baris bagi SETIAP akaun — pengguna menekan baris yang dia
       nampak, jadi slot akaun itulah yang patut berubah. Corak tulisan server
       per-akaun SAMA seperti `prunProdukDariJadual` (effect tulisan biasa hanya
       menjaga akaun aktif). */
    const cerminStatusKeSlot = useCallback((senarai) => {
        if (!senarai || !senarai.length) return;
        const prev = schedSusunanRef.current || {};
        const next = {};
        const terkesan = [];
        for (const akaunId in prev) {
            const akaun = prev[akaunId] || {};
            const isian = akaun.isian || {};
            const kA = kunciAkaun(akaunId);
            let isianBaru = null;
            for (const k in isian) {
                const e = isian[k];
                if (!e) continue;
                const pid = e.pid || e.p?.id;
                const r = senarai.find((x) => x.pid === pid && x.s === e.s && kunciAkaun(x.akaunId) === kA);
                if (!r) continue;
                const st = r.st || '';
                const sb = r.sb || '';
                /* ★ [2026-09-29] Posted — `md` ikut sama bila dihantar. */
                const adaMd = typeof r.md === 'string';
                if ((e.st || '') === st && (e.sb || '') === sb && (!adaMd || (e.md || '') === r.md)) continue;
                if (!isianBaru) isianBaru = { ...isian };
                isianBaru[k] = adaMd ? { ...e, st, sb, md: r.md } : { ...e, st, sb };
            }
            next[akaunId] = isianBaru ? { ...akaun, isian: isianBaru } : akaun;
            if (isianBaru) terkesan.push(akaunId);
        }
        if (!terkesan.length) return;
        setSchedSusunan(next);
        if (schedServerOkRef.current && auth.currentUser?.uid) {
            const uid = auth.currentUser.uid;
            terkesan.forEach((akaunId) => simpanSusunanAkaun(uid, akaunId, next[akaunId], schedRefDisimpan));
        }
    }, []);

    /* SATU pintu untuk setiap perubahan status yang bermula DARI KAD (pil
       status bawah setiap kotak set). Kad dahulu, kemudian slot — kalau tidak
       dua tempat itu boleh terpesong dan pengguna nampak dua jawapan berbeza
       untuk perkara yang sama. */
    const tukarStatusDariKad = useCallback((pid, setKey, idAkaun, pilihan) => {
        const { st, md } = pecahPilihanStatus(pilihan);   // 'posted' → complete + md 'now'
        const rekod = [{ pid, s: setKey, akaunId: idAkaun, st, sb: '', md }];
        tulisStatusAkaunKad(rekod);
        cerminStatusKeSlot(rekod);
    }, [tulisStatusAkaunKad, cerminStatusKeSlot]);

    /* Kosongkan status SLOT (akaun aktif sahaja) bagi senarai produk+set yang
       diberi. Dipakai oleh butang pukal pada bar kad. Ia TIDAK memerlukan rekod
       pada kad — slot yang statusnya tertinggal daripada zaman sebelum sync ini
       pun turut dibersihkan. Pulang senarai `pid__set` yang betul-betul berubah.
       ⛔ Slot 'running' dilangkau: ia sedang dihantar dan keputusannya akan
          ditulis sebentar lagi — guna Stop untuk menghentikannya. */
    const kosongkanSlotKadAktif = useCallback((pasangan) => {
        if (!pasangan || !pasangan.length || !schedAkaunAktif) return [];
        const su = schedSusunanRef.current?.[schedAkaunAktif];
        const isian = su?.isian;
        if (!isian) return [];
        const mahu = new Set(pasangan.map((x) => `${x.pid}__${x.s}`));
        const kunci = [];
        const berubah = [];
        for (const k in isian) {
            const e = isian[k];
            if (!e || !e.st || e.st === 'running') continue;
            const tanda = `${e.pid || e.p?.id}__${e.s}`;
            if (!mahu.has(tanda)) continue;
            kunci.push(k);
            berubah.push(tanda);
        }
        if (!kunci.length) return [];
        setSchedSusunan((prev) => {
            const s0 = prev[schedAkaunAktif];
            if (!s0?.isian) return prev;
            const baru = { ...s0.isian };
            kunci.forEach((k) => { if (baru[k]) baru[k] = { ...baru[k], st: '', sb: '' }; });
            return { ...prev, [schedAkaunAktif]: { ...s0, isian: baru } };
        });
        return berubah;
    }, [schedAkaunAktif]);

    /* Butang "Kosongkan status" dalam BAR KALENDAR (arahan user 2026-09-16:
       "pastikan ada features clear status kat bar dlm kalendar"). Aliran yang
       user mahu: Run TikTok → siap → kosongkan status → Run Facebook pada slot
       yang SAMA. Video kekal pada waktunya; hanya tanda status dibuang. */
    const schedKosongStatusSlot = useCallback((kunci) => {
        if (!kunci || !kunci.length || !schedAkaunAktif) return;
        const isian = schedSusunanRef.current?.[schedAkaunAktif]?.isian || {};
        const boleh = [];
        /* ★ [2026-09-18] Slot yang SUDAH tiada status, tetapi pil kad akaun ini
           masih bertanda (rekod tertinggal) — pil itu turut dikosongkan supaya
           kad dan kalendar tidak memberi dua jawapan berbeza untuk video yang
           sama (arahan user: kalendar kosongkan → senarai kiri ikut). */
        const kadSahaja = [];
        let berjalan = 0;
        kunci.forEach((k) => {
            const e = isian[k];
            if (!e) return;
            if (e.st === 'running') { berjalan++; return; }
            if (e.st) { boleh.push(k); return; }
            const pid = e.pid || e.p?.id;
            const r = statusAkaunDibuka(productsRef.current.find((p) => p.id === pid), e.s, schedAkaunAktif);
            if (!r) return;
            if (r.st === 'running') { berjalan++; return; }
            kadSahaja.push({ pid, s: e.s });
        });
        const bil = boleh.length + kadSahaja.length;
        if (!bil) {
            toast.info(berjalan
                ? T('ws.sched.kosong.running', 'Slot yang sedang dihantar tidak dikosongkan — guna Stop untuk menghentikannya.')
                : T('ws.sched.kosong.tiada', 'Tiada status untuk dikosongkan pada slot yang ditanda.'));
            return;
        }
        if (boleh.length) {
            setSchedSusunan((prev) => {
                const s0 = prev[schedAkaunAktif];
                if (!s0?.isian) return prev;
                const baru = { ...s0.isian };
                boleh.forEach((k) => { if (baru[k]) baru[k] = { ...baru[k], st: '', sb: '' }; });
                return { ...prev, [schedAkaunAktif]: { ...s0, isian: baru } };
            });
        }
        /* Cermin ke kad — pil status pada kad ialah paparan LAIN bagi benda yang
           sama, jadi ia mesti turut kosong. */
        tulisStatusAkaunKad([
            ...boleh.map((k) => ({
                pid: isian[k].pid || isian[k].p?.id, s: isian[k].s,
                akaunId: schedAkaunAktif, st: '', sb: '',
            })),
            ...kadSahaja.map((x) => ({ pid: x.pid, s: x.s, akaunId: schedAkaunAktif, st: '', sb: '' })),
        ]);
        toast.success((bil === 1
            ? T('ws.sched.kosong.okSatu', '1 status slot dikosongkan.')
            : T('ws.sched.kosong.ok', `${bil} status slot dikosongkan.`, { n: bil }))
            + (berjalan ? ' ' + T('ws.sched.kosong.running', 'Slot yang sedang dihantar tidak dikosongkan — guna Stop untuk menghentikannya.') : ''));
    }, [schedAkaunAktif, tulisStatusAkaunKad, T]);

    /* ★ [2026-09-23] BUTANG "STATUS" DALAM BAR KALENDAR — menggantikan butang
       "Kosongkan status" (arahan user: "buat macam di bar kad kiri").

       ⭐ TIADA soalan set di sini, dan itu disengajakan: satu slot MEMANG satu
          kad + satu set, dan satu tarikh boleh bercampur set 1/2/3 daripada kad
          berlainan (pemerhatian user 2026-09-23). Status dikenakan pada slot
          yang DITANDA sahaja.

       ⛔ Peraturan (running dilangkau · status baharu hanya untuk set yang ADA
          VIDEO · "sudah X") datang daripada `pelanStatusPasangan` — fungsi yang
          SAMA dengan bar pukal kad. Jangan salin peraturan itu ke sini; ubah di
          utils/statusAkaunKad.js sahaja.
       ⛔ Kosongkan ('') diserahkan kepada `schedKosongStatusSlot` yang sedia ada:
          ia turut membersihkan slot yang statusnya tertinggal TANPA rekod pada
          kad — pelan tidak nampak slot begitu kerana ia bermula daripada kad. */
    const schedTukarStatusSlot = useCallback((kunci, stBaru, labelStatus) => {
        const st = stBaru || '';
        if (st === '') { schedKosongStatusSlot(kunci); return; }
        if (!kunci || !kunci.length || !schedAkaunAktif) return;
        const isian = schedSusunanRef.current?.[schedAkaunAktif]?.isian || {};
        const pasangan = [];
        kunci.forEach((k) => {
            const e = isian[k];
            if (!e) return;
            const pid = e.pid || e.p?.id;
            pasangan.push({ kad: productsRef.current.find((p) => p.id === pid) || null, s: e.s });
        });
        const { tukar, sama, berjalan, tiadaVideo, tiadaKad } =
            pelanStatusPasangan(pasangan, schedAkaunAktif, st, namaAkaunDibuka);
        if (tukar.length) {
            tulisStatusAkaunKad(tukar);
            cerminStatusKeSlot(tukar);
        }
        /* Setiap slot yang DILANGKAU mesti ada sebabnya di skrin — bukan senyap. */
        const nota = [];
        if (berjalan) nota.push(T('ws.toast.statusBerjalan', 'Set yang sedang dihantar tidak diubah — guna Stop untuk menghentikannya.'));
        if (tiadaVideo) nota.push(T('ws.toast.statusSlotTiadaVideo', 'Slot yang setnya tiada video dilangkau — status hanya untuk set yang ada video.'));
        if (tiadaKad) nota.push(T('ws.toast.statusKadTiada', 'Slot yang kadnya tiada dalam senarai dilangkau.'));
        const ekor = nota.length ? ' ' + nota.join(' ') : '';
        if (!tukar.length) {
            if (sama) {
                toast.info(T('ws.toast.statusSudah', `Status itu memang sudah ${labelStatus} — tiada apa diubah.`, { status: labelStatus }) + ekor);
            } else if (nota.length) {
                toast.info(nota.join(' '));
            } else {
                toast.info(T('ws.sched.kosong.tiada', 'Tiada status untuk dikosongkan pada slot yang ditanda.'));
            }
            return;
        }
        toast.success((tukar.length === 1
            ? T('ws.toast.statusDitukarSatu', `1 status ditukar ke ${labelStatus}.`, { status: labelStatus })
            : T('ws.toast.statusDitukar', `${tukar.length} status ditukar ke ${labelStatus}.`, { n: tukar.length, status: labelStatus })) + ekor);
    }, [schedAkaunAktif, namaAkaunDibuka, schedKosongStatusSlot, tulisStatusAkaunKad, cerminStatusKeSlot, T]);

    /* ★ LANGKAH 5 — GRADUASI status: bila robot (extension) selesai, ia menulis
       hasil pada PRODUK (`setStatuses.tiktok_setN`). Effect ini menyalin hasil
       terminal itu ke SLOT yang sedang 'running', kemudian slot menyimpannya
       sendiri (kekal). Inilah jambatan antara laporan robot (per produk+set)
       dan paparan per-slot yang dikehendaki pengguna.

       ⛔ Ia menyentuh HANYA slot 'running' — status yang sudah siap (atau
          ditetapkan manual) tidak diganggu, jadi menjalankan produk sama di
          slot lain tidak menimpa slot yang sudah selesai. Ia mengimbas SEMUA
          akaun (bukan hanya yang aktif) supaya larian yang selesai selepas
          pengguna bertukar akaun tetap dikemas kini. */
    useEffect(() => {
        if (!uiV39) return;
        /* Pra-semak murah: kalau tiada slot 'running' langsung, jangan bina peta
           produk atau sentuh state — feed produk berdenyut kerap, jadi elak
           kerja O(produk) setiap denyut bila memang tiada apa untuk dinaik taraf.
           `schedSusunan` ada dalam deps supaya effect ini berjalan semula bila
           kalendar SIAP DIMUAT selepas feed produk (kes muat semula) — tanpa itu,
           slot 'running' tersimpan takkan naik taraf sehingga produk berubah. */
        let adaRunning = false;
        for (const a in schedSusunan) {
            const is = schedSusunan[a]?.isian || {};
            for (const k in is) { if (is[k]?.st === 'running') { adaRunning = true; break; } }
            if (adaRunning) break;
        }
        /* ★ [2026-11-03] Pil card larian TICK CARD (tiada slot) naik taraf bila robot siap —
           utils/rekodLarianKad.js. Digabung dengan naikKad di bawah dalam SATU tulisan. */
        const naikPil = naikTarafRekodKad(products);
        if (!adaRunning) {
            if (naikPil.length) tulisStatusAkaunKad(naikPil);
            return;
        }
        const petaProduk = new Map(products.map((p) => [p.id, p]));
        /* Kumpul naik taraf untuk KAD dahulu, dibaca daripada `schedSusunan`
           closure - BUKAN dari dalam updater setSchedSusunan di bawah.
           Updater React boleh dipanggil lebih daripada sekali, jadi kesan
           sampingan (tulisan Firestore) di dalamnya akan berganda. */
        const naikKad = [];
        for (const akaunId in schedSusunan) {
            const isianA = schedSusunan[akaunId]?.isian || {};
            for (const k in isianA) {
                const e = isianA[k];
                if (!e || e.st !== 'running') continue;
                const prod = petaProduk.get(e.pid || e.p?.id);
                const st = prod?.setStatuses?.[kunciStatusSlot(e)];
                if (st && st !== 'running') {
                    naikKad.push({ pid: prod.id, s: e.s, akaunId, st, sb: prod?.setStatusReason?.[kunciStatusSlot(e)] || '' });
                }
            }
        }
        if (naikKad.length || naikPil.length) tulisStatusAkaunKad([...naikKad, ...naikPil]);
        /* Bentuk UPDATER (prev → next): seretan kad yang berlaku pada saat yang
           sama tidak boleh ditimpa, dan `return prev` bila tiada perubahan
           membuat React langkau render + elak simpanan server + gelung tak
           terhingga (deps termasuk schedSusunan). */
        setSchedSusunan((prev) => {
            let berubah = false;
            const next = {};
            for (const akaunId in prev) {
                const su = prev[akaunId];
                const isian = su?.isian || {};
                let isianBaru = null;
                for (const k in isian) {
                    const e = isian[k];
                    if (!e || e.st !== 'running') continue;
                    const prod = petaProduk.get(e.pid || e.p?.id);
                    const st = prod?.setStatuses?.[kunciStatusSlot(e)];
                    if (st && st !== 'running') {
                        const sb = prod?.setStatusReason?.[kunciStatusSlot(e)] || '';
                        if (!isianBaru) isianBaru = { ...isian };
                        isianBaru[k] = { ...e, st, sb };
                        berubah = true;
                    }
                }
                next[akaunId] = isianBaru ? { ...su, isian: isianBaru } : su;
            }
            return berubah ? next : prev;
        });
    }, [products, schedSusunan, uiV39, tulisStatusAkaunKad]);

    /* Retry SEMUA slot gagal sekali gus (bulk-first). handleRunTikTokKalendar
       mengenakan pagar yang SAMA (video ada, 15 minit, gandaan 5, 30 hari) —
       slot yang waktunya sudah berlalu dilangkau dengan mesej. */
    const schedRetrySemuaGagal = useCallback((kunciDipapar) => {
        /* ★ [2026-09-18] Jalur gagal kini boleh ditutup (×) — kalendar menghantar
           senarai slot yang MASIH dipapar pada jalur, supaya kegagalan yang
           pengguna sudah tutup tidak diulang tanpa dia sedar. Tanpa senarai
           (cth pemanggil yang menghantar objek klik) = semua slot gagal. */
        const senarai = Array.isArray(kunciDipapar)
            ? schedSlotGagal.filter((k) => kunciDipapar.includes(k))
            : schedSlotGagal;
        if (!senarai.length) return;
        /* ★ [2026-09-16] Slot Facebook (pf:'fb') diulang oleh robot Facebook, slot
           TikTok oleh robot TikTok — dua larian berasingan bila kedua-dua ada
           (extension menyusun giliran, bukan menolak). */
        const isian = schedSusunanAktif?.isian || {};
        const fb = senarai.filter((k) => isian[k]?.pf === 'fb');
        const sp = senarai.filter((k) => isian[k]?.pf === 'sp');
        const tt = senarai.filter((k) => isian[k]?.pf !== 'fb' && isian[k]?.pf !== 'sp');
        if (tt.length) handleRunTikTokKalendar(new Set(tt));
        if (fb.length) handleRunFacebookKalendar(new Set(fb));
        if (sp.length) handleRunPhone(new Set(sp));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [schedSlotGagal, schedSusunanAktif]);

    /* Retry SATU slot (butang pada slot gagal). `off`/`minit` = offset+minit
       daripada Slot. Halang retry berganda: kalau statusnya sudah 'running'
       (sedang dihantar), abaikan. */
    const schedRetrySlot = useCallback((off, minit) => {
        const isian = schedSusunanAktif?.isian || {};
        const e = isian[`${off}_${minit}`];
        if (!e) return;
        if (e.st === 'running') return; // sedang jalan — jangan hantar dua kali
        (e.pf === 'fb' ? handleRunFacebookKalendar : e.pf === 'sp' ? handleRunPhone : handleRunTikTokKalendar)(new Set([`${off}_${minit}`]));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [schedSusunanAktif]);

    /* ---------- Stop / bersih larian tersangkut ----------------------
       Slot 'running' ("Sending…") pada akaun aktif. Ia boleh tersangkut kalau
       larian terganggu (cth extension dimuat semula di tengah jalan) — extension
       yang sepatutnya menulis 'complete/failed' sudah mati, jadi 'running' kekal
       selamanya. */
    const schedSlotRunning = useMemo(() => {
        const isian = schedSusunanAktif?.isian || {};
        let bil = 0;
        for (const k in isian) {
            if (isian[k]?.st === 'running') bil++;
        }
        return bil;
    }, [schedSusunanAktif]);

    /* Hentikan larian + bersihkan penanda 'running' pada akaun aktif. Dua kesan:
       (1) isyarat STOP ke extension (kalau ada larian betul-betul jalan), dan
       (2) reset status 'running' → kosong supaya slot yang tersangkut kembali
           normal (bukan biru "Sending…" selamanya). */
    const schedStopLarian = useCallback(() => {
        window.postMessage({ type: 'SESAAT_STOP_TIKTOK' }, '*');
        const isian = schedSusunanRef.current?.[schedAkaunAktif]?.isian
            || schedSusunanAktif?.isian || {};
        /* Slot 'running' pada akaun aktif → dikosongkan. Status dibaca daripada
           SLOT (bukan produk). */
        const kunciRunning = [];
        const perProduk = {};
        for (const k in isian) {
            const e = isian[k];
            if (!e || e.st !== 'running') continue;
            kunciRunning.push(k);
            (perProduk[e.pid || e.p?.id] = perProduk[e.pid || e.p?.id] || new Set()).add(e.s);
        }
        if (!kunciRunning.length) { toast.info(T('ws.sched.stop.tiada', 'Tiada larian untuk dihentikan.')); return; }
        /* (1) Kosongkan status SLOT 'running' → kosong. */
        setSchedSusunan((prev) => {
            const su = prev[schedAkaunAktif]; if (!su) return prev;
            const isianBaru = { ...(su.isian || {}) };
            kunciRunning.forEach((k) => { if (isianBaru[k]) isianBaru[k] = { ...isianBaru[k], st: '', sb: '' }; });
            return { ...prev, [schedAkaunAktif]: { ...su, isian: isianBaru } };
        });
        /* (2) Bersihkan juga penanda 'running' pada PRODUK — supaya effect
           graduasi tidak menyalinnya balik ke slot yang baru dikosongkan.
           ★ [2026-11-03] Dalam tulisan YANG SAMA: catatan Shopee `sp_` + pil card akaun aktif
           yang masih 'running' (dahulu pil kekal "Sending…" selepas Stop, dan rekod telefon
           dikosongkan oleh tulisan berasingan yang kemudian DITINDIH tulisan ini). */
        const ids = new Set(Object.keys(perProduk));
        const kA = kunciAkaun(schedAkaunAktif);
        const updated = products.map((p) => {
            if (!ids.has(p.id)) return p;
            const ss = { ...(p.setStatuses || {}) };
            let petaAkaun = p.setStatusAkaun || {};
            perProduk[p.id].forEach((s) => {
                if (ss[`tiktok_${s}`] === 'running') ss[`tiktok_${s}`] = '';
                if (ss[`fb_${s}`] === 'running') ss[`fb_${s}`] = '';   // ★ [2026-09-16] slot Facebook
                if (ss[`sp_${s}`] === 'running') ss[`sp_${s}`] = '';   // telefon
                if (petaAkaun?.[`tiktok_${s}`]?.[kA]?.st === 'running') {
                    petaAkaun = gabungStatusAkaun(petaAkaun, s, schedAkaunAktif, { st: '', sb: '' });
                }
            });
            return { ...p, setStatuses: ss, setStatusAkaun: petaAkaun };
        });
        setProducts(updated);
        saveProducts(auth.currentUser.uid, updated.filter((p) => ids.has(p.id))).catch(() => {});
        /* ★ [2026-09-16] Robot Facebook tiada isyarat Stop (had sedia ada, sama
           seperti laluan tick kad) — beritahu, jangan biar pelanggan sangka ia
           berhenti serta-merta. */
        const adaFb = kunciRunning.some((k) => isian[k]?.pf === 'fb');
        toast.success(T('ws.sched.stop.ok', 'Larian dihentikan. Slot yang tersangkut dibersihkan.')
            + (adaFb ? ' ' + T('ws.fb.stopNota', 'Robot Facebook tidak boleh dihentikan di tengah jalan — reel yang sedang dimuat naik akan diselesaikan dahulu.') : ''));
    }, [schedSusunanAktif, schedAkaunAktif, products, T]);

    /* ★ LANGKAH 5 — tukar status slot secara MANUAL (dropdown popup butiran).
       Berguna bila robot silap tanda, atau pengguna nak tandakan sendiri satu
       slot sudah/belum selesai. Ditulis terus ke slot; tidak masuk timbunan
       Undo (menanda status bukan langkah perancangan yang perlu dibatalkan). */
    const schedSetStatusSlot = useCallback((off, minit, pilihan) => {
        const k = `${off}_${minit}`;
        const { st, md } = pecahPilihanStatus(pilihan);   // ★ 29 Sept 'posted' → complete + md 'now'
        /* Cermin ke rekod kad. Slot boleh dipadam; kad yang menyimpan sejarah,
           jadi suntingan di sini mesti sampai ke sana juga - kalau tidak kad
           akan terus memapar status lama yang user sudah betulkan. */
        const isiKini = schedSusunan?.[schedAkaunAktif]?.isian?.[k];
        if (isiKini) {
            tulisStatusAkaunKad([{ pid: isiKini.pid || isiKini.p?.id, s: isiKini.s, akaunId: schedAkaunAktif, st, sb: '', md }]);
        }
        setSchedSusunan((prev) => {
            const su = prev[schedAkaunAktif];
            if (!su?.isian?.[k]) return prev;
            return { ...prev, [schedAkaunAktif]: { ...su, isian: { ...su.isian, [k]: { ...su.isian[k], st, sb: '', md } } } };
        });
    }, [schedAkaunAktif, schedSusunan, tulisStatusAkaunKad]);

    /* ★ LANGKAH 5 — padam video untuk produk+set slot (sama seperti "Del Video"
       dalam bar pukal). Guna semula modal pengesahan + laluan padam yang SAMA
       (`confirmBulkDeleteVideos`) supaya logik padam teruji tidak diduakan. */
    const schedPadamVideoSlot = useCallback((pid, s) => {
        const p = products.find((x) => x.id === pid);
        const v = p?.prompts?.[s];
        if (!v?.uploadedVideo) { toast.info(T('ws.sched.vid.tiada', 'Tiada video untuk dipadam pada set ini.')); return; }
        const items = [{ productId: pid, setKey: s, videoUrl: v.uploadedVideo, thumbUrl: v.uploadedVideoThumb || '' }];
        const est = sumStorageBytes(items.flatMap((it) => [it.videoUrl, it.thumbUrl].filter(Boolean)));
        bulkVideoEstimateRef.current = est;
        setBulkVideoDeleteConfirm({ open: true, setKey: s, items, estBytes: null, busy: false, progress: null });
        est.then((bytes) => setBulkVideoDeleteConfirm((prev) => (prev.open && prev.items === items) ? { ...prev, estBytes: bytes } : prev));
    }, [products, T]);

    // Run TikTok Logic — ★ DIRECT MESSAGE approach (bypasses Firestore queue)
    /* `pilihanGateMasuk` (2026-10-06) = pilihan popup gate beg kuning (utils/gateBegKuning.js).
       ⛔ Fungsi ini juga dipanggil sebagai pengendali klik / dari App.jsx — hujah pertama boleh jadi
       objek event. `bacaPilihanGate` hanya menerima objek berpenanda `__gateBeg`. */
    const handleRunTikTok = async (pilihanGateMasuk = null) => {
        const gate = bacaPilihanGate(pilihanGateMasuk);
        /* ★ LANGKAH 3: di paparan Schedule (mod kalendar), Run baca KALENDAR.
           Di tab lain, ia baca kad bertick seperti biasa (keputusan 8.5). */
        if (schedMode) return handleRunTikTokKalendar();

        const tiktokSpaceProducts = selectedSpaceId === 'default'
            ? products.filter(p => !(p.spaceId || p.groupId) || p.spaceId === 'default' || p.groupId === 'default')
            : products.filter(p => p.spaceId === selectedSpaceId || p.groupId === selectedSpaceId);
        
        // ★ v3.0.0: Run any selected product, regardless of tab
        // ★ Fix: Filter by current group — only run products from the group user is viewing
        console.log('[TikTok Run] Debug:', {
            totalProducts: products.length,
            selectedSpaceId,
            selectedGroupId,
            spaceFiltered: tiktokSpaceProducts.length,
            withSelected: tiktokSpaceProducts.filter(p => p.selected).length,
        });

        const productsToRun = tiktokSpaceProducts.filter(p => {
            if (!p.selected) return false;
            /* v3.9: tab semasa sahaja — penyakit yang SAMA seperti Run Flow
               (disahkan 2026-08-12). Di sini akibatnya lebih berat: kad yang
               ditanda di tab Flow akan benar-benar DISIARKAN ke TikTok,
               bukan sekadar dijana. Siaran tidak boleh ditarik balik dengan
               semudah memadam kad.

               ⛔ Rupa lama kekal seperti asal, sama sebab macam Run Flow. */
            if (uiV39 && activeTab !== 'all' && getProductTab(p) !== activeTab) return false;
            /* ★ [2026-10-06] "Langkau N kad ini" dalam popup gate beg kuning → kad tanpa link TikTok
               dikeluarkan dari larian INI (tanda pilihan pada kad tidak disentuh). */
            if (gate?.langkauIds && gate.langkauIds.has(p.id)) return false;
            if (selectedGroupId === 'all') return true;
            return (p.workspaceGroup || 'Workspace') === selectedGroupId;
        });
        if (productsToRun.length === 0) {
            alert(T('ws.tiktok.noneSelected', "Tiada produk dipilih untuk dijalankan."));
            return;
        }

        /* ★ [2026-11-04] PHOTO POST (utils/jenisPostTiktok.js) — dibekukan SEKALI untuk larian ini.
           Satu post gambar setiap card, status pada set PERTAMA yang dipilih (`setLarian`).
           Card tanpa gambar → TAHAN sebelum apa-apa dihantar (bukan gagal senyap di robot). */
        /* ⚠️ Suis hanya wujud dalam v4 mod New (`slotTabV4`) — di luar v4 sentiasa 'video' (KEMBAR pagar App.jsx). */
        const jenisPostLarian = slotTabV4 ? bacaJenisPostTiktok() : 'video';
        const setLarian = setLarianTiktok(tiktokTargetSets, jenisPostLarian);
        if (jenisPostLarian === 'gambar') {
            const tanpaGambar = productsToRun.filter((p) => !gambarKad(p).length);
            if (tanpaGambar.length) {
                const nama = tanpaGambar.slice(0, 5).map((p) => `• ${p.name || p.id}`).join('\n') + (tanpaGambar.length > 5 ? `\n… +${tanpaGambar.length - 5}` : '');
                alert(T('ws.tiktok.gambar.tiada', `Photo post: ${tanpaGambar.length} card tiada gambar (gambar utama / tambahan). Untick card ini atau tambah gambar, kemudian Run semula.`, { n: tanpaGambar.length }) + '\n\n' + nama);
                return;
            }
            if (!setLarian.length) {
                alert(T('ws.tiktok.gambar.tiadaSet', 'Photo post: pilih sekurang-kurangnya satu set (status post disimpan pada set itu).'));
                return;
            }
        }

        /* ---------- PAGAR JULAT JADUAL --------------------------------
           TikTok hanya menerima jadual antara 15 minit dan HAD_HARI_TIKTOK
           hari dari sekarang. Diperiksa DI SINI, sebelum apa-apa dihantar,
           kerana kegagalan di hujung sana senyap: robot menetapkan waktu
           yang ditolak, videonya tetap tersimpan sebagai draf, dan pengguna
           hanya menyedarinya apabila tiada satu pun video tersiar.

           Kotak Start memang sudah membawa `min`/`max` (lihat App.jsx),
           tetapi itu tidak memadai — tetingkap boleh dibiar terbuka
           berjam-jam sehingga masa yang dipilih tadi sudah berlalu, dan
           had atas hanya dilanggar oleh video TERAKHIR dalam barisan,
           bukan oleh masa mula. */
        if (isScheduled) {
            const masaMula = new Date(scheduledStartTime);
            if (!scheduledStartTime || isNaN(masaMula.getTime())) {
                alert(T('ws.sched.pickStart', "Sila pilih masa mula jadual terlebih dahulu."));
                return;
            }

            const sekarang = Date.now();
            if (masaMula.getTime() - sekarang < 15 * 60 * 1000) {
                alert(T('ws.sched.min15', "TikTok memerlukan jadual sekurang-kurangnya 15 minit dari sekarang.\n\nSila pilih masa mula yang lebih lewat."));
                return;
            }

            /* Roda minit TikTok hanya ada 00,05,10,…,55 — tiada nilai lain
               WUJUD untuk dipilih. Atribut `step` pada kotak masa sepatutnya
               sudah menghalang ini, tetapi nilai boleh datang daripada state
               lama atau browser yang mengabaikan `step`; kalau ia lolos,
               SETIAP video dalam larian gagal verify dan jatuh jadi draf.
               Lebih baik dihalang di sini daripada ditemui 30 video kemudian. */
            if (masaMula.getMinutes() % 5 !== 0) {
                alert(T('ws.sched.step5', "TikTok hanya menerima jadual pada setiap 5 minit (contoh 14:30, 14:35).\n\nSila laraskan minit pada masa mula."));
                return;
            }

            /* Bilangan tugasan dikira daripada SUMBER YANG SAMA seperti
               payload di bawah: setiap produk dipilih × setiap set sasaran
               menjadi satu video (lihat `productDataForExtension` dan
               `sortedSets`). Ia anggaran PALING BANYAK — set yang tiada
               video akan dilangkau di sebelah extension — jadi pagar ini
               tidak akan terlepas jadual yang melampaui had. */
            const bilVideo = productsToRun.length * Math.max(1, setLarian.length);   // ★ Photo post: satu post setiap card
            /* ⚠️ `scheduledInterval` ialah RENTETAN. */
            const selangMinit = parseInt(scheduledInterval) || 30;
            const masaAkhir = masaMula.getTime() + (bilVideo - 1) * selangMinit * 60 * 1000;
            const hadAtas = sekarang + HAD_HARI_TIKTOK * 24 * 60 * 60 * 1000;

            if (masaAkhir > hadAtas) {
                alert(T('ws.sched.overLimit',
                    `Jadual ini melebihi had TikTok.\n\n` +
                    `${bilVideo} video pada selang ${selangMinit} minit menjadikan video terakhir jatuh melebihi ${HAD_HARI_TIKTOK} hari dari sekarang, dan TikTok tidak menerima tarikh sejauh itu.\n\n` +
                    `Sila kurangkan selang masa, atau kurangkan bilangan video dalam larian ini.`,
                    { bil: bilVideo, selang: selangMinit, had: HAD_HARI_TIKTOK }
                ));
                return;
            }
        }

        /* ★ [2026-10-06] GATE BEG KUNING (keputusan user) — kembar gate dalam handleRunTikTokKalendar.
           Beg kuning HIDUP + ada kad terpilih tanpa link produk TikTok (cth produk Shopee) → TAHAN dan
           tanya dahulu; tanpa gate ini robot menyimpan semua video kad itu sebagai draf. Diletak selepas
           pagar jadual dan SEBELUM apa-apa dihantar / dicop 'running'. */
        if (begKuningRef.current && !gate) {
            const semakan = semakGateBegKuning(productsToRun);
            if (semakan.perlu) {
                setGateBeg({
                    laluan: 'tick',
                    senarai: semakan.tiada, bilLain: semakan.bilLain, semuaTiada: semakan.semuaTiada,
                    idTiada: [...semakan.idTiada],
                });
                return;
            }
        }

        setIsSaving(true);

        // ★ PRE-FLIGHT CHECK: Confirm content script alive before dispatching TikTok automation.
        const ping = await pingExtension();
        if (!ping.alive) {
            console.warn('[TikTok] ✗ Pre-flight ping failed — content script unreachable. Showing refresh modal.');
            setAutomationProgress({
                isActive: true, type: 'tiktok', steps: [], currentStep: 0, totalSteps: 0,
                status: 'disconnected',
                extensionStatus: 'disconnected',
                message: T('ws.run.extDisconnected', 'Extension Terputus Sambungan'),
                details: T('ws.run.extDisconnectedTiktok', 'Tab ini perlu di-refresh dulu sebelum boleh start TikTok.')
            });
            setIsSaving(false);
            return;
        }
        // ★ GATE VERSI (v3.8.2): blok extension lama sebelum Run
        const _vGate = await checkExtensionVersionGate(ping.version);
        if (_vGate) { setVersionGateModal(_vGate); setIsSaving(false); return; }

        /* ★ [2026-09-18] Beg kuning MATI → video sahaja (satu takrifan dengan laluan
           kalendar — utils/pautanProduk.js).
           ★ [2026-10-06] `tanpaBeg` = "Post tanpa beg kuning" dari popup gate — larian INI sahaja. */
        const begKuning = gate?.tanpaBeg ? false : begKuningRef.current;
        const modTt = modTiktokBerkesan({ begKuning, isPostOnly, isShowcaseOnly });
        const effectiveShowcase = modTt.isShowcaseMode;
        const effectiveShowcaseOnly = modTt.isShowcaseOnly;
        const totalSteps = 3;
        setAutomationProgress({
            isActive: true, type: 'tiktok', steps: [
                { label: T('ws.tiktok.step.prepare', 'Menyediakan produk untuk TikTok...'), status: 'pending' },
                { label: T('ws.run.step.send', 'Menghantar arahan ke Extension...'), status: 'pending' },
                { label: T('ws.run.step.done', 'Selesai!'), status: 'pending' }
            ], currentStep: 0, totalSteps, status: 'running',
            extensionStatus: 'connected',
            message: T('ws.tiktok.title', `TikTok Automation — ${productsToRun.length} produk`, { n: productsToRun.length }),
            /* Nama mod TikTok (Showcase / Post) kekal sama dua bahasa. */
            details: T('ws.run.setsLabel', `Sets: ${tiktokTargetSets.map(s => s.replace('set', 'S')).join(', ')}`, { sets: tiktokTargetSets.map(s => s.replace('set', 'S')).join(', ') })
                + (!begKuning
                    ? T('ws.tiktok.mode.tanpaBeg', ' | Tanpa beg kuning')
                    : effectiveShowcaseOnly
                    ? T('ws.tiktok.mode.showcaseOnly', ' | Showcase Only')
                    : effectiveShowcase
                        ? T('ws.tiktok.mode.showcasePost', ' | Showcase + Post')
                        : T('ws.tiktok.mode.postOnly', ' | Post Only'))
        });

        try {
            let stepIdx = 0;

            // Step 1: Update product settings + set loading status
            setAutomationProgress(prev => ({ ...prev, currentStep: stepIdx + 1, steps: prev.steps.map((s, i) => i === stepIdx ? { ...s, status: 'running' } : s) }));
            const runIds = new Set(productsToRun.map(tp => tp.id));
            /* ★ [2026-11-03] Override: run tick card juga menulis pil card (akaun kalendar yang
               dibuka), larian terakhir menang — keputusan user. Set yang ada video SAHAJA (set
               tanpa video dilangkau robot; pil 'running' padanya takkan pernah siap). Naik taraf
               bila robot siap: rekodLarianKad.js (dalam effect graduasi). */
            const namaAkaunTick = (schedAkaun.find((a) => a.id === schedAkaunAktif)?.nama) || '';
            const updatedProducts = products.map(p => {
                if (runIds.has(p.id)) {
                    const newSetStatuses = { ...(p.setStatuses || {}) };
                    /* ★ [2026-11-04] setLarian = semua set (video) ATAU set pertama sahaja (Photo post). */
                    setLarian.forEach(s => {
                        newSetStatuses[`tiktok_${s}`] = 'running';
                    });
                    const setAdaVideo = jenisPostLarian === 'gambar' ? setLarian : setLarian.filter((s) => p.prompts?.[s]?.uploadedVideo);
                    return {
                        ...p,
                        setStatuses: newSetStatuses,
                        // md 'now' (Posted) hanya bila TIDAK berjadual: laluan tick dijadual oleh isScheduled, bukan caraPost.
                        setStatusAkaun: petaMulaLarian(p.setStatusAkaun, setAdaVideo, schedAkaunAktif, { pf: 'tt', md: caraPost === 'now' && !isScheduled ? 'now' : '', nama: namaAkaunTick }),
                        extensionSettings: {
                            isImageOnly,
                            isShowcaseMode: effectiveShowcase,
                            isPostOnly,
                            isShowcaseOnly: effectiveShowcaseOnly,
                            begKuning
                        }
                    };
                }
                return p;
            });
            setProducts(updatedProducts);

            // ★ Save ONLY the products that changed (was: saving all N products = N×listener reads)
            const changedOnly = updatedProducts.filter(p => runIds.has(p.id));
            await saveProducts(auth.currentUser.uid, changedOnly);
            setAutomationProgress(prev => ({ ...prev, steps: prev.steps.map((s, i) => i === stepIdx ? { ...s, status: 'done' } : s) }));
            stepIdx++;

            // Step 2: Send DIRECT message to extension (bypasses Firestore queue!)
            setAutomationProgress(prev => ({ ...prev, currentStep: stepIdx + 1, steps: prev.steps.map((s, i) => i === stepIdx ? { ...s, status: 'running' } : s) }));

            // Prepare product data for the extension
            const productDataForExtension = productsToRun.map(p => ({
                id: p.id,
                name: p.name,
                link: linkTiktokUntukRobot(p, begKuning),   // ★ [2026-09-18] kosong bila beg kuning MATI
                prompts: p.prompts,
                imageBase64: p.imageBase64 || null,
                imageUrl: p.imageUrl || p.localImagePath || null,
                /* ★ [2026-11-04] Gambar tambahan untuk Photo post — lihat nota kembar dalam handleRunTikTokKalendar. */
                extraImageUrls: Array.isArray(p.extraImageUrls) ? p.extraImageUrls : [],
            }));

            // ★ Send ONE DIRECT_TIKTOK message with ALL target sets (sequential processing in content script)
            const sortedSets = [...setLarian].sort();   // ★ Photo post: set pertama sahaja (setLarianTiktok)
            console.log(`[TikTok] ★ Sending DIRECT TIKTOK with sets: [${sortedSets.join(', ')}]`);
            window.postMessage({
                type: 'SESAAT_DIRECT_TIKTOK',
                /* ★ [v3.9.3] KOTAK TERBUKA. Tetapan larian BAHARU masuk DI SINI,
                   bukan sebagai medan baharu di sebelahnya — medan tetap perlu
                   disentuh di 4 tempat + release extension, dan yang tercicir
                   gagal SENYAP. ⛔ WAJIB ada pada KEDUA-DUA laluan Run TikTok
                   (kalendar + lama); terlepas satu = CTA hilang senyap di situ. */
                tetapan: { ctaText: ctaTeksLarian || '', aiLabel: aiLabelAktif !== false, begKuning, semakMuzik: tetapanSemakanTiktok().semakMuzik, semakKandungan: tetapanSemakanTiktok().semakKandungan, jenisPost: jenisPostLarian },   /* ★ [2026-11-04] jenisPost — utils/jenisPostTiktok.js */   /* ★ [2026-10-13] semakMuzik + semakKandungan */   // ★ v3.9.4 — suis AI label Control Panel · ★ [2026-09-18] begKuning
                products: productDataForExtension,
                targetSets: sortedSets,
                uid: auth.currentUser.uid,
                schedule: isScheduled ? {
                    startTime: scheduledStartTime,
                    interval: parseInt(scheduledInterval) || 30
                } : null,
                /* Diikat pada `isScheduled` supaya bendera ini MUSTAHIL hidup
                   tanpa masa jadual. Suis di App.jsx sudah menjaganya, tetapi
                   ikatan di sini menjadikannya benar walau apa pun keadaan
                   state di hulu — dan tanpa masa, "Direct Schedule" bermakna
                   robot menekan Schedule pada borang yang kosong. */
                directSchedule: !!(isScheduled && directSchedule),
                /* ★ v3.9.2 — mod larian DIBEKUKAN pada saat Run ditekan di browser INI
                   (sama seperti laluan kalendar; lihat nota di sana). */
                modes: { isShowcaseMode: effectiveShowcase, isPostOnly: modTt.isPostOnly, isShowcaseOnly: effectiveShowcaseOnly }
            }, '*');

            console.log(`[TikTok] ★ Sent 1 DIRECT TIKTOK message for ${sortedSets.length} sets`);
            await new Promise(r => setTimeout(r, 1000));

            setAutomationProgress(prev => ({ ...prev, steps: prev.steps.map((s, i) => i === stepIdx ? { ...s, status: 'done', label: T('ws.tiktok.sentLabel', `${productsToRun.length} produk Ã— ${sortedSets.length} set dihantar ✓`, { n: productsToRun.length, sets: sortedSets.length }) } : s) }));
            stepIdx++;

            // Step 3: Done
            await new Promise(r => setTimeout(r, 300));
            setAutomationProgress(prev => ({
                ...prev, currentStep: stepIdx + 1, status: 'success',
                steps: prev.steps.map((s, i) => i === stepIdx ? { ...s, status: 'done' } : s),
                message: T('ws.tiktok.started', `🎉 TikTok Automation Dimulakan!`),
                details: (() => {
                    const mod = !begKuning
                        ? T('ws.tiktok.doneMode.tanpaBeg', ' Post video tanpa beg kuning.')
                        : effectiveShowcaseOnly
                        ? T('ws.tiktok.doneMode.showcaseOnly', ' Showcase Only.')
                        : effectiveShowcase
                            ? T('ws.tiktok.doneMode.showcasePost', ' Showcase + Post Video.')
                            : T('ws.tiktok.doneMode.postOnly', ' Post Video Only.');
                    return T('ws.tiktok.startedDetail', `${productsToRun.length} produk telah dihantar terus ke Extension.${mod} Extension sedang membuka TikTok Studio...`, { n: productsToRun.length, mod });
                })()
            }));

            // ★ Auto-close popup after 5 seconds
            setTimeout(() => {
                setAutomationProgress(prev => ({ ...prev, isActive: false }));
            }, 5000);
        } catch (error) {
            console.error("Error starting TikTok automation:", error);
            setAutomationProgress(prev => ({
                ...prev, status: 'error',
                message: T('ws.tiktok.failed', 'âŒ TikTok Automation Gagal!'),
                details: error.message,
                steps: prev.steps.map((s, i) => i === prev.currentStep - 1 ? { ...s, status: 'error' } : s)
            }));

            // ★ Auto-close popup after 5 seconds
            setTimeout(() => {
                setAutomationProgress(prev => ({ ...prev, isActive: false }));
            }, 5000);
        } finally {
            setIsSaving(false);
        }
    };

    // ★ Expose methods to parent (App.jsx) via ref
    // Switch group and auto-deselect products not in the new group
    const switchGroup = (groupId) => {
        setSelectedGroupId(groupId);
        setProducts(prev => prev.map(p => {
            if (!p.selected) return p;
            const pGroup = p.workspaceGroup || 'Workspace';
            const inNewGroup = groupId === 'all' ? pGroup === 'Workspace' : pGroup === groupId;
            return inNewGroup ? p : { ...p, selected: false };
        }));
    };

    // ★ Bulk Import (Smart Custom) — append new products + save to cloud
    const handleBulkImport = async (newProducts) => {
        if (!Array.isArray(newProducts) || newProducts.length === 0) return;
        // Auto-fill originalIndex bila import tak provide (untuk product card display number)
        const startIdx = products.length + 1;
        // P6.3 — Smart Custom: produk yang dah ada prompts (cth dari Excel bulk) → 'flow'.
        // Produk tanpa prompts (cth library pull) → 'chatgpt' supaya user run ChatGPT dulu.
        const hasPromptsFor = (p) => {
            const s1 = p?.prompts?.set1 || {};
            return !!(s1.promptImage || s1.promptVideo || s1.promptVideoScene1 || s1.captionTiktok);
        };
        // Stamp space + group from current view, preserve incoming moduleId/scene
        const stamped = newProducts.map((p, idx) => {
            const defaultTab = (propActiveModuleId === 'flownity' || (propActiveModuleId === 'smartcustom' && !hasPromptsFor(p))) ? 'chatgpt' : 'flow';
            return {
                ...p,
                tab: p.tab || defaultTab,
                originalIndex: p.originalIndex ?? (startIdx + idx),
                spaceId: selectedSpaceId === 'default' ? null : selectedSpaceId,
                workspaceGroup: selectedGroupId === 'all' ? 'Workspace' : selectedGroupId,
            };
        });
        const updated = [...products, ...stamped];
        setProducts(updated);
        try {
            await saveToCloud(updated);
            toast.success?.(T('ws.import.done', `${stamped.length} produk diimport`, { n: stamped.length })) || console.log(`[BulkImport] ${stamped.length} products imported`);
        } catch (err) {
            console.error('[BulkImport] Save failed:', err);
            alert(T('ws.import.failed', 'Gagal save bulk import. Sila cuba lagi.'));
        }
    };

    // P6.5 — ChatGPT Auto-Run orchestrator. Loops produk yang `tab='chatgpt'` AND selected.
    // Per-product: postMessage ke extension content script → background opens chatgpt.com tab → run task → return result.
    // Webapp apply mapping engine + save ke Firestore.
    const [chatgptRunning, setChatgptRunning] = useState(false);
    const [chatgptProgress, setChatgptProgress] = useState({ current: 0, total: 0, label: '' });

    // ★ EXTRA ARAHAN — arahan tambahan per produk (tab Agent AI). Disimpan pada
    //   product.extraInstruction; masa run ditampal di hujung mesej selepas kod gate
    //   (compose dalam utils/sesaatGate.js buildGateBlock — perubahan webapp sahaja).
    const [extraEditId, setExtraEditId] = useState(null);   // product.id yang sedang diedit
    const [extraDraft, setExtraDraft] = useState('');
    const saveExtraInstruction = (productId, text) => {
        const t = (text || '').trim();
        const updated = products.map(p => p.id === productId ? { ...p, extraInstruction: t } : p);
        setProducts(updated);
        saveToCloud(updated);
        setExtraEditId(null);
    };
    // ★ Stop scrape dari extension side panel (butang Stop modal progress):
    //   background broadcast CHATGPT_SCRAPE_STOP → content script relay postMessage → set ref → loop break.
    const chatgptStopRef = useRef(false);
    useEffect(() => {
        const onScrapeStop = (event) => {
            if (event.data?.type === 'SESAAT_CHATGPT_SCRAPE_STOP') chatgptStopRef.current = true;
        };
        window.addEventListener('message', onScrapeStop);
        return () => window.removeEventListener('message', onScrapeStop);
    }, []);
    // FLOWNITY — platform scrape (chatgpt | gemini). Setting untuk run seterusnya sahaja; persist localStorage.
    // Gemini (Gems) LOCKED — automation belum siap. Buka semula: set false.
    const FLOWNITY_GEMINI_LOCKED = false;
    const [flownityScrapePlatform, setFlownityScrapePlatform] = useState(() => {
        const v = localStorage.getItem('flownity_scrapePlatform');
        return v === 'gemini' && !FLOWNITY_GEMINI_LOCKED ? 'gemini' : 'chatgpt';
    });
    const changeFlownityScrapePlatform = (v) => {
        if (v === 'gemini' && FLOWNITY_GEMINI_LOCKED) return;
        setFlownityScrapePlatform(v);
        try { localStorage.setItem('flownity_scrapePlatform', v); } catch (e) { /* ignore */ }
    };
    // Nama paparan dropdown platform — admin boleh custom via gear ⚙ FLOWNITY (scrapeConfig.{platform}.displayName).
    // Fetch sekali bila bar scrape FLOWNITY visible sahaja (jimat reads).
    const [flownityPlatformNames, setFlownityPlatformNames] = useState({ chatgpt: 'ChatGPT (GPTs)', gemini: 'Gemini (Gems)' });
    const flownityScrapeBarVisible = !uiV39 && activeTab === 'chatgpt' && products.some(p => getProductTab(p) === 'chatgpt' && p.moduleId === 'flownity');
    /* v3.9: kawalan berpindah ke Control Panel kanan, jadi nama platform
       diperlukan sebaik tab Agent AI dibuka — bukan hanya bila ada kad
       FLOWNITY dalam tab. Panel sentiasa ada, kad boleh datang kemudian. */
    const perluNamaPlatformFlownity = flownityScrapeBarVisible || (uiV39 && activeTab === 'chatgpt');
    useEffect(() => {
        if (!perluNamaPlatformFlownity) return;
        let alive = true;
        (async () => {
            try {
                const { doc: fsDoc, getDoc } = await import('firebase/firestore');
                const snap = await getDoc(fsDoc(db, 'modules', 'flownity'));
                if (!alive || !snap.exists()) return;
                const sc = snap.data().scrapeConfig || {};
                setFlownityPlatformNames({
                    chatgpt: (sc.chatgpt?.displayName || '').trim() || 'ChatGPT (GPTs)',
                    gemini: (sc.gemini?.displayName || '').trim() || 'Gemini (Gems)',
                });
            } catch (e) { /* kekal nama default */ }
        })();
        return () => { alive = false; };
    }, [perluNamaPlatformFlownity]);

    // ★ AGENT SAYA (module SMART) — agent custom GPT milik pelanggan sendiri,
    //   dikonfigurasi di PRO Studio → Agent Saya. Disimpan dalam collection yang
    //   sama seperti template lama tetapi ditanda `agentV: 2`.
    const [smartAgents, setSmartAgents] = useState([]);
    const [smartAgentId, setSmartAgentId] = useState(() => {
        try { return localStorage.getItem('smart_agentId') || ''; } catch { return ''; }
    });
    const smartAgentBarVisible = !uiV39 && activeTab === 'chatgpt'
        && products.some(p => getProductTab(p) === 'chatgpt' && p.moduleId === 'smartcustom');
    /* v3.9: senarai agent diperlukan sebaik tab Agent AI dibuka. Suis
       "Smart" dalam Control Panel boleh dihidupkan bila-bila masa, dan
       menunggu sehingga ada kad Smart Custom bermakna dropdown itu kosong
       tepat pada saat pengguna membukanya. */
    const perluSenaraiAgent = smartAgentBarVisible || (uiV39 && activeTab === 'chatgpt');

    useEffect(() => {
        if (!perluSenaraiAgent || !auth.currentUser?.uid) return;
        let alive = true;
        (async () => {
            try {
                const { collection: fsCol, getDocs: fsGetDocs } = await import('firebase/firestore');
                const snap = await fsGetDocs(fsCol(db, 'users', auth.currentUser.uid, 'chatgptTemplates'));
                if (!alive) return;
                const list = snap.docs
                    .map(d => ({ id: d.id, ...d.data() }))
                    .filter(a => Number(a.agentV) === 2)
                    /* Toggle "Papar di Workspace" di PRO Studio (2026-10-18). Tiada medan = papar.
                       Agent OFF yang masih terpilih (localStorage) tidak lagi dalam senarai →
                       runSmartAgent memberi alert "Sila pilih agent", bukan larian senyap. */
                    .filter(agentDiWorkspace)
                    .sort(bandingAgent);
                setSmartAgents(list);
            } catch (e) {
                console.error('[SmartAgent] muat senarai gagal:', e);
            }
        })();
        return () => { alive = false; };
    }, [perluSenaraiAgent]);

    const changeSmartAgent = (id) => {
        setSmartAgentId(id);
        try { localStorage.setItem('smart_agentId', id || ''); } catch { /* abaikan */ }
    };

    /* ── Bekalan untuk Control Panel Agent AI (v3.9) ───────────────────
       Kiraan kad menggunakan penapis yang SAMA PERSIS dengan `targets`
       dalam handleRunChatGPT — dipilih, bertanda tab Agent AI, dan dalam
       group yang sedang dibuka. Kalau kiraan di panel dikira dengan
       peraturan yang lebih longgar, butang Run akan berjanji lebih
       daripada apa yang sebenarnya berjalan. Itulah kelemahan bar lama:
       ia mengira SEMUA kad bertanda, merentas tab dan merentas group. */
    const agentPanelCounts = useMemo(() => {
        const k = { flownity: 0, smart: 0, lain: 0 };
        products.forEach(p => {
            if (!p.selected) return;
            if (getProductTab(p) !== 'chatgpt') return;
            if (selectedGroupId !== 'all' && (p.workspaceGroup || 'Workspace') !== selectedGroupId) return;
            if (p.moduleId === 'flownity') k.flownity++;
            else if (p.moduleId === 'smartcustom') k.smart++;
            else k.lain++;
        });
        return k;
    }, [products, selectedGroupId]);

    /* Panel duduk dalam App.jsx, jadi keadaan ini dihantar ke atas. Ia
       PAPARAN sahaja — tiada satu pun daripadanya menjadi state di sana,
       supaya sumber kebenaran kekal di sini. */
    useEffect(() => {
        if (!onAgentPanelChange) return;
        onAgentPanelChange({
            agents: smartAgents.map(a => ({
                id: a.id,
                name: a.name || T('ws.agent.unnamed', 'Agent tanpa nama'),
                /* Dipapar sebagai label dalam pemilih agent — agent ChatGPT dan
                   Gemini duduk bercampur dalam satu senarai, jadi tanpa label ini
                   pelanggan terpaksa mengingat sendiri agent mana tinggal di mana. */
                platform: a.platform === 'gemini' ? 'gemini' : 'chatgpt',
                configured: !!a.configured,
                configuredAt: a.configuredAt || '',
                setCount: a.setCount,
                sceneCount: a.sceneCount,
                output: a.output,
                productPhoto: a.productPhoto,
                avatar: a.avatar,
                /* Field yang benar-benar berpadan dengan jawapan agent —
                   ukuran sebenar sama ada padanan sudah berjaya, bukan
                   sekadar bilangan field dalam borang. */
                fieldsMatched: [...(a.sceneFields || []), ...(a.setFields || [])].filter(f => f && f.source).length,
                /* Bilangan pusingan bertanda "Simpan gambar" (PRO Studio, Langkah 2). Pemilih agent
                   memaparkannya supaya pelanggan tahu agent mana menyimpan gambar ke card — dan berapa
                   ruang gambar kosong setiap card perlukan (arahan user 2026-09-13). SATU takrifan
                   dengan larian sebenar + semakan ruang: `imageTurnsDaripadaAgent`. */
                imageTurns: imageTurnsDaripadaAgent(a).length,
            })),
            agentId: smartAgentId,
            platform: flownityScrapePlatform,
            platformNames: flownityPlatformNames,
            geminiLocked: FLOWNITY_GEMINI_LOCKED,
            running: chatgptRunning,
            progress: chatgptProgress,
            counts: agentPanelCounts,
        });
    }, [smartAgents, smartAgentId, flownityScrapePlatform, flownityPlatformNames, chatgptRunning, chatgptProgress, agentPanelCounts]);

    /* ★ TETAPAN AGENT TERKINI DIBACA PADA SETIAP KLIK RUN (keputusan user 2026-09-13).
       Senarai `smartAgents` dibaca SEKALI semasa tab Agent AI dibuka, jadi agent yang
       di-Configure semula di PRO Studio dalam tab lain terus berjalan dengan resipi LAMA
       selagi tab Workspace tidak dimuat semula — SENYAP (bukti kad 1730856067963782836:
       larian 22:33 mengisi Hook Text daripada padanan lama, larian 22:37 ikut padanan baharu).
       Satu bacaan doc setiap klik; salinan dalam senarai turut dikemas kini.
       ⛔ Bacaan GAGAL = larian DIBATALKAN dengan mesej, bukan jatuh senyap ke salinan lama —
          salinan lama itulah punca pepijat ini.
       `bacaAgentRef` hanya menahan klik berganda SEMASA bacaan; ia dilepaskan sebelum
       handleRunChatGPT dipanggil, jadi larian yang tersangkut tidak boleh mengunci Run. */
    const bacaAgentRef = useRef(false);

    // Jalankan agent pelanggan pada produk yang dipilih. Guna laluan yang SAMA
    // dengan Run Agent AI biasa (handleRunChatGPT) supaya semua pagar sedia ada
    // — pre-flight ping, gate versi, hydrate Split V2, simpan berperingkat —
    // terpakai tanpa disalin semula.
    const runSmartAgent = async (opts) => {
        if (bacaAgentRef.current) return;
        const dipilih = smartAgents.find(a => a.id === smartAgentId);
        if (!dipilih) { alert(T('ws.agent.alert.pilihAgent', 'Sila pilih agent terlebih dahulu.')); return; }
        const namaDipilih = dipilih.name || T('ws.agent.unnamed', 'Agent tanpa nama');

        let agent;
        bacaAgentRef.current = true;
        try {
            const uid = auth.currentUser?.uid;
            if (!uid) throw new Error('tiada sesi log masuk');
            const snap = await getDoc(doc(db, 'users', uid, 'chatgptTemplates', dipilih.id));
            if (!snap.exists() || Number(snap.data()?.agentV) !== 2) {
                setSmartAgents(prev => prev.filter(a => a.id !== dipilih.id));
                alert(T('ws.agent.alert.agentTiada', `Agent "${namaDipilih}" sudah tiada — mungkin telah dipadam di PRO Studio. Sila pilih agent lain.`, { nama: namaDipilih }));
                return;
            }
            agent = { id: snap.id, ...snap.data() };
            setSmartAgents(prev => prev.map(a => (a.id === agent.id ? agent : a)));
        } catch (e) {
            console.error('[SmartAgent] baca tetapan agent terkini gagal:', e);
            alert(T('ws.agent.alert.gagalBacaAgent', `Tetapan terkini agent "${namaDipilih}" tidak dapat dibaca. Semak sambungan internet anda, kemudian tekan Run semula.`, { nama: namaDipilih }));
            return;
        } finally {
            bacaAgentRef.current = false;
        }

        if (!agent.configured) {
            alert(T('ws.agent.alert.belumConfigure', `Agent "${agent.name}" belum dikonfigurasi.\n\nBuka PRO Studio → Agent Saya → Langkah 5 (Configure), jalankan sekali dengan satu produk, kemudian Simpan.`, { nama: agent.name }));
            return;
        }
        handleRunChatGPT({
            gptUrl: agent.gptUrl,
            platform: agent.platform === 'gemini' ? 'gemini' : 'chatgpt',
            geminiModel: agent.geminiModel || '',
            // ★ Gemini: Extended thinking — tetapan agent, jadi larian pukal ikut sama
            //   (peraturan sama seperti cip Extended ChatGPT di bawah).
            geminiExtended: agent.platform === 'gemini' ? (agent.geminiExtended || '') : '',
            /* ★ Cip "Extended" ChatGPT — tetapan agent, jadi larian pukal di sini
               MESTI mengikutnya sama seperti larian Configure. Tanpa baris ini,
               pelanggan memilih "Matikan Extended" di PRO Studio dan mendapati ia
               tidak mati semasa Run (aduan user 2026-08-20).
               ⚠️ `chatgptExtendedOff` (boolean) ialah nama medan LAMA yang dipakai
               beberapa jam sebelum ia bertukar kepada tiga keadaan — diterima di
               sini supaya agent yang disimpan ketika itu tetap berkelakuan betul. */
            chatgptExtendedOff: agent.platform === 'gemini' || agent.chatgptTahap
                ? false
                : (agent.chatgptExtended === 'mati' || (!agent.chatgptExtended && !!agent.chatgptExtendedOff)),
            /* ★ Tahap Thinking ChatGPT (2026-09-26) — dipilih di Configure, dipakai di sini.
               Kosong = agent lama → chatgptExtendedOff di atas. EMPAT tempat: payload
               Configure · di sini (+ salinan template di bawah) · content.ts · background.ts. */
            chatgptTahap: agent.platform === 'gemini' ? '' : String(agent.chatgptTahap || ''),
            promptTemplate: '',          // custom GPT pelanggan bawa arahannya sendiri
            sceneCount: agent.sceneCount || 1,
            agent,                        // ← penanda laluan resipi (lihat handleRunChatGPT)
            moduleFilter: opts?.moduleFilter,
        });
    };

    const sendChatGPTTaskToExtension = (payload) => {
        // Request-response via window.postMessage with requestId
        // ⛔ HAD MASA MESTI IKUT BILANGAN BALASAN. Agent "Agent Saya" boleh berbalas
        //   beberapa pusingan; setiap pusingan = agent berfikir + menulis semula.
        //   Had tetap 3 minit membatalkan larian yang sebenarnya berjalan elok —
        //   bug sebenar 2026-08-05: semua produk log "Task timeout (3 minutes)".
        //   Extension ada had dalamannya sendiri, jadi nilai di sini hanyalah jaring.
        const _replyCount = Array.isArray(payload.replies) ? payload.replies.length : 0;
        /* Pusingan bergambar menunggu gambar siap dijana (jaring extension 5 min setiap
           satu) — jaring di sini ikut sama supaya larian yang elok tidak dibatalkan. */
        const _imgCount = Array.isArray(payload.imageTurns) ? payload.imageTurns.length : 0;
        /* Gambar produk TAMBAHAN (2026-09-13): setiap satu dimuat turun, dilampirkan dan
           ditunggu siap dimuat naik di extension — biasanya beberapa saat, jaring terburuk
           ~1.5 minit setiap gambar. */
        const _extraCount = Array.isArray(payload.extraImageUrls) ? payload.extraImageUrls.length : 0;
        /* hadMasaPusinganGambar = 5 min + ruang 3 cuba semula gambar (2026-09-13). */
        const timeoutMs = 240000 + (_replyCount * 300000) + hadMasaPusinganGambar(_imgCount) + (_extraCount * 90000);
        return new Promise((resolve) => {
            const requestId = `cgpt_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
            const listener = (event) => {
                if (event.data?.type === 'SESAAT_DIRECT_CHATGPT_TASK_RESULT' && event.data.requestId === requestId) {
                    window.removeEventListener('message', listener);
                    resolve(event.data.response || { success: false, error: 'Empty response' });
                }
            };
            window.addEventListener('message', listener);
            // Timeout safety — skala ikut bilangan balasan (lihat nota di atas)
            setTimeout(() => {
                window.removeEventListener('message', listener);
                resolve({ success: false, error: `Task timeout (${Math.round(timeoutMs / 60000)} minit)` });
            }, timeoutMs);
            window.postMessage({ type: 'SESAAT_DIRECT_CHATGPT_TASK', requestId, ...payload }, '*');
        });
    };

    const handleRunChatGPT = async (template) => {
        if (!template || !template.gptUrl) {
            alert(T('ws.agent.alert.pilihTemplate', 'Pilih template dulu'));
            return;
        }
        /* Run ditekan semula → tanda "Tiada ruang gambar" lama dikosongkan dahulu; semakan ruang di
           bawah menandakan semula kad yang MASIH penuh (keputusan user 2026-09-13). */
        setKadTiadaRuang([]);
        setPopupTiadaRuang(false);
        /* Dua penapis, dua tugas berbeza (arahan user 2026-08-12:
           "group bergerak ikut group, tab bergerak ikut tab"):

             TAB   — laluan ini memang milik tab Agent AI, jadi hanya kad
                     bertanda `chatgpt` yang layak. Ini sudah ada sejak awal.
             GROUP — BAHARU. Sebelum ini Agent AI satu-satunya laluan Run
                     yang mengabaikan group: kad Agent AI bertanda dalam
                     group lain turut berjalan walaupun pengguna sedang
                     membuka group yang lain sama sekali. Flow dan TikTok
                     kedua-duanya sudah menghormati group sejak dahulu; ini
                     menyamakan yang ketiga.

           ⛔ Penapis group TIDAK dipagar `uiV39` — ia bukan reka bentuk
              baharu, ia membetulkan laluan yang tersasar daripada dua
              laluan Run yang lain. Rupa lama patut berkelakuan sama. */
        const targets = products.filter(p => {
            if (!p.selected) return false;
            if (getProductTab(p) !== 'chatgpt') return false;
            /* MODULE — hanya laluan Control Panel v3.9 yang menghantar
               penapis ini. Sebabnya dua enjin Agent AI mengisi bentuk
               field yang BERBEZA: agent FLOWNITY memulangkan babak
               `promptVideoScene1..N`, agent pelanggan pula memulangkan
               apa yang dia padankan sendiri di PRO Studio. Tanpa penapis,
               kad Smart Custom yang kebetulan ditanda akan dijalankan
               dengan agent FLOWNITY dan pulang dengan medan yang tidak
               padan — senyap, tanpa ralat.
               ⚠️ Bar lama (rupa lama) sengaja TIDAK menghantarnya supaya
                  perangai yang pelanggan pakai hari ini tidak berubah. */
            if (template.moduleFilter && p.moduleId !== template.moduleFilter) return false;
            if (selectedGroupId === 'all') return true;
            return (p.workspaceGroup || 'Workspace') === selectedGroupId;
        });
        if (targets.length === 0) {
            /* ⛔ `moduleFilter` dibanding dengan id module ('smartcustom'/'flownity') — JANGAN sentuh. */
            alert(template.moduleFilter === 'smartcustom'
                ? T('ws.agent.alert.tiadaKadSmart', 'Tiada kad Smart Custom dipilih. Suis Smart menjalankan kad Smart Custom sahaja — matikan suis itu untuk kad FLOWNITY.')
                : template.moduleFilter === 'flownity'
                    ? T('ws.agent.alert.tiadaKadFlownity', 'Tiada kad FLOWNITY dipilih. Hidupkan suis Smart untuk menjalankan kad Smart Custom dengan agent anda sendiri.')
                    : T('ws.agent.alert.tiadaProduk', 'Tiada produk selected.'));
            return;
        }

        /* ★ GAMBAR DARIPADA JAWAPAN AGENT (2026-09-11). Pusingan yang gambarnya
           disimpan ke kad. ⛔ TIADA pagar versi khusus di sini (keputusan user
           2026-09-11) — pagar global `config/extension_gate` yang memaksa semua
           pelanggan ke versi baharu; extension lama yang terlepas hanya
           memulangkan `images` kosong dan kad diberitahu (lihat `_imgNota`). */
        const _imgTurns = template.agent ? imageTurnsDaripadaAgent(template.agent) : [];

        /* ★ SEMAKAN RUANG GAMBAR (keputusan user 2026-09-13) — SEBELUM ping extension, sebelum apa-apa
           tab dibuka. Agent yang menyimpan gambar perlukan ruang kosong pada SETIAP kad sasaran; satu kad
           penuh = SELURUH larian ditahan (tiada automation langsung) sehingga pelanggan membetulkannya
           atau memilih kad lain. Tanpa ini robot tetap membuka ChatGPT/Gemini dan agent menjana gambar
           yang kemudiannya DITOLAK semasa simpan — masa + kuota jana gambar pelanggan terbuang. Semakan
           semasa simpan (`simpanGambarAgentKeKad`) KEKAL jaring terakhir.
           ⛔ Tab My Agent SAHAJA (keputusan user) — Run Flow tidak menyimpan gambar ke kad.
           `extraImageUrls` ialah medan aras-ATAS kad (doc ringan Split V2), jadi tiada hydrate diperlukan. */
        const _tiadaRuang = kadTiadaRuangGambar(targets, _imgTurns.length);
        if (_tiadaRuang.length > 0) {
            setKadTiadaRuang(_tiadaRuang);
            setPopupTiadaRuang(true);
            const _idPertama = _tiadaRuang[0].id;
            setTimeout(() => {
                try {
                    const sel = (typeof CSS !== 'undefined' && CSS.escape) ? CSS.escape(_idPertama) : String(_idPertama).replace(/"/g, '\\"');
                    document.querySelector(`[data-product-id="${sel}"]`)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
                } catch { /* tatal gagal = kad masih bertanda; bukan kegagalan larian */ }
            }, 80);
            return;
        }

        // ★ PRE-FLIGHT CHECK (sama corak Run Flow/TikTok): confirm content script alive
        //   SEBELUM dispatch. Kalau mati (extension baru update/reload) → modal refresh,
        //   jangan start loop — elak "Selesai X/X" palsu tanpa automation jalan.
        const ping = await pingExtension();
        if (!ping.alive) {
            console.warn('[ChatGPT] ✗ Pre-flight ping failed — content script unreachable. Showing refresh modal.');
            setAutomationProgress({
                isActive: true, type: 'chatgpt', steps: [], currentStep: 0, totalSteps: 0,
                status: 'disconnected',
                extensionStatus: 'disconnected',
                message: T('ws.ext.putus.tajuk', 'Extension Terputus Sambungan'),
                details: T('ws.ext.putus.detailAgent', 'Tab ini perlu di-refresh dulu sebelum boleh run Agent AI.')
            });
            return;
        }
        // ★ GATE VERSI (v3.8.2): blok extension lama sebelum Run
        const _vGate = await checkExtensionVersionGate(ping.version);
        if (_vGate) { setVersionGateModal(_vGate); return; }

        /* `_imgTurns` dikira lebih awal (sebelum pre-flight) — ia turut dipakai semakan ruang gambar. */

        const { applyMapping } = await import('../utils/chatgptMappingEngine');
        // ★ SESAAT GATE — kod akses harian dijana di webapp (satu tempat rotate: utils/sesaatGate.js)
        const { buildGateBlock, ADMIN_LESEN_KEY } = await import('../utils/sesaatGate');

        // ★ SESAAT LESEN — ambil license key user SEKALI (sebelum loop). Admin guna key khas
        //   sebab akaun admin takda license key biasa. Dihantar dalam gateBlock tiap produk.
        let sesaatLesen = '';
        try {
            const _isAdmin = getUserRole(auth.currentUser?.email) === ROLES.ADMIN;
            if (_isAdmin) {
                sesaatLesen = ADMIN_LESEN_KEY;
            } else if (auth.currentUser?.uid) {
                const { doc: fsDoc, getDoc } = await import('firebase/firestore');
                const licSnap = await getDoc(fsDoc(db, 'licenses', auth.currentUser.uid));
                sesaatLesen = (licSnap.exists() ? (licSnap.data().licenseKey || '') : '').trim();
            }
        } catch (e) {
            console.warn('[ChatGPT] Gagal ambil license key untuk LESEN:', e);
        }

        chatgptStopRef.current = false;
        setChatgptRunning(true);
        setChatgptProgress({ current: 0, total: targets.length, label: T('ws.agent.progress.mula', 'Mula...') });

        // ★ SPLIT V2: hydrate produk split SEBELUM merge — base merge & prime cache
        //   mesti teks PENUH (kalau tidak, mapping separa menutup teks set lain
        //   pada paparan/Run walaupun subdoc merge kekalkannya di cloud).
        try {
            await hydrateDetails(targets, { throwOnError: true });
        } catch (e) {
            alert(T('ws.split.alert.gagalMuat', "Gagal memuatkan teks penuh produk dari cloud. Sila semak sambungan internet anda dan cuba semula."));
            setChatgptRunning(false);
            setChatgptProgress({ current: 0, total: 0, label: '' });
            return;
        }

        let working = [...products];
        const subPrompt = (tpl, prod) => {
            const t = tpl || '';
            return t
                .replaceAll('{productName}', prod.name || '')
                .replaceAll('{productLink}', prod.link || '')
                .replaceAll('{imageUrl}', prod.imageUrl || prod.localImagePath || '');
        };

        let done = 0;
        /* ★ CUBA SEMULA AUTOMATIK (2026-10-24, aduan hb.izyan: "tick banyak, 1 je masuk").
           Kad yang gagal kerana sambungan extension putus / tiada jawapan (utils/cubaSemulaAgent.js)
           ditambah SEKALI ke hujung barisan ini dan dicuba semula selepas kad lain siap.
           `done` hanya dikira bila kad selesai muktamad, jadi kemajuan kekal N/targets.length. */
        const barisan = targets.map(item => ({ item, ulang: false }));
        for (let _gi = 0; _gi < barisan.length; _gi++) {
            const { item, ulang: _ulang } = barisan[_gi];
            if (chatgptStopRef.current) break; // user tekan Stop di side panel
            let _diulangKemudian = false;
            if (_ulang) {
                setChatgptProgress({ current: done, total: targets.length, label: T('ws.agent.progress.cubaSemula', `Retrying ${item.name?.slice(0, 30) || ''}...`, { nama: item.name?.slice(0, 30) || '' }) });
                await new Promise(r => setTimeout(r, JEDA_CUBA_SEMULA_MS));
                if (chatgptStopRef.current) break;
            }
            const _sebelumGiliran = working.find(p => p.id === item.id); // asas beza — lihat hujung gelung
            if (!_ulang) setChatgptProgress({ current: done, total: targets.length, label: T('ws.agent.progress.memproses', `Processing ${item.name?.slice(0, 30) || ''}...`, { nama: item.name?.slice(0, 30) || '' }) });

            // ★ FLOWNITY METERING — coin dipotong MASA MULA (tekan Generate, sebelum scrape produk ni),
            //   tak kira scrape jadi ke tak (keputusan user Jul 2026 — scrape belum stabil 100%, jadi
            //   metering ikat pada Generate, bukan pada kejayaan scrape). Server yang tentukan sumber:
            //   trial → pool 5 coin trial (pipelineCoins); paid tanpa grant → coin percubaan FLOWNITY.
            //   Coin habis → berhenti terus; produk yang belum sampai giliran TAK terpotong.
            //   Cubaan semula automatik (`_ulang`) TIDAK memotong coin kali kedua — ulang itu pilihan sistem.
            if (item.moduleId === 'flownity' && !_ulang) {
                try {
                    const coinRes = await aiService.deductFlownityTrialCoin();
                    if (coinRes?.mode === 'trial') {
                        console.log(`[FLOWNITY] Coin dipotong — baki ${coinRes.remaining}`);
                    }
                } catch (err) {
                    console.warn('[FLOWNITY] Coin tak dapat dipotong — run dihentikan:', err.message);
                    alert(err.message);
                    break;
                }
            }

            try {
                const masterPrompt = subPrompt(template.promptTemplate, item);
                const result = await sendChatGPTTaskToExtension({
                    gptUrl: template.gptUrl,
                    productName: item.name || '',
                    productLink: item.link || '',
                    imageBase64: item.imageBase64 || item.imageUrl || item.localImagePath || '',
                    masterPrompt,
                    // ★ SESAAT GATE — dijana SAAT hantar (per produk); extension tampal di hujung mesej.
                    //   kod harian + LESEN: <key user> + Extra Arahan produk (jika ada).
                    // ★ AGENT SAYA: TIADA gateBlock (blok kod lesen hanya untuk GPT rasmi
                    //   SESAAT — menghantarnya ke GPT penjual lain merosakkan jawapan).
                    //   Arahan tambahan + balasan berturutan datang dari tetapan AGENT,
                    //   bukan per kad produk.
                    gateBlock: template.agent ? '' : buildGateBlock(item.extraInstruction, sesaatLesen),
                    ...(template.agent ? {
                        agentMode: true,
                        moduleLabel: 'Smart Custom',
                        /* ★ DATA PRODUK + ayat arahan agent (2026-08-21).
                           ⛔ INI tempat KEDUA yang menghantar tugasan agent —
                              yang pertama ialah larian Configure di PRO Studio.
                              Kedua-duanya WAJIB memanggil `gabungArahanAgent`
                              yang sama: kalibrasi dibuat atas bentuk mesej
                              Configure, jadi larian di sini mesti menghantar
                              bentuk yang serupa atau padanan medan tersasar
                              secara SENYAP (pepijat sama pernah berlaku pada
                              tetapan Extended, 2026-08-20). */
                        /* ⚠️⚠️ `withDetail(item)` — BUKAN `item`. Selepas Split V2 teks
                           berat kad (termasuk perenggan `intelligenceData.imageAnalysis`
                           yang MENJADI blok DATA PRODUK) tidak lagi duduk pada doc kad;
                           ia ditarik oleh `hydrateDetails` di atas ke dalam detailCache,
                           dan `withDetail` ialah SATU-SATUNYA cara membacanya semula.
                           `targets` dibina daripada state `products` yang RINGAN, jadi
                           menghantar `item` mentah bermakna agent hanya menerima nama +
                           link — persis pepijat 2026-08-22: Configure menghantar data
                           penuh (ia memuat perenggan sendiri) tetapi larian Workspace
                           tidak. Kegagalannya SENYAP: tiada ralat, cuma blok data kosong.
                           Corak sama sudah dipakai oleh laluan Run Flow
                           (`productsToRun.map(withDetail)`). */
                        extraInstruction: gabungArahanAgent(withDetail(item), template.agent),
                        replies: Array.isArray(template.agent.replies)
                            ? template.agent.replies.map(r => String(r || '').trim()).filter(Boolean)
                            : [],
                        /* ★ Pusingan yang gambarnya disimpan ke kad (2026-09-11). Peraturan
                           EMPAT tempat: payload Configure · di sini · jambatan content.ts ·
                           background.ts. */
                        imageTurns: _imgTurns,
                        /* ★ GAMBAR TAMBAHAN kad (2026-09-13) — dihantar bersama gambar utama
                           (sehingga 5, sama seperti jalur gambar pada kad) supaya agent boleh
                           membina product sheet daripada banyak gambar. Peraturan EMPAT tempat:
                           payload Configure · di sini · jambatan content.ts · background.ts.
                           ⛔ Laluan BUKAN-agent (FLOWNITY / Smart Custom lama) SENGAJA tidak
                              menghantarnya — perangai lama kekal. */
                        extraImageUrls: gambarTambahan(item),
                    } : {}),
                    platform: template.platform || 'chatgpt', // 'gemini' = scrape Gem (FLOWNITY)
                    geminiModel: template.geminiModel || '',   // '' = ikut tetapan Gemini
                    geminiExtended: template.geminiExtended || '', // ★ Gemini: Extended thinking on/off ('' = jangan sentuh)
                    // ★ ChatGPT sahaja — true = buang cip "Thinking" sebelum menaip
                    //   (nama medan kekal "Extended" = label cip lama sebelum 13 Sept).
                    chatgptExtendedOff: !!template.chatgptExtendedOff,
                    chatgptTahap: template.chatgptTahap || '', // ★ tahap Thinking agent (2026-09-26)
                    // ★ Kiraan produk untuk modal progress extension side panel (Produk X/Y)
                    //   Kedudukan dalam barisan (termasuk cubaan semula) — background memulangkan fokus
                    //   ke tab webapp bila taskCurrent >= taskTotal.
                    taskCurrent: _gi + 1,
                    taskTotal: barisan.length,
                });

                if (!result.success) {
                    // ★ MID-RUN BRIDGE CHECK: error jenis "sambungan extension mati" (bukan error produk)
                    //   → berhenti terus + modal refresh, JANGAN sambung produk seterusnya.
                    const errText = String(result.error || '');
                    const bridgeDead = adalahRalatSambungan(errText);
                    if (bridgeDead) {
                        console.warn('[ChatGPT] ✗ Extension bridge mati mid-run:', errText);
                        /* "context invalidated" = refresh tab memadai; ralat lain (service worker
                           lama / tiada penerima) = refresh TIDAK membantu → suruh Reload extension. */
                        setAutomationProgress({
                            isActive: true, type: 'chatgpt', steps: [], currentStep: 0, totalSteps: 0,
                            status: 'disconnected',
                            extensionStatus: 'disconnected',
                            message: T('ws.ext.putus.tajuk', 'Extension Terputus Sambungan'),
                            details: /context invalidated/i.test(errText)
                                ? T('ws.ext.putus.detailAgentSambung', 'Tab ini perlu di-refresh dulu sebelum sambung run Agent AI.')
                                : T('ext.ralatSambungan', 'SESAAT tidak dapat connect dengan extension. Tekan "Reload" di manage extension, kemudian cuba lagi.')
                        });
                        setChatgptRunning(false);
                        setChatgptProgress({ current: 0, total: 0, label: '' });
                        return; // abort keseluruhan run
                    }
                    console.error(`[ChatGPT] Task failed for ${item.name}:`, result.error);
                    /* ★ Cuba semula SEKALI di hujung barisan (2026-10-24) — hanya ralat sambungan /
                       tiada jawapan. Cubaan kedua yang gagal = gagal muktamad, dilog seperti biasa. */
                    if (!_ulang && bolehCubaSemulaAgent(errText)) {
                        _diulangKemudian = true;
                        barisan.push({ item, ulang: true });
                    }
                    const _notaUlang = _diulangKemudian
                        ? ' — akan dicuba semula automatik di hujung larian'
                        : (_ulang ? ' — cubaan semula automatik juga gagal' : '');
                    working = working.map(p => p.id === item.id
                        ? { ...p, logs: [...(p.logs || []), `ChatGPT error: ${result.error}${_notaUlang}`] }
                        : p
                    );
                } else {
                    // ★ LUBANG 1 — GPT balas TAPI tiada JSON guna (gate tolak / kod-lesen salah / chat lama).
                    //   Dulu direkod "success" kosong senyap → user tak perasan. Sekarang tanda GAGAL jelas.
                    const rawJson = result.data?.rawJson;
                    const promptsObj = result.data?.prompts;
                    const rawHasKeys = rawJson && typeof rawJson === 'object' && Object.keys(rawJson).length > 0;
                    const promptsHasKeys = promptsObj && typeof promptsObj === 'object' && Object.keys(promptsObj).length > 0;

                    // ★ AGENT SAYA — susun ikut RESIPI (tiada AI, tiada kos). Pusingan
                    //   perbualan yang dipilih pelanggan diambil daripada rawTurns.
                    const _agentTurns = Array.isArray(result.data?.rawTurns) ? result.data.rawTurns : [];
                    const _agentRaw = template.agent
                        ? String(
                            _agentTurns[Math.min(template.agent.outputTurn || 0, Math.max(0, _agentTurns.length - 1))]
                            || result.data?.rawText
                            || ''
                        ).trim()
                        : '';

                    /* ★ GAMBAR daripada pusingan bertanda (2026-09-11) — disimpan SEBELUM
                       teks dipadankan, dan BEBAS daripadanya: agent gambar (product sheet /
                       storyboard) selalunya tiada teks untuk dipadankan, dan itu bukan
                       kegagalan. Peraturan (keputusan user): larian yang ada pusingan
                       bertanda MENAMBAH gambar ke kad hingga had 4 tambahan; larian tanpa
                       pusingan bertanda tidak menyentuh gambar tambahan langsung. Extension
                       lama tidak memulangkan `images` → kad diberitahu dengan jelas. */
                    let _imgNota = '';
                    let _imgDisimpan = 0;
                    if (template.agent && _imgTurns.length) {
                        const _imgs = Array.isArray(result.data?.images) ? result.data.images : [];
                        if (!_imgs.length) {
                            _imgNota = '[Sebab] Gambar tidak diterima daripada extension — pastikan extension SESAAT versi terkini dipasang, kemudian Run semula';
                        } else {
                            try {
                                const _hasil = await simpanGambarAgentKeKad({
                                    storage, uid: auth.currentUser.uid, productId: item.id, images: _imgs,
                                    sediaAda: gambarTambahan(item),
                                    bump: (b) => bumpStorageCounter(db, auth.currentUser.uid, b),
                                });
                                _imgDisimpan = _hasil.disimpan;
                                if (_hasil.disimpan) {
                                    working = working.map(p => p.id === item.id ? { ...p, extraImageUrls: _hasil.urls } : p);
                                }
                                _imgNota = `Gambar agent: ${_hasil.disimpan} disimpan (jumlah ${_hasil.urls.length}/${GBR_MAKS_TAMBAHAN} gambar tambahan)`
                                    + (_hasil.ditolak ? ` · ${_hasil.ditolak} TIDAK disimpan — had 5 gambar setiap kad sudah penuh, buang gambar dahulu` : '')
                                    + (_hasil.gagal ? ` · ${_hasil.gagal} gagal dimuat naik` : '');
                                if (!_hasil.disimpan) _imgNota = `[Sebab] ${_imgNota}`;
                            } catch (e) {
                                _imgNota = `[Sebab] Gambar agent gagal disimpan: ${e?.message || e}`;
                            }
                        }
                    }

                    if (template.agent && _agentRaw.length >= 40) {
                        const { applyRecipe, bersihJawapan } = await import('../utils/agentRecipe');
                        /* Nyahescape JSON tak sah (`\n` literal → baris SEBENAR) supaya
                           output kad + raw tersimpan sepadan dgn apa yang pelanggan
                           nampak di Configure. */
                        const _agentRawBersih = bersihJawapan(_agentRaw);
                        const { prompts: mapped, filled, missing, mode, terpotong = [] } = applyRecipe(_agentRawBersih, template.agent);
                        // `mode` (json|text) direkod dalam log — bila resipi dipelajari daripada
                        // satu bentuk tetapi agent membalas dalam bentuk lain, ini yang
                        // mendedahkannya serta-merta (kes sebenar 2026-08-05).
                        const _modeNote = `bentuk jawapan: ${mode === 'json' ? 'JSON' : 'teks'}`;

                        if (!filled) {
                            console.warn(`[AgentSaya] ${item.name}: resipi tak padan apa-apa.`, missing);
                            /* Agent GAMBAR memang tiada teks untuk dipadankan — itu bukan
                               kegagalan bila gambarnya sudah disimpan. Teks kad tidak disentuh. */
                            const _pesan = _imgDisimpan > 0
                                ? `Agent Saya @ ${new Date().toISOString()}: teks tidak dipadankan (${missing.join(', ') || 'tiada field berpadan'}) — ${_modeNote}. Gambar disimpan; teks kad tidak disentuh.`
                                : `Agent GAGAL @ ${new Date().toISOString()}: jawapan tidak padan resipi (${missing.join(', ') || 'tiada field berpadan'}) — ${_modeNote}. Configure semula agent di PRO Studio.`;
                            working = working.map(p => p.id === item.id
                                ? { ...p, logs: [...(p.logs || []), _pesan] }
                                : p);
                        } else {
                            /* Ganti, bukan tampal — lihat gantiPromptsDenganHasil. */
                            const mergedPrompts = gantiPromptsDenganHasil(withDetail(item).prompts, mapped);
                            const _newRawOutput = _agentRawBersih.slice(0, 20000);
                            working = working.map(p => p.id === item.id
                                ? {
                                    ...p,
                                    prompts: mergedPrompts,
                                    rawOutput: _newRawOutput,
                                    sceneCount: template.agent.sceneCount || 1,
                                    /* ★ Penanda enjin (19 Ogos) — kad ini berjalan atas ENJIN
                                       DINAMIK, bukan enjin rasmi 1/2-babak. Tanpa penanda ini,
                                       pemilih enjin jatuh kepada skrip SATU babak dan larian
                                       "3 babak" menghasilkan SIFAR video secara senyap. */
                                    /* ★ PENGHALAAN ENJIN ikut bilangan babak pelanggan.

                                       1-2 babak → enjin SEDIA ADA yang sudah ada dalam extension
                                       pelanggan hari ini (1 babak = AI8SAAT, 2 babak = AI16SAAT).
                                       Sampai pelanggan melalui deploy webapp SAHAJA.

                                       3-5 babak → enjin DINAMIK, yang hanya wujud selepas keluaran
                                       extension v3.9. Borang PRO Studio mengunci 3-5 sehingga itu.

                                       ⛔ JANGAN halakan SEMUA kad ke enjin dinamik — extension
                                       pelanggan belum mengenali kunci itu, dan kunci yang tidak
                                       dikenali menyebabkan larian TERGANTUNG tanpa sebarang ralat
                                       (bukan jatuh balik kepada enjin lama). */
                                    ...(((template.agent.sceneCount || 1) > 2)
                                        ? { flowEngine: 'dinamik' }
                                        : { smartcustomSceneCount: (template.agent.sceneCount || 1) === 2 ? 2 : 1 }),
                                    chatgptUrl: result.data?.chatInstructionUrl || template.gptUrl,
                                    logs: [...(p.logs || []), `Agent Saya berjaya @ ${new Date().toISOString()} — ${filled} field diisi${missing.length ? ` (tiada: ${missing.join(', ')})` : ''} — ${_modeNote}`,
                                        /* Nilai melebihi had panjang enjin (agentRecipe) — dipotong, jadi
                                           pelanggan WAJIB tahu (2026-09-13; dulu dipotong senyap). */
                                        ...(terpotong.length ? [`[Sebab] Teks terlalu panjang — dipotong pada had sistem: ${terpotong.join(', ')} @ ${new Date().toISOString()}`] : [])],
                                }
                                : p);
                            if (item.splitV === 2 || isSplitEnabled()) {
                                primeDetailCache(item.id, { prompts: mergedPrompts, rawOutput: _newRawOutput });
                            }
                        }
                    } else if (template.agent) {
                        console.warn(`[AgentSaya] ${item.name}: jawapan kosong/terlalu pendek.`);
                        /* Jawapan gambar boleh hampir tanpa teks (diukur: 4 aksara) — bila
                           gambarnya sudah disimpan, ini bukan kegagalan. */
                        working = working.map(p => p.id === item.id
                            ? { ...p, logs: [...(p.logs || []), _imgDisimpan > 0
                                ? `Agent Saya @ ${new Date().toISOString()}: jawapan teks kosong (agent gambar) — gambar disimpan; teks kad tidak disentuh.`
                                : `Agent GAGAL @ ${new Date().toISOString()}: jawapan agent kosong atau terlalu pendek.`] }
                            : p);
                    } else if (!rawHasKeys && !promptsHasKeys) {
                        console.warn(`[ChatGPT] ${item.name}: GPT tak pulangkan JSON (kemungkinan gate ditolak).`);
                        working = working.map(p => p.id === item.id
                            ? { ...p, logs: [...(p.logs || []), `ChatGPT GAGAL @ ${new Date().toISOString()}: GPT tak pulangkan JSON (kemungkinan kod/lesen ditolak atau chat lama). Cuba semula.`] }
                            : p
                        );
                    } else {
                        // Apply mapping engine. Untuk N-scene (cth FLOWNITY) guna rawJson (output MENTAH) sebab
                        // normalize lama squash jadi 3-set (gambar/video) → buang babak 3+. Smart Custom (1/2 scene)
                        // kekal guna prompts ternormalize.
                        const sourceJson = (Number(template.sceneCount) >= 3 && rawJson) ? rawJson : (promptsObj || {});
                        const mapped = applyMapping(sourceJson, template.mapping || '', template.sceneCount || 1);
                        /* ★ SPLIT V2: asas = teks PENUH (withDetail; cache dah dihydrate awal).
                           Ganti, bukan tampal — peraturan yang SAMA seperti laluan Agent Saya
                           (arahan user 2026-08-19, susulan). Kesan pada laluan ini: kad yang
                           dahulunya dijana pipeline biasa kemudian di-scrape Smart Custom akan
                           kehilangan medan pipeline yang tidak dihasilkan scrape itu — memang
                           itu yang dikehendaki, kerana kad hendaklah memapar SATU hasil, bukan
                           campuran dua sumber yang mustahil ditelah pelanggan. */
                        const mergedPrompts = gantiPromptsDenganHasil(withDetail(item).prompts, mapped);
                        const _newRawOutput = JSON.stringify(rawJson || promptsObj || {}, null, 2);
                        working = working.map(p => p.id === item.id
                            ? {
                                ...p,
                                prompts: mergedPrompts,
                                // ★ Raw AI Output — simpan JSON MENTAH yang di-scrape (untuk modal "Raw AI Output"/Full Prompt),
                                //   tak kira mapping jadi ke tak. Guna rawJson (penuh) kalau ada, else prompts ternormalize.
                                rawOutput: _newRawOutput,
                                chatgptUrl: result.data?.chatInstructionUrl || template.gptUrl,
                                logs: [...(p.logs || []), `ChatGPT success @ ${new Date().toISOString()}`],
                            }
                            : p
                        );
                        // ★ SPLIT V2: prime cache — teks scrape kekal dipapar selepas feed strip state
                        if (item.splitV === 2 || isSplitEnabled()) {
                            primeDetailCache(item.id, { prompts: mergedPrompts, rawOutput: _newRawOutput });
                        }
                    }
                    /* ★ Nota gambar PRODUK yang dihantar kepada agent (2026-09-13) — SATU baris,
                       hanya bila kad membawa gambar tambahan. Kekurangan = `[Sebab] …` supaya
                       pelanggan nampak (bukan senyap). Larian produk TIDAK dibatalkan kerananya. */
                    const _gbrProduk = template.agent
                        ? ringkasGambarProduk(gambarTambahan(item).length, result.data?.gambarProduk)
                        : null;
                    if (_gbrProduk) {
                        const _gpNota = _gbrProduk.status === 'lama'
                            ? '[Sebab] Gambar tambahan kad TIDAK dihantar kepada agent — extension lama; pasang extension SESAAT versi terkini, kemudian Run semula'
                            : `${_gbrProduk.status === 'kurang' ? '[Sebab] ' : ''}Gambar produk dihantar kepada agent: ${_gbrProduk.dihantar}/${_gbrProduk.dijangka}`
                                + (_gbrProduk.pendua ? ` (${_gbrProduk.pendua} gambar sama dilangkau)` : '')
                                + (_gbrProduk.amaran.length ? ` — ${_gbrProduk.amaran.join(' · ')}` : '');
                        working = working.map(p => p.id === item.id
                            ? { ...p, logs: [...(p.logs || []), `${_gpNota} @ ${new Date().toISOString()}`] }
                            : p);
                    }
                    /* ★ Nota gambar agent — SATU baris log pada kad, tak kira teks padan
                       atau tidak. `[Sebab] …` = gagal (extension lama / had penuh / muat
                       naik gagal) — pelanggan mesti nampak, bukan senyap. */
                    if (_imgNota) {
                        working = working.map(p => p.id === item.id
                            ? { ...p, logs: [...(p.logs || []), `${_imgNota} @ ${new Date().toISOString()}`] }
                            : p);
                    }
                    /* ★ Gambar yang BERJAYA selepas extension mencuba semula (2026-09-13) — satu
                       baris supaya pelanggan faham kenapa perbualan GPT/Gem ada mesej berulang. */
                    const _cubaSemulaNota = template.agent ? ringkasCubaSemulaGambar(result.data?.cubaSemulaGambar) : '';
                    if (_cubaSemulaNota) {
                        working = working.map(p => p.id === item.id
                            ? { ...p, logs: [...(p.logs || []), `${_cubaSemulaNota} @ ${new Date().toISOString()}`] }
                            : p);
                    }
                    /* ★ "Matikan Thinking" (ChatGPT) dipilih tetapi cip masih hidup / tidak
                       dapat disemak (2026-09-13). Dulu SENYAP — robot mencari perkataan
                       "Extended" dan melapor "sudah mati" sebaik ChatGPT menukar label
                       cip kepada "Thinking". Larian tetap diteruskan (jawapan masih
                       berguna), tetapi pelanggan mesti tahu. Extension lama tidak
                       memulangkan keadaan (undefined) → tiada nota. */
                    const _thinkingKeadaan = result.data?.chatgptExtendedUsed;
                    if ((template.platform || 'chatgpt') !== 'gemini' && template.chatgptExtendedOff
                        && typeof _thinkingKeadaan === 'string' && _thinkingKeadaan !== 'off') {
                        const _sebab = String(result.data?.chatgptThinkingNota || '').trim();
                        working = working.map(p => p.id === item.id
                            ? { ...p, logs: [...(p.logs || []), `[Sebab] Thinking ChatGPT tidak dapat dimatikan${_sebab ? ` (${_sebab})` : ''} — jawapan dijana dengan Thinking hidup @ ${new Date().toISOString()}`] }
                            : p);
                    }
                    /* ★ Tahap Thinking agent (2026-09-26) tidak dapat ditetapkan — larian
                       diteruskan, pelanggan diberitahu pada kad. Skrip lama (tiada
                       chatgptTahapKeadaan) juga dikira gagal: bising, bukan senyap. */
                    if ((template.platform || 'chatgpt') !== 'gemini' && template.chatgptTahap
                        && result.data?.chatgptTahapKeadaan !== 'ok') {
                        const _nota = String(result.data?.chatgptTahapNota || 'extension/skrip lama').trim();
                        working = working.map(p => p.id === item.id
                            ? { ...p, logs: [...(p.logs || []), `[Sebab] Thinking ChatGPT tidak dapat ditetapkan ke "${template.chatgptTahap}" (${_nota}) @ ${new Date().toISOString()}`] }
                            : p);
                    }
                    /* ★ Gemini — prinsip sama (2026-09-13): Extended thinking / model yang
                       dipilih pelanggan tetapi TIDAK aktif pada larian ini. Dulu hanya
                       console.warn dalam tab Gem. `geminiModelSepadan` dikira oleh extension
                       (undefined pada extension lama → tiada nota). */
                    if ((template.platform || 'chatgpt') === 'gemini') {
                        /* ★ 2026-10-11: tahap Thinking Low/Medium/High (Gemini 3) menggantikan
                           Extended hidup/mati — perbandingan + ayat log dalam SATU util yang
                           dikongsi dengan Configure PRO Studio (utils/geminiPemilih.js). */
                        const _nota = [];
                        const _tahapGagal = ayatLogTahapGemini(semakTahapGemini(template.geminiExtended, result.data));
                        if (_tahapGagal) _nota.push(_tahapGagal);
                        if (result.data?.geminiModelSepadan === false) {
                            _nota.push(`[Sebab] Model Gemini "${template.geminiModel || ''}" tidak dapat dipilih — jawapan dijana dengan model "${result.data?.geminiModelUsed || '—'}"`);
                        }
                        if (_nota.length) {
                            const _masa = new Date().toISOString();
                            working = working.map(p => p.id === item.id
                                ? { ...p, logs: [...(p.logs || []), ..._nota.map(n => `${n} @ ${_masa}`)] }
                                : p);
                        }
                    }
                }
            } catch (err) {
                console.error(`[ChatGPT] Unexpected error for ${item.name}:`, err);
                working = working.map(p => p.id === item.id
                    ? { ...p, logs: [...(p.logs || []), `ChatGPT exception: ${err.message}`] }
                    : p
                );
            }

            if (!_diulangKemudian) done++;
            /* ⛔⛔ JANGAN kembalikan `setProducts(working)` / `saveToCloud(working)` (2026-10-13).
               `working` = salinan SEMUA kad semasa Run ditekan. Memulangkannya menimpa apa-apa
               yang ditulis pihak lain selepas itu — robot Flow di browser lain (video, poster,
               status, log, link collection) dan larian Agent di tab kedua — dengan salinan
               lama, senyap (ditangkap hidup: 5 video hilang daripada kad pelanggan). Hanya
               medan yang giliran INI ubah pada kad INI dipulangkan ke state dan ditulis ke
               cloud. Butiran: utils/hasilAgentKad.js + utils/simpanHasilAgent.js. */
            const _hasilGiliran = kiraHasilAgent(_sebelumGiliran, working.find(p => p.id === item.id));
            if (_hasilGiliran) {
                setProducts(prev => prev.map(p => p.id === item.id ? terapHasilAgent(p, _hasilGiliran) : p));
                simpanHasilAgent(auth.currentUser?.uid, item, _hasilGiliran).catch(e => {
                    console.error('[ChatGPT] Save mid-run failed:', e);
                    const _nama = String(item.name || '').slice(0, 40);
                    const _sebab = e?.message || String(e);
                    toast.error(T('ws.agent.toast.simpanGagal', `Hasil agent untuk "${_nama}" tidak dapat disimpan. Sila Run semula produk ini. (${_sebab})`, { nama: _nama, msg: _sebab }));
                });
            }
        }

        setChatgptProgress({ current: done, total: targets.length, label: chatgptStopRef.current ? T('ws.agent.progress.dihentikan', `Dihentikan (${done}/${targets.length})`, { siap: done, jumlah: targets.length }) : T('ws.agent.progress.selesai', `Selesai ${done}/${targets.length}`, { siap: done, jumlah: targets.length }) });
        setTimeout(() => {
            setChatgptRunning(false);
            setChatgptProgress({ current: 0, total: 0, label: '' });
        }, 2500);
    };

    // FLOWNITY — load admin scrape config (modules/flownity.scrapeConfig.{chatgpt|gemini}) + run scrape
    // pada produk selected. Custom GPT / Gem bawa master prompt; kita submit produk je + scrape JSON → card.
    const runFlownityScrape = async (opts) => {
        const sel = products.filter(p => p.selected);
        if (sel.length === 0) { alert(T('ws.flownity.alert.pilihProduk', 'Pilih sekurang-kurangnya satu produk dulu.')); return; }
        const platform = flownityScrapePlatform === 'gemini' ? 'gemini' : 'chatgpt';
        const platformLabel = platform === 'gemini' ? 'Gemini' : 'ChatGPT';
        try {
            const { doc: fsDoc, getDoc } = await import('firebase/firestore');
            const snap = await getDoc(fsDoc(db, 'modules', 'flownity'));
            const data = snap.exists() ? snap.data() : {};
            const cfg = data.scrapeConfig?.[platform] || {};
            if (!cfg.gptUrl) {
                /* ⛔ `platform` = nilai yang dibanding ('gemini'/'chatgpt') — JANGAN sentuh.
                   Nama jenis agen + nama platform kekal sama dalam kedua-dua bahasa. */
                const jenisAgen = platform === 'gemini' ? 'Gem' : 'Custom GPT';
                alert(T('ws.flownity.alert.urlBelumSet', `Admin belum set URL ${jenisAgen} untuk FLOWNITY.\nBuka gear ⚙ FLOWNITY → section "Scrape Agent AI" → pilih ${platformLabel} → isi URL + Simpan.`, { jenisAgen, platform: platformLabel }));
                return;
            }
            let agentUrl = cfg.gptUrl;
            if (platform === 'gemini') {
                // Normalize URL Gem → base /gem/{gemId} sahaja (buang chatId supaya buka chat baru)
                const m = agentUrl.match(/^(https:\/\/gemini\.google\.com\/gem\/[^/?#]+)/);
                if (m) agentUrl = m[1];
            }
            const template = {
                gptUrl: agentUrl,
                platform,
                promptTemplate: cfg.promptTemplate || 'Nama produk: {productName}\nLink produk: {productLink}\n\nKeluarkan output dalam format JSON yang diminta.',
                mapping: cfg.mapping || '',
                sceneCount: data.sceneCount || 5,
                moduleFilter: opts?.moduleFilter,
            };
            // Metering coin FLOWNITY berlaku PER-PRODUK dalam handleRunChatGPT
            // (guard item.moduleId === 'flownity' sebelum setiap trigger scrape).
            await handleRunChatGPT(template);
        } catch (e) {
            console.error('[FLOWNITY] runFlownityScrape failed:', e);
            alert(T('ws.flownity.alert.gagalMula', 'Gagal mula scrape: ' + e.message, { ralat: e.message }));
        }
    };

    /* ★ v4 (v3.9.3) — RUN FACEBOOK REELS (Shopee affiliate).
       Dipanggil oleh butang Run di App.jsx bila Post To = Facebook. Mengumpul
       produk bertick (corak SAMA handleRunTikTok), membina peta video+caption
       setiap set, dan menghantar SESAAT_DIRECT_FACEBOOK ke extension.
       ★ v3.9.4 — CONTENT LIBRARY + MOD (keputusan user 2026-09-11):
         • TIADA lagi URL page — robot buka Content Library, yang mengikut page AKTIF
           dalam browser itu (satu browser = satu page).
         • Mod ikut suis Direct Schedule (SAMA dengan TikTok): HIDUP = post sekarang,
           MATI = simpan DRAF. Larian ikut slot kalendar untuk FB = Fasa M2 (belum dibina).
         • AI label ikut suis Control Panel (lalai hidup).
         • Kedua-duanya dalam `tetapan` = KOTAK TERBUKA (corak TikTok v3.9.3) — tetapan
           larian FB baharu masuk di situ, BUKAN sebagai medan baharu di sebelahnya. */
    /* Link Shopee untuk kad yang belum menyimpannya — dicari di My Products ikut
       link TikTok (retroaktif, fail-open). Dipakai KEDUA-DUA laluan Facebook
       (tick kad + kalendar). Pulang fungsi `shopeeUntuk(kad)`. */
    const petaShopeeMyProducts = async (senaraiKad) => {
        const norml = (u) => String(u || '').trim().toLowerCase();
        const petaShopee = {}; // link → shopeeLink (dari My Products)
        if (senaraiKad.some(p => !p.shopeeLink && p.link)) {
            try {
                const email = auth.currentUser?.email;
                const folderSnap = await getDocs(collection(db, 'library'));
                const snaps = await Promise.all(folderSnap.docs.map(f =>
                    email ? getDocs(query(collection(db, 'library', f.id, 'items'), where('addedBy', '==', email))) : Promise.resolve({ docs: [] })
                ));
                snaps.forEach(snap => snap.docs.forEach(d => {
                    const it = d.data();
                    if (it?.link && it?.shopeeLink) { const k = norml(it.link); if (!petaShopee[k]) petaShopee[k] = it.shopeeLink; }
                }));
            } catch (e) { console.warn('[FB] Gagal baca shopeeLink My Products (diabaikan):', e?.message); }
        }
        return (p) => p.shopeeLink || petaShopee[norml(p.link)] || '';
    };

    /* ★ [2026-09-18] Popup "Facebook Reels dimulakan" TUTUP SENDIRI selepas 5 saat — SAMA
       seperti Flow/TikTok (arahan user). Dahulu ia menunggu isyarat "robot siap"
       (FB_PROGRESS) yang TIDAK PERNAH sampai ke webapp: background menghantarnya melalui
       chrome.runtime.sendMessage sahaja, dan itu tidak sampai ke content script (had Chrome
       — lihat sendToWebappTabs dalam background.ts). Akibatnya popup tersangkut sehingga
       ditutup dengan tangan. Keputusan setiap reel kekal kelihatan pada slot kalendar + kad.
       Hanya popup FB yang masih dalam keadaan "dimulakan" ditutup — popup larian lain yang
       dibuka dalam 5 saat itu tidak disentuh. */
    const tutupPopupFbSelepas5s = () => {
        setTimeout(() => setAutomationProgress((prev) => (
            prev.isActive && prev.type === 'facebook' && prev.status === 'success' ? { ...prev, isActive: false } : prev
        )), 5000);
    };

    /* ============================================================
       ★ [2026-09-16] Run Facebook BACA KALENDAR (Bahagian 4) — cermin
       handleRunTikTokKalendar. Bahagian tulen (pagar FB, rancangan, payload)
       hidup dalam utils/rancanganKalendar.js; di sini hanya state + mesej.
       Set diambil daripada SLOT (bukan pemilih set Control Panel); status
       robot (setStatuses.fb_setN) naik ke slot melalui effect graduasi kerana
       slot dicop `pf:'fb'`. Mod tick kad di bawah KEKAL (keputusan user 13 Sept).
       ============================================================ */
    const handleRunFacebookKalendar = async (kunciTerpilih = null) => {
        const kunciJalan = kunciTerpilih || schedPilih;
        if (!kunciJalan || !kunciJalan.size) {
            alert(T('ws.sched.run.noPilih', 'Sila pilih sekurang-kurangnya satu slot sebelum Run — tick kepala hari untuk pilih semua slot hari itu, atau klik slot satu-satu.'));
            return;
        }
        if (!caraPost) { alert(T('ws.cara.pilihDulu', 'Pilih cara post dahulu (Post sekarang · Jadual · Simpan draf) di Control Panel.')); return; }
        const isian = schedSusunanAktif?.isian || {};
        const petaProduk = new Map(products.map((p) => [p.id, p]));
        let isianServer = null;
        try {
            const svr = await muatSusunanAkaun(auth.currentUser?.uid, schedAkaunAktif);
            isianServer = svr?.isian || null;
        } catch { isianServer = null; }
        const { rancangan, kiraan, langkauLain } = binaRancanganFb({
            isian, kunciJalan, produk: petaProduk, isianServer, sekarang: Date.now(),
            caraPost, groupSemasa: selectedGroupId, akaunId: schedAkaunAktif,
            deps: { adalahTarikh, tarikhKeDate, bezaHariIni },
        });
        if (langkauLain.length) {
            setSchedSusunan((prev) => {
                const su = prev[schedAkaunAktif] || { hariTemplate: {}, isian: {} };
                const isianBaru = { ...(su.isian || {}) };
                langkauLain.forEach(({ k, st, sb }) => { if (isianBaru[k]) isianBaru[k] = { ...isianBaru[k], st, sb }; });
                return { ...prev, [schedAkaunAktif]: { ...su, isian: isianBaru } };
            });
        }
        if (rancangan.length === 0) {
            const sebab = [];
            if (kiraan.jalanLain) sebab.push(T('ws.sched.run.rLain', `${kiraan.jalanLain} slot dilangkau — sudah dijalankan oleh browser lain`, { n: kiraan.jalanLain }));
            if (kiraan.tiadaVideo) sebab.push(T('ws.sched.run.rVideo', `${kiraan.tiadaVideo} slot belum ada video (jalankan Flow dahulu)`, { n: kiraan.tiadaVideo }));
            if (kiraan.terlepas) sebab.push(T('ws.fb.run.rMasa', `${kiraan.terlepas} slot waktunya sudah terlalu hampir (kurang 30 minit)`, { n: kiraan.terlepas }));
            if (kiraan.lepasHad) sebab.push(T('ws.fb.run.rHad', `${kiraan.lepasHad} slot melepasi had ${HAD_HARI_FB} hari`, { n: kiraan.lepasHad, had: HAD_HARI_FB }));
            if (kiraan.tiadaProduk) sebab.push(T('ws.sched.run.rProduk', `${kiraan.tiadaProduk} slot produknya sudah tiada`, { n: kiraan.tiadaProduk }));
            if (kiraan.kunciRosak) sebab.push(T('ws.sched.run.rKunci', `${kiraan.kunciRosak} slot tarikhnya tidak difahami — buka semula tab Schedule, kemudian seret video itu sekali lagi`, { n: kiraan.kunciRosak }));
            alert(T('ws.sched.run.noRunnable', 'Tiada slot yang boleh dijalankan pada tarikh yang ditick.') + (sebab.length ? '\n\n' + sebab.join('\n') : ''));
            return;
        }
        if (caraPost === 'now' && rancangan.length !== 1) {
            alert(T('ws.sched.run.nowSatu', `Post sekarang hanya untuk SATU video. Anda tick ${rancangan.length} slot — kekalkan satu sahaja, atau pilih Jadual / Simpan draf.`, { n: rancangan.length }));
            return;
        }

        setIsSaving(true);
        try {
            const ping = await pingExtension();
            if (!ping.alive) {
                setAutomationProgress({
                    isActive: true, type: 'facebook', steps: [], currentStep: 0, totalSteps: 0,
                    status: 'disconnected', extensionStatus: 'disconnected',
                    message: T('ws.run.extDisconnected', 'Extension Terputus Sambungan'),
                    details: T('ws.run.extDisconnectedFb', 'Tab ini perlu di-refresh dulu sebelum boleh start Facebook.'),
                });
                return;
            }
            const _vGate = await checkExtensionVersionGate(ping.version);
            if (_vGate) { setVersionGateModal(_vGate); return; }
            /* Laluan kalendar WAJIB extension yang faham `tetapan` (mod + jadual per set
               + `sets`); extension lama akan TERUS POST semua set. */
            if (!ping.fbTetapan) { alert(T('ws.fb.perluKemasKiniKalendar', 'Run Facebook dari kalendar memerlukan extension SESAAT versi terbaharu. Sila muat turun dan pasang semula extension dari dashboard, kemudian cuba lagi.')); return; }

            const kadTerlibat = [...new Set(rancangan.map((r) => r.pid))].map((id) => petaProduk.get(id)).filter(Boolean);
            /* ★ [2026-09-18] Toggle "Add product" MATI → link Shopee TIDAK dihantar (robot
               FB hanya buka Add product bila link berisi), tiada carian My Products, tiada
               amaran "tiada link Shopee". Link pada kad tidak disentuh. */
            const addProduct = fbAddProductRef.current;
            const shopeeUntuk = addProduct ? await petaShopeeMyProducts(kadTerlibat) : () => '';
            const payload = binaPayloadFb({ rancangan, produk: petaProduk, caraPost, aiLabel: aiLabelAktif !== false, shopeeUntuk });
            const semuaProdukFb = payload.kumpulan.flatMap((k) => k.products);
            const tiadaShopee = semuaProdukFb.filter((p) => !p.shopeeLink).length;
            if (addProduct && tiadaShopee > 0) {
                const teruskan = window.confirm(T('ws.fb.noShopeeWarn', `${tiadaShopee} produk tiada link Shopee — reel akan diterbit TANPA link affiliate. Teruskan?`, { n: tiadaShopee }));
                if (!teruskan) return;
            }
            const dilangkau = kiraan.tiadaVideo + kiraan.terlepas + kiraan.lepasHad + kiraan.tiadaProduk + kiraan.salahMinit;
            if (dilangkau > 0) toast.warning(T('ws.sched.run.skipped', `${dilangkau} slot dilangkau (video belum siap / waktu terlepas). ${rancangan.length} akan dijalankan.`, { n: dilangkau, jalan: rancangan.length }));
            if (kiraan.luarGroup > 0) toast.info(T('ws.sched.run.otherGroup', `${kiraan.luarGroup} daripada slot ini milik produk group lain — ia tetap akan dijalankan.`, { n: kiraan.luarGroup }));

            /* Cop 'running' pada KAD (kunci fb_setN yang robot FB tulis semula + rekod
               per-akaun untuk pil) dan pada SLOT (pf:'fb'). Corak sama Run TikTok. */
            const setIkutProduk = {};
            rancangan.forEach((r) => { (setIkutProduk[r.pid] = setIkutProduk[r.pid] || new Set()).add(r.s); });
            const runIds = new Set(Object.keys(setIkutProduk));
            const namaAkaunLarian = (schedAkaun.find((a) => a.id === schedAkaunAktif)?.nama) || '';
            const updatedProducts = products.map((p) => {
                if (!runIds.has(p.id)) return p;
                const newSetStatuses = { ...(p.setStatuses || {}) };
                let petaAkaun = p.setStatusAkaun || {};
                setIkutProduk[p.id].forEach((s) => {
                    newSetStatuses[`fb_${s}`] = 'running';
                    petaAkaun = gabungStatusAkaun(petaAkaun, s, schedAkaunAktif, { st: 'running', sb: '', md: caraPost === 'now' ? 'now' : '', pf: 'fb', nama: namaAkaunLarian, masa: Date.now() });   // ★ 29 Sept md pada kad — lihat laluan TikTok · ★ 3 Nov pf (rekodLarianKad.js)
                });
                return { ...p, setStatuses: newSetStatuses, setStatusAkaun: petaAkaun };
            });
            setProducts(updatedProducts);
            await saveProducts(auth.currentUser.uid, updatedProducts.filter((p) => runIds.has(p.id)));
            const kunciRun = new Set(rancangan.map((r) => r.k));
            setSchedSusunan((prev) => {
                const su = prev[schedAkaunAktif] || { hariTemplate: {}, isian: {} };
                const isianBaru = { ...(su.isian || {}) };
                kunciRun.forEach((k) => { if (isianBaru[k]) isianBaru[k] = { ...isianBaru[k], st: 'running', sb: '', pf: 'fb', md: caraPost === 'now' ? 'now' : '' }; });   // ★ 27 Sept md — lihat laluan TikTok
                return { ...prev, [schedAkaunAktif]: { ...su, isian: isianBaru } };
            });
            if (schedServerOkRef.current && auth.currentUser?.uid) {
                flushSimpanan(auth.currentUser.uid, schedAkaunAktif, schedSusunan[schedAkaunAktif], schedRefDisimpan);
            }

            /* ⛔ Extension 3.9.4 (dilepaskan 16 Sept 21:18) mengulang SEMUA targetSets pada
               setiap produk dan tidak mengenali `sets` — jadi payload dipecah ikut
               kumpulan set yang sama tepat (lihat rancanganKalendar.js). Lazimnya SATU
               kumpulan; bila lebih, dihantar berturutan dan extension menyusun giliran
               (`robotMulaAtauBeratur` — larian kedua beratur, bukan ditolak). */
            console.log(`[FB] ★ Menghantar DIRECT FACEBOOK (kalendar): ${semuaProdukFb.length} produk, ${rancangan.length} reel, ${payload.kumpulan.length} kumpulan, mode=${payload.tetapan.mode}, addProduct=${addProduct}, laluan=${fbLaluanRef.current}`);
            /* ★ [2026-09-27] `payload.tetapan.captionKosongSengaja` (binaPayloadFb) ikut sama ke skrip. */
            if (payload.tetapan.captionKosongSengaja?.length) console.log(`[FB] [Tetapan pelanggan] Caption Facebook SENGAJA dikosongkan (post tanpa caption, semakan senarai dilangkau): ${payload.tetapan.captionKosongSengaja.join(', ')}`);
            payload.kumpulan.forEach((kump, i) => {
                const hantar = () => window.postMessage({
                    type: 'SESAAT_DIRECT_FACEBOOK',
                    /* ★ [2026-09-18] `addProduct` = niat pelanggan (kotak terbuka). Robot kini
                       melangkau Add product kerana link kosong; medan ini untuk rekod/log. */
                    tetapan: { ...payload.tetapan, addProduct, laluan: fbLaluanRef.current },
                    products: kump.products,
                    targetSets: kump.targetSets,
                    pageUrl: 'https://www.facebook.com/professional_dashboard/content/content_library',
                    ctaText: ctaTeksLarian || '',
                    uid: auth.currentUser?.uid,
                }, '*');
                if (i === 0) hantar(); else setTimeout(hantar, 1500 * i);
            });
            setAutomationProgress((prev) => ({
                ...(prev || {}), isActive: true, type: 'facebook', steps: [], currentStep: 0, totalSteps: 0, status: 'success',
                message: T('ws.fb.started', '🎬 Facebook Reels dimulakan!'),
                details: T('ws.fb.run.startedDetail', `${rancangan.length} reel dihantar ke Extension — robot membuka Content Library Facebook dan mengikut waktu setiap slot. Jangan tutup tab itu.`, { n: rancangan.length }),
            }));
            tutupPopupFbSelepas5s();
        } finally {
            setIsSaving(false);
        }
    };

    const handleRunFacebook = async () => {
        /* ★ [2026-09-16] Di tab Schedule (mod kalendar), Run Facebook baca KALENDAR —
           sama seperti Run TikTok. Di tab lain ia baca kad bertick seperti biasa. */
        if (schedMode) return handleRunFacebookKalendar();

        const fbSpaceProducts = selectedSpaceId === 'default'
            ? products.filter(p => !(p.spaceId || p.groupId) || p.spaceId === 'default' || p.groupId === 'default')
            : products.filter(p => p.spaceId === selectedSpaceId || p.groupId === selectedSpaceId);

        /* ★ FB baca kad BERTICK dalam group semasa — TIADA tapisan tab (flow/tiktok)
           seperti TikTok, kerana FB bukan marking kad; pengguna tick kad, ia dipost.
           Kalendar TIDAK diguna (FB tiada jadual). */
        const productsToRun = fbSpaceProducts.filter(p => {
            if (!p.selected) return false;
            if (selectedGroupId === 'all') return true;
            return (p.workspaceGroup || 'Workspace') === selectedGroupId;
        });
        if (productsToRun.length === 0) {
            alert(T('ws.tiktok.noneSelected', "Tiada produk dipilih untuk dijalankan."));
            return;
        }

        const sortedSets = [...tiktokTargetSets].sort();

        /* ★ v4 — KAD LAMA TERIMA LINK SHOPEE DARI MY PRODUCTS.
           Kad yang di-pull SEBELUM medan shopeeLink wujud tiada link tersimpan. Di sini,
           kad bertick yang tiada shopeeLink tetapi ada `link` (URL TikTok — SAMA dengan
           item My Products) → ambil shopeeLink dari My Products, padan ikut link. Retroaktif:
           pelanggan tak perlu buat apa-apa tambahan. Fail-open: kalau bacaan gagal, larian
           teruskan dengan apa yang ada pada kad.
           ★ [2026-09-18] Toggle "Add product" MATI → link Shopee TIDAK dihantar (robot FB
           hanya buka Add product bila link berisi), tiada carian My Products, tiada
           amaran, tiada tulisan link ke kad. Link sedia ada pada kad tidak disentuh. */
        const addProduct = fbAddProductRef.current;
        const shopeeUntuk = addProduct ? await petaShopeeMyProducts(productsToRun) : () => '';

        // Bina payload: hanya set yang MEMANG ada video disertakan.
        const productData = [];
        const captionKosongSengaja = [];   // ★ [2026-09-27] untuk log robot "[Tetapan pelanggan]" (namaFailReelFb)
        let tiadaShopee = 0;
        const shopeeBaru = {}; // id → shopeeLink diambil dari My Products (untuk disimpan ke kad)
        for (const p of productsToRun) {
            const videos = {};
            const captions = {};
            for (const setKey of sortedSets) {
                const vurl = p.prompts?.[setKey]?.uploadedVideo;
                if (vurl) {
                    videos[setKey] = vurl;
                    captions[setKey] = captionUntukFb(p.prompts?.[setKey]);   // ★ [2026-09-16] caption FB kalau diisi, kalau tidak TikTok
                    if (fbKosongSengaja(p.prompts?.[setKey])) captionKosongSengaja.push(namaFailReelFb(p.name || '', setKey));
                }
            }
            if (Object.keys(videos).length === 0) { continue; }
            const sLink = shopeeUntuk(p);
            if (!sLink) tiadaShopee++;
            else if (!p.shopeeLink) shopeeBaru[p.id] = sLink; // diambil dari My Products
            productData.push({
                id: p.id,
                name: p.name || '',
                shopeeLink: sLink,
                videos,
                captions
            });
        }

        if (productData.length === 0) {
            alert(T('ws.fb.noVideo', "Tiada video sedia untuk produk yang dipilih. Jalankan Run Flow dahulu untuk menghasilkan video."));
            return;
        }

        /* ★ v3.9.4 — PRA-TERBANG (dulu FB menghantar arahan tanpa menyemak extension
           langsung). Mod draf / AI label mati WAJIB extension yang faham `tetapan` —
           extension lama akan TERUS POST walaupun pelanggan meminta simpan draf. */
        /* ★ [2026-09-16] Cara post daripada pemilih Control Panel. Tick kad tiada waktu →
           "Jadual" hanya dari kalendar. Rupa lama (tiada pemilih) ikut suis Direct
           Schedule seperti dahulu. ⚠️ Post sekarang pada tick kad SENGAJA tidak dihadkan
           kepada satu video — itu laluan yang pelanggan sudah guna sejak 7 Sept. */
        if (uiV39 && !caraPost) { alert(T('ws.cara.pilihDulu', 'Pilih cara post dahulu (Post sekarang · Jadual · Simpan draf) di Control Panel.')); return; }
        if (caraPost === 'schedule') { alert(T('ws.fb.jadualKalendar', 'Jadual hanya dari tab Schedule — di sini tiada waktu untuk dijadualkan. Pergi ke tab Schedule dan tick slot, atau pilih Post sekarang / Simpan draf.')); return; }
        const modeFb = caraPost === 'now' ? 'post' : caraPost === 'draft' ? 'draft' : (directSchedule ? 'post' : 'draft');
        const aiLabelFb = aiLabelAktif !== false;
        const ping = await pingExtension();
        if (!ping.alive) {
            setAutomationProgress({
                isActive: true, type: 'facebook', steps: [], currentStep: 0, totalSteps: 0,
                status: 'disconnected', extensionStatus: 'disconnected',
                message: T('ws.run.extDisconnected', 'Extension Terputus Sambungan'),
                details: T('ws.run.extDisconnectedFb', 'Tab ini perlu di-refresh dulu sebelum boleh start Facebook.'),
            });
            return;
        }
        const _vGate = await checkExtensionVersionGate(ping.version);
        if (_vGate) { setVersionGateModal(_vGate); return; }
        if ((modeFb !== 'post' || !aiLabelFb) && !ping.fbTetapan) {
            alert(T('ws.fb.perluKemasKini', 'Simpan draf dan pilihan AI label untuk Facebook memerlukan extension SESAAT versi terbaharu. Sila muat turun dan pasang semula extension dari dashboard, kemudian cuba lagi.'));
            return;
        }

        // Amaran (bukan halangan) bila ada produk tanpa link Shopee — reel akan
        // diterbit tanpa label "Commission eligible". Tiada amaran bila pelanggan
        // sendiri mematikan Add product.
        if (addProduct && tiadaShopee > 0) {
            const teruskan = window.confirm(T('ws.fb.noShopeeWarn',
                `${tiadaShopee} produk tiada link Shopee — reel akan diterbit TANPA link affiliate. Teruskan?`,
                { n: tiadaShopee }));
            if (!teruskan) return;
        }

        // Simpan link Shopee yang baru diambil dari My Products ke kad (best-effort):
        // supaya kad memaparkannya + larian seterusnya tidak perlu lookup lagi.
        const idsBaru = Object.keys(shopeeBaru);
        if (idsBaru.length > 0) {
            const setBaru = new Set(idsBaru);
            setProducts(prev => prev.map(p => setBaru.has(p.id) ? { ...p, shopeeLink: shopeeBaru[p.id] } : p));
            try {
                const changed = productsToRun.filter(p => setBaru.has(p.id)).map(p => ({ ...p, shopeeLink: shopeeBaru[p.id] }));
                await saveProducts(auth.currentUser.uid, changed);
                console.log(`[FB] ${idsBaru.length} kad terima link Shopee dari My Products`);
            } catch (e) { console.warn('[FB] Gagal simpan shopeeLink ke kad (diabaikan):', e?.message); }
        }

        /* ★ [2026-11-03] Override: run tick card FB menulis pil card (akaun kalendar yang dibuka) —
           larian terakhir menang, keputusan user. Corak SAMA laluan kalendar: cop fb_setN 'running'
           (hasil robot lama tak naik taraf pil serta-merta) + rekod pil pf 'fb'. Naik taraf bila
           robot siap: rekodLarianKad.js. Diletak SELEPAS simpanan shopeeLink di atas dan membawa
           shopeeLink itu: dua simpanan dari objek basi saling menindih. */
        const setFbIkut = new Map(productData.map((d) => [d.id, Object.keys(d.videos)]));
        const namaAkaunFb = (schedAkaun.find((a) => a.id === schedAkaunAktif)?.nama) || '';
        const cop = (p) => {
            const sets = setFbIkut.get(p.id);
            if (!sets) return p;
            const ss = { ...(p.setStatuses || {}) };
            sets.forEach((s) => { ss[`fb_${s}`] = 'running'; });
            return {
                ...p, ...(shopeeBaru[p.id] ? { shopeeLink: shopeeBaru[p.id] } : {}), setStatuses: ss,
                setStatusAkaun: petaMulaLarian(p.setStatusAkaun, sets, schedAkaunAktif, { pf: 'fb', md: modeFb === 'post' ? 'now' : '', nama: namaAkaunFb }),
            };
        };
        setProducts((prev) => prev.map(cop));
        try {
            await saveProducts(auth.currentUser.uid, products.filter((p) => setFbIkut.has(p.id)).map(cop));
        } catch (e) {
            console.warn('[FB] Gagal simpan status card:', e?.message);
            toast.warning(T('ws.fb.statusTakSimpan', 'Status card tidak dapat disimpan — Facebook tetap dijalankan. Semak status card selepas larian.'));
        }

        console.log(`[FB] ★ Menghantar DIRECT FACEBOOK: ${productData.length} produk, sets=[${sortedSets.join(', ')}], mode=${modeFb}, aiLabel=${aiLabelFb}, addProduct=${addProduct}, laluan=${fbLaluanRef.current}`);
        if (captionKosongSengaja.length) console.log(`[FB] [Tetapan pelanggan] Caption Facebook SENGAJA dikosongkan (post tanpa caption, semakan senarai dilangkau): ${captionKosongSengaja.join(', ')}`);
        window.postMessage({
            type: 'SESAAT_DIRECT_FACEBOOK',
            /* ★ [2026-09-27] `captionKosongSengaja` = senarai nama fail reel (namaFailReelFb) yang
               pelanggan SENGAJA kosongkan caption FB — kotak terbuka, sampai ke skrip tanpa ZIP;
               skrip menulisnya dalam log "[Tetapan pelanggan]" setiap reel. */
            tetapan: { mode: modeFb, aiLabel: aiLabelFb, addProduct, laluan: fbLaluanRef.current, captionKosongSengaja },   // ★ [2026-09-18] addProduct = rekod niat; link kosong yang melangkau
            products: productData,
            targetSets: sortedSets,
            // ⚠️ Untuk extension 3.9.3 SAHAJA (ia masih perlukan URL untuk membuka tab).
            //    Extension 3.9.4 mengabaikannya dan membuka Content Library sendiri.
            pageUrl: 'https://www.facebook.com/professional_dashboard/content/content_library',
            ctaText: ctaTeksLarian || '',   // ★ v4 — CTA beg kuning → "Link name" FB
            uid: auth.currentUser?.uid
        }, '*');

        setAutomationProgress(prev => ({
            ...(prev || {}),
            isActive: true,
            type: 'facebook',
            steps: [],
            currentStep: 0,
            totalSteps: 0,
            status: 'success',
            message: T('ws.fb.started', "🎬 Facebook Reels dimulakan!"),
            details: modeFb === 'draft'
                ? T('ws.fb.startedDetailDraft', "Robot membuka Content Library Facebook dan menyimpan reel sebagai draf. Jangan tutup tab itu.")
                : T('ws.fb.startedDetail', "Robot membuka Content Library Facebook dan memuat naik reel. Jangan tutup tab itu.")
        }));
        tutupPopupFbSelepas5s();
    };

    /* ★ GATE beg kuning (2026-10-06) — butang popup menjalankan SEMULA Run TikTok dengan pilihan
       pelanggan. Dipanggil melalui ref supaya memakai fungsi Run TERKINI (state semasa), bukan
       closure render semasa popup dibuka. Popup ditutup DAHULU; larian baharu membawa penanda gate,
       jadi gate tidak muncul kali kedua. Data `gateBeg` disemak sebelum dipakai. */
    const runTikTokRef = useRef({ kalendar: null, tick: null });
    useEffect(() => { runTikTokRef.current = { kalendar: handleRunTikTokKalendar, tick: handleRunTikTok }; });
    const jalankanDariGateBeg = (cara) => {
        const g = gateBeg;
        setGateBeg(null);
        if (!g || !Array.isArray(g.idTiada)) return;
        const pilihan = cara === 'tanpaBeg' ? pilihanGateTanpaBeg() : pilihanGateLangkau(g.idTiada);
        if (g.laluan === 'kalendar') {
            const kunci = cara === 'tanpaBeg' ? g.kunciSemua : g.kunciLain;
            if (!Array.isArray(kunci) || kunci.length === 0) return;
            runTikTokRef.current.kalendar?.(new Set(kunci), pilihan);
        } else {
            runTikTokRef.current.tick?.(pilihan);
        }
    };

    /* ============================================================
       ★ [2026-10-27] RUN PHONE (bulk) — post ke app telefon via WebUSB/ADB.
       ============================================================
       Enjin BULK dari card ditick (corak SAMA handleRunTikTok tick), TAPI:
       · Jalan dalam WEBAPP (WebUSB), bukan extension/userScript.
       · Di tab Schedule, slot kalendar yang dipilih menang (set slot itu, ikut
         susunan masa), corak SAMA handleRunTikTok. Tiada slot dipilih = card ditick.
         Masa slot diabaikan: telefon post sekarang, sama seperti Post sekarang TikTok.
       · "Boleh jalan sekarang" = hantar SEMUA video card ditick ke telefon +
         buka app sekali. Auto-post hands-off (isi caption/produk + terbit) =
         fasa seterusnya (kena ukur UI Shopee).
       · Telefon disambung dahulu di page Setup/Test (grant sekali); di sini
         `reconnect()` senyap. Belum setup → minta user buka Setup/Test.
       Kegagalan BISING: kira video berjaya/gagal, lapor. */
    const handleRunPhone = async (kunciTerpilih = null) => {
        // 1. Card ditick dalam space/group/tab semasa (corak handleRunTikTok).
        const spaceProducts = selectedSpaceId === 'default'
            ? products.filter(p => !(p.spaceId || p.groupId) || p.spaceId === 'default' || p.groupId === 'default')
            : products.filter(p => p.spaceId === selectedSpaceId || p.groupId === selectedSpaceId);
        const toRun = spaceProducts.filter(p => {
            if (!p.selected) return false;
            if (uiV39 && activeTab !== 'all' && getProductTab(p) !== activeTab) return false;
            if (selectedGroupId === 'all') return true;
            return (p.workspaceGroup || 'Workspace') === selectedGroupId;
        });
        // ★ [2026-11-04] App skrin-boleh-dibaca (TikTok — video/gambar/text, DRAFT sahaja) →
        //   enjin sendiri utils/phoneRunDump.js. Laluan Shopee di bawah TIDAK berubah.
        {
            let idPilih = 'shopee';
            try { idPilih = localStorage.getItem('sesaat_phone_app_v1') || 'shopee'; } catch { /* storan ditutup */ }
            const appPilih = cariPhoneApp(idPilih);
            if (appPilih.ready && appPilih.engine === 'dump') {
                await jalanPhoneDump({
                    toRun, app: appPilih, ctlRef: phoneCtlRef, stopRef: phoneStopRef,
                    setAutomationProgress, tulisStatusAkaunKad, cerminStatusKeSlot, akaunId: schedAkaunAktif || '',
                    ctaText: ctaTeksLarian || '', // CTA beg kuning TikTok + "Link name" FB
                });
                return;
            }
        }
        // 2. Senarai video: SATU video per card (post telefon = 1 card → 1 post).
        //    Ambil set PERTAMA yang ada video (set1 → set2 → set3). TIDAK lagi
        //    darab ikut `tiktokTargetSets` (pemilih Set TikTok) — Control Panel
        //    phone tiada pemilih Set, jadi fallback lama ['set1','set2','set3']
        //    menghantar 3 video senyap per card. productId disimpan untuk
        //    peringkat seterusnya (caption + tag produk dari card).
        const SET_ORDER = ['set1', 'set2', 'set3'];
        const vids = [];
        const videoSet = (p, sk, url) => ({
            name: p.name || p.id, setKey: sk, url, productId: p.id,
            // caption = kotak Facebook Caption set itu (captionUntukPhone);
            // link produk = shopeeLink (link affiliate Shopee) → fallback link.
            caption: captionUntukPhone(p.prompts?.[sk]),
            productLink: (p.shopeeLink || p.link || '').trim(), // bukan link Shopee → runner gagal jelas
        });
        const kunciJalan = kunciTerpilih || schedPilih; // kunciTerpilih = Retry
        const guna = !!kunciTerpilih || (schedMode && schedPilih.size > 0);
        let slotTiadaVideo = 0, sudahJalan = 0;
        /* Elak post berganda. Lebih ketat daripada TikTok: slot siap/tak pasti tak dijalankan
           semula walau browser ini sendiri yang jalankan, kerana Shopee tak boleh ditarik
           balik. Nak ulang: kosongkan status slot dahulu (aliran sama Run TikTok → Run FB).
           ★ [2026-11-03] Override (keputusan user): hanya larian SHOPEE yang menghalang —
           status FB/TikTok pada card/slot yang sama tidak lagi menolak. Peraturan:
           sudahMasukShopee (utils/androidPostCheck.js). */
        const tandaSp = (p, sk) => p?.setStatuses?.[`sp_${sk}`] || '';
        if (guna) {
            let isianServer = null;
            try { isianServer = (await muatSusunanAkaun(auth.currentUser?.uid, schedAkaunAktif))?.isian || null; } catch { isianServer = null; }
            const isian = schedSusunanAktif?.isian || {};
            const petaProduk = new Map(products.map((p) => [p.id, p]));
            [...kunciJalan]
                .filter((k) => isian[k])
                .sort((a, b) => {
                    const pa = String(a).split('_'); const pb = String(b).split('_');
                    return String(pa.slice(0, -1).join('_')).localeCompare(pb.slice(0, -1).join('_')) || Number(pa.pop()) - Number(pb.pop());
                })
                .forEach((k) => {
                    const e = isian[k];
                    const p = petaProduk.get(e.pid || e.p?.id);
                    if (sudahMasukShopee({ tanda: tandaSp(p, e.s), slot: e, slotServer: isianServer?.[k] })) { sudahJalan++; return; }
                    const url = p?.prompts?.[e.s]?.uploadedVideo;
                    if (p && typeof url === 'string' && /^https?:\/\//.test(url)) vids.push(videoSet(p, e.s, url));
                    else slotTiadaVideo++;
                });
        } else toRun.forEach(p => {
            const pr = p.prompts || {};
            for (const sk of SET_ORDER) {
                const url = pr[sk]?.uploadedVideo;
                if (typeof url === 'string' && /^https?:\/\//.test(url)) {
                    if (sudahMasukShopee({ tanda: tandaSp(p, sk), rekodKad: statusAkaunDibuka(p, sk, schedAkaunAktif) })) sudahJalan++;
                    else vids.push(videoSet(p, sk, url));
                    break;
                }
            }
        });
        if (!vids.length) {
            alert(sudahJalan
                ? `${sudahJalan} card atau slot sudah di-post ke Shopee (atau sedang dihantar / belum pasti). Kosongkan statusnya dahulu kalau mahu post semula.`
                : T('ws.phone.noVideo', 'Tiada video pada card atau slot yang dipilih. Pilih card atau slot yang ada video dahulu.'));
            return;
        }
        // 3. App dipilih di Control Panel (simpanan per-browser).
        let appIdSel = 'shopee';
        try { appIdSel = localStorage.getItem('sesaat_phone_app_v1') || 'shopee'; } catch { /* storan ditutup */ }
        const app = cariPhoneApp(appIdSel);
        if (!app.ready) { alert(`${app.label} belum sedia untuk phone automation.`); return; }
        // Semak sebelum mula (corak gate beg kuning TikTok): card yang pasti gagal diberitahu
        // sekarang, bukan selepas dua minit robot berjalan.
        const masalah = vids.map((v) => ({ v, sebab: masalahIsiPost(v) })).filter((x) => x.sebab);
        if (masalah.length) {
            const senarai = masalah.map((x) => `• ${x.v.name}: ${x.sebab}`).join('\n');
            if (masalah.length === vids.length) { alert(`Tiada card yang boleh dijalankan:\n${senarai}`); return; }
            if (!window.confirm(`${masalah.length} card akan dilangkau:\n${senarai}\n\nTeruskan card yang lain?`)) return;
            vids.splice(0, vids.length, ...vids.filter((v) => !masalahIsiPost(v)));
        }
        // Popup progress SAMA Flow/TikTok/FB. Ia menutup skrin, jadi butang tak boleh
        // ditekan dua kali sepanjang larian.
        const tutupProgress = () => setAutomationProgress((prev) => ({ ...prev, isActive: false }));
        phoneStopRef.current = false;
        setAutomationProgress({
            isActive: true, type: 'phone', status: 'running', currentStep: 0, totalSteps: 1,
            steps: [{ label: 'Connecting to your phone', status: 'running' }],
            message: `Posting ${vids.length} video to ${app.label}`, details: 'Starting the robot…', extensionStatus: 'unknown',
        });
        // 4. Sambung telefon (grant dari Setup/Test). reconnect = tiada pemilih.
        if (!phoneCtlRef.current) phoneCtlRef.current = new AndroidController(() => {}, () => {});
        const ctl = phoneCtlRef.current;
        try {
            await ctl.reconnect();
            await ctl.getDeviceInfo(); // perlu serial (peta telefon) + saiz skrin
        } catch (e) {
            tutupProgress();
            if (e?.code === 'NO_GRANTED') {
                alert('Telefon belum di-setup pada browser ini. Buka "Set up & test your phone" dahulu untuk sambung + kalibrasi telefon sekali, kemudian Run semula.');
            } else {
                alert('Tak dapat sambung telefon: ' + (e?.message || e));
            }
            return;
        }
        const serial = ctl.info?.serial || ctl.device?.serial || '';
        // 4b. Gate: telefon mesti dah "ready" (lulus Test kalibrasi) — kalau tidak,
        //     peta tiada → robot akan teraba-raba. Minta Test dahulu.
        const defaultTelefon = await loadAdminDefault(appIdSel);
        if (!phoneReady(appIdSel, serial, defaultTelefon.version)) {
            tutupProgress();
            alert(`Telefon ini belum dikalibrasi untuk ${app.label}.\n\nBuka "Set up & test your phone", tekan "Run test" sekali (ia simpan sebagai Draft, tak terbit) sampai nampak "Phone ready ✅", kemudian Run semula di sini.`);
            return;
        }
        // 4c. Mod post ikut pilihan "How to post" Control Panel (now → post, draft → draft).
        let route = 'draft';
        try { route = localStorage.getItem('sesaat_phone_route_v1') || 'draft'; } catch { /* storan ditutup */ }
        const mode = route === 'now' ? 'post' : 'draft';

        // 5. Per card: transfer video → jalankan resipi penuh (auto-post / draft).
        //    Jaring Draft dalam runner: gagal lepas skrin post → simpan Draft.
        let terbit = 0, draf = 0; const gagal = []; const drafTakLengkap = [];
        /* Status guna penulis SEDIA ADA TikTok/FB: kad dahulu, kemudian slot. Posted = complete + md now.
           ★ [2026-11-03] pf 'sp' = pil card tahu larian terakhir ialah Shopee; sp = catatan
           tersembunyi Shopee (pintu elak post berganda) — ditulis walau tiada akaun kalendar. */
        const rekodStatus = (v, st, sb = '') => ({ pid: v.productId, s: v.setKey, akaunId: schedAkaunAktif || '', st, sb, md: mode === 'post' ? 'now' : '', pf: 'sp', sp: st });
        const catatStatus = (v, st, sb = '') => {
            const rekod = [rekodStatus(v, st, sb)];
            tulisStatusAkaunKad(rekod);
            if (schedAkaunAktif) cerminStatusKeSlot(rekod);
        };
        const rekodRun = vids.map((v) => rekodStatus(v, 'running'));
        tulisStatusAkaunKad(rekodRun);
        if (schedAkaunAktif) {
            cerminStatusKeSlot(rekodRun);
            const pasangan = new Set(vids.map((v) => `${v.productId}__${v.setKey}`));
            setSchedSusunan((prev) => {
                const su = prev[schedAkaunAktif];
                if (!su?.isian) return prev;
                const isianBaru = { ...su.isian };
                Object.keys(isianBaru).forEach((k) => {
                    const e = isianBaru[k];
                    if (e && pasangan.has(`${e.pid || e.p?.id}__${e.s}`)) isianBaru[k] = { ...e, pf: 'sp' };
                });
                return { ...prev, [schedAkaunAktif]: { ...su, isian: isianBaru } };
            });
        }
        const labelStep = recipeFor(appIdSel).steps.map((s) => s.labelEn);
        const statusStep = { running: 'running', pass: 'done', healed: 'done', error: 'error' };
        let dihentikan = 0;
        for (let i = 0; i < vids.length; i++) {
            if (phoneStopRef.current) {
                dihentikan = vids.length - i;
                // SATU tulisan (bukan satu per card): tulisan serentak saling menindih.
                const rekodHenti = vids.slice(i).map((x) => rekodStatus(x, ''));
                tulisStatusAkaunKad(rekodHenti);
                if (schedAkaunAktif) cerminStatusKeSlot(rekodHenti);
                break;
            }
            const v = vids[i];
            const steps = [{ label: 'Send video to phone', status: 'running' }, ...labelStep.map((label) => ({ label, status: 'pending' }))];
            const paparStep = () => setAutomationProgress((prev) => ({
                ...prev, steps: steps.map((st) => ({ ...st })), totalSteps: steps.length,
                details: `Card ${i + 1} of ${vids.length}: ${v.name}`,
            }));
            paparStep();
            try {
                const res = await fetch(v.url);
                if (!res.ok) throw new Error('muat turun gagal');
                const blob = await res.blob();
                if (!blob || !blob.size) throw new Error('video kosong');
                const dest = phoneVideoDest(v.name, v.productId, v.setKey);
                await ctl.pushVideo(blob, dest, () => {});
                await ctl.mediaScan(dest);
                steps[0].status = 'done';
                paparStep();
                const r = await runRecipe(ctl, {
                    appId: appIdSel, serial, mode,
                    params: { caption: v.caption, productLink: v.productLink, videoDest: dest },
                }, {
                    onLog: () => {},
                    onStep: (st) => {
                        if (!steps[st.index + 1]) return;
                        steps[st.index + 1].status = statusStep[st.status] || 'pending';
                        paparStep();
                    },
                });
                if (r.status === 'done') { terbit++; catatStatus(v, 'complete'); }
                else if (r.status === 'draft_saved') { draf++; catatStatus(v, 'draft'); }
                else if (r.draftSaved) {
                    const kurang = (r.belumSiap || []).join(', ') || 'isi';
                    drafTakLengkap.push(`${v.name}: belum disahkan ${kurang} (${r.reason || 'gagal'})`);
                    catatStatus(v, 'draft', `Tidak lengkap: ${kurang}`);
                }
                // Post ditekan tapi tak disahkan: mungkin dah naik, Run semula boleh jadi post berganda.
                else if (r.failedAt === 'finish') {
                    gagal.push(`${v.name}: post tak dapat disahkan, semak profil Shopee sebelum Run semula (${r.reason})`);
                    catatStatus(v, 'uncertain', r.reason || '');
                } else {
                    gagal.push(`${v.name}: ${r.reason || 'gagal'}`);
                    catatStatus(v, 'failed', r.reason || 'gagal');
                }
            } catch (err) {
                gagal.push(`${v.name}: ${err?.message || err}`);
                catatStatus(v, 'failed', String(err?.message || err));
            }
        }
        // 6. Laporan jujur (bising — tak senyap).
        const baris = [];
        if (terbit) baris.push(`✅ ${terbit} post terbit ke ${app.label}.`);
        if (draf) baris.push(`📝 ${draf} disimpan sebagai Draft (buka ${app.label} → Me → Drafts untuk terbit sendiri).`);
        if (sudahJalan) baris.push(`ℹ️ ${sudahJalan} dilangkau: sudah di-post ke Shopee.`);
        if (masalah.length) baris.push(`⚠️ ${masalah.length} dilangkau: maklumat card tak lengkap.`);
        if (dihentikan) baris.push(`⏹️ Dihentikan: ${dihentikan} belum dijalankan.`);
        if (slotTiadaVideo) baris.push(`⚠️ ${slotTiadaVideo} slot dilangkau: tiada video.`);
        if (drafTakLengkap.length) baris.push(`⚠️ ${drafTakLengkap.length} Draft TIDAK lengkap. Lengkapkan dahulu sebelum terbit:\n` + drafTakLengkap.join('\n'));
        if (gagal.length) baris.push(`⚠️ ${gagal.length} gagal: ` + gagal.slice(0, 5).join(' · ') + (gagal.length > 5 ? ' …' : ''));
        if (!baris.length) baris.push('Tiada apa diproses.');
        setAutomationProgress((prev) => ({
            ...prev, steps: [], totalSteps: 0, details: baris.join('\n'), message: 'Phone posting finished',
            status: gagal.length || drafTakLengkap.length ? 'error' : 'success',
        }));
    };

    useImperativeHandle(ref, () => ({
        handleRunFlow,
        handleRunTikTok,
        handleRunFacebook,
        handleRunPhone,
        handleBulkImport,
        /* Control Panel Agent AI (v3.9) — panel di App.jsx menekan butang
           melalui tiga pintu ini. Penapis module dihantar dari SINI, bukan
           dari panel, supaya peraturan "suis Smart menentukan kad mana"
           hidup di tempat yang sama dengan laluan larian. */
        setSmartAgent: changeSmartAgent,
        setFlownityPlatform: changeFlownityScrapePlatform,
        runAgentPanel: (smart) => (smart
            ? runSmartAgent({ moduleFilter: 'smartcustom' })
            : runFlownityScrape({ moduleFilter: 'flownity' })),
        // ★ v3.0.0 Fasa 6: Group state exposed to App.jsx
        getGroups: () => groups,
        getSelectedGroupId: () => selectedGroupId,
        setSelectedGroupId: switchGroup,
        createGroup: (name) => handleCreateGroup(name, false),
        renameGroup: handleRenameGroup,
        deleteGroup: handleDeleteGroup,
        getGroupProductCount: (name) => products.filter(p => p.workspaceGroup === name).length,
    }));

    /* ★ Module yang boleh duduk dalam tab Agent AI (id 'chatgpt') — 2026-10-25.
       Dahulu "Mark Agent AI" memindahkan SEMUA kad bertick bila salah satu
       Smart Custom / FLOWNITY, jadi kad AI8SAAT / AI16SAAT ikut terbawa,
       hilang dari tab Flow, dan tidak pernah dijalankan (Run Agent AI
       menapis module). Senarai ini dipakai OLEH butang dan handleMarkAs.
       ⚠️ KEMBAR: `getProductTab` memaksa module yang sama ke tab 'chatgpt'. */
    // 'blank' (2026-11-02) = kad kosong boleh pindah ke My Agent juga — satu-satunya kad tak
    // terkunci (keputusan user). Routing tab-nya ikut p.tab eksplisit (cabang else getProductTab),
    // jadi senarai ini hanya membuka butang "Mark My Agent" + handleMarkAs untuk kad kosong.
    const MODUL_TAB_AGENT = ['smartcustom', 'flownity', 'blank'];

    // ★ v3.0.0: Mark selected products as Flow or TikTok (replaces Move To)
    const handleMarkAs = async (targetTab) => {
        let selectedProducts = filteredAndSortedProducts.filter(p => p.selected);
        if (selectedProducts.length === 0) return;

        // Tab Agent AI: kad module lain dibiar di tempat asal (masih bertick) + diberitahu.
        let bilDilangkau = 0;
        if (targetTab === 'chatgpt') {
            const bolehPindah = selectedProducts.filter(p => MODUL_TAB_AGENT.includes(p.moduleId));
            bilDilangkau = selectedProducts.length - bolehPindah.length;
            selectedProducts = bolehPindah;
            if (selectedProducts.length === 0) return;
        }

        setIsSaving(true);
        try {
            const selectedIds = new Set(selectedProducts.map(p => p.id));
            const updatedProducts = products.map(p => {
                if (selectedIds.has(p.id)) {
                    return {
                        ...p,
                        tab: targetTab,
                        status: targetTab === 'tiktok' ? 'ready_tiktok' : (p.status === 'ready_tiktok' ? 'generated' : p.status),
                        selected: activeTab === 'all' ? p.selected : false, // Deselect if it will disappear from current tab
                        movedAt: Date.now()
                    };
                }
                return p;
            });
            setProducts(updatedProducts);
            await saveToCloud(updatedProducts);
            if (bilDilangkau > 0) {
                alert(T('ws.pukal.markAgentDilangkau',
                    `${bilDilangkau} card(s) were not moved. Only Smart Custom and FLOWNITY cards can be placed in ${TAB_NAMA.chatgpt}.`,
                    { bil: bilDilangkau, tab: TAB_NAMA.chatgpt }));
            }
        } catch (error) {
            console.error(`Error marking products as ${targetTab}:`, error);
        } finally {
            setIsSaving(false);
        }
    };

    // Legacy aliases for backward compatibility
    const handleMoveToTikTok = () => handleMarkAs('tiktok');
    const handleMoveToFlow = () => handleMarkAs('flow');



    // Archive product to library
    const handleArchiveProduct = async (product) => {
        if (!auth.currentUser) return;
        try {
            // ★ SPLIT V2: hydrate dulu — arkib mesti salinan PENUH self-contained
            //   (collection archivedProducts tidak dipecah). Gagal muat = abort (catch bawah).
            if (needsDetail(product)) await hydrateDetails(product, { throwOnError: true });
            const productFull = withDetail(product);
            const archiveRef = collection(db, 'users', auth.currentUser.uid, 'archivedProducts');
            await addDoc(archiveRef, sanitizeForFirestore({
                ...productFull,
                archivedAt: serverTimestamp(),
                spaceId: product.spaceId || product.groupId,
                spaceName: spaces.find(s => s.id === (product.spaceId || product.groupId))?.name || 'Default',
            }));
            /* ⚠️ Ayat lalai kekal membawa aksara rosak "?" di hadapan (ia memang
               ada dalam kod asal) — rupa LAMA tidak boleh berubah. Versi kamus
               (v3.9) sudah bersih tanpa aksara itu. */
            alert(T('ws.arkib.alert.berjaya', `? "${product.name}" telah diarkibkan!`, { nama: product.name }));
        } catch (error) {
            console.error('Archive Error:', error);
            alert(T('ws.arkib.alert.gagal', '? Gagal mengarkibkan produk.'));
        }
    };

    // Import product from library
    const handleImportFromLibrary = (archivedProduct) => {
        const newProduct = {
            id: `prod_${Date.now()}_${Math.random().toString(36).substring(2, 9)}`,
            originalIndex: products.length + 1,
            name: archivedProduct.name,
            link: archivedProduct.link || '',
            imageBase64: archivedProduct.imageBase64 || null,
            imageUrl: archivedProduct.imageUrl || null,
            localImagePath: archivedProduct.localImagePath || null,
            prompts: archivedProduct.prompts || getEmptyPromptCollection(),
            selectedSets: archivedProduct.selectedSets || ['set1', 'set2', 'set3'],
            logs: [],
            selected: true,
            spaceId: selectedSpaceId === 'default' ? null : selectedSpaceId,
            logicId: archivedProduct.logicId || null,
            tab: archivedProduct.tab || 'flow',
            status: archivedProduct.tab === 'tiktok' ? 'ready_tiktok' : 'generated',
        };
        const updated = [...products, newProduct];
        setProducts(updated);
        saveToCloud(updated);
        alert(T('ws.arkib.alert.import', `? "${newProduct.name}" telah diimport ke space ini!`, { nama: newProduct.name }));
    };

    const selectedSpaceName = spaces.find(s => s.id === selectedSpaceId)?.name || 'All Products';

    if (isLoading) {
        return (
            <div className="h-screen flex items-center justify-center bg-slate-50 dark:bg-slate-900">
                <div className="w-8 h-8 border-4 border-indigo-500/30 border-t-indigo-500 rounded-full animate-spin"></div>
            </div>
        );
    }

    return (
        /* Latar kanvas dalam v3.9 memakai token yang SAMA dengan prototaip
           (`--s-ground`), bukan salinan kod warna — kalau tema dilaraskan
           kemudian, halaman ini ikut sendiri.

           ⚠️ LATAR SAHAJA (arahan user 2026-08-10). Warna teks `text-slate-800`
              sengaja DIKEKALKAN: kad produk masih putih, jadi teks di dalamnya
              mesti kekal gelap. Selagi kad belum ditukar, latar gelap dengan
              kad putih memang nampak berlainan — itu dijangka. */
        <div
            className={`text-slate-800 dark:text-slate-100 h-full flex flex-1 overflow-hidden${uiV39 ? '' : ' bg-slate-50 dark:bg-slate-950'}`}
            style={uiV39 ? { background: 'var(--s-ground)' } : undefined}
        >
            {/* ★ Popup halangan upload (dwibahasa + pill tukar bahasa) — arahan user 2026-08-23 */}
            <UploadBlockPopup data={uploadBlockPopup} onClose={() => setUploadBlockPopup(null)} />

            {/* ★ SAVE ERROR BANNER — surfaces failures so user is never silently lost */}
            {saveError && (
                <div style={{
                    position: 'fixed', top: 0, left: '50%', transform: 'translateX(-50%)',
                    zIndex: 10000, marginTop: 12, maxWidth: 560, width: 'calc(100% - 32px)',
                    background: '#fef2f2', border: '1px solid #fecaca',
                    borderRadius: 12, padding: '12px 16px',
                    boxShadow: '0 10px 30px rgba(220,38,38,0.18)',
                    display: 'flex', alignItems: 'flex-start', gap: 12,
                }}>
                    <span className="material-symbols-outlined" style={{ color: '#dc2626', fontSize: 22, marginTop: 1 }}>error</span>
                    <div style={{ flex: 1, fontSize: 13, color: '#7f1d1d' }}>
                        <div style={{ fontWeight: 700, marginBottom: 2 }}>
                            {T('ws.save.ralat.tajuk', 'Save gagal selepas 3 cubaan')}
                        </div>
                        <div style={{ opacity: 0.85, fontSize: 12, lineHeight: 1.5 }}>
                            {saveError.code ? `[${saveError.code}] ` : ''}{saveError.message}
                            <br />
                            <span style={{ color: '#16a34a' }}>{T('ws.save.ralat.clipboard', `✓ ${saveError.changedCount} edit telah disalin ke clipboard sebagai backup.`, { bil: saveError.changedCount })}</span>
                            {/* Perkataan "Reload" dibalut <b> — ia disisip sebagai serpihan
                                supaya penekanan itu tidak hilang selepas diterjemah. */}
                            {' '}{(() => {
                                const tebal = <b>{T('ws.save.ralat.butangReload', 'Reload')}</b>;
                                const ayat = T('ws.save.ralat.arahan', 'Klik {reload} untuk muat semula. Selepas reload anda boleh paste kandungan clipboard untuk recovery.');
                                const [depan, ...belakang] = ayat.split('{reload}');
                                return <>{depan}{tebal}{belakang.join('{reload}')}</>;
                            })()}
                        </div>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 6, flexShrink: 0 }}>
                        <button
                            onClick={() => window.location.reload()}
                            style={{
                                padding: '6px 12px', borderRadius: 8, border: 'none',
                                background: '#dc2626', color: 'white', fontSize: 12, fontWeight: 700,
                                cursor: 'pointer',
                            }}
                        >{T('ws.save.ralat.butangReload', 'Reload')}</button>
                        <button
                            onClick={() => setSaveError(null)}
                            style={{
                                padding: '4px 12px', borderRadius: 8,
                                border: '1px solid #fecaca', background: 'transparent',
                                color: '#7f1d1d', fontSize: 11, cursor: 'pointer',
                            }}
                        >{T('ws.umum.tutup', 'Tutup')}</button>
                    </div>
                </div>
            )}

            {/* ★ EXTENSION ORPHAN BANNER — content script lost touch with extension after a reload */}
            {extensionOrphan && (
                <div style={{
                    position: 'fixed', top: 0, left: '50%', transform: 'translateX(-50%)',
                    zIndex: 10000, marginTop: 12, maxWidth: 560, width: 'calc(100% - 32px)',
                    background: '#fffbeb', border: '1px solid #fde68a',
                    borderRadius: 12, padding: '12px 16px',
                    boxShadow: '0 10px 30px rgba(217,119,6,0.18)',
                    display: 'flex', alignItems: 'center', gap: 12,
                }}>
                    <span className="material-symbols-outlined" style={{ color: '#d97706', fontSize: 22 }}>sync_problem</span>
                    <div style={{ flex: 1, fontSize: 13, color: '#78350f' }}>
                        <div style={{ fontWeight: 700, marginBottom: 2 }}>{T('ws.ext.yatim.tajuk', 'Extension dah di-reload')}</div>
                        <div style={{ fontSize: 12 }}>{T('ws.ext.yatim.teks', 'Refresh tab ini untuk sambung sync semula dengan extension.')}</div>
                    </div>
                    <button
                        onClick={() => window.location.reload()}
                        style={{
                            padding: '6px 14px', borderRadius: 8, border: 'none',
                            background: '#d97706', color: 'white', fontSize: 12, fontWeight: 700,
                            cursor: 'pointer',
                        }}
                    >{T('ws.ext.yatim.butang', 'Refresh')}</button>
                </div>
            )}

            {/* ★ SAVE STATUS INDICATOR — small pill at top showing live save state */}
            {(saveStatus === 'saving' || saveStatus === 'saved' || (typeof saveStatus === 'string' && saveStatus.startsWith('retry'))) && !saveError && (
                <div style={{
                    position: 'fixed', top: 12, left: '50%', transform: 'translateX(-50%)',
                    zIndex: 9999, padding: '6px 14px', borderRadius: 999,
                    fontSize: 12, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 6,
                    background: saveStatus === 'saved' ? '#ecfdf5' : saveStatus.startsWith?.('retry') ? '#fffbeb' : '#eff6ff',
                    color: saveStatus === 'saved' ? '#065f46' : saveStatus.startsWith?.('retry') ? '#92400e' : '#1e40af',
                    border: `1px solid ${saveStatus === 'saved' ? '#a7f3d0' : saveStatus.startsWith?.('retry') ? '#fde68a' : '#bfdbfe'}`,
                    boxShadow: '0 4px 12px rgba(0,0,0,0.06)',
                }}>
                    {saveStatus === 'saving' && <><span style={{ width: 10, height: 10, border: '2px solid #1e40af', borderTopColor: 'transparent', borderRadius: '50%', animation: 'spin 0.7s linear infinite' }} /> {T('ws.save.status.menyimpan', 'Menyimpan...')}</>}
                    {saveStatus === 'saved' && <>{T('ws.save.status.tersimpan', '✓ Tersimpan')}</>}
                    {/* ⛔ `saveStatus.replace('retry ','')` mengupas nombor cubaan daripada
                        NILAI status ('retry 2/3') — itu bukan ayat, jangan sentuh. */}
                    {typeof saveStatus === 'string' && saveStatus.startsWith?.('retry') && <><span style={{ width: 10, height: 10, border: '2px solid #92400e', borderTopColor: 'transparent', borderRadius: '50%', animation: 'spin 0.7s linear infinite' }} /> {T('ws.save.status.mencubaSemula', `Mencuba semula (${saveStatus.replace('retry ', '')})...`, { cubaan: saveStatus.replace('retry ', '') })}</>}
                </div>
            )}

            {/* ICON SIDEBAR REMOVED - NOW IN App.jsx */}


            {/* SPACE SETTINGS MODAL */}
            {isSettingsOpen && editingSpaceId && (
                <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
                    <div className="bg-white dark:bg-slate-900 w-full max-w-lg rounded-3xl shadow-2xl overflow-hidden animate-in fade-in zoom-in duration-200">
                        <div className="p-6 border-b border-slate-100 dark:border-slate-800 flex items-center justify-between">
                            <div className="flex items-center space-x-3">
                                <div className="w-10 h-10 rounded-xl bg-primary/10 text-primary flex items-center justify-center">
                                    <span className="material-symbols-outlined">settings</span>
                                </div>
                                <div>
                                    <h3 className="font-bold text-slate-900 dark:text-white">{T('ws.space.tajuk', 'Space Settings')}</h3>
                                    {/* Nama space = DATA pelanggan — dihantar sebagai pemboleh ubah. */}
                                    <p className="text-xs text-slate-500">{T('ws.space.subtajuk', `Kawal cara AI bekerja untuk space ${spaces.find(s => s.id === editingSpaceId)?.name}`, { nama: spaces.find(s => s.id === editingSpaceId)?.name })}</p>
                                </div>
                            </div>
                            <button onClick={() => setIsSettingsOpen(false)} className="p-2 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-full transition-colors">
                                <span className="material-symbols-outlined text-slate-400">close</span>
                            </button>
                        </div>

                        <div className="p-6 space-y-6 max-h-[70vh] overflow-y-auto custom-scrollbar">
                            {/* Execution Mode */}
                            <div className="space-y-3">
                                <div className="flex items-center gap-2">
                                    <label className="text-[10px] font-black uppercase tracking-widest text-slate-400">{T('ws.space.modLarian.label', 'Execution Mode')}</label>
                                    <div className="group relative">
                                        <span className="material-symbols-outlined text-slate-300 text-[14px] cursor-help">info</span>
                                        <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 w-48 p-2 bg-slate-800 text-white text-[9px] rounded-lg opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-50">
                                            {T('ws.space.modLarian.tip', 'Pilih cara browser memproses video anda.')}
                                        </div>
                                    </div>
                                </div>
                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                                    <button
                                        onClick={() => {
                                            const updated = spaces.map(s => s.id === editingSpaceId ? { ...s, settings: { ...s.settings, executionMode: 'scene' } } : s);
                                            setSpaces(updated);
                                            saveSpacesToCloud(updated);
                                        }}
                                        className={`p-4 rounded-2xl border-2 transition-all text-left ${(spaces.find(s => s.id === editingSpaceId)?.settings?.executionMode || 'set') === 'scene'
                                            ? 'border-primary bg-primary/5 ring-4 ring-primary/10'
                                            : 'border-slate-100 dark:border-slate-800 hover:border-slate-200 dark:hover:border-slate-700'
                                            }`}
                                    >
                                        <span className="material-symbols-outlined text-primary mb-2">movie</span>
                                        <p className="font-bold text-xs">{T('ws.space.modScene.tajuk', 'Scene Mode')}</p>
                                        <p className="text-[9px] text-slate-500 leading-tight mt-1">{T('ws.space.modScene.teks', 'Satu browser buat semua scene serentak.')}</p>
                                    </button>
                                    <button
                                        onClick={() => {
                                            const updated = spaces.map(s => s.id === editingSpaceId ? { ...s, settings: { ...s.settings, executionMode: 'set' } } : s);
                                            setSpaces(updated);
                                            saveSpacesToCloud(updated);
                                        }}
                                        className={`p-4 rounded-2xl border-2 transition-all text-left ${(spaces.find(s => s.id === editingSpaceId)?.settings?.executionMode || 'set') === 'set'
                                            ? 'border-primary bg-primary/5 ring-4 ring-primary/10'
                                            : 'border-slate-100 dark:border-slate-800 hover:border-slate-200 dark:hover:border-slate-700'
                                            }`}
                                    >
                                        <span className="material-symbols-outlined text-primary mb-2">layers</span>
                                        <p className="font-bold text-xs">{T('ws.space.modSet.tajuk', 'Set Mode')}</p>
                                        <p className="text-[9px] text-slate-500 leading-tight mt-1">{T('ws.space.modSet.teks', 'Kerja diasingkan mengikut Set pada browser berbeza.')}</p>
                                    </button>
                                </div>
                            </div>

                            {/* Default Logic */}
                            <div className="space-y-3">
                                <label className="text-[10px] font-black uppercase tracking-widest text-slate-400">{T('ws.space.logicLalai', 'Default AI Logic')}</label>
                                <select
                                    value={spaces.find(s => s.id === editingSpaceId)?.settings?.defaultLogicId || ''}
                                    onChange={(e) => {
                                        const updated = spaces.map(s => s.id === editingSpaceId ? { ...s, settings: { ...s.settings, defaultLogicId: e.target.value } } : s);
                                        setSpaces(updated);
                                        saveSpacesToCloud(updated);
                                    }}
                                    className="w-full bg-slate-50 dark:bg-slate-800 border-slate-200 dark:border-slate-700 rounded-xl text-sm p-3 focus:ring-primary focus:border-primary"
                                >
                                    <option value="">{T('ws.space.pilihPersona', 'Select a default persona...')}</option>
                                    {logicOptions.map(opt => (
                                        <option key={opt.id} value={opt.id}>{opt.name}</option>
                                    ))}
                                </select>
                            </div>

                            {/* Custom Labels */}
                            <div className="space-y-4 pt-4 border-t border-slate-100 dark:border-slate-800">
                                <label className="text-[10px] font-black uppercase tracking-widest text-slate-400">{T('ws.space.kustomAntaraMuka', 'Interface Customization')}</label>

                                <div className="space-y-4">
                                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                        <div className="space-y-1.5">
                                            <p className="text-[9px] font-bold text-slate-500 uppercase">{T('ws.space.labelPromptImej', 'Image Prompt Label')}</p>
                                            <input
                                                type="text"
                                                value={spaces.find(s => s.id === editingSpaceId)?.settings?.labels?.imagePrompt || 'Image Prompt'}
                                                onChange={(e) => {
                                                    const updatedSpaces = spaces.map(s => {
                                                        if (s.id === editingSpaceId) {
                                                            const st = s.settings || {};
                                                            const l = st.labels || { imagePrompt: 'Image Prompt', videoPrompt: 'Video Prompt', captionTiktok: 'TikTok Caption' };
                                                            return { ...s, settings: { ...st, labels: { ...l, imagePrompt: e.target.value } } };
                                                        }
                                                        return s;
                                                    });
                                                    setSpaces(updatedSpaces);
                                                    saveSpacesToCloud(updatedSpaces);
                                                }}
                                                className="w-full bg-slate-50 dark:bg-slate-800 border-slate-200 dark:border-slate-700 rounded-lg text-xs p-2.5"
                                            />
                                        </div>
                                        <div className="space-y-1.5">
                                            <p className="text-[9px] font-bold text-slate-500 uppercase">{T('ws.space.labelPromptVideo', 'Video Prompt Label')}</p>
                                            <input
                                                type="text"
                                                value={spaces.find(s => s.id === editingSpaceId)?.settings?.labels?.videoPrompt || 'Video Prompt'}
                                                onChange={(e) => {
                                                    const updatedSpaces = spaces.map(s => {
                                                        if (s.id === editingSpaceId) {
                                                            const st = s.settings || {};
                                                            const l = st.labels || { imagePrompt: 'Image Prompt', videoPrompt: 'Video Prompt', captionTiktok: 'TikTok Caption' };
                                                            return { ...s, settings: { ...st, labels: { ...l, videoPrompt: e.target.value } } };
                                                        }
                                                        return s;
                                                    });
                                                    setSpaces(updatedSpaces);
                                                    saveSpacesToCloud(updatedSpaces);
                                                }}
                                                className="w-full bg-slate-50 dark:bg-slate-800 border-slate-200 dark:border-slate-700 rounded-lg text-xs p-2.5"
                                            />
                                        </div>
                                    </div>

                                    <div className="space-y-1.5">
                                        <div className="flex items-center justify-between">
                                            <p className="text-[9px] font-bold text-slate-500 uppercase">{T('ws.space.labelCaptionTiktok', 'TikTok Caption Label')}</p>
                                            <label className="flex items-center space-x-2 cursor-pointer">
                                                <input
                                                    type="checkbox"
                                                    checked={spaces.find(s => s.id === editingSpaceId)?.settings?.showTikTokCaption !== false}
                                                    onChange={(e) => {
                                                        const updatedSpaces = spaces.map(s => s.id === editingSpaceId ? { ...s, settings: { ...(s.settings || {}), showTikTokCaption: e.target.checked } } : s);
                                                        setSpaces(updatedSpaces);
                                                        saveSpacesToCloud(updatedSpaces);
                                                    }}
                                                    className="w-3 h-3 rounded border-slate-300 text-primary"
                                                />
                                                <span className="text-[9px] font-bold text-slate-400">{T('ws.space.showField', 'SHOW FIELD')}</span>
                                            </label>
                                        </div>
                                        <input
                                            type="text"
                                            value={spaces.find(s => s.id === editingSpaceId)?.settings?.labels?.captionTiktok || 'TikTok Caption'}
                                            onChange={(e) => {
                                                const updatedSpaces = spaces.map(s => {
                                                    if (s.id === editingSpaceId) {
                                                        const st = s.settings || {};
                                                        const l = st.labels || {};
                                                        return { ...s, settings: { ...st, labels: { ...l, captionTiktok: e.target.value } } };
                                                    }
                                                    return s;
                                                });
                                                setSpaces(updatedSpaces);
                                                saveSpacesToCloud(updatedSpaces);
                                            }}
                                            className="w-full bg-slate-50 dark:bg-slate-800 border-slate-200 dark:border-slate-700 rounded-lg text-xs p-2.5 disabled:opacity-50"
                                            disabled={spaces.find(s => s.id === editingSpaceId)?.settings?.showTikTokCaption === false}
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Set Management */}
                            <div className="space-y-4 pt-4 border-t border-slate-100 dark:border-slate-800">
                                <label className="text-[10px] font-black uppercase tracking-widest text-slate-400">{T('ws.space.urusSet', 'Set Management')}</label>
                                <div className="space-y-4">
                                    {/* Set 1 */}
                                    <div className="bg-slate-50 dark:bg-slate-800/50 p-3 rounded-2xl border border-slate-100 dark:border-slate-800">
                                        <div className="flex items-center justify-between mb-2">
                                            <p className="text-[10px] font-bold text-slate-500">{T('ws.space.set1Tajuk', 'SET 1 TITLE')}</p>
                                            <span className="text-[8px] px-1.5 py-0.5 bg-emerald-100 text-emerald-600 rounded">{T('ws.space.sentiasaHidup', 'ALWAYS ON')}</span>
                                        </div>
                                        <input
                                            type="text"
                                            value={spaces.find(s => s.id === editingSpaceId)?.settings?.labels?.set1 || 'Set 1'}
                                            onChange={(e) => {
                                                const updatedSpaces = spaces.map(s => {
                                                    if (s.id === editingSpaceId) {
                                                        const st = s.settings || {};
                                                        const l = st.labels || {};
                                                        return { ...s, settings: { ...st, labels: { ...l, set1: e.target.value } } };
                                                    }
                                                    return s;
                                                });
                                                setSpaces(updatedSpaces);
                                                saveSpacesToCloud(updatedSpaces);
                                            }}
                                            className="w-full bg-white dark:bg-slate-900 border-slate-200 dark:border-slate-700 rounded-lg text-xs p-2"
                                        />
                                    </div>

                                    {/* Set 2 */}
                                    <div className="bg-slate-50 dark:bg-slate-800/50 p-3 rounded-2xl border border-slate-100 dark:border-slate-800">
                                        <div className="flex items-center justify-between mb-2">
                                            <p className="text-[10px] font-bold text-slate-500">{T('ws.space.set2Tajuk', 'SET 2 TITLE')}</p>
                                            <label className="flex items-center space-x-2 cursor-pointer">
                                                <input
                                                    type="checkbox"
                                                    checked={spaces.find(s => s.id === editingSpaceId)?.settings?.showSet2 !== false}
                                                    onChange={(e) => {
                                                        const updatedSpaces = spaces.map(s => s.id === editingSpaceId ? { ...s, settings: { ...(s.settings || {}), showSet2: e.target.checked } } : s);
                                                        setSpaces(updatedSpaces);
                                                        saveSpacesToCloud(updatedSpaces);
                                                    }}
                                                    className="w-3 h-3 rounded border-slate-300 text-primary"
                                                />
                                                <span className="text-[9px] font-bold text-slate-400 uppercase">{T('ws.space.kelihatan', 'Visible')}</span>
                                            </label>
                                        </div>
                                        <input
                                            type="text"
                                            value={spaces.find(s => s.id === editingSpaceId)?.settings?.labels?.set2 || 'Set 2'}
                                            onChange={(e) => {
                                                const updatedSpaces = spaces.map(s => {
                                                    if (s.id === editingSpaceId) {
                                                        const st = s.settings || {};
                                                        const l = st.labels || {};
                                                        return { ...s, settings: { ...st, labels: { ...l, set2: e.target.value } } };
                                                    }
                                                    return s;
                                                });
                                                setSpaces(updatedSpaces);
                                                saveSpacesToCloud(updatedSpaces);
                                            }}
                                            className="w-full bg-white dark:bg-slate-900 border-slate-200 dark:border-slate-700 rounded-lg text-xs p-2 disabled:opacity-50"
                                            disabled={spaces.find(s => s.id === editingSpaceId)?.settings?.showSet2 === false}
                                        />
                                    </div>

                                    {/* Set 3 */}
                                    <div className="bg-slate-50 dark:bg-slate-800/50 p-3 rounded-2xl border border-slate-100 dark:border-slate-800">
                                        <div className="flex items-center justify-between mb-2">
                                            <p className="text-[10px] font-bold text-slate-500">{T('ws.space.set3Tajuk', 'SET 3 TITLE')}</p>
                                            <label className="flex items-center space-x-2 cursor-pointer">
                                                <input
                                                    type="checkbox"
                                                    checked={spaces.find(s => s.id === editingSpaceId)?.settings?.showSet3 !== false}
                                                    onChange={(e) => {
                                                        const updatedSpaces = spaces.map(s => s.id === editingSpaceId ? { ...s, settings: { ...(s.settings || {}), showSet3: e.target.checked } } : s);
                                                        setSpaces(updatedSpaces);
                                                        saveSpacesToCloud(updatedSpaces);
                                                    }}
                                                    className="w-3 h-3 rounded border-slate-300 text-primary"
                                                />
                                                <span className="text-[9px] font-bold text-slate-400 uppercase">{T('ws.space.kelihatan', 'Visible')}</span>
                                            </label>
                                        </div>
                                        <input
                                            type="text"
                                            value={spaces.find(s => s.id === editingSpaceId)?.settings?.labels?.set3 || 'Set 3'}
                                            onChange={(e) => {
                                                const updatedSpaces = spaces.map(s => {
                                                    if (s.id === editingSpaceId) {
                                                        const st = s.settings || {};
                                                        const l = st.labels || {};
                                                        return { ...s, settings: { ...st, labels: { ...l, set3: e.target.value } } };
                                                    }
                                                    return s;
                                                });
                                                setSpaces(updatedSpaces);
                                                saveSpacesToCloud(updatedSpaces);
                                            }}
                                            className="w-full bg-white dark:bg-slate-900 border-slate-200 dark:border-slate-700 rounded-lg text-xs p-2 disabled:opacity-50"
                                            disabled={spaces.find(s => s.id === editingSpaceId)?.settings?.showSet3 === false}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="p-6 bg-slate-50 dark:bg-slate-800/50 flex justify-end">
                            <button
                                onClick={() => setIsSettingsOpen(false)}
                                className="bg-primary text-white px-8 py-2.5 rounded-xl font-bold text-xs shadow-lg shadow-primary/20 hover:brightness-110 active:scale-95 transition-all"
                            >
                                {T('ws.umum.selesai', 'Done')}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* MAIN CONTENT — SPLIT PANEL */}
            <main className="flex-1 flex flex-col overflow-hidden">
                {/* Split Panel Container */}
                <div ref={splitContainerRef} className="flex-1 flex overflow-hidden relative">

                    {/* ===== CENTRALIZED PANEL (Single Panel) ===== */}
                    {/* v3.9: --s-panel (#141414), BUKAN --s-ground (#111111).
                        Prototaip meletakkan lajur kerjanya di atas panel kandungan
                        #141414; menggunakan warna halaman yang lebih gelap di sini
                        menyongsangkan rupa bar tab: bekasnya (putih 4%) jatuh ke
                        ~#151515, jadi tab AKTIF (#181818) kelihatan lebih CERAH
                        daripada bekasnya — sedangkan dalam prototaip bekas jadi
                        ~#1B1B1B dan tab aktif kelihatan lebih GELAP.

                        Warna butang tab sendiri sudah identik dengan prototaip;
                        yang salah ialah permukaan di belakangnya. Diukur, bukan
                        diteka: user melaporkan "warna background tab lain betul"
                        2026-08-11 dan inilah puncanya. */}
                    <div
                        style={{ width: '100%', ...(uiV39 ? { background: 'var(--s-panel)' } : null) }}
                        className={`relative flex flex-col h-full overflow-hidden${uiV39 ? '' : ' bg-slate-50/80 dark:bg-slate-950'}`}
                    >

                        {/* Product Cards — Scrollable + Marquee Selection */}
                        <div
                            ref={pasangKanvas}
                            onMouseDown={handleMarqueeDown}
                            onMouseMove={handleMarqueeMove}
                            onMouseUp={handleMarqueeUp}
                            onDragStartCapture={handleCanvasDragStart}
                            className="flex-1 overflow-y-auto custom-scrollbar pb-6"
                            /* ⚠️ Corak bintik ada DUA sumber: kelas `dotted-canvas` pada <main>
                               (App.jsx) dan salinan inline di sini. Membuang satu sahaja tidak
                               menghilangkan bintik — kena kedua-duanya. v3.9 rata, tiada corak. */
                            style={{ ...(uiV39 ? null : { backgroundImage: 'radial-gradient(#cbd5e1 1px, transparent 1px)', backgroundSize: '24px 24px' }), position: 'relative', userSelect: selectionBox ? 'none' : 'auto' }}
                        >
                            {/* Toolbar Row — sticky atas masa scroll */}
                            {/* Padding v3.9 — mengikut prototaip (/workspace-v3.9):

                                ATAS 22px = jurang tajuk-ke-tab, nilai yang sama dipakai
                                  `.s-work__right` dalam prototaip.

                                  ⚠️ Dahulu 78px. Angka itu perlu kerana jalur kepala
                                     MELAYANG (position:absolute) dan tidak mengambil
                                     ruang, jadi bar ini terpaksa menampung ketinggiannya
                                     sendiri. Sejak kepala berpindah ke dalam aliran
                                     (BingkaiIsi + `.s-work__head` dalam App.jsx), kepala
                                     membawa ruangnya sendiri — 78px di sini akan menjadi
                                     jurang berganda.

                                KIRI/KANAN 28px = jarak tepi halaman v3.9 yang piawai,
                                  sama seperti `.s-work__head` di atasnya dan setiap
                                  halaman v3.9 yang lain (Extension, Marketplace,
                                  Products). Dahulu 40px, dijajarkan pada senarai produk
                                  sahaja — itulah punca aduan user 2026-08-12 bahawa jarak
                                  Workspace tidak sama dengan halaman lain.

                                ⛔ Nilai tepi ini WAJIB sama dengan padding senarai produk
                                   di bawah (sm:px-7). Kalau satu diubah, ubah kedua-dua —
                                   kalau tidak tab dan kad tidak lagi sebaris. */}
                            {/* ⛔ LATAR PEJAL WAJIB dalam v3.9 (aduan user 2026-08-12:
                                "header, switch group, tab dan sorting, expand icon tak
                                elok time scroll down").

                                Bar ini MELEKAT (sticky) sementara senarai menatal di
                                bawahnya, jadi tanpa latar sendiri kad yang lalu di
                                belakangnya kelihatan tembus — nama produk bertindih
                                dengan tajuk "Workspace", pemilih group dan tab.

                                Ia bukan sekadar bar tab: padding atas 78px itu ialah
                                kawasan tempat jalur kepala MELAYANG (tajuk + pemilih
                                group, position:absolute dalam App.jsx). Kerana kawasan
                                itu milik bar ini, latar pejal di sini pula yang
                                melindungi kepala — kepala sendiri tiada latar.

                                Bukan corak baharu: telefon sudah pun berbuat begini
                                (`.sesaat-ws-toolbar` dalam mobile.css, dengan nota
                                sebab yang sama). Hanya desktop yang tertinggal.

                                Warna mengikut `--s-panel` — permukaan yang SAMA dengan
                                bekas di belakangnya (lihat nota latar bekas di atas),
                                jadi semasa TIDAK menatal jalur ini langsung tidak
                                kelihatan. Rupa lama kekal telus seperti asal. */}
                            {/* Workspace v4 (23 Okt): tab + alat kanan dipindah ke kepala halaman → jalur ini KOSONG dan
                                tinggal sebagai jarak 22px kepala → isi, SAMA seperti prototaip /workspace-v4 (arahan user).
                                Tab Schedule kekal penuh (bar tarikh kalendar). Bar pukal melekat di bawahnya (jalurTinggi). */}
                            <div ref={jalurRef} className="flex items-center justify-between bg-transparent sesaat-ws-toolbar" style={{ padding: uiV39 ? '22px 28px 16px' : '16px 20px 12px 20px', position: 'sticky', top: 0, zIndex: 20, ...(uiV39 ? { background: 'var(--s-panel)' } : null), ...(slotTabV4 && !schedMode ? { padding: '22px 0 0' } : null) }}>
                                <div className="flex items-center gap-3">
                                    {/* Select All Checkbox
                                        ⛔ DIBUANG dalam v3.9 (arahan user 2026-08-11). Kotak ini
                                           terapung sendirian di bawah pemilih group tanpa label,
                                           jadi ia terbaca seolah-olah milik pemilih group —
                                           sedangkan ia menandakan SEMUA produk dalam senarai.

                                        Ia tidak hilang: dalam v3.9 "Pilih semua" duduk di dalam
                                        BAR PUKAL yang muncul selepas satu kad ditanda (keputusan
                                        user 2026-08-09). Di situ ia ada label, dan konteksnya
                                        jelas kerana bar itu memang tentang pilihan.
                                        Rupa lama KEKAL ada kotak ini. */}
                                    {!uiV39 && (
                                    <label className="flex items-center gap-2 cursor-pointer">
                                        <input
                                            type="checkbox"
                                            checked={filteredAndSortedProducts.length > 0 && filteredAndSortedProducts.every(p => p.selected)}
                                            onChange={(e) => {
                                                const ids = new Set(filteredAndSortedProducts.map(p => p.id));
                                                const updated = products.map(p => ({
                                                    ...p,
                                                    selected: ids.has(p.id) ? e.target.checked : p.selected
                                                }));
                                                setProducts(updated);
                                                saveToCloud(updated);
                                            }}
                                            className="w-3.5 h-3.5 rounded border-slate-300 text-primary focus:ring-primary"
                                            /* Sama seperti kotak semak pada kad: tanpa accent putih ia
                                               keluar hitam pekat atas bar gelap. */
                                            style={uiV39 ? { accentColor: 'var(--s-select)' } : undefined}
                                        />
                                    </label>
                                    )}

                                </div>
                                {/* v3.9 (arahan user 2026-08-11): bar ini mengambil seluruh
                                    lebar dan menolak isinya ke dua hujung — TAB ke kiri,
                                    susunan ke kanan, sama seperti prototaip. Rupa lama
                                    mengumpul kedua-duanya di kanan; itu masuk akal dahulu
                                    kerana kiri dipenuhi kotak "pilih semua", tetapi kotak itu
                                    sudah berpindah ke bar pukal dalam v3.9 dan meninggalkan
                                    ruang kosong menganga. */}
                                <div
                                  className="flex items-center gap-1.5 sesaat-ws-toolbar-right"
                                  /* ⭐ Pada tab Schedule (arahan user 2026-08-21): jalur ini bertukar
                                     dari flex → GRID dengan lajur SAMA seperti grid kalendar di bawah
                                     (`.s-tikjad`), supaya bar tarikh (lajur 2) berbaris TEPAT dengan
                                     tepi kiri kalendar — menandakan ia kepunyaan kalendar. Jalur ini
                                     dan kalendar berkongsi tepi kiri + lebar yang sama (padding 28px),
                                     jadi lajurnya sepadan. `justifyItems:start` elak tab & tarikh
                                     diregangkan mengisi lajur. */
                                  style={uiV39
                                    ? (schedMode
                                        /* ⚠️ columnGap WAJIB 18px — SAMA dengan `gap` grid kalendar
                                           (`.s-tikjad`). Kedua-dua jalur bermula pada tepi 28px yang
                                           sama dan lebar lajur 1 sama, jadi hanya jurang lajur yang
                                           menentukan di mana lajur 2 bermula. 6px (nilai jalur tab
                                           biasa) menyasarkan bar tarikh 12px ke kiri garisan kalendar. */
                                        /* Lajur 1 = SAMA dengan grid kalendar di bawah. Bila senarai
                                           kecut (Pilihan A), lajur 1 turut mengecut 34px supaya bar
                                           tarikh geser ke kiri sebaris dengan kalendar — tanpa ini ada
                                           ruang kosong menganga di kiri (aduan user 27 Okt).
                                           ⭐ v4 (arahan user 2026-11-01): bila senarai kecut, lajur kiri
                                              HILANG sepenuhnya (`.s-tikjad--solo`), jadi jalur ini pun
                                              jadi SATU lajur — bar tarikh penuh, sebaris dgn kalendar
                                              penuh. Slot kepala (lajur 1) kosong masa kecut, jadi ia
                                              cuma susun jadi dua baris tanpa isi. */
                                        ? (senaraiKecut && slotTabV4
                                            ? { flex: 1, display: 'grid', gridTemplateColumns: 'minmax(0, 1fr)', alignItems: 'center', justifyItems: 'start', columnGap: 18 }
                                            : { flex: 1, display: 'grid', gridTemplateColumns: (senaraiKecut ? '34px' : 'clamp(500px, 37%, 780px)') + ' minmax(0, 1fr)', alignItems: 'center', justifyItems: 'start', columnGap: 18 })
                                        : { flex: 1, justifyContent: 'space-between' })
                                    : undefined}
                                >
                                    {/* ★ Playground-Style Filter Pills (Refined to match Group Button Exactly) */}
                                    {/* v3.9: nilai `.s-seg` prototaip — latar --s-fill, bucu 10px,
                                        padding 3px, jurang 2px. Petak putih 12px itu rupa lama. */}
                                    {/* ⭐ Workspace v4 (arahan user 23 Okt — ikut prototaip /workspace-v4): jalur tab
                                        DIPINDAH ke kepala halaman, sebaris dengan pemilih group, melalui portal ke
                                        `slotTabV4` (App.jsx). Suis v4 mati → slot null → rupa SAMA seperti dahulu.
                                        Logik tab tidak disalin — elemen yang sama, cuma tempat render berubah. */}
                                    {(() => { const jalurTab = (
                                    <div className="sesaat-ws-pills" style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        /* Jalur tab: nilai `.s-seg` prototaip — latar --s-fill,
                                           bucu 10px, padding 3px, jurang 2px, tinggi 36px. */
                                        background: uiV39 ? 'var(--s-fill)' : '#ffffff',
                                        padding: uiV39 ? 3 : '4px 8px',
                                        borderRadius: uiV39 ? 10 : '12px',
                                        ...(uiV39 ? { gap: 2 } : null),
                                        /* Jurang ke susunan diuruskan oleh `space-between` pada
                                           bar dalam v3.9, jadi margin tetap ini akan bertindih. */
                                        marginRight: uiV39 ? 0 : 16,
                                        gap: 2
                                    }}>
                                        {(() => {
                                            // P6.3 — Tab Agent AI (id kekal 'chatgpt').
                                            // Muncul ikut KANDUNGAN group (ada card FLOWNITY/Smart Custom, tak kira tab mana) — bukan ikut module aktif sidebar.
                                            //
                                            // v3.9 (arahan user 2026-08-10): tab ini TETAP ada, sama seperti tab lain.
                                            // Syarat lama menyembunyikannya sehingga group mengandungi kad Smart Custom
                                            // atau FLOWNITY — jadi pengguna yang belum pernah membuat kad sebegitu tidak
                                            // pernah tahu tab itu wujud, dan bar tab berubah bilangannya sendiri apabila
                                            // pengguna bertukar group. Suis mati → syarat lama kembali, tepat seperti dulu.
                                            const adaAgent = uiV39 || chatgptCount > 0
                                                || baseFilteredProducts.some(p => p.moduleId === 'smartcustom' || p.moduleId === 'flownity')
                                                || propActiveModuleId === 'smartcustom' || propActiveModuleId === 'flownity';
                                            const agent = { id: 'chatgpt', label: TAB_NAMA.chatgpt, count: chatgptCount, icon: 'smart_toy' };
                                            /* Tab Generate v3.9 tiada kiraan (arahan user
                                               2026-08-12). Ia tidak lagi memaparkan kad, jadi
                                               sebarang nombor di situ menjanjikan senarai yang
                                               tidak wujud — dan nombor itu dahulunya jumlah
                                               ketiga-tiga tab lain, jadi ia turut menipu tentang
                                               berapa banyak kerja yang ada.

                                               `null` bermakna "jangan lukis lencana langsung";
                                               tab lain menghantar nombor seperti biasa. Rupa lama
                                               kekal berkiraan — di sana tab "All" memang senarai
                                               semua produk. */
                                            const generate = { id: 'all', label: TAB_NAMA.all, count: uiV39 ? null : baseFilteredProducts.length, icon: 'grid_view' };
                                            const flow = { id: 'flow', label: TAB_NAMA.flow, count: flowCount, icon: 'merge' };
                                            const schedule = { id: 'tiktok', label: TAB_NAMA.tiktok, count: tiktokCount, icon: 'music_note' };

                                            /* Susunan v3.9: Generate · Agent AI · Flow · Schedule
                                               (arahan user 2026-08-11 — Agent AI di sebelah KANAN Generate).

                                               ⚠️ Ini menggantikan keputusan awal hari yang sama yang meletakkan
                                                  Agent AI di HUJUNG mengikut prototaip. Jangan "betulkan" ia
                                                  kembali ke hujung tanpa bertanya — prototaip bukan lagi rujukan
                                                  untuk susunan tab ini.

                                               Susunan ini juga sama dengan turutan kerja sebenar (Agent AI →
                                               Flow → Schedule) dan sama dengan susunan butang Mark dalam bar
                                               pukal, jadi mata tidak perlu belajar dua susunan berbeza.

                                               Rupa lama kekal susunan asalnya. */
                                            return [generate, ...(adaAgent ? [agent] : []), flow, schedule];
                                        })().map(tab => (
                                            <button
                                                key={tab.id}
                                                onClick={() => { handleSwitchTab(tab.id); }}
                                                style={{
                                                    padding: '6px 12px', 
                                                    borderRadius: '8px', 
                                                    display: 'flex', 
                                                    alignItems: 'center', 
                                                    gap: 8,
                                                    fontSize: 13, 
                                                    fontWeight: 700, 
                                                    cursor: 'pointer', 
                                                    transition: 'all 0.15s', 
                                                    border: 'none',
                                                    fontFamily: 'inherit',
                                                    /* KOTAK TAB v3.9 — setiap nilai diukur terus daripada
                                                       `.s-seg__item` prototaip yang hidup, bukan dianggar:
                                                         tinggi 30px · padding 0 12px · bucu 8px · 13px/500
                                                         aktif → latar --s-card (#181818), teks --s-ink (putih)
                                                         mati  → telus, teks --s-ink-3
                                                       Petak latar DAN teks putih bersama-sama menandakan
                                                       tab aktif. Ikon dikekalkan (arahan user 2026-08-11) —
                                                       itu satu-satunya beza yang tinggal daripada prototaip,
                                                       selain kiraan di hujung. */
                                                    ...(uiV39 ? {
                                                        height: 30,
                                                        padding: '0 12px',
                                                        fontWeight: 500,
                                                        color: activeTab === tab.id ? 'var(--s-ink)' : 'var(--s-ink-3)',
                                                        background: activeTab === tab.id ? 'var(--s-card)' : 'transparent',
                                                    } : {
                                                        color: activeTab === tab.id ? '#1f2937' : '#64748b',
                                                        background: activeTab === tab.id ? '#f3f4f6' : 'transparent',
                                                    }),
                                                }}
                                            >
                                                <span className="material-symbols-outlined" style={{ fontSize: 18, color: uiV39 ? (activeTab === tab.id ? 'var(--s-ink)' : 'var(--s-ink-3)') : (activeTab === tab.id ? '#1f2937' : '#94a3b8') }}>{tab.icon}</span>
                                                {tab.label}
                                                {tab.count != null && (
                                                <span style={{
                                                    fontSize: 11,
                                                    fontWeight: uiV39 ? 500 : 800,
                                                    background: uiV39 ? 'transparent' : (activeTab === tab.id ? 'rgba(0,0,0,0.06)' : 'transparent'),
                                                    padding: '1px 5px',
                                                    borderRadius: 4,
                                                    marginLeft: 2,
                                                    color: uiV39 ? 'var(--s-ink-3)' : (activeTab === tab.id ? '#1f2937' : '#94a3b8')
                                                }}>{tab.count}</span>
                                                )}
                                            </button>
                                        ))}
                                    </div>
                                    );
                                    /* Tab Schedule: bar tarikh mesti kekal di LAJUR 2 grid — petak kosong ganti tab di lajur 1. */
                                    return slotTabV4 ? (<>{createPortal(jalurTab, slotTabV4)}{schedMode && <div ref={setSlotKepalaSched} style={{ width: '100%' }} />}</>) : jalurTab;
                                    })()}
                                    {/* ── hujung bekas TAB ──────────────────────────────
                                        Susunan + buka/tutup semua DIKELUARKAN daripada bekas
                                        tab (arahan user 2026-08-10). Dahulunya ketiga-tiganya
                                        berkongsi satu petak, jadi mata membaca enam butang
                                        sebagai satu deretan — sedangkan tab MENAPIS (produk
                                        mana kelihatan) manakala dua ini MENGATUR (bagaimana
                                        ia disusun dan dipapar). Jarak kecil itulah yang
                                        memberitahu perbezaan itu tanpa perlu label.

                                        Kedudukan akan dilaraskan sendiri oleh user kemudian.

                                        ⛔ v3.9 (arahan user 2026-08-13) — kawalan ini TIDAK
                                           muncul pada dua tab:
                                             · Generate — tiada senarai produk di sana langsung
                                               (kad komposer yang mengambil tempatnya), jadi
                                               tiada apa untuk disusun.
                                             · Schedule — ia BERPINDAH turun, duduk terus di atas
                                               senarai produk dalam tab itu. Sebabnya senarai di
                                               sana bukan lagi kandungan tunggal halaman; ia satu
                                               daripada DUA grid, dan kawalan yang melayang di
                                               jalur atas tidak memberitahu grid mana yang ia
                                               susun.
                                           Rupa lama tidak disentuh — di sana ia kekal di jalur
                                           alat pada semua tab seperti dahulu. */}
                                    {/* ⭐ KELOMPOK KANAN jalur alat. Syarat luar dilonggarkan
                                           kepada "bukan tab Generate" kerana bekas ini kini
                                           membawa DUA benda: kawalan susunan (syarat lamanya
                                           kekal, di dalam) DAN butang sorok/papar Control Panel,
                                           yang perlu muncul pada tab Schedule juga.

                                           Satu bekas, bukan dua yang masing-masing menolak diri
                                           dengan `marginLeft: auto`: butang Control Panel mesti
                                           duduk di HUJUNG SEKALI pada setiap tab, walaupun
                                           jirannya berubah. */}
                                    {/* ⭐ Slot bar tarikh kalendar (arahan user 2026-08-21). Dalam GRID
                                        jalur ini (lihat gaya di atas), slot ini jatuh pada LAJUR 2 —
                                        berbaris tepat dengan tepi kiri kalendar (garisan merah yang
                                        user tunjuk). Tab duduk di lajur 1. Bar tarikh sebenar +
                                        logiknya kekal di KalendarMingguV39 — ini cuma tempat ia dirender. */}
                                    {schedMode && (
                                        <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between', gap: 8, width: '100%' }}>
                                            <div ref={setSchedDateNavSlot} style={{ display: 'flex', alignItems: 'center', flex: 'none' }} />
                                            {/* Hujung kanan baris yang sama. `flexWrap` = jaring skrin sempit:
                                                bila tarikh + dua butang tidak muat, ia turun semula jadi dua
                                                baris seperti dahulu, bukan terkeluar dari lajur. */}
                                            <div ref={setSchedAlatSlot} style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', minWidth: 0 }} />
                                        </div>
                                    )}
                                    {/* ⛔ Kelompok kanan (susun + Show Control Panel) TIDAK dirender pada
                                        tab Schedule: susun berpindah ke atas senarai, Show Control Panel
                                        berpindah ke bar kalendar — jadi ia kosong di sini, dan
                                        membiarkannya akan menokok petak grid HANTU di lajur 1 baris 2. */}
                                    {/* Workspace v4: kelompok kanan (susun · buka/tutup · Show Control Panel) DIPINDAH ke
                                        kepala halaman, sebelah pil bahasa (portal ke `slotAlatV4`, App.jsx). */}
                                    {(!uiV39 || (activeTab !== 'all' && activeTab !== 'tiktok')) && (() => { const alatKanan = (
                                    <div style={{ display: 'flex', alignItems: 'center', gap: uiV39 ? 8 : 4, marginLeft: 4 }}>
                                    {(!uiV39 || activeTab !== 'tiktok') && (<>
                                    {/* ★ v3.0.0: Sort button inline with filter pills
                                        v3.9 memakai menu prototaip (tiga jenis + toggle arah,
                                        dibuka dengan TEKAN). Menu lama dikekalkan sepenuhnya di
                                        bawah — tutup suis, ia kembali seperti asal tanpa deploy. */}
                                    {uiV39 ? (
                                    <SortMenuV39
                                        jenis={flowSortType}
                                        arah={flowSortDirection}
                                        onTukar={(j, a) => { setFlowSortType(j); setFlowSortDirection(a); }}
                                    />
                                    ) : (
                                    <div className="relative group/sort">
                                        {/* Butang susun — dalam prototaip ia CHIP bergaris (border
                                            --s-line-strong, bucu 8px, padding 0 11px, teks --s-ink),
                                            bukan teks bogel. Nilai diukur terus daripada prototaip. */}
                                        <button style={{
                                            padding: uiV39 ? '0 11px' : '6px 10px', height: uiV39 ? 32 : undefined,
                                            borderRadius: 8, display: 'flex', alignItems: 'center', gap: 6,
                                            fontSize: 13, fontWeight: uiV39 ? 500 : 700, cursor: 'pointer',
                                            border: uiV39 ? '1px solid var(--s-line-strong)' : 'none', fontFamily: 'inherit',
                                            color: uiV39 ? 'var(--s-ink)' : '#64748b', background: 'transparent', transition: 'all 0.15s'
                                        }}>
                                            <span className="material-symbols-outlined" style={{ fontSize: 18, color: uiV39 ? 'var(--s-ink-3)' : '#94a3b8' }}>sort</span>
                                            {/* ⛔ 'time'/'index'/'module' + 'asc'/'desc' = nilai yang disimpan
                                                dalam localStorage dan dibanding — JANGAN sentuh. Label '1-10'
                                                dan '10-1' ialah simbol, sama dua bahasa. */}
                                            {flowSortType === 'time' && flowSortDirection === 'desc' ? T('ws.susun.terbaru', 'Newest') : flowSortType === 'time' && flowSortDirection === 'asc' ? T('ws.susun.terlama', 'Oldest') : flowSortType === 'index' && flowSortDirection === 'asc' ? '1-10' : flowSortType === 'index' && flowSortDirection === 'desc' ? '10-1' : flowSortType === 'module' && flowSortDirection === 'asc' ? T('ws.susun.modulAZ', 'Module A-Z') : T('ws.susun.modulZA', 'Module Z-A')}
                                        </button>
                                        <div className="absolute right-0 top-full pt-1 w-44 z-50 hidden group-hover/sort:block">
                                            <div className="bg-white rounded-xl shadow-xl border border-slate-100 p-1.5">
                                                <div className="text-[9px] font-bold text-slate-400 uppercase tracking-widest px-2 py-0.5">{T('ws.susun.ikutNombor', 'By Number')}</div>
                                                <button onClick={() => { setFlowSortType('index'); setFlowSortDirection('asc'); }}
                                                    className={`w-full text-left px-2 py-1 text-[10px] rounded-lg flex items-center justify-between ${flowSortType === 'index' && flowSortDirection === 'asc' ? 'bg-primary/10 text-primary' : 'hover:bg-slate-50'}`}
                                                >
                                                    <span>{T('ws.susun.menaik', 'Ascending (1-10)')}</span>
                                                    {flowSortType === 'index' && flowSortDirection === 'asc' && <span className="material-symbols-outlined text-[12px]">check</span>}
                                                </button>
                                                <button onClick={() => { setFlowSortType('index'); setFlowSortDirection('desc'); }}
                                                    className={`w-full text-left px-2 py-1 text-[10px] rounded-lg flex items-center justify-between ${flowSortType === 'index' && flowSortDirection === 'desc' ? 'bg-primary/10 text-primary' : 'hover:bg-slate-50'}`}
                                                >
                                                    <span>{T('ws.susun.menurun', 'Descending (10-1)')}</span>
                                                    {flowSortType === 'index' && flowSortDirection === 'desc' && <span className="material-symbols-outlined text-[12px]">check</span>}
                                                </button>
                                                <div className="border-t border-slate-100 my-0.5"></div>
                                                <div className="text-[9px] font-bold text-slate-400 uppercase tracking-widest px-2 py-0.5">{T('ws.susun.ikutMasa', 'By Time')}</div>
                                                <button onClick={() => { setFlowSortType('time'); setFlowSortDirection('desc'); }}
                                                    className={`w-full text-left px-2 py-1 text-[10px] rounded-lg flex items-center justify-between ${flowSortType === 'time' && flowSortDirection === 'desc' ? 'bg-primary/10 text-primary' : 'hover:bg-slate-50'}`}
                                                >
                                                    <span>{T('ws.susun.terbaruDulu', 'Newest First')}</span>
                                                    {flowSortType === 'time' && flowSortDirection === 'desc' && <span className="material-symbols-outlined text-[12px]">check</span>}
                                                </button>
                                                <button onClick={() => { setFlowSortType('time'); setFlowSortDirection('asc'); }}
                                                    className={`w-full text-left px-2 py-1 text-[10px] rounded-lg flex items-center justify-between ${flowSortType === 'time' && flowSortDirection === 'asc' ? 'bg-primary/10 text-primary' : 'hover:bg-slate-50'}`}
                                                >
                                                    <span>{T('ws.susun.terlamaDulu', 'Oldest First')}</span>
                                                    {flowSortType === 'time' && flowSortDirection === 'asc' && <span className="material-symbols-outlined text-[12px]">check</span>}
                                                </button>
                                                <div className="border-t border-slate-100 my-0.5"></div>
                                                <div className="text-[9px] font-bold text-slate-400 uppercase tracking-widest px-2 py-0.5">{T('ws.susun.ikutModule', 'By Module')}</div>
                                                <button onClick={() => { setFlowSortType('module'); setFlowSortDirection('asc'); }}
                                                    className={`w-full text-left px-2 py-1 text-[10px] rounded-lg flex items-center justify-between ${flowSortType === 'module' && flowSortDirection === 'asc' ? 'bg-primary/10 text-primary' : 'hover:bg-slate-50'}`}
                                                >
                                                    <span>A → Z</span>
                                                    {flowSortType === 'module' && flowSortDirection === 'asc' && <span className="material-symbols-outlined text-[12px]">check</span>}
                                                </button>
                                                <button onClick={() => { setFlowSortType('module'); setFlowSortDirection('desc'); }}
                                                    className={`w-full text-left px-2 py-1 text-[10px] rounded-lg flex items-center justify-between ${flowSortType === 'module' && flowSortDirection === 'desc' ? 'bg-primary/10 text-primary' : 'hover:bg-slate-50'}`}
                                                >
                                                    <span>Z → A</span>
                                                    {flowSortType === 'module' && flowSortDirection === 'desc' && <span className="material-symbols-outlined text-[12px]">check</span>}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    )}
                                    {/* Expand/Collapse All */}
                                    <button
                                        onClick={() => {
                                            const newState = !allFlowExpanded;
                                            setAllFlowExpanded(newState);
                                            const newExpandedCards = {};
                                            filteredAndSortedProducts.forEach(p => { newExpandedCards[p.id] = newState; });
                                            setExpandedCards(prev => ({ ...prev, ...newExpandedCards }));
                                            // Sync to extension
                                            filteredAndSortedProducts.forEach(p => {
                                                window.postMessage({ type: 'SESAAT_CARD_EXPAND', productId: p.id, expanded: newState }, '*');
                                            });
                                        }}
                                        /* Butang buka/tutup semua — chip bergaris yang sama seperti
                                           butang susun di sebelahnya (nilai prototaip). */
                                        style={{
                                            padding: uiV39 ? '0 11px' : '6px 8px', height: uiV39 ? 32 : undefined,
                                            borderRadius: 8, display: 'flex', alignItems: 'center',
                                            border: uiV39 ? '1px solid var(--s-line-strong)' : 'none',
                                            cursor: 'pointer', background: 'transparent',
                                            color: uiV39 ? 'var(--s-ink)' : '#64748b', transition: 'all 0.15s'
                                        }}
                                        title={allFlowExpanded ? T('ws.kad.tutupSemua', 'Collapse all cards') : T('ws.kad.bukaSemua', 'Expand all cards')}
                                    >
                                        {/* v3.9 memakai ikon lucide yang SAMA dengan prototaip;
                                            rupa lama kekal pada ikon Material. Dua set ikon ini
                                            berbeza tebal garisnya, jadi mencampurkannya dalam
                                            satu bar membuatkan satu butang nampak lebih berat
                                            daripada jirannya. */}
                                        {uiV39 ? (
                                            allFlowExpanded
                                                ? <ChevronsDownUp size={16} strokeWidth={2} style={{ color: 'var(--s-ink)' }} />
                                                : <ChevronsUpDown size={16} strokeWidth={2} style={{ color: 'var(--s-ink-3)' }} />
                                        ) : (
                                            <span className="material-symbols-outlined" style={{ fontSize: 20, color: allFlowExpanded ? '#3b82f6' : '#94a3b8' }}>
                                                {allFlowExpanded ? 'unfold_less' : 'unfold_more'}
                                            </span>
                                        )}
                                    </button>
                                    </>)}

                                    {/* ── Papar semula Control Panel ────────────────────
                                        HUJUNG SEKALI, sebelah kanan ikon buka/tutup semua
                                        (arahan user 2026-08-15). Jalur ini melekat semasa
                                        menatal (`position: sticky` pada bekasnya), jadi
                                        butang kekal dicapai walau senarai sudah panjang.

                                        ⭐ Muncul HANYA semasa panel tersorok. Butang MENYOROK
                                           duduk di dalam panel itu sendiri, di kiri tajuk
                                           "Control Panel" (App.jsx) — jadi semasa panel
                                           terbuka jalur ini kekal bersih, dan pada bila-bila
                                           masa hanya SATU daripada dua kawalan itu wujud.

                                        ⛔ BERTEKS PENUH di sini, bukan ikon sahaja dan bukan
                                           "Show" sahaja: panel sudah tiada di skrin, jadi
                                           tiada apa-apa yang menamakan benda yang bakal
                                           muncul — dan butang ini SATU-SATUNYA jalan
                                           memanggilnya balik. (Ikon-sahaja pernah ditolak
                                           pada butang Optimize dalam sidebar — "org tak
                                           faham".)

                                        Keadaan dimiliki App.jsx (lajur kanan miliknya), jadi
                                        butang ini hanya wujud apabila App menghantar
                                        pengendalinya — rupa lama tidak menerima prop itu dan
                                        kekal seperti dahulu.

                                        Tab Generate tidak sampai ke sini langsung: syarat
                                        bekas di atas sudah menyingkirkannya. */}
                                    {/* ⛔ Pada tab kalendar (schedMode), butang ini DISOROK —
                                        ia dipindah ke dalam bar kalendar (arahan user
                                        2026-08-20, Style 1 Google Calendar). Tanpa
                                        `!schedMode` ia akan berganda dengan butang di situ. */}
                                    {/* Workspace v4 (arahan user 23 Okt, ikut prototaip): butang ini SENTIASA ada di kepala
                                        halaman dan bertukar Show ⇄ Hide Control Panel; butang "Hide" dalam kepala panel
                                        (App.jsx) disorok semasa v4. Classic: kelakuan lama (Show sahaja, bila tersorok). */}
                                    {uiV39 && onTogglePanelSorok && (panelSorok || slotAlatV4) && !schedMode && (
                                        <button
                                            onClick={onTogglePanelSorok}
                                            aria-expanded={!panelSorok}
                                            title={T('ws.panel.paparTitle', 'Papar Control Panel')}
                                            /* Bentuk chip yang SAMA dengan butang buka/tutup
                                               semua di sebelahnya — tinggi 32, bucu 8, satu
                                               garis nipis. Butang berteks dengan bentuk lain
                                               akan nampak seperti datang dari bar yang lain. */
                                            style={{
                                                display: 'flex', alignItems: 'center', gap: 6,
                                                height: 32, padding: '0 11px', borderRadius: 8,
                                                border: '1px solid var(--s-line-strong)',
                                                background: 'transparent', cursor: 'pointer',
                                                color: 'var(--s-ink)', fontSize: 13, fontWeight: 500,
                                                whiteSpace: 'nowrap', transition: 'all 0.15s',
                                            }}
                                        >
                                            {panelSorok ? <PanelRightOpen size={14} strokeWidth={2} /> : <PanelRightClose size={14} strokeWidth={2} />}
                                            {panelSorok ? T('ws.panel.paparButang', 'Show Control Panel') : 'Hide Control Panel'}
                                        </button>
                                    )}
                                    </div>
                                    );
                                    return slotAlatV4 ? createPortal(alatKanan, slotAlatV4) : alatKanan;
                                    })()}
                                    {/* Workspace v4 — tab Schedule (arahan user 23 Okt): Show ⇄ Hide Control Panel di kepala
                                        halaman juga (kelompok kanan di atas tidak dirender pada tab ini). Butang Show dalam bar
                                        kalendar + Hide dalam kepala panel disorok semasa v4. Rupa SAMA dengan butang kelompok kanan. */}
                                    {uiV39 && schedMode && slotAlatV4 && onTogglePanelSorok && createPortal(
                                        <button
                                            onClick={onTogglePanelSorok}
                                            aria-expanded={!panelSorok}
                                            title={T('ws.panel.paparTitle', 'Papar Control Panel')}
                                            style={{
                                                display: 'flex', alignItems: 'center', gap: 6,
                                                height: 32, padding: '0 11px', borderRadius: 8,
                                                border: '1px solid var(--s-line-strong)',
                                                background: 'transparent', cursor: 'pointer',
                                                color: 'var(--s-ink)', fontSize: 13, fontWeight: 500,
                                                whiteSpace: 'nowrap', transition: 'all 0.15s',
                                            }}
                                        >
                                            {panelSorok ? <PanelRightOpen size={14} strokeWidth={2} /> : <PanelRightClose size={14} strokeWidth={2} />}
                                            {panelSorok ? T('ws.panel.paparButang', 'Show Control Panel') : 'Hide Control Panel'}
                                        </button>,
                                        slotAlatV4,
                                    )}

                                </div>
                            </div>
                            {/* P6.3 — ChatGPT templates section: render ATAS bila tab chatgpt active. Product list tetap render bawah, di-filter ikut activeTab.
                                ⛔ v3.9: DISOROK. Kawalan Agent AI berpindah ke Control Panel
                                   kanan, yang mengenal DUA laluan sahaja — agent SESAAT dan
                                   agent pelanggan (PRO Studio). Bar ini laluan KETIGA (template
                                   Smart Custom lama, agentV bukan 2); membiarkannya bermakna
                                   pengguna melihat dua tempat menekan Run untuk kerja yang sama.
                                   Rupa lama tidak berubah. */}
                            {!uiV39 && activeTab === 'chatgpt' && !products.some(p => getProductTab(p) === 'chatgpt' && p.moduleId === 'flownity') && (
                                <ChatGPTTabView
                                    selectedProductCount={products.filter(p => p.selected && (p.tab || 'flow') === 'chatgpt').length}
                                    onRunChatGPT={handleRunChatGPT}
                                    isRunning={chatgptRunning}
                                    progress={chatgptProgress}
                                />
                            )}
                            {/* ★ AGENT SAYA (module SMART) — custom GPT milik pelanggan sendiri,
                                dikonfigurasi di PRO Studio. Berasingan daripada bar FLOWNITY di bawah. */}
                            {smartAgentBarVisible && (
                                <div className="px-3 sm:px-10 pt-4" /* v3.9 (arahan user 2026-08-11): had 1200px DIBUANG — kad melebar
   mengisi lajur, sama seperti prototaip. HANYA lebar yang berubah;
   padding, ketinggian kad dan susunan dalamannya tidak disentuh.
   Rupa lama kekal berpusat pada 1200px. */
                                style={{ maxWidth: uiV39 ? 'none' : 1200, margin: '0 auto', width: '100%' }}>
                                    <div className="bg-white rounded-xl border border-slate-200 px-4 py-2.5 shadow-sm flex items-center gap-2 flex-wrap">
                                        <div className="w-7 h-7 rounded-lg bg-violet-50 flex items-center justify-center flex-shrink-0">
                                            <span className="material-symbols-outlined text-base text-violet-500">smart_toy</span>
                                        </div>
                                        <span className="text-[11px] font-bold text-slate-700">{T('ws.agent.saya.tajuk', 'Agent Saya')}</span>
                                        <select
                                            value={smartAgentId}
                                            onChange={(e) => changeSmartAgent(e.target.value)}
                                            disabled={chatgptRunning}
                                            className="flex-1 min-w-[180px] bg-slate-50 border border-slate-200 rounded-lg text-[11px] px-2 py-1.5 font-medium"
                                        >
                                            <option value="">{T('ws.agent.saya.pilih', '— Pilih agent —')}</option>
                                            {smartAgents.map(a => (
                                                <option key={a.id} value={a.id} disabled={!a.configured}>
                                                    {/* `a.name` = nama agent yang pelanggan tulis sendiri — DATA.
                                                        Nama platform juga DATA (nama produk), jadi kedua-duanya
                                                        kekal apa adanya dalam dua-dua bahasa. */}
                                                    {a.name} · {a.platform === 'gemini' ? 'Gemini' : 'ChatGPT'}{a.configured ? '' : T('ws.agent.saya.belumConfigure', ' — belum Configure')}
                                                </option>
                                            ))}
                                        </select>
                                        {smartAgents.length === 0 && (
                                            <a href="/prostudio" className="text-[10px] font-bold text-violet-600 underline">
                                                {T('ws.agent.saya.tiadaAgent', 'Tiada agent — buka PRO Studio')}
                                            </a>
                                        )}
                                        {(() => {
                                            const selN = products.filter(p => p.selected && getProductTab(p) === 'chatgpt').length;
                                            const chosen = smartAgents.find(a => a.id === smartAgentId);
                                            const canRun = !chatgptRunning && selN > 0 && !!chosen?.configured;
                                            return (
                                                <button
                                                    onClick={runSmartAgent}
                                                    disabled={!canRun}
                                                    className={`px-3 py-1.5 rounded-lg text-white text-[11px] font-bold flex items-center gap-1 transition-all ${canRun ? 'bg-gradient-to-r from-violet-500 to-purple-600 hover:from-violet-600 hover:to-purple-700 shadow-sm' : 'bg-slate-300 cursor-not-allowed'}`}
                                                    title={!chosen ? T('ws.agent.saya.titlePilihDulu', 'Pilih agent dulu')
                                                        : !chosen.configured ? T('ws.agent.saya.titleBelumConfigure', 'Agent ini belum dikonfigurasi di PRO Studio')
                                                            : selN === 0 ? T('ws.agent.titlePilihProduk', 'Select produk dulu')
                                                                : chatgptRunning ? T('ws.agent.titleSedangJalan', 'Sedang jalan...') : T('ws.agent.saya.titleRun', 'Run Agent')}
                                                >
                                                    {chatgptRunning ? (
                                                        <><div className="w-3 h-3 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>{chatgptProgress.current}/{chatgptProgress.total}</>
                                                    ) : (
                                                        <><span className="material-symbols-outlined text-[14px]">play_arrow</span>{T('ws.agent.saya.butangRun', `Run Agent (${selN})`, { bil: selN })}</>
                                                    )}
                                                </button>
                                            );
                                        })()}
                                    </div>
                                    {chatgptRunning && chatgptProgress.label && (
                                        <div className="mt-2 px-3 py-1.5 bg-violet-50 border border-violet-100 rounded-lg text-[10px] text-violet-700 font-bold truncate">{chatgptProgress.label}</div>
                                    )}
                                </div>
                            )}

                            {/* FLOWNITY — Run ChatGPT scrape bar dalam tab ChatGPT (bila ada produk FLOWNITY dalam tab).
                                v3.9: DISOROK — `flownityScrapeBarVisible` sudah membawa `!uiV39`;
                                kawalannya kini dalam Control Panel kanan (suis Smart mati). */}
                            {flownityScrapeBarVisible && (
                                <div className="px-3 sm:px-10 pt-4" /* v3.9 (arahan user 2026-08-11): had 1200px DIBUANG — kad melebar
   mengisi lajur, sama seperti prototaip. HANYA lebar yang berubah;
   padding, ketinggian kad dan susunan dalamannya tidak disentuh.
   Rupa lama kekal berpusat pada 1200px. */
                                style={{ maxWidth: uiV39 ? 'none' : 1200, margin: '0 auto', width: '100%' }}>
                                    <div className="bg-white rounded-xl border border-slate-200 px-4 py-2.5 shadow-sm flex items-center gap-2 flex-wrap">
                                        <div className="w-7 h-7 rounded-lg bg-emerald-50 flex items-center justify-center flex-shrink-0">
                                            <span className="material-symbols-outlined text-base text-emerald-600">smart_toy</span>
                                        </div>
                                        <span className="text-[11px] font-bold text-slate-700">{T('ws.flownity.scrapeTajuk', 'Scrape Agent AI')}</span>
                                        {/* Platform scrape: ChatGPT (custom GPT) atau Gemini (Gem) — config admin berasingan */}
                                        <select
                                            value={flownityScrapePlatform}
                                            onChange={(e) => changeFlownityScrapePlatform(e.target.value)}
                                            disabled={chatgptRunning}
                                            className="flex-1 min-w-[140px] bg-slate-50 border border-slate-200 rounded-lg text-[11px] px-2 py-1.5 font-medium"
                                        >
                                            <option value="chatgpt">{flownityPlatformNames.chatgpt}</option>
                                            <option value="gemini" disabled={FLOWNITY_GEMINI_LOCKED}>{flownityPlatformNames.gemini}{FLOWNITY_GEMINI_LOCKED ? T('ws.flownity.akanDatang', ' — Akan Datang') : ''}</option>
                                        </select>
                                        {(() => {
                                            const selN = products.filter(p => p.selected).length;
                                            const canRun = !chatgptRunning && selN > 0;
                                            const runLabel = flownityScrapePlatform === 'gemini' ? 'Run Gemini' : 'Run ChatGPT';
                                            return (
                                                <button
                                                    onClick={runFlownityScrape}
                                                    disabled={!canRun}
                                                    className={`px-3 py-1.5 rounded-lg text-white text-[11px] font-bold flex items-center gap-1 transition-all ${canRun ? 'bg-emerald-600 hover:bg-emerald-700 shadow-sm' : 'bg-slate-300 cursor-not-allowed'}`}
                                                    title={selN === 0 ? T('ws.agent.titlePilihProduk', 'Select produk dulu') : chatgptRunning ? T('ws.agent.titleSedangJalan', 'Sedang jalan...') : runLabel}
                                                >
                                                    {chatgptRunning ? (
                                                        <><div className="w-3 h-3 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>{chatgptProgress.current}/{chatgptProgress.total}</>
                                                    ) : (
                                                        <><span className="material-symbols-outlined text-[14px]">play_arrow</span>{runLabel} ({selN})</>
                                                    )}
                                                </button>
                                            );
                                        })()}
                                    </div>
                                    {chatgptRunning && chatgptProgress.label && (
                                        <div className="mt-2 px-3 py-1.5 bg-emerald-50 border border-emerald-100 rounded-lg text-[10px] text-emerald-700 font-bold truncate">{chatgptProgress.label}</div>
                                    )}
                                </div>
                            )}
                            {/* v3.9: padding ATAS dibuang (`pt-8 sm:pt-12` = 48px).
                                Diukur pada prototaip: jurang antara bar tab dan kad
                                pertama ialah 17px; di sini ia 60px kerana padding itu
                                bertindan dengan padding bawah bar tab. Hasilnya jalur
                                kosong menganga yang tiada dalam prototaip.
                                Jurang kini datang SEPENUHNYA daripada padding bawah bar
                                tab (16px) — satu sumber, senang dilaras. */}
                            {/* Tepi 28px (sm:px-7) dalam v3.9 — jarak halaman v3.9 yang
                                piawai, sama seperti bar tab di atas dan `.s-work__head`.
                                Dahulu 40px (sm:px-10), tinggalan zaman kepala terapung.
                                Rupa lama kekal px-10. */}
                            {/* ⚠️ `pb-24` DIGUGURKAN pada tab Schedule. Di sana kedua-dua
                               lajur sudah mempunyai tatal sendiri dan tingginya dikira
                               tepat mengisi skrin - padding 96px di bawahnya menjadikan
                               kandungan lebih tinggi daripada kawasan tatal, jadi kawasan
                               LUAR turut boleh ditatal dan tepi kanan memapar dua bar
                               tatal. Tab lain memang perlukan ruang nafas itu. */}
                            <div className={uiV39 ? ('px-3 sm:px-7 pt-0 ' + (schedMode || senaraiV4Tetap ? 'pb-0' : 'pb-24') + (senaraiV4Tetap ? ' s-senaraiv4' : '')) : 'px-3 sm:px-10 pt-8 sm:pt-12 pb-24 space-y-4 sm:space-y-6'} /* v3.9 (arahan user 2026-08-11): had 1200px DIBUANG — kad melebar
   mengisi lajur, sama seperti prototaip. HANYA lebar yang berubah;
   padding, ketinggian kad dan susunan dalamannya tidak disentuh.
   Rupa lama kekal berpusat pada 1200px. */
                                /* Workspace v4 — tab My Agent / Flow, panel terbuka (arahan user 23 Okt: 'buat style mcm tab schedule'):
                                   bar scroll senarai rapat pada kotak kad, jurang ke Control Panel selepasnya. Padding kanan 28 → 8. */
                                style={{ maxWidth: uiV39 ? 'none' : 1200, margin: '0 auto', width: '100%', ...(slotTabV4 && !panelSorok && (activeTab === 'chatgpt' || activeTab === 'flow') ? { paddingRight: 8 } : null), ...(senaraiV4Tetap && kanvasTinggi > jalurTinggi ? { '--s-tikjad-tinggi': (kanvasTinggi - jalurTinggi) + 'px' } : null) }}>
                                {/* Tab Generate v3.9 TIDAK memapar senarai produk
                                    (arahan user 2026-08-12) — kad komposer yang
                                    mengambil tempatnya, dihantar siap dari App.jsx
                                    melalui `kandunganTabGenerate`.

                                    ⛔ Jangan isi dengan skrin "No Products" bila
                                       komposer belum sampai: ayat itu memberitahu
                                       pengguna sesuatu yang SALAH — produknya ada,
                                       cuma tidak tinggal di tab ini lagi.

                                    ⛔ Komposer dibina di App.jsx, bukan di sini,
                                       kerana SEMUA state janaan (produk staged,
                                       avatar, module aktif, kuota, laluan Generate)
                                       tinggal di sana. Memindahkannya ke fail ini
                                       bermakna menyalin state itu — dan salinan
                                       state ialah punca bug yang paling senyap. */}
                                {uiV39 && activeTab === 'all' ? kandunganTabGenerate
                                 /* Tab Schedule v3.9 (arahan user 2026-08-12): DUA grid —
                                    senarai kad di kiri, kalendar slot di kanan. Kedua-duanya
                                    kelihatan serentak kerana kerja di sini ialah MENYERET
                                    produk ke slot waktu; senarai di belakang suis
                                    menjadikannya mustahil.

                                    ⭐ 2026-08-13: senarai kiri BUKAN lagi baris ringkas
                                       "produk bervideo". Ia kad PENUH yang sama seperti tab
                                       Flow, dan isinya kad BERTANDA Schedule (keputusan
                                       user). Sebab itu ia tidak lagi menggantikan senarai
                                       kad biasa — ia MEMBUNGKUSnya: senarai yang sama
                                       mengalir masuk ke lajur kiri, kalendar menyertainya di
                                       kanan. Aduan yang membawa kepada perubahan ini: kad
                                       yang ditanda Schedule hilang daripada tab Flow tanpa
                                       muncul di mana-mana.

                                    Control Panel di sebelah kanan TIDAK disentuh — ia kekal
                                    mod lama (masa mula + selang) atas arahan user, dan
                                    itulah yang masih mengawal waktu sebenar semasa Run.

                                    ⚠️ Susunan di sini BELUM menjadi jadual sebenar. Untuk
                                       setiap video membawa tarikh dan jamnya sendiri ke
                                       TikTok, background.ts perlu diubah — dan fail itu
                                       hanya sampai kepada pelanggan melalui release
                                       extension baharu. Jangan lapor ciri ini sebagai
                                       "boleh jadual" sebelum bahagian itu dibina. */
                                 : (
                                 <SchedGrid
                                    aktif={schedMode}
                                    /* Hide/show manual (user 27 Okt). `senaraiKecut` dikira di atas
                                       (kongsi dgn bar tarikh supaya geser serentak). */
                                    kiriSorok={senaraiKecut}
                                    onTogol={() => setSenaraiSorok((v) => !v)}
                                    slotKepala={slotTabV4 ? slotKepalaSched : null}
                                    /* Ukuran hidup -> pemboleh ubah CSS. Peraturan tatal tinggal
                                       dalam ui.css supaya media query boleh mematikannya pada
                                       susun atur satu lajur; hanya NILAI datang dari sini. Tanpa
                                       ukuran (render pertama) pemboleh ubah tidak dihantar langsung
                                       dan lajur berkelakuan seperti sebelum ini.

                                       Tolak tinggi jalur alat: grid ini bermula tepat di bawah
                                       jalur itu, jadi ruang kelihatan yang tinggal untuk senarai
                                       ialah tinggi kanvas TOLAK jalur. */
                                    gayaGrid={kanvasTinggi > jalurTinggi
                                        ? { '--s-tikjad-tinggi': (kanvasTinggi - jalurTinggi) + 'px' }
                                        : undefined}
                                    /* Kepala senarai — dipindahkan ke sini daripada
                                       JadualTiktokV39 kerana senarainya sudah berpindah.
                                       Kiraan membaca senarai yang BETUL-BETUL dipapar
                                       (termasuk tapisan carian), bukan `schedKad` —
                                       angka yang tidak sepadan dengan apa yang di depan
                                       mata lebih buruk daripada tiada angka. */
                                    kepala={
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: slotTabV4 ? 0 : 14, flexWrap: 'wrap', width: '100%' }}>
                                            <span style={{ fontSize: 13, color: 'var(--s-ink)' }}>{T('ws.jadual.kepalaProduk', 'Products')}</span>
                                            <Badge tone="neutral">{filteredAndSortedProducts.length}</Badge>
                                            <span style={{ marginLeft: 'auto', display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                                                {/* Hide senarai — PILL (ikon + teks) sebelah KIRI "Time"
                                                    (arahan user 2026-11-01). Gaya SAMA dengan pill
                                                    Show/Hide Control Panel supaya mata tidak belajar dua
                                                    gaya butang. Muncul hanya bila senarai terbuka (kepala
                                                    tidak dirender semasa senarai tersorok); buka balik =
                                                    jalur nipis `.s-tikjad__buka`. */}
                                                <button
                                                    type="button"
                                                    onClick={() => setSenaraiSorok(true)}
                                                    title="Hide product list"
                                                    style={{
                                                        display: 'inline-flex', alignItems: 'center', gap: 6,
                                                        height: 32, padding: '0 11px', borderRadius: 8,
                                                        border: '1px solid var(--s-line-strong)',
                                                        background: 'transparent', cursor: 'pointer',
                                                        color: 'var(--s-ink)', fontSize: 13, fontWeight: 500,
                                                        whiteSpace: 'nowrap', transition: 'all 0.15s',
                                                    }}
                                                >
                                                    <PanelLeftClose size={14} strokeWidth={2} />
                                                    Hide list
                                                </button>
                                                <SortMenuV39
                                                    jenis={tiktokSortType}
                                                    arah={tiktokSortDirection}
                                                    onTukar={(j, a) => { setTiktokSortType(j); setTiktokSortDirection(a); }}
                                                />
                                            </span>
                                        </div>
                                    }
                                    kalendar={
                                        <JadualTiktokV39
                                            hanyaKalendar
                                            /* ⭐ Bar tarikh gaya v4 (‹ · Today · › + "Bulan Tahun")
                                               hidup HANYA bila suis v4 ON — `slotTabV4` wujud hanya
                                               bila generateV2.aktif. v3.9 live kekal rupa asal. */
                                            v4={!!slotTabV4}
                                            slotNav={schedDateNavSlot}
                                            slotBarKiri={schedAlatSlot}
                                            templates={schedTemplates}
                                            kad={schedKad}
                                            kadSemua={schedKadSemua}
                                            capsyen={schedCapsyen}
                                            susunan={schedSusunanAktif}
                                            onUbahSusunan={schedUbahSusunan}
                                            akaun={schedAkaun}
                                            akaunAktif={schedAkaunAktif}
                                            onTukarAkaun={setSchedAkaunAktif}
                                            onCiptaAkaun={schedCiptaAkaun}
                                            onNamaAkaun={schedNamaAkaun}
                                            onPadamAkaun={schedPadamAkaun}
                                            onUrusTemplate={() => setSchedModalBuka(true)}
                                            /* Show Control Panel BERTEKS dalam bar kalendar
                                               (Style 1) — muncul bila panel tersembunyi. */
                                            onPaparPanel={slotAlatV4 ? null : onTogglePanelSorok}   /* v4: butang di kepala halaman */
                                            panelSorok={panelSorok}
                                            /* ⭐ "Show list" dalam bar kalendar (arahan user 2026-11-01) —
                                               buka balik senarai bila ia tersorok. Pasangan pill "Hide list"
                                               dalam kepala. HANYA v4 (slotTabV4): di sana senarai tersorok
                                               = lajur kiri hilang, jadi buka balik perlu rumah lain. Classic
                                               kekal jalur nipis `.s-tikjad__buka` → onPaparSenarai null. */
                                            senaraiKecut={senaraiKecut}
                                            onPaparSenarai={slotTabV4 ? () => setSenaraiSorok(false) : null}
                                            setLuar={schedSetLuar}
                                            onLapor={schedLapor}
                                            /* Kalendar melapor pilihan slot naik → butang Run
                                               (Control Panel) menjalankan slot yang dipilih ini. */
                                            onPilihBerubah={(kunci) => setSchedPilih(new Set(kunci))}
                                            onRetryGagal={schedRetrySlot}
                                            bilGagal={schedSlotGagal.length}
                                            onRetrySemuaGagal={schedRetrySemuaGagal}
                                            bilSending={schedSlotRunning}
                                            onStopLarian={schedStopLarian}
                                            onTukarStatus={schedSetStatusSlot}
                                            onPadamVideo={schedPadamVideoSlot}
                                            onTukarStatusSlot={schedTukarStatusSlot}
                                            namaAkaunStatus={namaAkaunDibuka}
                                        />
                                    }
                                 >
                                 {filteredAndSortedProducts.length === 0 ? (
                                    <div className="text-center py-16">
                                        <span className="material-symbols-outlined text-5xl text-slate-300 mb-3">auto_awesome</span>
                                        {/* Ayat ini mengalir daripada TAB_NAMA — kalau tidak, tab bernama
                                            "Schedule" akan mengarahkan pengguna mencari butang "TikTok"
                                            yang sudah tiada namanya di skrin. */}
                                        {/* ⛔ 'chatgpt'/'tiktok'/'flow' = nilai tab yang dibanding — JANGAN sentuh.
                                            TAB_NAMA sudah diterjemah di tempat lahirnya, jadi ia dihantar
                                            masuk sebagai pemboleh ubah, bukan diterjemah semula di sini. */}
                                        <h3 className="text-base font-bold text-slate-500 mb-1">{activeTab === 'chatgpt' || activeTab === 'tiktok' || activeTab === 'flow' ? T('ws.senarai.kosong.tajukTab', `No ${TAB_NAMA[activeTab]} Products`, { tab: TAB_NAMA[activeTab] }) : T('ws.senarai.kosong.tajuk', 'No Products')}</h3>
                                        <p className="text-xs text-slate-400">{activeTab === 'chatgpt' ? T('ws.senarai.kosong.agent', `Mark products as ${TAB_NAMA.chatgpt} dari tab ${TAB_NAMA.flow} / ${TAB_NAMA.tiktok} untuk muncul di sini`, { agent: TAB_NAMA.chatgpt, flow: TAB_NAMA.flow, tiktok: TAB_NAMA.tiktok }) : activeTab === 'tiktok' ? T('ws.senarai.kosong.tiktok', `Mark products as ${TAB_NAMA.tiktok} to see them here`, { tiktok: TAB_NAMA.tiktok }) : T('ws.senarai.kosong.tambah', 'Add products using the form above')}</p>
                                    </div>
                                ) : (
                                    /* v3.9: SATU bingkai mengelilingi semua baris, bukan kad
                                       berasingan yang berjurang. Bingkai memegang latar dan
                                       garis luar; setiap baris cuma menyumbang garis nipis di
                                       bawahnya. Corak sama seperti prototaip.

                                       ⚠️ `overflow: hidden` SENGAJA tiada di sini. Bar pukal melekat
                                       (sticky) di dalam bingkai ini, dan mana-mana nenek moyang yang
                                       `overflow: hidden` mematikan sticky secara SENYAP. Bucu bulat
                                       dikendalikan oleh baris pertama/terakhir dalam CSS.

                                       ⭐ Workspace v4 (26 Okt, arahan user "buat la sama follow
                                          mcm kat tab schedule"): bingkai INILAH kotak tatal lajur,
                                          corak sama seperti `.s-tikjad__tatal` pada tab Schedule.
                                          `overflow-y: auto` (BUKAN hidden) jadi bar pukal sticky
                                          di dalamnya kekal hidup — ui.css memakukannya pada
                                          `top: 0` di dalam kotak ini. */
                                    <div className={uiV39 ? ('sesaat-bingkai-v39' + (senaraiV4Tetap ? ' s-senaraiv4__tatal' : '')) : undefined}>
                                    {filteredAndSortedProducts.map((productRaw, idx) => {
                                        // ★ SPLIT V2: substitusi di PINTU render — semua bacaan teks
                                        //   dalam kad (textarea, copy, modal) nampak prompts penuh
                                        //   dari detailCache; state products kekal ringan.
                                        const product = withDetail(productRaw);
                                        /* ★ Tab Schedule (arahan user 2026-08-20): kad TIDAK boleh dibuka
                                           untuk lihat/edit prompt di sini — tab ini untuk JADUAL sahaja.
                                           Kad kekal tertutup (video sahaja; klik video = preview). Edit
                                           prompt dibuat di tab Flow. `kadDibuka` memaksa tertutup dalam mod
                                           Schedule di SEMUA cawangan render, dan anak panah buka disorok. */
                                        const kadDibuka = !schedMode && !!expandedCards?.[product.id];
                                        /* Gambar produk untuk Flow: utama + tambahan. `gbrBanyak` menentukan rupa kepala kad. */
                                        const gbrTambah = uiV39 ? gambarTambahan(product) : [];
                                        const gbrBanyak = gbrTambah.length > 0;
                                        const gbrSemua = gbrBanyak ? [product.imageBase64 || product.imageUrl, ...gbrTambah].filter(Boolean) : [];
                                        const gbrDibuka = gbrBanyak && gambarBuka.has(product.id);
                                        /* Paparan besar jalur gambar (2026-09-13). Senarai SAMA seperti jalur — nombor
                                           dalam pemapar = nombor pada petak, gambar 1 bertanda Utama. */
                                        const bukaGambarBesar = (mula) => setPratontonKad({
                                            senarai: gbrSemua.map((s, k) => ({ src: s, tanda: k === 0 ? T('ws.gbr.utama', 'Utama') : '' })),
                                            mula,
                                            tajuk: product.name || '',
                                        });
                                        const isMarqueeSelected = product.selected || (previewSelectedIds && previewSelectedIds.includes(product.id));
                                        /* ★ Tanda "Tiada ruang gambar" (larian Agent Saya ditahan, 2026-09-13). Dikira semula
                                           setiap render: kad yang sudah ada ruang (gambar dibuang melalui Edit data) hilang
                                           tandanya sendiri tanpa perlu Run semula. Tick dibuang = tanda hilang (2026-09-18,
                                           peraturan sama tanda "tiada prompt" di bawah). */
                                        const _ruang = ruangGambarById[product.id];
                                        const tiadaRuangGambar = !!_ruang && (!!_ruang.pratonton || (!!product.selected && (GBR_MAKS_TAMBAHAN - gambarTambahan(product).length) < _ruang.perlu));
                                        /* ★ Tanda "Set N tiada prompt" (Run Flow ditahan, 2026-09-18). Dikira SEMULA setiap render
                                           dengan tetapan Control Panel semasa: hilang sendiri sebaik card tidak lagi menahan
                                           larian (prompt diisi · tick dibuang · set dibuang tick · Workflow ditukar). */
                                        const _pk = promptKosongById.get(product.id);
                                        const masalahPromptSemasa = !_pk ? []
                                            : _pk.pratonton ? _pk.masalah
                                            : !product.selected ? []
                                            /* Teks card sedang dimuat semula (cache tiada) → kekalkan senarai asal; kalau dikira
                                               sekarang, card tanpa teks kelihatan "semua set kosong" sekejap. */
                                            : needsDetail(productRaw) ? _pk.masalah
                                            : masalahPromptKad(product, opsyenSemakPrompt(product));
                                        const promptKosongFlow = masalahPromptSemasa.length > 0;
                                        /* Rupa oren kad SAMA untuk kedua-dua semakan (arahan user: "guna gaya yg sama"). */
                                        const kadOren = tiadaRuangGambar || promptKosongFlow;
                                        /* Di mana bar pukal muncul.
                                           Rupa lama: atas kad DIPILIH yang pertama — tanda kad ke-20,
                                           bar itu jauh di bawah dan pengguna terpaksa menatal mencarinya.
                                           v3.9 (arahan user 2026-08-10): SENTIASA di atas senarai dan
                                           melekat di situ semasa menatal, tidak kira kad mana ditanda. */
                                        const isFirstSelected = uiV39
                                            ? (idx === 0 && filteredAndSortedProducts.some(p => p.selected))
                                            : (product.selected && (idx === 0 || !filteredAndSortedProducts[idx - 1]?.selected));
                                        const selectedCount = isFirstSelected ? filteredAndSortedProducts.filter(p => p.selected).length : 0;
                                        // ★ Bulk video delete — kira video per set utk selected cards (butang hide bila 0)
                                        const selVideoCounts = isFirstSelected ? (() => {
                                            const c = { set1: 0, set2: 0, set3: 0 };
                                            filteredAndSortedProducts.forEach(p => {
                                                if (!p.selected) return;
                                                ['set1', 'set2', 'set3'].forEach(k => { if (p.prompts?.[k]?.uploadedVideo) c[k]++; });
                                            });
                                            return c;
                                        })() : null;
                                        const selVideoTotal = selVideoCounts ? selVideoCounts.set1 + selVideoCounts.set2 + selVideoCounts.set3 : 0;
                                        /* ★ Kira pil status per set utk kad terpilih (butang hide bila 0).
                                           [2026-09-18] AKAUN YANG DIBUKA sahaja, melalui `statusAkaunDibuka` —
                                           sumber yang SAMA seperti pil di skrin, jadi nombor menu = pil yang
                                           pengguna nampak. (Dahulu ia mengira SEMUA akaun sedangkan butang
                                           hanya mengubah akaun yang dibuka: menu kata "Set 1 · 1", butang tidak
                                           buat apa-apa.) Hanya tab Schedule (`schedMode`) memapar pil. */
                                        const selStatusCounts = (isFirstSelected && schedMode)
                                            ? kiraStatusAkaun(filteredAndSortedProducts.filter(p => p.selected), schedAkaunAktif)
                                            : null;
                                        const selStatusTotal = selStatusCounts ? selStatusCounts.jumlah : 0;
                                        return (
                                        <React.Fragment key={product.id}>
                                        {isFirstSelected && selectedCount >= 1 && (
                                            <div
                                                className={`flex flex-wrap items-center gap-1.5 sm:gap-2 py-2 px-2 ${uiV39 ? 'sesaat-barpukal-v39' : 'justify-center'}`}
                                                /* Melekat TEPAT di bawah jalur alat (V39_TOOLBAR_H).
                                                   zIndex lebih rendah daripada jalur itu supaya ia
                                                   menyelit di BAWAHnya, bukan menutupinya.

                                                   ⛔ Dahulunya 60px, iaitu ANGGARAN tinggi bar tab
                                                      sahaja — sedangkan jalur sebenar 130px kerana ia
                                                      turut menampung kepala yang melayang. Selagi jalur
                                                      itu telus, bar ini kelihatan "muat" di situ; sebaik
                                                      ia diberi latar pejal, bar pukal akan HILANG terus
                                                      di belakangnya. Jadi dua perubahan ini sepasang —
                                                      jangan pulangkan satu tanpa satu lagi. */
                                                style={uiV39 ? { position: 'sticky', top: jalurTinggi, zIndex: 15 } : undefined}
                                                onClick={(e) => e.stopPropagation()}
                                            >
                                                <label className="flex items-center gap-1.5 cursor-pointer group" title={T('ws.pukal.pilihSemuaTitle', 'Select All (Ctrl+A)')}>
                                                    <input
                                                        type="checkbox"
                                                        checked={filteredAndSortedProducts.every(p => p.selected)}
                                                        onChange={(e) => {
                                                            const ids = new Set(filteredAndSortedProducts.map(p => p.id));
                                                            const updated = products.map(p => ({ ...p, selected: ids.has(p.id) ? e.target.checked : p.selected }));
                                                            setProducts(updated);
                                                            saveToCloud(updated);
                                                        }}
                                                        className="w-3.5 h-3.5 rounded border-slate-300 text-primary focus:ring-primary cursor-pointer"
                                                    />
                                                    {/* v3.9 pakai perkataan prototaip: "Pilih semua" pada kotak
                                                        semak, "N dipilih" sebagai kiraan. */}
                                                    <span className="text-[10px] sm:text-[11px] font-bold text-slate-500">
                                                        {uiV39 ? T('ws.pukal.pilihSemua', `Pilih semua`) : T('ws.pukal.dipilihLama', `${selectedCount} selected`, { bil: selectedCount })}
                                                    </span>
                                                </label>
                                                {uiV39 && (
                                                    <>
                                                        <span className="sesaat-barpukal-garis" />
                                                        <span className="sesaat-barpukal-kira">{T('ws.pukal.dipilih', `${selectedCount} dipilih`, { bil: selectedCount })}</span>
                                                    </>
                                                )}
                                                <div className="w-px h-4 bg-slate-200 hidden sm:block"></div>
                                                {/* Retry — tindakan PERTAMA dalam bar, mengikut prototaip. Dalam
                                                    rupa lama ia kekal sebagai butang RETRY pada setiap kad. */}
                                                {uiV39 && (
                                                    <button
                                                        onClick={handleBulkRetry}
                                                        className="px-2 sm:px-3 py-1.5 text-[10px] sm:text-[11px] font-bold text-amber-600 rounded-xl flex items-center gap-1 sm:gap-1.5 transition-all"
                                                        title={T('ws.pukal.retryTitle', 'Jana semula pipeline untuk kad yang ditanda')}
                                                    >
                                                        <span className="material-symbols-outlined text-[14px] sm:text-[15px]">refresh</span>
                                                        {T('ws.pukal.retry', 'Retry')}
                                                    </button>
                                                )}
                                                {/* ⚠️ SUSUNAN mengikut bar tab di atas: Agent AI → Flow → Schedule
                                                    (arahan user 2026-08-10). Dua tempat yang menamakan perkara
                                                    yang sama mesti menyusunnya sama juga — kalau tidak pengguna
                                                    terpaksa mencari semula setiap kali matanya turun ke bar ini.
                                                    Namanya pun datang daripada `TAB_NAMA` yang SAMA, jadi ia
                                                    tidak boleh terpesong daripada nama tab. */}
                                                {/* P6.3 — Mark Agent AI (id kekal 'chatgpt'; Smart Custom + FLOWNITY) */}
                                                {products.some(p => p.selected && MODUL_TAB_AGENT.includes(p.moduleId)) && activeTab !== 'chatgpt' && (
                                                    <button onClick={() => handleMarkAs('chatgpt')} className="px-2 sm:px-3 py-1.5 text-[10px] sm:text-[11px] font-bold text-violet-600 hover:text-white bg-violet-50 hover:bg-violet-500 rounded-xl flex items-center gap-1 sm:gap-1.5 transition-all">
                                                        <span className="material-symbols-outlined text-[14px] sm:text-[15px]">smart_toy</span><span className="hidden sm:inline">{T('ws.pukal.mark', 'Mark')}</span> {TAB_NAMA.chatgpt}
                                                    </button>
                                                )}
                                                {activeTab !== 'flow' && (
                                                    <button onClick={() => handleMarkAs('flow')} className="px-2 sm:px-3 py-1.5 text-[10px] sm:text-[11px] font-bold text-indigo-600 hover:text-white bg-indigo-50 hover:bg-indigo-500 rounded-xl flex items-center gap-1 sm:gap-1.5 transition-all">
                                                        <span className="material-symbols-outlined text-[14px] sm:text-[15px]">merge</span><span className="hidden sm:inline">{T('ws.pukal.mark', 'Mark')}</span> {TAB_NAMA.flow}
                                                    </button>
                                                )}
                                                {activeTab !== 'tiktok' && (
                                                    <button onClick={() => handleMarkAs('tiktok')} className="px-2 sm:px-3 py-1.5 text-[10px] sm:text-[11px] font-bold text-rose-500 hover:text-white bg-rose-50 hover:bg-rose-500 rounded-xl flex items-center gap-1 sm:gap-1.5 transition-all">
                                                        <span className="material-symbols-outlined text-[14px] sm:text-[15px]">music_note</span><span className="hidden sm:inline">{T('ws.pukal.mark', 'Mark')}</span> {TAB_NAMA.tiktok}
                                                    </button>
                                                )}
                                                <div className="w-px h-4 bg-slate-200"></div>
                                                {/* ★ Fasa 6: Move to Group */}
                                                <div className="relative">
                                                    <button ref={groupDropdownBtnRef} onClick={() => { setShowGroupDropdown(prev => !prev); setShowAvatarDropdown(false); setShowDelVideoDropdown(false); setShowClearStatusDropdown(false); setShowKosongPromptDropdown(false); }} className="px-2 sm:px-3 py-1.5 text-[10px] sm:text-[11px] font-bold text-amber-600 hover:text-white bg-amber-50 hover:bg-amber-500 rounded-xl flex items-center gap-1 sm:gap-1.5 transition-all">
                                                        <span className="material-symbols-outlined text-[14px] sm:text-[15px]">folder</span><span className="hidden sm:inline">{T('ws.pukal.move', 'Move')}</span> Group
                                                        <span className="material-symbols-outlined text-[12px]">expand_more</span>
                                                    </button>
                                                    {showGroupDropdown && (
                                                        <div className={`absolute left-0 bg-white rounded-xl shadow-2xl border border-slate-200 py-1 z-50 min-w-[150px] max-h-[60vh] overflow-y-auto ${groupDropdownDirection === 'up' ? 'bottom-full mb-1' : 'top-full mt-1'}`}>
                                                            {groups.map(g => (
                                                                <button key={g} onClick={() => handleMoveToGroup(g)} className="w-full px-3 py-2 text-left text-[11px] font-medium text-slate-600 hover:bg-amber-50 hover:text-amber-700 flex items-center gap-2">
                                                                    <span className="material-symbols-outlined text-[14px] text-slate-400">folder</span>{g === 'Workspace' ? T('ws.pukal.groupUtama', 'Main Group') : g}
                                                                </button>
                                                            ))}
                                                            <div className="border-t border-slate-100 mt-1 pt-1">
                                                                {showNewGroupInput ? (
                                                                    <div className="px-2 py-1 flex gap-1">
                                                                        <input autoFocus value={newGroupName} onChange={e => setNewGroupName(e.target.value)} onKeyDown={e => { if (e.key === 'Enter') handleCreateGroup(newGroupName); if (e.key === 'Escape') { setShowNewGroupInput(false); setNewGroupName(''); } }} placeholder={T('ws.pukal.namaGroup', 'Group name')} className="flex-1 text-[11px] px-2 py-1 border border-slate-200 rounded-lg focus:outline-none focus:ring-1 focus:ring-amber-500" />
                                                                        <button onClick={() => handleCreateGroup(newGroupName)} className="px-2 py-1 text-[10px] font-bold text-white bg-amber-500 rounded-lg">{T('ws.umum.ok', 'OK')}</button>
                                                                    </div>
                                                                ) : (
                                                                    <button onClick={() => setShowNewGroupInput(true)} className="w-full px-3 py-2 text-left text-[11px] font-bold text-amber-600 hover:bg-amber-50 flex items-center gap-2">
                                                                        <span className="material-symbols-outlined text-[14px]">add</span>{T('ws.pukal.groupBaharu', 'New Group')}
                                                                    </button>
                                                                )}
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="w-px h-4 bg-slate-200"></div>
                                                {/* ★ Tukar Avatar — repoint avatar produk dipilih tanpa jana semula (GOYANG dilangkau) */}
                                                <div className="relative">
                                                    <button ref={avatarDropdownBtnRef} onClick={() => { setShowAvatarDropdown(prev => !prev); setShowGroupDropdown(false); setShowDelVideoDropdown(false); setShowClearStatusDropdown(false); setShowKosongPromptDropdown(false); }} className="px-2 sm:px-3 py-1.5 text-[10px] sm:text-[11px] font-bold text-violet-600 hover:text-white bg-violet-50 hover:bg-violet-500 rounded-xl flex items-center gap-1 sm:gap-1.5 transition-all">
                                                        <span className="material-symbols-outlined text-[14px] sm:text-[15px]">face</span><span className="hidden sm:inline">{T('ws.pukal.tukar', 'Tukar')}</span> Avatar
                                                        <span className="material-symbols-outlined text-[12px]">expand_more</span>
                                                    </button>
                                                    {showAvatarDropdown && (() => {
                                                        const eligible = filteredAndSortedProducts.filter(p => p.selected && p.moduleId !== 'goyang');
                                                        const genderSet = new Set(eligible.map(p => p.gender || 'none'));
                                                        const selGender = eligible.length === 0 ? 'none' : (genderSet.size === 1 ? [...genderSet][0] : 'mixed');
                                                        const sameGenderAvatars = (selGender === 'male' || selGender === 'female')
                                                            ? (propSavedAvatars || []).filter(a => a.gender === selGender)
                                                            : [];
                                                        /* ⛔ 'male'/'female' = nilai `p.gender` yang disimpan — JANGAN sentuh. */
                                                        const genderLabel = selGender === 'male' ? T('ws.gender.lelaki', 'Lelaki') : selGender === 'female' ? T('ws.gender.perempuan', 'Perempuan') : '';
                                                        return (
                                                        <div className={`absolute left-0 bg-white rounded-xl shadow-2xl border border-slate-200 py-1 z-50 min-w-[210px] max-h-[60vh] overflow-y-auto ${avatarDropdownDirection === 'up' ? 'bottom-full mb-1' : 'top-full mt-1'}`}>
                                                            <div className="px-3 py-1.5 text-[9px] font-bold text-slate-400 uppercase tracking-wide border-b border-slate-100">
                                                                {T('ws.avatar.tukarTajuk', 'Tukar avatar')}{genderLabel && <span className="text-violet-500">{T('ws.avatar.hanyaGender', ` · ${genderLabel} sahaja`, { gender: genderLabel })}</span>}
                                                            </div>
                                                            {/* ⚠️ Tiga mesej di bawah membawa penekanan <b> dalam rupa LAMA.
                                                                Kamus menyimpan ayat sebagai teks biasa, jadi rupa v3.9
                                                                memaparkannya tanpa <b> manakala rupa lama kekal
                                                                betul-betul seperti asal — tiada satu pun aksara berubah
                                                                untuk pelanggan hari ini. */}
                                                            {selGender === 'mixed' ? (
                                                                <div className="px-3 py-3 text-[11px] text-slate-500 leading-relaxed">
                                                                    {uiV39
                                                                        ? t('ws.avatar.campur')
                                                                        : <>Card dipilih <b>campur lelaki &amp; perempuan</b>.<br />Pilih card jantina <b>sama sahaja</b> dulu — satu avatar tak boleh untuk dua jantina.</>}
                                                                </div>
                                                            ) : selGender === 'none' ? (
                                                                <div className="px-3 py-3 text-[11px] text-slate-500 leading-relaxed">
                                                                    {uiV39
                                                                        ? t('ws.avatar.tiadaJantina')
                                                                        : <>Card dipilih <b>tiada jantina</b> — tak boleh tukar avatar (avatar mesti padan jantina dengan prompt asal).</>}
                                                                </div>
                                                            ) : sameGenderAvatars.length === 0 ? (
                                                                <div className="px-3 py-3 text-[11px] text-slate-500 leading-relaxed">
                                                                    {uiV39
                                                                        ? t('ws.avatar.tiadaAvatar', { gender: genderLabel })
                                                                        : <>Tiada avatar <b>{genderLabel}</b> dalam library kau. Buat avatar {genderLabel} dulu di panel Avatar (sidebar).</>}
                                                                </div>
                                                            ) : (
                                                                sameGenderAvatars.map(av => (
                                                                    <button key={av.id} onClick={() => { setShowAvatarDropdown(false); setAvatarChangeModal({ open: true, avatar: av, count: eligible.length }); }} className="w-full px-3 py-2 text-left text-[11px] font-medium text-slate-600 hover:bg-violet-50 hover:text-violet-700 flex items-center gap-2">
                                                                        {av.imageUrl
                                                                            ? <img src={av.imageUrl} alt="" className="w-7 h-7 rounded-md object-cover border border-violet-200 shrink-0" />
                                                                            : <span className="material-symbols-outlined text-[16px] text-slate-400 shrink-0">face</span>}
                                                                        <span className="flex-1 min-w-0">
                                                                            <span className="block truncate">{av.name || T('ws.avatar.namaLalai', 'Avatar')}</span>
                                                                            {(av.age || av.gender === 'female') && (
                                                                                <span className="block text-[9px] text-slate-400 truncate">
                                                                                    {av.age || ''}{av.gender === 'female' ? `${av.age ? ' · ' : ''}${av.hijab ? T('ws.avatar.hijab', 'Hijab') : T('ws.avatar.tiadaHijab', 'Tiada Hijab')}` : ''}
                                                                                </span>
                                                                            )}
                                                                        </span>
                                                                        <span className="material-symbols-outlined text-[13px] shrink-0" style={{ color: av.gender === 'male' ? '#60a5fa' : '#f472b6' }}>{av.gender === 'male' ? 'male' : 'female'}</span>
                                                                    </button>
                                                                ))
                                                            )}
                                                        </div>
                                                        );
                                                    })()}
                                                </div>
                                                <div className="w-px h-4 bg-slate-200"></div>
                                                {/* ★ DUPLICATE — salin kad terpilih jadi stok baharu (prompt sama, tiada kuota) */}
                                                <button
                                                    disabled={isSaving}
                                                    onClick={() => {
                                                        setShowGroupDropdown(false); setShowAvatarDropdown(false); setShowDelVideoDropdown(false); setShowClearStatusDropdown(false); setShowKosongPromptDropdown(false);
                                                        const ids = filteredAndSortedProducts.filter(p => p.selected).map(p => p.id);
                                                        if (ids.length === 0) return;
                                                        setDuplicateModal({ open: true, ids, copies: 1, busy: false });
                                                    }}
                                                    className="px-2 sm:px-3 py-1.5 text-[10px] sm:text-[11px] font-bold text-sky-600 hover:text-white bg-sky-50 hover:bg-sky-500 disabled:opacity-50 rounded-xl flex items-center gap-1 sm:gap-1.5 transition-all"
                                                    title={T('ws.pukal.duplicateTitle', 'Salin kad terpilih — prompt sama, sedia untuk Run Flow (tiada kuota generation)')}
                                                >
                                                    <span className="material-symbols-outlined text-[14px] sm:text-[15px]">content_copy</span>{T('ws.pukal.duplicate', 'Duplicate')}
                                                </button>
                                                <div className="w-px h-4 bg-slate-200"></div>
                                                {/* Save selected products to cloud */}
                                                <button onClick={handleSaveSelectedToCloud} disabled={isSaving} className="px-2 sm:px-3 py-1.5 text-[10px] sm:text-[11px] font-bold text-emerald-600 hover:text-white bg-emerald-50 hover:bg-emerald-500 disabled:opacity-50 rounded-xl flex items-center gap-1 sm:gap-1.5 transition-all">
                                                    <span className="material-symbols-outlined text-[14px] sm:text-[15px]">cloud_upload</span><span className="hidden sm:inline">{T('ws.pukal.save', 'Save')}</span> Cloud
                                                </button>
                                                <div className="w-px h-4 bg-slate-200"></div>
                                                {/* ★ STATUS — tukar atau kosongkan pil status pada kad terpilih
                                                    (2026-09-18, ganti "Kosongkan Status"; rupa dalam MenuStatusPukal.jsx).
                                                    Tab Schedule SAHAJA (di tab lain pil itu langsung tidak dipapar)
                                                    dan menyorok bila akaun yang dibuka tiada status pada kad yang
                                                    ditanda — tiada pil kelihatan = tiada apa untuk diurus.

                                                    ⛔ JANGAN guna kelas `text-slate-*` pada butang bar ini. Blok
                                                       pemetaan global dalam design/ui.css (`body.s-v39 .text-slate-500`)
                                                       berkekhususan SAMA (0,2,1) dan dimuat KEMUDIAN, jadi ia menang
                                                       seri dan teks butang keluar kelabu tema di atas permukaan
                                                       terbalik. Baris dalam PANEL selamat memakai slate — peraturan
                                                       panel (0,3,1) mengatasinya. */}
                                                {schedMode && selStatusTotal > 0 && (
                                                    <>
                                                        <MenuStatusPukal
                                                            buka={showClearStatusDropdown}
                                                            onTogol={() => { setShowClearStatusDropdown(prev => !prev); setShowAvatarDropdown(false); setShowGroupDropdown(false); setShowDelVideoDropdown(false); setShowKosongPromptDropdown(false); }}
                                                            onTutup={() => setShowClearStatusDropdown(false)}
                                                            kiraan={selStatusCounts}
                                                            labelSet={(k) => (spaces.find(s => s.id === selectedSpaceId)?.settings?.labels?.[k]) || k.replace('set', 'Set ')}
                                                            namaAkaun={namaAkaunDibuka}
                                                            onPilih={(k, st, label) => { setShowClearStatusDropdown(false); bulkTukarStatus(k, st, label); }}
                                                            T={T}
                                                        />
                                                        <div className="w-px h-4 bg-slate-200"></div>
                                                    </>
                                                )}
                                                {/* ★ KOSONGKAN PROMPT — teks prompt + caption sahaja, ikut set (2026-09-13).
                                                    SENTIASA kelihatan bila ada kad ditanda (berbeza dengan Del Video):
                                                    teks kad tertutup belum dimuat (Split V2), jadi "ada teks atau tidak"
                                                    hanya boleh dikira selepas set dipilih — bukan di sini. */}
                                                <div className="relative">
                                                    <button onClick={() => { setShowKosongPromptDropdown(prev => !prev); setShowAvatarDropdown(false); setShowGroupDropdown(false); setShowDelVideoDropdown(false); setShowClearStatusDropdown(false); }} className="sesaat-bahaya px-2 sm:px-3 py-1.5 text-[10px] sm:text-[11px] font-bold text-pink-600 hover:text-white bg-pink-50 hover:bg-pink-500 rounded-xl flex items-center gap-1 sm:gap-1.5 transition-all" title={T('ws.pukal.kosongPromptTitle', 'Kosongkan teks prompt dan caption pada kad yang ditanda — video, gambar dan data produk tidak disentuh')}>
                                                        <span className="material-symbols-outlined text-[14px] sm:text-[15px]">ink_eraser</span><span className="hidden sm:inline">{T('ws.pukal.kosong', 'Kosongkan')}</span> Prompt
                                                        <span className="material-symbols-outlined text-[12px]">expand_more</span>
                                                    </button>
                                                    {showKosongPromptDropdown && (
                                                        <div className="absolute left-0 top-full mt-1 bg-white rounded-xl shadow-2xl border border-slate-200 py-1 z-50 min-w-[170px]">
                                                            {SET_KAD.map(k => (
                                                                <button key={k} onClick={() => { setShowKosongPromptDropdown(false); requestKosongkanPrompt(k); }} className="w-full px-3 py-2 text-left text-[11px] font-medium text-slate-600 hover:bg-pink-50 hover:text-pink-600 flex items-center gap-2">
                                                                    <span className="material-symbols-outlined text-[14px] text-slate-400">ink_eraser</span>{labelSetKad(k)}
                                                                </button>
                                                            ))}
                                                            <div className="border-t border-slate-100 mt-1 pt-1">
                                                                <button onClick={() => { setShowKosongPromptDropdown(false); requestKosongkanPrompt('all'); }} className="w-full px-3 py-2 text-left text-[11px] font-bold text-pink-600 hover:bg-pink-50 flex items-center gap-2">
                                                                    <span className="material-symbols-outlined text-[14px]">delete_sweep</span>{labelSetKad('all')}
                                                                </button>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="w-px h-4 bg-slate-200"></div>
                                                {/* ★ Bulk video-only delete — hide bila selected cards takda video */}
                                                {selVideoTotal > 0 && (
                                                    <div className="relative">
                                                        <button onClick={() => { setShowDelVideoDropdown(prev => !prev); setShowAvatarDropdown(false); setShowGroupDropdown(false); setShowClearStatusDropdown(false); setShowKosongPromptDropdown(false); }} className="sesaat-bahaya px-2 sm:px-3 py-1.5 text-[10px] sm:text-[11px] font-bold text-orange-500 hover:text-white bg-orange-50 hover:bg-orange-500 rounded-xl flex items-center gap-1 sm:gap-1.5 transition-all">
                                                            <span className="material-symbols-outlined text-[14px] sm:text-[15px]">movie_off</span><span className="hidden sm:inline">{T('ws.pukal.del', 'Del')}</span> Video
                                                            <span className="material-symbols-outlined text-[12px]">expand_more</span>
                                                        </button>
                                                        {showDelVideoDropdown && (
                                                            <div className="absolute left-0 top-full mt-1 bg-white rounded-xl shadow-2xl border border-slate-200 py-1 z-50 min-w-[170px]">
                                                                {['set1', 'set2', 'set3'].map(k => selVideoCounts[k] > 0 && (
                                                                    <button key={k} onClick={() => { setShowDelVideoDropdown(false); requestBulkDeleteVideos(k); }} className="w-full px-3 py-2 text-left text-[11px] font-medium text-slate-600 hover:bg-orange-50 hover:text-orange-600 flex items-center justify-between gap-2">
                                                                        <span className="flex items-center gap-2"><span className="material-symbols-outlined text-[14px] text-slate-400">videocam_off</span>{(spaces.find(s => s.id === selectedSpaceId)?.settings?.labels?.[k]) || k.replace('set', 'Set ')}</span>
                                                                        <span className="text-[10px] font-bold text-orange-500">{selVideoCounts[k]}</span>
                                                                    </button>
                                                                ))}
                                                                <div className="border-t border-slate-100 mt-1 pt-1">
                                                                    <button onClick={() => { setShowDelVideoDropdown(false); requestBulkDeleteVideos('all'); }} className="w-full px-3 py-2 text-left text-[11px] font-bold text-orange-600 hover:bg-orange-50 flex items-center justify-between gap-2">
                                                                        <span className="flex items-center gap-2"><span className="material-symbols-outlined text-[14px]">delete_sweep</span>{T('ws.pukal.semuaSet', 'Semua Set')}</span>
                                                                        <span className="text-[10px] font-bold">{selVideoTotal}</span>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                                {selVideoTotal > 0 && <div className="w-px h-4 bg-slate-200"></div>}
                                                {/* ★ v3.0.0: Delete in floating bar */}
                                                <button onClick={() => {
                                                    const selectedIds = filteredAndSortedProducts.filter(p => p.selected).map(p => p.id);
                                                    requestDeleteProducts(selectedIds);
                                                }} className="sesaat-bahaya px-2 sm:px-3 py-1.5 text-[10px] sm:text-[11px] font-bold text-rose-500 hover:text-white bg-rose-50 hover:bg-rose-500 rounded-xl flex items-center gap-1 sm:gap-1.5 transition-all">
                                                    <span className="material-symbols-outlined text-[14px] sm:text-[15px]">delete</span><span className="hidden sm:inline">{T('ws.pukal.delete', 'Delete')}</span>
                                                </button>
                                                <div className="w-px h-4 bg-slate-200"></div>
                                                <button onClick={() => { setShowGroupDropdown(false); setShowDelVideoDropdown(false); setShowAvatarDropdown(false); setShowClearStatusDropdown(false); setShowKosongPromptDropdown(false); const ids = new Set(filteredAndSortedProducts.filter(p => p.selected).map(p => p.id)); const updated = products.map(p => ids.has(p.id) ? { ...p, selected: false } : p); setProducts(updated); }} className={`px-2 py-1.5 text-[11px] font-medium text-slate-400 hover:text-slate-600 rounded-xl flex items-center gap-1 transition-colors ${uiV39 ? 'sesaat-barpukal-batal' : ''}`} title={uiV39 ? T('ws.pukal.batalTitle', 'Batal pilihan') : undefined}>
                                                    {/* v3.9: tanda silang senyap di HUJUNG bar, bukan butang berteks
                                                        di tengah-tengah deretan tindakan (corak prototaip). */}
                                                    <span className="material-symbols-outlined text-[15px]">close</span>{uiV39 ? '' : T('ws.pukal.cancel', 'Cancel')}
                                                </button>
                                            </div>
                                        )}
                                        <div
                                            data-product-id={product.id}
                                            className={`overflow-hidden relative transition-all duration-150${uiV39 ? ' sesaat-kad-v39' : ''}`}
                                            /* ★ Sasaran jatuhan seretan susun (v3.9). Muatan 'susun:<id,id>' dari pemegang
                                               susun, atau '<id,id>' dari pemegang kalendar (tab Schedule) — kedua-duanya
                                               menyusun bila dijatuhkan pada kad. 'setvid:' (seret video set) diabaikan. */
                                            onDragOver={uiV39 ? (e) => {
                                                if (Array.from(e.dataTransfer.types || []).includes('text/plain')) { e.preventDefault(); e.dataTransfer.dropEffect = 'move'; }
                                            } : undefined}
                                            onDrop={uiV39 ? (e) => {
                                                const raw = e.dataTransfer.getData('text/plain') || '';
                                                /* 'setvid:' = seret video set ke kalendar · 'gbr:' = susun gambar
                                                   DALAM kad (dikendali oleh petak gambar itu sendiri). Tanpa pagar
                                                   ini, muatan 'gbr:' dibaca sebagai senarai id kad → kiraSusunanSeret
                                                   menomborkan semula seluruh senarai atas id yang tidak wujud. */
                                                if (!raw || raw.startsWith('setvid:') || raw.startsWith('gbr:')) return;
                                                e.preventDefault(); e.stopPropagation();
                                                susunKadSeret(raw.replace(/^susun:/, '').split(',').filter(Boolean), product.id);
                                            } : undefined}
                                            onClick={() => {
                                                const updated = products.map(p => p.id === product.id ? { ...p, selected: !p.selected } : p);
                                                setProducts(updated);
                                                saveToCloud(updated);
                                            }}
                                            style={{
                                                borderRadius: 12,
                                                boxShadow: kadOren ? '0 0 0 1px #f59e0b, 0 2px 8px rgba(245,158,11,0.15)' : isMarqueeSelected ? '0 0 0 1px #2563eb, 0 2px 8px rgba(37,99,235,0.1)' : '0 1px 4px rgba(0,0,0,0.04)',
                                                border: kadOren ? '1px solid #f59e0b' : isMarqueeSelected ? '1px solid #2563eb' : getProductTab(product) === 'tiktok' ? '1px solid rgba(244,63,94,0.3)' : getProductTab(product) === 'flow' ? '1px solid rgba(99,102,241,0.3)' : '1px solid transparent',
                                                background: kadOren ? '#fffbeb' : isMarqueeSelected ? '#f0f7ff' : '#ffffff',
                                                cursor: 'pointer',
                                                userSelect: 'none',
                                                /* v3.9 — warna kad ikut token prototaip (`--s-card`, `--s-line`).
                                                   Diletak SELEPAS nilai lama supaya ia menimpa secara semula jadi;
                                                   tanpa itu terpaksa guna !important dalam CSS, dan lapisan
                                                   !important pada kad ialah punca rupa kad jadi susah diramal. */
                                                ...(uiV39 ? {
                                                    /* Setiap baris MELUKIS latarnya sendiri, bukan bekas di luar.
                                                       Sebabnya bar pukal duduk di dalam bekas yang sama: kalau
                                                       bekas itu yang melukis latar, jurang antara bar dan baris
                                                       pertama menunjukkan warna yang SAMA — bar nampak melekat
                                                       pada senarai. Dengan baris melukis sendiri, jurang itu
                                                       menunjukkan latar halaman dan bar berdiri sendiri.

                                                       Bucu 16px hanya pada baris pertama dan terakhir, supaya
                                                       deretan baris kekal kelihatan seperti SATU bingkai. */
                                                    background: kadOren ? 'linear-gradient(var(--s-warn-soft), var(--s-warn-soft)), var(--s-card)' : isMarqueeSelected ? 'var(--s-fill)' : 'var(--s-card)',
                                                    /* Bingkai kad dibentuk oleh BARIS, bukan oleh bekas di luar:
                                                       tepi kiri/kanan pada setiap baris, tepi atas pada baris
                                                       pertama, tepi bawah pada semua. Hasilnya satu kotak
                                                       bergaris keliling seperti prototaip.

                                                       ⚠️ Bekas di luar TIDAK boleh memegang bingkai itu — bar
                                                          pukal melekat hidup di dalam bekas yang sama, jadi
                                                          bingkai di situ akan mengurung bar itu sekali dan
                                                          jurang antara bar dan senarai hilang. */
                                                    border: 'none',
                                                    borderLeft: '1px solid var(--s-line)',
                                                    borderRight: '1px solid var(--s-line)',
                                                    borderTop: idx === 0 ? '1px solid var(--s-line)' : 'none',
                                                    borderBottom: '1px solid var(--s-line)',
                                                    borderRadius: 0,
                                                    ...(idx === 0 ? { borderTopLeftRadius: 16, borderTopRightRadius: 16 } : null),
                                                    ...(idx === filteredAndSortedProducts.length - 1 ? { borderBottomLeftRadius: 16, borderBottomRightRadius: 16 } : null),
                                                    boxShadow: kadOren
                                                        ? (isMarqueeSelected ? 'inset 2px 0 0 var(--s-select), inset 0 0 0 1.5px var(--s-warn)' : 'inset 0 0 0 1.5px var(--s-warn)')
                                                        : isMarqueeSelected ? 'inset 2px 0 0 var(--s-select)' : 'none',
                                                } : null),
                                                /* Ruang untuk jalur pemegang seret (tab Schedule sahaja).
                                                   Jalur itu diletak secara mutlak supaya susunan dalaman
                                                   kad — yang dikongsi dengan tab lain — tidak perlu
                                                   disentuh langsung. */
                                                ...((schedMode || uiV39) ? { paddingLeft: 26 } : null),
                                            }}>
                                            {/* ---------- Pemegang seret (tab Schedule) ----------
                                                Kad penuh dipakai di tab Schedule (keputusan user
                                                2026-08-13), jadi seretan perlukan pemegangnya sendiri:
                                                kad ini sudah menggunakan kliknya untuk menanda pilihan
                                                dan mengandungi textarea apabila dibuka.

                                                Tanda 1·2·3 di sini ialah SATU-SATUNYA tempat pengguna
                                                dapat tahu set mana sudah masuk kalendar — pada baris
                                                ringkas dahulu ia duduk di sebelah nama produk. */}
                                            {/* ★ Pemegang SUSUN kad (v3.9, semua tab kecuali Schedule — di sana pemegang
                                                kalendar mengambil tempat yang sama dan jatuhan pada kad tetap menyusun). */}
                                            {uiV39 && !schedMode && (() => {
                                                const idsSeret = product.selected
                                                    ? filteredAndSortedProducts.filter(p => p.selected).map(p => p.id)
                                                    : [product.id];
                                                const pukal = idsSeret.length > 1;
                                                return (
                                                    <span
                                                        className={'s-jadgrip' + (pukal ? ' s-jadgrip--pukal' : '')}
                                                        draggable
                                                        onClick={(e) => e.stopPropagation()}
                                                        onDragStart={(e) => {
                                                            e.stopPropagation();
                                                            e.dataTransfer.setData('text/plain', 'susun:' + idsSeret.join(','));
                                                            e.dataTransfer.effectAllowed = 'move';
                                                        }}
                                                        title={pukal
                                                            ? T('ws.susun.seret.pukal', `Seret ${idsSeret.length} kad bertanda sekali gus untuk menyusun`, { bil: idsSeret.length })
                                                            : T('ws.susun.seret.tunggal', 'Seret untuk menyusun kad')}
                                                    >
                                                        {pukal && <span className="s-jadgrip__kira">{idsSeret.length}</span>}
                                                        <GripVertical size={13} strokeWidth={2} aria-hidden="true" />
                                                    </span>
                                                );
                                            })()}
                                            {schedMode && (() => {
                                                const gunaSet = schedSetGuna[product.id] || [];
                                                const luarSet = schedSetLuar[product.id] || {};
                                                /* Boleh diseret selagi ada set yang belum masuk kalendar
                                                   INI. Video tidak dikira sebagai syarat — slot memang
                                                   boleh menunggu videonya. */
                                                const bolehSeret = gunaSet.length < 3;
                                                /* ⭐ SERETAN PUKAL (arahan user 2026-08-13). Menyeret kad
                                                   yang DITANDA membawa semua kad bertanda sekali — bukan
                                                   kad itu sahaja. Kad yang tidak ditanda kekal berseorangan,
                                                   jadi seretan tunggal tidak pernah tiba-tiba menjadi borong.

                                                   Muatan dihantar sebagai id dipisah koma; kalendar yang
                                                   memecahkannya semula. Id produk tidak pernah mengandungi
                                                   koma (`prod_<ms>_<idx>_<rawak>`). */
                                                const idsSeret = product.selected
                                                    ? filteredAndSortedProducts.filter(p => p.selected).map(p => p.id)
                                                    : [product.id];
                                                const pukal = idsSeret.length > 1;
                                                return (
                                                    <span
                                                        className={'s-jadgrip' + (bolehSeret ? '' : ' s-jadgrip--habis') + (pukal ? ' s-jadgrip--pukal' : '')}
                                                        draggable={bolehSeret}
                                                        onClick={(e) => e.stopPropagation()}
                                                        onDragStart={(e) => {
                                                            e.dataTransfer.setData('text/plain', idsSeret.join(','));
                                                            /* ⚠️ 'copyMove', BUKAN 'copy'. Slot kalendar
                                                               mengisytiharkan `dropEffect = 'move'` (ia
                                                               melayan seretan pindah-slot dengan sasaran yang
                                                               SAMA), dan browser membatalkan seluruh operasi
                                                               apabila dropEffect sasaran tiada dalam
                                                               effectAllowed sumber — jatuhan langsung tidak
                                                               pernah berlaku, tanpa ralat, walaupun seretan
                                                               kelihatan berjalan dan slot menyala.
                                                               (Aduan user 2026-08-15: "drag ke kalendar tak
                                                               masuk".) Menyempitkannya semula kepada 'copy'
                                                               akan mematikan ciri ini sekali lagi. */
                                                            e.dataTransfer.effectAllowed = 'copyMove';
                                                        }}
                                                        title={!bolehSeret
                                                            ? T('ws.jadual.seret.habis', 'Ketiga-tiga set sudah ada dalam kalendar ini')
                                                            : pukal
                                                                ? T('ws.jadual.seret.pukal', `Seret ${idsSeret.length} kad bertanda sekali gus · bilangan slot mengikut template hari yang dijatuhkan`, { bil: idsSeret.length })
                                                                : T('ws.jadual.seret.tunggal', `Seret ke slot kalendar · ${gunaSet.length}/3 set sudah dijadualkan`, { guna: gunaSet.length })}
                                                    >
                                                        {/* Bilangan kad yang akan ikut sama. Tanpa angka ini,
                                                            seretan pukal dan seretan tunggal kelihatan serupa
                                                            sehinggalah slot terisi. */}
                                                        {pukal && <span className="s-jadgrip__kira">{idsSeret.length}</span>}
                                                        <GripVertical size={13} strokeWidth={2} aria-hidden="true" />
                                                        <span className="s-jadgrip__set">
                                                            {['set1', 'set2', 'set3'].map((sk, si) => {
                                                                const adaVideo = !!product.prompts?.[sk]?.uploadedVideo;
                                                                const dijadual = gunaSet.includes(sk);
                                                                const diLuar = !dijadual && !!luarSet[sk];
                                                                return (
                                                                    <span
                                                                        key={sk}
                                                                        className={
                                                                            's-seret__titik'
                                                                            + (adaVideo ? ' s-seret__titik--ada' : '')
                                                                            + (diLuar ? ' s-seret__titik--luar' : '')
                                                                            + (dijadual ? ' s-seret__titik--guna' : '')
                                                                        }
                                                                        title={
                                                                            dijadual ? T('ws.jadual.titik.dijadual', `Set ${si + 1}: sudah dalam kalendar ini`, { n: si + 1 })
                                                                                : diLuar ? T('ws.jadual.titik.diLuar', `Set ${si + 1}: sudah dijadualkan pada ${luarSet[sk]}`, { n: si + 1, tarikh: luarSet[sk] })
                                                                                    : adaVideo ? T('ws.jadual.titik.sedia', `Set ${si + 1}: sedia`, { n: si + 1 })
                                                                                        : T('ws.jadual.titik.tiadaVideo', `Set ${si + 1}: tiada video lagi`, { n: si + 1 })
                                                                        }
                                                                    >
                                                                        {si + 1}
                                                                    </span>
                                                                );
                                                            })}
                                                        </span>
                                                    </span>
                                                );
                                            })()}
                                            {/* ★ v3.0.0: Mark indicator — absolute top-left, overlapping card.
                                                v3.9 menggunakan chip dalam baris pautan sebaliknya, jadi pil ini
                                                disorok di sana — kalau tidak, kad ada DUA butang tanda. */}
                                            {!uiV39 && getProductTab(product) === 'flow' && (
                                                <button
                                                    onClick={(e) => { e.stopPropagation(); const updated = products.map(p => p.id === product.id ? { ...p, tab: 'tiktok', status: 'ready_tiktok', movedAt: Date.now() } : p); setProducts(updated); saveToCloud(updated); }}
                                                    style={{ position: 'absolute', top: 6, left: 8, zIndex: 10 }}
                                                    className="px-2 py-0.5 text-[9px] font-bold text-indigo-600 bg-indigo-50/90 hover:bg-indigo-100 rounded-lg flex items-center gap-1 transition-all backdrop-blur-sm"
                                                    title={T('ws.kad.pilTandaTiktok', 'Click to mark as TikTok')}
                                                >
                                                    <span className="material-symbols-outlined text-[12px]">merge</span>
                                                    Flow
                                                </button>
                                            )}
                                            {!uiV39 && getProductTab(product) === 'tiktok' && (
                                                <button
                                                    onClick={(e) => { e.stopPropagation(); const updated = products.map(p => p.id === product.id ? { ...p, tab: 'flow', status: p.status === 'ready_tiktok' ? 'generated' : p.status, movedAt: Date.now() } : p); setProducts(updated); saveToCloud(updated); }}
                                                    style={{ position: 'absolute', top: 6, left: 8, zIndex: 10 }}
                                                    className="px-2 py-0.5 text-[9px] font-bold text-rose-500 bg-rose-50/90 hover:bg-rose-100 rounded-lg flex items-center gap-1 transition-all backdrop-blur-sm"
                                                    title={T('ws.kad.pilTandaFlow', 'Click to mark as Flow')}
                                                >
                                                    <span className="material-symbols-outlined text-[12px]">music_note</span>
                                                    TikTok
                                                </button>
                                            )}
                                            {(product.isGenerating || product.generationFailed) && (
                                                /* Lapisan v3.9 = LUT SINAR 40% (pilihan user 2026-08-13),
                                                   warnanya datang daripada token `--s-wash-jana` kerana ia
                                                   BERTUKAR ARAH ikut tema: PUTIH di atas kad gelap, HITAM di
                                                   atas kad putih (mod terang, 2026-08-16). Nilai keras di sini
                                                   dahulu bermakna mod terang menyapu putih ke atas kad putih —
                                                   iaitu tiada apa-apa yang kelihatan.

                                                   Dua sebab ia putih (mod gelap) dan bukan gelap:
                                                   (a) kad yang sedang menjana mesti terpisah jelas daripada kad gelap
                                                       yang pipelinenya sudah siap — baris terang di tengah senarai
                                                       gelap tidak boleh tersalah lihat;
                                                   (b) lut sinar supaya gambar dan nama produk kekal nampak. Bila 30 kad
                                                       menjana serentak, lapisan legap menjadikan kesemuanya kotak
                                                       serupa dan pelanggan hilang jejak kad mana produk mana.

                                                   ⚠️ 40% bukan angka rasa — ia DIUKUR. Lapisan putih turut meliputi
                                                   teks kad, dan teks itu memang sudah putih (#FAFAFA), jadi makin
                                                   tinggi peratus makin latar naik ke arah warna teks sendiri:
                                                       88% → latar #dfdfdf, nisbah beza teks 1.28:1  (hampir ghaib)
                                                       55% → latar #949494, 2.91:1                   (menyusahkan)
                                                       40% → latar #727272, 4.61:1                   ← dipilih
                                                       28% → latar #575757, 6.92:1                   (kesan putih pudar)
                                                   4.5:1 ialah paras teks kecil boleh dibaca selesa. Menaikkan peratus
                                                   ini SEMESTINYA mengaburkan nama produk — jangan naikkan tanpa
                                                   mengira semula. (Kiraan mod terang: tokens.css, blok `html.s-light`.)

                                                   Keadaan GAGAL dikecualikan — ia masih memakai lapisan legap lama
                                                   kerana rekaannya belum diputuskan. */
                                                <div
                                                    className={`absolute inset-0 z-50 flex flex-col items-center justify-center transition-all duration-300 ${
                                                        uiV39 && !product.generationFailed ? 's-lapisjana' : 'bg-white/95 dark:bg-slate-900/95 backdrop-blur-sm'
                                                    }`}
                                                >
                                                    {/* Warna lapisan berpindah ke anak ini (2026-08-16) supaya ia boleh
                                                        BERNAFAS tanpa melunturkan kapsul sekali — lihat nota `.s-lapisjana`
                                                        dalam ui.css. Kepekatan `--s-wash-jana` tidak berubah walau sedikit;
                                                        yang bertukar hanyalah tempat ia disapu. */}
                                                    {uiV39 && !product.generationFailed && (
                                                        <span className="s-lapisjana__wash" aria-hidden="true" />
                                                    )}
                                                    {product.generationFailed ? (
                                                        kadDibuka ? (
                                                        /*★ FAILED STATE — show error + retry */
                                                        <>
                                                            <div className="w-12 h-12 rounded-full bg-red-100 dark:bg-red-900/30 flex items-center justify-center mb-3">
                                                                <span className="material-symbols-outlined text-2xl text-red-500">error</span>
                                                            </div>
                                                            <h3 className="text-sm font-bold text-red-600 dark:text-red-400 mb-2">
                                                                {product.generationFailed.systemSide ? T('ws.jana.gagal.gangguan', 'Gangguan Sementara') : T('ws.jana.gagal.tajuk', 'Pipeline Gagal')}
                                                            </h3>
                                                            <p className="text-[11px] text-slate-500 dark:text-slate-400 text-center px-6 mb-4 max-w-[220px] leading-relaxed">
                                                                {product.generationFailed.error}
                                                            </p>
                                                            <div className="flex items-center gap-2">
                                                                {/* Gangguan pihak kita (systemSide) — Retry DISOROK. Tekan berulang tak
                                                                    membantu & dulu jadi punca pelanggan habiskan kuota beramai-ramai. */}
                                                                {!product.generationFailed.systemSide && (
                                                                <button
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        const logicId = product.generationFailed.logicId || product.logicId;
                                                                        // Clear failed state and start retry
                                                                        setProducts(prev => prev.map(p => p.id === product.id ? { ...p, generationFailed: null } : p));
                                                                        if (logicId) {
                                                                            generateForProduct(product.id, logicId, product);
                                                                        }
                                                                    }}
                                                                    className="px-4 py-1.5 rounded-lg bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white text-[11px] font-bold shadow-sm active:scale-[0.97] transition-all flex items-center gap-1.5"
                                                                >
                                                                    <span className="material-symbols-outlined text-[14px]">refresh</span>
                                                                    Retry
                                                                </button>
                                                                )}
                                                                <button
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        const updated = products.map(p => p.id === product.id ? { ...p, generationFailed: null } : p);
                                                                        setProducts(updated);
                                                                    }}
                                                                    className="px-4 py-1.5 rounded-lg border border-slate-200 dark:border-slate-700 text-[11px] font-bold text-slate-500 dark:text-slate-400 hover:bg-slate-50 dark:hover:bg-slate-800 transition-all"
                                                                >
                                                                    {T('ws.jana.dismiss', 'Dismiss')}
                                                                </button>
                                                            </div>
                                                        </>
                                                        ) : (
                                                        /* FAILED STATE (COLLAPSED) — compact horizontal error */
                                                        <div className="flex items-center gap-3 w-full h-full px-4 py-3">
                                                            {/* Error icon */}
                                                            <div className="shrink-0 w-9 h-9 rounded-full bg-red-100 dark:bg-red-900/30 flex items-center justify-center">
                                                                <span className="material-symbols-outlined text-[18px] text-red-500">error</span>
                                                            </div>
                                                            {/* Error info */}
                                                            <div className="flex-1 min-w-0">
                                                                <p className="text-[11px] font-bold text-red-600 dark:text-red-400 leading-tight">
                                                                    {product.generationFailed.systemSide ? T('ws.jana.gagal.gangguan', 'Gangguan Sementara') : T('ws.jana.gagal.tajuk', 'Pipeline Gagal')}
                                                                </p>
                                                                <p className="text-[10px] text-slate-500 dark:text-slate-400 truncate mt-0.5 leading-tight" title={product.generationFailed.error}>
                                                                    {product.generationFailed.error}
                                                                </p>
                                                            </div>
                                                            {/* Action buttons */}
                                                            <div className="flex items-center gap-1.5 shrink-0">
                                                                {/* Sama seperti paparan penuh — Retry disorok bila gangguan pihak kita. */}
                                                                {!product.generationFailed.systemSide && (
                                                                <button
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        const logicId = product.generationFailed.logicId || product.logicId;
                                                                        setProducts(prev => prev.map(p => p.id === product.id ? { ...p, generationFailed: null } : p));
                                                                        if (logicId) {
                                                                            generateForProduct(product.id, logicId, product);
                                                                        }
                                                                    }}
                                                                    className="px-3 py-1.5 rounded-lg bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white text-[10px] font-bold shadow-sm active:scale-[0.97] transition-all flex items-center gap-1"
                                                                >
                                                                    <span className="material-symbols-outlined text-[13px]">refresh</span>
                                                                    Retry
                                                                </button>
                                                                )}
                                                                <button
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        const updated = products.map(p => p.id === product.id ? { ...p, generationFailed: null } : p);
                                                                        setProducts(updated);
                                                                    }}
                                                                    className="w-7 h-7 rounded-full flex items-center justify-center text-slate-300 dark:text-slate-600 hover:text-slate-500 dark:hover:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-800 transition-all"
                                                                    title={T('ws.jana.dismiss', 'Dismiss')}
                                                                >
                                                                    <span className="material-symbols-outlined text-[14px]">close</span>
                                                                </button>
                                                            </div>
                                                        </div>
                                                        )
                                                    ) : uiV39 ? (
                                                        /* ★ v3.9 — KAPSUL GELAP TERAPUNG (pilihan user 2026-08-13)
                                                           Satu kapsul melayan kad terbuka DAN kad tertutup kerana ia
                                                           dipusatkan pada lapisan; tiada cabang expanded/collapsed
                                                           berasingan seperti tema lama.

                                                           Peraturan v3.9 dipatuhi: tiada gradien, tiada emoji, ikon
                                                           lucide (bukan Material Symbols string macam tema lama).

                                                           ⚠️ KAPSUL SENTIASA BERTENTANGAN DENGAN LAPISAN — kedua-duanya
                                                           kini datang daripada token berpasangan (`--s-wash-jana` +
                                                           `--s-kapsul*`, tokens.css) supaya ia bertukar arah serentak:
                                                           mod gelap = lapisan putih + kapsul hitam; mod terang = lapisan
                                                           hitam + kapsul putih. Jangan tetapkan warna keras di sini
                                                           semula — kapsul hitam yang tertinggal dalam mod terang
                                                           (keadaan sebelum 2026-08-16) terapung sendirian di atas kad
                                                           putih yang lapisannya langsung tidak kelihatan.

                                                           Warna dalaman (bulatan, ikon, garis pemisah, butang tutup)
                                                           guna `currentColor` + kelegapan, jadi ia ikut kapsul sendiri
                                                           tanpa perlu senarai warna kedua.

                                                           ⚠️ TIADA bar kemajuan di sini, dan itu DISENGAJAKAN. Server
                                                           hanya melaporkan satu keadaan — 'generating' kemudian
                                                           'complete' (totalSteps:1). Peratusan pada overlay lama
                                                           dikira daripada senarai tiga langkah yang dibina di klien,
                                                           jadi ia angka rekaan. Jangan tambah bar di sini melainkan
                                                           server benar-benar melaporkan kemajuan setiap set. */
                                                        <div
                                                            className="inline-flex items-center gap-[7px] rounded-full s-kapsuljana"
                                                            style={{
                                                                background: 'var(--s-kapsul)',
                                                                color: 'var(--s-kapsul-ink)',
                                                                padding: '6px 7px 6px 10px',
                                                                fontSize: 11.5,
                                                                fontWeight: 700,
                                                                letterSpacing: '.01em',
                                                                whiteSpace: 'nowrap',
                                                                boxShadow: 'var(--s-kapsul-shadow)',
                                                            }}
                                                        >
                                                            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" className="shrink-0">
                                                                <circle cx="12" cy="12" r="10" stroke="currentColor" strokeOpacity=".26" strokeWidth="2.4" />
                                                                <circle
                                                                    cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2.4"
                                                                    strokeLinecap="round" strokeDasharray="30 33"
                                                                    style={{ animation: 'pipeline-orbit .95s linear infinite', transformOrigin: 'center' }}
                                                                />
                                                            </svg>
                                                            {/* lucide: zap */}
                                                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="shrink-0">
                                                                <path d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z" />
                                                            </svg>
                                                            <span style={{ letterSpacing: '.05em' }}>{T('ws.jana.lencanaAi', 'PIPELINE AI')}</span>
                                                            {/* .28 = hasil darab nilai lama (.62 warna × .45 kelegapan) */}
                                                            <span className="shrink-0" style={{ width: 1, height: 11, background: 'currentColor', opacity: .28 }} />
                                                            <span style={{ fontWeight: 500, opacity: .62 }}>{T('ws.jana.kapsul.teks', 'menulis 3 set prompt…')}</span>
                                                            <button
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    const updated = products.map(p => p.id === product.id ? { ...p, isGenerating: false, generatingStatus: null } : p);
                                                                    setProducts(updated);
                                                                    saveToCloud(updated);
                                                                }}
                                                                title={T('ws.jana.batalTitle', 'Batalkan')}
                                                                className="shrink-0 grid place-items-center rounded-full"
                                                                style={{ width: 19, height: 19, border: '1px solid color-mix(in srgb, currentColor 26%, transparent)', background: 'transparent', opacity: .75 }}
                                                            >
                                                                {/* lucide: x */}
                                                                <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round">
                                                                    <path d="M18 6 6 18" /><path d="m6 6 12 12" />
                                                                </svg>
                                                            </button>
                                                        </div>
                                                    ) : kadDibuka ? (
                                                        /* ★ EXPANDED — Vertical Pipeline (full detail) */
                                                        <div className="pipeline-overlay flex flex-col items-center justify-center w-full h-full px-6">
                                                            {/* Orbital Spinner */}
                                                            <div className="relative mb-5" style={{ width: 56, height: 56 }}>
                                                                <div className="absolute inset-0 rounded-full" style={{ background: 'radial-gradient(circle, rgba(234,88,12,0.12) 0%, transparent 70%)', animation: 'pipeline-glow 2s ease-in-out infinite' }} />
                                                                <svg className="absolute inset-0" width="56" height="56" viewBox="0 0 56 56">
                                                                    <circle cx="28" cy="28" r="24" fill="none" stroke="currentColor" strokeWidth="2.5" className="text-slate-100 dark:text-slate-800" />
                                                                    <circle cx="28" cy="28" r="24" fill="none" stroke="url(#pipeGrad)" strokeWidth="2.5" strokeLinecap="round" strokeDasharray="100 51" style={{ animation: 'pipeline-orbit 1.2s linear infinite', transformOrigin: 'center' }} />
                                                                    <defs><linearGradient id="pipeGrad" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stopColor="#f59e0b" /><stop offset="100%" stopColor="#ea580c" /></linearGradient></defs>
                                                                </svg>
                                                                <div className="absolute inset-0 flex items-center justify-center">
                                                                    <span className="material-symbols-outlined text-xl" style={{ color: '#ea580c' }}>
                                                                        {product.generatingStatus?.phase === 'complete' ? 'check' : 'auto_awesome'}
                                                                    </span>
                                                                </div>
                                                            </div>

                                                            {/* Header */}
                                                            <div className="text-center mb-5">
                                                                <h3 className="text-[13px] font-extrabold tracking-tight" style={{ background: 'linear-gradient(135deg, #f59e0b, #ea580c)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
                                                                    {product.generatingStatus?.phase === 'complete' ? T('ws.jana.lama.siap', 'Pipeline Complete!') : T('ws.jana.lama.tajuk', 'AI Pipeline')}
                                                                </h3>
                                                                <p className="text-[10px] text-slate-400 dark:text-slate-500 mt-0.5 font-medium">
                                                                    {product.generatingStatus?.phase === 'complete' ? T('ws.jana.lama.semuaSelesai', 'All steps finished') : T('ws.jana.lama.memproses', 'Processing your content...')}
                                                                </p>
                                                            </div>

                                                            {/* Vertical Step List */}
                                                            {product.generatingStatus?.steps?.length > 0 ? (
                                                                <div className="w-full max-w-[260px]">
                                                                    <div className="relative">
                                                                        {/* Vertical connector line */}
                                                                        <div className="absolute left-[17px] top-[20px] bottom-[20px] w-[1.5px] bg-slate-100 dark:bg-slate-800 rounded-full" />
                                                                        <div className="absolute left-[17px] top-[20px] w-[1.5px] rounded-full transition-all duration-700 ease-out"
                                                                            style={{ height: `${Math.max(0, Math.min(100, ((product.generatingStatus.stepIndex || 0) / Math.max(1, (product.generatingStatus.totalSteps || 3) - 1)) * 100))}%`, background: 'linear-gradient(180deg, #ea580c 0%, #f59e0b 100%)', maxHeight: 'calc(100% - 40px)' }} />

                                                                        <div className="relative space-y-1">
                                                                            {product.generatingStatus.steps.map((step, si) => (
                                                                                <div key={step.id} className="pipeline-step-enter" style={{ animationDelay: `${si * 80}ms` }}>
                                                                                    <div className={`flex items-center gap-3 px-3 py-2.5 rounded-xl transition-all duration-500 ${
                                                                                        step.status === 'active' ? 'bg-amber-50/80 dark:bg-amber-950/30 shadow-sm shadow-amber-100 dark:shadow-amber-900/20'
                                                                                            : step.status === 'done' ? 'bg-orange-50/60 dark:bg-orange-950/20'
                                                                                                : 'opacity-35'
                                                                                    }`}>
                                                                                        <div className={`relative shrink-0 w-[34px] h-[34px] rounded-full flex items-center justify-center transition-all duration-500 ${
                                                                                            step.status === 'active' ? 'bg-white dark:bg-slate-800 shadow-md shadow-amber-200 dark:shadow-amber-900/30 ring-2 ring-amber-400/40'
                                                                                                : step.status === 'done' ? 'bg-orange-500 shadow-sm shadow-orange-200 dark:shadow-orange-900/30'
                                                                                                    : 'bg-slate-100 dark:bg-slate-800'
                                                                                        }`}>
                                                                                            {/* Rotating spinner ring overlay — only when active (expanded view) */}
                                                                                            {step.status === 'active' && (
                                                                                                <svg className="absolute inset-0 pointer-events-none" width="34" height="34" viewBox="0 0 34 34">
                                                                                                    <circle cx="17" cy="17" r="15" fill="none" stroke="rgba(245,158,11,0.18)" strokeWidth="2.5" />
                                                                                                    <circle cx="17" cy="17" r="15" fill="none" stroke="#ea580c" strokeWidth="2.5" strokeLinecap="round" strokeDasharray="55 40" style={{ animation: 'pipeline-orbit 1s linear infinite', transformOrigin: 'center' }} />
                                                                                                </svg>
                                                                                            )}
                                                                                            {step.status === 'done' ? (
                                                                                                <span className="material-symbols-outlined text-[16px] text-white pipeline-check-pop" style={{ fontVariationSettings: "'FILL' 1, 'wght' 600" }}>check</span>
                                                                                            ) : step.status === 'active' ? (
                                                                                                <span className="material-symbols-outlined relative text-[16px] text-orange-600" style={{ animation: 'pipeline-pulse-dot 1.5s ease-in-out infinite', fontVariationSettings: "'FILL' 1, 'wght' 600" }}>{step.icon}</span>
                                                                                            ) : (
                                                                                                <span className="material-symbols-outlined text-[14px] text-slate-300 dark:text-slate-600">{step.icon}</span>
                                                                                            )}
                                                                                        </div>
                                                                                        <div className="flex-1 min-w-0">
                                                                                            <p className={`text-[11px] font-bold tracking-wide transition-colors duration-300 ${
                                                                                                step.status === 'active' ? 'text-orange-600 dark:text-orange-400'
                                                                                                    : step.status === 'done' ? 'text-orange-700 dark:text-orange-400'
                                                                                                        : 'text-slate-400 dark:text-slate-600'
                                                                                            }`}>{step.label}</p>
                                                                                            {step.status === 'active' && (
                                                                                                <p className="text-[9px] text-slate-400 dark:text-slate-500 truncate mt-0.5 font-medium animate-pulse">{step.detail}</p>
                                                                                            )}
                                                                                            {step.status === 'done' && (
                                                                                                <p className="text-[9px] text-orange-600/70 dark:text-amber-400/60 font-medium mt-0.5">{T('ws.jana.lama.langkahSiap', 'Completed')}</p>
                                                                                            )}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    </div>

                                                                    {/* Progress bar */}
                                                                    <div className="mt-4 px-1">
                                                                        <div className="flex justify-between items-center mb-1.5">
                                                                            <span className="text-[9px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-widest">{T('ws.jana.lama.kemajuan', 'Progress')}</span>
                                                                            <span className="text-[10px] font-extrabold text-orange-600 dark:text-orange-400">{Math.round(((product.generatingStatus.stepIndex || 0) / (product.generatingStatus.totalSteps || 3)) * 100)}%</span>
                                                                        </div>
                                                                        <div className="w-full bg-slate-100 dark:bg-slate-800 rounded-full h-[5px] overflow-hidden">
                                                                            <div className="h-full rounded-full transition-all duration-700 ease-out relative"
                                                                                style={{ width: `${Math.round(((product.generatingStatus.stepIndex || 0) / (product.generatingStatus.totalSteps || 3)) * 100)}%`, background: 'linear-gradient(90deg, rgb(245,158,11), rgb(234,88,12), rgb(194,65,12))', animation: 'pipeline-bar-glow 2s ease-in-out infinite' }}>
                                                                                <div className="absolute inset-0 pipeline-shimmer-bar rounded-full" />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ) : (
                                                                <div className="flex flex-col items-center gap-2">
                                                                    <div className="flex gap-1">
                                                                        {[0,1,2].map(i => (<div key={i} className="w-1.5 h-1.5 rounded-full bg-orange-400" style={{ animation: `pipeline-pulse-dot 1.2s ease-in-out ${i * 0.2}s infinite` }} />))}
                                                                    </div>
                                                                    <p className="text-[11px] text-slate-400 dark:text-slate-500 font-medium">{T('ws.jana.lama.mulaPipeline', 'Initializing pipeline...')}</p>
                                                                </div>
                                                            )}

                                                            <button
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    const updated = products.map(p => p.id === product.id ? { ...p, isGenerating: false, generatingStatus: null } : p);
                                                                    setProducts(updated);
                                                                    saveToCloud(updated);
                                                                }}
                                                                className="mt-5 px-5 py-1.5 rounded-full text-[10px] font-bold text-slate-400 dark:text-slate-500 hover:text-red-500 dark:hover:text-red-400 border border-slate-200 dark:border-slate-700 hover:border-red-200 dark:hover:border-red-800 hover:bg-red-50/50 dark:hover:bg-red-950/20 transition-all duration-200 uppercase tracking-wider"
                                                            >
                                                                {T('ws.umum.batal', 'Cancel')}
                                                            </button>
                                                        </div>
                                                    ) : (
                                                        /* ★ COLLAPSED — Horizontal Pipeline (compact inline) */
                                                        <div className="pipeline-overlay flex items-center justify-center w-full h-full px-4 py-3">
                                                            <div className="flex items-center gap-4 w-full max-w-full">
                                                                {/* Mini spinner */}
                                                                <div className="relative shrink-0" style={{ width: 36, height: 36 }}>
                                                                    <svg width="36" height="36" viewBox="0 0 36 36">
                                                                        <circle cx="18" cy="18" r="15" fill="none" stroke="currentColor" strokeWidth="2" className="text-slate-100 dark:text-slate-800" />
                                                                        <circle cx="18" cy="18" r="15" fill="none" stroke="url(#pipeGradH)" strokeWidth="2" strokeLinecap="round" strokeDasharray="65 30" style={{ animation: 'pipeline-orbit 1.2s linear infinite', transformOrigin: 'center' }} />
                                                                        <defs><linearGradient id="pipeGradH" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stopColor="#f59e0b" /><stop offset="100%" stopColor="#ea580c" /></linearGradient></defs>
                                                                    </svg>
                                                                    <div className="absolute inset-0 flex items-center justify-center">
                                                                        <span className="material-symbols-outlined text-[14px]" style={{ color: product.generatingStatus?.phase === 'complete' ? '#ea580c' : '#ea580c' }}>
                                                                            {product.generatingStatus?.phase === 'complete' ? 'check' : 'auto_awesome'}
                                                                        </span>
                                                                    </div>
                                                                </div>

                                                                {/* ★ PIPELINE AI badge — premium feature label with glowing shimmer (user often mistakes this for a regular loading bar) */}
                                                                <div
                                                                    className="shrink-0 relative overflow-hidden flex flex-col items-center justify-center px-2.5 py-1.5 rounded-lg"
                                                                    style={{
                                                                        background: 'linear-gradient(135deg, rgb(245, 158, 11) 0%, rgb(234, 88, 12) 55%, rgb(194, 65, 12) 100%)',
                                                                        boxShadow: '0 0 6px rgba(234, 88, 12, 0.22), 0 1px 3px rgba(154, 52, 18, 0.18), inset 0 1px 0 rgba(255,255,255,0.12)',
                                                                        minHeight: 36,
                                                                        animation: 'pipeline-bar-glow 2.2s ease-in-out infinite',
                                                                    }}
                                                                    title={T('ws.jana.lencana.title', 'Pipeline AI — 3 peringkat analisis untuk hasil video berkualiti')}
                                                                >
                                                                    {/* Shimmer sweep overlay (reuse existing keyframes) */}
                                                                    <div className="absolute inset-0 pipeline-shimmer-bar pointer-events-none rounded-lg" />

                                                                    {/* Top row — relative so it paints above the absolute shimmer */}
                                                                    <div className="relative flex items-center gap-1 text-white leading-none" style={{ textShadow: '0 1px 2px rgba(120, 53, 15, 0.4)' }}>
                                                                        <span
                                                                            className="material-symbols-outlined"
                                                                            style={{ fontSize: 13, fontVariationSettings: "'FILL' 1, 'wght' 700" }}
                                                                        >
                                                                            bolt
                                                                        </span>
                                                                        <span className="text-[10px] font-extrabold tracking-wider">{T('ws.jana.lencanaAi', 'PIPELINE AI')}</span>
                                                                    </div>
                                                                    <span className="relative text-[8px] text-white/95 font-bold uppercase tracking-[0.12em] mt-0.5 leading-none" style={{ textShadow: '0 1px 2px rgba(120, 53, 15, 0.4)' }}>
                                                                        {T('ws.jana.lencana.peringkat', '3 Peringkat')}
                                                                    </span>
                                                                </div>

                                                                {/* Horizontal steps + progress */}
                                                                {product.generatingStatus?.steps?.length > 0 ? (
                                                                    <div className="flex-1 min-w-0">
                                                                        {/* Steps row */}
                                                                        <div className="flex items-center gap-1.5 mb-2">
                                                                            {product.generatingStatus.steps.map((step, si) => (
                                                                                <React.Fragment key={step.id}>
                                                                                    {si > 0 && (
                                                                                        <div className={`h-[1.5px] flex-1 min-w-[12px] max-w-[28px] rounded-full transition-all duration-500 ${
                                                                                            step.status === 'done' || step.status === 'active' ? 'bg-amber-300 dark:bg-amber-700' : 'bg-slate-200 dark:bg-slate-700'
                                                                                        }`} />
                                                                                    )}
                                                                                    <div className={`pipeline-step-enter flex items-center gap-1.5 px-2 py-1.5 rounded-lg transition-all duration-400 shrink-0 ${
                                                                                        step.status === 'active' ? 'bg-amber-50/90 dark:bg-amber-950/40 shadow-sm shadow-amber-100/50 dark:shadow-amber-900/20'
                                                                                            : step.status === 'done' ? 'bg-orange-50/70 dark:bg-orange-950/25'
                                                                                                : 'opacity-40'
                                                                                    }`} style={{ animationDelay: `${si * 60}ms` }}>
                                                                                        {/* Compact icon */}
                                                                                        <div className={`shrink-0 relative w-[24px] h-[24px] rounded-full flex items-center justify-center transition-all duration-500 ${
                                                                                            step.status === 'active' ? 'bg-white dark:bg-slate-800 shadow-sm'
                                                                                                : step.status === 'done' ? 'bg-orange-500'
                                                                                                    : 'bg-slate-100 dark:bg-slate-800'
                                                                                        }`}>
                                                                                            {/* Rotating spinner ring overlay — only when active */}
                                                                                            {step.status === 'active' && (
                                                                                                <svg className="absolute inset-0 pointer-events-none" width="24" height="24" viewBox="0 0 24 24">
                                                                                                    {/* Track */}
                                                                                                    <circle cx="12" cy="12" r="10.5" fill="none" stroke="rgba(245,158,11,0.20)" strokeWidth="2" />
                                                                                                    {/* Rotating arc */}
                                                                                                    <circle cx="12" cy="12" r="10.5" fill="none" stroke="#ea580c" strokeWidth="2" strokeLinecap="round" strokeDasharray="38 28" style={{ animation: 'pipeline-orbit 0.9s linear infinite', transformOrigin: 'center' }} />
                                                                                                </svg>
                                                                                            )}
                                                                                            {step.status === 'done' ? (
                                                                                                <span className="material-symbols-outlined text-[12px] text-white pipeline-check-pop" style={{ fontVariationSettings: "'FILL' 1, 'wght' 600" }}>check</span>
                                                                                            ) : step.status === 'active' ? (
                                                                                                <span className="material-symbols-outlined relative text-[13px] text-orange-600" style={{ animation: 'pipeline-pulse-dot 1.2s ease-in-out infinite', fontVariationSettings: "'FILL' 1, 'wght' 600" }}>{step.icon}</span>
                                                                                            ) : (
                                                                                                <span className="material-symbols-outlined text-[11px] text-slate-300 dark:text-slate-600">{step.icon}</span>
                                                                                            )}
                                                                                        </div>
                                                                                        {/* Label + detail */}
                                                                                        <div className="min-w-0">
                                                                                            <p className={`text-[10px] font-bold leading-tight transition-colors duration-300 ${
                                                                                                step.status === 'active' ? 'text-orange-600 dark:text-orange-400'
                                                                                                    : step.status === 'done' ? 'text-orange-700 dark:text-orange-400'
                                                                                                        : 'text-slate-400 dark:text-slate-600'
                                                                                            }`}>{step.label}</p>
                                                                                            {step.status === 'active' && (
                                                                                                <p className="text-[8px] text-slate-400 dark:text-slate-500 truncate font-medium animate-pulse leading-tight">{step.detail}</p>
                                                                                            )}
                                                                                        </div>
                                                                                    </div>
                                                                                </React.Fragment>
                                                                            ))}
                                                                        </div>
                                                                        {/* Thin progress bar */}
                                                                        <div className="w-full bg-slate-100 dark:bg-slate-800 rounded-full h-[3px] overflow-hidden">
                                                                            <div className="h-full rounded-full transition-all duration-700 ease-out relative"
                                                                                style={{ width: `${Math.round(((product.generatingStatus.stepIndex || 0) / (product.generatingStatus.totalSteps || 3)) * 100)}%`, background: 'linear-gradient(90deg, rgb(245,158,11), rgb(234,88,12), rgb(194,65,12))', animation: 'pipeline-bar-glow 2s ease-in-out infinite' }}>
                                                                                <div className="absolute inset-0 pipeline-shimmer-bar rounded-full" />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                ) : (
                                                                    <div className="flex items-center gap-2">
                                                                        <div className="flex gap-1">
                                                                            {[0,1,2].map(i => (<div key={i} className="w-1 h-1 rounded-full bg-orange-400" style={{ animation: `pipeline-pulse-dot 1.2s ease-in-out ${i * 0.2}s infinite` }} />))}
                                                                        </div>
                                                                        <p className="text-[10px] text-slate-400 dark:text-slate-500 font-medium">{T('ws.jana.lama.mula', 'Initializing...')}</p>
                                                                    </div>
                                                                )}

                                                                {/* Inline cancel */}
                                                                <button
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        const updated = products.map(p => p.id === product.id ? { ...p, isGenerating: false, generatingStatus: null } : p);
                                                                        setProducts(updated);
                                                                        saveToCloud(updated);
                                                                    }}
                                                                    className="shrink-0 w-7 h-7 rounded-full flex items-center justify-center text-slate-300 dark:text-slate-600 hover:text-red-500 dark:hover:text-red-400 hover:bg-red-50 dark:hover:bg-red-950/30 transition-all duration-200"
                                                                    title={T('ws.umum.batal', 'Cancel')}
                                                                >
                                                                    <span className="material-symbols-outlined text-[14px]">close</span>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                            {/* â•â• Horizontal Card Layout (40:60) — Playground Style â•â• */}
                                            {/* ★ Tab Schedule (arahan user 2026-08-21): tukar jadi LAJUR — nama
                                                di ATAS, video di BAWAH (tiru kad extension). Merampingkan kad supaya
                                                senarai boleh mengecut & kalendar dapat ruang. Dikunci pada schedMode +
                                                kad kuncup; tab Flow + kad terbuka tidak berubah. */}
                                            <div className="flex flex-col sm:flex-row w-full relative" style={{ padding: schedMode ? '12px 12px 12px 12px' : '12px 44px 12px 12px', ...(schedMode && !kadDibuka ? { flexDirection: 'column', gap: 10 } : null) }}>
                                                {/* â•â•â• LEFT SIDE (40%) — Info â•â•â• */}
                                                {/* ★ Tab Schedule (arahan user 2026-08-20): sisi kiri MENGECUT
                                                    (`1 1 auto` + minWidth 0 → nama dipangkas) supaya kawasan video
                                                    kanan sentiasa dapat 180px penuhnya — 3 gambar set tidak lagi
                                                    terpotong. Tab lain KEKAL `unset` (tiada perubahan). */}
                                                {/* ★ Gambar produk tambahan — lihat `gambarTambahan` di kepala fail.
                                                    Ada tambahan (v3.9 sahaja) → avatar naik ke DEPAN (order CSS, bukan
                                                    JSX dipindah — blok avatar panjang dan membawa logik GOYANG) dan
                                                    gambar produk jadi timbunan yang boleh dikembang. Tiada tambahan →
                                                    baris kad kekal seperti sedia ada, satu piksel pun tidak berubah. */}
                                                {/* ★ alignContent flex-start (2026-09-11): bila kad DIBUKA, lajur kiri ini
                                                    setinggi lajur set di kanan. Tanpa ini, browser membahagi ruang lebih
                                                    sama rata antara dua baris → butiran (ID · nama · chip) terhumban ke
                                                    tengah-bawah kad, bukan rapat di bawah avatar + gambar.
                                                    ★ alignItems CENTER untuk gambar berbilang (arahan user 2026-09-12): dulu
                                                    flex-start, jadi bila nama produk jadi 2 baris (atau apa-apa yang meninggikan
                                                    kad), kotak tanda + avatar + jalur gambar + butang kembang melekat di ATAS.
                                                    Dalam flex-wrap, alignItems berkuat kuasa SETIAP BARIS — jadi bila butiran
                                                    jatuh ke baris kedua, ia tetap rapat di bawah (alignContent flex-start
                                                    yang mengawal jarak antara baris, bukan alignItems). */}
                                                <div style={{ display: 'flex', alignItems: !kadDibuka ? 'center' : 'flex-start', gap: 12, flex: !kadDibuka ? (schedMode ? 'none' : 'unset') : '0 0 40%', minWidth: !kadDibuka ? (schedMode ? 0 : 'unset') : '40%', marginRight: schedMode && !kadDibuka ? 0 : 24, ...(schedMode && !kadDibuka ? { width: '100%' } : null), ...(gbrBanyak ? { flexWrap: 'wrap', alignItems: 'center', alignContent: 'flex-start', paddingLeft: 28 } : null) }}>
                                                {/* â'¡ Checkbox — Centered.
                                                    v3.9 guna kotak binaan sendiri (16px, bucu 5px, isian putih
                                                    --s-select dengan tanda gelap) sama seperti prototaip. Kotak
                                                    ASLI browser tidak boleh dijadikan begitu: `color-scheme: dark`
                                                    menjadikannya petak hitam pekat, dan `accentColor` hanya
                                                    mengubah isian masa BERTANDA — keadaan kosongnya kekal berat. */}
                                                {/* ★ Inden 28px (lebar kotak tanda + jurang) diletak pada BEKAS dan
                                                    kotak tanda ditarik keluar semula dengan margin negatif. Kesannya:
                                                    apa sahaja yang melimpah ke baris kedua — butiran produk — bermula
                                                    sejajar dengan lajur AVATAR, bukan di bawah kotak tanda (arahan user
                                                    2026-09-05). Nombor ajaib dielakkan pada butiran itu sendiri kerana
                                                    ia hanya betul apabila baris memang melimpah. */}
                                                <div className="flex items-center justify-center shrink-0" style={gbrBanyak ? { marginLeft: -28 } : undefined}>
                                                    {uiV39 ? (
                                                        <button
                                                            type="button"
                                                            role="checkbox"
                                                            aria-checked={!!product.selected}
                                                            title={product.selected ? T('ws.kad.buangTanda', 'Buang tanda') : T('ws.kad.tandakan', 'Tandakan kad')}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                const updated = products.map(p => p.id === product.id ? { ...p, selected: !p.selected } : p);
                                                                setProducts(updated);
                                                                saveToCloud(updated);
                                                            }}
                                                            style={{
                                                                width: 16, height: 16, flex: 'none', cursor: 'pointer', padding: 0,
                                                                borderRadius: 5, display: 'grid', placeItems: 'center',
                                                                border: `1px solid ${product.selected ? 'var(--s-select)' : 'var(--s-line-strong)'}`,
                                                                background: product.selected ? 'var(--s-select)' : 'transparent',
                                                            }}
                                                        >
                                                            {product.selected && (
                                                                <svg width="9" height="9" viewBox="0 0 12 12" fill="none">
                                                                    <path d="M2 6.4L4.7 9L10 3.4" stroke="#111" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
                                                                </svg>
                                                            )}
                                                        </button>
                                                    ) : (
                                                    <input
                                                        type="checkbox"
                                                        checked={product.selected || false}
                                                        onChange={(e) => {
                                                            e.stopPropagation();
                                                            const updated = products.map(p => p.id === product.id ? { ...p, selected: e.target.checked } : p);
                                                            setProducts(updated);
                                                            saveToCloud(updated);
                                                        }}
                                                        className="w-[18px] h-[18px] rounded cursor-pointer shrink-0"
                                                        style={{ accentColor: '#2563eb' }}
                                                    />
                                                    )}
                                                </div>
                                                {/* â'¢â'£ Thumbnail — 40x40 with hover overlay */}
                                                {/* v3.9: petak 68px bucu 11px — saiz prototaip. Gambar produk
                                                    dan avatar WAJIB sama saiz: dua petak berlainan saiz
                                                    bersebelahan menjadikan baris nampak sendeng. */}
                                                {gbrBanyak ? (
                                                    <div className="flex items-center gap-1.5 shrink-0" style={{ order: 2, ...(gbrDibuka ? { flex: '0 1 auto', minWidth: 0, maxWidth: '100%' } : null) }} onClick={(e) => e.stopPropagation()}>
                                                        {gbrDibuka ? (
                                                            /* TERBUKA — lima petak berbaris. Boleh geser bila kad sempit. */
                                                            <div className="flex gap-1.5 min-w-0" style={{ overflowX: 'auto', scrollbarWidth: 'none' }}>
                                                                {gbrSemua.map((src, i) => (
                                                                    <div key={i} className="relative shrink-0 pgb-ada-sudut" style={{ width: 68, height: 68, cursor: 'grab' }}
                                                                        title={T('ws.gbr.seret', `Gambar ${i + 1} — tekan untuk lihat besar, seret untuk susun. Gambar 1 ialah gambar utama`, { n: i + 1 })}
                                                                        /* Tekan (tanpa seret) = paparan besar. Browser TIDAK menghantar klik selepas
                                                                           seretan, jadi susun-dengan-seret tidak terjejas. */
                                                                        role="button"
                                                                        tabIndex={0}
                                                                        aria-label={T('gbrBesar.lihatNo', `Lihat gambar ${i + 1} saiz besar`, { n: i + 1 })}
                                                                        onClick={() => bukaGambarBesar(i)}
                                                                        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); e.stopPropagation(); bukaGambarBesar(i); } }}
                                                                        draggable
                                                                        onDragStart={(e) => { e.stopPropagation(); e.dataTransfer.setData('text/plain', `gbr:${product.id}:${i}`); e.dataTransfer.effectAllowed = 'move'; }}
                                                                        onDragOver={(e) => { const t = Array.from(e.dataTransfer.types || []); if (t.includes('text/plain')) { e.preventDefault(); e.stopPropagation(); e.dataTransfer.dropEffect = 'move'; } }}
                                                                        onDrop={(e) => {
                                                                            const raw = e.dataTransfer.getData('text/plain') || '';
                                                                            if (!raw.startsWith(`gbr:${product.id}:`)) return;
                                                                            e.preventDefault(); e.stopPropagation();
                                                                            susunGambarSeret(product.id, parseInt(raw.split(':').pop(), 10), i);
                                                                        }}>
                                                                        <img alt="" src={src} className="w-full h-full object-cover" loading="lazy" draggable={false}
                                                                            style={{ borderRadius: 11, border: `1px solid ${i === 0 ? 'var(--s-line-strong)' : 'var(--s-line)'}`, background: 'var(--s-ground)' }} />
                                                                        {/* Nombor kedudukan — inilah satu-satunya cara pengguna tahu gambar
                                                                            mana yang akan jadi gambar UTAMA selepas diseret. */}
                                                                        <span style={{ position: 'absolute', left: 4, top: 4, minWidth: 16, height: 16, padding: '0 4px', borderRadius: 6, background: 'rgba(0,0,0,.62)', color: '#fff', fontSize: 10, fontWeight: 600, lineHeight: '16px', textAlign: 'center' }}>
                                                                            {i + 1}
                                                                        </span>
                                                                        {i === 0 && (
                                                                            <span style={{ position: 'absolute', left: 0, right: 0, bottom: 0, height: 15, borderBottomLeftRadius: 11, borderBottomRightRadius: 11, background: 'rgba(0,0,0,.62)', color: '#fff', fontSize: 9, fontWeight: 600, lineHeight: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                                {T('ws.gbr.utama', 'Utama')}
                                                                            </span>
                                                                        )}
                                                                        {/* Kanta kecil muncul bila dituding — tanda petak ini boleh ditekan. */}
                                                                        <span className="pgb-sudut" aria-hidden>
                                                                            <span className="material-symbols-outlined">zoom_in</span>
                                                                        </span>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        ) : (
                                                            /* TERTUTUP — timbunan + kiraan. Lebar 76px: dua petak di belakang
                                                               dianjak 7px setiap satu supaya tepinya kelihatan. */
                                                            <div className="relative shrink-0" style={{ width: 76, height: 68, cursor: 'pointer' }} onClick={() => togolGambar(product.id)}
                                                                title={T('ws.gbr.buka', `Papar kesemua ${gbrSemua.length} gambar produk`, { bil: gbrSemua.length })}>
                                                                {gbrSemua.slice(0, 3).reverse().map((src, i) => {
                                                                    const ke = Math.min(3, gbrSemua.length) - 1 - i;
                                                                    return (
                                                                        <img key={ke} alt="" src={src} loading="lazy" className="object-cover"
                                                                            style={{ position: 'absolute', left: ke * 7, top: 8 - ke * 3, width: 60, height: 60, borderRadius: 10, border: '1px solid var(--s-line)', background: 'var(--s-ground)' }} />
                                                                    );
                                                                })}
                                                                <span style={{ position: 'absolute', left: 0, bottom: 0, padding: '1px 6px', borderRadius: 6, background: 'var(--s-ink)', color: 'var(--s-card)', fontSize: 10, fontWeight: 600, lineHeight: 1.5 }}>
                                                                    {gbrSemua.length}
                                                                </span>
                                                            </div>
                                                        )}
                                                        <button type="button" onClick={() => togolGambar(product.id)}
                                                            title={gbrDibuka ? T('ws.gbr.tutup', 'Kuncupkan gambar produk') : T('ws.gbr.buka', `Papar kesemua ${gbrSemua.length} gambar produk`, { bil: gbrSemua.length })}
                                                            style={{ width: 22, height: 22, flex: 'none', display: 'grid', placeItems: 'center', cursor: 'pointer', padding: 0, borderRadius: 7, border: '1px solid var(--s-line-strong)', background: 'transparent', color: 'var(--s-ink-2)' }}>
                                                            <span className="material-symbols-outlined" style={{ fontSize: 15 }}>{gbrDibuka ? 'chevron_left' : 'chevron_right'}</span>
                                                        </button>
                                                    </div>
                                                ) : (
                                                <div className="group/thumb relative shrink-0" style={{ width: uiV39 ? 68 : 40, height: uiV39 ? 68 : 40 }}>
                                                    {(product.imageBase64 || product.imageUrl) ? (
                                                        <img alt="thumb" className="w-full h-full object-cover" style={{ borderRadius: uiV39 ? 11 : 10, border: `1px solid ${uiV39 ? 'var(--s-line)' : '#e2e8f0'}`, background: uiV39 ? 'var(--s-ground)' : '#f8fafc' }} src={product.imageBase64 || product.imageUrl} />
                                                    ) : (
                                                        <div className="w-full h-full flex items-center justify-center" style={{ borderRadius: uiV39 ? 11 : 10, border: `1px solid ${uiV39 ? 'var(--s-line)' : '#e2e8f0'}`, background: uiV39 ? 'var(--s-ground)' : '#f8fafc' }}>
                                                            <span className={`material-symbols-outlined text-lg ${uiV39 ? '' : 'text-slate-300'}`} style={uiV39 ? { color: 'var(--s-ink-3)' } : undefined}>{product.kosong ? 'add' : 'image'}</span>
                                                        </div>
                                                    )}
                                                    {!(product.kosong && !(product.imageBase64 || product.imageUrl)) && (
                                                    <div className="absolute inset-0 bg-black/40 opacity-0 group-hover/thumb:opacity-100 transition-opacity flex flex-col items-center justify-center gap-0.5" style={{ borderRadius: 10 }}>
                                                        <button
                                                            onClick={(e) => { e.stopPropagation(); setPreviewImage(product.imageBase64 || product.imageUrl); }}
                                                            className="p-0.5 hover:bg-white/20 rounded text-white"
                                                            title={T('ws.kad.pratonton', 'Preview')}
                                                        >
                                                            <span className="material-symbols-outlined text-[14px]">zoom_in</span>
                                                        </button>
                                                        <button
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                setUploadingProductId(product.id);
                                                                fileInputRef.current.click();
                                                            }}
                                                            className="p-0.5 hover:bg-white/20 rounded text-white"
                                                            title={T('ws.kad.tukarGambar', 'Change Image')}
                                                        >
                                                            <span className="material-symbols-outlined text-[14px]">upload</span>
                                                        </button>
                                                    </div>
                                                    )}
                                                    {/* ★ [2026-11-04] Blank Card — petak gambar KOSONG: menu Add product / Add image.
                                                        Hanya muncul bila kad kosong DAN belum ada gambar (kad biasa tak berubah). */}
                                                    {product.kosong && !(product.imageBase64 || product.imageUrl) && (
                                                        <>
                                                            <button
                                                                type="button"
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    if (blankMenuFor?.id === product.id) { setBlankMenuFor(null); return; }
                                                                    const r = e.currentTarget.getBoundingClientRect();
                                                                    setBlankMenuFor({ id: product.id, x: r.left, y: r.bottom + 4 });
                                                                }}
                                                                title={T('ws.kad.tambahIsi', 'Tambah produk atau gambar')}
                                                                aria-label={T('ws.kad.tambahIsi', 'Tambah produk atau gambar')}
                                                                className="absolute inset-0"
                                                                style={{ borderRadius: 10, background: 'transparent', cursor: 'pointer' }}
                                                            />
                                                            {blankMenuFor?.id === product.id && createPortal(
                                                                /* Portal ke <body> + position fixed — elak dipotong oleh overflow kad.
                                                                   Dibalut .s-root supaya token warna --s-* kekal di luar app container. */
                                                                <div className="s-root">
                                                                    <div className="fixed inset-0 z-[9998]" onClick={(e) => { e.stopPropagation(); setBlankMenuFor(null); }} />
                                                                    <div
                                                                        className="fixed z-[9999] w-44 py-1 rounded-xl shadow-xl"
                                                                        style={{ left: blankMenuFor.x, top: blankMenuFor.y, background: 'var(--s-card)', border: '1px solid var(--s-line)' }}
                                                                        onClick={(e) => e.stopPropagation()}
                                                                    >
                                                                        <button
                                                                            type="button"
                                                                            onClick={(e) => { e.stopPropagation(); setBlankMenuFor(null); setAddProductFor(product.id); }}
                                                                            className="w-full flex items-center gap-2 px-3 py-2 text-left text-[12px] font-semibold hover:bg-[color:var(--s-ground)]"
                                                                            style={{ color: 'var(--s-ink)' }}
                                                                        >
                                                                            <span className="material-symbols-outlined text-[16px]" style={{ color: 'var(--s-ink-2)' }}>inventory_2</span>
                                                                            {T('ws.kad.tambahProduk', 'Add product')}
                                                                        </button>
                                                                        <button
                                                                            type="button"
                                                                            onClick={(e) => { e.stopPropagation(); setBlankMenuFor(null); setUploadingProductId(product.id); fileInputRef.current?.click(); }}
                                                                            className="w-full flex items-center gap-2 px-3 py-2 text-left text-[12px] font-semibold hover:bg-[color:var(--s-ground)]"
                                                                            style={{ color: 'var(--s-ink)' }}
                                                                        >
                                                                            <span className="material-symbols-outlined text-[16px]" style={{ color: 'var(--s-ink-2)' }}>image</span>
                                                                            {T('ws.kad.tambahGambar', 'Add image')}
                                                                        </button>
                                                                    </div>
                                                                </div>,
                                                                document.body
                                                            )}
                                                        </>
                                                    )}
                                                </div>
                                                )}
                                                {/* Reference Slot — 40x40 reserved (v3.9: 68x68, sama dengan gambar produk).
                                                    GOYANG: bg image > hand gender. Else: avatar > gender.
                                                    ★ Bila ada gambar tambahan, petak ini naik ke DEPAN (order 1) — avatar
                                                    sentiasa satu, jadi kedudukannya tetap walau berapa pun gambar produk. */}
                                                <div className="relative shrink-0" style={{ width: uiV39 ? 68 : 40, height: uiV39 ? 68 : 40, ...(gbrBanyak ? { order: 1 } : null) }}>
                                                    {(() => {
                                                        const isGoyang = product.moduleId === 'goyang';
                                                        const tpl = product.templateSnapshot || propSelectedTemplate;
                                                        if (isGoyang) {
                                                            const goyangBgUrl = tpl?.customBgImageUrl || '';
                                                            const goyangHandGender = tpl?.handGender || 'auto';
                                                            if (goyangBgUrl) {
                                                                /* GOYANG tiada avatar — petak ini gambar template, dan
                                                                   "hand gender" itulah gender kad ini. Jadi ia dapat
                                                                   jalur yang SAMA seperti avatar (arahan user
                                                                   2026-08-10), bukan chip berasingan pada baris badge. */
                                                                return (
                                                                    <>
                                                                        <img
                                                                            alt="template bg"
                                                                            className="w-full h-full object-cover"
                                                                            style={{ borderRadius: uiV39 ? 11 : 10, border: uiV39 ? '1px solid var(--s-line)' : '2px solid #fbbf24', background: uiV39 ? 'var(--s-ground)' : '#fef3c7' }}
                                                                            src={goyangBgUrl}
                                                                            title={T('ws.kad.templateBg', `Template BG: ${tpl?.customBgFilename || T('ws.kad.bgLalai', 'custom background')}`, { fail: tpl?.customBgFilename || T('ws.kad.bgLalai', 'custom background') })}
                                                                        />
                                                                        {uiV39 && goyangHandGender !== 'auto' && (
                                                                            <span style={{
                                                                                position: 'absolute', left: 0, right: 0, bottom: 0, height: 15,
                                                                                borderBottomLeftRadius: 11, borderBottomRightRadius: 11,
                                                                                background: 'rgba(0,0,0,.62)', color: '#fff',
                                                                                fontSize: 9, fontWeight: 600, lineHeight: 1,
                                                                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                                            }}>
                                                                                {goyangHandGender === 'male' ? T('ws.gender.lelakiRingkas', 'Men') : T('ws.gender.perempuanRingkas', 'Women')}
                                                                            </span>
                                                                        )}
                                                                    </>
                                                                );
                                                            }
                                                            if (goyangHandGender !== 'auto') {
                                                                /* Tiada gambar template — petak ikon. v3.9 letak
                                                                   PERKATAAN gender di bawah ikon (arahan user
                                                                   2026-08-10): ikon sahaja memaksa mata meneka. */
                                                                return (
                                                                    <div
                                                                        className="w-full h-full flex items-center justify-center"
                                                                        style={{
                                                                            borderRadius: uiV39 ? 11 : 10,
                                                                            border: `1px dashed ${uiV39 ? 'var(--s-line-strong)' : '#fde68a'}`,
                                                                            background: uiV39 ? 'var(--s-ground)' : '#fef3c7',
                                                                            /* Sama seperti petak gender bukan-GOYANG di bawah: emoji
                                                                               mesti mengisi petak seperti gambar di sebelahnya. */
                                                                            ...(uiV39 ? { position: 'relative', overflow: 'hidden', paddingBottom: 15 } : null),
                                                                        }}
                                                                        title={T('ws.kad.tangan', `Hand: ${goyangHandGender === 'male' ? T('ws.gender.lelaki', 'Lelaki') : T('ws.gender.perempuan', 'Perempuan')}`, { gender: goyangHandGender === 'male' ? T('ws.gender.lelaki', 'Lelaki') : T('ws.gender.perempuan', 'Perempuan') })}
                                                                    >
                                                                        <span style={{ fontSize: uiV39 ? 34 : 22, lineHeight: 1 }}>{goyangHandGender === 'male' ? '👨' : '👩'}</span>
                                                                        {uiV39 && (
                                                                            <span style={{
                                                                                position: 'absolute', left: 0, right: 0, bottom: 0, height: 15,
                                                                                borderBottomLeftRadius: 11, borderBottomRightRadius: 11,
                                                                                background: 'rgba(0,0,0,.62)', color: '#fff',
                                                                                fontSize: 9, fontWeight: 600, lineHeight: 1,
                                                                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                                            }}>
                                                                                {goyangHandGender === 'male' ? T('ws.gender.lelakiRingkas', 'Men') : T('ws.gender.perempuanRingkas', 'Women')}
                                                                            </span>
                                                                        )}
                                                                    </div>
                                                                );
                                                            }
                                                            return <div style={{ width: uiV39 ? 68 : 40, height: uiV39 ? 68 : 40 }} />;
                                                        }
                                                        // Non-GOYANG: avatar > gender > empty
                                                        if (product.avatarImageUrl) {
                                                            /* v3.9: gender duduk DI DALAM gambar avatar sebagai jalur
                                                               bawah (arahan user 2026-08-10) — bukan chip berasingan
                                                               pada baris badge. Gender memerihalkan AVATAR, bukan
                                                               produk; duduk jauh daripada avatar ia terbaca seperti
                                                               ciri produk. Jalurnya hitam lut sinar dengan teks putih
                                                               tetap, kerana ia terletak atas GAMBAR yang warnanya
                                                               tidak boleh diramal — token tema tidak selamat di situ. */
                                                            return (
                                                                <>
                                                                    <img alt="avatar" className="w-full h-full object-cover" style={{ borderRadius: uiV39 ? 11 : 10, border: uiV39 ? '1px solid var(--s-line)' : '2px solid #c4b5fd', background: uiV39 ? 'var(--s-ground)' : '#ede9fe' }} src={product.avatarImageUrl} />
                                                                    {uiV39 && product.gender && (
                                                                        <span style={{
                                                                            position: 'absolute', left: 0, right: 0, bottom: 0, height: 15,
                                                                            borderBottomLeftRadius: 11, borderBottomRightRadius: 11,
                                                                            background: 'rgba(0,0,0,.62)', color: '#fff',
                                                                            fontSize: 9, fontWeight: 600, lineHeight: 1,
                                                                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                                        }}>
                                                                            {product.gender === 'male' ? T('ws.gender.lelakiRingkas', 'Men') : T('ws.gender.perempuanRingkas', 'Women')}
                                                                        </span>
                                                                    )}
                                                                </>
                                                            );
                                                        }
                                                        if (product.gender) {
                                                            /* Pelanggan pilih "tiada avatar" tetapi tetapkan gender —
                                                               petak ikon dapat PERKATAAN gender di bawah ikon, sama
                                                               seperti petak tangan GOYANG (arahan user 2026-08-10). */
                                                            return (
                                                                <div
                                                                    className={`w-full h-full flex items-center justify-center${uiV39 ? '' : ''}`}
                                                                    style={{
                                                                        borderRadius: uiV39 ? 11 : 10,
                                                                        border: `1px dashed ${uiV39 ? 'var(--s-line-strong)' : '#cbd5e1'}`,
                                                                        background: uiV39 ? 'var(--s-ground)' : '#f8fafc',
                                                                        /* v3.9: petak ini BERSAUDARA dengan petak gambar produk dan
                                                                           gambar avatar — jadi isinya mesti mengisi ruang yang sama.
                                                                           Emoji 22px dahulu terapung kecil di tengah petak 68px,
                                                                           sedangkan dua petak jirannya penuh dengan gambar; hasilnya
                                                                           baris itu nampak seperti ada satu petak yang tercicir.
                                                                           Ruang bawah dikosongkan untuk jalur gender. */
                                                                        ...(uiV39 ? { position: 'relative', overflow: 'hidden', paddingBottom: product.gender ? 15 : 0 } : null),
                                                                    }}
                                                                >
                                                                    {/* Emoji yang SAMA dengan pemilih avatar (arahan user 2026-08-10):
                                                                        pelanggan pilih 👨 dalam dropdown, jadi kad mesti tunjuk 👨 —
                                                                        bukan lambang kedua untuk pilihan yang sama. Pengecualian
                                                                        monokrom yang sama seperti emoji tangan GOYANG di atas. */}
                                                                    {uiV39
                                                                        ? <span style={{ fontSize: 34, lineHeight: 1 }}>{product.gender === 'male' ? '👨' : '👩'}</span>
                                                                        : <span className="material-symbols-outlined" style={{ fontSize: 20, color: product.gender === 'male' ? '#3b82f6' : '#ec4899' }}>{product.gender === 'male' ? 'male' : 'female'}</span>}
                                                                    {/* Jalur gender IDENTIK dengan yang di atas gambar avatar sebenar —
                                                                        dua petak itu bersebelahan pada kad yang sama, jadi dua rupa
                                                                        berlainan untuk maklumat yang sama akan terbaca seperti dua
                                                                        benda berlainan. */}
                                                                    {uiV39 && product.gender && (
                                                                        <span style={{
                                                                            position: 'absolute', left: 0, right: 0, bottom: 0, height: 15,
                                                                            borderBottomLeftRadius: 11, borderBottomRightRadius: 11,
                                                                            background: 'rgba(0,0,0,.62)', color: '#fff',
                                                                            fontSize: 9, fontWeight: 600, lineHeight: 1,
                                                                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                                        }}>
                                                                            {product.gender === 'male' ? T('ws.gender.lelakiRingkas', 'Men') : T('ws.gender.perempuanRingkas', 'Women')}
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            );
                                                        }
                                                        /* Tiada avatar dan tiada jantina. Pada kad bergambar banyak, petak yang
                                                           betul-betul kosong membuatkan jalur gambar kelihatan tersasar ke kanan
                                                           tanpa sebab (arahan user 2026-09-05) — jadi ia diberi bingkai putus +
                                                           label. Kad biasa kekal petak kosong seperti sedia ada. */
                                                        if (uiV39 && gbrBanyak) {
                                                            return (
                                                                <div className="w-full h-full flex flex-col items-center justify-center gap-1"
                                                                    style={{ borderRadius: 11, border: '1px dashed var(--s-line-strong)', background: 'transparent' }}
                                                                    title={T('ws.gbr.tiadaAvatar', 'Tiada avatar')}>
                                                                    <span className="material-symbols-outlined" style={{ fontSize: 20, color: 'var(--s-ink-3)' }}>person_off</span>
                                                                    <span style={{ fontSize: 9, fontWeight: 600, lineHeight: 1, color: 'var(--s-ink-3)', textAlign: 'center' }}>
                                                                        {T('ws.gbr.tiadaAvatar', 'Tiada avatar')}
                                                                    </span>
                                                                </div>
                                                            );
                                                        }
                                                        return <div style={{ width: uiV39 ? 68 : 40, height: uiV39 ? 68 : 40 }} />;
                                                    })()}
                                                </div>
                                                {/* Content Column — bila ada gambar tambahan, butiran duduk di RUANG
                                                    KANAN jalur gambar (arahan user 2026-09-05, selepas melihatnya hidup:
                                                    versi pertama menjatuhkannya ke baris bawah dan meninggalkan kawasan
                                                    kosong yang besar di sebelah gambar). Asas 220px: bila kad terlalu
                                                    sempit untuk itu, bekas `flexWrap` menurunkannya sendiri ke baris
                                                    bawah — jadi nama tidak pernah terpicit jadi 2-3 aksara. */}
                                                <div className="flex-1 min-w-0" style={{ display: 'flex', flexDirection: 'column', gap: 3, ...(gbrBanyak ? { order: 3, flex: '1 1 220px' } : null) }}>
                                                    {/* Full Prompt badge moved to badge row below */}
                                                    {/* Nombor produk = ID produk TikTok. Baris SENDIRI atas nama — ID panjang
                                                        (~19 digit), kalau inline ia sepit nama produk sampai terpotong. */}
                                                    <div title={T('ws.kad.idTitle', 'ID produk TikTok')} style={uiV39
                                                        /* v3.9: ID menyepi — saiz `.s-num` prototaip (12.5px, --s-ink-3),
                                                           bukan lagi ungu tebal 10px yang bersaing dengan nama produk. */
                                                        ? { fontSize: 12.5, fontWeight: 400, color: 'var(--s-ink-3)', lineHeight: 1.4, fontVariantNumeric: 'tabular-nums' }
                                                        : { fontSize: 10, fontWeight: 800, color: '#6366f1', letterSpacing: '0.01em', lineHeight: 1.2, fontVariantNumeric: 'tabular-nums' }}>
                                                        #{productDisplayNo(product, idx + 1)}
                                                    </div>
                                                    {/* â'¤â'¥â'¦ Name Row */}
                                                    {editingProductHeader.id === product.id && editingProductHeader.field === 'name' ? (
                                                        <div className="flex items-center gap-1">
                                                            <input
                                                                autoFocus
                                                                value={editingValue}
                                                                onChange={(e) => setEditingValue(e.target.value)}
                                                                onKeyDown={(e) => { if (e.key === 'Enter') saveEditingField(); if (e.key === 'Escape') cancelEditing(); }}
                                                                className="flex-1 text-xs font-semibold bg-white border border-blue-300 rounded px-1.5 py-0.5 focus:outline-none focus:ring-1 focus:ring-blue-500"
                                                                style={{ color: '#111827' }}
                                                            />
                                                            <button onClick={saveEditingField} className="p-0.5 rounded bg-blue-50 hover:bg-blue-100 text-blue-600 transition-colors" title={T('ws.common.save', 'Save')}>
                                                                <span className="material-symbols-outlined text-[14px]">check</span>
                                                            </button>
                                                            <button onClick={cancelEditing} className="p-0.5 rounded bg-slate-100 hover:bg-slate-200 text-slate-400 transition-colors" title={T('ws.common.cancel', 'Cancel')}>
                                                                <span className="material-symbols-outlined text-[14px]">close</span>
                                                            </button>
                                                        </div>
                                                    ) : (
                                                        <div className="group/name" style={uiV39
                                                            /* v3.9: nama = satu-satunya teks terang pada baris (15.5px / 600). */
                                                            ? { fontSize: 15.5, fontWeight: 600, color: 'var(--s-ink)', letterSpacing: '-0.012em', lineHeight: 1.3 }
                                                            : { fontSize: 13, fontWeight: 600, color: '#111827', letterSpacing: '-0.01em', lineHeight: 1.3 }}>
                                                            {/* v3.9: nama dipotong pada DUA baris dengan tiga titik
                                                                (arahan user 2026-08-10). Nama produk TikTok kerap
                                                                200+ aksara — tanpa had, satu kad menolak kad lain
                                                                jauh ke bawah dan senarai jadi susah diimbas.
                                                                Nama penuh kekal boleh dibaca melalui tooltip.

                                                                ⛔ Butang pencil/salin duduk DI DALAM blok ini, bukan
                                                                   di sebelahnya (arahan user 2026-08-11): ia mesti
                                                                   mengikut aliran teks supaya berada selepas PERKATAAN
                                                                   TERAKHIR nama — pada nama panjang, itu bermakna ia
                                                                   turun ke baris kedua, selepas "…".
                                                                   Percubaan terdahulu meletakkannya sebagai jiran flex;
                                                                   itu memakukannya di hujung KANAN kad, jauh daripada
                                                                   hujung nama. */}
                                                            {uiV39 ? (
                                                                <span
                                                                    title={product.name}
                                                                    style={{
                                                                        display: '-webkit-box',
                                                                        WebkitLineClamp: 2,
                                                                        WebkitBoxOrient: 'vertical',
                                                                        overflow: 'hidden',
                                                                    }}
                                                                >
                                                                    {product.name}
                                                                    {/* Ruang tanpa-pemisah: menahan butang daripada
                                                                        tertinggal sendirian pada baris ketiga. */}
                                                                    {' '}
                                                                    <span className="hidden group-hover/name:inline-flex items-center gap-0.5" style={{ verticalAlign: 'middle' }}>
                                                                        {/* Pensel nama DIBUANG (v3.9) — edit nama melalui chip "Edit data" (2026-09-12). Salin kekal. */}
                                                                        <button onClick={(e) => { e.stopPropagation(); copyToClipboard(product.name, `name_${product.id}`); }} className="inline-flex p-0 rounded hover:bg-slate-100 text-slate-400 hover:text-blue-600 transition-colors" title={T('ws.kad.salinNama', 'Copy name')}>
                                                                            <span className="material-symbols-outlined text-[12px]">{copiedField === `name_${product.id}` ? 'check' : 'content_copy'}</span>
                                                                        </button>
                                                                    </span>
                                                                </span>
                                                            ) : (
                                                                <>
                                                                    {product.name}
                                                                    <span className="hidden group-hover/name:inline-flex items-center gap-0.5 ml-1" style={{ verticalAlign: 'middle' }}>
                                                                        <button onClick={(e) => { e.stopPropagation(); startEditingField(product.id, 'name', product.name); }} className="inline-flex p-0 rounded hover:bg-slate-100 text-slate-400 hover:text-blue-600 transition-colors" title={T('ws.kad.editNama', 'Edit name')}>
                                                                            <span className="material-symbols-outlined text-[12px]">edit</span>
                                                                        </button>
                                                                        <button onClick={(e) => { e.stopPropagation(); copyToClipboard(product.name, `name_${product.id}`); }} className="inline-flex p-0 rounded hover:bg-slate-100 text-slate-400 hover:text-blue-600 transition-colors" title={T('ws.kad.salinNama', 'Copy name')}>
                                                                            <span className="material-symbols-outlined text-[12px]">{copiedField === `name_${product.id}` ? 'check' : 'content_copy'}</span>
                                                                        </button>
                                                                    </span>
                                                                </>
                                                            )}
                                                        </div>
                                                    )}
                                                    {/* â'§â'¨â'© Link Row */}
                                                    {/* v3.9: link produk TikTok, link Flow collection dan butang tanda
                                                        duduk SEBARIS (arahan user 2026-08-10). Dalam rupa lama pembalut
                                                        ini langsung tiada gaya, jadi ketiga-tiganya kekal bertindan
                                                        menegak persis seperti sebelum ini. */}
                                                    <div style={uiV39 ? { display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap', marginTop: 2 } : undefined}>
                                                    {/* ★ EDIT DATA — chip KONTRAS di PANGKAL baris (Idea 7, keputusan user 2026-09-12).
                                                        Permukaan terbalik v3.9 (terang = hitam/putih, gelap = putih/hitam) — corak sama
                                                        kad Extension + bar pukal; tiada warna baharu. Membuka borang Product Data yang
                                                        SAMA seperti My Products. Pensel nama + link pada kad DIBUANG (rupa v3.9) — semua
                                                        edit lalu borang ini. v3.9 sahaja; rupa lama tidak disentuh. */}
                                                    {uiV39 && (
                                                        <button
                                                            type="button"
                                                            onClick={(e) => { e.stopPropagation(); bukaEditDataKad(product); }}
                                                            disabled={editDataLoadingId === product.id}
                                                            style={{ ...CHIP_V39, display: 'inline-flex', alignItems: 'center', gap: 4, cursor: 'pointer', background: 'var(--s-primary)', color: 'var(--s-primary-ink)', border: '1px solid var(--s-primary)', opacity: editDataLoadingId === product.id ? 0.6 : 1 }}
                                                            title={T('ws.card.editData', 'Edit data')}
                                                        >
                                                            <span className="material-symbols-outlined text-[13px]">{editDataLoadingId === product.id ? 'progress_activity' : 'edit_document'}</span>
                                                            {T('ws.card.editData', 'Edit data')}
                                                        </button>
                                                    )}
                                                    {/* ★ TIADA RUANG GAMBAR — larian Agent Saya ditahan kerana kad ini penuh (2026-09-13).
                                                        Dua rupa: v3.9 = chip token amaran; rupa lama = amber tetap. Klik = tanda kad
                                                        seperti klik di mana-mana pada kad (tiada tindakan sendiri). */}
                                                    {tiadaRuangGambar && (
                                                        <span
                                                            style={uiV39
                                                                ? { ...CHIP_V39, gap: 4, fontWeight: 600, background: 'var(--s-warn-soft)', color: 'var(--s-warn)', border: '1px solid transparent' }
                                                                : { display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: 11, fontWeight: 600, lineHeight: 1.4, padding: '1px 7px', margin: '2px 0', borderRadius: 5, whiteSpace: 'nowrap', background: '#fffbeb', color: '#b45309', border: '1px solid #fcd34d' }}
                                                            title={T('ws.agent.ruang.labelTip', `Agent yang dipilih perlu ${_ruang?.perlu || 1} ruang gambar kosong pada card ini. Buang gambar tambahan melalui Edit data.`, { perlu: _ruang?.perlu || 1 })}
                                                        >
                                                            <span className="material-symbols-outlined text-[13px]">hide_image</span>
                                                            {T('ws.agent.ruang.label', 'Tiada ruang gambar')}
                                                        </span>
                                                    )}
                                                    {/* ★ TIADA PROMPT — Run Flow ditahan kerana card ini tiada prompt untuk set/babak yang dipilih
                                                        (2026-09-18). Rupa SAMA chip "Tiada ruang gambar" di atas. Tooltip = ayat penuh (set mana,
                                                        prompt apa). Klik = tanda kad seperti klik di mana-mana pada kad (tiada tindakan sendiri). */}
                                                    {promptKosongFlow && (() => {
                                                        const _rp = ringkasMasalahPrompt(masalahPromptSemasa, T);
                                                        return (
                                                            <span
                                                                style={uiV39
                                                                    ? { ...CHIP_V39, gap: 4, fontWeight: 600, background: 'var(--s-warn-soft)', color: 'var(--s-warn)', border: '1px solid transparent' }
                                                                    : { display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: 11, fontWeight: 600, lineHeight: 1.4, padding: '1px 7px', margin: '2px 0', borderRadius: 5, whiteSpace: 'nowrap', background: '#fffbeb', color: '#b45309', border: '1px solid #fcd34d' }}
                                                                title={_rp.baris}
                                                            >
                                                                <span className="material-symbols-outlined text-[13px]">speaker_notes_off</span>
                                                                {_rp.chip}
                                                            </span>
                                                        );
                                                    })()}
                                                    {editingProductHeader.id === product.id && editingProductHeader.field === 'link' ? (
                                                        <div className="flex items-center gap-1">
                                                            <input
                                                                autoFocus
                                                                value={editingValue}
                                                                onChange={(e) => setEditingValue(e.target.value)}
                                                                onKeyDown={(e) => { if (e.key === 'Enter') saveEditingField(); if (e.key === 'Escape') cancelEditing(); }}
                                                                className="flex-1 text-[10px] text-slate-500 bg-white border border-blue-300 rounded px-1.5 py-0.5 focus:outline-none focus:ring-1 focus:ring-blue-500"
                                                            />
                                                            <button onClick={saveEditingField} className="p-0.5 rounded bg-blue-50 hover:bg-blue-100 text-blue-600 transition-colors" title={T('ws.common.save', 'Save')}>
                                                                <span className="material-symbols-outlined text-[14px]">check</span>
                                                            </button>
                                                            <button onClick={cancelEditing} className="p-0.5 rounded bg-slate-100 hover:bg-slate-200 text-slate-400 transition-colors" title={T('ws.common.cancel', 'Cancel')}>
                                                                <span className="material-symbols-outlined text-[14px]">close</span>
                                                            </button>
                                                        </div>
                                                    ) : (uiV39 && !String(product.link || '').trim() && (product.shopeeProductUrl || product.shopeeLink)) ? (
                                                        /* ★ 2026-10-06 — KAD SHOPEE (tiada link TikTok, ada rujukan Shopee; audit Shopee S7).
                                                           Dahulu chip "TikTok product" tetap dipapar dengan href kosong — klik membuka SESAAT
                                                           sendiri dalam tab baharu, dan halaman produk Shopee tidak boleh dibuka dari mana-mana.
                                                           Kini chip "Shopee product" membuka halaman produk Shopee. Kad lama yang belum membawa
                                                           `shopeeProductUrl` (sebelum 6 Okt) tidak memapar chip produk — chip "Shopee link"
                                                           (link affiliate) di bawah kekal. Kad ber-link TikTok + rupa lama: tidak disentuh. */
                                                        product.shopeeProductUrl ? (
                                                            <div className="group/link flex items-center" style={CHIP_V39}>
                                                                <span className="material-symbols-outlined text-[13px]" style={{ marginRight: 4, color: 'var(--s-ink-3)' }}>storefront</span>
                                                                <a href={product.shopeeProductUrl} target="_blank" rel="noopener noreferrer" className="transition-colors">{T('ws.card.linkShopeeProduct', 'Shopee product')}</a>
                                                                <span className="hidden group-hover/link:inline-flex items-center gap-0.5 ml-1 align-middle">
                                                                    <button onClick={(e) => { e.stopPropagation(); copyToClipboard(product.shopeeProductUrl, `link_${product.id}`); }} className="inline-flex p-0.5 rounded hover:bg-slate-100 text-slate-400 hover:text-blue-600 transition-colors" title={T('ws.card.copyLink', 'Copy link')}>
                                                                        <span className="material-symbols-outlined text-[12px]">{copiedField === `link_${product.id}` ? 'check' : 'content_copy'}</span>
                                                                    </button>
                                                                </span>
                                                            </div>
                                                        ) : null
                                                    ) : (
                                                        <div className="group/link flex items-center" style={uiV39 ? CHIP_V39 : { fontSize: 11, color: '#64748b' }}>
                                                            <span className="material-symbols-outlined text-[13px]" style={{ marginRight: 4, color: uiV39 ? 'var(--s-ink-3)' : '#9ca3af' }}>link</span>
                                                            <a href={product.link} target="_blank" rel="noopener noreferrer" className={uiV39 ? 'transition-colors' : 'hover:text-blue-600 transition-colors'}>{uiV39 ? T('ws.card.linkTiktokProduct', 'TikTok product') : safeHostname(product.link)}</a>
                                                            <span className="hidden group-hover/link:inline-flex items-center gap-0.5 ml-1 align-middle">
                                                                {/* Pensel link: rupa LAMA sahaja — v3.9 edit link melalui chip "Edit data" (2026-09-12). */}
                                                                {!uiV39 && (
                                                                <button onClick={(e) => { e.stopPropagation(); startEditingField(product.id, 'link', product.link); }} className="inline-flex p-0.5 rounded hover:bg-slate-100 text-slate-400 hover:text-blue-600 transition-colors" title={T('ws.card.editLink', 'Edit link')}>
                                                                    <span className="material-symbols-outlined text-[12px]">edit</span>
                                                                </button>
                                                                )}
                                                                <button onClick={(e) => { e.stopPropagation(); copyToClipboard(product.link, `link_${product.id}`); }} className="inline-flex p-0.5 rounded hover:bg-slate-100 text-slate-400 hover:text-blue-600 transition-colors" title={T('ws.card.copyLink', 'Copy link')}>
                                                                    <span className="material-symbols-outlined text-[12px]">{copiedField === `link_${product.id}` ? 'check' : 'content_copy'}</span>
                                                                </button>
                                                            </span>
                                                        </div>
                                                    )}
                                                    {/* ★ Shopee affiliate link (v4 FB Reels) — sama corak seperti link TikTok
                                                        di atas. Muncul HANYA bila ada nilai (kebanyakan kad belum ada, jadi
                                                        tak clutter); pelanggan tambah melalui borang Edit Data Produk.
                                                        Toggle Run FB Reels masih locked admin — ini cuma menyimpan data. */}
                                                    {/* ★ v4 — Link Shopee: PAPAR + COPY SAHAJA (tak boleh edit atas kad).
                                                        My Products = SUMBER link (keputusan user 2026-09-04: "My Products
                                                        yang menang"). Edit dibuat di borang Edit Data Produk (My Products)
                                                        → mengalir automatik ke kad. Dua tempat edit = keliru, jadi kad
                                                        papar sahaja. */}
                                                    {product.shopeeLink ? (
                                                        <div className="group/shopee flex items-center" style={uiV39 ? CHIP_V39 : { fontSize: 11, color: '#64748b' }}>
                                                            <span className="material-symbols-outlined text-[13px]" style={{ marginRight: 4, color: uiV39 ? 'var(--s-ink-3)' : '#9ca3af' }}>shopping_bag</span>
                                                            <a href={product.shopeeLink} target="_blank" rel="noopener noreferrer" className={uiV39 ? 'transition-colors' : 'hover:text-blue-600 transition-colors'}>{T('ws.card.linkShopee', 'Shopee link')}</a>
                                                            <span className="hidden group-hover/shopee:inline-flex items-center gap-0.5 ml-1 align-middle">
                                                                <button onClick={(e) => { e.stopPropagation(); copyToClipboard(product.shopeeLink, `shopee_${product.id}`); }} className="inline-flex p-0.5 rounded hover:bg-slate-100 text-slate-400 hover:text-blue-600 transition-colors" title={T('ws.card.copyLink', 'Copy link')}>
                                                                    <span className="material-symbols-outlined text-[12px]">{copiedField === `shopee_${product.id}` ? 'check' : 'content_copy'}</span>
                                                                </button>
                                                            </span>
                                                        </div>
                                                    ) : null}
                                                    {/* ★ FASA 2: Link Collection Flow — bawah link produk, muncul bila produk dah ada collection tersimpan */}
                                                    {product.collectionUrl && (
                                                        <div className="group/coll flex items-center" style={uiV39 ? CHIP_V39 : { fontSize: 11, color: '#64748b', marginTop: 2 }}>
                                                            <span className="material-symbols-outlined text-[13px]" style={{ marginRight: 4, color: uiV39 ? 'var(--s-ink-3)' : '#9ca3af' }}>movie</span>
                                                            <a href={product.collectionUrl} target="_blank" rel="noopener noreferrer" className={uiV39 ? 'transition-colors' : 'hover:text-indigo-600 transition-colors'} title={product.collectionUrl}>{uiV39 ? 'Flow collection' : 'Collection Flow'}</a>
                                                            <span className="hidden group-hover/coll:inline-flex items-center gap-0.5 ml-1 align-middle">
                                                                <button onClick={(e) => { e.stopPropagation(); copyToClipboard(product.collectionUrl, `coll_${product.id}`); }} className="inline-flex p-0.5 rounded hover:bg-slate-100 text-slate-400 hover:text-indigo-600 transition-colors" title={T('ws.card.copyCollectionLink', 'Copy link collection')}>
                                                                    <span className="material-symbols-outlined text-[12px]">{copiedField === `coll_${product.id}` ? 'check' : 'content_copy'}</span>
                                                                </button>
                                                            </span>
                                                        </div>
                                                    )}
                                                    {/* ⛔ TIADA butang tanda pada kad dalam v3.9 (arahan user 2026-08-10):
                                                        tab kad itu sendiri sudah memberitahu ia berada di mana, jadi
                                                        pil "Flow"/"Schedule" pada setiap kad hanya mengulang perkara
                                                        yang sama. Menukar tanda dibuat melalui bar pukal (tandakan
                                                        kad → Mark Flow / Mark Schedule) — laluan borong, bukan
                                                        satu-satu. Rupa lama KEKAL ada pil di sudut kad. */}
                                                    {/* Badge Row — Full Prompt + Extension + Retry.

                                                        v3.9: bekas ini DILARUTKAN dengan `display: contents` supaya
                                                        setiap badge menyertai baris pautan di atas — satu baris
                                                        sahaja, seperti prototaip. Melarutkan bekas lebih selamat
                                                        daripada memindahkan badge keluar dari sini: semua badge
                                                        bersyarat (DUPLICATE, Extra Arahan, module, gender, BG)
                                                        kekal di tempat asalnya dalam kod. */}
                                                    <div className="sesaat-badgerow" style={uiV39 ? { display: 'contents' } : { display: 'flex', gap: 6, marginTop: 4, flexWrap: 'wrap' }}>
                                                        {/* ★ Chip "Edit Prompts" — HANYA tab Schedule (arahan user 2026-08-21):
                                                            pelanggan kadang nak edit caption TikTok sahaja tanpa balik ke tab
                                                            Flow. Ia buka modal editor set (SET 1/2/3) yang SAMA seperti tab
                                                            Flow (`setPromptModalProductId`). Chip Full Prompt/EXT di bawah
                                                            kekal disorok dalam schedMode — ini penggantinya yang lebih fokus. */}
                                                        {schedMode && (
                                                            <button
                                                                type="button"
                                                                onClick={(e) => { e.stopPropagation(); setPromptModalProductId(product.id); }}
                                                                style={{ ...CHIP_V39, cursor: 'pointer', gap: 4, fontFamily: 'inherit' }}
                                                                title={T('ws.promptModal.title', 'Edit Prompts')}
                                                            >
                                                                <span className="material-symbols-outlined" style={{ fontSize: 13 }}>edit_note</span>
                                                                {T('ws.promptModal.title', 'Edit Prompts')}
                                                            </button>
                                                        )}
                                                        {/* ★ Chip EDIT (Full Prompt, EXT) disorok dalam tab Schedule
                                                            (arahan user 2026-08-20): kad Schedule untuk JADUAL sahaja,
                                                            edit prompt di tab Flow. Yang kekal = TikTok product + badge
                                                            module. Ini juga memendekkan kad (kurang chip bertindan). */}
                                                        {!schedMode && (<>
                                                        <button
                                                            onClick={async (e) => {
                                                                e.stopPropagation();
                                                                // ★ SPLIT V2: teks mungkin di subdoc — hydrate dulu (papar status memuatkan)
                                                                let _src = product;
                                                                if (needsDetail(product)) {
                                                                    setRawOutputModal({ open: true, productId: product.id, content: '', plainContent: T('ws.card.loadingFullText', 'Memuatkan teks penuh dari cloud…'), viewMode: 'plain' });
                                                                    try {
                                                                        await hydrateDetails(product, { throwOnError: true });
                                                                    } catch (_err) {
                                                                        setRawOutputModal({ open: true, productId: product.id, content: '', plainContent: T('ws.card.loadFullTextFailed', 'Gagal memuatkan teks dari cloud. Sila tutup modal ini dan cuba semula.'), viewMode: 'plain' });
                                                                        return;
                                                                    }
                                                                    _src = withDetail(product);
                                                                }
                                                                // ★ Satu pusat: kalau salinan rawOutput takda (dah tak disimpan ke cloud),
                                                                // susun paparan terus dari prompts — hasil sama, tiada salinan bertindih.
                                                                const _rawView = _src.rawOutput || promptsToJson(_src.prompts);
                                                                setRawOutputModal({ open: true, productId: product.id, content: _rawView, plainContent: jsonToPlain(_rawView), viewMode: 'plain' });
                                                            }}
                                                            style={{ padding: '2px 8px', background: '#f1f5f9', border: '1px solid #e2e8f0', borderRadius: 4, fontSize: 10, fontWeight: 700, color: '#6366f1', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 3, lineHeight: 1 }}
                                                            title={T('ws.card.viewEditFullPrompt', 'View / Edit full prompt')}
                                                        >
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="4 17 10 11 4 5"></polyline><line x1="12" x2="20" y1="19" y2="19"></line></svg>
                                                            Full Prompt
                                                        </button>
                                                        <button
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                window.postMessage({ type: 'SESAAT_NAVIGATE_TO_PRODUCT', productId: product.id, setKey: lockedSet || activeSet || 'set1', openPreview: false }, '*');
                                                            }}
                                                            style={{ padding: '2px 8px', background: '#f1f5f9', border: '1px solid #e2e8f0', borderRadius: 4, fontSize: 10, fontWeight: 700, color: '#6366f1', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 3, lineHeight: 1 }}
                                                            title={T('ws.card.openInExtension', 'Open in Extension')}
                                                        >
                                                            <span className="material-symbols-outlined text-[11px]">extension</span>
                                                            EXT
                                                        </button>
                                                        </>)}
                                                        {/* v3.9: RETRY berpindah ke bar pukal (arahan user 2026-08-11),
                                                            jadi ia disorok di sini — kalau tidak, ada dua pintu untuk
                                                            tindakan yang sama dan pengguna tidak tahu mana satu betul. */}
                                                        {!uiV39 && (
                                                        <button
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleRetryPipeline(product);
                                                            }}
                                                            style={{ padding: '2px 8px', background: '#f1f5f9', border: '1px solid #e2e8f0', borderRadius: 4, fontSize: 10, fontWeight: 700, color: '#f59e0b', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 3, lineHeight: 1 }}
                                                            title={T('ws.card.retryPipeline', 'Retry Pipeline')}
                                                        >
                                                            <span className="material-symbols-outlined text-[11px]">refresh</span>
                                                            {T('ws.card.retryShort', 'RETRY')}
                                                        </button>
                                                        )}
                                                        {/* ★ DUPLICATE — PENANDA, bukan butang am. Muncul HANYA pada kad yang
                                                            memang hasil salinan (`duplicatedFrom`), supaya pill ni benar-benar
                                                            bermaksud "kad ini salinan". Laluan utama buat salinan = butang
                                                            Duplicate dalam bar terapung (tick kad dahulu). Klik pill ni =
                                                            tambah stok lagi daripada kad salinan yang sama. */}
                                                        {!schedMode && product.duplicatedFrom && (() => {
                                                            const _origName = products.find(p => p.id === product.duplicatedFrom)?.name;
                                                            return (
                                                                <button
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        setDuplicateModal({ open: true, ids: [product.id], copies: 1, busy: false });
                                                                    }}
                                                                    style={{ padding: '2px 8px', background: '#f0f9ff', border: '1px solid #bae6fd', borderRadius: 4, fontSize: 10, fontWeight: 700, color: '#0284c7', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 3, lineHeight: 1 }}
                                                                    title={_origName
                                                                        ? T('ws.card.duplicateFrom', `Kad ini salinan daripada "${_origName}" — klik untuk buat salinan lagi`, { nama: _origName })
                                                                        : T('ws.card.duplicateFromDeleted', 'Kad ini salinan (kad asal sudah dipadam) — klik untuk buat salinan lagi')}
                                                                >
                                                                    <span className="material-symbols-outlined text-[11px]">content_copy</span>
                                                                    DUPLICATE
                                                                </button>
                                                            );
                                                        })()}
                                                        {/* ★ EXTRA ARAHAN — arahan tambahan per produk (mesej Agent AI). Tab chatgpt sahaja.
                                                            ⛔ DISOROK untuk module SMART: di sana arahan tambahan ditetapkan SEKALI
                                                               di peringkat agent (PRO Studio → Agent Saya → Langkah 2), bukan per kad.
                                                               Dua tempat = pelanggan keliru mana satu digunakan.
                                                               FLOWNITY KEKAL guna butang ini — jangan buang terus. */}
                                                        {getProductTab(product) === 'chatgpt' && product.moduleId !== 'smartcustom' && (
                                                            <button
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    if (extraEditId === product.id) { setExtraEditId(null); return; }
                                                                    setExtraDraft(product.extraInstruction || '');
                                                                    setExtraEditId(product.id);
                                                                }}
                                                                style={{ padding: '2px 8px', background: product.extraInstruction ? '#7c3aed' : '#ede9fe', border: `1px solid ${product.extraInstruction ? '#7c3aed' : '#c4b5fd'}`, borderRadius: 4, fontSize: 10, fontWeight: 700, color: product.extraInstruction ? '#ffffff' : '#7c3aed', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 3, lineHeight: 1 }}
                                                                title={product.extraInstruction ? T('ws.card.extraInstructionTip', `Extra Arahan: ${product.extraInstruction.slice(0, 120)}`, { teks: product.extraInstruction.slice(0, 120) }) : T('ws.card.extraInstructionAdd', 'Tambah arahan tambahan (ditampal pada mesej Agent AI)')}
                                                            >
                                                                <span className="material-symbols-outlined text-[11px]">edit_note</span>
                                                                {T('ws.card.extraInstruction', 'Extra Arahan')}{product.extraInstruction ? ' ✓' : ''}
                                                            </button>
                                                        )}
                                                        {/* Module Badge — guna warna dari registry/Firestore (mod.color) */}
                                                        {product.moduleId && (() => {
                                                            const mod = propModules?.find(m => m.id === product.moduleId);
                                                            if (!mod) return null;
                                                            const c = mod.color || '#475569';
                                                            return (
                                                                <span
                                                                    style={{
                                                                        padding: '2px 6px',
                                                                        background: `${c}1A`,
                                                                        border: `1px solid ${c}66`,
                                                                        borderRadius: 4,
                                                                        fontSize: 10, fontWeight: 700,
                                                                        color: c,
                                                                        display: 'inline-flex', alignItems: 'center', gap: 2, lineHeight: 1,
                                                                    }}
                                                                    title={T('ws.card.moduleBadge', `Module: ${mod.name}`, { nama: mod.name })}
                                                                >
                                                                    <span className="material-symbols-outlined text-[11px]">{mod.icon || 'view_module'}</span>
                                                                    {mod.name || product.moduleId}
                                                                </span>
                                                            );
                                                        })()}
                                                        {/* Avatar Badge — hidden for GOYANG (hand-only, no avatar concept).
                                                            v3.9: DISOROK (arahan user 2026-08-10) — gambar avatar itu
                                                            sendiri sudah nampak pada petak di kiri, jadi chip bertulis
                                                            "Avatar" hanya mengulang apa yang mata sudah lihat. Prototaip
                                                            membuang label ini atas sebab yang sama. */}
                                                        {!uiV39 && product.avatarImageUrl && product.moduleId !== 'goyang' && (
                                                            <span
                                                                style={{ padding: '2px 8px', background: '#ede9fe', border: '1px solid #c4b5fd', borderRadius: 4, fontSize: 10, fontWeight: 700, color: '#7c3aed', display: 'inline-flex', alignItems: 'center', gap: 3, lineHeight: 1 }}
                                                                title={T('ws.card.avatarAttached', 'Avatar attached')}
                                                            >
                                                                <span className="material-symbols-outlined text-[11px]">person</span>
                                                                Avatar
                                                            </span>
                                                        )}
                                                        {/* Template BG Badge — GOYANG only, shows when template SNAPSHOT (locked at generate) has custom bg.
                                                            No fallback to active template — badge only appears after generate. */}
                                                        {(() => {
                                                            /* v3.9: DISOROK (arahan user 2026-08-10) — gambar template
                                                               sudah dipapar pada petak rujukan di kiri kad. */
                                                            if (uiV39) return null;
                                                            const isGoyang = product.moduleId === 'goyang';
                                                            const tpl = product.templateSnapshot;
                                                            const goyangBgUrl = (isGoyang && tpl?.customBgImageUrl) || '';
                                                            if (!goyangBgUrl) return null;
                                                            return (
                                                                <span
                                                                    style={{ padding: '2px 8px', background: '#fef3c7', border: '1px solid #fde68a', borderRadius: 4, fontSize: 10, fontWeight: 700, color: '#b45309', display: 'inline-flex', alignItems: 'center', gap: 3, lineHeight: 1 }}
                                                                    title={T('ws.card.templateBg', `Template BG: ${tpl?.customBgFilename || T('ws.card.customBackground', 'custom background')}`, { fail: tpl?.customBgFilename || T('ws.card.customBackground', 'custom background') })}
                                                                >
                                                                    <span className="material-symbols-outlined text-[11px]">image</span>
                                                                    BG
                                                                </span>
                                                            );
                                                        })()}
                                                        {/* Hand Gender Badge — GOYANG only, shows when template SNAPSHOT handGender is explicit (not auto).
                                                            No fallback to active template — badge only appears after generate. Style aligned with Women/Men badge below.
                                                            v3.9: DISOROK — gender GOYANG kini dipapar pada petak template
                                                            itu sendiri, jadi chip ini hanya mengulanginya. */}
                                                        {(() => {
                                                            if (uiV39) return null;
                                                            const isGoyang = product.moduleId === 'goyang';
                                                            const tpl = product.templateSnapshot;
                                                            const hg = isGoyang ? (tpl?.handGender || 'auto') : 'auto';
                                                            if (hg === 'auto') return null;
                                                            const isMale = hg === 'male';
                                                            return (
                                                                <span
                                                                    style={{ padding: '2px 8px', background: isMale ? '#eff6ff' : '#fdf2f8', border: `1px solid ${isMale ? '#bfdbfe' : '#fbcfe8'}`, borderRadius: 4, fontSize: 10, fontWeight: 700, color: isMale ? '#3b82f6' : '#ec4899', display: 'inline-flex', alignItems: 'center', gap: 3, lineHeight: 1 }}
                                                                    title={isMale ? T('ws.card.handMen', 'Hand: Men') : T('ws.card.handWomen', 'Hand: Women')}
                                                                >
                                                                    <span className="material-symbols-outlined text-[11px]">{isMale ? 'male' : 'female'}</span>
                                                                    {isMale ? T('ws.card.men', 'Men') : T('ws.card.women', 'Women')}
                                                                </span>
                                                            );
                                                        })()}
                                                        {/* Gender Badge — non-GOYANG only (GOYANG uses Hand Gender badge above).
                                                            v3.9: DISOROK — gender sudah dipapar sebagai jalur di dalam
                                                            gambar avatar, jadi chip ini hanya mengulanginya. */}
                                                        {!uiV39 && product.gender && product.moduleId !== 'goyang' && (
                                                            <span
                                                                style={{ padding: '2px 8px', background: product.gender === 'male' ? '#eff6ff' : '#fdf2f8', border: `1px solid ${product.gender === 'male' ? '#bfdbfe' : '#fbcfe8'}`, borderRadius: 4, fontSize: 10, fontWeight: 700, color: product.gender === 'male' ? '#3b82f6' : '#ec4899', display: 'inline-flex', alignItems: 'center', gap: 3, lineHeight: 1 }}
                                                                title={product.gender === 'male' ? T('ws.card.men', 'Men') : T('ws.card.women', 'Women')}
                                                            >
                                                                <span className="material-symbols-outlined text-[11px]">{product.gender === 'male' ? 'male' : 'female'}</span>
                                                                {product.gender === 'male' ? T('ws.card.men', 'Men') : T('ws.card.women', 'Women')}
                                                            </span>
                                                        )}
                                                    </div>
                                                    </div>{/* tutup baris pautan + badge */}
                                                    {/* ★ EXTRA ARAHAN — panel edit, buka di bawah baris badge (in-flow, tak tindih apa-apa)
                                                        Pagar module SMART diulang di sini supaya panel tidak boleh terbuka
                                                        walaupun `extraEditId` tertinggal daripada kad module lain. */}
                                                    {extraEditId === product.id && product.moduleId !== 'smartcustom' && (
                                                        <div
                                                            onClick={(e) => e.stopPropagation()}
                                                            style={{ marginTop: 8, maxWidth: 440, cursor: 'default' }}
                                                            className="bg-white border border-violet-200 rounded-xl shadow-sm p-2.5"
                                                        >
                                                            <div className="text-[10px] font-bold text-violet-600 mb-1.5 flex items-center gap-1">
                                                                <span className="material-symbols-outlined text-[13px]">edit_note</span>
                                                                {T('ws.extra.panelTitle', 'Extra Arahan — ditampal pada mesej Agent AI produk ini')}
                                                            </div>
                                                            <textarea
                                                                value={extraDraft}
                                                                onChange={(e) => setExtraDraft(e.target.value)}
                                                                maxLength={1000}
                                                                rows={3}
                                                                autoFocus
                                                                placeholder={T('ws.extra.placeholder', 'Contoh: Guna gaya lawak. Fokus audiens mak-mak.')}
                                                                className="w-full text-[11px] border border-slate-200 rounded-lg p-2 focus:outline-none focus:border-violet-400 resize-none"
                                                            />
                                                            <div className="flex items-center justify-between mt-1.5">
                                                                <span className="text-[9px] text-slate-400">{extraDraft.length}/1000</span>
                                                                <div className="flex items-center gap-1.5">
                                                                    {product.extraInstruction && (
                                                                        <button onClick={() => saveExtraInstruction(product.id, '')} className="px-2 py-1 text-[10px] font-bold text-rose-500 hover:bg-rose-50 rounded-lg transition-all">{T('ws.extra.delete', 'Padam')}</button>
                                                                    )}
                                                                    <button onClick={() => setExtraEditId(null)} className="px-2 py-1 text-[10px] font-medium text-slate-400 hover:text-slate-600 rounded-lg transition-all">{T('ws.extra.cancel', 'Batal')}</button>
                                                                    <button onClick={() => saveExtraInstruction(product.id, extraDraft)} className="px-2.5 py-1 text-[10px] font-bold text-white bg-violet-500 hover:bg-violet-600 rounded-lg transition-all">{T('ws.extra.save', 'Simpan')}</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                                </div>
                                                {/* â•â•â• RIGHT SIDE (60%) — Videos/Sets â•â•â• */}
                                                <div style={{ flex: (!kadDibuka && schedMode) ? 'none' : 1, display: 'flex', justifyContent: (!kadDibuka && schedMode) ? 'flex-start' : (!kadDibuka ? 'flex-end' : 'flex-start'), alignItems: 'flex-start', position: 'relative', ...(schedMode && !kadDibuka ? { width: '100%' } : null) }}>
                                                    {/* ★ SPLIT V2: overlay memuatkan — kunci interaksi sementara teks
                                                        di-hydrate (elak user taip atas textarea kosong → draft ringan) */}
                                                    {kadDibuka && isDetailPending(product) && (
                                                        <div style={{ position: 'absolute', inset: 0, zIndex: 20, background: 'rgba(255,255,255,0.75)', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, borderRadius: 8 }}>
                                                            {detailErrorIds.has(product.id) ? (
                                                                <button
                                                                    onClick={(e) => { e.stopPropagation(); hydrateDetails(productRaw); }}
                                                                    style={{ padding: '6px 12px', borderRadius: 8, border: '1px solid #fca5a5', background: '#fef2f2', color: '#dc2626', fontSize: 11, fontWeight: 700, cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 6 }}
                                                                >
                                                                    <span className="material-symbols-outlined text-[14px]">refresh</span>
                                                                    {T('ws.detail.loadFailedRetry', 'Teks tidak dapat dimuat — klik untuk cuba semula')}
                                                                </button>
                                                            ) : (
                                                                <>
                                                                    <div className="w-4 h-4 border-2 border-indigo-500/30 border-t-indigo-500 rounded-full animate-spin"></div>
                                                                    <span style={{ fontSize: 11, fontWeight: 700, color: '#6366f1' }}>{T('ws.detail.loadingPrompt', 'Memuatkan teks prompt…')}</span>
                                                                </>
                                                            )}
                                                        </div>
                                                    )}
                                                    {!kadDibuka ? (
                                                        /* Collapsed: 1 thumbnail (N-scene) atau 3 thumbnails (others).

                                                           v3.9: kawasan video menempah lebar TETAP 180px (3 × 52 +
                                                           2 × 12 jurang) walaupun kad itu hanya ada satu petak —
                                                           kad FLOWNITY. Tanpa tempahan itu lajur teks kad FLOWNITY
                                                           jadi ~130px lebih lebar daripada kad lain, jadi namanya
                                                           berpatah di tempat berlainan dan tepi kanan setiap baris
                                                           tidak sejajar (arahan user 2026-08-11). Petak tunggal
                                                           dirapatkan ke kanan supaya ia sebaris dengan petak
                                                           TERAKHIR kad tiga-set. */
                                                        <div className="sesaat-kad-vid" style={{ display: 'flex', gap: schedMode ? 8 : 12, marginRight: schedMode ? 0 : 16, width: schedMode ? '100%' : undefined, ...(uiV39 ? (schedMode ? { justifyContent: 'flex-start' } : { minWidth: 180, justifyContent: 'flex-end' }) : null) }}>
                                                            {/* ★ Tab Schedule: kotak video ISI LEBAR (flex:1, tinggi 90 landskap
                                                                — tiru kad extension). Tab lain kekal petak tetap 52×90. */}
                                                            {(getSceneCount(product) >= 3 || resipiGambarSahaja(product)) ? (
                                                                <div draggable={schedMode || undefined} onDragStart={schedMode ? (e) => { e.stopPropagation(); e.dataTransfer.setData('text/plain', `setvid:${product.id}|set1`); e.dataTransfer.effectAllowed = 'copyMove'; } : undefined} style={{ ...(schedMode ? { flex: 1, minWidth: 0, cursor: 'grab' } : { width: 52 }), height: 90, borderRadius: uiV39 ? 8 : 6, background: uiV39 ? 'var(--s-ground)' : '#f8fafc', border: `1px solid ${uiV39 ? 'var(--s-line)' : '#e2e8f0'}`, display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
                                                                    {product.prompts?.set1?.uploadedVideo ? (
                                                                        <VideoThumbPreview product={product} setKey="set1" onPlayLocalVideo={handlePlayLocalVideo} onPlayCloudVideo={handlePlayCloudVideo} t={tAnak} pushingKeys={cloudPushingKeys} />
                                                                    ) : (
                                                                        <span className={`material-symbols-outlined text-[20px]${uiV39 ? '' : ' text-slate-300'}`} style={uiV39 ? { color: 'var(--s-ink-3)' } : undefined}>play_arrow</span>
                                                                    )}
                                                                </div>
                                                            ) : (
                                                                ['set1', 'set2', 'set3'].map((setKey, i) => {
                                                                    /* ⛔ Kotak video ini KEKAL sama persis. Dalam tab Schedule ia
                                                                       dibalut satu lajur supaya pil status boleh duduk di BAWAHnya;
                                                                       pada tab lain ia dipulangkan tanpa sebarang pembalut, jadi
                                                                       rupa lama dan tab lain tidak berubah satu piksel pun. */
                                                                    const kotakSet = (
                                                                    <div draggable={schedMode || undefined} onDragStart={schedMode ? (e) => { e.stopPropagation(); e.dataTransfer.setData('text/plain', `setvid:${product.id}|${setKey}`); e.dataTransfer.effectAllowed = 'copyMove'; } : undefined} style={{ ...(schedMode ? { width: '100%', cursor: 'grab' } : { width: 52 }), height: 90, borderRadius: uiV39 ? 8 : 6, background: uiV39 ? 'var(--s-ground)' : '#f8fafc', border: `1px solid ${uiV39 ? 'var(--s-line)' : '#e2e8f0'}`, display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
                                                                        {product.prompts?.[setKey]?.uploadedVideo ? (
                                                                            <VideoThumbPreview product={product} setKey={setKey} onPlayLocalVideo={handlePlayLocalVideo} onPlayCloudVideo={handlePlayCloudVideo} t={tAnak} pushingKeys={cloudPushingKeys} />
                                                                        ) : (
                                                                            <span className={`material-symbols-outlined text-[20px]${uiV39 ? '' : ' text-slate-300'}`} style={uiV39 ? { color: 'var(--s-ink-3)' } : undefined}>play_arrow</span>
                                                                        )}
                                                                    </div>
                                                                    );
                                                                    if (!schedMode) return <React.Fragment key={i}>{kotakSet}</React.Fragment>;
                                                                    return (
                                                                        <div key={i} style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: 4 }}>
                                                                            {kotakSet}
                                                                            <StatusSetV39
                                                                                rekod={statusAkaunDibuka(product, setKey, schedAkaunAktif)}
                                                                                namaAkaun={namaAkaunDibuka}
                                                                                t={T}
                                                                                onTukar={(nilai) => tukarStatusDariKad(product.id, setKey, schedAkaunAktif, nilai)}
                                                                            />
                                                                        </div>
                                                                    );
                                                                })
                                                            )}
                                                        </div>
                                                    ) : (
                                                        /* Expanded */
                                                        (getSceneCount(product) >= 3 || resipiGambarSahaja(product)) ? (
                                                        /* N-scene (FLOWNITY etc): scene tabs kiri + 1 video kanan */
                                                        <div className="w-full flex">
                                                            {/* LEFT: scene tabs + active scene content */}
                                                            <div className="flex-1 p-4 border-r border-slate-100 dark:border-slate-800 min-w-0">
                                                                {/* Scene tabs */}
                                                                {(() => {
                                                                    const _nSc = getSceneCount(product);
                                                                    const _act = activeSceneTab[product.id] || 1;
                                                                    const _scriptVal = getEffectiveVideoScript(product.id, product.prompts, 'set1', String(_act));
                                                                    const _imgVal = (draftPromptMap[product.id] ?? product.prompts)?.set1?.[`promptVideo${_act}`] || ''; // visual = Image Prompt
                                                                    const _fullVal = getEffectiveNSceneFull(product.id, product.prompts, _act); // Video Prompt penuh (visual + dialog)
                                                                    const _resipiKad = getEffectiveScriptKey(product) === 'resipi';
                                                                    return (
                                                                        <>
                                                                            {/* ★ RESIPI: Image Prompt (satu untuk semua scene) + Video Prompt setiap scene — bentuk data lain daripada FLOWNITY */}
                                                                            {_resipiKad ? (
                                                                                <KadResipiPrompt
                                                                                    berlainan={resipiBerlainan(product)}
                                                                                    tanpaGambar={resipiTanpaGambar(product)}
                                                                                    tanpaVideo={resipiGambarSahaja(product)}
                                                                                    gambarHasil={product.gambarHasil}
                                                                                    set={(draftPromptMap[product.id] ?? product.prompts)?.set1}
                                                                                    bilBabak={_nSc}
                                                                                    aktif={_act}
                                                                                    onPilihBabak={(n) => setActiveSceneTab(prev => ({ ...prev, [product.id]: n }))}
                                                                                    onBuka={() => setPromptModalProductId(product.id)}
                                                                                    onSalin={(jenis, n, teks, kunci) => copyWithTag(jenis, 'set1', n, teks, kunci)}
                                                                                    salinan={copiedField}
                                                                                    idProduk={product.id}
                                                                                    T={T}
                                                                                />
                                                                            ) : (<>
                                                                            <div className="flex gap-1.5 flex-wrap mb-3">
                                                                                {Array.from({ length: _nSc }, (_, i) => {
                                                                                    const n = i + 1;
                                                                                    const isAct = _act === n;
                                                                                    return (
                                                                                        <button
                                                                                            key={n}
                                                                                            onClick={(e) => { e.stopPropagation(); setActiveSceneTab(prev => ({ ...prev, [product.id]: n })); }}
                                                                                            /* `sesaat-scenepil` = cangkuk khusus pil Scene. Kelas
                                                                                               `bg-violet-50` TIDAK boleh dijadikan penanda "aktif"
                                                                                               dalam CSS — ia dipakai 17 tempat lain dalam fail ini
                                                                                               (Extra Arahan, avatar, dsb.), jadi mewarnainya sebagai
                                                                                               aktif akan menyalakan butang yang tiada kaitan. */
                                                                                            className={`sesaat-scenepil${isAct ? ' sesaat-scenepil--on' : ''} px-2.5 py-0.5 text-[11px] rounded-full border transition-all ${isAct ? 'bg-violet-50 dark:bg-violet-900/30 text-violet-700 dark:text-violet-300 border-violet-300 dark:border-violet-700 font-bold' : 'text-slate-400 border-slate-200 dark:border-slate-700 hover:border-slate-400 dark:hover:border-slate-500'}`}
                                                                                        >Scene {n}</button>
                                                                                    );
                                                                                })}
                                                                            </div>
                                                                            {/* Active scene box */}
                                                                            <div className="bg-slate-50 dark:bg-slate-800/40 rounded-lg border border-slate-100 dark:border-slate-800 p-3">
                                                                                {/* Image Prompt (visual) */}
                                                                                <div className="group/prompt mb-2">
                                                                                    <div className="flex justify-between items-center mb-1">
                                                                                        <label className="text-[10px] font-bold text-slate-400 uppercase tracking-[0.05em]">Image Prompt</label>
                                                                                        <button onClick={(e) => { e.stopPropagation(); copyWithTag('IMAGE', 'set1', _act, _imgVal, `nimg_${_act}_${product.id}`); }} className="opacity-0 group-hover/prompt:opacity-100 p-0.5 rounded hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 hover:text-blue-500 transition-all" title={T('ws.common.copy', 'Copy')}>
                                                                                            <span className="material-symbols-outlined text-[12px]">{copiedField === `nimg_${_act}_${product.id}` ? 'check' : 'content_copy'}</span>
                                                                                        </button>
                                                                                    </div>
                                                                                    <textarea
                                                                                        value={_imgVal}
                                                                                        readOnly onClick={() => setPromptModalProductId(product.id)}
                                                                                        className="w-full h-16 bg-blue-50/40 dark:bg-blue-900/10 p-2 rounded-lg border border-blue-100 dark:border-blue-900/30 text-[11px] leading-relaxed text-slate-600 dark:text-slate-400 resize-none cursor-pointer hover:border-blue-300/60 hover:bg-blue-50 dark:hover:bg-blue-900/20 transition-colors font-mono"
                                                                                        placeholder={T('ws.prompt.nsceneImagePlaceholder', `Image Prompt Scene ${_act}...`, { n: _act })}
                                                                                    />
                                                                                </div>
                                                                                {/* Video Dialog (skrip) */}
                                                                                <div className="group/prompt mb-2">
                                                                                    <div className="flex justify-between items-center mb-1">
                                                                                        <label className="text-[10px] font-bold text-slate-400 uppercase tracking-[0.05em]">Video Dialog</label>
                                                                                        <button onClick={(e) => { e.stopPropagation(); copyToClipboard(_scriptVal, `nscript_${_act}_${product.id}`); }} className="opacity-0 group-hover/prompt:opacity-100 p-0.5 rounded hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 hover:text-emerald-500 transition-all" title={T('ws.common.copy', 'Copy')}>
                                                                                            <span className="material-symbols-outlined text-[12px]">{copiedField === `nscript_${_act}_${product.id}` ? 'check' : 'content_copy'}</span>
                                                                                        </button>
                                                                                    </div>
                                                                                    <textarea
                                                                                        value={_scriptVal}
                                                                                        readOnly onClick={() => setPromptModalProductId(product.id)}
                                                                                        className="w-full h-14 bg-emerald-50 dark:bg-emerald-900/10 p-2 rounded-lg border border-emerald-200 dark:border-emerald-800/40 text-[11px] leading-relaxed text-slate-700 dark:text-slate-300 resize-none cursor-pointer hover:border-emerald-400/60 hover:bg-emerald-100/60 dark:hover:bg-emerald-900/20 transition-colors italic"
                                                                                        placeholder={T('ws.prompt.nsceneDialoguePlaceholder', `Dialogue Scene ${_act}...`, { n: _act })}
                                                                                    />
                                                                                </div>
                                                                                {/* Video Prompt (penuh: visual + dialog — sedia untuk paste ke Flow) */}
                                                                                <div className="group/prompt">
                                                                                    <div className="flex justify-between items-center mb-1">
                                                                                        <label className="text-[10px] font-bold text-slate-400 uppercase tracking-[0.05em]">Video Prompt</label>
                                                                                        <button onClick={(e) => { e.stopPropagation(); copyWithTag('VIDEO', 'set1', _act, _fullVal, `nprompt_${_act}_${product.id}`); }} className="opacity-0 group-hover/prompt:opacity-100 p-0.5 rounded hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 hover:text-primary transition-all" title={T('ws.common.copy', 'Copy')}>
                                                                                            <span className="material-symbols-outlined text-[12px]">{copiedField === `nprompt_${_act}_${product.id}` ? 'check' : 'content_copy'}</span>
                                                                                        </button>
                                                                                    </div>
                                                                                    <textarea
                                                                                        value={_fullVal}
                                                                                        readOnly onClick={() => setPromptModalProductId(product.id)}
                                                                                        className="w-full h-20 bg-slate-50 dark:bg-slate-800/40 p-2 rounded-lg border border-slate-100 dark:border-slate-800 text-[11px] leading-relaxed text-slate-600 dark:text-slate-400 resize-none cursor-pointer hover:border-primary/40 hover:bg-white dark:hover:bg-slate-800/60 transition-colors font-mono"
                                                                                        placeholder={T('ws.prompt.nsceneVideoPlaceholder', `Video Prompt Veo 3 Scene ${_act}...`, { n: _act })}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                            </>)}
                                                                            {/* TikTok Caption — ★ [2026-09-27] + suis TikTok/FB (paparan sahaja, SuisCaptionKad.jsx) */}
                                                                            <div className="mt-3 pt-3 border-t border-slate-100 dark:border-slate-800">
                                                                                {(() => {
                                                                                    const capFb = capTabFb.has(product.id);
                                                                                    const cap = captionKad((draftPromptMap[product.id] ?? product.prompts)?.set1, capFb);
                                                                                    return (
                                                                                <div className="group/prompt">
                                                                                    <div className="flex justify-between items-center mb-1">
                                                                                        <label className="text-[9px] font-bold text-slate-400 uppercase tracking-[0.1em]">{labelCaptionKad(null, capFb, T)}</label>
                                                                                        <div className="flex items-center gap-0.5">
                                                                                        <SuisCaptionKad fb={capFb} onTukar={(v) => tukarCapKad(product.id, v)} T={T} />
                                                                                        <button onClick={(e) => { e.stopPropagation(); copyToClipboard(cap.teks, `ncap_${product.id}`); }} className="opacity-0 group-hover/prompt:opacity-100 p-0.5 rounded hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 hover:text-slate-600 transition-all" title={T('ws.common.copy', 'Copy')}>
                                                                                            <span className="material-symbols-outlined text-[12px]">{copiedField === `ncap_${product.id}` ? 'check' : 'content_copy'}</span>
                                                                                        </button>
                                                                                        </div>
                                                                                    </div>
                                                                                    <textarea
                                                                                        value={cap.teks}
                                                                                        onChange={capFb ? undefined : (e) => updateDraftPrompt(product.id, product.prompts, 'set1', 'captionTiktok', e.target.value)}
                                                                                        readOnly onClick={() => setPromptModalProductId(product.id)}
                                                                                        className="w-full h-12 bg-slate-50 dark:bg-slate-800/40 p-2 rounded-lg border border-slate-100 dark:border-slate-800 text-[11px] leading-relaxed text-slate-600 dark:text-slate-400 resize-none cursor-pointer hover:border-primary/40 hover:bg-white dark:hover:bg-slate-800/60 transition-colors"
                                                                                        placeholder={cap.kosongSengaja ? T('ws.caption.fbKosongSengaja', 'Kosong — Facebook akan post tanpa caption') : capFb ? T('ws.prompt.empty', 'Empty') : T('ws.prompt.tiktokCaptionPlaceholder', 'TikTok caption...')}
                                                                                    />
                                                                                </div>
                                                                                    );
                                                                                })()}
                                                                            </div>
                                                                        </>
                                                                    );
                                                                })()}
                                                            </div>
                                                            {/* RIGHT: 1 video placeholder */}
                                                            <div className="w-1/3 min-w-[140px] p-4 flex flex-col flex-shrink-0">
                                                                <p className="text-[9px] font-bold text-slate-400 uppercase tracking-[0.1em] mb-2 text-center">Video</p>
                                                                {product.prompts?.set1?.uploadedVideo ? (
                                                                    <div className={`group/video transition-all duration-200 ${deletingState.productId === product.id && deletingState.setKey === 'set1' && deletingState.fadingOut ? 'opacity-0 scale-95 pointer-events-none' : 'opacity-100 scale-100'}`}>
                                                                        <div className="relative rounded-lg overflow-hidden bg-black aspect-[9/16]">
                                                                            <VideoThumbPreview product={product} setKey="set1" onPlayLocalVideo={handlePlayLocalVideo} onPlayCloudVideo={handlePlayCloudVideo} t={tAnak} pushingKeys={cloudPushingKeys} />
                                                                        </div>
                                                                        <div className="flex gap-1 mt-1.5 opacity-0 group-hover/video:opacity-100 transition-all duration-200">
                                                                            <button onClick={() => { const a = document.createElement('a'); a.href = product.prompts.set1.uploadedVideo; a.download = `${product.name || 'video'}_set1.mp4`; a.target = '_blank'; a.click(); }} className="flex-1 flex items-center justify-center px-1 py-1 rounded-md bg-slate-100 dark:bg-slate-800 hover:bg-blue-50 dark:hover:bg-blue-900/30 text-slate-500 hover:text-blue-600 text-[9px] font-bold transition-all">
                                                                                <span className="material-symbols-outlined text-[11px]">download</span>
                                                                            </button>
                                                                            <button onClick={() => requestDeleteVideo(product, 'set1')} disabled={deletingState.productId === product.id && deletingState.setKey === 'set1'} className="flex-1 flex items-center justify-center px-1 py-1 rounded-md bg-slate-100 dark:bg-slate-800 hover:bg-red-50 dark:hover:bg-red-900/30 text-slate-500 hover:text-red-500 text-[9px] font-bold transition-all disabled:opacity-50">
                                                                                <span className="material-symbols-outlined text-[11px]">delete</span>
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                ) : (
                                                                    <div onClick={() => { setUploadingState({ productId: product.id, setKey: 'set1', isUploading: false }); videoInputRef.current?.click(); }} className="aspect-[9/16] bg-slate-50 dark:bg-slate-800/40 rounded-lg border border-dashed border-slate-200 dark:border-slate-700 flex flex-col items-center justify-center text-[9px] text-slate-400 gap-1 cursor-pointer hover:bg-slate-100 dark:hover:bg-slate-800 transition-all group">
                                                                        {uploadingState.productId === product.id && uploadingState.setKey === 'set1' && uploadingState.isUploading ? (
                                                                            <span className="material-symbols-outlined animate-spin text-primary">sync</span>
                                                                        ) : (
                                                                            <>
                                                                                <span className="material-symbols-outlined text-[22px] text-slate-300 group-hover:text-primary transition-colors">cloud_upload</span>
                                                                                <span className="font-bold group-hover:text-primary transition-colors uppercase tracking-wider text-[9px]">{T('ws.video.uploadVideo', 'Upload Video')}</span>
                                                                            </>
                                                                        )}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                        ) : (
                                                        /* Existing: Full 3-column sets grid */
                                                        /* Mobile: 3 set bertindan menegak (3 lajur pada telefon = ~100px
                                                           setiap satu, textarea prompt jadi tak boleh dibaca). Garis
                                                           pemisah bertukar dari menegak ke mendatar mengikut susunan. */
                                                        <div className="sesaat-setwrap" style={{ flex: 1, minWidth: 0, width: '100%' }}>
                                                        {/* Jalur tab SET — TELEFON sahaja. Hanya set yang memang
                                                            dipaparkan diberi tab (Set 2/3 boleh dimatikan dalam
                                                            tetapan space), jadi tab tidak pernah menuding ke
                                                            lajur yang tidak wujud. */}
                                                        {(() => {
                                                            const tetapanSpace = spaces.find(s => s.id === selectedSpaceId)?.settings;
                                                            /* ⚠️ KEDUDUKAN lajur, bukan nombor set. Set 2/3 boleh
                                                               dimatikan dalam tetapan space; bila Set 2 mati, Set 3
                                                               menjadi lajur KEDUA dalam DOM. Peraturan menyorok dalam
                                                               mobile.css memakai :nth-child, jadi menyimpan "3" di sini
                                                               akan menyorok lajur yang salah. */
                                                            const senaraiSet = [
                                                                { nama: tetapanSpace?.labels?.set1 || 'Set 1' },
                                                                ...(tetapanSpace?.showSet2 !== false ? [{ nama: tetapanSpace?.labels?.set2 || 'Set 2' }] : []),
                                                                ...(tetapanSpace?.showSet3 !== false ? [{ nama: tetapanSpace?.labels?.set3 || 'Set 3' }] : []),
                                                            ].map((x, i) => ({ ...x, pos: i + 1 }));
                                                            if (senaraiSet.length < 2) return null;
                                                            const aktif = setTabKad[product.id] || 1;
                                                            return (
                                                                <div className="sesaat-settab md:hidden" role="tablist">
                                                                    {senaraiSet.map((x) => (
                                                                        <button
                                                                            key={x.pos}
                                                                            type="button"
                                                                            role="tab"
                                                                            aria-selected={aktif === x.pos}
                                                                            onClick={(e) => { e.stopPropagation(); setSetTabKad(prev => ({ ...prev, [product.id]: x.pos })); }}
                                                                            className={aktif === x.pos ? 'is-on' : undefined}
                                                                        >
                                                                            {x.nama}
                                                                        </button>
                                                                    ))}
                                                                </div>
                                                            );
                                                        })()}
                                                        <div data-set-aktif={setTabKad[product.id] || 1} className="sesaat-setgrid w-full grid grid-cols-1 md:grid-cols-3 divide-y md:divide-y-0 md:divide-x divide-slate-100 dark:divide-slate-800">
                                                    {/* Set 1 */}
                                                    <div className="p-4 bg-white/20 dark:bg-slate-900/40">
                                                        <div className="mb-3">
                                                            <h4 className="text-[10px] font-extrabold text-slate-500 dark:text-slate-400 uppercase tracking-[0.1em] px-2 py-0.5 bg-white/50 dark:bg-slate-800 rounded-md inline-block">{spaces.find(s => s.id === selectedSpaceId)?.settings?.labels?.set1 || 'Set 1'}</h4>
                                                        </div>
                                                        <div className="space-y-2">
                                                            <div>
                                                                <label className="text-[11px] font-bold text-emerald-400 uppercase flex items-center gap-1 mb-1">
                                                                    <span className="w-1 h-1 rounded-full bg-emerald-500"></span> Video
                                                                </label>
                                                                {product.prompts?.set1?.uploadedVideo ? (
                                                                    <div className={`group/video transition-all duration-200 ${deletingState.productId === product.id && deletingState.setKey === 'set1' && deletingState.fadingOut ? 'opacity-0 scale-95 pointer-events-none' : 'opacity-100 scale-100'}`}>
                                                                        <div className="relative rounded-lg overflow-hidden bg-black aspect-[9/16]">
                                                                            <VideoThumbPreview product={product} setKey="set1" onPlayLocalVideo={handlePlayLocalVideo} onPlayCloudVideo={handlePlayCloudVideo} t={tAnak} pushingKeys={cloudPushingKeys} />
                                                                        </div>
                                                                        <div className="flex gap-1.5 mt-1.5 opacity-0 group-hover/video:opacity-100 transition-all duration-200">
                                                                            <button
                                                                                onClick={() => { const a = document.createElement('a'); a.href = product.prompts.set1.uploadedVideo; a.download = `${product.name || 'video'}_set1.mp4`; a.target = '_blank'; a.click(); }}
                                                                                className="flex-1 flex items-center justify-center gap-1 px-2 py-1 rounded-md bg-slate-100 dark:bg-slate-800 hover:bg-blue-50 dark:hover:bg-blue-900/30 text-slate-500 hover:text-blue-600 text-[10px] font-bold transition-all"
                                                                            >
                                                                                <span className="material-symbols-outlined text-[13px]">download</span> {T('ws.video.download', 'Download')}
                                                                            </button>
                                                                            <button
                                                                                onClick={() => requestDeleteVideo(product, 'set1')}
                                                                                disabled={deletingState.productId === product.id && deletingState.setKey === 'set1'}
                                                                                className="flex-1 flex items-center justify-center gap-1 px-2 py-1 rounded-md bg-slate-100 dark:bg-slate-800 hover:bg-red-50 dark:hover:bg-red-900/30 text-slate-500 hover:text-red-500 text-[10px] font-bold transition-all disabled:opacity-50 disabled:cursor-not-allowed"
                                                                            >
                                                                                {deletingState.productId === product.id && deletingState.setKey === 'set1' ? (
                                                                                    <><span className="material-symbols-outlined animate-spin text-[13px]">progress_activity</span> {T('ws.video.deleting', 'Deleting…')}</>
                                                                                ) : (
                                                                                    <><span className="material-symbols-outlined text-[13px]">delete</span> {T('ws.video.delete', 'Delete')}</>
                                                                                )}
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                ) : (
                                                                    <div
                                                                        onClick={() => {
                                                                            if (isUploadBlockedProduct(product)) { showUploadBlockedAlert(product); return; }
                                                                            setUploadingState({ productId: product.id, setKey: 'set1', isUploading: false });
                                                                            videoInputRef.current?.click();
                                                                        }}
                                                                        className="aspect-[9/16] bg-slate-50 dark:bg-slate-800/40 rounded-lg border border-dashed border-slate-200 dark:border-slate-700 flex flex-col items-center justify-center text-[10px] text-slate-400 gap-1 cursor-pointer hover:bg-slate-100 dark:hover:bg-slate-800 transition-all group"
                                                                    >
                                                                        {uploadingState.productId === product.id && uploadingState.setKey === 'set1' && uploadingState.isUploading ? (
                                                                            <span className="material-symbols-outlined animate-spin text-primary">sync</span>
                                                                        ) : (
                                                                            <>
                                                                                <span className="material-symbols-outlined text-[22px] text-slate-300 group-hover:text-primary transition-colors">cloud_upload</span>
                                                                                <span className="font-bold group-hover:text-primary transition-colors uppercase tracking-wider text-[9px]">{T('ws.video.uploadVideo', 'Upload Video')}</span>
                                                                            </>
                                                                        )}
                                                                    </div>
                                                                )}
                                                            </div>
                                                            {/* Hook Text — separate field for all modules. Bidirectional sync dengan promptImage (auto-extract via regex). */}
                                                            <div className="group/prompt">
                                                                <div className="flex justify-between items-center mb-1">
                                                                    <label className="text-[11px] font-bold text-slate-400 uppercase flex items-center gap-1">
                                                                        <span className="w-1 h-1 rounded-full bg-amber-500"></span> Hook Text
                                                                    </label>
                                                                    <div className="flex items-center gap-0.5">
                                                                    <button onClick={(e) => { e.stopPropagation(); setPromptModalProductId(product.id); }} className="opacity-0 group-hover/prompt:opacity-100 p-0.5 rounded hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 hover:text-amber-500 transition-all" title={T('ws.prompt.editAllFullscreen', 'Edit semua prompt (fullscreen)')}>
                                                                        <span className="material-symbols-outlined text-[12px]">open_in_full</span>
                                                                    </button>
                                                                    <button onClick={(e) => { e.stopPropagation(); copyToClipboard(getEffectiveHookText(product.id, product.prompts, 'set1'), `hookText_set1_${product.id}`); }} className="opacity-0 group-hover/prompt:opacity-100 p-0.5 rounded hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 hover:text-amber-500 transition-all" title={T('ws.common.copy', 'Copy')}>
                                                                        <span className="material-symbols-outlined text-[12px]">{copiedField === `hookText_set1_${product.id}` ? 'check' : 'content_copy'}</span>
                                                                    </button>
                                                                    </div>
                                                                </div>
                                                                <div className="relative">
                                                                    <textarea
                                                                        value={getEffectiveHookText(product.id, product.prompts, 'set1')}
                                                                        onChange={(e) => updateDraftPrompt(product.id, product.prompts, 'set1', 'hookText', e.target.value)}
                                                                        readOnly onClick={() => setPromptModalProductId(product.id)}
                                                                        className="w-full h-10 bg-amber-50 dark:bg-amber-900/10 p-2 rounded-lg border border-amber-200 dark:border-amber-800/40 text-[11px] leading-relaxed text-slate-700 dark:text-slate-300 resize-none cursor-pointer hover:border-amber-400/60 hover:bg-amber-100/60 dark:hover:bg-amber-900/20 transition-colors"
                                                                        placeholder={T('ws.prompt.hookPlaceholder', 'Hook ayat — edit di sini auto-sync ke Image Prompt')}
                                                                    />
                                                                    <TemplateBadge label={getTemplateBadgeLabel(product, 'set1', 'hook')} color="amber" />
                                                                </div>
                                                                {hookSyncWarnings[`${product.id}_set1`] && (
                                                                    <div className="text-[9px] text-amber-600 dark:text-amber-400 mt-1 px-1 leading-snug font-semibold">
                                                                        {hookSyncWarnings[`${product.id}_set1`]}
                                                                    </div>
                                                                )}
                                                            </div>
                                                            <div className="group/prompt" style={resipiTanpaGambar(product) ? { display: 'none' } : undefined}>
                                                                <div className="flex justify-between items-center mb-1">
                                                                    <label className="text-[11px] font-bold text-slate-400 uppercase flex items-center gap-1">
                                                                        <span className="w-1 h-1 rounded-full bg-blue-500"></span> {spaces.find(s => s.id === selectedSpaceId)?.settings?.labels?.imagePrompt || 'Image Prompt'}
                                                                    </label>
                                                                    <div className="flex items-center gap-0.5">
                                                                    <button onClick={(e) => { e.stopPropagation(); setPromptModalProductId(product.id); }} className="opacity-0 group-hover/prompt:opacity-100 p-0.5 rounded hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 hover:text-primary transition-all" title={T('ws.prompt.editAllFullscreen', 'Edit semua prompt (fullscreen)')}>
                                                                        <span className="material-symbols-outlined text-[12px]">open_in_full</span>
                                                                    </button>
                                                                    <button onClick={(e) => { e.stopPropagation(); copyWithTag('IMAGE', 'set1', null, product.prompts?.set1?.promptImage || '', `promptImage_set1_${product.id}`); }} className="opacity-0 group-hover/prompt:opacity-100 p-0.5 rounded hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 hover:text-primary transition-all" title={T('ws.common.copy', 'Copy')}>
                                                                        <span className="material-symbols-outlined text-[12px]">{copiedField === `promptImage_set1_${product.id}` ? 'check' : 'content_copy'}</span>
                                                                    </button>
                                                                    </div>
                                                                </div>
                                                                <div className="relative">
                                                                    <textarea
                                                                        value={(draftPromptMap[product.id] ?? product.prompts)?.set1?.promptImage || ''}
                                                                        onChange={(e) => updateDraftPrompt(product.id, product.prompts, 'set1', 'promptImage', e.target.value)}
                                                                        readOnly onClick={() => setPromptModalProductId(product.id)} className="w-full h-16 bg-slate-50 dark:bg-slate-800/40 p-2 rounded-lg border border-slate-100 dark:border-slate-800 text-[11px] leading-relaxed text-slate-600 dark:text-slate-400 resize-none focus:ring-primary focus:border-primary cursor-pointer hover:border-primary/40 hover:bg-white dark:hover:bg-slate-800/60 transition-colors"
                                                                        placeholder={T('ws.prompt.empty', 'Empty')}
                                                                    />
                                                                    <TemplateBadge label={getTemplateBadgeLabel(product, 'set1', 'bg')} color="blue" />
                                                                </div>
                                                            </div>
                                                            {/* ★ RESIPI gambar berlainan, 2 scene: Image Prompt scene 2 */}
                                                            {((kadDuaBabak(product) && resipiBerlainan(product)) || resipiFrame(product)) && (
                                                                <KotakGambarBabak tajuk={resipiFrame(product) ? T('ws.resipi.imageEnd', 'Image Prompt · After (End frame)') : undefined} set={(draftPromptMap[product.id] ?? product.prompts)?.set1} babak={2} onBuka={() => setPromptModalProductId(product.id)} onSalin={(jenis, n, teks, kunci) => copyWithTag(jenis, 'set1', n, teks, kunci)} salinan={copiedField} kunci={`rimg2_set1_${product.id}`} T={T} />
                                                            )}
                                                            {/* Video Script + Video Prompt — AI16SAAT/Home Niche: 2-scene; others: 1-scene. Video Script muncul dulu (auto-sync ke Video Prompt). */}
                                                            {kadDuaBabak(product) ? (
                                                                <>
                                                                    {/* Video Script (Scene 1) */}
                                                                    <div className="group/prompt">
                                                                        <div className="flex justify-between items-center mb-1">
                                                                            <label className="text-[11px] font-bold text-slate-400 uppercase flex items-center gap-1">
                                                                                <span className="w-1 h-1 rounded-full bg-emerald-500"></span> Video Script (Scene 1)
                                                                            </label>
                                                                            <div className="flex items-center gap-0.5">
                                                                            <button onClick={(e) => { e.stopPropagation(); setPromptModalProductId(product.id); }} className="opacity-0 group-hover/prompt:opacity-100 p-0.5 rounded hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 hover:text-emerald-500 transition-all" title={T('ws.prompt.editAllFullscreen', 'Edit semua prompt (fullscreen)')}>
                                                                                <span className="material-symbols-outlined text-[12px]">open_in_full</span>
                                                                            </button>
                                                                            <button onClick={(e) => { e.stopPropagation(); copyToClipboard(getEffectiveVideoScript(product.id, product.prompts, 'set1', '1'), `videoScript1_set1_${product.id}`); }} className="opacity-0 group-hover/prompt:opacity-100 p-0.5 rounded hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 hover:text-emerald-500 transition-all" title={T('ws.common.copy', 'Copy')}>
                                                                                <span className="material-symbols-outlined text-[12px]">{copiedField === `videoScript1_set1_${product.id}` ? 'check' : 'content_copy'}</span>
                                                                            </button>
                                                                            </div>
                                                                        </div>
                                                                        <textarea
                                                                            value={getEffectiveVideoScript(product.id, product.prompts, 'set1', '1')}
                                                                            onChange={(e) => updateDraftPrompt(product.id, product.prompts, 'set1', 'videoScript1', e.target.value)}
                                                                            readOnly onClick={() => setPromptModalProductId(product.id)}
                                                                            className="w-full h-12 bg-emerald-50 dark:bg-emerald-900/10 p-2 rounded-lg border border-emerald-200 dark:border-emerald-800/40 text-[11px] leading-relaxed text-slate-700 dark:text-slate-300 resize-none cursor-pointer hover:border-emerald-400/60 hover:bg-emerald-100/60 dark:hover:bg-emerald-900/20 transition-colors"
                                                                            placeholder={T('ws.prompt.voiceoverScene1Placeholder', 'Voiceover Scene 1 — auto-sync ke Video Prompt (Scene 1)')}
                                                                        />
                                                                    </div>
                                                                    {/* Video Prompt (Scene 1) */}
                                                                    <div className="group/prompt">
                                                                        <div className="flex justify-between items-center mb-1">
                                                                            <label className="text-[11px] font-bold text-slate-400 uppercase flex items-center gap-1">
                                                                                <span className="w-1 h-1 rounded-full bg-purple-500"></span> Video Prompt (Scene 1)
                                                                            </label>
                                                                            <div className="flex items-center gap-0.5">
                                                                            <button onClick={(e) => { e.stopPropagation(); setPromptModalProductId(product.id); }} className="opacity-0 group-hover/prompt:opacity-100 p-0.5 rounded hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 hover:text-primary transition-all" title={T('ws.prompt.editAllFullscreen', 'Edit semua prompt (fullscreen)')}>
                                                                                <span className="material-symbols-outlined text-[12px]">open_in_full</span>
                                                                            </button>
                                                                            <button onClick={(e) => { e.stopPropagation(); copyWithTag('VIDEO', 'set1', 1, product.prompts?.set1?.promptVideo1 || product.prompts?.set1?.promptVideo || '', `promptVideo1_set1_${product.id}`); }} className="opacity-0 group-hover/prompt:opacity-100 p-0.5 rounded hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 hover:text-primary transition-all" title={T('ws.common.copy', 'Copy')}>
                                                                                <span className="material-symbols-outlined text-[12px]">{copiedField === `promptVideo1_set1_${product.id}` ? 'check' : 'content_copy'}</span>
                                                                            </button>
                                                                            </div>
                                                                        </div>
                                                                        <textarea
                                                                            value={(draftPromptMap[product.id] ?? product.prompts)?.set1?.promptVideo1 || (draftPromptMap[product.id] ?? product.prompts)?.set1?.promptVideo || ''}
                                                                            onChange={(e) => updateDraftPrompt(product.id, product.prompts, 'set1', 'promptVideo1', e.target.value)}
                                                                            readOnly onClick={() => setPromptModalProductId(product.id)} className="w-full h-16 bg-slate-50 dark:bg-slate-800/40 p-2 rounded-lg border border-slate-100 dark:border-slate-800 text-[11px] leading-relaxed text-slate-600 dark:text-slate-400 resize-none focus:ring-primary focus:border-primary cursor-pointer hover:border-primary/40 hover:bg-white dark:hover:bg-slate-800/60 transition-colors"
                                                                            placeholder={T('ws.prompt.empty', 'Empty')}
                                                                        />
                                                                    </div>
                                                                    {/* Video Script (Scene 2) */}
                                                                    <div className="group/prompt">
                                                                        <div className="flex justify-between items-center mb-1">
                                                                            <label className="text-[11px] font-bold text-slate-400 uppercase flex items-center gap-1">
                                                                                <span className="w-1 h-1 rounded-full bg-teal-500"></span> Video Script (Scene 2)
                                                                            </label>
                                                                            <div className="flex items-center gap-0.5">
                                                                            <button onClick={(e) => { e.stopPropagation(); setPromptModalProductId(product.id); }} className="opacity-0 group-hover/prompt:opacity-100 p-0.5 rounded hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 hover:text-teal-500 transition-all" title={T('ws.prompt.editAllFullscreen', 'Edit semua prompt (fullscreen)')}>
                                                                                <span className="material-symbols-outlined text-[12px]">open_in_full</span>
                                                                            </button>
                                                                            <button onClick={(e) => { e.stopPropagation(); copyToClipboard(getEffectiveVideoScript(product.id, product.prompts, 'set1', '2'), `videoScript2_set1_${product.id}`); }} className="opacity-0 group-hover/prompt:opacity-100 p-0.5 rounded hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 hover:text-teal-500 transition-all" title={T('ws.common.copy', 'Copy')}>
                                                                                <span className="material-symbols-outlined text-[12px]">{copiedField === `videoScript2_set1_${product.id}` ? 'check' : 'content_copy'}</span>
                                                                            </button>
                                                                            </div>
                                                                        </div>
                                                                        <textarea
                                                                            value={getEffectiveVideoScript(product.id, product.prompts, 'set1', '2')}
                                                                            onChange={(e) => updateDraftPrompt(product.id, product.prompts, 'set1', 'videoScript2', e.target.value)}
                                                                            readOnly onClick={() => setPromptModalProductId(product.id)}
                                                                            className="w-full h-12 bg-teal-50 dark:bg-teal-900/10 p-2 rounded-lg border border-teal-200 dark:border-teal-800/40 text-[11px] leading-relaxed text-slate-700 dark:text-slate-300 resize-none cursor-pointer hover:border-teal-400/60 hover:bg-teal-100/60 dark:hover:bg-teal-900/20 transition-colors"
                                                                            placeholder={T('ws.prompt.voiceoverScene2Placeholder', 'Voiceover Scene 2 — auto-sync ke Video Prompt (Scene 2)')}
                                                                        />
                                                                    </div>
                                                                    {/* Video Prompt (Scene 2) */}
                                                                    <div className="group/prompt">
                                                                        <div className="flex justify-between items-center mb-1">
                                                                            <label className="text-[11px] font-bold text-slate-400 uppercase flex items-center gap-1">
                                                                                <span className="w-1 h-1 rounded-full bg-violet-500"></span> Video Prompt (Scene 2)
                                                                            </label>
                                                                            <div className="flex items-center gap-0.5">
                                                                            <button onClick={(e) => { e.stopPropagation(); setPromptModalProductId(product.id); }} className="opacity-0 group-hover/prompt:opacity-100 p-0.5 rounded hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 hover:text-primary transition-all" title={T('ws.prompt.editAllFullscreen', 'Edit semua prompt (fullscreen)')}>
                                                                                <span className="material-symbols-outlined text-[12px]">open_in_full</span>
                                                                            </button>
                                                                            <button onClick={(e) => { e.stopPropagation(); copyWithTag('VIDEO', 'set1', 2, product.prompts?.set1?.promptVideo2 || '', `promptVideo2_set1_${product.id}`); }} className="opacity-0 group-hover/prompt:opacity-100 p-0.5 rounded hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 hover:text-primary transition-all" title={T('ws.common.copy', 'Copy')}>
                                                                                <span className="material-symbols-outlined text-[12px]">{copiedField === `promptVideo2_set1_${product.id}` ? 'check' : 'content_copy'}</span>
                                                                            </button>
                                                                            </div>
                                                                        </div>
                                                                        <textarea
                                                                            value={(draftPromptMap[product.id] ?? product.prompts)?.set1?.promptVideo2 || ''}
                                                                            onChange={(e) => updateDraftPrompt(product.id, product.prompts, 'set1', 'promptVideo2', e.target.value)}
                                                                            readOnly onClick={() => setPromptModalProductId(product.id)} className="w-full h-16 bg-slate-50 dark:bg-slate-800/40 p-2 rounded-lg border border-slate-100 dark:border-slate-800 text-[11px] leading-relaxed text-slate-600 dark:text-slate-400 resize-none focus:ring-primary focus:border-primary cursor-pointer hover:border-primary/40 hover:bg-white dark:hover:bg-slate-800/60 transition-colors"
                                                                            placeholder={T('ws.prompt.empty', 'Empty')}
                                                                        />
                                                                    </div>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    {/* Video Script (single-scene) */}
                                                                    <div className="group/prompt">
                                                                        <div className="flex justify-between items-center mb-1">
                                                                            <label className="text-[11px] font-bold text-slate-400 uppercase flex items-center gap-1">
                                                                                <span className="w-1 h-1 rounded-full bg-emerald-500"></span> Video Script
                                                                            </label>
                                                                            <div className="flex items-center gap-0.5">
                                                                            <button onClick={(e) => { e.stopPropagation(); setPromptModalProductId(product.id); }} className="opacity-0 group-hover/prompt:opacity-100 p-0.5 rounded hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 hover:text-emerald-500 transition-all" title={T('ws.prompt.editAllFullscreen', 'Edit semua prompt (fullscreen)')}>
                                                                                <span className="material-symbols-outlined text-[12px]">open_in_full</span>
                                                                            </button>
                                                                            <button onClick={(e) => { e.stopPropagation(); copyToClipboard(getEffectiveVideoScript(product.id, product.prompts, 'set1'), `videoScript_set1_${product.id}`); }} className="opacity-0 group-hover/prompt:opacity-100 p-0.5 rounded hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 hover:text-emerald-500 transition-all" title={T('ws.common.copy', 'Copy')}>
                                                                                <span className="material-symbols-outlined text-[12px]">{copiedField === `videoScript_set1_${product.id}` ? 'check' : 'content_copy'}</span>
                                                                            </button>
                                                                            </div>
                                                                        </div>
                                                                        <textarea
                                                                            value={getEffectiveVideoScript(product.id, product.prompts, 'set1')}
                                                                            onChange={(e) => updateDraftPrompt(product.id, product.prompts, 'set1', 'videoScript', e.target.value)}
                                                                            readOnly onClick={() => setPromptModalProductId(product.id)}
                                                                            className="w-full h-12 bg-emerald-50 dark:bg-emerald-900/10 p-2 rounded-lg border border-emerald-200 dark:border-emerald-800/40 text-[11px] leading-relaxed text-slate-700 dark:text-slate-300 resize-none cursor-pointer hover:border-emerald-400/60 hover:bg-emerald-100/60 dark:hover:bg-emerald-900/20 transition-colors"
                                                                            placeholder={T('ws.prompt.voiceoverPlaceholder', 'Voiceover script — auto-sync ke Video Prompt')}
                                                                        />
                                                                    </div>
                                                                    {/* Video Prompt (single-scene) */}
                                                                    <div className="group/prompt">
                                                                        <div className="flex justify-between items-center mb-1">
                                                                            <label className="text-[11px] font-bold text-slate-400 uppercase flex items-center gap-1">
                                                                                <span className="w-1 h-1 rounded-full bg-purple-500"></span> {spaces.find(s => s.id === selectedSpaceId)?.settings?.labels?.videoPrompt || 'Video Prompt'}
                                                                            </label>
                                                                            <div className="flex items-center gap-0.5">
                                                                            <button onClick={(e) => { e.stopPropagation(); setPromptModalProductId(product.id); }} className="opacity-0 group-hover/prompt:opacity-100 p-0.5 rounded hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 hover:text-primary transition-all" title={T('ws.prompt.editAllFullscreen', 'Edit semua prompt (fullscreen)')}>
                                                                                <span className="material-symbols-outlined text-[12px]">open_in_full</span>
                                                                            </button>
                                                                            <button onClick={(e) => { e.stopPropagation(); copyWithTag('VIDEO', 'set1', null, product.prompts?.set1?.promptVideo || '', `promptVideo_set1_${product.id}`); }} className="opacity-0 group-hover/prompt:opacity-100 p-0.5 rounded hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 hover:text-primary transition-all" title={T('ws.common.copy', 'Copy')}>
                                                                                <span className="material-symbols-outlined text-[12px]">{copiedField === `promptVideo_set1_${product.id}` ? 'check' : 'content_copy'}</span>
                                                                            </button>
                                                                            </div>
                                                                        </div>
                                                                        <textarea
                                                                            value={(draftPromptMap[product.id] ?? product.prompts)?.set1?.promptVideo || ''}
                                                                            onChange={(e) => updateDraftPrompt(product.id, product.prompts, 'set1', 'promptVideo', e.target.value)}
                                                                            readOnly onClick={() => setPromptModalProductId(product.id)} className="w-full h-16 bg-slate-50 dark:bg-slate-800/40 p-2 rounded-lg border border-slate-100 dark:border-slate-800 text-[11px] leading-relaxed text-slate-600 dark:text-slate-400 resize-none focus:ring-primary focus:border-primary cursor-pointer hover:border-primary/40 hover:bg-white dark:hover:bg-slate-800/60 transition-colors"
                                                                            placeholder={T('ws.prompt.empty', 'Empty')}
                                                                        />
                                                                    </div>
                                                                </>
                                                            )}
                                                            {!product.hideCaption && spaces.find(s => s.id === selectedSpaceId)?.settings?.showTikTokCaption !== false && (() => {
                                                                /* ★ [2026-09-27] Suis TikTok/FB pada setiap set (pilihan A) — tekan di mana-mana set,
                                                                   ketiga-tiga set bertukar. Paparan sahaja; edit caption FB dalam modal. */
                                                                const capFb = capTabFb.has(product.id);
                                                                const cap = captionKad((draftPromptMap[product.id] ?? product.prompts)?.set1, capFb);
                                                                return (
                                                                <div className="group/prompt">
                                                                    <div className="flex justify-between items-center mb-1">
                                                                        <label className="text-[11px] font-bold text-slate-400 uppercase flex items-center gap-1">
                                                                            <span className={`w-1 h-1 rounded-full ${capFb ? 'bg-sky-500' : 'bg-rose-500'}`}></span> {labelCaptionKad(spaces.find(s => s.id === selectedSpaceId)?.settings?.labels?.captionTiktok, capFb, T)}
                                                                        </label>
                                                                        <div className="flex items-center gap-0.5">
                                                                        <SuisCaptionKad fb={capFb} onTukar={(v) => tukarCapKad(product.id, v)} T={T} />
                                                                        <button onClick={(e) => { e.stopPropagation(); setPromptModalProductId(product.id); }} className="opacity-0 group-hover/prompt:opacity-100 p-0.5 rounded hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 hover:text-primary transition-all" title={T('ws.prompt.editAllFullscreen', 'Edit semua prompt (fullscreen)')}>
                                                                            <span className="material-symbols-outlined text-[12px]">open_in_full</span>
                                                                        </button>
                                                                        <button onClick={(e) => { e.stopPropagation(); copyToClipboard(captionKad(product.prompts?.set1, capFb).teks, `captionTiktok_set1_${product.id}`); }} className="opacity-0 group-hover/prompt:opacity-100 p-0.5 rounded hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 hover:text-primary transition-all" title={T('ws.common.copy', 'Copy')}>
                                                                            <span className="material-symbols-outlined text-[12px]">{copiedField === `captionTiktok_set1_${product.id}` ? 'check' : 'content_copy'}</span>
                                                                        </button>
                                                                        </div>
                                                                    </div>
                                                                    <textarea
                                                                        value={cap.teks}
                                                                        onChange={capFb ? undefined : (e) => updateDraftPrompt(product.id, product.prompts, 'set1', 'captionTiktok', e.target.value)}
                                                                        readOnly onClick={() => setPromptModalProductId(product.id)} className="w-full h-16 bg-slate-50 dark:bg-slate-800/40 p-2 rounded-lg border border-slate-100 dark:border-slate-800 text-[11px] leading-relaxed text-slate-600 dark:text-slate-400 resize-none focus:ring-primary focus:border-primary cursor-pointer hover:border-primary/40 hover:bg-white dark:hover:bg-slate-800/60 transition-colors"
                                                                        placeholder={cap.kosongSengaja ? T('ws.caption.fbKosongSengaja', 'Kosong — Facebook akan post tanpa caption') : T('ws.prompt.empty', 'Empty')}
                                                                    />
                                                                </div>
                                                                );
                                                            })()}
                                                        </div>
                                                    </div>

                                                    {/* Set 2 */}
                                                    {spaces.find(s => s.id === selectedSpaceId)?.settings?.showSet2 !== false && (
                                                        <div className="p-4 bg-white/20 dark:bg-slate-900/40">
                                                            <div className="mb-3">
                                                                <h4 className="text-[10px] font-extrabold text-slate-500 dark:text-slate-400 uppercase tracking-[0.1em] px-2 py-0.5 bg-white/50 dark:bg-slate-800 rounded-md inline-block">{spaces.find(s => s.id === selectedSpaceId)?.settings?.labels?.set2 || 'Set 2'}</h4>
                                                            </div>
                                                            <div className="space-y-2">
                                                                <div>
                                                                    <label className="text-[11px] font-bold text-emerald-400 uppercase flex items-center gap-1 mb-1">
                                                                        <span className="w-1 h-1 rounded-full bg-emerald-500"></span> Video
                                                                    </label>
                                                                    {product.prompts?.set2?.uploadedVideo ? (
                                                                        <div className={`group/video transition-all duration-200 ${deletingState.productId === product.id && deletingState.setKey === 'set2' && deletingState.fadingOut ? 'opacity-0 scale-95 pointer-events-none' : 'opacity-100 scale-100'}`}>
                                                                            <div className="relative rounded-lg overflow-hidden bg-black aspect-[9/16]">
                                                                                <VideoThumbPreview product={product} setKey="set2" onPlayLocalVideo={handlePlayLocalVideo} onPlayCloudVideo={handlePlayCloudVideo} t={tAnak} pushingKeys={cloudPushingKeys} />
                                                                            </div>
                                                                            <div className="flex gap-1.5 mt-1.5 opacity-0 group-hover/video:opacity-100 transition-all duration-200">
                                                                                <button
                                                                                    onClick={() => { const a = document.createElement('a'); a.href = product.prompts.set2.uploadedVideo; a.download = `${product.name || 'video'}_set2.mp4`; a.target = '_blank'; a.click(); }}
                                                                                    className="flex-1 flex items-center justify-center gap-1 px-2 py-1 rounded-md bg-slate-100 dark:bg-slate-800 hover:bg-blue-50 dark:hover:bg-blue-900/30 text-slate-500 hover:text-blue-600 text-[10px] font-bold transition-all"
                                                                                >
                                                                                    <span className="material-symbols-outlined text-[13px]">download</span> {T('ws.video.download', 'Download')}
                                                                                </button>
                                                                                <button
                                                                                    onClick={() => requestDeleteVideo(product, 'set2')}
                                                                                    disabled={deletingState.productId === product.id && deletingState.setKey === 'set2'}
                                                                                    className="flex-1 flex items-center justify-center gap-1 px-2 py-1 rounded-md bg-slate-100 dark:bg-slate-800 hover:bg-red-50 dark:hover:bg-red-900/30 text-slate-500 hover:text-red-500 text-[10px] font-bold transition-all disabled:opacity-50 disabled:cursor-not-allowed"
                                                                                >
                                                                                    {deletingState.productId === product.id && deletingState.setKey === 'set2' ? (
                                                                                        <><span className="material-symbols-outlined animate-spin text-[13px]">progress_activity</span> {T('ws.video.deleting', 'Deleting…')}</>
                                                                                    ) : (
                                                                                        <><span className="material-symbols-outlined text-[13px]">delete</span> {T('ws.video.delete', 'Delete')}</>
                                                                                    )}
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    ) : (
                                                                        <div
                                                                            onClick={() => {
                                                                                if (isUploadBlockedProduct(product)) { showUploadBlockedAlert(product); return; }
                                                                                setUploadingState({ productId: product.id, setKey: 'set2', isUploading: false });
                                                                                videoInputRef.current?.click();
                                                                            }}
                                                                            className="aspect-[9/16] bg-slate-50 dark:bg-slate-800/40 rounded-lg border border-dashed border-slate-200 dark:border-slate-700 flex flex-col items-center justify-center text-[10px] text-slate-400 gap-1 cursor-pointer hover:bg-slate-100 dark:hover:bg-slate-800 transition-all group"
                                                                        >
                                                                            {uploadingState.productId === product.id && uploadingState.setKey === 'set2' && uploadingState.isUploading ? (
                                                                                <span className="material-symbols-outlined animate-spin text-primary">sync</span>
                                                                            ) : (
                                                                                <>
                                                                                    <span className="material-symbols-outlined text-[22px] text-slate-300 group-hover:text-primary transition-colors">cloud_upload</span>
                                                                                    <span className="font-bold group-hover:text-primary transition-colors uppercase tracking-wider text-[9px]">{T('ws.video.uploadVideo', 'Upload Video')}</span>
                                                                                </>
                                                                            )}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                                {/* Hook Text — separate field for all modules. Bidirectional sync dengan promptImage. */}
                                                                <div className="group/prompt">
                                                                    <div className="flex justify-between items-center mb-1">
                                                                        <label className="text-[11px] font-bold text-slate-400 uppercase flex items-center gap-1">
                                                                            <span className="w-1 h-1 rounded-full bg-amber-500"></span> Hook Text
                                                                        </label>
                                                                        <div className="flex items-center gap-0.5">
                                                                        <button onClick={(e) => { e.stopPropagation(); setPromptModalProductId(product.id); }} className="opacity-0 group-hover/prompt:opacity-100 p-0.5 rounded hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 hover:text-amber-500 transition-all" title={T('ws.prompt.editAllFullscreen', 'Edit semua prompt (fullscreen)')}>
                                                                            <span className="material-symbols-outlined text-[12px]">open_in_full</span>
                                                                        </button>
                                                                        <button onClick={(e) => { e.stopPropagation(); copyToClipboard(getEffectiveHookText(product.id, product.prompts, 'set2'), `hookText_set2_${product.id}`); }} className="opacity-0 group-hover/prompt:opacity-100 p-0.5 rounded hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 hover:text-amber-500 transition-all" title={T('ws.common.copy', 'Copy')}>
                                                                            <span className="material-symbols-outlined text-[12px]">{copiedField === `hookText_set2_${product.id}` ? 'check' : 'content_copy'}</span>
                                                                        </button>
                                                                        </div>
                                                                    </div>
                                                                    <div className="relative">
                                                                        <textarea
                                                                            value={getEffectiveHookText(product.id, product.prompts, 'set2')}
                                                                            onChange={(e) => updateDraftPrompt(product.id, product.prompts, 'set2', 'hookText', e.target.value)}
                                                                            readOnly onClick={() => setPromptModalProductId(product.id)}
                                                                            className="w-full h-10 bg-amber-50 dark:bg-amber-900/10 p-2 rounded-lg border border-amber-200 dark:border-amber-800/40 text-[11px] leading-relaxed text-slate-700 dark:text-slate-300 resize-none cursor-pointer hover:border-amber-400/60 hover:bg-amber-100/60 dark:hover:bg-amber-900/20 transition-colors"
                                                                            placeholder={T('ws.prompt.hookPlaceholder', 'Hook ayat — edit di sini auto-sync ke Image Prompt')}
                                                                        />
                                                                        <TemplateBadge label={getTemplateBadgeLabel(product, 'set2', 'hook')} color="amber" />
                                                                    </div>
                                                                    {hookSyncWarnings[`${product.id}_set2`] && (
                                                                        <div className="text-[9px] text-amber-600 dark:text-amber-400 mt-1 px-1 leading-snug font-semibold">
                                                                            {hookSyncWarnings[`${product.id}_set2`]}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                                <div className="group/prompt" style={resipiTanpaGambar(product) ? { display: 'none' } : undefined}>
                                                                    <div className="flex justify-between items-center mb-1">
                                                                        <label className="text-[11px] font-bold text-slate-400 uppercase flex items-center gap-1">
                                                                            <span className="w-1 h-1 rounded-full bg-blue-500"></span> {spaces.find(s => s.id === selectedSpaceId)?.settings?.labels?.imagePrompt || 'Image Prompt'}
                                                                        </label>
                                                                        <div className="flex items-center gap-0.5">
                                                                        <button onClick={(e) => { e.stopPropagation(); setPromptModalProductId(product.id); }} className="opacity-0 group-hover/prompt:opacity-100 p-0.5 rounded hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 hover:text-primary transition-all" title={T('ws.prompt.editAllFullscreen', 'Edit semua prompt (fullscreen)')}>
                                                                            <span className="material-symbols-outlined text-[12px]">open_in_full</span>
                                                                        </button>
                                                                        <button onClick={(e) => { e.stopPropagation(); copyWithTag('IMAGE', 'set2', null, product.prompts?.set2?.promptImage || '', `promptImage_set2_${product.id}`); }} className="opacity-0 group-hover/prompt:opacity-100 p-0.5 rounded hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 hover:text-primary transition-all" title={T('ws.common.copy', 'Copy')}>
                                                                            <span className="material-symbols-outlined text-[12px]">{copiedField === `promptImage_set2_${product.id}` ? 'check' : 'content_copy'}</span>
                                                                        </button>
                                                                        </div>
                                                                    </div>
                                                                    <div className="relative">
                                                                        <textarea
                                                                            value={(draftPromptMap[product.id] ?? product.prompts)?.set2?.promptImage || ''}
                                                                            onChange={(e) => updateDraftPrompt(product.id, product.prompts, 'set2', 'promptImage', e.target.value)}
                                                                            readOnly onClick={() => setPromptModalProductId(product.id)} className="w-full h-16 bg-slate-50 dark:bg-slate-800/40 p-2 rounded-lg border border-slate-100 dark:border-slate-800 text-[11px] leading-relaxed text-slate-600 dark:text-slate-400 resize-none focus:ring-primary focus:border-primary cursor-pointer hover:border-primary/40 hover:bg-white dark:hover:bg-slate-800/60 transition-colors"
                                                                            placeholder={T('ws.prompt.empty', 'Empty')}
                                                                        />
                                                                        <TemplateBadge label={getTemplateBadgeLabel(product, 'set2', 'bg')} color="blue" />
                                                                    </div>
                                                                </div>
                                                                {/* ★ RESIPI gambar berlainan, 2 scene: Image Prompt scene 2 */}
                                                                {((kadDuaBabak(product) && resipiBerlainan(product)) || resipiFrame(product)) && (
                                                                    <KotakGambarBabak tajuk={resipiFrame(product) ? T('ws.resipi.imageEnd', 'Image Prompt · After (End frame)') : undefined} set={(draftPromptMap[product.id] ?? product.prompts)?.set2} babak={2} onBuka={() => setPromptModalProductId(product.id)} onSalin={(jenis, n, teks, kunci) => copyWithTag(jenis, 'set2', n, teks, kunci)} salinan={copiedField} kunci={`rimg2_set2_${product.id}`} T={T} />
                                                                )}
                                                                {/* Video Script + Video Prompt Set 2 — AI16SAAT/Home Niche: 2-scene; others: 1-scene. Video Script muncul dulu. */}
                                                                {kadDuaBabak(product) ? (
                                                                    <>
                                                                        {/* Video Script (Scene 1) */}
                                                                        <div className="group/prompt">
                                                                            <div className="flex justify-between items-center mb-1">
                                                                                <label className="text-[11px] font-bold text-slate-400 uppercase flex items-center gap-1">
                                                                                    <span className="w-1 h-1 rounded-full bg-emerald-500"></span> Video Script (Scene 1)
                                                                                </label>
                                                                                <div className="flex items-center gap-0.5">
                                                                                <button onClick={(e) => { e.stopPropagation(); setPromptModalProductId(product.id); }} className="opacity-0 group-hover/prompt:opacity-100 p-0.5 rounded hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 hover:text-emerald-500 transition-all" title={T('ws.prompt.editAllFullscreen', 'Edit semua prompt (fullscreen)')}>
                                                                                    <span className="material-symbols-outlined text-[12px]">open_in_full</span>
                                                                                </button>
                                                                                <button onClick={(e) => { e.stopPropagation(); copyToClipboard(getEffectiveVideoScript(product.id, product.prompts, 'set2', '1'), `videoScript1_set2_${product.id}`); }} className="opacity-0 group-hover/prompt:opacity-100 p-0.5 rounded hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 hover:text-emerald-500 transition-all" title={T('ws.common.copy', 'Copy')}>
                                                                                    <span className="material-symbols-outlined text-[12px]">{copiedField === `videoScript1_set2_${product.id}` ? 'check' : 'content_copy'}</span>
                                                                                </button>
                                                                                </div>
                                                                            </div>
                                                                            <textarea
                                                                                value={getEffectiveVideoScript(product.id, product.prompts, 'set2', '1')}
                                                                                onChange={(e) => updateDraftPrompt(product.id, product.prompts, 'set2', 'videoScript1', e.target.value)}
                                                                                readOnly onClick={() => setPromptModalProductId(product.id)}
                                                                                className="w-full h-12 bg-emerald-50 dark:bg-emerald-900/10 p-2 rounded-lg border border-emerald-200 dark:border-emerald-800/40 text-[11px] leading-relaxed text-slate-700 dark:text-slate-300 resize-none cursor-pointer hover:border-emerald-400/60 hover:bg-emerald-100/60 dark:hover:bg-emerald-900/20 transition-colors"
                                                                                placeholder={T('ws.prompt.voiceoverScene1Placeholder', 'Voiceover Scene 1 — auto-sync ke Video Prompt (Scene 1)')}
                                                                            />
                                                                        </div>
                                                                        {/* Video Prompt (Scene 1) */}
                                                                        <div className="group/prompt">
                                                                            <div className="flex justify-between items-center mb-1">
                                                                                <label className="text-[11px] font-bold text-slate-400 uppercase flex items-center gap-1">
                                                                                    <span className="w-1 h-1 rounded-full bg-purple-500"></span> Video Prompt (Scene 1)
                                                                                </label>
                                                                                <div className="flex items-center gap-0.5">
                                                                                <button onClick={(e) => { e.stopPropagation(); setPromptModalProductId(product.id); }} className="opacity-0 group-hover/prompt:opacity-100 p-0.5 rounded hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 hover:text-primary transition-all" title={T('ws.prompt.editAllFullscreen', 'Edit semua prompt (fullscreen)')}>
                                                                                    <span className="material-symbols-outlined text-[12px]">open_in_full</span>
                                                                                </button>
                                                                                <button onClick={(e) => { e.stopPropagation(); copyWithTag('VIDEO', 'set2', 1, product.prompts?.set2?.promptVideo1 || product.prompts?.set2?.promptVideo || '', `promptVideo1_set2_${product.id}`); }} className="opacity-0 group-hover/prompt:opacity-100 p-0.5 rounded hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 hover:text-primary transition-all" title={T('ws.common.copy', 'Copy')}>
                                                                                    <span className="material-symbols-outlined text-[12px]">{copiedField === `promptVideo1_set2_${product.id}` ? 'check' : 'content_copy'}</span>
                                                                                </button>
                                                                                </div>
                                                                            </div>
                                                                            <textarea
                                                                                value={(draftPromptMap[product.id] ?? product.prompts)?.set2?.promptVideo1 || (draftPromptMap[product.id] ?? product.prompts)?.set2?.promptVideo || ''}
                                                                                onChange={(e) => updateDraftPrompt(product.id, product.prompts, 'set2', 'promptVideo1', e.target.value)}
                                                                                readOnly onClick={() => setPromptModalProductId(product.id)} className="w-full h-16 bg-slate-50 dark:bg-slate-800/40 p-2 rounded-lg border border-slate-100 dark:border-slate-800 text-[11px] leading-relaxed text-slate-600 dark:text-slate-400 resize-none focus:ring-primary focus:border-primary cursor-pointer hover:border-primary/40 hover:bg-white dark:hover:bg-slate-800/60 transition-colors"
                                                                                placeholder={T('ws.prompt.empty', 'Empty')}
                                                                            />
                                                                        </div>
                                                                        {/* Video Script (Scene 2) */}
                                                                        <div className="group/prompt">
                                                                            <div className="flex justify-between items-center mb-1">
                                                                                <label className="text-[11px] font-bold text-slate-400 uppercase flex items-center gap-1">
                                                                                    <span className="w-1 h-1 rounded-full bg-teal-500"></span> Video Script (Scene 2)
                                                                                </label>
                                                                                <div className="flex items-center gap-0.5">
                                                                                <button onClick={(e) => { e.stopPropagation(); setPromptModalProductId(product.id); }} className="opacity-0 group-hover/prompt:opacity-100 p-0.5 rounded hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 hover:text-teal-500 transition-all" title={T('ws.prompt.editAllFullscreen', 'Edit semua prompt (fullscreen)')}>
                                                                                    <span className="material-symbols-outlined text-[12px]">open_in_full</span>
                                                                                </button>
                                                                                <button onClick={(e) => { e.stopPropagation(); copyToClipboard(getEffectiveVideoScript(product.id, product.prompts, 'set2', '2'), `videoScript2_set2_${product.id}`); }} className="opacity-0 group-hover/prompt:opacity-100 p-0.5 rounded hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 hover:text-teal-500 transition-all" title={T('ws.common.copy', 'Copy')}>
                                                                                    <span className="material-symbols-outlined text-[12px]">{copiedField === `videoScript2_set2_${product.id}` ? 'check' : 'content_copy'}</span>
                                                                                </button>
                                                                                </div>
                                                                            </div>
                                                                            <textarea
                                                                                value={getEffectiveVideoScript(product.id, product.prompts, 'set2', '2')}
                                                                                onChange={(e) => updateDraftPrompt(product.id, product.prompts, 'set2', 'videoScript2', e.target.value)}
                                                                                readOnly onClick={() => setPromptModalProductId(product.id)}
                                                                                className="w-full h-12 bg-teal-50 dark:bg-teal-900/10 p-2 rounded-lg border border-teal-200 dark:border-teal-800/40 text-[11px] leading-relaxed text-slate-700 dark:text-slate-300 resize-none cursor-pointer hover:border-teal-400/60 hover:bg-teal-100/60 dark:hover:bg-teal-900/20 transition-colors"
                                                                                placeholder={T('ws.prompt.voiceoverScene2Placeholder', 'Voiceover Scene 2 — auto-sync ke Video Prompt (Scene 2)')}
                                                                            />
                                                                        </div>
                                                                        {/* Video Prompt (Scene 2) */}
                                                                        <div className="group/prompt">
                                                                            <div className="flex justify-between items-center mb-1">
                                                                                <label className="text-[11px] font-bold text-slate-400 uppercase flex items-center gap-1">
                                                                                    <span className="w-1 h-1 rounded-full bg-violet-500"></span> Video Prompt (Scene 2)
                                                                                </label>
                                                                                <div className="flex items-center gap-0.5">
                                                                                <button onClick={(e) => { e.stopPropagation(); setPromptModalProductId(product.id); }} className="opacity-0 group-hover/prompt:opacity-100 p-0.5 rounded hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 hover:text-primary transition-all" title={T('ws.prompt.editAllFullscreen', 'Edit semua prompt (fullscreen)')}>
                                                                                    <span className="material-symbols-outlined text-[12px]">open_in_full</span>
                                                                                </button>
                                                                                <button onClick={(e) => { e.stopPropagation(); copyWithTag('VIDEO', 'set2', 2, product.prompts?.set2?.promptVideo2 || '', `promptVideo2_set2_${product.id}`); }} className="opacity-0 group-hover/prompt:opacity-100 p-0.5 rounded hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 hover:text-primary transition-all" title={T('ws.common.copy', 'Copy')}>
                                                                                    <span className="material-symbols-outlined text-[12px]">{copiedField === `promptVideo2_set2_${product.id}` ? 'check' : 'content_copy'}</span>
                                                                                </button>
                                                                                </div>
                                                                            </div>
                                                                            <textarea
                                                                                value={(draftPromptMap[product.id] ?? product.prompts)?.set2?.promptVideo2 || ''}
                                                                                onChange={(e) => updateDraftPrompt(product.id, product.prompts, 'set2', 'promptVideo2', e.target.value)}
                                                                                readOnly onClick={() => setPromptModalProductId(product.id)} className="w-full h-16 bg-slate-50 dark:bg-slate-800/40 p-2 rounded-lg border border-slate-100 dark:border-slate-800 text-[11px] leading-relaxed text-slate-600 dark:text-slate-400 resize-none focus:ring-primary focus:border-primary cursor-pointer hover:border-primary/40 hover:bg-white dark:hover:bg-slate-800/60 transition-colors"
                                                                                placeholder={T('ws.prompt.empty', 'Empty')}
                                                                            />
                                                                        </div>
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        {/* Video Script (single-scene) */}
                                                                        <div className="group/prompt">
                                                                            <div className="flex justify-between items-center mb-1">
                                                                                <label className="text-[11px] font-bold text-slate-400 uppercase flex items-center gap-1">
                                                                                    <span className="w-1 h-1 rounded-full bg-emerald-500"></span> Video Script
                                                                                </label>
                                                                                <div className="flex items-center gap-0.5">
                                                                                <button onClick={(e) => { e.stopPropagation(); setPromptModalProductId(product.id); }} className="opacity-0 group-hover/prompt:opacity-100 p-0.5 rounded hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 hover:text-emerald-500 transition-all" title={T('ws.prompt.editAllFullscreen', 'Edit semua prompt (fullscreen)')}>
                                                                                    <span className="material-symbols-outlined text-[12px]">open_in_full</span>
                                                                                </button>
                                                                                <button onClick={(e) => { e.stopPropagation(); copyToClipboard(getEffectiveVideoScript(product.id, product.prompts, 'set2'), `videoScript_set2_${product.id}`); }} className="opacity-0 group-hover/prompt:opacity-100 p-0.5 rounded hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 hover:text-emerald-500 transition-all" title={T('ws.common.copy', 'Copy')}>
                                                                                    <span className="material-symbols-outlined text-[12px]">{copiedField === `videoScript_set2_${product.id}` ? 'check' : 'content_copy'}</span>
                                                                                </button>
                                                                                </div>
                                                                            </div>
                                                                            <textarea
                                                                                value={getEffectiveVideoScript(product.id, product.prompts, 'set2')}
                                                                                onChange={(e) => updateDraftPrompt(product.id, product.prompts, 'set2', 'videoScript', e.target.value)}
                                                                                readOnly onClick={() => setPromptModalProductId(product.id)}
                                                                                className="w-full h-12 bg-emerald-50 dark:bg-emerald-900/10 p-2 rounded-lg border border-emerald-200 dark:border-emerald-800/40 text-[11px] leading-relaxed text-slate-700 dark:text-slate-300 resize-none cursor-pointer hover:border-emerald-400/60 hover:bg-emerald-100/60 dark:hover:bg-emerald-900/20 transition-colors"
                                                                                placeholder={T('ws.prompt.voiceoverPlaceholder', 'Voiceover script — auto-sync ke Video Prompt')}
                                                                            />
                                                                        </div>
                                                                        {/* Video Prompt (single-scene) */}
                                                                        <div className="group/prompt">
                                                                            <div className="flex justify-between items-center mb-1">
                                                                                <label className="text-[11px] font-bold text-slate-400 uppercase flex items-center gap-1">
                                                                                    <span className="w-1 h-1 rounded-full bg-purple-500"></span> {spaces.find(s => s.id === selectedSpaceId)?.settings?.labels?.videoPrompt || 'Video Prompt'}
                                                                                </label>
                                                                                <div className="flex items-center gap-0.5">
                                                                                <button onClick={(e) => { e.stopPropagation(); setPromptModalProductId(product.id); }} className="opacity-0 group-hover/prompt:opacity-100 p-0.5 rounded hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 hover:text-primary transition-all" title={T('ws.prompt.editAllFullscreen', 'Edit semua prompt (fullscreen)')}>
                                                                                    <span className="material-symbols-outlined text-[12px]">open_in_full</span>
                                                                                </button>
                                                                                <button onClick={(e) => { e.stopPropagation(); copyWithTag('VIDEO', 'set2', null, product.prompts?.set2?.promptVideo || '', `promptVideo_set2_${product.id}`); }} className="opacity-0 group-hover/prompt:opacity-100 p-0.5 rounded hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 hover:text-primary transition-all" title={T('ws.common.copy', 'Copy')}>
                                                                                    <span className="material-symbols-outlined text-[12px]">{copiedField === `promptVideo_set2_${product.id}` ? 'check' : 'content_copy'}</span>
                                                                                </button>
                                                                                </div>
                                                                            </div>
                                                                            <textarea
                                                                                value={(draftPromptMap[product.id] ?? product.prompts)?.set2?.promptVideo || ''}
                                                                                onChange={(e) => updateDraftPrompt(product.id, product.prompts, 'set2', 'promptVideo', e.target.value)}
                                                                                readOnly onClick={() => setPromptModalProductId(product.id)} className="w-full h-16 bg-slate-50 dark:bg-slate-800/40 p-2 rounded-lg border border-slate-100 dark:border-slate-800 text-[11px] leading-relaxed text-slate-600 dark:text-slate-400 resize-none focus:ring-primary focus:border-primary cursor-pointer hover:border-primary/40 hover:bg-white dark:hover:bg-slate-800/60 transition-colors"
                                                                                placeholder={T('ws.prompt.empty', 'Empty')}
                                                                            />
                                                                        </div>
                                                                    </>
                                                                )}
                                                                {!product.hideCaption && spaces.find(s => s.id === selectedSpaceId)?.settings?.showTikTokCaption !== false && (() => {
                                                                    /* ★ [2026-09-27] Suis TikTok/FB — sama seperti Set 1 (SuisCaptionKad.jsx). */
                                                                    const capFb = capTabFb.has(product.id);
                                                                    const cap = captionKad((draftPromptMap[product.id] ?? product.prompts)?.set2, capFb);
                                                                    return (
                                                                    <div className="group/prompt">
                                                                        <div className="flex justify-between items-center mb-1">
                                                                            <label className="text-[11px] font-bold text-slate-400 uppercase flex items-center gap-1">
                                                                                <span className={`w-1 h-1 rounded-full ${capFb ? 'bg-sky-500' : 'bg-rose-500'}`}></span> {labelCaptionKad(spaces.find(s => s.id === selectedSpaceId)?.settings?.labels?.captionTiktok, capFb, T)}
                                                                            </label>
                                                                            <div className="flex items-center gap-0.5">
                                                                            <SuisCaptionKad fb={capFb} onTukar={(v) => tukarCapKad(product.id, v)} T={T} />
                                                                            <button onClick={(e) => { e.stopPropagation(); setPromptModalProductId(product.id); }} className="opacity-0 group-hover/prompt:opacity-100 p-0.5 rounded hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 hover:text-primary transition-all" title={T('ws.prompt.editAllFullscreen', 'Edit semua prompt (fullscreen)')}>
                                                                                <span className="material-symbols-outlined text-[12px]">open_in_full</span>
                                                                            </button>
                                                                            <button onClick={(e) => { e.stopPropagation(); copyToClipboard(captionKad(product.prompts?.set2, capFb).teks, `captionTiktok_set2_${product.id}`); }} className="opacity-0 group-hover/prompt:opacity-100 p-0.5 rounded hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 hover:text-primary transition-all" title={T('ws.common.copy', 'Copy')}>
                                                                                <span className="material-symbols-outlined text-[12px]">{copiedField === `captionTiktok_set2_${product.id}` ? 'check' : 'content_copy'}</span>
                                                                            </button>
                                                                            </div>
                                                                        </div>
                                                                        <textarea
                                                                            value={cap.teks}
                                                                            onChange={capFb ? undefined : (e) => updateDraftPrompt(product.id, product.prompts, 'set2', 'captionTiktok', e.target.value)}
                                                                            readOnly onClick={() => setPromptModalProductId(product.id)} className="w-full h-16 bg-slate-50 dark:bg-slate-800/40 p-2 rounded-lg border border-slate-100 dark:border-slate-800 text-[11px] leading-relaxed text-slate-600 dark:text-slate-400 resize-none focus:ring-primary focus:border-primary cursor-pointer hover:border-primary/40 hover:bg-white dark:hover:bg-slate-800/60 transition-colors"
                                                                            placeholder={cap.kosongSengaja ? T('ws.caption.fbKosongSengaja', 'Kosong — Facebook akan post tanpa caption') : T('ws.prompt.empty', 'Empty')}
                                                                        />
                                                                    </div>
                                                                    );
                                                                })()}
                                                            </div>
                                                        </div>
                                                    )}
                                                    {/* Set 3 */}
                                                    {spaces.find(s => s.id === selectedSpaceId)?.settings?.showSet3 !== false && (
                                                        <div className="p-4 bg-white/20 dark:bg-slate-900/40">
                                                            <div className="mb-3">
                                                                <h4 className="text-[10px] font-extrabold text-slate-500 dark:text-slate-400 uppercase tracking-[0.1em] px-2 py-0.5 bg-white/50 dark:bg-slate-800 rounded-md inline-block">{spaces.find(s => s.id === selectedSpaceId)?.settings?.labels?.set3 || 'Set 3'}</h4>
                                                            </div>
                                                            <div className="space-y-2">
                                                                <div>
                                                                    <label className="text-[11px] font-bold text-emerald-400 uppercase flex items-center gap-1 mb-1">
                                                                        <span className="w-1 h-1 rounded-full bg-emerald-500"></span> Video
                                                                    </label>
                                                                    {product.prompts?.set3?.uploadedVideo ? (
                                                                        <div className={`group/video transition-all duration-200 ${deletingState.productId === product.id && deletingState.setKey === 'set3' && deletingState.fadingOut ? 'opacity-0 scale-95 pointer-events-none' : 'opacity-100 scale-100'}`}>
                                                                            <div className="relative rounded-lg overflow-hidden bg-black aspect-[9/16]">
                                                                                <VideoThumbPreview product={product} setKey="set3" onPlayLocalVideo={handlePlayLocalVideo} onPlayCloudVideo={handlePlayCloudVideo} t={tAnak} pushingKeys={cloudPushingKeys} />
                                                                            </div>
                                                                            <div className="flex gap-1.5 mt-1.5 opacity-0 group-hover/video:opacity-100 transition-all duration-200">
                                                                                <button
                                                                                    onClick={() => { const a = document.createElement('a'); a.href = product.prompts.set3.uploadedVideo; a.download = `${product.name || 'video'}_set3.mp4`; a.target = '_blank'; a.click(); }}
                                                                                    className="flex-1 flex items-center justify-center gap-1 px-2 py-1 rounded-md bg-slate-100 dark:bg-slate-800 hover:bg-blue-50 dark:hover:bg-blue-900/30 text-slate-500 hover:text-blue-600 text-[10px] font-bold transition-all"
                                                                                >
                                                                                    <span className="material-symbols-outlined text-[13px]">download</span> {T('ws.video.download', 'Download')}
                                                                                </button>
                                                                                <button
                                                                                    onClick={() => requestDeleteVideo(product, 'set3')}
                                                                                    disabled={deletingState.productId === product.id && deletingState.setKey === 'set3'}
                                                                                    className="flex-1 flex items-center justify-center gap-1 px-2 py-1 rounded-md bg-slate-100 dark:bg-slate-800 hover:bg-red-50 dark:hover:bg-red-900/30 text-slate-500 hover:text-red-500 text-[10px] font-bold transition-all disabled:opacity-50 disabled:cursor-not-allowed"
                                                                                >
                                                                                    {deletingState.productId === product.id && deletingState.setKey === 'set3' ? (
                                                                                        <><span className="material-symbols-outlined animate-spin text-[13px]">progress_activity</span> {T('ws.video.deleting', 'Deleting…')}</>
                                                                                    ) : (
                                                                                        <><span className="material-symbols-outlined text-[13px]">delete</span> {T('ws.video.delete', 'Delete')}</>
                                                                                    )}
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    ) : (
                                                                        <div
                                                                            onClick={() => {
                                                                                if (isUploadBlockedProduct(product)) { showUploadBlockedAlert(product); return; }
                                                                                setUploadingState({ productId: product.id, setKey: 'set3', isUploading: false });
                                                                                videoInputRef.current?.click();
                                                                            }}
                                                                            className="aspect-[9/16] bg-slate-50 dark:bg-slate-800/40 rounded-lg border border-dashed border-slate-200 dark:border-slate-700 flex flex-col items-center justify-center text-[10px] text-slate-400 gap-1 cursor-pointer hover:bg-slate-100 dark:hover:bg-slate-800 transition-all group"
                                                                        >
                                                                            {uploadingState.productId === product.id && uploadingState.setKey === 'set3' && uploadingState.isUploading ? (
                                                                                <span className="material-symbols-outlined animate-spin text-primary">sync</span>
                                                                            ) : (
                                                                                <>
                                                                                    <span className="material-symbols-outlined text-[22px] text-slate-300 group-hover:text-primary transition-colors">cloud_upload</span>
                                                                                    <span className="font-bold group-hover:text-primary transition-colors uppercase tracking-wider text-[9px]">{T('ws.video.uploadVideo', 'Upload Video')}</span>
                                                                                </>
                                                                            )}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                                {/* Hook Text — separate field for all modules. Bidirectional sync dengan promptImage. */}
                                                                <div className="group/prompt">
                                                                    <div className="flex justify-between items-center mb-1">
                                                                        <label className="text-[11px] font-bold text-slate-400 uppercase flex items-center gap-1">
                                                                            <span className="w-1 h-1 rounded-full bg-amber-500"></span> Hook Text
                                                                        </label>
                                                                        <div className="flex items-center gap-0.5">
                                                                        <button onClick={(e) => { e.stopPropagation(); setPromptModalProductId(product.id); }} className="opacity-0 group-hover/prompt:opacity-100 p-0.5 rounded hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 hover:text-amber-500 transition-all" title={T('ws.prompt.editAllFullscreen', 'Edit semua prompt (fullscreen)')}>
                                                                            <span className="material-symbols-outlined text-[12px]">open_in_full</span>
                                                                        </button>
                                                                        <button onClick={(e) => { e.stopPropagation(); copyToClipboard(getEffectiveHookText(product.id, product.prompts, 'set3'), `hookText_set3_${product.id}`); }} className="opacity-0 group-hover/prompt:opacity-100 p-0.5 rounded hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 hover:text-amber-500 transition-all" title={T('ws.common.copy', 'Copy')}>
                                                                            <span className="material-symbols-outlined text-[12px]">{copiedField === `hookText_set3_${product.id}` ? 'check' : 'content_copy'}</span>
                                                                        </button>
                                                                        </div>
                                                                    </div>
                                                                    <div className="relative">
                                                                        <textarea
                                                                            value={getEffectiveHookText(product.id, product.prompts, 'set3')}
                                                                            onChange={(e) => updateDraftPrompt(product.id, product.prompts, 'set3', 'hookText', e.target.value)}
                                                                            readOnly onClick={() => setPromptModalProductId(product.id)}
                                                                            className="w-full h-10 bg-amber-50 dark:bg-amber-900/10 p-2 rounded-lg border border-amber-200 dark:border-amber-800/40 text-[11px] leading-relaxed text-slate-700 dark:text-slate-300 resize-none cursor-pointer hover:border-amber-400/60 hover:bg-amber-100/60 dark:hover:bg-amber-900/20 transition-colors"
                                                                            placeholder={T('ws.prompt.hookPlaceholder', 'Hook ayat — edit di sini auto-sync ke Image Prompt')}
                                                                        />
                                                                        <TemplateBadge label={getTemplateBadgeLabel(product, 'set3', 'hook')} color="amber" />
                                                                    </div>
                                                                    {hookSyncWarnings[`${product.id}_set3`] && (
                                                                        <div className="text-[9px] text-amber-600 dark:text-amber-400 mt-1 px-1 leading-snug font-semibold">
                                                                            {hookSyncWarnings[`${product.id}_set3`]}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                                <div className="group/prompt" style={resipiTanpaGambar(product) ? { display: 'none' } : undefined}>
                                                                    <div className="flex justify-between items-center mb-1">
                                                                        <label className="text-[11px] font-bold text-slate-400 uppercase flex items-center gap-1">
                                                                            <span className="w-1 h-1 rounded-full bg-blue-500"></span> {spaces.find(s => s.id === selectedSpaceId)?.settings?.labels?.imagePrompt || 'Image Prompt'}
                                                                        </label>
                                                                        <div className="flex items-center gap-0.5">
                                                                        <button onClick={(e) => { e.stopPropagation(); setPromptModalProductId(product.id); }} className="opacity-0 group-hover/prompt:opacity-100 p-0.5 rounded hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 hover:text-primary transition-all" title={T('ws.prompt.editAllFullscreen', 'Edit semua prompt (fullscreen)')}>
                                                                            <span className="material-symbols-outlined text-[12px]">open_in_full</span>
                                                                        </button>
                                                                        <button onClick={(e) => { e.stopPropagation(); copyWithTag('IMAGE', 'set3', null, product.prompts?.set3?.promptImage || '', `promptImage_set3_${product.id}`); }} className="opacity-0 group-hover/prompt:opacity-100 p-0.5 rounded hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 hover:text-primary transition-all" title={T('ws.common.copy', 'Copy')}>
                                                                            <span className="material-symbols-outlined text-[12px]">{copiedField === `promptImage_set3_${product.id}` ? 'check' : 'content_copy'}</span>
                                                                        </button>
                                                                        </div>
                                                                    </div>
                                                                    <div className="relative">
                                                                        <textarea
                                                                            value={(draftPromptMap[product.id] ?? product.prompts)?.set3?.promptImage || ''}
                                                                            onChange={(e) => updateDraftPrompt(product.id, product.prompts, 'set3', 'promptImage', e.target.value)}
                                                                            readOnly onClick={() => setPromptModalProductId(product.id)} className="w-full h-16 bg-slate-50 dark:bg-slate-800/40 p-2 rounded-lg border border-slate-100 dark:border-slate-800 text-[11px] leading-relaxed text-slate-600 dark:text-slate-400 resize-none focus:ring-primary focus:border-primary cursor-pointer hover:border-primary/40 hover:bg-white dark:hover:bg-slate-800/60 transition-colors"
                                                                            placeholder={T('ws.prompt.empty', 'Empty')}
                                                                        />
                                                                        <TemplateBadge label={getTemplateBadgeLabel(product, 'set3', 'bg')} color="blue" />
                                                                    </div>
                                                                </div>
                                                                {/* ★ RESIPI gambar berlainan, 2 scene: Image Prompt scene 2 */}
                                                                {((kadDuaBabak(product) && resipiBerlainan(product)) || resipiFrame(product)) && (
                                                                    <KotakGambarBabak tajuk={resipiFrame(product) ? T('ws.resipi.imageEnd', 'Image Prompt · After (End frame)') : undefined} set={(draftPromptMap[product.id] ?? product.prompts)?.set3} babak={2} onBuka={() => setPromptModalProductId(product.id)} onSalin={(jenis, n, teks, kunci) => copyWithTag(jenis, 'set3', n, teks, kunci)} salinan={copiedField} kunci={`rimg2_set3_${product.id}`} T={T} />
                                                                )}
                                                                {/* Video Script + Video Prompt Set 3 — AI16SAAT/Home Niche: 2-scene; others: 1-scene. Video Script muncul dulu. */}
                                                                {kadDuaBabak(product) ? (
                                                                    <>
                                                                        {/* Video Script (Scene 1) */}
                                                                        <div className="group/prompt">
                                                                            <div className="flex justify-between items-center mb-1">
                                                                                <label className="text-[11px] font-bold text-slate-400 uppercase flex items-center gap-1">
                                                                                    <span className="w-1 h-1 rounded-full bg-emerald-500"></span> Video Script (Scene 1)
                                                                                </label>
                                                                                <div className="flex items-center gap-0.5">
                                                                                <button onClick={(e) => { e.stopPropagation(); setPromptModalProductId(product.id); }} className="opacity-0 group-hover/prompt:opacity-100 p-0.5 rounded hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 hover:text-emerald-500 transition-all" title={T('ws.prompt.editAllFullscreen', 'Edit semua prompt (fullscreen)')}>
                                                                                    <span className="material-symbols-outlined text-[12px]">open_in_full</span>
                                                                                </button>
                                                                                <button onClick={(e) => { e.stopPropagation(); copyToClipboard(getEffectiveVideoScript(product.id, product.prompts, 'set3', '1'), `videoScript1_set3_${product.id}`); }} className="opacity-0 group-hover/prompt:opacity-100 p-0.5 rounded hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 hover:text-emerald-500 transition-all" title={T('ws.common.copy', 'Copy')}>
                                                                                    <span className="material-symbols-outlined text-[12px]">{copiedField === `videoScript1_set3_${product.id}` ? 'check' : 'content_copy'}</span>
                                                                                </button>
                                                                                </div>
                                                                            </div>
                                                                            <textarea
                                                                                value={getEffectiveVideoScript(product.id, product.prompts, 'set3', '1')}
                                                                                onChange={(e) => updateDraftPrompt(product.id, product.prompts, 'set3', 'videoScript1', e.target.value)}
                                                                                readOnly onClick={() => setPromptModalProductId(product.id)}
                                                                                className="w-full h-12 bg-emerald-50 dark:bg-emerald-900/10 p-2 rounded-lg border border-emerald-200 dark:border-emerald-800/40 text-[11px] leading-relaxed text-slate-700 dark:text-slate-300 resize-none cursor-pointer hover:border-emerald-400/60 hover:bg-emerald-100/60 dark:hover:bg-emerald-900/20 transition-colors"
                                                                                placeholder={T('ws.prompt.voiceoverScene1Placeholder', 'Voiceover Scene 1 — auto-sync ke Video Prompt (Scene 1)')}
                                                                            />
                                                                        </div>
                                                                        {/* Video Prompt (Scene 1) */}
                                                                        <div className="group/prompt">
                                                                            <div className="flex justify-between items-center mb-1">
                                                                                <label className="text-[11px] font-bold text-slate-400 uppercase flex items-center gap-1">
                                                                                    <span className="w-1 h-1 rounded-full bg-purple-500"></span> Video Prompt (Scene 1)
                                                                                </label>
                                                                                <div className="flex items-center gap-0.5">
                                                                                <button onClick={(e) => { e.stopPropagation(); setPromptModalProductId(product.id); }} className="opacity-0 group-hover/prompt:opacity-100 p-0.5 rounded hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 hover:text-primary transition-all" title={T('ws.prompt.editAllFullscreen', 'Edit semua prompt (fullscreen)')}>
                                                                                    <span className="material-symbols-outlined text-[12px]">open_in_full</span>
                                                                                </button>
                                                                                <button onClick={(e) => { e.stopPropagation(); copyWithTag('VIDEO', 'set3', 1, product.prompts?.set3?.promptVideo1 || product.prompts?.set3?.promptVideo || '', `promptVideo1_set3_${product.id}`); }} className="opacity-0 group-hover/prompt:opacity-100 p-0.5 rounded hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 hover:text-primary transition-all" title={T('ws.common.copy', 'Copy')}>
                                                                                    <span className="material-symbols-outlined text-[12px]">{copiedField === `promptVideo1_set3_${product.id}` ? 'check' : 'content_copy'}</span>
                                                                                </button>
                                                                                </div>
                                                                            </div>
                                                                            <textarea
                                                                                value={(draftPromptMap[product.id] ?? product.prompts)?.set3?.promptVideo1 || (draftPromptMap[product.id] ?? product.prompts)?.set3?.promptVideo || ''}
                                                                                onChange={(e) => updateDraftPrompt(product.id, product.prompts, 'set3', 'promptVideo1', e.target.value)}
                                                                                readOnly onClick={() => setPromptModalProductId(product.id)} className="w-full h-16 bg-slate-50 dark:bg-slate-800/40 p-2 rounded-lg border border-slate-100 dark:border-slate-800 text-[11px] leading-relaxed text-slate-600 dark:text-slate-400 resize-none focus:ring-primary focus:border-primary cursor-pointer hover:border-primary/40 hover:bg-white dark:hover:bg-slate-800/60 transition-colors"
                                                                                placeholder={T('ws.prompt.empty', 'Empty')}
                                                                            />
                                                                        </div>
                                                                        {/* Video Script (Scene 2) */}
                                                                        <div className="group/prompt">
                                                                            <div className="flex justify-between items-center mb-1">
                                                                                <label className="text-[11px] font-bold text-slate-400 uppercase flex items-center gap-1">
                                                                                    <span className="w-1 h-1 rounded-full bg-teal-500"></span> Video Script (Scene 2)
                                                                                </label>
                                                                                <div className="flex items-center gap-0.5">
                                                                                <button onClick={(e) => { e.stopPropagation(); setPromptModalProductId(product.id); }} className="opacity-0 group-hover/prompt:opacity-100 p-0.5 rounded hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 hover:text-teal-500 transition-all" title={T('ws.prompt.editAllFullscreen', 'Edit semua prompt (fullscreen)')}>
                                                                                    <span className="material-symbols-outlined text-[12px]">open_in_full</span>
                                                                                </button>
                                                                                <button onClick={(e) => { e.stopPropagation(); copyToClipboard(getEffectiveVideoScript(product.id, product.prompts, 'set3', '2'), `videoScript2_set3_${product.id}`); }} className="opacity-0 group-hover/prompt:opacity-100 p-0.5 rounded hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 hover:text-teal-500 transition-all" title={T('ws.common.copy', 'Copy')}>
                                                                                    <span className="material-symbols-outlined text-[12px]">{copiedField === `videoScript2_set3_${product.id}` ? 'check' : 'content_copy'}</span>
                                                                                </button>
                                                                                </div>
                                                                            </div>
                                                                            <textarea
                                                                                value={getEffectiveVideoScript(product.id, product.prompts, 'set3', '2')}
                                                                                onChange={(e) => updateDraftPrompt(product.id, product.prompts, 'set3', 'videoScript2', e.target.value)}
                                                                                readOnly onClick={() => setPromptModalProductId(product.id)}
                                                                                className="w-full h-12 bg-teal-50 dark:bg-teal-900/10 p-2 rounded-lg border border-teal-200 dark:border-teal-800/40 text-[11px] leading-relaxed text-slate-700 dark:text-slate-300 resize-none cursor-pointer hover:border-teal-400/60 hover:bg-teal-100/60 dark:hover:bg-teal-900/20 transition-colors"
                                                                                placeholder={T('ws.prompt.voiceoverScene2Placeholder', 'Voiceover Scene 2 — auto-sync ke Video Prompt (Scene 2)')}
                                                                            />
                                                                        </div>
                                                                        {/* Video Prompt (Scene 2) */}
                                                                        <div className="group/prompt">
                                                                            <div className="flex justify-between items-center mb-1">
                                                                                <label className="text-[11px] font-bold text-slate-400 uppercase flex items-center gap-1">
                                                                                    <span className="w-1 h-1 rounded-full bg-violet-500"></span> Video Prompt (Scene 2)
                                                                                </label>
                                                                                <div className="flex items-center gap-0.5">
                                                                                <button onClick={(e) => { e.stopPropagation(); setPromptModalProductId(product.id); }} className="opacity-0 group-hover/prompt:opacity-100 p-0.5 rounded hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 hover:text-primary transition-all" title={T('ws.prompt.editAllFullscreen', 'Edit semua prompt (fullscreen)')}>
                                                                                    <span className="material-symbols-outlined text-[12px]">open_in_full</span>
                                                                                </button>
                                                                                <button onClick={(e) => { e.stopPropagation(); copyWithTag('VIDEO', 'set3', 2, product.prompts?.set3?.promptVideo2 || '', `promptVideo2_set3_${product.id}`); }} className="opacity-0 group-hover/prompt:opacity-100 p-0.5 rounded hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 hover:text-primary transition-all" title={T('ws.common.copy', 'Copy')}>
                                                                                    <span className="material-symbols-outlined text-[12px]">{copiedField === `promptVideo2_set3_${product.id}` ? 'check' : 'content_copy'}</span>
                                                                                </button>
                                                                                </div>
                                                                            </div>
                                                                            <textarea
                                                                                value={(draftPromptMap[product.id] ?? product.prompts)?.set3?.promptVideo2 || ''}
                                                                                onChange={(e) => updateDraftPrompt(product.id, product.prompts, 'set3', 'promptVideo2', e.target.value)}
                                                                                readOnly onClick={() => setPromptModalProductId(product.id)} className="w-full h-16 bg-slate-50 dark:bg-slate-800/40 p-2 rounded-lg border border-slate-100 dark:border-slate-800 text-[11px] leading-relaxed text-slate-600 dark:text-slate-400 resize-none focus:ring-primary focus:border-primary cursor-pointer hover:border-primary/40 hover:bg-white dark:hover:bg-slate-800/60 transition-colors"
                                                                                placeholder={T('ws.prompt.empty', 'Empty')}
                                                                            />
                                                                        </div>
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        {/* Video Script (single-scene) */}
                                                                        <div className="group/prompt">
                                                                            <div className="flex justify-between items-center mb-1">
                                                                                <label className="text-[11px] font-bold text-slate-400 uppercase flex items-center gap-1">
                                                                                    <span className="w-1 h-1 rounded-full bg-emerald-500"></span> Video Script
                                                                                </label>
                                                                                <div className="flex items-center gap-0.5">
                                                                                <button onClick={(e) => { e.stopPropagation(); setPromptModalProductId(product.id); }} className="opacity-0 group-hover/prompt:opacity-100 p-0.5 rounded hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 hover:text-emerald-500 transition-all" title={T('ws.prompt.editAllFullscreen', 'Edit semua prompt (fullscreen)')}>
                                                                                    <span className="material-symbols-outlined text-[12px]">open_in_full</span>
                                                                                </button>
                                                                                <button onClick={(e) => { e.stopPropagation(); copyToClipboard(getEffectiveVideoScript(product.id, product.prompts, 'set3'), `videoScript_set3_${product.id}`); }} className="opacity-0 group-hover/prompt:opacity-100 p-0.5 rounded hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 hover:text-emerald-500 transition-all" title={T('ws.common.copy', 'Copy')}>
                                                                                    <span className="material-symbols-outlined text-[12px]">{copiedField === `videoScript_set3_${product.id}` ? 'check' : 'content_copy'}</span>
                                                                                </button>
                                                                                </div>
                                                                            </div>
                                                                            <textarea
                                                                                value={getEffectiveVideoScript(product.id, product.prompts, 'set3')}
                                                                                onChange={(e) => updateDraftPrompt(product.id, product.prompts, 'set3', 'videoScript', e.target.value)}
                                                                                readOnly onClick={() => setPromptModalProductId(product.id)}
                                                                                className="w-full h-12 bg-emerald-50 dark:bg-emerald-900/10 p-2 rounded-lg border border-emerald-200 dark:border-emerald-800/40 text-[11px] leading-relaxed text-slate-700 dark:text-slate-300 resize-none cursor-pointer hover:border-emerald-400/60 hover:bg-emerald-100/60 dark:hover:bg-emerald-900/20 transition-colors"
                                                                                placeholder={T('ws.prompt.voiceoverPlaceholder', 'Voiceover script — auto-sync ke Video Prompt')}
                                                                            />
                                                                        </div>
                                                                        {/* Video Prompt (single-scene) */}
                                                                        <div className="group/prompt">
                                                                            <div className="flex justify-between items-center mb-1">
                                                                                <label className="text-[11px] font-bold text-slate-400 uppercase flex items-center gap-1">
                                                                                    <span className="w-1 h-1 rounded-full bg-purple-500"></span> {spaces.find(s => s.id === selectedSpaceId)?.settings?.labels?.videoPrompt || 'Video Prompt'}
                                                                                </label>
                                                                                <div className="flex items-center gap-0.5">
                                                                                <button onClick={(e) => { e.stopPropagation(); setPromptModalProductId(product.id); }} className="opacity-0 group-hover/prompt:opacity-100 p-0.5 rounded hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 hover:text-primary transition-all" title={T('ws.prompt.editAllFullscreen', 'Edit semua prompt (fullscreen)')}>
                                                                                    <span className="material-symbols-outlined text-[12px]">open_in_full</span>
                                                                                </button>
                                                                                <button onClick={(e) => { e.stopPropagation(); copyWithTag('VIDEO', 'set3', null, product.prompts?.set3?.promptVideo || '', `promptVideo_set3_${product.id}`); }} className="opacity-0 group-hover/prompt:opacity-100 p-0.5 rounded hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 hover:text-primary transition-all" title={T('ws.common.copy', 'Copy')}>
                                                                                    <span className="material-symbols-outlined text-[12px]">{copiedField === `promptVideo_set3_${product.id}` ? 'check' : 'content_copy'}</span>
                                                                                </button>
                                                                                </div>
                                                                            </div>
                                                                            <textarea
                                                                                value={(draftPromptMap[product.id] ?? product.prompts)?.set3?.promptVideo || ''}
                                                                                onChange={(e) => updateDraftPrompt(product.id, product.prompts, 'set3', 'promptVideo', e.target.value)}
                                                                                readOnly onClick={() => setPromptModalProductId(product.id)} className="w-full h-16 bg-slate-50 dark:bg-slate-800/40 p-2 rounded-lg border border-slate-100 dark:border-slate-800 text-[11px] leading-relaxed text-slate-600 dark:text-slate-400 resize-none focus:ring-primary focus:border-primary cursor-pointer hover:border-primary/40 hover:bg-white dark:hover:bg-slate-800/60 transition-colors"
                                                                                placeholder={T('ws.prompt.empty', 'Empty')}
                                                                            />
                                                                        </div>
                                                                    </>
                                                                )}
                                                                {!product.hideCaption && spaces.find(s => s.id === selectedSpaceId)?.settings?.showTikTokCaption !== false && (() => {
                                                                    /* ★ [2026-09-27] Suis TikTok/FB — sama seperti Set 1 (SuisCaptionKad.jsx). */
                                                                    const capFb = capTabFb.has(product.id);
                                                                    const cap = captionKad((draftPromptMap[product.id] ?? product.prompts)?.set3, capFb);
                                                                    return (
                                                                    <div className="group/prompt">
                                                                        <div className="flex justify-between items-center mb-1">
                                                                            <label className="text-[11px] font-bold text-slate-400 uppercase flex items-center gap-1">
                                                                                <span className={`w-1 h-1 rounded-full ${capFb ? 'bg-sky-500' : 'bg-rose-500'}`}></span> {labelCaptionKad(spaces.find(s => s.id === selectedSpaceId)?.settings?.labels?.captionTiktok, capFb, T)}
                                                                            </label>
                                                                            <div className="flex items-center gap-0.5">
                                                                            <SuisCaptionKad fb={capFb} onTukar={(v) => tukarCapKad(product.id, v)} T={T} />
                                                                            <button onClick={(e) => { e.stopPropagation(); setPromptModalProductId(product.id); }} className="opacity-0 group-hover/prompt:opacity-100 p-0.5 rounded hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 hover:text-primary transition-all" title={T('ws.prompt.editAllFullscreen', 'Edit semua prompt (fullscreen)')}>
                                                                                <span className="material-symbols-outlined text-[12px]">open_in_full</span>
                                                                            </button>
                                                                            <button onClick={(e) => { e.stopPropagation(); copyToClipboard(captionKad(product.prompts?.set3, capFb).teks, `captionTiktok_set3_${product.id}`); }} className="opacity-0 group-hover/prompt:opacity-100 p-0.5 rounded hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 hover:text-primary transition-all" title={T('ws.common.copy', 'Copy')}>
                                                                                <span className="material-symbols-outlined text-[12px]">{copiedField === `captionTiktok_set3_${product.id}` ? 'check' : 'content_copy'}</span>
                                                                            </button>
                                                                            </div>
                                                                        </div>
                                                                        <textarea
                                                                            value={cap.teks}
                                                                            onChange={capFb ? undefined : (e) => updateDraftPrompt(product.id, product.prompts, 'set3', 'captionTiktok', e.target.value)}
                                                                            readOnly onClick={() => setPromptModalProductId(product.id)} className="w-full h-16 bg-slate-50 dark:bg-slate-800/40 p-2 rounded-lg border border-slate-100 dark:border-slate-800 text-[11px] leading-relaxed text-slate-600 dark:text-slate-400 resize-none focus:ring-primary focus:border-primary cursor-pointer hover:border-primary/40 hover:bg-white dark:hover:bg-slate-800/60 transition-colors"
                                                                            placeholder={cap.kosongSengaja ? T('ws.caption.fbKosongSengaja', 'Kosong — Facebook akan post tanpa caption') : T('ws.prompt.empty', 'Empty')}
                                                                        />
                                                                    </div>
                                                                    );
                                                                })()}
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                                        </div>
                                                        ) /* end N-scene ternary else (3-column) */
                                                    )}
                                                </div>
                                                {/* â•â•â• ABSOLUTE ARROW BUTTON â•â•â• */}
                                                {/* ★ Anak panah BUKA disorok dalam tab Schedule (arahan user
                                                    2026-08-20) — kad tak boleh dibuka di sini; edit prompt di
                                                    tab Flow. */}
                                                {!schedMode && (
                                                <div
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        const newExpanded = !kadDibuka;
                                                        setExpandedCards(prev => ({ ...prev, [product.id]: newExpanded }));
                                                        // Sync expand/collapse to extension
                                                        window.postMessage({ type: 'SESAAT_CARD_EXPAND', productId: product.id, expanded: newExpanded }, '*');
                                                    }}
                                                    style={{
                                                        position: 'absolute',
                                                        top: !kadDibuka ? '50%' : '24px',
                                                        right: 16,
                                                        transform: !kadDibuka ? 'translateY(-50%)' : 'rotate(90deg)',
                                                        transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                                                        boxShadow: uiV39 ? 'none' : '0 1px 2px rgba(0,0,0,0.05)',
                                                        cursor: 'pointer',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        /* v3.9: bulatan 28px bergaris nipis — sama seperti butang buka
                                                           baris prototaip. Rupa lama kekal petak 32px berbayang. */
                                                        border: `1px solid ${uiV39 ? 'var(--s-line)' : '#f1f5f9'}`,
                                                        background: uiV39 ? 'transparent' : '#fff',
                                                        width: uiV39 ? 28 : 32, height: uiV39 ? 28 : 32,
                                                        borderRadius: uiV39 ? 999 : 8, zIndex: 10
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        if (uiV39) { e.currentTarget.style.background = 'var(--s-fill-hover)'; return; }
                                                        e.currentTarget.style.borderColor = '#3b82f6'; e.currentTarget.style.background = '#f0f9ff';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        if (uiV39) { e.currentTarget.style.background = 'transparent'; return; }
                                                        e.currentTarget.style.borderColor = '#f1f5f9'; e.currentTarget.style.background = '#fff';
                                                    }}
                                                    title={!kadDibuka ? T('ws.card.expand', 'Expand card') : T('ws.card.collapse', 'Collapse card')}
                                                >
                                                    <span className="material-symbols-outlined text-[16px]" style={{ color: uiV39 ? 'var(--s-ink-3)' : (!kadDibuka ? '#9ca3af' : '#3b82f6') }}>arrow_right</span>
                                                </div>
                                                )}
                                            </div>
                                        </div>
                                        </React.Fragment>
                                    );})}
                                    </div>
                                )}
                                </SchedGrid>
                                )}
                            </div>

                            {/* ★ Marquee Selection Box Overlay */}
                            {selectionBox && (
                                <div style={{
                                    position: 'absolute',
                                    left: Math.min(selectionBox.x1, selectionBox.x2),
                                    top: Math.min(selectionBox.y1, selectionBox.y2),
                                    width: Math.abs(selectionBox.x2 - selectionBox.x1),
                                    height: Math.abs(selectionBox.y2 - selectionBox.y1),
                                    background: 'rgba(37, 99, 235, 0.08)',
                                    border: '1.5px solid rgba(37, 99, 235, 0.4)',
                                    borderRadius: 4,
                                    pointerEvents: 'none',
                                    zIndex: 50,
                                }} />
                            )}
                        </div>

                    </div>

                </div>




                {/* ===== AUTOMATION PROGRESS OVERLAY ===== */}
                {
                    automationProgress.isActive && (
                        <div className="fixed inset-0 z-[9999] bg-black/60 backdrop-blur-sm flex items-center justify-center p-4 animate-fadeIn">
                            {automationProgress.status === 'disconnected' ? (
                                /* ★ DISCONNECTED STATE — Extension content script not responding to ping */
                                <div className="w-full max-w-md bg-white dark:bg-slate-900 rounded-2xl shadow-2xl border border-red-200 dark:border-red-900/50 shadow-red-500/10 overflow-hidden">
                                    {/* Header — red */}
                                    <div className="px-6 py-4 bg-gradient-to-r from-red-500 to-rose-600">
                                        <div className="flex items-center gap-3">
                                            <div className="w-10 h-10 bg-white/20 rounded-xl flex items-center justify-center backdrop-blur">
                                                <span className="material-symbols-outlined text-white text-xl">wifi_off</span>
                                            </div>
                                            <div>
                                                <h3 className="text-white font-bold text-sm">{T('ws.auto.disconnectedTitle', '🔴 Extension Terputus Sambungan')}</h3>
                                                <p className="text-white/80 text-[11px]">{T('ws.auto.disconnectedSub', 'Tab ini perlu di-refresh dulu')}</p>
                                            </div>
                                        </div>
                                    </div>
                                    {/* Body */}
                                    <div className="px-6 py-5 space-y-3">
                                        <p className="text-sm text-slate-700 dark:text-slate-200 leading-relaxed">
                                            {/* Penekanan <strong> kekal untuk rupa LAMA; kamus menyimpan ayat
                                                sebagai teks biasa, jadi rupa v3.9 memaparkannya tanpa penebalan. */}
                                            {uiV39
                                                ? t('ws.auto.disconnectedBody')
                                                : <>Extension tidak merespons. Selalu berlaku selepas extension update — <strong>bukan masalah produk anda</strong>.</>}
                                        </p>
                                        <p className="text-xs text-slate-500 dark:text-slate-400 leading-relaxed">
                                            {T('ws.auto.disconnectedHint', 'Klik butang di bawah untuk refresh tab ini. Selepas refresh, klik butang Run semula.')}
                                        </p>
                                    </div>
                                    {/* Footer */}
                                    <div className="px-6 py-4 border-t border-slate-100 dark:border-slate-800 flex justify-end gap-2">
                                        <button
                                            onClick={() => setAutomationProgress(prev => ({ ...prev, isActive: false }))}
                                            className="px-4 py-2 rounded-xl font-bold text-xs uppercase tracking-wide bg-slate-200 dark:bg-slate-700 hover:bg-slate-300 dark:hover:bg-slate-600 text-slate-700 dark:text-slate-200 transition-all"
                                        >
                                            {T('ws.auto.cancel', 'Batal')}
                                        </button>
                                        <button
                                            onClick={() => window.location.reload()}
                                            className="px-5 py-2 rounded-xl font-bold text-xs uppercase tracking-wide bg-red-500 hover:bg-red-600 text-white shadow-lg shadow-red-500/20 transition-all transform hover:scale-[1.02] active:scale-95"
                                        >
                                            <span className="flex items-center gap-1.5">
                                                <span className="material-symbols-outlined text-sm">refresh</span>
                                                {T('ws.auto.refreshNow', 'Refresh Tab Sekarang')}
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            ) : (
                            <div className={`w-full max-w-md bg-white dark:bg-slate-900 rounded-2xl shadow-2xl border overflow-hidden transition-all duration-500 ${automationProgress.type === 'flow'
                                ? 'border-indigo-200 dark:border-indigo-900/50 shadow-indigo-500/10'
                                : 'border-rose-200 dark:border-rose-900/50 shadow-rose-500/10'
                                }`}>
                                {/* Header */}
                                <div className={`px-6 py-4 ${automationProgress.type === 'flow'
                                    ? 'bg-gradient-to-r from-indigo-500 to-violet-600'
                                    : 'bg-gradient-to-r from-rose-500 to-pink-600'
                                    }`}>
                                    <div className="flex items-center gap-3">
                                        <div className="w-10 h-10 bg-white/20 rounded-xl flex items-center justify-center backdrop-blur">
                                            <span className="material-symbols-outlined text-white text-xl">
                                                {automationProgress.status === 'success' ? 'check_circle' : automationProgress.status === 'error' ? 'error' : automationProgress.type === 'flow' ? 'auto_awesome' : automationProgress.type === 'phone' ? 'smartphone' : 'videocam'}
                                            </span>
                                        </div>
                                        <div>
                                            <h3 className="text-white font-bold text-sm">{automationProgress.message}</h3>
                                            <p className="text-white/70 text-[11px] whitespace-pre-line">{automationProgress.details}</p>
                                        </div>
                                    </div>
                                </div>

                                {/* ★ Extension Status Badge — always visible so user knows connection state */}
                                {automationProgress.extensionStatus === 'connected' && (
                                    <div className="px-6 py-2 bg-emerald-50 dark:bg-emerald-950/30 border-b border-emerald-100 dark:border-emerald-900/50 flex items-center gap-2">
                                        <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse"></span>
                                        <span className="text-[11px] font-semibold text-emerald-700 dark:text-emerald-300">{T('ws.auto.extensionConnected', 'Extension Bersambung')}</span>
                                    </div>
                                )}

                                {/* Progress Steps */}
                                <div className="px-6 py-5 space-y-3">
                                    {automationProgress.steps.map((step, idx) => (
                                        <div key={idx} className={`flex items-center gap-3 transition-all duration-300 ${step.status === 'pending' ? 'opacity-40' : 'opacity-100'}`}>
                                            <div className={`w-7 h-7 rounded-full flex items-center justify-center flex-shrink-0 transition-all duration-500 ${step.status === 'done' ? (automationProgress.type === 'flow' ? 'bg-indigo-100 dark:bg-indigo-900/30' : 'bg-rose-100 dark:bg-rose-900/30') :
                                                step.status === 'running' ? (automationProgress.type === 'flow' ? 'bg-indigo-500 animate-pulse' : 'bg-rose-500 animate-pulse') :
                                                    step.status === 'error' ? 'bg-red-100 dark:bg-red-900/30' :
                                                        'bg-slate-100 dark:bg-slate-800'
                                                }`}>
                                                {step.status === 'done' && (
                                                    <span className={`material-symbols-outlined text-sm ${automationProgress.type === 'flow' ? 'text-indigo-600 dark:text-indigo-400' : 'text-rose-600 dark:text-rose-400'}`}>check</span>
                                                )}
                                                {step.status === 'running' && (
                                                    <span className="material-symbols-outlined text-sm text-white animate-spin">progress_activity</span>
                                                )}
                                                {step.status === 'error' && (
                                                    <span className="material-symbols-outlined text-sm text-red-500">close</span>
                                                )}
                                                {step.status === 'pending' && (
                                                    <span className="text-[10px] font-bold text-slate-400">{idx + 1}</span>
                                                )}
                                            </div>
                                            <span className={`text-xs font-medium transition-colors ${step.status === 'done' ? 'text-slate-700 dark:text-slate-200' :
                                                step.status === 'running' ? (automationProgress.type === 'flow' ? 'text-indigo-600 dark:text-indigo-400' : 'text-rose-600 dark:text-rose-400') :
                                                    step.status === 'error' ? 'text-red-500' :
                                                        'text-slate-400'
                                                }`}>{step.label}</span>
                                        </div>
                                    ))}
                                </div>

                                {/* Overall Progress Bar */}
                                <div className="px-6 pb-2">
                                    <div className="w-full h-1.5 bg-slate-100 dark:bg-slate-800 rounded-full overflow-hidden">
                                        <div
                                            className={`h-full rounded-full transition-all duration-700 ease-out ${automationProgress.status === 'error' ? 'bg-red-500' :
                                                automationProgress.type === 'flow'
                                                    ? 'bg-gradient-to-r from-indigo-500 to-violet-500'
                                                    : 'bg-gradient-to-r from-rose-500 to-pink-500'
                                                }`}
                                            style={{ width: `${automationProgress.totalSteps > 0 ? (automationProgress.steps.filter(s => s.status === 'done').length / automationProgress.totalSteps) * 100 : 0}%` }}
                                        ></div>
                                    </div>
                                </div>

                                {/* Footer */}
                                <div className="px-6 py-4 border-t border-slate-100 dark:border-slate-800 flex justify-end">
                                    {(automationProgress.status === 'success' || automationProgress.status === 'error') ? (
                                        <button
                                            onClick={() => setAutomationProgress(prev => ({ ...prev, isActive: false }))}
                                            className={`px-5 py-2 rounded-xl font-bold text-xs uppercase tracking-wide transition-all transform hover:scale-[1.02] active:scale-95 ${automationProgress.status === 'success'
                                                ? (automationProgress.type === 'flow'
                                                    ? 'bg-indigo-500 hover:bg-indigo-600 text-white shadow-lg shadow-indigo-500/20'
                                                    : 'bg-rose-500 hover:bg-rose-600 text-white shadow-lg shadow-rose-500/20')
                                                : 'bg-slate-200 dark:bg-slate-700 hover:bg-slate-300 dark:hover:bg-slate-600 text-slate-700 dark:text-slate-200'
                                                }`}
                                        >
                                            <span className="flex items-center gap-1.5">
                                                <span className="material-symbols-outlined text-sm">{automationProgress.status === 'success' ? 'done_all' : 'close'}</span>
                                                {T('ws.auto.close', 'Tutup')}
                                            </span>
                                        </button>
                                    ) : (
                                        <div className="flex items-center gap-2">
                                            <div className={`w-2 h-2 rounded-full animate-pulse ${automationProgress.type === 'flow' ? 'bg-indigo-500' : 'bg-rose-500'}`}></div>
                                            <span className="text-[11px] text-slate-400 font-medium">{T('ws.auto.processing', 'Sedang memproses...')}</span>
                                            {automationProgress.type === 'phone' && (
                                                <button
                                                    type="button"
                                                    onClick={() => { phoneStopRef.current = true; setAutomationProgress((prev) => ({ ...prev, message: 'Stopping after this card…' })); }}
                                                    className="ml-3 px-3 py-1.5 rounded-lg font-bold text-[11px] bg-slate-200 dark:bg-slate-700 text-slate-700 dark:text-slate-200"
                                                >
                                                    Stop after this card
                                                </button>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                            )}
                        </div>
                    )
                }
                {/* ===== TIADA RUANG GAMBAR — Run Agent Saya ditahan (2026-09-13) ===== */}
                {popupTiadaRuang && (
                    <PopupRuangGambarAgent senarai={kadTiadaRuang} onTutup={() => setPopupTiadaRuang(false)} T={T} />
                )}
                {/* ===== TIADA PROMPT — Run Flow ditahan (2026-09-18) ===== */}
                {popupPromptKosong && (
                    <PopupPromptKosongFlow senarai={kadPromptKosong} onTutup={() => setPopupPromptKosong(false)} T={T} />
                )}
                {/* ===== MODEL VIDEO TIADA — robot Flow menghentikan Run (2026-09-24) ===== */}
                {popupModelTiada && (
                    <PopupModelFlowTiada info={popupModelTiada} onTutup={tutupPopupModel} T={T} />
                )}
                {/* ===== MIXED-MODULE WARNING MODAL ===== */}
                {mixedModuleModal && (
                    <div className="fixed inset-0 z-[10000] bg-black/60 backdrop-blur-sm flex items-center justify-center p-4 animate-fadeIn">
                        <div className="w-full max-w-md bg-white dark:bg-slate-900 rounded-2xl shadow-2xl border border-amber-200 dark:border-amber-900/50 shadow-amber-500/10 overflow-hidden">
                            {/* Header */}
                            <div className="px-6 py-4 bg-gradient-to-r from-amber-500 to-orange-500 relative">
                                <button
                                    onClick={() => setMixedModuleModal(null)}
                                    className="absolute top-3 right-3 w-8 h-8 bg-white/20 hover:bg-white/30 text-white rounded-full flex items-center justify-center backdrop-blur transition-colors"
                                    aria-label={T('ws.common.close', 'Tutup')}
                                >
                                    <span className="material-symbols-outlined text-base">close</span>
                                </button>
                                <div className="flex items-center gap-3 pr-10">
                                    <div className="w-10 h-10 bg-white/20 rounded-xl flex items-center justify-center backdrop-blur">
                                        <span className="material-symbols-outlined text-white text-xl">warning</span>
                                    </div>
                                    <div>
                                        <h3 className="text-white font-bold text-sm">{T('ws.mixed.title', 'Tak Boleh Run Mixed Module')}</h3>
                                        <p className="text-white/80 text-[11px]">{T('ws.mixed.subtitle', 'Pilih satu module sahaja untuk Run Flow')}</p>
                                    </div>
                                </div>
                            </div>

                            {/* Body */}
                            <div className="px-6 py-5 space-y-3">
                                <p className="text-sm text-slate-600 dark:text-slate-300">
                                    {/* Penekanan <strong> kekal untuk rupa LAMA; kamus menyimpan ayat
                                        sebagai teks biasa, jadi rupa v3.9 memaparkannya tanpa penebalan. */}
                                    {uiV39
                                        ? t('ws.mixed.body', { n: mixedModuleModal.groups.length })
                                        : <>Awak pilih produk dari <strong>{mixedModuleModal.groups.length} module berlainan</strong>. Setiap module guna automation script berbeza, jadi tak boleh run serentak dalam satu batch. Sila pilih dari satu module sahaja, atau run secara berasingan.</>}
                                </p>
                                <div className="space-y-2">
                                    {mixedModuleModal.groups.map((g, i) => (
                                        <div key={i} className="px-3 py-2 bg-slate-50 dark:bg-slate-800/50 rounded-lg border border-slate-200 dark:border-slate-700">
                                            <div className="flex items-center justify-between">
                                                <span className="text-xs font-semibold text-slate-700 dark:text-slate-200">{g.marketingName}</span>
                                                <span className="text-[10px] font-bold text-amber-600 dark:text-amber-400 bg-amber-50 dark:bg-amber-900/30 px-2 py-0.5 rounded-full">
                                                    {T('ws.mixed.productCount', `${g.count} produk`, { n: g.count })}
                                                </span>
                                            </div>
                                            {g.productNames.length > 0 && (
                                                <div className="mt-1 text-[11px] text-slate-500 dark:text-slate-400 truncate">
                                                    {g.productNames.join(', ')}{g.hasMore ? ', ...' : ''}
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* Footer */}
                            <div className="px-6 py-4 border-t border-slate-100 dark:border-slate-800 flex justify-end">
                                <button
                                    onClick={() => setMixedModuleModal(null)}
                                    className="px-5 py-2 rounded-xl font-bold text-xs uppercase tracking-wide bg-amber-500 hover:bg-amber-600 text-white shadow-lg shadow-amber-500/20 transition-all transform hover:scale-[1.02] active:scale-95"
                                >
                                    <span className="flex items-center gap-1.5">
                                        <span className="material-symbols-outlined text-sm">check_circle</span>
                                        {T('ws.mixed.understood', 'Faham')}
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {/* ===== GATE VERSI EXTENSION (v3.8.2) MODAL ===== */}
                {versionGateModal && (() => {
                    // Dua mod: 'duplicate' = amaran extension berganda (boleh ditutup);
                    // selainnya = gate versi (paksa kemas kini).
                    const isDupWarn = versionGateModal.mode === 'duplicate';
                    const dupCount = versionGateModal.count || 2;

                    /* ★ v3.9.2 — MOD SUIS "ALLOW USER SCRIPTS".
                       Pelanggan sudah pada versi terkini; yang tinggal ialah satu suis
                       BROWSER yang extension tidak boleh hidupkan sendiri (Chrome sengaja
                       menjadikannya keputusan pengguna).
                       ⛔ Butang di bawah membuat SEMAKAN SEBENAR melalui extension, bukan
                          kotak tanda "saya sudah buat" — pelanggan yang tersilap perlu
                          tahu serta-merta, bukan selepas Run gagal esok. */
                    if (versionGateModal.mode === 'userscript') {
                        /* ★ v3.9.2 — GAYA v3.9 (arahan user): monokrom, token --s-*,
                           TIADA gradien ungu. Modal lama (mod versi/duplicate di bawah)
                           kekal gaya Tailwind sedia ada — ia bukan skop kerja ini dan
                           menukarnya berisiko tanpa faedah. */
                        const langkah = (tajuk, baris) => (
                            <div style={{ background: 'var(--s-card)', border: '1px solid var(--s-line)', borderRadius: 12, padding: 12 }}>
                                <p style={{ fontSize: 11, fontWeight: 700, color: 'var(--s-ink)', margin: '0 0 6px' }}>{tajuk}</p>
                                <ol style={{ fontSize: 11, color: 'var(--s-ink-2)', margin: 0, paddingLeft: 16, lineHeight: 1.6, listStyle: 'decimal' }}>
                                    {baris.map((b, i) => <li key={i}>{b}</li>)}
                                </ol>
                            </div>
                        );
                        return (
                            <div style={{ position: 'fixed', inset: 0, zIndex: 10000, background: 'rgba(0,0,0,.62)', display: 'grid', placeItems: 'center', padding: 16 }}>
                                <div style={{ width: '100%', maxWidth: 400, background: 'var(--s-panel)', border: '1px solid var(--s-line)', borderRadius: 'var(--s-r-lg)', boxShadow: 'var(--s-shadow-modal)', overflow: 'hidden' }}>
                                    {/* Kepala monokrom — ikon dalam bulatan --s-fill, bukan gradien */}
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '16px 20px', borderBottom: '1px solid var(--s-line)' }}>
                                        <div style={{ width: 38, height: 38, borderRadius: 12, background: 'var(--s-fill)', display: 'grid', placeItems: 'center', flex: 'none' }}>
                                            <span className="material-symbols-outlined" style={{ fontSize: 20, color: 'var(--s-ink)' }}>lock_open</span>
                                        </div>
                                        <div>
                                            <h3 style={{ fontSize: 14, fontWeight: 700, color: 'var(--s-ink)', margin: 0 }}>{T('ws.usgate.title', 'Satu Langkah Lagi')}</h3>
                                            <p style={{ fontSize: 11, color: 'var(--s-ink-2)', margin: 0 }}>{T('ws.usgate.sub', 'Hidupkan satu suis dalam browser anda')}</p>
                                        </div>
                                    </div>
                                    <div style={{ padding: '18px 20px', display: 'flex', flexDirection: 'column', gap: 12 }}>
                                        <p style={{ fontSize: 13.5, color: 'var(--s-ink-2)', margin: 0, lineHeight: 1.6 }}>
                                            {T('ws.usgate.why', 'Suis ini membenarkan SESAAT menerima kemas kini automation terus daripada kami — jadi anda tidak perlu pasang semula extension setiap kali ada pembaikan. Cukup hidupkan sekali sahaja.')}
                                        </p>
                                        {langkah(T('ws.usgate.chrome', 'Google Chrome'), [
                                            T('ws.usgate.c1', 'Buka chrome://extensions dalam tab baharu'),
                                            T('ws.usgate.c2', 'Klik Details pada extension SESAAT'),
                                            T('ws.usgate.c3', 'Hidupkan Allow user scripts'),
                                        ])}
                                        {/* Gambar sebenar suis di Chrome — pelanggan cari baris ini.
                                            Chrome memapar amaran "may be unsafe"; kapsyen menenangkan
                                            supaya mereka tidak panik dan batal separuh jalan. */}
                                        <div style={{ border: '1px solid var(--s-line)', borderRadius: 12, overflow: 'hidden' }}>
                                            <img src="/allow-user-scripts.png" alt="Allow User Scripts toggle" style={{ display: 'block', width: '100%' }} />
                                            <p style={{ fontSize: 11, color: 'var(--s-ink-2)', margin: 0, padding: '8px 12px', background: 'var(--s-card)', lineHeight: 1.5 }}>
                                                {T('ws.usgate.imgcap', 'Cari baris ini, hidupkan suis di kanan. Chrome akan papar amaran "may be unsafe" — ia normal; suis ini cuma membenarkan SESAAT terima kemas kini daripada kami.')}
                                            </p>
                                        </div>
                                        {langkah(T('ws.usgate.edge', 'Microsoft Edge'), [
                                            T('ws.usgate.e1', 'Buka edge://extensions dalam tab baharu'),
                                            T('ws.usgate.e2', 'Kalau ada Allow user scripts — hidupkan'),
                                            T('ws.usgate.e3', 'Kalau tiada — hidupkan Developer mode di bawah sekali'),
                                        ])}
                                        {versionGateModal.gagal && (
                                            <div style={{ background: 'var(--s-stop-soft)', borderRadius: 12, padding: 12 }}>
                                                <p style={{ fontSize: 11.5, color: 'var(--s-stop)', margin: 0, lineHeight: 1.55 }}>
                                                    {T('ws.usgate.gagal', 'Masih belum dikesan. Pastikan suis itu betul-betul hidup, kemudian muat semula halaman ini sebelum cuba lagi.')}
                                                </p>
                                            </div>
                                        )}
                                        <button
                                            onClick={async () => {
                                                const p = await pingExtension(700);
                                                if (p?.userScripts === true) setVersionGateModal(null);
                                                else setVersionGateModal({ mode: 'userscript', forced: true, gagal: true });
                                            }}
                                            style={{ width: '100%', padding: '12px 16px', borderRadius: 12, background: 'var(--s-primary)', color: 'var(--s-primary-ink)', border: 0, fontWeight: 700, fontSize: 13.5, cursor: 'pointer', marginTop: 4 }}
                                        >
                                            {T('ws.usgate.semak', 'Saya dah hidupkan — semak')}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        );
                    }

                    /* ★ 2026-09-27 (arahan user "patutnya guna design baru kita"): rupa v3.9
                       dalam fail sendiri — GateExtensionV39.jsx. Logik semakan KEKAL di sini.
                       Rupa lama di bawah kekal untuk !uiV39 (token --s-* hanya dalam .s-root). */
                    if (uiV39) {
                        return (
                            <GateExtensionV39
                                t={t} T={T}
                                mod={versionGateModal.mode}
                                bilExtension={dupCount}
                                versiDiperlukan={versionGateModal.requiredVersion}
                                adaBerganda={!!versionGateModal.duplicate}
                                paksa={!!versionGateModal.forced}
                                semakan={versionRecheck}
                                onTutup={() => setVersionGateModal(null)}
                                onSemak={semakSelepasKemasKini}
                            />
                        );
                    }

                    return (
                    <div className="fixed inset-0 z-[10000] bg-black/60 backdrop-blur-sm flex items-center justify-center p-4 animate-fadeIn">
                        <div className={`w-full max-w-md bg-white dark:bg-slate-900 rounded-2xl shadow-2xl border overflow-hidden ${isDupWarn ? 'border-amber-200 dark:border-amber-900/50' : 'border-violet-200 dark:border-violet-900/50'}`}>
                            {/* Header */}
                            <div className={`px-6 py-4 bg-gradient-to-r ${isDupWarn ? 'from-amber-500 to-orange-600' : 'from-violet-600 to-indigo-600'}`}>
                                <div className="flex items-center gap-3">
                                    <div className="w-10 h-10 bg-white/20 rounded-xl flex items-center justify-center backdrop-blur">
                                        <span className="material-symbols-outlined text-white text-xl">{isDupWarn ? 'extension_off' : 'system_update'}</span>
                                    </div>
                                    <div>
                                        <h3 className="text-white font-bold text-sm">{isDupWarn ? T('ws.vergate.dupTitle', 'Extension Lama Masih Terpasang') : T('ws.vergate.title', 'Kemas Kini Extension Diperlukan')}</h3>
                                        <p className="text-white/80 text-[11px]">{isDupWarn ? T('ws.vergate.dupSub', 'Sila buang versi lama daripada browser') : T('ws.vergate.sub', 'Versi terkini diperlukan untuk meneruskan')}</p>
                                    </div>
                                </div>
                            </div>

                            {/* ===== MOD AMARAN: lebih daripada satu extension SESAAT aktif ===== */}
                            {isDupWarn ? (
                            <>
                            <div className="px-6 py-5 space-y-4">
                                <p className="text-sm text-slate-600 dark:text-slate-300 leading-relaxed">
                                    {/* Serlahan warna kekal untuk rupa LAMA; kamus menyimpan ayat sebagai
                                        teks biasa, jadi rupa v3.9 memaparkannya tanpa serlahan itu. */}
                                    {uiV39
                                        ? t('ws.vergate.dupBody', { n: dupCount })
                                        : <>Browser ini mempunyai <span className="font-semibold text-amber-600 dark:text-amber-400">{dupCount} extension SESAAT</span> yang
                                    aktif serentak. Versi terkini anda berfungsi seperti biasa, tetapi versi lama masih terpasang
                                    dan perlu dibuang.</>}
                                </p>

                                <div className="rounded-xl px-4 py-3.5 bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800/60">
                                    <div className="flex items-center gap-1.5 mb-1.5">
                                        <span className="material-symbols-outlined text-amber-600 dark:text-amber-400 text-base">warning</span>
                                        <span className="text-xs font-bold text-amber-700 dark:text-amber-300">{T('ws.vergate.dupWhyTitle', 'Kenapa ia perlu dibuang?')}</span>
                                    </div>
                                    <ul className="text-xs text-slate-600 dark:text-slate-300 leading-relaxed space-y-1 list-disc pl-4">
                                        <li>{uiV39 ? t('ws.vergate.dupWhy1') : <>Arahan Run boleh dihantar <span className="font-semibold">dua kali</span> &mdash; video berganda dan kuota Flow terbakar.</>}</li>
                                        <li>{uiV39 ? t('ws.vergate.dupWhy2') : <>Extension lama masih cuba menyimpan data anda, tetapi simpanannya <span className="font-semibold">ditolak sistem</span> tanpa notis.</>}</li>
                                        <li>{uiV39 ? t('ws.vergate.dupWhy3') : <>Ia dikira sebagai <span className="font-semibold">dua browser</span> daripada had lesen anda.</>}</li>
                                    </ul>
                                </div>

                                <div className="bg-slate-50 dark:bg-slate-800/50 rounded-lg px-4 py-3 space-y-1.5 border border-slate-200 dark:border-slate-700">
                                    {/* ⛔ 'chrome://extensions' = alamat literal dan 'Remove' = nama butang
                                        Chrome sendiri — kedua-duanya kekal sama dalam mana-mana bahasa. */}
                                    <div className="text-xs text-slate-600 dark:text-slate-300"><span className="text-amber-600 dark:text-amber-400 font-bold">1.</span>&nbsp; {uiV39 ? t('ws.vergate.dupStep1') : <>Taip <span className="font-mono font-semibold">chrome://extensions</span> pada address bar</>}</div>
                                    <div className="text-xs text-slate-600 dark:text-slate-300"><span className="text-amber-600 dark:text-amber-400 font-bold">2.</span>&nbsp; {uiV39 ? t('ws.vergate.dupStep2') : <>Cari semua kad SESAAT. Tekan <span className="font-semibold">Remove</span> pada yang bukan versi terkini</>}</div>
                                    <div className="text-xs text-slate-600 dark:text-slate-300"><span className="text-amber-600 dark:text-amber-400 font-bold">3.</span>&nbsp; {T('ws.vergate.dupStep3', 'Pastikan tinggal satu sahaja, kemudian refresh tab ini')}</div>
                                </div>
                            </div>
                            <div className="px-6 py-4 border-t border-slate-100 dark:border-slate-800">
                                <button onClick={() => setVersionGateModal(null)}
                                        className="w-full flex items-center justify-center gap-2 px-5 py-3 rounded-xl font-bold text-sm bg-amber-500 hover:bg-amber-600 text-white shadow-lg shadow-amber-500/20 transition-all">
                                    <span className="material-symbols-outlined text-lg">check_circle</span>
                                    {T('ws.vergate.dupOk', 'Faham')}
                                </button>
                            </div>
                            </>
                            ) : (
                            <>
                            {/* ===== MOD GATE VERSI ===== */}
                            <div className="px-6 py-5 space-y-4">
                                <div className="flex items-center justify-center gap-2">
                                    <span className="text-[11px] px-2.5 py-1 rounded-full bg-red-50 text-red-600 dark:bg-red-900/30 dark:text-red-400 font-semibold">{T('ws.vergate.yourVersionOld', 'Versi anda: lama')}</span>
                                    <span className="material-symbols-outlined text-slate-400 text-base">arrow_forward</span>
                                    <span className="text-[11px] px-2.5 py-1 rounded-full bg-emerald-50 text-emerald-600 dark:bg-emerald-900/30 dark:text-emerald-400 font-semibold">{T('ws.vergate.requiredVersion', `Diperlukan: v${versionGateModal.requiredVersion}`, { versi: versionGateModal.requiredVersion })}</span>
                                </div>
                                <p className="text-sm text-slate-600 dark:text-slate-300 text-center leading-relaxed">
                                    {T('ws.vergate.body', 'Anda masih menggunakan versi lama extension SESAAT. Sila kemas kini untuk meneruskan penggunaan.')}
                                </p>

                                {/* ★ Extension lama masih terpasang serentak — itulah puncanya. Beritahu terus,
                                    supaya pelanggan tidak terus memasang semula versi baharu berulang kali. */}
                                {versionGateModal.duplicate && (
                                    <div className="rounded-lg px-3.5 py-2.5 bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800/60">
                                        <p className="text-xs text-amber-700 dark:text-amber-300 leading-relaxed">
                                            {uiV39 ? t('ws.vergate.duplicateNotice') : <><span className="font-semibold">Kami mengesan lebih daripada satu extension SESAAT</span> dalam
                                            browser ini. Versi baharu tidak menggantikan versi lama secara automatik &mdash; ia dipasang
                                            sebagai extension berasingan. Sila buang yang lama pada langkah 2 di bawah.</>}
                                        </p>
                                    </div>
                                )}

                                <div className="bg-slate-50 dark:bg-slate-800/50 rounded-lg px-4 py-3 space-y-1.5 border border-slate-200 dark:border-slate-700">
                                    <div className="text-xs text-slate-600 dark:text-slate-300"><span className="text-violet-600 dark:text-violet-400 font-bold">1.</span>&nbsp; {T('ws.vergate.step1', 'Muat turun fail ZIP di bawah')}</div>
                                    <div className="text-xs text-slate-600 dark:text-slate-300"><span className="text-violet-600 dark:text-violet-400 font-bold">2.</span>&nbsp; {uiV39 ? t('ws.vergate.step2') : <>Buka <span className="font-mono font-semibold">chrome://extensions</span> dan tekan <span className="font-semibold">Remove</span> pada extension SESAAT yang lama</>}</div>
                                    <div className="text-xs text-slate-600 dark:text-slate-300"><span className="text-violet-600 dark:text-violet-400 font-bold">3.</span>&nbsp; {T('ws.vergate.step3', 'Pasang extension baharu (panduan penuh di Dashboard, Step 1)')}</div>
                                    {/* Petikan mesti sepadan dengan label butang `ws.vergate.iHaveUpdated`. */}
                                    <div className="text-xs text-slate-600 dark:text-slate-300"><span className="text-violet-600 dark:text-violet-400 font-bold">4.</span>&nbsp; {uiV39 ? t('ws.vergate.step4') : <>Kembali ke tab ini dan tekan &ldquo;Saya Sudah Kemas Kini&rdquo;</>}</div>
                                </div>

                                {versionRecheck === 'still-old' && (
                                    <div className="rounded-lg px-3.5 py-2.5 bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800/60">
                                        <p className="text-xs text-amber-700 dark:text-amber-300 leading-relaxed">
                                            {uiV39 ? t('ws.vergate.stillOld') : <>Sistem masih mengesan versi lama. Punca paling kerap: extension lama <span className="font-semibold">belum
                                            dibuang</span> daripada <span className="font-mono font-semibold">chrome://extensions</span>. Sila pastikan
                                            tinggal satu extension SESAAT sahaja, kemudian cuba sekali lagi.</>}
                                        </p>
                                    </div>
                                )}
                            </div>
                            {/* Footer */}
                            <div className="px-6 py-4 border-t border-slate-100 dark:border-slate-800 space-y-2">
                                <a href="/SESAAT-EXTENSION.zip" download="SESAAT-EXTENSION.zip"
                                   className="w-full flex items-center justify-center gap-2 px-5 py-3 rounded-xl font-bold text-sm bg-violet-600 hover:bg-violet-700 text-white shadow-lg shadow-violet-500/20 transition-all">
                                    <span className="material-symbols-outlined text-lg">download</span>
                                    {T('ws.vergate.download', 'Muat Turun Versi Terkini')}
                                </a>
                                {versionGateModal.forced ? (
                                    <button
                                        disabled={versionRecheck === 'checking'}
                                        onClick={semakSelepasKemasKini}
                                        className="w-full flex items-center justify-center gap-2 px-5 py-2.5 rounded-xl font-semibold text-xs border border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-800 disabled:opacity-50 transition-all">
                                        <span className="material-symbols-outlined text-base">{versionRecheck === 'checking' ? 'progress_activity' : 'refresh'}</span>
                                        {versionRecheck === 'checking' ? T('ws.vergate.checking', 'Menyemak…') : T('ws.vergate.iHaveUpdated', 'Saya Sudah Kemas Kini')}
                                    </button>
                                ) : (
                                    <button onClick={() => setVersionGateModal(null)}
                                            className="w-full text-center text-xs text-slate-400 hover:text-slate-600 dark:hover:text-slate-300 py-1">
                                        {T('ws.vergate.close', 'Tutup')}
                                    </button>
                                )}
                            </div>
                            </>
                            )}
                        </div>
                    </div>
                    );
                })()}

                {/* ===== MODAL PENGUMUMAN WORKSPACE (config/workspace_announce) ===== */}
                {announceModal && (
                    <div
                        onClick={() => setAnnounceModal(null)}
                        style={{ position: 'fixed', inset: 0, zIndex: 100000, background: 'rgba(0,0,0,.55)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}
                    >
                        <div
                            onClick={(e) => e.stopPropagation()}
                            style={{ background: 'var(--s-card, #ffffff)', color: 'var(--s-ink, #111111)', maxWidth: 460, width: '100%', borderRadius: 16, padding: '24px 22px 20px', boxShadow: '0 20px 60px rgba(0,0,0,.35)', position: 'relative', border: '1px solid var(--s-line, rgba(0,0,0,.08))',
                                // 2026-10-10: mesej panjang + skrin pendek (1366×768) → modal terkeluar skrin atas & bawah.
                                // Hadkan tinggi ikut skrin; badan mesej sahaja yang scroll, × dan "Faham" kekal nampak.
                                maxHeight: '100%', boxSizing: 'border-box', display: 'flex', flexDirection: 'column' }}
                        >
                            <button
                                onClick={() => setAnnounceModal(null)}
                                aria-label="Tutup"
                                style={{ position: 'absolute', top: 12, right: 12, width: 32, height: 32, borderRadius: 8, border: 'none', background: 'transparent', cursor: 'pointer', fontSize: 22, lineHeight: 1, color: 'var(--s-ink-3, #999999)' }}
                            >×</button>
                            <div style={{ fontSize: 22, marginBottom: 8 }}>📣</div>
                            {announceModal.title && (
                                <div style={{ fontSize: 17, fontWeight: 700, marginBottom: 10, paddingRight: 28, lineHeight: 1.35 }}>{announceModal.title}</div>
                            )}
                            <div style={{ fontSize: 14, lineHeight: 1.6, whiteSpace: 'pre-wrap', overflowWrap: 'anywhere', overflowY: 'auto', minHeight: 0, flex: '1 1 auto' }}>{pautkanTeks(announceModal.body)}</div>
                            <button
                                onClick={() => setAnnounceModal(null)}
                                style={{ marginTop: 18, width: '100%', flexShrink: 0, padding: '11px 14px', borderRadius: 10, border: 'none', cursor: 'pointer', fontWeight: 600, fontSize: 14, background: 'var(--s-primary, #262626)', color: 'var(--s-primary-ink, #fafafa)' }}
                            >Faham</button>
                        </div>
                    </div>
                )}

                {/* ===== FULLSCREEN PROMPT EDIT MODAL ===== */}
                {(() => {
                    if (!promptModalProductId) return null;
                    // ★ SPLIT V2: withDetail — teks dari detailCache (hydrate auto via effect
                    //   expandedCards/promptModalProductId di atas)
                    const product = withDetail(products.find(p => p.id === promptModalProductId));
                    if (!product) return null;
                    const _modalDetailPending = isDetailPending(product);
                    const space = spaces.find(s => s.id === selectedSpaceId);
                    const labels = space?.settings?.labels || {};
                    const showCaption = !product.hideCaption && space?.settings?.showTikTokCaption !== false;
                    const showSet2 = space?.settings?.showSet2 !== false;
                    const showSet3 = space?.settings?.showSet3 !== false;
                    const isAi16 = kadDuaBabak(product);
                    const renderColumn = (setKey, setLabel) => (
                        <div className="flex flex-col gap-3 p-4 bg-slate-50/60 dark:bg-slate-900/40 rounded-xl border border-slate-100 dark:border-slate-800 self-start">
                            <h4 className="text-[11px] font-extrabold text-slate-500 dark:text-slate-400 uppercase tracking-[0.1em] px-3 py-1 bg-white dark:bg-slate-800 rounded-md self-start shadow-sm">{setLabel}</h4>
                            {/* Hook Text — separate field for all modules. Bidirectional sync dengan promptImage. */}
                            <div className="group/prompt">
                                <div className="flex justify-between items-center mb-1">
                                    <label className="text-[11px] font-bold text-slate-500 uppercase flex items-center gap-1">
                                        <span className="w-1.5 h-1.5 rounded-full bg-amber-500"></span> Hook Text
                                    </label>
                                    <button onClick={() => copyToClipboard(getEffectiveHookText(product.id, product.prompts, setKey), `modal_hookText_${setKey}_${product.id}`)} className="opacity-0 group-hover/prompt:opacity-100 p-1 rounded hover:bg-slate-200 dark:hover:bg-slate-800 text-slate-500 hover:text-amber-500 transition-all" title={T('ws.common.copy', 'Copy')}>
                                        <span className="material-symbols-outlined text-[14px]">{copiedField === `modal_hookText_${setKey}_${product.id}` ? 'check' : 'content_copy'}</span>
                                    </button>
                                </div>
                                <div className="relative">
                                    <textarea
                                        value={getEffectiveHookText(product.id, product.prompts, setKey)}
                                        onChange={(e) => updateDraftPrompt(product.id, product.prompts, setKey, 'hookText', e.target.value)}
                                        className="w-full h-20 bg-amber-50 dark:bg-amber-900/10 p-3 rounded-lg border border-amber-200 dark:border-amber-800/40 text-sm leading-relaxed text-slate-700 dark:text-slate-200 resize-y focus:ring-2 focus:ring-amber-500 focus:border-amber-500"
                                        placeholder={T('ws.prompt.hookPlaceholder', 'Hook ayat — edit di sini auto-sync ke Image Prompt')}
                                    />
                                    <TemplateBadge label={getTemplateBadgeLabel(product, setKey, 'hook')} color="amber" />
                                </div>
                                {hookSyncWarnings[`${product.id}_${setKey}`] && (
                                    <div className="text-[10px] text-amber-600 dark:text-amber-400 mt-1 px-1 leading-snug font-semibold">
                                        {hookSyncWarnings[`${product.id}_${setKey}`]}
                                    </div>
                                )}
                                {/* ★ Template trace — fragment yang Cloud Function actually fetched untuk set ni */}
                                {product.templateTrace?.[setKey]?.hook && (
                                    <div className={`text-[9px] mt-1 px-1 leading-snug font-mono ${product.templateTrace[setKey].hook.startsWith('❌') ? 'text-rose-600' : 'text-slate-500'}`}>
                                        {T('ws.promptModal.fragmentUsed', `🔎 Fragment used: ${product.templateTrace[setKey].hook}`, { nilai: product.templateTrace[setKey].hook })}
                                    </div>
                                )}
                            </div>
                            <div className="group/prompt" style={resipiTanpaGambar(product) ? { display: 'none' } : undefined}>
                                <div className="flex justify-between items-center mb-1">
                                    <label className="text-[11px] font-bold text-slate-500 uppercase flex items-center gap-1">
                                        <span className="w-1.5 h-1.5 rounded-full bg-blue-500"></span> {labels.imagePrompt || 'Image Prompt'}
                                    </label>
                                    <button onClick={() => copyWithTag('IMAGE', setKey, null, product.prompts?.[setKey]?.promptImage || '', `modal_promptImage_${setKey}_${product.id}`)} className="opacity-0 group-hover/prompt:opacity-100 p-1 rounded hover:bg-slate-200 dark:hover:bg-slate-800 text-slate-500 hover:text-primary transition-all" title={T('ws.common.copy', 'Copy')}>
                                        <span className="material-symbols-outlined text-[14px]">{copiedField === `modal_promptImage_${setKey}_${product.id}` ? 'check' : 'content_copy'}</span>
                                    </button>
                                </div>
                                <div className="relative">
                                    <HighlightTextarea
                                        value={(draftPromptMap[product.id] ?? product.prompts)?.[setKey]?.promptImage || ''}
                                        onChange={(e) => updateDraftPrompt(product.id, product.prompts, setKey, 'promptImage', e.target.value)}
                                        highlights={[{ text: getEffectiveHookText(product.id, product.prompts, setKey), color: 'bg-amber-200/70 dark:bg-amber-500/30' }]}
                                        heightClassName="h-56 lg:h-72"
                                        boxClassName="bg-white dark:bg-slate-800/40 rounded-lg border border-slate-200 dark:border-slate-700"
                                        textClassName="p-3 text-sm leading-relaxed"
                                        placeholder={T('ws.prompt.empty', 'Empty')}
                                    />
                                    <TemplateBadge label={getTemplateBadgeLabel(product, setKey, 'bg')} color="blue" />
                                </div>
                                {/* ★ Template trace — bg fragment yang Cloud Function actually fetched */}
                                {product.templateTrace?.[setKey]?.bg && (
                                    <div className={`text-[9px] mt-1 px-1 leading-snug font-mono ${product.templateTrace[setKey].bg.startsWith('❌') ? 'text-rose-600' : 'text-slate-500'}`}>
                                        {T('ws.promptModal.bgFragment', `🔎 BG fragment: ${product.templateTrace[setKey].bg}`, { nilai: product.templateTrace[setKey].bg })}
                                    </div>
                                )}
                            </div>
                            {/* ★ RESIPI gambar berlainan, 2 scene: Image Prompt scene 2 */}
                            {((isAi16 && resipiBerlainan(product)) || resipiFrame(product)) && (
                                <KotakGambarBabak tajuk={resipiFrame(product) ? T('ws.resipi.imageEnd', 'Image Prompt · After (End frame)') : undefined} set={(draftPromptMap[product.id] ?? product.prompts)?.[setKey]} babak={2} onUbah={(medan, nilai) => updateDraftPrompt(product.id, product.prompts, setKey, medan, nilai)} onSalin={(jenis, n, teks, kunci) => copyWithTag(jenis, setKey, n, teks, kunci)} salinan={copiedField} kunci={`modal_rimg2_${setKey}_${product.id}`} T={T} />
                            )}
                            {isAi16 ? (
                                <>
                                    {/* Video Script (Scene 1) — voiceover, bidirectional sync dengan promptVideo1 */}
                                    <div className="group/prompt">
                                        <div className="flex justify-between items-center mb-1">
                                            <label className="text-[11px] font-bold text-slate-500 uppercase flex items-center gap-1">
                                                <span className="w-1.5 h-1.5 rounded-full bg-emerald-500"></span> Video Script (Scene 1)
                                            </label>
                                            <button onClick={() => copyToClipboard(getEffectiveVideoScript(product.id, product.prompts, setKey, '1'), `modal_videoScript1_${setKey}_${product.id}`)} className="opacity-0 group-hover/prompt:opacity-100 p-1 rounded hover:bg-slate-200 dark:hover:bg-slate-800 text-slate-500 hover:text-emerald-500 transition-all" title={T('ws.common.copy', 'Copy')}>
                                                <span className="material-symbols-outlined text-[14px]">{copiedField === `modal_videoScript1_${setKey}_${product.id}` ? 'check' : 'content_copy'}</span>
                                            </button>
                                        </div>
                                        <textarea
                                            value={getEffectiveVideoScript(product.id, product.prompts, setKey, '1')}
                                            onChange={(e) => updateDraftPrompt(product.id, product.prompts, setKey, 'videoScript1', e.target.value)}
                                            className="w-full h-24 bg-emerald-50 dark:bg-emerald-900/10 p-3 rounded-lg border border-emerald-200 dark:border-emerald-800/40 text-sm leading-relaxed text-slate-700 dark:text-slate-200 resize-y focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
                                            placeholder={T('ws.prompt.voiceoverScene1Placeholder', 'Voiceover Scene 1 — auto-sync ke Video Prompt (Scene 1)')}
                                        />
                                    </div>
                                    {/* Video Prompt (Scene 1) */}
                                    <div className="group/prompt">
                                        <div className="flex justify-between items-center mb-1">
                                            <label className="text-[11px] font-bold text-slate-500 uppercase flex items-center gap-1">
                                                <span className="w-1.5 h-1.5 rounded-full bg-purple-500"></span> Video Prompt (Scene 1)
                                            </label>
                                            <button onClick={() => copyWithTag('VIDEO', setKey, 1, product.prompts?.[setKey]?.promptVideo1 || product.prompts?.[setKey]?.promptVideo || '', `modal_promptVideo1_${setKey}_${product.id}`)} className="opacity-0 group-hover/prompt:opacity-100 p-1 rounded hover:bg-slate-200 dark:hover:bg-slate-800 text-slate-500 hover:text-primary transition-all" title={T('ws.common.copy', 'Copy')}>
                                                <span className="material-symbols-outlined text-[14px]">{copiedField === `modal_promptVideo1_${setKey}_${product.id}` ? 'check' : 'content_copy'}</span>
                                            </button>
                                        </div>
                                        <HighlightTextarea
                                            value={(draftPromptMap[product.id] ?? product.prompts)?.[setKey]?.promptVideo1 || (draftPromptMap[product.id] ?? product.prompts)?.[setKey]?.promptVideo || ''}
                                            onChange={(e) => updateDraftPrompt(product.id, product.prompts, setKey, 'promptVideo1', e.target.value)}
                                            highlights={[
                                                { text: getEffectiveVideoScript(product.id, product.prompts, setKey, '1'), color: 'bg-emerald-200/70 dark:bg-emerald-500/30' },
                                                { text: getEffectiveHookText(product.id, product.prompts, setKey), color: 'bg-amber-200/70 dark:bg-amber-500/30' }
                                            ]}
                                            heightClassName="h-56 lg:h-72"
                                            boxClassName="bg-white dark:bg-slate-800/40 rounded-lg border border-slate-200 dark:border-slate-700"
                                            textClassName="p-3 text-sm leading-relaxed"
                                            placeholder={T('ws.prompt.empty', 'Empty')}
                                        />
                                    </div>
                                    {/* Video Script (Scene 2) — voiceover, bidirectional sync dengan promptVideo2 */}
                                    <div className="group/prompt">
                                        <div className="flex justify-between items-center mb-1">
                                            <label className="text-[11px] font-bold text-slate-500 uppercase flex items-center gap-1">
                                                <span className="w-1.5 h-1.5 rounded-full bg-teal-500"></span> Video Script (Scene 2)
                                            </label>
                                            <button onClick={() => copyToClipboard(getEffectiveVideoScript(product.id, product.prompts, setKey, '2'), `modal_videoScript2_${setKey}_${product.id}`)} className="opacity-0 group-hover/prompt:opacity-100 p-1 rounded hover:bg-slate-200 dark:hover:bg-slate-800 text-slate-500 hover:text-teal-500 transition-all" title={T('ws.common.copy', 'Copy')}>
                                                <span className="material-symbols-outlined text-[14px]">{copiedField === `modal_videoScript2_${setKey}_${product.id}` ? 'check' : 'content_copy'}</span>
                                            </button>
                                        </div>
                                        <textarea
                                            value={getEffectiveVideoScript(product.id, product.prompts, setKey, '2')}
                                            onChange={(e) => updateDraftPrompt(product.id, product.prompts, setKey, 'videoScript2', e.target.value)}
                                            className="w-full h-24 bg-teal-50 dark:bg-teal-900/10 p-3 rounded-lg border border-teal-200 dark:border-teal-800/40 text-sm leading-relaxed text-slate-700 dark:text-slate-200 resize-y focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
                                            placeholder={T('ws.prompt.voiceoverScene2Placeholder', 'Voiceover Scene 2 — auto-sync ke Video Prompt (Scene 2)')}
                                        />
                                    </div>
                                    {/* Video Prompt (Scene 2) */}
                                    <div className="group/prompt">
                                        <div className="flex justify-between items-center mb-1">
                                            <label className="text-[11px] font-bold text-slate-500 uppercase flex items-center gap-1">
                                                <span className="w-1.5 h-1.5 rounded-full bg-violet-500"></span> Video Prompt (Scene 2)
                                            </label>
                                            <button onClick={() => copyWithTag('VIDEO', setKey, 2, product.prompts?.[setKey]?.promptVideo2 || '', `modal_promptVideo2_${setKey}_${product.id}`)} className="opacity-0 group-hover/prompt:opacity-100 p-1 rounded hover:bg-slate-200 dark:hover:bg-slate-800 text-slate-500 hover:text-primary transition-all" title={T('ws.common.copy', 'Copy')}>
                                                <span className="material-symbols-outlined text-[14px]">{copiedField === `modal_promptVideo2_${setKey}_${product.id}` ? 'check' : 'content_copy'}</span>
                                            </button>
                                        </div>
                                        <HighlightTextarea
                                            value={(draftPromptMap[product.id] ?? product.prompts)?.[setKey]?.promptVideo2 || ''}
                                            onChange={(e) => updateDraftPrompt(product.id, product.prompts, setKey, 'promptVideo2', e.target.value)}
                                            highlights={[
                                                { text: getEffectiveVideoScript(product.id, product.prompts, setKey, '2'), color: 'bg-teal-200/70 dark:bg-teal-500/30' },
                                                { text: getEffectiveHookText(product.id, product.prompts, setKey), color: 'bg-amber-200/70 dark:bg-amber-500/30' }
                                            ]}
                                            heightClassName="h-56 lg:h-72"
                                            boxClassName="bg-white dark:bg-slate-800/40 rounded-lg border border-slate-200 dark:border-slate-700"
                                            textClassName="p-3 text-sm leading-relaxed"
                                            placeholder={T('ws.prompt.empty', 'Empty')}
                                        />
                                    </div>
                                </>
                            ) : (
                                <>
                                    {/* Video Script — voiceover single-scene, bidirectional sync dengan promptVideo */}
                                    <div className="group/prompt">
                                        <div className="flex justify-between items-center mb-1">
                                            <label className="text-[11px] font-bold text-slate-500 uppercase flex items-center gap-1">
                                                <span className="w-1.5 h-1.5 rounded-full bg-emerald-500"></span> Video Script
                                            </label>
                                            <button onClick={() => copyToClipboard(getEffectiveVideoScript(product.id, product.prompts, setKey), `modal_videoScript_${setKey}_${product.id}`)} className="opacity-0 group-hover/prompt:opacity-100 p-1 rounded hover:bg-slate-200 dark:hover:bg-slate-800 text-slate-500 hover:text-emerald-500 transition-all" title={T('ws.common.copy', 'Copy')}>
                                                <span className="material-symbols-outlined text-[14px]">{copiedField === `modal_videoScript_${setKey}_${product.id}` ? 'check' : 'content_copy'}</span>
                                            </button>
                                        </div>
                                        <textarea
                                            value={getEffectiveVideoScript(product.id, product.prompts, setKey)}
                                            onChange={(e) => updateDraftPrompt(product.id, product.prompts, setKey, 'videoScript', e.target.value)}
                                            className="w-full h-24 bg-emerald-50 dark:bg-emerald-900/10 p-3 rounded-lg border border-emerald-200 dark:border-emerald-800/40 text-sm leading-relaxed text-slate-700 dark:text-slate-200 resize-y focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
                                            placeholder={T('ws.prompt.voiceoverPlaceholder', 'Voiceover script — auto-sync ke Video Prompt')}
                                        />
                                    </div>
                                    {/* Video Prompt (single-scene) */}
                                    <div className="group/prompt">
                                        <div className="flex justify-between items-center mb-1">
                                            <label className="text-[11px] font-bold text-slate-500 uppercase flex items-center gap-1">
                                                <span className="w-1.5 h-1.5 rounded-full bg-purple-500"></span> {labels.videoPrompt || 'Video Prompt'}
                                            </label>
                                            <button onClick={() => copyWithTag('VIDEO', setKey, null, product.prompts?.[setKey]?.promptVideo || '', `modal_promptVideo_${setKey}_${product.id}`)} className="opacity-0 group-hover/prompt:opacity-100 p-1 rounded hover:bg-slate-200 dark:hover:bg-slate-800 text-slate-500 hover:text-primary transition-all" title={T('ws.common.copy', 'Copy')}>
                                                <span className="material-symbols-outlined text-[14px]">{copiedField === `modal_promptVideo_${setKey}_${product.id}` ? 'check' : 'content_copy'}</span>
                                            </button>
                                        </div>
                                        <HighlightTextarea
                                            value={(draftPromptMap[product.id] ?? product.prompts)?.[setKey]?.promptVideo || ''}
                                            onChange={(e) => updateDraftPrompt(product.id, product.prompts, setKey, 'promptVideo', e.target.value)}
                                            highlights={[
                                                { text: getEffectiveVideoScript(product.id, product.prompts, setKey), color: 'bg-emerald-200/70 dark:bg-emerald-500/30' },
                                                { text: getEffectiveHookText(product.id, product.prompts, setKey), color: 'bg-amber-200/70 dark:bg-amber-500/30' }
                                            ]}
                                            heightClassName="h-56 lg:h-72"
                                            boxClassName="bg-white dark:bg-slate-800/40 rounded-lg border border-slate-200 dark:border-slate-700"
                                            textClassName="p-3 text-sm leading-relaxed"
                                            placeholder={T('ws.prompt.empty', 'Empty')}
                                        />
                                    </div>
                                </>
                            )}
                            {showCaption && (
                                <div className="group/prompt">
                                    <div className="flex justify-between items-center mb-1">
                                        <label className="text-[11px] font-bold text-slate-500 uppercase flex items-center gap-1">
                                            <span className="w-1.5 h-1.5 rounded-full bg-rose-500"></span> {labels.captionTiktok || 'TikTok Caption'}
                                        </label>
                                        <button onClick={() => copyToClipboard(product.prompts?.[setKey]?.captionTiktok || '', `modal_captionTiktok_${setKey}_${product.id}`)} className="opacity-0 group-hover/prompt:opacity-100 p-1 rounded hover:bg-slate-200 dark:hover:bg-slate-800 text-slate-500 hover:text-primary transition-all" title={T('ws.common.copy', 'Copy')}>
                                            <span className="material-symbols-outlined text-[14px]">{copiedField === `modal_captionTiktok_${setKey}_${product.id}` ? 'check' : 'content_copy'}</span>
                                        </button>
                                    </div>
                                    <textarea
                                        value={(draftPromptMap[product.id] ?? product.prompts)?.[setKey]?.captionTiktok || ''}
                                        onChange={(e) => updateDraftPrompt(product.id, product.prompts, setKey, 'captionTiktok', e.target.value)}
                                        className="w-full h-20 lg:h-24 bg-white dark:bg-slate-800/40 p-3 rounded-lg border border-slate-200 dark:border-slate-700 text-sm leading-relaxed text-slate-700 dark:text-slate-200 resize-y focus:ring-2 focus:ring-primary focus:border-primary"
                                        placeholder={T('ws.prompt.empty', 'Empty')}
                                    />
                                    {/* ★ [2026-09-16] Caption FACEBOOK (Bahagian 5). Medan `captionFb` INLINE dalam
                                        doc utama (INLINE_PROMPT_FIELDS + kembar extension) supaya Run Facebook
                                        membacanya tanpa hidrat subdoc.
                                        ★ [2026-09-27] Keputusan user: kotak ini memapar caption TikTok sebagai isi
                                        LALAI (terus ikut suntingan TikTok selagi kotak FB tidak disentuh); ubah +
                                        Save = caption FB sendiri; kosongkan + Save = FB post TANPA caption.
                                        Medan maya `captionFbKotak` → setDenganKotakFb (utils/captionKad.js). */}
                                    <label className="mt-2 text-[11px] font-bold text-slate-500 uppercase flex items-center gap-1 flex-wrap">
                                        <span className="w-1.5 h-1.5 rounded-full bg-sky-500"></span> {T('ws.caption.fb', 'Facebook Caption')}
                                    </label>
                                    <textarea
                                        value={teksKotakFb((draftPromptMap[product.id] ?? product.prompts)?.[setKey])}
                                        onChange={(e) => updateDraftPrompt(product.id, product.prompts, setKey, 'captionFbKotak', e.target.value)}
                                        className="w-full h-16 bg-white dark:bg-slate-800/40 p-3 rounded-lg border border-slate-200 dark:border-slate-700 text-sm leading-relaxed text-slate-700 dark:text-slate-200 resize-y focus:ring-2 focus:ring-sky-500 focus:border-sky-500"
                                        placeholder={fbKosongSengaja((draftPromptMap[product.id] ?? product.prompts)?.[setKey]) ? T('ws.caption.fbKosongSengaja', 'Kosong — Facebook akan post tanpa caption') : T('ws.caption.fbPlaceholder', 'Caption Facebook (pilihan)')}
                                    />
                                </div>
                            )}
                        </div>
                    );
                    const colCount = 1 + (showSet2 ? 1 : 0) + (showSet3 ? 1 : 0);
                    const gridCls = colCount === 3 ? 'grid-cols-1 lg:grid-cols-3' : colCount === 2 ? 'grid-cols-1 lg:grid-cols-2' : 'grid-cols-1';
                    const _modalSceneCount = getSceneCount(product);
                    const isNSceneModal = _modalSceneCount >= 3 || resipiGambarSahaja(product);
                    return (
                        <div
                            className={`fixed inset-0 z-[10000] bg-black/60 backdrop-blur-sm flex items-center justify-center animate-fadeIn transition-[padding] duration-300 ${isQuickNotesOpen ? 'p-4 sm:pl-4 sm:py-4 sm:pr-[376px]' : 'p-4'}`}
                            onClick={() => { setPromptModalProductId(null); setIsQuickNotesOpen(false); }}
                        >
                            {/* Modal ini dirender DI LUAR kad, jadi ia tidak mewarisi
                                `.sesaat-kad-v39`. Ia dapat cangkuknya sendiri supaya blok
                                gaya v3.9 boleh menyentuh kedua-duanya. */}
                            <div
                                ref={promptModalRef}
                                className={`w-[80%] h-[90vh] rounded-2xl shadow-2xl flex flex-col overflow-hidden border transition-all duration-300 relative ${uiV39 ? 'sesaat-modal-v39' : 'bg-white dark:bg-slate-900 border-slate-200 dark:border-slate-800'}`}
                                style={uiV39 ? { background: 'var(--s-panel)', borderColor: 'var(--s-line)' } : undefined}
                                onClick={(e) => e.stopPropagation()}
                            >
                                {/* ★ Shortcut "/" (2026-09-25) — taip "/" dalam MANA-MANA kotak popup ini
                                    untuk memasukkan shortcut dari PRO Studio. Pembantu mendengar event
                                    yang naik dari kotak, jadi tiada kotak di bawah perlu disentuh. */}
                                <ShortcutSlashPembantu bekasRef={promptModalRef} t={t} />
                                {/* ★ SPLIT V2: overlay memuatkan — kunci textarea sementara teks di-hydrate */}
                                {_modalDetailPending && (
                                    <div style={{ position: 'absolute', inset: 0, zIndex: 30, background: 'rgba(255,255,255,0.8)', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10 }}>
                                        <div className="w-5 h-5 border-2 border-indigo-500/30 border-t-indigo-500 rounded-full animate-spin"></div>
                                        <span style={{ fontSize: 13, fontWeight: 700, color: '#6366f1' }}>{T('ws.detail.loadingPrompt', 'Memuatkan teks prompt…')}</span>
                                    </div>
                                )}
                                <div className="px-6 py-3 border-b border-slate-200 dark:border-slate-800 flex items-center justify-between bg-white dark:bg-slate-900 shadow-sm">
                                    <div className="flex items-center gap-3 min-w-0">
                                        <span className="material-symbols-outlined text-primary text-xl">edit_note</span>
                                        <div className="min-w-0">
                                            <h3 className="text-sm font-bold text-slate-800 dark:text-slate-100 truncate">{T('ws.promptModal.title', 'Edit Prompts')}</h3>
                                            <p className="text-[11px] text-slate-500 dark:text-slate-400 truncate">{product.name || T('ws.promptModal.untitledProduct', 'Untitled product')}</p>
                                        </div>
                                    </div>
                                    <div className="flex items-center gap-2">
                                        <button
                                            onClick={() => setIsQuickNotesOpen(prev => !prev)}
                                            style={{
                                                padding: '6px 10px', borderRadius: 8, display: 'flex', alignItems: 'center', gap: 6,
                                                fontSize: 13, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit',
                                                border: isQuickNotesOpen ? '1px solid #6366f1' : '1px solid #cbd5e1',
                                                color: isQuickNotesOpen ? '#6366f1' : '#64748b',
                                                background: isQuickNotesOpen ? '#eef2ff' : 'transparent',
                                                transition: 'all 0.15s'
                                            }}
                                            title={isQuickNotesOpen ? T('ws.promptModal.closeQuickNotes', 'Tutup Quick Notes') : T('ws.promptModal.openQuickNotes', 'Buka Quick Notes')}
                                        >
                                            <span className="material-symbols-outlined" style={{ fontSize: 18, color: isQuickNotesOpen ? '#6366f1' : '#94a3b8' }}>sticky_note_2</span>
                                            {/* "Quick Notes" = nama ciri — kekal sama dalam kedua-dua bahasa. */}
                                            Quick Notes
                                        </button>
                                        <button
                                            onClick={() => { setPromptModalProductId(null); setIsQuickNotesOpen(false); }}
                                            className="w-9 h-9 rounded-full bg-slate-100 hover:bg-slate-200 dark:bg-slate-800 dark:hover:bg-slate-700 text-slate-600 dark:text-slate-300 flex items-center justify-center transition-colors"
                                            aria-label={T('ws.common.close', 'Tutup')}
                                            title={T('ws.common.close', 'Tutup')}
                                        >
                                            <span className="material-symbols-outlined text-base">close</span>
                                        </button>
                                    </div>
                                </div>
                                {isNSceneModal ? (
                                    /* N-scene modal (FLOWNITY etc): Scene 1..N columns + TikTok Caption */
                                    <div className="flex-1 overflow-auto p-4 flex flex-col gap-4">
                                        {/* Lajur scene bertindan menegak pada telefon — 5 lajur pada skrin
                                            375px bermakna ~60px setiap scene, mustahil dibaca atau diedit. */}
                                        {/* ★ RESIPI: Image Prompt (satu untuk semua scene) + Video Prompt setiap scene */}
                                        {getEffectiveScriptKey(product) === 'resipi' ? (
                                            <ModalResipiPrompt
                                                berlainan={resipiBerlainan(product)}
                                                tanpaGambar={resipiTanpaGambar(product)}
                                                tanpaVideo={resipiGambarSahaja(product)}
                                                set={(draftPromptMap[product.id] ?? product.prompts)?.set1}
                                                bilBabak={_modalSceneCount}
                                                onUbah={(medan, nilai) => updateDraftPrompt(product.id, product.prompts, 'set1', medan, nilai)}
                                                onSalin={(jenis, n, teks, kunci) => copyWithTag(jenis, 'set1', n, teks, kunci)}
                                                salinan={copiedField}
                                                idProduk={product.id}
                                                T={T}
                                            />
                                        ) : (
                                        <div className={`flex-1 grid gap-4 items-stretch grid-cols-1 ${_modalSceneCount <= 3 ? 'md:grid-cols-3' : _modalSceneCount === 4 ? 'md:grid-cols-4' : 'md:grid-cols-5'}`}>
                                            {Array.from({ length: _modalSceneCount }, (_, i) => {
                                                const n = i + 1;
                                                const scriptVal = getEffectiveVideoScript(product.id, product.prompts, 'set1', String(n));
                                                const imgVal = (draftPromptMap[product.id] ?? product.prompts)?.set1?.[`promptVideo${n}`] || ''; // visual = Image Prompt
                                                const fullVal = getEffectiveNSceneFull(product.id, product.prompts, n); // Video Prompt penuh (visual + dialog)
                                                return (
                                                    <div key={n} className="flex flex-col gap-3 p-4 bg-slate-50/60 dark:bg-slate-900/40 rounded-xl border border-slate-100 dark:border-slate-800 h-full">
                                                        <h4 className="text-[11px] font-extrabold text-slate-500 dark:text-slate-400 uppercase tracking-[0.1em] px-3 py-1 bg-white dark:bg-slate-800 rounded-md self-start shadow-sm">Scene {n}</h4>
                                                        {/* Image Prompt (visual — jana gambar scene) */}
                                                        <div className="group/prompt">
                                                            <div className="flex justify-between items-center mb-1">
                                                                <label className="text-[11px] font-bold text-slate-500 uppercase flex items-center gap-1">
                                                                    <span className="w-1.5 h-1.5 rounded-full bg-blue-500"></span> Image Prompt
                                                                </label>
                                                                <button onClick={() => copyToClipboard(imgVal, `modal_nimg${n}_${product.id}`)} className="opacity-0 group-hover/prompt:opacity-100 p-1 rounded hover:bg-slate-200 dark:hover:bg-slate-800 text-slate-500 hover:text-blue-500 transition-all" title={T('ws.common.copy', 'Copy')}>
                                                                    <span className="material-symbols-outlined text-[14px]">{copiedField === `modal_nimg${n}_${product.id}` ? 'check' : 'content_copy'}</span>
                                                                </button>
                                                            </div>
                                                            <textarea
                                                                value={imgVal}
                                                                onChange={(e) => updateDraftPrompt(product.id, product.prompts, 'set1', `promptVideo${n}`, e.target.value)}
                                                                className="w-full h-28 bg-blue-50/50 dark:bg-blue-900/10 p-3 rounded-lg border border-blue-200 dark:border-blue-900/40 text-sm leading-relaxed text-slate-700 dark:text-slate-200 resize-y focus:ring-2 focus:ring-blue-500 focus:border-blue-500 font-mono"
                                                                placeholder={T('ws.promptModal.nsceneImagePlaceholder', `Image Prompt Scene ${n} — visual sahaja`, { n })}
                                                            />
                                                        </div>
                                                        {/* Video Dialog (skrip — auto-sync ke Video Prompt) */}
                                                        <div className="group/prompt">
                                                            <div className="flex justify-between items-center mb-1">
                                                                <label className="text-[11px] font-bold text-slate-500 uppercase flex items-center gap-1">
                                                                    <span className="w-1.5 h-1.5 rounded-full bg-emerald-500"></span> Video Dialog
                                                                </label>
                                                                <button onClick={() => copyToClipboard(scriptVal, `modal_nscript${n}_${product.id}`)} className="opacity-0 group-hover/prompt:opacity-100 p-1 rounded hover:bg-slate-200 dark:hover:bg-slate-800 text-slate-500 hover:text-emerald-500 transition-all" title={T('ws.common.copy', 'Copy')}>
                                                                    <span className="material-symbols-outlined text-[14px]">{copiedField === `modal_nscript${n}_${product.id}` ? 'check' : 'content_copy'}</span>
                                                                </button>
                                                            </div>
                                                            <textarea
                                                                value={scriptVal}
                                                                onChange={(e) => updateDraftPrompt(product.id, product.prompts, 'set1', `videoScript${n}`, e.target.value)}
                                                                className="w-full h-24 bg-emerald-50 dark:bg-emerald-900/10 p-3 rounded-lg border border-emerald-200 dark:border-emerald-800/40 text-sm leading-relaxed text-slate-700 dark:text-slate-200 resize-y focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 italic"
                                                                placeholder={T('ws.prompt.nsceneDialoguePlaceholder', `Dialogue Scene ${n}...`, { n })}
                                                            />
                                                        </div>
                                                        {/* Video Prompt (penuh: visual + dialog — sedia untuk paste ke Flow) */}
                                                        <div className="group/prompt flex flex-col flex-1 min-h-0">
                                                            <div className="flex justify-between items-center mb-1">
                                                                <label className="text-[11px] font-bold text-slate-500 uppercase flex items-center gap-1">
                                                                    <span className="w-1.5 h-1.5 rounded-full bg-purple-500"></span> Video Prompt
                                                                </label>
                                                                <button onClick={() => copyToClipboard(fullVal, `modal_nprompt${n}_${product.id}`)} className="opacity-0 group-hover/prompt:opacity-100 p-1 rounded hover:bg-slate-200 dark:hover:bg-slate-800 text-slate-500 hover:text-primary transition-all" title={T('ws.common.copy', 'Copy')}>
                                                                    <span className="material-symbols-outlined text-[14px]">{copiedField === `modal_nprompt${n}_${product.id}` ? 'check' : 'content_copy'}</span>
                                                                </button>
                                                            </div>
                                                            <textarea
                                                                value={fullVal}
                                                                onChange={(e) => updateDraftPrompt(product.id, product.prompts, 'set1', `fullVideo${n}`, e.target.value)}
                                                                className="w-full flex-1 min-h-[140px] bg-white dark:bg-slate-800/40 p-3 rounded-lg border border-slate-200 dark:border-slate-700 text-sm leading-relaxed text-slate-600 dark:text-slate-400 resize-none focus:ring-2 focus:ring-primary focus:border-primary font-mono"
                                                                placeholder={T('ws.promptModal.nsceneVideoPlaceholder', `Video Prompt Veo 3 Scene ${n} — visual + dialog`, { n })}
                                                            />
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                        )}
                                        {/* TikTok Caption — full width below scenes */}
                                        {showCaption && (
                                            <div className="group/prompt p-4 bg-slate-50/60 dark:bg-slate-900/40 rounded-xl border border-slate-100 dark:border-slate-800">
                                                <div className="flex justify-between items-center mb-1">
                                                    <label className="text-[11px] font-bold text-slate-500 uppercase flex items-center gap-1">
                                                        <span className="w-1.5 h-1.5 rounded-full bg-rose-400"></span> TikTok Caption
                                                    </label>
                                                    <button onClick={() => copyToClipboard((draftPromptMap[product.id] ?? product.prompts)?.set1?.captionTiktok || '', `modal_ncap_${product.id}`)} className="opacity-0 group-hover/prompt:opacity-100 p-1 rounded hover:bg-slate-200 dark:hover:bg-slate-800 text-slate-500 hover:text-rose-500 transition-all" title={T('ws.common.copy', 'Copy')}>
                                                        <span className="material-symbols-outlined text-[14px]">{copiedField === `modal_ncap_${product.id}` ? 'check' : 'content_copy'}</span>
                                                    </button>
                                                </div>
                                                <textarea
                                                    value={(draftPromptMap[product.id] ?? product.prompts)?.set1?.captionTiktok || ''}
                                                    onChange={(e) => updateDraftPrompt(product.id, product.prompts, 'set1', 'captionTiktok', e.target.value)}
                                                    className="w-full h-20 bg-white dark:bg-slate-800/40 p-3 rounded-lg border border-slate-200 dark:border-slate-700 text-sm leading-relaxed text-slate-700 dark:text-slate-200 resize-y focus:ring-2 focus:ring-rose-400 focus:border-rose-400"
                                                    placeholder={T('ws.prompt.tiktokCaptionPlaceholder', 'TikTok caption...')}
                                                />
                                                {/* ★ [2026-09-16 · 2026-09-27] Caption Facebook — lihat nota pada blok per-set di atas. */}
                                                <label className="mt-2 text-[11px] font-bold text-slate-500 uppercase flex items-center gap-1 flex-wrap">
                                                    <span className="w-1.5 h-1.5 rounded-full bg-sky-500"></span> {T('ws.caption.fb', 'Facebook Caption')}
                                                </label>
                                                <textarea
                                                    value={teksKotakFb((draftPromptMap[product.id] ?? product.prompts)?.set1)}
                                                    onChange={(e) => updateDraftPrompt(product.id, product.prompts, 'set1', 'captionFbKotak', e.target.value)}
                                                    className="w-full h-16 bg-white dark:bg-slate-800/40 p-3 rounded-lg border border-slate-200 dark:border-slate-700 text-sm leading-relaxed text-slate-700 dark:text-slate-200 resize-y focus:ring-2 focus:ring-sky-500 focus:border-sky-500"
                                                    placeholder={fbKosongSengaja((draftPromptMap[product.id] ?? product.prompts)?.set1) ? T('ws.caption.fbKosongSengaja', 'Kosong — Facebook akan post tanpa caption') : T('ws.caption.fbPlaceholder', 'Caption Facebook (pilihan)')}
                                                />
                                            </div>
                                        )}
                                    </div>
                                ) : (
                                <div className={`flex-1 overflow-auto p-4 grid gap-4 ${gridCls}`}>
                                    {renderColumn('set1', labels.set1 || 'Set 1')}
                                    {showSet2 && renderColumn('set2', labels.set2 || 'Set 2')}
                                    {showSet3 && renderColumn('set3', labels.set3 || 'Set 3')}
                                </div>
                                )}
                                <div className="px-6 py-3 border-t border-slate-200 dark:border-slate-800 bg-slate-50 dark:bg-slate-900/60 flex items-center justify-end gap-2">
                                    {dirtyProductIds.has(product.id) ? (
                                        <span className="text-[11px] text-amber-600 dark:text-amber-400 font-medium mr-auto flex items-center gap-1">
                                            <span className="material-symbols-outlined text-[14px]">edit</span> {T('ws.promptModal.unsavedChanges', 'Ada perubahan yang belum disimpan')}
                                        </span>
                                    ) : savedPromptNotifs[product.id] ? (
                                        <span className="text-[11px] text-emerald-600 dark:text-emerald-400 font-medium mr-auto flex items-center gap-1">
                                            <span className="material-symbols-outlined text-[14px]">check_circle</span> {T('ws.promptModal.saved', 'Berjaya disimpan')}
                                        </span>
                                    ) : (
                                        <span className="text-[11px] text-slate-400 mr-auto">{T('ws.promptModal.saveHint', 'Edit dan klik Simpan untuk kekalkan perubahan')}</span>
                                    )}
                                    {(() => {
                                        const isDirty = dirtyProductIds.has(product.id);
                                        const isSaved = !!savedPromptNotifs[product.id] && !isDirty;
                                        return (
                                            <button
                                                onClick={() => saveProductDraftPrompts(product.id)}
                                                disabled={!isDirty}
                                                className={`px-5 py-2 rounded-lg text-white text-[11px] font-bold transition-all disabled:cursor-not-allowed flex items-center gap-1.5 ${isSaved ? 'bg-emerald-500 shadow-lg shadow-emerald-500/30' : 'bg-indigo-600 hover:bg-indigo-700 disabled:opacity-40'}`}
                                            >
                                                <span className="material-symbols-outlined text-[14px]">{isSaved ? 'check_circle' : 'save'}</span> {isSaved ? T('ws.promptModal.savedBtn', 'Tersimpan') : T('ws.promptModal.saveBtn', 'Simpan')}
                                            </button>
                                        );
                                    })()}
                                </div>
                            </div>
                        </div>
                    );
                })()}

                {/* Hidden File Input for Video Upload */}
                <input
                    type="file"
                    ref={videoInputRef}
                    className="hidden"
                    accept="video/*"
                    onChange={handleVideoUpload}
                />

                {/* Hidden File Input for Image Upload */}
                <input
                    type="file"
                    ref={fileInputRef}
                    className="hidden"
                    accept="image/*"
                    onChange={(e) => {
                        if (uploadingProductId && e.target.files?.[0]) {
                            handleImageUpload(uploadingProductId, e.target.files[0]);
                            setUploadingProductId(null);
                        }
                    }}
                />

                {/* ★ [2026-11-04] Blank Card — "Add product": pilih dari My Products, salin
                    data produk ke dalam kad kosong (satu kad = satu produk). Guna semula
                    modal pemilih sedia ada (ProductLibraryModal). */}
                {addProductFor && (
                    <ProductLibraryModal
                        isOpen={true}
                        uiV39={uiV39}
                        onClose={() => setAddProductFor(null)}
                        onSelectProducts={(arr) => {
                            const lp = Array.isArray(arr) ? arr[0] : null;   // satu kad = satu produk
                            const kad = products.find(p => p.id === addProductFor);
                            const updates = salinProdukKeKad(lp, kad?.name);
                            if (updates) updateProduct(addProductFor, updates);
                            setAddProductFor(null);
                        }}
                    />
                )}

                {/* Image Preview Modal */}
                {
                    previewImage && (
                        <div
                            className="fixed inset-0 z-[9999] bg-black/80 flex items-center justify-center p-4 cursor-zoom-out"
                            onClick={() => setPreviewImage(null)}
                        >
                            <div className="relative max-w-4xl max-h-[90vh] rounded-2xl overflow-hidden shadow-2xl animate-in zoom-in-95 duration-200">
                                <img src={previewImage} alt={T('ws.preview.alt', 'Preview')} className="w-full h-full object-contain" />
                                <button
                                    className="absolute top-4 right-4 w-10 h-10 bg-black/50 hover:bg-black/70 text-white rounded-full flex items-center justify-center backdrop-blur-md transition-colors"
                                    onClick={(e) => { e.stopPropagation(); setPreviewImage(null); }}
                                >
                                    <span className="material-symbols-outlined">close</span>
                                </button>
                            </div>
                        </div>
                    )
                }

                {/* Paparan besar jalur gambar kad v3.9 (2026-09-13) — di-portal sendiri ke <body>. */}
                {pratontonKad && (
                    <PratontonGambar
                        senarai={pratontonKad.senarai}
                        mula={pratontonKad.mula}
                        tajuk={pratontonKad.tajuk}
                        onTutup={() => setPratontonKad(null)}
                        T={T}
                    />
                )}



                {/* ★ v3.0.0: Video Player Modal */}
                {videoModal.open && (
                    <div
                        className="fixed inset-0 z-[9999] bg-black/80 backdrop-blur-sm flex items-center justify-center p-4"
                        onClick={closeVideoModal}
                    >
                        <div className="relative w-full max-w-lg rounded-2xl overflow-hidden shadow-2xl bg-black" onClick={(e) => e.stopPropagation()}>
                            {videoModal.loading && (
                                <div className="aspect-[9/16] flex flex-col items-center justify-center gap-3">
                                    <div className="w-10 h-10 border-3 border-white/30 border-t-white rounded-full animate-spin"></div>
                                    <span className="text-white/70 text-sm">{T('ws.videoModal.loading', 'Memuat video dari extension...')}</span>
                                </div>
                            )}
                            {videoModal.error && (
                                <div className="aspect-[9/16] flex flex-col items-center justify-center gap-3 px-8">
                                    <span className="material-symbols-outlined text-[48px] text-red-400">error</span>
                                    <span className="text-white/70 text-sm text-center">{videoModal.error}</span>
                                </div>
                            )}
                            {videoModal.blobUrl && !videoModal.loading && (
                                <video
                                    src={videoModal.blobUrl}
                                    controls
                                    autoPlay
                                    className="w-full max-h-[85vh] object-contain"
                                />
                            )}
                            {/* ★ Hint: beritahu user boleh tekan Esc untuk tutup */}
                            <div className="absolute top-3 left-3 flex items-center gap-1.5 h-9 px-2.5 bg-black/50 text-white/90 rounded-full backdrop-blur-md pointer-events-none select-none">
                                <span className="material-symbols-outlined text-[16px]">keyboard</span>
                                <span className="text-xs font-medium">{T('ws.videoModal.escToClose', 'Esc to close')}</span>
                            </div>
                            <button
                                className="absolute top-3 right-3 w-9 h-9 bg-black/50 hover:bg-black/70 text-white rounded-full flex items-center justify-center backdrop-blur-md transition-colors"
                                onClick={closeVideoModal}
                                title={T('ws.videoModal.close', 'Close (Esc)')}
                            >
                                <span className="material-symbols-outlined text-[20px]">close</span>
                            </button>
                        </div>
                    </div>
                )}

                {/* Delete Video Confirm Dialog */}
                <ConfirmDialog
                    isOpen={deleteConfirm.open}
                    onClose={() => !deleteConfirm.busy && setDeleteConfirm({ open: false, product: null, setKey: null, busy: false })}
                    onConfirm={confirmDeleteVideo}
                    title={T('ws.confirm.deleteVideoTitle', 'Padam video ini?')}
                    message={deleteConfirm.product ? (() => { const setLabel = (spaces.find(s => s.id === selectedSpaceId)?.settings?.labels?.[deleteConfirm.setKey]) || (deleteConfirm.setKey || '').replace('set', 'Set '); return T('ws.confirm.deleteVideoMsg', `Video untuk ${setLabel} akan dipadam terus dari cloud. Tindakan ini tak boleh undo.`, { setLabel }); })() : ''}
                    confirmLabel={T('ws.confirm.delete', 'Padam')}
                    cancelLabel={T('ws.confirm.cancel', 'Batal')}
                    variant="danger"
                    busy={deleteConfirm.busy}
                />

                {/* Bulk product delete — frees cloud storage, shows space reclaimed */}
                <ConfirmDialog
                    isOpen={productDeleteConfirm.open}
                    onClose={() => !productDeleteConfirm.busy && setProductDeleteConfirm({ open: false, ids: [], estBytes: null, busy: false, progress: null })}
                    onConfirm={confirmDeleteProducts}
                    title={T('ws.confirm.deleteProductsTitle', `Padam ${productDeleteConfirm.ids.length} produk?`, { n: productDeleteConfirm.ids.length })}
                    message={(() => { const ruang = productDeleteConfirm.estBytes != null ? T('ws.confirm.spaceFreed', ` (~${fmtStorage(productDeleteConfirm.estBytes)} akan dikosongkan)`, { saiz: fmtStorage(productDeleteConfirm.estBytes) }) : T('ws.confirm.calculating', ' (mengira ruang…)'); return T('ws.confirm.deleteProductsMsg', `Video berkaitan akan dipadam terus daripada storan awan${ruang}. Tindakan ini tidak boleh dibatalkan.`, { ruang }); })()}
                    confirmLabel={T('ws.confirm.deleteProductsBtn', `Padam ${productDeleteConfirm.ids.length} produk`, { n: productDeleteConfirm.ids.length })}
                    cancelLabel={T('ws.confirm.cancel', 'Batal')}
                    variant="danger"
                    busy={productDeleteConfirm.busy}
                    busyLabel={productDeleteConfirm.progress ? T('ws.confirm.deletingProgress', `Memadam ${productDeleteConfirm.progress.done}/${productDeleteConfirm.progress.total}…`, { selesai: productDeleteConfirm.progress.done, jumlah: productDeleteConfirm.progress.total }) : T('ws.confirm.deleting', 'Memadam…')}
                />

                {/* ★ Bulk video-only delete — card & prompt kekal, video sahaja dipadam */}
                <ConfirmDialog
                    isOpen={bulkVideoDeleteConfirm.open}
                    onClose={() => !bulkVideoDeleteConfirm.busy && setBulkVideoDeleteConfirm({ open: false, setKey: null, items: [], estBytes: null, busy: false, progress: null })}
                    onConfirm={confirmBulkDeleteVideos}
                    title={T('ws.confirm.deleteVideosTitle', `Padam ${bulkVideoDeleteConfirm.items.length} video?`, { n: bulkVideoDeleteConfirm.items.length })}
                    message={(() => { const ruang = bulkVideoDeleteConfirm.estBytes != null ? T('ws.confirm.spaceFreed', ` (~${fmtStorage(bulkVideoDeleteConfirm.estBytes)} akan dikosongkan)`, { saiz: fmtStorage(bulkVideoDeleteConfirm.estBytes) }) : T('ws.confirm.calculating', ' (mengira ruang…)'); return T('ws.confirm.deleteVideosMsg', `Video sahaja akan dipadam terus daripada storan awan — produk, prompt dan kapsyen kekal${ruang}. Tindakan ini tidak boleh dibatalkan.`, { ruang }); })()}
                    confirmLabel={T('ws.confirm.deleteVideosBtn', `Padam ${bulkVideoDeleteConfirm.items.length} video`, { n: bulkVideoDeleteConfirm.items.length })}
                    cancelLabel={T('ws.confirm.cancel', 'Batal')}
                    variant="danger"
                    busy={bulkVideoDeleteConfirm.busy}
                    busyLabel={bulkVideoDeleteConfirm.progress ? T('ws.confirm.deletingProgress', `Memadam ${bulkVideoDeleteConfirm.progress.done}/${bulkVideoDeleteConfirm.progress.total}…`, { selesai: bulkVideoDeleteConfirm.progress.done, jumlah: bulkVideoDeleteConfirm.progress.total }) : T('ws.confirm.deleting', 'Memadam…')}
                />

                {/* ★ KOSONGKAN PROMPT — teks sahaja; video, gambar & data produk kekal.
                    Dikunci (busy) semasa menyemak dan menulis; Batal hanya pada fasa 'sedia'. */}
                {kosongPrompt.open && (() => {
                    const setLabel = labelSetKad(kosongPrompt.setKey || 'all');
                    const bil = kosongPrompt.pelan.length;
                    const nota = (kosongPrompt.kosong > 0 ? T('ws.confirm.kosongPromptSudahKosong', ` Sudah kosong, dilangkau: ${kosongPrompt.kosong} kad.`, { n: kosongPrompt.kosong }) : '')
                        + (kosongPrompt.langkau > 0 ? T('ws.confirm.kosongPromptDijana', ` Sedang dijana, dilangkau: ${kosongPrompt.langkau} kad.`, { n: kosongPrompt.langkau }) : '');
                    return (
                        <ConfirmDialog
                            isOpen={kosongPrompt.open}
                            onClose={() => { if (kosongPrompt.fasa !== 'sedia') return; kosongPromptReqRef.current += 1; setKosongPrompt(KOSONG_PROMPT_TUTUP); }}
                            onConfirm={confirmKosongkanPrompt}
                            title={T('ws.confirm.kosongPromptTitle', `Kosongkan prompt ${setLabel}?`, { set: setLabel })}
                            message={kosongPrompt.fasa === 'semak'
                                ? T('ws.confirm.kosongPromptSemakMsg', 'Menyemak teks pada kad yang ditanda…')
                                : T('ws.confirm.kosongPromptMsg', `Semua teks prompt dan Caption TikTok dalam ${setLabel} akan dikosongkan. Video, gambar dan data produk kekal. Tindakan ini tidak boleh dibatalkan.`, { set: setLabel }) + nota}
                            confirmLabel={bil === 1 ? T('ws.confirm.kosongPromptBtnSatu', 'Kosongkan 1 kad') : T('ws.confirm.kosongPromptBtn', `Kosongkan ${bil} kad`, { n: bil })}
                            cancelLabel={T('ws.confirm.cancel', 'Batal')}
                            variant="danger"
                            busy={kosongPrompt.fasa !== 'sedia'}
                            busyLabel={kosongPrompt.fasa === 'semak' ? T('ws.confirm.kosongPromptSemak', 'Menyemak…') : T('ws.confirm.kosongPromptTulis', 'Mengosongkan…')}
                        />
                    );
                })()}

                {/* ★ Modal pengesahan Tukar Avatar — sedarkan user impact gender/umur/hijab pada prompt yang dah siap */}
                {/* ★ DUPLICATE KAD — pilih bilangan salinan (tiada had) */}
                {duplicateModal.open && (() => {
                    const srcCount = duplicateModal.ids.length;
                    const per = Math.max(1, Math.floor(Number(duplicateModal.copies) || 1));
                    const total = srcCount * per;
                    const tutupDup = () => !isSaving && setDuplicateModal({ open: false, ids: [], copies: 1, busy: false });
                    const jalankanDup = async () => {
                        const { ids } = duplicateModal;
                        setDuplicateModal({ open: false, ids: [], copies: 1, busy: false });
                        await handleDuplicateProducts(ids, per);
                    };

                    /* ---------- Rupa v3.9 ----------------------------------
                       Tiga perkara sengaja berbeza daripada rupa lama di bawah,
                       bukan kerana citarasa:

                       · Kotak maklumat BIRU dibuang. v3.9 monokrom dengan satu
                         aksen sahaja, dan aksen itu milik butang tindakan. Ayat
                         di dalamnya tidak hilang — ia berpindah ke tempat yang
                         lebih berguna (bawah).
                       · "Kuota generation tidak digunakan" turun ke kaki dialog,
                         bersebelahan butang. Itulah saat pengguna teragak-agak,
                         dan itulah jawapan kepada keraguannya.
                       · Pilihan bilangan memakai Segmented — kawalan yang sama
                         seperti tab di atas senarai produk. Pil bulat `.s-pill`
                         tidak boleh dipakai: ia 34px TETAP, jadi "10×" terkeluar
                         daripada bulatannya. */
                    if (uiV39) return (
                        <div
                            className="s-modal"
                            role="dialog" aria-modal="true" aria-label={T('ws.dup.title', 'Duplicate kad')}
                            onClick={tutupDup}
                        >
                            <div className="s-modal__panel" style={{ maxWidth: 440 }} onClick={(e) => e.stopPropagation()}>
                                <header className="s-modal__head">
                                    <div style={{ flex: 1, minWidth: 0 }}>
                                        <div style={{ fontSize: 14, fontWeight: 600, color: 'var(--s-ink)' }}>{T('ws.dup.title', 'Duplicate kad')}</div>
                                        <div className="s-dim" style={{ marginTop: 2 }}>{T('ws.dup.selectedCount', `${srcCount} kad dipilih`, { n: srcCount })}</div>
                                    </div>
                                    <button type="button" className="s-modal__x" onClick={tutupDup} aria-label={T('ws.common.close', 'Tutup')} title="Tutup">
                                        <X size={16} strokeWidth={2} />
                                    </button>
                                </header>

                                <div style={{ padding: 16, display: 'flex', flexDirection: 'column', gap: 14 }}>
                                    <div>
                                        <span className="s-lbl">{T('ws.dup.copiesPerCard', 'Salinan bagi setiap kad')}</span>
                                        <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
                                            <Segmented
                                                value={String(per)}
                                                onChange={(v) => setDuplicateModal(prev => ({ ...prev, copies: Number(v) }))}
                                                options={[1, 2, 3, 5, 10].map(n => ({ value: String(n), label: `${n}×` }))}
                                            />
                                            {/* Medan bebas — TIADA had (keputusan user 2026-08-03).
                                                Bila nilainya bukan salah satu pintasan di sebelah,
                                                Segmented sengaja tidak menandakan apa-apa: itu jujur,
                                                bukan pepijat. */}
                                            <input
                                                className="s-input"
                                                type="number" min="1" value={duplicateModal.copies}
                                                onChange={(e) => setDuplicateModal(prev => ({ ...prev, copies: e.target.value }))}
                                                aria-label={T('ws.dup.copiesAria', 'Bilangan salinan')}
                                                title={T('ws.dup.copiesTitle', 'Bilangan salinan (tiada had)')}
                                                style={{ width: 76, height: 34 }}
                                            />
                                        </div>
                                    </div>

                                    <p style={{ margin: 0, fontSize: 13.5, lineHeight: 1.55, color: 'var(--s-ink-2)' }}>
                                        {/* Penebalan <b> kekal untuk rupa lalai; kamus menyimpan ayat
                                            sebagai teks biasa. */}
                                        {uiV39
                                            ? t('ws.dup.willCreate', { jumlah: total })
                                            : <><b style={{ color: 'var(--s-ink)' }}>{total} kad baharu</b> akan dihasilkan dengan
                                        prompt, gambar produk, template dan avatar yang sama.</>}
                                    </p>

                                    <p className="s-hint" style={{ margin: 0 }}>
                                        {T('ws.dup.notCopied', 'Video, thumbnail dan status upload TikTok tidak disalin — setiap kad baharu menjana videonya sendiri apabila anda Run Flow. Nama salinan diberi nombor, contoh (2), supaya folder video mudah dibezakan.')}
                                    </p>
                                </div>

                                <footer className="s-modal__foot">
                                    <span className="s-dim" style={{ flex: 1, minWidth: 0 }}>
                                        {T('ws.dup.noQuota', 'Kuota generation tidak digunakan')}
                                    </span>
                                    <Btn variant="quiet" size="sm" disabled={isSaving} onClick={tutupDup}>{T('ws.dup.cancel', 'Batal')}</Btn>
                                    <Btn
                                        size="sm" disabled={isSaving} onClick={jalankanDup}
                                        icon={<Copy size={14} strokeWidth={2} />}
                                    >
                                        {T('ws.dup.confirm', `Salin ${total} kad`, { jumlah: total })}
                                    </Btn>
                                </footer>
                            </div>
                        </div>
                    );

                    return (
                        <div className="fixed inset-0 z-[9999] bg-black/50 backdrop-blur-sm flex items-center justify-center p-4"
                            onClick={() => !isSaving && setDuplicateModal({ open: false, ids: [], copies: 1, busy: false })}>
                            <div className="relative w-full max-w-sm bg-white rounded-2xl shadow-2xl border border-slate-200 p-5 animate-in zoom-in-95 duration-200"
                                onClick={(e) => e.stopPropagation()}>
                                <div className="flex items-center gap-3 mb-3">
                                    <div className="w-11 h-11 rounded-xl bg-sky-50 flex items-center justify-center shrink-0">
                                        <span className="material-symbols-outlined text-sky-500">content_copy</span>
                                    </div>
                                    <div className="min-w-0">
                                        <div className="text-sm font-bold text-slate-800">{T('ws.dup.titleLama', 'Duplicate Kad')}</div>
                                        <div className="text-[11px] text-slate-500">{T('ws.dup.selectedCount', `${srcCount} kad dipilih`, { n: srcCount })}</div>
                                    </div>
                                </div>

                                <p className="text-[11px] text-slate-500 leading-relaxed mb-2">
                                    {/* Cabang ini rupa LAMA sahaja, jadi T() sentiasa memulangkan ayat asal
                                        berserta penebalannya. Kunci disebut supaya ia tidak yatim. */}
                                    {uiV39
                                        ? t('ws.dup.copiesPerCardLama')
                                        : <>Berapa salinan bagi <b className="text-slate-700">setiap</b> kad?</>}
                                </p>
                                <div className="flex flex-wrap items-center gap-1.5 mb-3">
                                    {[1, 2, 3, 5, 10].map(n => (
                                        <button key={n} onClick={() => setDuplicateModal(prev => ({ ...prev, copies: n }))}
                                            className={`px-3 py-1.5 rounded-xl text-[12px] font-bold transition-colors ${per === n ? 'bg-sky-500 text-white' : 'bg-slate-100 text-slate-600 hover:bg-slate-200'}`}>
                                            {n}×
                                        </button>
                                    ))}
                                    <input
                                        type="number" min="1" value={duplicateModal.copies}
                                        onChange={(e) => setDuplicateModal(prev => ({ ...prev, copies: e.target.value }))}
                                        className="w-16 px-2 py-1.5 text-[12px] font-bold text-slate-700 border border-slate-200 rounded-xl focus:outline-none focus:ring-1 focus:ring-sky-500"
                                        title={T('ws.dup.copiesTitle', 'Bilangan salinan (tiada had)')}
                                    />
                                </div>

                                <div className="rounded-xl bg-sky-50 border border-sky-100 p-3 mb-3">
                                    <p className="text-[11px] text-sky-900 leading-relaxed">
                                        {uiV39
                                            ? t('ws.dup.willCreateLama', { jumlah: total })
                                            : <><b>{total} kad baharu</b> akan dihasilkan dengan prompt, gambar produk, template dan avatar yang <b>sama</b>. Kuota generation <b>tidak digunakan</b> kerana tiada penjanaan AI baharu.</>}
                                    </p>
                                </div>
                                <p className="text-[11px] text-slate-500 leading-relaxed mb-4">
                                    {uiV39
                                        ? t('ws.dup.notCopied')
                                        : <>Video, thumbnail dan status upload TikTok <b>tidak</b> disalin — setiap kad baharu menjana videonya sendiri apabila anda Run Flow. Nama salinan diberi nombor, contoh <span className="font-mono text-slate-600">(2)</span>, supaya folder video mudah dibezakan.</>}
                                </p>

                                <div className="flex items-center justify-end gap-2">
                                    <button disabled={isSaving} onClick={() => setDuplicateModal({ open: false, ids: [], copies: 1, busy: false })}
                                        className="px-4 py-2 text-[12px] font-bold text-slate-500 hover:text-slate-700 hover:bg-slate-100 disabled:opacity-50 rounded-xl transition-colors">
                                        {T('ws.dup.cancel', 'Batal')}
                                    </button>
                                    <button disabled={isSaving} onClick={async () => {
                                        const { ids } = duplicateModal;
                                        setDuplicateModal({ open: false, ids: [], copies: 1, busy: false });
                                        await handleDuplicateProducts(ids, per);
                                    }}
                                        className="px-4 py-2 text-[12px] font-bold text-white bg-sky-500 hover:bg-sky-600 disabled:opacity-50 rounded-xl transition-colors flex items-center gap-1.5">
                                        <span className="material-symbols-outlined text-[16px]">content_copy</span>{T('ws.dup.confirmLama', `Ya, salin ${total} kad`, { jumlah: total })}
                                    </button>
                                </div>
                            </div>
                        </div>
                    );
                })()}

                {avatarChangeModal.open && avatarChangeModal.avatar && (
                    <div className="fixed inset-0 z-[9999] bg-black/50 backdrop-blur-sm flex items-center justify-center p-4"
                        onClick={() => !isSaving && setAvatarChangeModal({ open: false, avatar: null, count: 0 })}>
                        <div className="relative w-full max-w-sm bg-white rounded-2xl shadow-2xl border border-slate-200 p-5 animate-in zoom-in-95 duration-200"
                            onClick={(e) => e.stopPropagation()}>
                            {/* Avatar baru + badge */}
                            <div className="flex items-center gap-3 mb-3">
                                {avatarChangeModal.avatar.imageUrl
                                    ? <img src={avatarChangeModal.avatar.imageUrl} alt="" className="w-14 h-14 rounded-xl object-cover border-2 border-violet-200 shrink-0" />
                                    : <div className="w-14 h-14 rounded-xl bg-violet-50 flex items-center justify-center shrink-0"><span className="material-symbols-outlined text-violet-400">face</span></div>}
                                <div className="min-w-0">
                                    <div className="text-sm font-bold text-slate-800 truncate">{avatarChangeModal.avatar.name || T('ws.avatarChange.fallbackName', 'Avatar')}</div>
                                    <div className="flex flex-wrap items-center gap-1 mt-1">
                                        <span className="px-1.5 py-0.5 rounded-md text-[10px] font-bold" style={{ background: avatarChangeModal.avatar.gender === 'male' ? '#dbeafe' : '#fce7f3', color: avatarChangeModal.avatar.gender === 'male' ? '#2563eb' : '#db2777' }}>
                                            {avatarChangeModal.avatar.gender === 'male' ? T('ws.avatarChange.male', '♂ Lelaki') : T('ws.avatarChange.female', '♀ Perempuan')}
                                        </span>
                                        {avatarChangeModal.avatar.age && <span className="px-1.5 py-0.5 rounded-md text-[10px] font-bold bg-slate-100 text-slate-600">{avatarChangeModal.avatar.age}</span>}
                                        {avatarChangeModal.avatar.gender === 'female' && (
                                            <span className="px-1.5 py-0.5 rounded-md text-[10px] font-bold" style={{ background: avatarChangeModal.avatar.hijab ? '#dcfce7' : '#fef3c7', color: avatarChangeModal.avatar.hijab ? '#16a34a' : '#d97706' }}>
                                                {avatarChangeModal.avatar.hijab ? T('ws.avatarChange.hijab', 'Hijab') : T('ws.avatarChange.noHijab', 'Tiada Hijab')}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>
                            {/* Amaran impact */}
                            <div className="rounded-xl bg-amber-50 border border-amber-200 p-3 mb-3">
                                <p className="text-[11px] text-amber-800 leading-relaxed">
                                    <span className="font-bold">{T('ws.avatarChange.warningLabel', '⚠️ Perhatian:')}</span>{' '}
                                    {uiV39
                                        ? t('ws.avatarChange.warning')
                                        : <>Prompt &amp; video yang dah siap ditulis ikut avatar <b>asal</b> (jantina, umur, hijab). Pastikan avatar baru ni <b>padan</b> — contoh kalau asal <b>ada hijab</b>, jangan pilih yang <b>tiada hijab</b>, nanti hasil tak sama.</>}
                                </p>
                            </div>
                            <p className="text-xs text-slate-500 mb-4">
                                {uiV39
                                    ? t('ws.avatarChange.count', { n: avatarChangeModal.count })
                                    : <><b className="text-slate-700">{avatarChangeModal.count}</b> card akan ditukar avatar. Prompt &amp; video kekal — tiada jana semula, tiada coin.</>}
                            </p>
                            {/* Butang */}
                            <div className="flex items-center justify-end gap-2">
                                <button disabled={isSaving} onClick={() => setAvatarChangeModal({ open: false, avatar: null, count: 0 })}
                                    className="px-4 py-2 text-[12px] font-bold text-slate-500 hover:text-slate-700 hover:bg-slate-100 disabled:opacity-50 rounded-xl transition-colors">
                                    {T('ws.avatarChange.cancel', 'Batal')}
                                </button>
                                <button disabled={isSaving} onClick={async () => { const av = avatarChangeModal.avatar; setAvatarChangeModal({ open: false, avatar: null, count: 0 }); await applyAvatarChange(av); }}
                                    className="px-4 py-2 text-[12px] font-bold text-white bg-violet-500 hover:bg-violet-600 disabled:opacity-50 rounded-xl transition-colors flex items-center gap-1.5">
                                    <span className="material-symbols-outlined text-[16px]">check</span>{T('ws.avatarChange.confirm', 'Ya, tukar')}
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {/* Pengurus Schedule template (v3.9). Tanpa sekurang-kurangnya
                    satu template, tiada hari dalam kalendar yang mempunyai slot —
                    jadi ini satu-satunya jalan keluar daripada kalendar kosong.
                    Ia komponen yang SAMA dengan prototaip. */}
                {schedModalBuka && (
                    <ScheduleTemplateModalV39
                        senarai={schedTemplates}
                        setSenarai={setSchedTemplates}
                        kadContoh={schedKad}
                        /* ⭐ Dua wayar ini TERTINGGAL sehingga 2026-08-26. Tanpa
                           `guna`, amaran padam sentiasa berkata "tidak digunakan
                           oleh mana-mana hari" (bohong); tanpa `onTemplatePadam`,
                           hari yang memakai template terpadam menyimpan slot
                           HANTU — wujud dalam data, tidak kelihatan, set kad
                           kekal bertanda "sudah dijadualkan". Kini padam =
                           hari yang memakainya terus dikosongkan. */
                        guna={gunaTemplate}
                        onTemplatePadam={padamTemplateDariKalendar}
                        /* ⭐ Tanpa `t` modal ini kekal ayat lalai (campur BM/EN)
                           walaupun halaman sudah bertukar English — corak sama
                           `tAnak` yang dipakai VideoThumbPreview: null bila suis
                           mati (rupa lama), fungsi terjemahan bila v3.9 hidup.
                           Modal ini v3.9 sahaja, jadi tAnak sentiasa berisi bila
                           ia kelihatan. */
                        t={tAnak}
                        onClose={() => setSchedModalBuka(false)}
                    />
                )}

                {/* Toast notifications */}
                <ToastContainer />

                {/* ★ EDIT DATA dari kad — borang Product Data yang sama seperti My Products (v3.9).
                    Logik cari-pasangan + simpan: utils/editDataProduk.js. */}
                {editDataKad && uiV39 && (
                    <CompleteProductDataModal
                        product={editDataKad.produkBorang}
                        onClose={() => setEditDataKad(null)}
                        onSave={simpanEditDataKad}
                        onMuatNaikGambar={muatNaikGambarKad}
                        v39
                        penuh
                        t={t}
                        kad={{ kes: editDataKad.kes, kumpulan: editDataKad.kumpulan, profil: editDataKad.profil, bilKadLain: editDataKad.bilKadLain, padanShopee: editDataKad.padanShopee === true }}
                    />
                )}

                {/* ★ GATE beg kuning sebelum Run TikTok (2026-10-06) — kedua-dua rupa; di-portal sendiri ke <body>. */}
                <PopupGateBegKuning
                    buka={!!gateBeg}
                    senarai={gateBeg?.senarai}
                    bilLain={gateBeg?.bilLain || 0}
                    semuaTiada={gateBeg?.semuaTiada === true}
                    onLangkau={() => jalankanDariGateBeg('langkau')}
                    onTanpaBeg={() => jalankanDariGateBeg('tanpaBeg')}
                    onBatal={() => setGateBeg(null)}
                    T={T}
                />

                {/* Raw Output Modal */}
                {rawOutputModal.open && (
                    <div
                        className="fixed inset-0 z-[9999] bg-black/60 backdrop-blur-sm flex items-center justify-center p-4"
                        onClick={() => setRawOutputModal({ open: false, productId: null, content: '', plainContent: '', viewMode: 'json' })}
                    >
                        <div
                            className="relative w-full max-w-2xl max-h-[85vh] bg-white dark:bg-slate-900 rounded-2xl shadow-2xl border border-slate-200 dark:border-slate-700 flex flex-col overflow-hidden animate-in zoom-in-95 duration-200"
                            onClick={(e) => e.stopPropagation()}
                        >
                            {/* Header */}
                            <div className="flex items-center justify-between px-5 py-3.5 border-b border-slate-100 dark:border-slate-800">
                                <div className="flex items-center gap-2">
                                    <span className="material-symbols-outlined text-lg text-violet-500">terminal</span>
                                    <h3 className="text-sm font-bold text-slate-700 dark:text-white">{T('ws.raw.title', 'Raw AI Output')}</h3>
                                </div>
                                <div className="flex items-center gap-2">
                                    {/* JSON / Plain Toggle */}
                                    <div className="flex items-center bg-slate-100 dark:bg-slate-800 rounded-lg p-0.5 border border-slate-200 dark:border-slate-700">
                                        <button
                                            onClick={() => setRawOutputModal(prev => ({ ...prev, viewMode: 'json', content: plainToJson(prev.plainContent, prev.content) }))}
                                            className={`px-2.5 py-1 rounded-md text-[10px] font-bold transition-all ${rawOutputModal.viewMode === 'json'
                                                ? 'bg-violet-500 text-white shadow-sm'
                                                : 'text-slate-500 dark:text-slate-400 hover:text-violet-500'
                                                }`}
                                        >
                                            JSON
                                        </button>
                                        <button
                                            onClick={() => setRawOutputModal(prev => ({ ...prev, viewMode: 'plain', plainContent: jsonToPlain(prev.content) }))}
                                            className={`px-2.5 py-1 rounded-md text-[10px] font-bold transition-all ${rawOutputModal.viewMode === 'plain'
                                                ? 'bg-emerald-500 text-white shadow-sm'
                                                : 'text-slate-500 dark:text-slate-400 hover:text-emerald-500'
                                                }`}
                                        >
                                            {T('ws.raw.plain', 'Plain')}
                                        </button>
                                    </div>
                                    <button
                                        onClick={() => setRawOutputModal({ open: false, productId: null, content: '', plainContent: '', viewMode: 'json' })}
                                        className="p-1 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 hover:text-slate-600 dark:hover:text-slate-300 transition-colors"
                                    >
                                        <span className="material-symbols-outlined text-lg">close</span>
                                    </button>
                                </div>
                            </div>
                            {/* Body */}
                            <div className="flex-1 p-4 overflow-auto">
                                {rawOutputModal.viewMode === 'json' ? (
                                    <textarea
                                        value={rawOutputModal.content}
                                        readOnly
                                        className="w-full h-full min-h-[400px] bg-slate-50 dark:bg-slate-800/50 border border-slate-200 dark:border-slate-700 rounded-xl p-4 text-[11px] font-mono text-slate-700 dark:text-slate-300 leading-relaxed resize-y focus:outline-none focus:ring-2 focus:ring-violet-500/30 focus:border-violet-400 transition-all"
                                        spellCheck="false"
                                    />
                                ) : (
                                    /* Plain text view */
                                    <textarea
                                        value={rawOutputModal.plainContent}
                                        readOnly
                                        className="w-full h-full min-h-[400px] bg-slate-50 dark:bg-slate-800/50 border border-slate-200 dark:border-slate-700 rounded-xl p-4 text-[11px] font-mono text-slate-700 dark:text-slate-300 leading-relaxed resize-y focus:outline-none focus:ring-2 focus:ring-emerald-500/30 focus:border-emerald-400 transition-all shadow-inner"
                                        spellCheck="false"
                                    />
                                )}
                            </div>
                            {/* Link chat ChatGPT — balik ke conversation asal yang di-scrape */}
                            {(() => {
                                const chatUrl = products.find(p => p.id === rawOutputModal.productId)?.chatgptUrl;
                                if (!chatUrl) return null;
                                return (
                                    <div className="px-5 py-2.5 border-t border-slate-100 dark:border-slate-800 flex items-center gap-2">
                                        <span className="material-symbols-outlined text-[15px] text-emerald-500 flex-shrink-0">smart_toy</span>
                                        <a href={chatUrl} target="_blank" rel="noopener noreferrer" title={chatUrl}
                                            className="text-[11px] font-semibold text-emerald-600 dark:text-emerald-400 hover:underline truncate flex-1 min-w-0">
                                            {chatUrl}
                                        </a>
                                        <button
                                            onClick={() => navigator.clipboard.writeText(chatUrl)}
                                            className="p-1 rounded-md hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 hover:text-slate-600 transition-colors flex-shrink-0"
                                            title={T('ws.raw.copyChatLink', 'Salin link chat')}
                                        >
                                            <span className="material-symbols-outlined text-[14px]">content_copy</span>
                                        </button>
                                    </div>
                                );
                            })()}
                            {/* Footer */}
                            <div className="flex items-center justify-between px-5 py-3 border-t border-slate-100 dark:border-slate-800 bg-slate-50/50 dark:bg-slate-800/30">
                                <button
                                    onClick={() => {
                                        const textToCopy = rawOutputModal.viewMode === 'plain' ? rawOutputModal.plainContent : rawOutputModal.content;
                                        navigator.clipboard.writeText(textToCopy);
                                        // Brief visual feedback
                                        const btn = document.getElementById('copyAllBtn');
                                        /* ⚠️ Teks ini ditulis semula ke DOM di bawah — kedua-dua tempat WAJIB
                                           dikemas kini bersama, kalau tidak butang kekal dalam bahasa lain
                                           selepas 1.5 saat. */
                                        if (btn) { btn.textContent = T('ws.raw.copied', '✓ Copied!'); setTimeout(() => { btn.textContent = T('ws.raw.copyAll', 'Copy All'); }, 1500); }
                                    }}
                                    id="copyAllBtn"
                                    className="px-3 py-1.5 rounded-lg border border-slate-200 dark:border-slate-700 text-[11px] font-bold text-slate-500 dark:text-slate-400 hover:bg-blue-50 hover:border-blue-300 hover:text-blue-600 dark:hover:bg-blue-900/20 dark:hover:border-blue-700 dark:hover:text-blue-400 transition-all flex items-center gap-1"
                                >
                                    <span className="material-symbols-outlined text-[13px]">content_copy</span>
                                    {T('ws.raw.copyAll', 'Copy All')}
                                </button>
                                <div className="flex items-center gap-2">
                                    <button
                                        onClick={() => setRawOutputModal({ open: false, productId: null, content: '', plainContent: '', viewMode: 'json' })}
                                        className="px-3 py-1.5 rounded-lg border border-slate-200 dark:border-slate-700 text-[11px] font-bold text-slate-500 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-800 transition-all"
                                    >
                                        {T('ws.raw.close', 'Close')}
                                    </button>
                                    {/* Save DISOROK (jangan buang) — modal Raw AI Output read-only, user copy je */}
                                    {false && (
                                    <button
                                        onClick={() => {
                                            const finalJson = rawOutputModal.viewMode === 'plain'
                                                ? plainToJson(rawOutputModal.plainContent, products.find(p => p.id === rawOutputModal.productId)?.rawOutput || rawOutputModal.content || '{}')
                                                : rawOutputModal.content;

                                            let newPrompts = products.find(p => p.id === rawOutputModal.productId)?.prompts || {};
                                            try {
                                                const parsed = JSON.parse(finalJson);
                                                const setKeys = Object.keys(parsed).filter(k => k.startsWith('set'));
                                                setKeys.forEach(setKey => {
                                                    if (!newPrompts[setKey]) newPrompts[setKey] = {};
                                                    if (parsed[setKey].promptImage) newPrompts[setKey].promptImage = parsed[setKey].promptImage;
                                                    if (parsed[setKey].hookText !== undefined) newPrompts[setKey].hookText = parsed[setKey].hookText;
                                                    if (parsed[setKey].promptVideo) newPrompts[setKey].promptVideo = parsed[setKey].promptVideo;
                                                    if (parsed[setKey].captionTiktok) newPrompts[setKey].captionTiktok = parsed[setKey].captionTiktok;
                                                });
                                            } catch (e) {
                                                console.error("Failed to parse final JSON to extract prompts", e);
                                            }

                                            const updated = products.map(p => p.id === rawOutputModal.productId
                                                ? { ...p, rawOutput: finalJson, prompts: { ...newPrompts } }
                                                : p
                                            );
                                            setProducts(updated);
                                            saveToCloud(updated);
                                            setRawOutputModal({ open: false, productId: null, content: '', plainContent: '', viewMode: 'json' });
                                        }}
                                        className={`px-4 py-1.5 rounded-lg text-white text-[11px] font-bold shadow-md hover:shadow-lg transition-all flex items-center gap-1 ${rawOutputModal.viewMode === 'plain' ? 'bg-gradient-to-r from-emerald-500 to-teal-600 hover:from-emerald-600 hover:to-teal-700' : 'bg-gradient-to-r from-violet-500 to-purple-600 hover:from-violet-600 hover:to-purple-700'}`}
                                    >
                                        <span className="material-symbols-outlined text-[13px]">save</span>
                                        Save
                                    </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </main>

            {/* Quick Notes side panel (right-slide). Sembunyikan backdrop bila modal Edit Prompts dibuka — supaya panel duduk di sebelah modal, bukan menutupnya. */}
            <QuickNotesPanel
                isOpen={isQuickNotesOpen}
                onClose={() => setIsQuickNotesOpen(false)}
                hideBackdrop={!!promptModalProductId}
            />
        </div>
    );
});

export default WorkspaceView;
